/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
    "/admin/whatsapp/connections": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List WhatsApp connections
         * @description Every Client's WhatsApp number, revoked ones included, with its number, status, quality and template approvals. Optionally for one Client. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    /** @description Only this Client's connection. */
                    ClientId?: string;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["WhatsAppConnectionAdminResponse"][];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/clients/{clientId}/webhook-subscriptions/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get a webhook subscription for any Client (admin)
         * @description **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    clientId: string;
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["WebhookSubscriptionResponse"];
                    };
                };
                /** @description Webhook.SubscriptionNotFound — when the subscription does not exist or does not belong to the calling Client */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /**
         * Update a webhook subscription for any Client (admin)
         * @description Admin override: typically used to force-disable a Client's subscription (active: false) for support or compliance reasons.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        patch: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    clientId: string;
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["PatchWebhookSubscriptionRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["WebhookSubscriptionResponse"];
                    };
                };
                /**
                 * @description Webhook.InvalidUrl — when the supplied URL is not an absolute https URL
                 *
                 *     Webhook.NoEventTypes — when event_types is empty
                 *
                 *     Webhook.EventTypeUnknown — is not a known webhook event type
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Webhook.SubscriptionNotFound — when the subscription does not exist or does not belong to the calling Client */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        trace?: never;
    };
    "/admin/webhook-deliveries": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List webhook deliveries across all Clients (admin)
         * @description Cross-Client delivery feed for ops monitoring. Filter by client, status, or since-timestamp.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    ClientId?: string;
                    Status?: components["schemas"]["WebhookDeliveryStatus"];
                    Since?: string;
                    Limit?: number | string;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["WebhookDeliveryResponse"][];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/clients/{clientId}/webhook-subscriptions/{id}/deliveries": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List webhook deliveries for any Client's subscription (admin)
         * @description **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    limit?: number | string;
                };
                header?: never;
                path: {
                    clientId: string;
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["WebhookDeliveryResponse"][];
                    };
                };
                /** @description Webhook.SubscriptionNotFound — when the subscription does not exist or does not belong to the calling Client */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/clients/{clientId}/webhook-subscriptions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List webhook subscriptions for any Client (admin)
         * @description **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    clientId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["WebhookSubscriptionResponse"][];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/clients/{clientId}/webhook-subscriptions/{id}/deliveries/{deliveryId}/retry": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Retry a webhook delivery for any Client (admin)
         * @description **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    clientId: string;
                    id: string;
                    deliveryId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["WebhookDeliveryResponse"];
                    };
                };
                /** @description Webhook.DeliveryNotFound — when the delivery does not exist or does not belong to the calling Client */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Webhook.DeliveryNotRetryable — when the delivery is already in Delivered status */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/users/{userId}/organisations/{organisationId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Add user to organisation (admin)
         * @description Add an existing user to an existing organisation with the given role. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    userId: string;
                    organisationId: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["AddUserToOrganisationRequest"];
                };
            };
            responses: {
                /** @description Created */
                201: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["OrganisationMembershipResponse"];
                    };
                };
                /** @description User.MissingRole — role is required */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description User.NotFound — user does not exist or is not visible to the caller
                 *
                 *     Organisation.NotFound — the organisation does not exist or could not be resolved
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description User.AlreadyInOrganisation — user is already a member of this organisation */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        /**
         * Remove user from organisation (admin)
         * @description Remove a user's membership of an organisation. The user account is not deleted. The organisation must always retain at least one Owner. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        delete: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    userId: string;
                    organisationId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description No Content */
                204: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description User.NotInOrganisation — user is not a member of this organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description User.CannotRemoveLastOwner — cannot remove the last Owner of the organisation */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        /**
         * Update user role (admin)
         * @description Update a user's role within an organisation. Requires admin access. The organisation must always retain at least one Owner.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        patch: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    userId: string;
                    organisationId: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["UpdateUserRoleRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["UpdateUserRoleResponse"];
                    };
                };
                /** @description User.MissingRole — role is required */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description User.NotInOrganisation — user is not a member of this organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description User.LastOwner — cannot demote the last Owner of the organisation */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        trace?: never;
    };
    "/admin/users/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get user (admin)
         * @description Retrieve any user and all their organisation memberships across clients. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["GetUserResponse"];
                    };
                };
                /** @description User.NotFound — user does not exist or is not visible to the caller */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/organisations/{organisationId}/users": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List organisation users (admin)
         * @description List users belonging to a specific organisation, including their role. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    /** @description Opaque pagination cursor. Pass back `next` or `previous` from a previous page's cursors. */
                    Cursor?: string;
                    /** @description Page size, 1 to 100. Defaults to 20. */
                    Limit?: number | string;
                    /** @description Exact match on email address. */
                    Email?: string;
                    /** @description Case-insensitive text matched anywhere in the member's name or email, for pickers that narrow as you type. */
                    Search?: string;
                };
                header?: never;
                path: {
                    organisationId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfOrganisationUserResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/users/{id}/organisations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List user organisations
         * @description List all organisations a user belongs to, including their role in each.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["UserOrganisationResponse"][];
                    };
                };
                /** @description User.NotFound — user does not exist or is not visible to the caller */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/users": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List all users (admin)
         * @description List users across organisations, with optional email and id filtering. Requires admin access. For users within a specific organisation (with role), use /admin/organisations/{organisationId}/users.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    Cursor?: string;
                    Id?: string;
                    Limit?: number | string;
                    Email?: string;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfUserResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user-activity/summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * User activity summary (admin)
         * @description Active users today, over the last 7 and 30 days (trailing windows ending at To), sign-ins in the window, a zero-filled daily series of sign-ins and active users, sign-ins by country, device type, operating system, browser, method and app, and active organisations per client. A user is active on a day if they signed in or refreshed their session that day. ClientIds is optional; without it every client is included. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query: {
                    From: string;
                    To: string;
                    ClientIds?: string[];
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["UserActivitySummary"];
                    };
                };
                /**
                 * @description Analytics.TooManyClients — too many clients requested in one analytics call
                 *
                 *     Analytics.InvalidWindow — the analytics window ends before it starts
                 *
                 *     Analytics.WindowTooLong — the analytics window exceeds the maximum span
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user-activity/users": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Per-user activity (admin)
         * @description Every user under the given clients (all clients when ClientIds is omitted), including users never seen, most recently active first. Each row carries the user's organisations and clients, last sign-in, last active (latest sign-in or session refresh), sign-ins in the window, and the location and device of their last sign-in. Search matches email or name. Format=csv returns every matching row as CSV instead of a page. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query: {
                    From: string;
                    To: string;
                    ClientIds?: string[];
                    Search?: string;
                    UserId?: string;
                    Cursor?: string;
                    Limit?: number | string;
                    Format?: string;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfUserActivityUserRow"];
                    };
                };
                /**
                 * @description Analytics.TooManyClients — too many clients requested in one analytics call
                 *
                 *     Analytics.InvalidWindow — the analytics window ends before it starts
                 *
                 *     Analytics.WindowTooLong — the analytics window exceeds the maximum span
                 *
                 *     Pagination.InvalidCursor — the cursor value is invalid
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user-activity/sign-ins": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Sign-ins (admin)
         * @description Customer sign-ins in the window, newest first, with method, app, approximate city-level location and device. Filter by ClientIds (all clients when omitted), UserId and Country (ISO 3166-1 alpha-2). Location is empty when the sign-in did not come through one of Dolfin's own apps. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query: {
                    From: string;
                    To: string;
                    ClientIds?: string[];
                    UserId?: string;
                    Country?: string;
                    Cursor?: string;
                    Limit?: number | string;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfUserSignInRow"];
                    };
                };
                /**
                 * @description Analytics.TooManyClients — too many clients requested in one analytics call
                 *
                 *     Analytics.InvalidWindow — the analytics window ends before it starts
                 *
                 *     Analytics.WindowTooLong — the analytics window exceeds the maximum span
                 *
                 *     Pagination.InvalidCursor — the cursor value is invalid
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/country-tax-rates": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List country tax rates (admin)
         * @description List all platform-managed country tax rates across all countries and effective windows, with optional ?country=XX filter. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    country?: string;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CountryTaxRateAdminResponse"][];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/tax-rates": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List an organisation's tax rates (admin)
         * @description Lists the merged set of platform-managed country defaults plus the organisation's own tax rates for the given organisationId, with optional ?code= filter. For the admin schedule tax-rate remap picker. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query: {
                    organisationId: string;
                    code?: string;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["TaxRateResponse"][];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/suppliers/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get supplier (admin)
         * @description Retrieve a single supplier by ID across organisations. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["SupplierResponse"];
                    };
                };
                /** @description Supplier.NotFound — supplier does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/suppliers": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List all suppliers (admin)
         * @description List suppliers across organisations, with optional organisation, name or email filtering. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    OrganisationId?: string;
                    Cursor?: string;
                    Limit?: number | string;
                    Name?: string;
                    Email?: string;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfSupplierResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/recurring-invoices/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get a recurring invoice schedule (admin)
         * @description Returns a recurring-invoice schedule by id across organisations, including its customer and line items. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["RecurringInvoiceScheduleResponse"];
                    };
                };
                /** @description RecurringInvoice.NotFound — schedule does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/recurring-invoices": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List all recurring invoice schedules (admin)
         * @description List recurring-invoice schedules across organisations, with optional organisation, status, and customer filters. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    OrganisationId?: string;
                    CustomerId?: string;
                    Statuses?: components["schemas"]["RecurringScheduleStatus"][];
                    Cursor?: string;
                    Limit?: number | string;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfRecurringInvoiceScheduleResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/recurring-invoices/{id}/line-item-tax-rates": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /**
         * Remap a recurring invoice schedule's line-item tax rates (admin)
         * @description Sets or clears the tax rate on named line items of a recurring-invoice schedule across organisations, re-validates the template, and recomputes the next run so an Active schedule resumes. Fix-forward for schedules stuck failing template validation after a referenced tax rate was deleted. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        patch: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["UpdateScheduleLineItemTaxRatesAdminRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["RecurringInvoiceScheduleResponse"];
                    };
                };
                /**
                 * @description RecurringInvoice.NotFound — schedule does not exist or belongs to a different organisation
                 *
                 *     RecurringInvoice.LineItemNotFound — a referenced line item does not exist on the schedule
                 *
                 *     Organisation.NotFound — the organisation does not exist or could not be resolved
                 *
                 *     Product.NotFound — a referenced product does not exist or belongs to a different organisation
                 *
                 *     TaxRate.NotFound — a referenced tax rate does not exist or belongs to a different organisation
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description RecurringInvoice.Terminal — schedule is already Completed or Cancelled */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        trace?: never;
    };
    "/admin/purchase-orders/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get a purchase order (admin)
         * @description Retrieve any purchase order and its lines by ID, across organisations. Each line carries how much of it has been matched. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PurchaseOrderResponse"];
                    };
                };
                /** @description PurchaseOrder.NotFound — purchase order does not exist or belongs to another organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/purchase-orders": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List all purchase orders (admin)
         * @description List purchase orders across organisations, with optional organisation, supplier and status filtering. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    OrganisationId?: string;
                    Cursor?: string;
                    Limit?: number | string;
                    SupplierId?: string;
                    Status?: components["schemas"]["PurchaseOrderStatus"];
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfPurchaseOrderResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/invoice-payments": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List all invoice payments (admin)
         * @description List invoice payments across organisations, with optional organisation and invoice filtering. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    OrganisationId?: string;
                    InvoiceId?: string;
                    Cursor?: string;
                    Limit?: number | string;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfInvoicePaymentResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/clients/{clientId}/organisations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Create organisation for a client (admin)
         * @description Create a new organisation under the client identified by the route, assigning it an industry classification. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    clientId: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["CreateOrganisationRequest"];
                };
            };
            responses: {
                /** @description Created */
                201: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["OrganisationAdminResponse"];
                    };
                };
                /**
                 * @description Organisation.MissingName — organisation name is required
                 *
                 *     Organisation.InvalidExternalReference — external reference must be 1 to 200 characters
                 *
                 *     Organisation.MissingIndustryId — industry ID is required
                 *
                 *     Organisation.MissingContactEmail — contact email is required
                 *
                 *     Organisation.InvalidContactEmail — contact email is not a valid email address
                 *
                 *     Organisation.InvalidCountry — country code is not a valid ISO 3166-1 alpha-2 code
                 *
                 *     Currency.NotFoundByCode — the specified currency is not supported
                 *
                 *     Organisation.ClientNotFound — specified client does not exist
                 *
                 *     Organisation.InvalidIndustryId — specified industry does not exist
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Company.ClientMismatch — the company and the organisation belong to different clients */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/clients/{clientId}/ap-settings": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get a client's AP settings (admin)
         * @description Retrieve a client's accounts-payable matching settings (applied to every organisation under the client), including whether pay-by-bank is enabled. Read-only admin view; the client edits these via /settings/ap. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    clientId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ApSettingsResponse"];
                    };
                };
                /** @description Client.NotFound — the client does not exist or is not visible to the caller */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /**
         * Patch a client's AP settings (admin)
         * @description Partially update a client's accounts-payable settings on the client's behalf — the same fields and validation as PATCH /settings/ap. Applies to every organisation under the client. Only supplied fields change; a settings row is created on first write. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        patch: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    clientId: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["PatchApSettingsRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ApSettingsResponse"];
                    };
                };
                /** @description ApSettings.Invalid — an AP settings value is out of its allowed range */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Client.NotFound — the client does not exist or is not visible to the caller */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description ApSettings.PaymentLinkModeNotAllowed — Dolfin payment links need pay-by-bank enabled and the ap.payments module */
                422: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        trace?: never;
    };
    "/admin/clients/{clientId}/ar-settings": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get a client's AR settings (admin)
         * @description Retrieve a client's accounts-receivable settings (applied to every organisation under the client) — currently the AR-email kill switch. Read-only admin view; the client edits these via /settings/ar. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    clientId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ArSettingsResponse"];
                    };
                };
                /** @description Client.NotFound — the client does not exist or is not visible to the caller */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/organisations/{id}/ar-settings": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get an organisation's AR settings (admin)
         * @description Retrieve an organisation's accounts-receivable defaults — payment terms, late payment fee, invoice tone, reminder schedule and bank details. Read-only admin view; the organisation edits these via /organisations/{organisationId}/settings/ar. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["OrganisationArSettingsResponse"];
                    };
                };
                /** @description Organisation.NotFound — the organisation does not exist or could not be resolved */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/organisations/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get organisation (admin)
         * @description Retrieve a single organisation by id across all clients, including the owning ClientId. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["OrganisationAdminResponse"];
                    };
                };
                /** @description Organisation.NotFound — the organisation does not exist or could not be resolved */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/organisations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List all organisations (admin)
         * @description List organisations across clients, with optional client, company and name filtering. Filtering by companyId gives the sites that belong to one parent company — the set a bill received against that company can be routed to. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    ClientId?: string;
                    CompanyId?: string;
                    Cursor?: string;
                    Limit?: number | string;
                    Name?: string;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfOrganisationAdminResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/organisations/{id}/invoice-pdf-template": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /**
         * Set an organisation's invoice PDF template (admin)
         * @description Set the PDF layout for new invoices. Existing invoices keep their layout. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        patch: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["PatchOrganisationInvoicePdfTemplateRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["OrganisationArSettingsResponse"];
                    };
                };
                /** @description OrganisationArSettings.Invalid — an organisation AR settings value is out of its allowed range */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["HttpValidationProblemDetails"];
                    };
                };
                /** @description Organisation.NotFound — the organisation does not exist or could not be resolved */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        trace?: never;
    };
    "/admin/organisations/search": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Search organisations (admin)
         * @description Fuzzy-search organisations by id, name, contact email, tax number, or company registration number, optionally narrowed to a single client. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query: {
                    q: string;
                    clientId?: string;
                    limit?: number | string;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["OrganisationAdminSearchHit"][];
                    };
                };
                /** @description Organisation.SearchQueryRequired — a non-empty search query is required */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Client.NotFound — the client does not exist or is not visible to the caller */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/modules/audit-logs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List module grant history (admin)
         * @description Paged, newest-first history of every change to client entitlements: which module moved, the state before and after, who changed it and why. Includes revocations, which leave no trace in the grants themselves. Pass `clientId` to narrow it to one client, or omit it to see changes across every client. Rows written by one staff action share a `changeSetId`, so a single edit that granted two modules and revoked a third reads back as one change. Cursor follows the standard keyset pagination convention.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    Cursor?: string;
                    Limit?: number | string;
                    ClientId?: string;
                    ModuleKey?: string;
                    ToState?: components["schemas"]["ModuleGrantState"];
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfClientModuleAuditLogResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Client.NotFound — the client does not exist or is not visible to the caller */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/clients/{clientId}/modules": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List a client's modules (admin)
         * @description List the modules a client is entitled to, each with the date it was granted and the Dolfin staff user who granted it. This is the full grant record; GET /clients/{id} returns the same keys without the attribution. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    clientId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ClientModuleResponse"][];
                    };
                };
                /** @description Client.NotFound — the client does not exist or is not visible to the caller */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        /**
         * Set a client's modules (admin)
         * @description Replace the set of modules a client is entitled to. Send the complete list you want the client to end up with — modules present are granted, modules absent are revoked, and an empty list revokes everything. Sending a module the client already holds leaves that grant untouched, so the original grant date and granter are preserved. Preview and deprecated modules cannot be newly granted, and a feature module such as "ap.payments" must be sent alongside its area module "ap". Takes effect on the client's very next request. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        put: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    clientId: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["ReplaceClientModulesRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ClientModuleResponse"][];
                    };
                };
                /**
                 * @description Module.UnknownKey — the module key is not in the catalogue
                 *
                 *     Module.NotGrantable — the module exists but cannot be newly granted (preview or deprecated)
                 *
                 *     Module.ParentRequired — a feature module cannot be granted without the area module it belongs to
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Client.NotFound — the client does not exist or is not visible to the caller */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/modules": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List the module catalogue (admin)
         * @description List every module Dolfin sells, including the ones that cannot currently be granted. Each entry carries its status and a `grantable` flag — preview modules are reserved but not sellable, and deprecated modules keep working for clients that already hold them but cannot be handed out again. Use this to render the grant UI; use PUT /admin/clients/{clientId}/modules to change what a client holds. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ModuleResponse"][];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/bills/{billId}/clear-matches": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Clear a voided bill's match data (admin)
         * @description Deletes a voided bill's match group, allocations and line resolutions, and walks the purchase orders and delivery notes it was consuming back down their status ladder so a re-issued invoice can match them. Voiding does this automatically; this is for bills voided before it did. Refused for a bill that is not voided. Idempotent. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    billId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ClearedBillMatches"];
                    };
                };
                /** @description Bill.NotFound — bill does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Match.BillNotVoided — the bill is not voided; only a voided bill's match data can be cleared */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/match-groups/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get a match group (admin)
         * @description One three-way match group in full: every bill line with its derived price and quantity variances, the allocations behind it and how each was matched (auto by SKU, auto by similarity, reviewer-confirmed, or manual), the ranked fuzzy purchase-order and delivery-note suggestions for the lines still unmatched, the bill header, the client's matching thresholds, and a count of how the lines were matched. This is the same view the organisation's own reviewer sees, with the engine's scores alongside it. Unlike the match group list, this recomputes suggestions on every call — fetch one group at a time, never in a loop. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["MatchGroupAdminView"];
                    };
                };
                /** @description Match.GroupNotFound — match group does not exist or belongs to another organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/bills/{billId}/allocations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List a bill's match allocations (admin)
         * @description The confirmed match allocations for a bill — each bill line tied to a purchase-order and/or delivery-note line, with how it was matched (Manual, Exact/auto, or Fuzzy) and who recorded it. Stored facts only; derived match suggestions are not included. Empty when the bill has no allocations. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    billId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["MatchAllocationAdminView"][];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/match-groups": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List match groups (admin)
         * @description List three-way match groups — the bill under review, who it belongs to, lifecycle status, and how much of it is matched — across organisations, with optional organisation, client, bill, invoice-number and status filtering and cursor-based pagination. This is the overview index: it carries no derived variances and no match suggestions, so it stays one query per page. Open a single group via /admin/match-groups/{id} for the reviewer's full derived view. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    OrganisationId?: string;
                    ClientId?: string;
                    Cursor?: string;
                    Limit?: number | string;
                    Status?: components["schemas"]["MatchGroupStatus"];
                    BillId?: string;
                    InvoiceNumber?: string;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfMatchGroupSummaryResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/match-stats-lines": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List the bill lines behind the match statistics (admin)
         * @description The drill-through for the match-statistics tiles: the individual bill lines in a state, with the ids needed to open the bill (and highlight the line), the purchase order and the delivery note. Scope it with either organisationId or clientId - one of the two is required, because the lines are classified in memory and an unscoped call would load every match group on the platform. Uncached, unlike the statistics themselves, because this is a work queue rather than a trend. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    OrganisationId?: string;
                    ClientId?: string;
                    Period?: components["schemas"]["MatchStatsPeriod"];
                    State?: components["schemas"]["MatchLineStateFilter"];
                    Cursor?: string;
                    Limit?: number | string;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfMatchLineAdminRow"];
                    };
                };
                /**
                 * @description Pagination.InvalidCursor — the cursor value is invalid
                 *
                 *     Match.StatsScopeRequired — the match-statistics line list must be scoped to an organisation or a client
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/clients/{clientId}/clone-for-match-testing": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Clone a client for three-way-match testing (admin)
         * @description Copy a client's matching-relevant data onto a brand-new client and rewind three-way matching to un-run, so auto-matching can be re-run under different AP settings and the two runs compared. COPIES: the client's organisations, its suppliers, the bills selected by the scope below together with their extracted line items, and all purchase orders and delivery notes. It copies NOTHING else — no users, no API keys, no invites, no payments, no approval policies, no companies, no webhooks. EXTRACTION IS HELD FIXED: bill, order and note lines are copied verbatim and no document is ever re-scanned, so matching settings are the only variable between the source and the clone. Bill PDFs are SHARED with the source rather than duplicated — the clone reads the same stored object and cannot delete it. THE CLONE IS A SANDBOX CLIENT: outbound AP email, the Gmail connector and pay-by-bank are all switched off and both OAuth redirect host lists are emptied, every organisation gets a freshly minted and registered inbound-email token so no forwarded supplier mail can reach it, there is no payment account, and no supplier or bill bank details are carried over. Every matching knob, by contrast, is copied faithfully — those are the thing under test. IT HAS NO USERS AND NO API KEY, so nobody can log into it: inspect it through the admin match surfaces using its returned ClientId. Scope the run with CreatedFrom/CreatedTo. The window bounds what is COPIED, not just what is re-matched, and a run selecting more bills than a single synchronous request can finish is refused rather than started. IF THE REWIND STEP FAILS, THE CLONE STILL EXISTS: the copy is committed before the rewind runs, so a failure there leaves that client — and its copy of real customer data — in place. A handled failure returns an error naming the new ClientId; an unexpected one surfaces as a 500 and the id is recorded only in the logs. Either way, finish it with the rematch endpoint or remove it by hand; no delete endpoint ships in v1. MODE: everything above describes Rewound, the default. Verbatim instead copies the source's EXISTING match groups, allocations, line resolutions and line stats as a baseline, leaves bills in their real states and purchase orders and delivery notes at their real statuses, and does NOT run the matcher at all — re-run it deliberately with the rematch endpoint once settings are tuned. A Verbatim run has no rewind phase, so unlike the case above it CANNOT leave a committed clone behind on failure: the copy rolls back and creates nothing. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    clientId: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    "application/json": null | components["schemas"]["CloneForMatchTestingRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["MatchTestCloneResponse"];
                    };
                };
                /**
                 * @description Clone.ScopeTooLarge — the scope selects more bills than a single synchronous rewind can process
                 *
                 *     Clone.RewindScopeEmpty — the supplied scope selects no bills
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Clone.SourceClientNotFound — the source client was not found */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/clients/{clientId}/match-stats/refresh": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Force match stats to recompute for a client (admin)
         * @description Drop this client's cached three-way match statistics so the next read recomputes from the database. Clears the client-wide rollup for every period, and the per-organisation drill-down for every organisation under the client. Nothing is written and no matching is re-run — this only discards a cached answer, so it is safe on a real client as well as on a match-testing clone. It does NOT recompute inline: fetch the statistics again afterwards, and that read pays for the fresh computation. Scoped to the given client only; no other tenant's cached statistics are affected. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    clientId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["RefreshMatchStatsResult"];
                    };
                };
                /** @description Client.NotFound — the client does not exist or is not visible to the caller */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/clients/{clientId}/rematch": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Re-run three-way matching on a cloned client (admin)
         * @description Re-run auto-matching on a match-testing clone from a clean slate, so an AP settings change can be judged without cloning again. It DELETES this client's match groups, allocations, line resolutions and line stats, returns every in-scope bill to review and clears its resolved approvers, and reopens the purchase orders and delivery notes those allocations were consuming — then re-runs the engine over the same bills and reports what it did. A purchase order or delivery note a human had CLOSED is REOPENED if this run un-allocated it, and that cannot be undone: the engine only ever derives Open, PartiallyMatched and FullyMatched, so nothing puts Closed back. Cancelled and Draft documents are never touched, and neither is a Closed document this run did not un-allocate. THERE IS NO UNDO more generally: any review decision recorded against those match groups is gone, and re-running the engine does not bring it back. PERMITTED ONLY ON A CLONE — a client with no clone provenance is refused and nothing is written. Being a Sandbox client is NOT sufficient and is not checked: sandbox is a tenancy mode real customers use. Extraction is untouched either way, so matching settings remain the only variable between runs. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    clientId: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    "application/json": null | components["schemas"]["RematchRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["MatchRewindResult"];
                    };
                };
                /**
                 * @description Clone.NotAClone — this operation is only permitted on a cloned client
                 *
                 *     Clone.RewindScopeEmpty — the supplied scope selects no bills
                 *
                 *     Clone.ScopeTooLarge — the scope selects more bills than a single synchronous rewind can process
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Client.NotFound — the client does not exist or is not visible to the caller */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/match-candidates/delivery-note-lines": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Search delivery-note lines as match candidates (admin)
         * @description Free-text search over a supplier's delivery-note lines, scored by the same name metric the matching engine uses to find candidates: trigram containment in both directions, edit distance, and a normalised token-set view that ignores word order, with an exact product-code match scoring 1.0 outright. Scope it with supplierId, organisationId or clientId — at least one is required, because an unscoped probe scans every delivery line on the platform. minSimilarity defaults to 0.5, deliberately below the client's own similarity threshold: the candidates worth explaining are the ones that fell short of it. Lines the engine could not have offered — already received in full against another bill, or on a closed or cancelled note — are returned too, flagged rather than hidden, because that is usually the answer. A delivery note carries no price, so the price and currency fields are always null. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    /** @description The text to score candidate lines against — typically a bill line's description, or a product code. At least three characters: trigrams are three characters wide, so a shorter probe matches nearly everything. */
                    Query?: string;
                    /** @description Restrict to one supplier's documents. This is the engine's own first filter — it only ever considers the billed supplier's orders and notes — so a search without it can surface lines that were never candidates for the bill in question. */
                    SupplierId?: string;
                    /** @description Restrict to one organisation's documents. */
                    OrganisationId?: string;
                    /** @description Restrict to every organisation belonging to one client. */
                    ClientId?: string;
                    /** @description The bill line the search was opened from. Filters NOTHING — it decides whose the goods are: each row comes back with how much of it is allocated to this bill line, so a consumed candidate can be told apart from one this very line already consumed. Omit it and that field is null rather than zero. */
                    BillLineId?: string;
                    /** @description Minimum name similarity (0–1) a line must reach to be returned. Defaults to 0.5, which sits below the typical 0.7 similarity threshold on purpose: a candidate above the threshold was already offered to the reviewer, and the ones that explain a missed match are underneath it. An exact product-code match is always returned regardless. */
                    MinSimilarity?: number | string;
                    /** @description Opaque cursor from a previous page's meta.cursors.next. Forward only — the list is a ranking, and a ranking is only stable in the direction it was computed. */
                    Cursor?: string;
                    /** @description Rows per page, 1–200. */
                    Limit?: number | string;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfMatchCandidateAdminRow"];
                    };
                };
                /**
                 * @description Pagination.InvalidCursor — the cursor value is invalid
                 *
                 *     Match.SearchScopeRequired — the match-candidate search must be scoped to a supplier, an organisation or a client
                 *
                 *     Match.SearchQueryTooShort — the match-candidate search needs at least three characters to search on
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/match-candidates/purchase-order-lines": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Search purchase-order lines as match candidates (admin)
         * @description Free-text search over a supplier's purchase-order lines, scored by the same name metric the matching engine uses to find candidates: trigram containment in both directions, edit distance, and a normalised token-set view that ignores word order, with an exact product-code match scoring 1.0 outright. Scope it with supplierId, organisationId or clientId — at least one is required, because an unscoped probe scans every order line on the platform. minSimilarity defaults to 0.5, deliberately below the client's own similarity threshold: the candidates worth explaining are the ones that fell short of it. Lines the engine could not have offered — fully consumed, or on a closed or cancelled order — are returned too, flagged rather than hidden, because that is usually the answer. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    /** @description The text to score candidate lines against — typically a bill line's description, or a product code. At least three characters: trigrams are three characters wide, so a shorter probe matches nearly everything. */
                    Query?: string;
                    /** @description Restrict to one supplier's documents. This is the engine's own first filter — it only ever considers the billed supplier's orders and notes — so a search without it can surface lines that were never candidates for the bill in question. */
                    SupplierId?: string;
                    /** @description Restrict to one organisation's documents. */
                    OrganisationId?: string;
                    /** @description Restrict to every organisation belonging to one client. */
                    ClientId?: string;
                    /** @description The bill line the search was opened from. Filters NOTHING — it decides whose the goods are: each row comes back with how much of it is allocated to this bill line, so a consumed candidate can be told apart from one this very line already consumed. Omit it and that field is null rather than zero. */
                    BillLineId?: string;
                    /** @description Minimum name similarity (0–1) a line must reach to be returned. Defaults to 0.5, which sits below the typical 0.7 similarity threshold on purpose: a candidate above the threshold was already offered to the reviewer, and the ones that explain a missed match are underneath it. An exact product-code match is always returned regardless. */
                    MinSimilarity?: number | string;
                    /** @description Opaque cursor from a previous page's meta.cursors.next. Forward only — the list is a ranking, and a ranking is only stable in the direction it was computed. */
                    Cursor?: string;
                    /** @description Rows per page, 1–200. */
                    Limit?: number | string;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfMatchCandidateAdminRow"];
                    };
                };
                /**
                 * @description Pagination.InvalidCursor — the cursor value is invalid
                 *
                 *     Match.SearchScopeRequired — the match-candidate search must be scoped to a supplier, an organisation or a client
                 *
                 *     Match.SearchQueryTooShort — the match-candidate search needs at least three characters to search on
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/organisations/{organisationId}/match-practice-data": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Seed three-way-match practice data (admin)
         * @description Add a batch of three-way-match practice bills to an organisation, in one of two shapes. ManualSet leaves the whole reconciliation to a person: nothing is allocated, wording is held below the client's auto-accept threshold, prices drift past tolerance, deliveries land short or over, and some charges have no paperwork behind them. MixedMatchTypes instead puts several KINDS of line on one bill — matched outright on SKU, matched unattended on wording, merely suggested, invisible to the engine, and unmatchable — so a single bill shows the full range. Both are deterministic: same suppliers, items, wording and prices every call, with only document numbers and dates moving. Additive — every call appends a fresh batch, reusing the same demo suppliers and continuing the document numbering, and never alters or removes anything already there. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organisationId: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    "application/json": null | components["schemas"]["SeedMatchPracticeDataAdminRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["SeedMatchPracticeDataAdminResponse"];
                    };
                };
                /** @description Organisation.NotFound — the organisation does not exist or could not be resolved */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/magic-links": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List magic links
         * @description List magic links with optional organisation filtering and cursor-based pagination.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    Cursor?: string;
                    Limit?: number | string;
                    OrganisationId?: string;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfMagicLinkResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        /**
         * Create magic link
         * @description Generate a magic link that grants access to a specific organisation.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        post: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["CreateMagicLinkRequest"];
                };
            };
            responses: {
                /** @description Created */
                201: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CreateMagicLinkResponse"];
                    };
                };
                /** @description MagicLink.MissingOrganisationId — organisation ID is required */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/invoices/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get an invoice (admin)
         * @description Retrieve an invoice by id without organisation scoping — full line-item detail.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["InvoiceResponse"];
                    };
                };
                /** @description Invoice.NotFound — no invoice with that id for this organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        /**
         * Void invoice (admin)
         * @description Void an invoice in any organisation. The row is retained with Status = Void. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        delete: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description No Content */
                204: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Invoice.NotFound — no invoice with that id for this organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Invoice.CommandFailed — the invoice command was rejected by the saga (state conflict)
                 *
                 *     Invoice.VoidRequiresCreditNote — the invoice was sent as an e-invoice, so it is corrected with a credit note rather than voided
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/invoices/{invoiceId}/audit-logs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List audit logs for an invoice (admin)
         * @description Paged audit-log history for an invoice: state transitions, reminder outcomes, and the actor behind each step. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    Cursor?: string;
                    Limit?: number | string;
                };
                header?: never;
                path: {
                    invoiceId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfInvoiceAuditLogResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Invoice.NotFound — no invoice with that id for this organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/invoices/audit-logs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List invoice audit logs across all organisations (admin)
         * @description Paged audit-log history for invoices across every organisation, newest first. Optionally filter by organisation and/or event type. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    Cursor?: string;
                    Limit?: number | string;
                    OrganisationId?: string;
                    EventType?: components["schemas"]["InvoiceEventType"];
                    FromState?: components["schemas"]["InvoiceState"];
                    ToState?: components["schemas"]["InvoiceState"];
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfInvoiceAuditLogResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/invoice-emails": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List all invoice emails (admin)
         * @description List invoice email send records across organisations, with optional organisation, invoice, and status filtering. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    OrganisationId?: string;
                    InvoiceId?: string;
                    Status?: components["schemas"]["InvoiceEmailStatus"];
                    Cursor?: string;
                    Limit?: number | string;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfAdminInvoiceEmailResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/invoices": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List invoices across organisations (admin)
         * @description Paged list of invoices, newest first. Optionally filter by organisation, status, customer, issue date, and invoice number (case-insensitive, matches any part). Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    Cursor?: string;
                    Limit?: number | string;
                    OrganisationId?: string;
                    States?: components["schemas"]["InvoiceState"][];
                    CustomerId?: string;
                    IssueDateFrom?: string;
                    IssueDateTo?: string;
                    RecurringScheduleId?: string;
                    InvoiceNumber?: string;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfInvoiceResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/invoice-reminders": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List all invoice reminders (admin)
         * @description List invoice reminders across organisations, with optional organisation, invoice, status, and offset filters. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    OrganisationId?: string;
                    InvoiceId?: string;
                    Status?: components["schemas"]["InvoiceReminderStatus"];
                    Offset?: components["schemas"]["InvoiceReminderOffset"];
                    Cursor?: string;
                    Limit?: number | string;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfAdminInvoiceReminderResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/gmail-connections/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get a Gmail connection (admin)
         * @description Returns full Gmail connection details for debugging: core fields, sync state, computed health flags (token/watch expiry), backfill window, attachment counts by state, and a Datadog traces deep-link.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["GmailConnectionAdminResponse"];
                    };
                };
                /** @description Gmail.ConnectionNotFound — connection does not exist */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/organisations/{organisationId}/gmail-audit-logs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Gmail audit logs for an organisation (admin)
         * @description Paged audit trail of Gmail connector activity for an organisation: connection lifecycle, candidate detections and imports, reauth signals. Cursor follows the standard keyset pagination convention.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    Cursor?: string;
                    Limit?: number | string;
                    EventType?: components["schemas"]["GmailAuditLogEventType"];
                    GmailConnectionId?: string;
                };
                header?: never;
                path: {
                    organisationId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfGmailAuditLogResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/gmail-connections": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Gmail connections (admin)
         * @description Paged list of Gmail connections across all organisations, newest first. Filterable by organisation, client, status, and email address. Cursor follows the standard keyset pagination convention.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    Cursor?: string;
                    Limit?: number | string;
                    OrganisationId?: string;
                    ClientId?: string;
                    Status?: components["schemas"]["GmailConnectionStatus"];
                    EmailAddress?: string;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfGmailConnectionAdminListItem"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/card-connections": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List all card connections (admin)
         * @description Lists card connections across organisations, optionally filtered. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    OrganisationId?: string;
                    Cursor?: string;
                    Limit?: number | string;
                    Status?: components["schemas"]["CardConnectionStatus"];
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfCardConnectionResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/card-transactions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List all card transactions (admin)
         * @description Lists card transactions across organisations. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    OrganisationId?: string;
                    Cursor?: string;
                    Limit?: number | string;
                    Status?: components["schemas"]["CardTransactionStatus"];
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfCardTransactionResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/expenses": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List all expenses (admin)
         * @description Lists expenses across organisations, most recent spend first. Optionally filter by organisation, state, spend date and merchant name (case-insensitive, matches any part). Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    OrganisationId?: string;
                    Cursor?: string;
                    Limit?: number | string;
                    States?: components["schemas"]["ExpenseState"][];
                    From?: string;
                    To?: string;
                    Merchant?: string;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfExpenseResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/expenses/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get expense (admin)
         * @description Returns a single expense from any organisation, with its coding lines, the underlying card transaction, and the similar expenses behind a learned account. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ExpenseResponse"];
                    };
                };
                /** @description Expense.NotFound — when the expense does not exist or belongs to another organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/expenses/{id}/audit-logs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List an expense's history (admin)
         * @description Returns everything that happened to an expense in any organisation, newest first. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ExpenseAuditLogResponse"][];
                    };
                };
                /** @description Expense.NotFound — when the expense does not exist or belongs to another organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/clients/{clientId}/expense-settings": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get a client's expense settings (admin)
         * @description Retrieve a client's expense settings (applied to every organisation under the client): the review-before-post gate, draft posting, the receipt-matching thresholds and the card backfill window. Read-only admin view; the client edits these via /settings/expenses. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    clientId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ClientExpenseSettingsResponse"];
                    };
                };
                /** @description Client.NotFound — the client does not exist or is not visible to the caller */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/receipt-llm-extractions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List receipt LLM extractions (admin)
         * @description List the LLM receipt-extraction diagnostics across organisations, most recent first — model, token usage, USD cost, config and timing, each linking back to its receipt via receiptId. Optionally filtered to one organisation, with cursor-based pagination. Only receipts read by the model appear; a receipt that fell back to OCR has no record. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    OrganisationId?: string;
                    Cursor?: string;
                    Limit?: number | string;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfReceiptLlmExtractionResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/receipts/{id}/llm-extraction": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get receipt LLM extraction (admin)
         * @description Returns the model, token usage, USD cost, config and timing for one receipt's extraction. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ReceiptLlmExtractionResponse"];
                    };
                };
                /** @description Receipt.LlmExtractionNotFound — receipt has no LLM extraction record (it fell back to OCR, or has not finished extracting) */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/organisations/{organisationId}/e-invoicing": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get an organisation's e-invoicing status (admin)
         * @description The organisation's e-invoicing registration status, its network address once registered, and any outstanding actions: the same answer the organisation's own status read gives, whether or not its client holds an e-invoicing module. Returns NotStarted, with details prefilled from the organisation, when no registration has been submitted. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organisationId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["EInvoicingRegistrationResponse"];
                    };
                };
                /** @description Organisation.NotFound — the organisation does not exist or could not be resolved */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/e-invoicing/registrations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List e-invoicing registrations (admin)
         * @description Every organisation's network registration, across clients, newest first. Keyset-paginated: follow meta.cursors.next for the next page. Filter by state to find the ones that need attention — Failed for refusals, ActionRequired for a registration waiting on a proof-of-ownership document, Submitted or Processing for ones still in flight. Each row carries the provider's own account of what happened, including which workflow step failed and when. Filter by clientId for one client's organisations only. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    state?: components["schemas"]["EInvoicingRegistrationState"];
                    country?: string;
                    clientId?: string;
                    cursor?: string;
                    limit?: number | string;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfEInvoicingRegistrationAdminResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/organisations/{organisationId}/received-e-invoices": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List an organisation's received e-invoices (admin)
         * @description Electronic invoices received for one organisation, newest first, whether or not its client holds an e-invoicing module. Keyset-paginated: follow meta.cursors.next for the next page. Each carries the bill or supplier credit note it became, or the reason it became neither. For every delivery across organisations, including unplaced ones, use the received e-invoices queue instead. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    cursor?: string;
                    limit?: number | string;
                    networkReference?: string;
                };
                header?: never;
                path: {
                    organisationId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfOrganisationEInvoiceResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Organisation.NotFound — the organisation does not exist or could not be resolved */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/outbound-e-invoices": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List sent e-invoices (admin)
         * @description Every invoice and credit note sent over an e-invoicing network, across organisations, newest first. Filter by networkReference to find a document by the id the network gave it (for SDI, the IdentificativoSdI), including a superseded attempt's; by organisationId; or by state. Keyset-paginated: follow meta.cursors.next. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    organisationId?: string;
                    state?: components["schemas"]["OutboundEInvoiceState"];
                    networkReference?: string;
                    cursor?: string;
                    limit?: number | string;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfOutboundEInvoiceAdminView"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/received-e-invoices": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List received e-invoices (admin)
         * @description Every e-invoice delivered to us, across organisations, newest first. Keyset-paginated: follow meta.cursors.next for the next page. Filter routedSuccess=false for documents that arrived and could not be placed — these need action. Includes the provider's own faults, which for an unreadable document are the only explanation that exists. Filter by networkReference to find a document by the id the network gave it (for SDI, the IdentificativoSdI). Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    routedSuccess?: boolean;
                    state?: components["schemas"]["ReceivedEInvoiceState"];
                    cursor?: string;
                    limit?: number | string;
                    networkReference?: string;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfReceivedEInvoiceAdminResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/outbound-e-invoices/{id}/resync": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Resync a sent e-invoice (admin)
         * @description Asks the e-invoicing provider about one delivery now and records what it says: the outcome of the current run, or any network reports not yet recorded. Changes nothing the provider does not confirm. Returns the delivery as it stands afterwards. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["OutboundEInvoiceAdminView"];
                    };
                };
                /** @description EInvoicing.DeliveryNotFound — this invoice has not been sent as an e-invoice */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description EInvoicing.ProviderRejected — the e-invoicing provider rejected the document */
                422: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description EInvoicing.ProviderUnavailable — the e-invoicing provider could not be reached */
                502: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/outbound-e-invoices/{id}/resend": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Resend a sent e-invoice (admin)
         * @description Sends a failed or abandoned delivery again, exactly as the organisation's own resend would: a document rebuilt from current data when nothing reached the network, otherwise the saved document. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["OutboundEInvoiceAdminView"];
                    };
                };
                /**
                 * @description EInvoicing.DeliveryNotFound — this invoice has not been sent as an e-invoice
                 *
                 *     Invoice.NotFound — no invoice with that id for this organisation
                 *
                 *     CreditNote.NotFound — no credit note with that id on this invoice for this organisation
                 *
                 *     Customer.NotFound — customer does not exist or belongs to a different organisation
                 *
                 *     Organisation.NotFound — the organisation does not exist or could not be resolved
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description EInvoicing.DeliveryNotResendable — this delivery cannot be sent again: it is in flight or delivered, or the network refused a document that has not changed since
                 *
                 *     EInvoicing.DeliveryNotRetryable — this delivery cannot be retried; the document itself was refused
                 *
                 *     EInvoicing.AlreadyDelivered — this invoice has already been sent as an e-invoice
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description EInvoicing.CountryNotSupported — e-invoicing is not available in this organisation's country yet
                 *
                 *     EInvoicing.SellerNotRegistered — this organisation is not registered to send e-invoices
                 *
                 *     EInvoicing.CustomerNotAddressable — this customer has no e-invoicing address to deliver to
                 *
                 *     EInvoicing.DocumentInvalid — the invoice is not valid as an e-invoice
                 *
                 *     EInvoicing.TotalsMismatch — the calculated totals do not match this invoice
                 *
                 *     EInvoicing.ProviderRejected — the e-invoicing provider rejected the document
                 */
                422: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description EInvoicing.ProviderUnavailable — the e-invoicing provider could not be reached */
                502: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Service Unavailable
                 *
                 *     EInvoicing.SendNotConfigured — sending e-invoices is not configured for this organisation's country
                 */
                503: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/received-e-invoices/{id}/reprocess": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Reprocess a received e-invoice (admin)
         * @description Reads one received e-invoice back from the provider and runs ingestion again: routing to its organisation, then the bill or supplier credit note. Allowed for Received, Unroutable and Unreadable documents, and for a routed one that never became a bill or credit note. Refused for a document that already did. Returns the document as it stands afterwards. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ReceivedEInvoiceAdminResponse"];
                    };
                };
                /** @description EInvoicing.ReceivedEInvoiceNotFound — no e-invoice with this id was received for this organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description EInvoicing.ReceivedEInvoiceAlreadyRouted — this received e-invoice has already become a bill or credit note, so there is nothing to reprocess */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description EInvoicing.ProviderUnavailable — the e-invoicing provider could not be reached */
                502: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/demos": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List demo organisations (admin)
         * @description Every demo organisation, newest first: prospect, company, preset, seeding status, expiry and when the prospect last signed in. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["DemoAdminResponse"][];
                    };
                };
            };
        };
        put?: never;
        /**
         * Create a demo organisation (admin)
         * @description Creates a demo organisation under the shared Demo client (or the Demo client given), seeded later as the chosen made-up business. The prospect becomes its Admin and gets a single-use sign-in link to the sandbox's "Try Dolfin Books" page, valid until the demo expires in 30 days. Emails the link unless sendEmail is false; the link is returned either way. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        post: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["CreateDemoAdminRequest"];
                };
            };
            responses: {
                /** @description Created */
                201: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["DemoLinkAdminResponse"];
                    };
                };
                /**
                 * @description Demo.InvalidRequest — prospect name, a valid prospect email, company name and a known preset are required; days must be 1 to 365
                 *
                 *     Demo.NotADemoClient — the client does not exist or is not a Demo client
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/demos/{organisationId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get a demo organisation (admin)
         * @description One demo organisation: prospect, company, preset, seeding status, expiry and last sign-in. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organisationId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["DemoAdminResponse"];
                    };
                };
                /** @description Demo.NotFound — organisation does not exist, is not a demo, or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        /**
         * Delete a demo (admin)
         * @description Permanently deletes the demo organisation, everything in it, and its users who belong to no other organisation. Refused for any organisation that is not a demo. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        delete: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organisationId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description No Content */
                204: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Demo.NotFound — organisation does not exist, is not a demo, or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Demo.PurgeBlocked — a row still references the demo's data, so nothing was removed */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/demos/{organisationId}/link": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Mint a new demo sign-in link (admin)
         * @description A fresh single-use sign-in link for the demo's prospect (its first Admin), valid until the demo expires, or for 30 days when the demo never expires; earlier links keep working until used. Optionally emails it. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organisationId: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["MintDemoLinkAdminRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["DemoLinkAdminResponse"];
                    };
                };
                /** @description Demo.NotFound — organisation does not exist, is not a demo, or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Demo.Expired — the demo has expired; extend it before minting a link */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/demos/{organisationId}/extend": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Extend a demo (admin)
         * @description Moves the demo's expiry later by the given number of days, counted from now if it has already expired. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organisationId: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["ExtendDemoAdminRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["DemoAdminResponse"];
                    };
                };
                /** @description Demo.InvalidRequest — prospect name, a valid prospect email, company name and a known preset are required; days must be 1 to 365 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Demo.NotFound — organisation does not exist, is not a demo, or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/demos/{organisationId}/seed": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Seed a demo now (admin)
         * @description Starts seeding the demo before the prospect clicks Try, e.g. ahead of a call. A no-op while it is already seeding. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organisationId: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    "application/json": null | components["schemas"]["SeedDemoRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["DemoStatusResponse"];
                    };
                };
                /** @description Demo.PresetRequired — the demo has no preset yet; name one of Cafe, Agency, Ecommerce or Wholesale */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Demo.NotFound — organisation does not exist, is not a demo, or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Demo.AlreadySeeded — the demo has already been seeded; reset it to start again */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/demos/{organisationId}/reset": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Reset a demo (admin)
         * @description Removes everything in the demo except the organisation, its users and memberships, then seeds the same business again dated to today. Works even while it is seeding, to unstick one. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organisationId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["DemoStatusResponse"];
                    };
                };
                /** @description Demo.NotFound — organisation does not exist, is not a demo, or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Demo.PurgeBlocked — a row still references the demo's data, so nothing was removed */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/delivery-notes/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get a delivery note (admin)
         * @description Retrieve any delivery note and its lines by ID, across organisations. Each line carries how much of its received quantity has been matched. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["DeliveryNoteResponse"];
                    };
                };
                /** @description DeliveryNote.NotFound — delivery note does not exist or belongs to another organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/delivery-notes": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List all delivery notes (admin)
         * @description List delivery notes across organisations, with optional organisation, supplier and status filtering. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    OrganisationId?: string;
                    Cursor?: string;
                    Limit?: number | string;
                    SupplierId?: string;
                    Status?: components["schemas"]["DeliveryNoteStatus"];
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfDeliveryNoteResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/invoices/{invoiceId}/credit-notes": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List credit notes for an invoice (admin)
         * @description Read-only list of credit notes raised against an invoice, newest first. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    invoiceId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CreditNoteResponse"][];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/credit-notes": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List credit notes across organisations (admin)
         * @description Paged list of credit notes, newest first. Optionally filter by organisation and/or invoice. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    Cursor?: string;
                    Limit?: number | string;
                    OrganisationId?: string;
                    InvoiceId?: string;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfCreditNoteResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/company-inbox-bills/{billId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get company inbox bill (admin)
         * @description Retrieve a bill still waiting in a company inbox — extracting, failed, awaiting an organisation, or discarded — across all clients, including the owning ClientId, its routing candidates and its discard details. A routed bill is no longer here: retrieve it from GET /admin/bills/{id} under the same id. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    billId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CompanyInboxBillAdminResponse"];
                    };
                };
                /** @description CompanyInboxBill.NotFound — the company bill does not exist or belongs to a different client */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/company-inbox-bills/{billId}/file-url": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get company inbox bill file URL (admin)
         * @description Get a short-lived signed URL for the document of a bill still waiting in a company inbox, across all clients. Once the bill is routed, use GET /admin/bills/{id}/file-url instead. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    billId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BillFileUrlResponse"];
                    };
                };
                /**
                 * @description CompanyInboxBill.NotFound — the company bill does not exist or belongs to a different client
                 *
                 *     CompanyInboxBill.NoFile — the company bill has no uploaded document
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/companies/{companyId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get company (admin)
         * @description Retrieve a single company by id across all clients, including the owning ClientId. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CompanyAdminResponse"];
                    };
                };
                /** @description Company.NotFound — the company does not exist or belongs to a different client */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/companies": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List all companies (admin)
         * @description List companies across clients, with optional client and name filtering. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    ClientId?: string;
                    Cursor?: string;
                    Limit?: number | string;
                    Name?: string;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfCompanyAdminResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/clients": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List clients
         * @description List all clients with optional name filtering and cursor-based pagination.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    Cursor?: string;
                    Limit?: number | string;
                    Name?: string;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfClientResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        /**
         * Create client
         * @description Register a new client that can own organisations and hold API keys.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        post: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["CreateClientRequest"];
                };
            };
            responses: {
                /** @description Created */
                201: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ClientResponse"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/clients/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get client (admin)
         * @description Retrieve a single client by id, including its clone provenance: SourceClientId and ClonedAt are non-null when this client was created by the match-testing clone, and SourceClientId is what permits POST /admin/clients/{id}/rematch on it. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ClientAdminResponse"];
                    };
                };
                /** @description Client.NotFound — the client does not exist or is not visible to the caller */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        /**
         * Delete a cloned client (admin)
         * @description Permanently delete a match-testing clone and everything it owns: its organisations, suppliers, bills, purchase orders, delivery notes, match data, settings and module grants. PERMITTED ONLY ON A CLONE — a client with no clone provenance (SourceClientId) is refused and nothing is deleted. Being a Sandbox client is NOT sufficient and is not checked: sandbox is a tenancy mode real customers use. The client it was cloned from is never touched. The delete runs in a single transaction, so if anything still references the clone's data that cannot be removed with it, the whole delete is rolled back. There is no undo. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        delete: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description No Content */
                204: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Clone.NotAClone — this operation is only permitted on a cloned client */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Client.NotFound — the client does not exist or is not visible to the caller */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Clone.DeleteBlocked — the clone has data that cannot be deleted with it, so nothing was deleted */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/clients/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get client
         * @description Retrieve a single client by id.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ClientResponse"];
                    };
                };
                /** @description Client.NotFound — the client does not exist or is not visible to the caller */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        /**
         * Update client
         * @description Update a client's name and/or per-client revenue share rates. Rate changes take effect on new PaymentIntents — historical InvoicePayments keep their snapshotted rates.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        put: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["UpdateClientRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ClientResponse"];
                    };
                };
                /**
                 * @description Client.MissingName — client name is required
                 *
                 *     Client.InvalidPaymentRevenueShare — PaymentRevenueSharePercent must be zero or positive
                 *
                 *     Client.InvalidDolfinRevenueShare — DolfinRevenueSharePercent must be zero or positive
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Client.NotFound — the client does not exist or is not visible to the caller */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/clients/{clientId}/hidden-settings": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get a client's hidden settings (admin)
         * @description Retrieve a client's Dolfin-managed hidden settings — staff-only knobs the client cannot see or edit, currently the bill-extraction mode (Ocr/Llm) and, when Llm, which model (Gemini Flash, Claude Sonnet, or Claude Haiku). Applies to every organisation under the client. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    clientId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["HiddenClientSettingsResponse"];
                    };
                };
                /** @description Client.NotFound — the client does not exist or is not visible to the caller */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /**
         * Patch a client's hidden settings (admin)
         * @description Partially update a client's Dolfin-managed hidden settings — staff-only knobs the client cannot see or edit: the bill-extraction mode (Ocr/Llm) and, when Llm, which model (Gemini Flash, Claude Sonnet, or Claude Haiku). Applies to every organisation under the client. Only supplied fields change; a settings row is created on first write. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        patch: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    clientId: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["PatchHiddenClientSettingsRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["HiddenClientSettingsResponse"];
                    };
                };
                /** @description Client.NotFound — the client does not exist or is not visible to the caller */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        trace?: never;
    };
    "/admin/clients": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List clients (admin)
         * @description List all clients with optional name filtering and cursor-based pagination, including each one's clone provenance (SourceClientId / ClonedAt). A non-null SourceClientId is what makes a client eligible for POST /admin/clients/{id}/rematch and DELETE /admin/clients/{id}. Clones are HIDDEN by default: pass ShowClones=true to include them. Pass SourceClientId to list ONLY the match-testing clones made from that client — this is how you find out what a client has already been cloned into. It implies clones, so ShowClones is ignored when it is set. Pass Type (Live or Sandbox) to list only clients of that tenancy mode; omit it to list both. Pass Search to fuzzy-find clients by name using PostgreSQL trigram similarity, which tolerates typos and partial words where the exact-substring Name filter does not. Trigrams need three characters to carry any signal, so shorter queries are ignored rather than matching almost everything. Search and Name may be combined and are applied together (AND). Ordering stays newest-first, NOT by match score, so the results remain cursor-pageable. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    Cursor?: string;
                    Limit?: number | string;
                    Name?: string;
                    SourceClientId?: string;
                    Search?: string;
                    Type?: components["schemas"]["ClientType"];
                    ShowClones?: boolean;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfClientAdminResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/organisations/{organisationId}/books": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List an organisation's books (admin)
         * @description Every set of books the organisation has had, newest first, closed ones included, with status, settings and setup checklist. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organisationId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BookResponse"][];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/organisations/{organisationId}/books/{bookId}/journal-entries": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List a book's journal entries (admin)
         * @description The general ledger of any of the organisation's books, closed ones included, newest accounting date first, with the same filters as the tenant list. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    /** @description Opaque pagination cursor. Pass back `next` or `previous` from a previous page's cursors. */
                    Cursor?: string;
                    /** @description Page size, 1 to 100. Defaults to 20. */
                    Limit?: number | string;
                    /** @description Only entries with a line on this ledger account. */
                    AccountId?: string;
                    /** @description Only entries dated on or after this day, YYYY-MM-DD. */
                    From?: string;
                    /** @description Only entries dated on or before this day, YYYY-MM-DD. */
                    To?: string;
                    /** @description Only entries from this kind of source document. */
                    SourceType?: components["schemas"]["JournalSourceType"];
                    /** @description Only entries of this source document (its id: the invoice, bill, expense, bank transaction...). */
                    SourceId?: string;
                    /** @description Cash lists each entry as it counts on cash basis: a payment carries the income, expenses and VAT it released from its document (pro rata), and invoices and bills, which release nothing until paid, are left out. Accrual lists the entries as posted. Defaults to the book's reporting basis. */
                    Basis?: components["schemas"]["ReportingBasis"];
                };
                header?: never;
                path: {
                    organisationId: string;
                    bookId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["JournalEntryPage"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Books.NotFound — book does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/bills/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get bill (admin)
         * @description Retrieve a single bill with full detail across organisations. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BillResponse"];
                    };
                };
                /** @description Bill.NotFound — bill does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/bills/{id}/file-url": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get bill file URL (admin)
         * @description Get a short-lived URL for the bill's document across organisations — a signed link to the stored file, or the network provider's copy for a received e-invoice. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BillFileUrlResponse"];
                    };
                };
                /**
                 * @description Bill.NotFound — bill does not exist or belongs to a different organisation
                 *
                 *     Bill.NoFile — bill has no document to show
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/bills/{billId}/llm-extraction": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get bill LLM extraction (admin)
         * @description Get the LLM extraction diagnostics for a bill — the model, input/output and cache token counts, the USD cost split, the config the request ran with (effort, thinking, max_tokens), duration and timestamp, plus who it was for: organisationId, and companyId as well when the document arrived through a company inbox. Only populated for bills extracted by the LLM path; OCR-extracted bills return 404. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    billId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BillLlmExtractionResponse"];
                    };
                };
                /** @description Bill.LlmExtractionNotFound — bill has no LLM extraction record (it was extracted by OCR, or not yet extracted) */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/bills/{billId}/audit-logs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List audit logs for a bill (admin)
         * @description Paged audit-log history for a bill: state transitions, actor, and bill snapshot at each step. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    Cursor?: string;
                    Limit?: number | string;
                };
                header?: never;
                path: {
                    billId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfBillAuditLogResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Bill.NotFound — bill does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/bills/audit-logs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List bill audit logs across all organisations (admin)
         * @description Paged audit-log history for bills across every organisation, newest first. Optionally filter by organisation and/or event type. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    Cursor?: string;
                    Limit?: number | string;
                    OrganisationId?: string;
                    EventType?: components["schemas"]["BillEventType"];
                    FromState?: components["schemas"]["BillState"];
                    ToState?: components["schemas"]["BillState"];
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfBillAuditLogResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/llm-extractions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List LLM extractions (admin)
         * @description List the LLM (Claude vision) bill-extraction diagnostics across organisations, most recent first — model, token usage, USD cost, config and timing, each linking back to its bill via billId. Covers both extraction paths: bills uploaded to an organisation carry organisationId, while documents that arrived in a company inbox also carry companyId, and gain their organisationId once routing assigns one. Optionally filtered to one organisation or one company, with cursor-based pagination. Only LLM-extracted bills appear. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    OrganisationId?: string;
                    CompanyId?: string;
                    Cursor?: string;
                    Limit?: number | string;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfBillLlmExtractionResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/bills": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List all bills (admin)
         * @description List bills across organisations, newest first, with optional organisation, state, supplier, invoice date and invoice number (case-insensitive, matches any part) filtering. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    OrganisationId?: string;
                    Cursor?: string;
                    Limit?: number | string;
                    States?: components["schemas"]["BillState"][];
                    SupplierId?: string;
                    InvoiceNumber?: string;
                    InvoiceDateFrom?: string;
                    InvoiceDateTo?: string;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfBillResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/organisations/{organisationId}/bank-accounts/{bankAccountId}/transactions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List a bank account's transactions (admin)
         * @description Synced transactions on one of the organisation's bank accounts, newest first, whatever the state of its connection. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    /** @description Opaque pagination cursor from a previous page. */
                    Cursor?: string;
                    /** @description Page size, 1 to 100. Defaults to 50. */
                    Limit?: number | string;
                };
                header?: never;
                path: {
                    organisationId: string;
                    bankAccountId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfBankTransactionResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description BankAccount.NotFound — bank account does not exist, belongs to a different organisation, or its connection was disconnected or revoked */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/organisations/{organisationId}/bank-connections": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List an organisation's bank connections (admin)
         * @description Every bank connection of the organisation, newest first, with its accounts, the provider consent and the full state history. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organisationId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BankConnectionAdminResponse"][];
                    };
                };
                /** @description Organisation.NotFound — the organisation does not exist or could not be resolved */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/api-keys": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List API keys (admin)
         * @description List API keys across Clients with optional ClientId filter and cursor pagination.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    ClientId?: string;
                    Cursor?: string;
                    Limit?: number | string;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfApiKeyResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        /**
         * Create API key (admin)
         * @description Mint a new API key for any Client. Admin only.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        post: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["AdminCreateApiKeyRequest"];
                };
            };
            responses: {
                /** @description Created */
                201: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CreateApiKeyResponse"];
                    };
                };
                /** @description ApiKey.ExpiresAtInPast — ExpiresAt is not in the future */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Client.NotFound — the client does not exist or is not visible to the caller */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/api-keys/{id}/revoke": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Revoke API key (admin)
         * @description Revoke any API key by id. Admin only.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description No Content */
                204: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description ApiKey.NotFound — API key does not exist or does not belong to this Client */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description ApiKey.AlreadyRevoked — key is already revoked */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/analytics/organisations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Organisation inventory with document counts (admin)
         * @description Every organisation under the given clients - name, creation date, owning company, and how many bills, purchase orders and delivery notes it received in the window. Organisations with NO documents in the window are included: the question this answers is which sites exist, not which were busy. Every row carries its client's type, so an organisation present in both a live and a sandbox client appears once for each and the difference is visible without a second call. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query: {
                    From: string;
                    To: string;
                    ClientIds?: string[];
                    OrganisationId?: string;
                    Format?: string;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["AnalyticsOrganisationRow"][];
                    };
                };
                /**
                 * @description Analytics.ScopeRequired — admin analytics must be scoped to at least one client
                 *
                 *     Analytics.TooManyClients — too many clients requested in one analytics call
                 *
                 *     Analytics.InvalidWindow — the analytics window ends before it starts
                 *
                 *     Analytics.WindowTooLong — the analytics window exceeds the maximum span
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/analytics/document-volume-daily": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Daily document volume (admin)
         * @description Per organisation per day, how many bills, purchase orders and delivery notes were created, across one or more clients. Live and test are not a parameter: every row carries its client's type, so one call covers both. Every day in the window is returned. NOTE on bills that arrived through a company inbox - their CreatedAt is the moment they were ROUTED to an organisation, not the moment they arrived, because promotion re-stamps it and deletes the inbox row that held the arrival time. Such a bill therefore lands on the day it was routed. Use /admin/analytics/inbox-routing for the arrival-anchored view. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query: {
                    From: string;
                    To: string;
                    ClientIds?: string[];
                    OrganisationId?: string;
                    Format?: string;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["DocumentVolumeDailyRow"][];
                    };
                };
                /**
                 * @description Analytics.ScopeRequired — admin analytics must be scoped to at least one client
                 *
                 *     Analytics.TooManyClients — too many clients requested in one analytics call
                 *
                 *     Analytics.InvalidWindow — the analytics window ends before it starts
                 *
                 *     Analytics.WindowTooLong — the analytics window exceeds the maximum span
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/analytics/activity": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get platform-wide activity (admin)
         * @description What every organisation on the platform created: all-time totals per resource, active organisations and records created for each of the last twelve months and the last thirteen weeks, and per-organisation breakdowns with first and last activity times. An organisation is active in a period if it created at least one bill, invoice, customer, supplier, product, tax rate, purchase order, delivery note, credit note, supplier credit note, expense or receipt in it. Cached server-side for up to an hour. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ActivityAnalyticsAdminResponse"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/clients/{clientId}/activity": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get a client's activity (admin)
         * @description What the client's organisations created: all-time totals per resource, active organisations and records created for each of the last twelve months and the last thirteen weeks, and per-organisation breakdowns with first and last activity times. An organisation is active in a period if it created at least one bill, invoice, customer, supplier, product, tax rate, purchase order, delivery note, credit note, supplier credit note, expense or receipt in it; activity does not carry forward. Cached server-side for up to an hour. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    clientId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ActivityAnalyticsAdminResponse"];
                    };
                };
                /** @description Client.NotFound — the client does not exist or is not visible to the caller */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/organisations/{organisationId}/activity": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get an organisation's activity (admin)
         * @description What the organisation created: all-time totals per resource with first and last creation times, and records created for each of the last twelve months and the last thirteen weeks. Cached server-side for up to an hour. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organisationId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ActivityAnalyticsAdminResponse"];
                    };
                };
                /** @description Organisation.NotFound — the organisation does not exist or could not be resolved */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/analytics/inbox-routing": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Company inbox routing, automatic versus manual (admin)
         * @description Per company, how bills that arrived in a company inbox were routed to an organisation. The auto-versus-manual split is read from the stored Bill.OrganisationAssignmentMethod, not inferred: the two code paths that can promote an inbox bill each hardcode their value, so it cannot be mislabelled, and the column has existed since the inbox table itself, so there are no unknowns. TWO headline shares are returned deliberately, because they answer different questions and differ by the parked backlog: manualShareOfAssigned is of bills that reached an organisation, nonAutoShareOfArrivals is of everything that arrived. Bills uploaded straight to an organisation never went through routing and are in neither. nonAutoShareOfArrivals is ALWAYS null when the request is scoped by OrganisationId: a still-parked inbox bill has no organisation yet, so its half of the arrivals denominator cannot be narrowed, and an org-scoped numerator over a company-wide denominator would misstate the figure - it is withheld rather than reported wrong. manualShareOfAssigned is unaffected. The lag block independently times each routed bill via BillLlmExtraction.ExtractedAt - the only pre-routing timestamp that survives promotion - and applies a 120-second threshold: at or under is treated as the system having done it, over as a person, regardless of the stored flag. coveredRows versus totalRoutedRows shows how many routed bills that timing rule could measure at all. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query: {
                    From: string;
                    To: string;
                    ClientIds?: string[];
                    OrganisationId?: string;
                    Format?: string;
                    CompanyId?: string;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["InboxRoutingCompanyRow"][];
                    };
                };
                /**
                 * @description Analytics.ScopeRequired — admin analytics must be scoped to at least one client
                 *
                 *     Analytics.TooManyClients — too many clients requested in one analytics call
                 *
                 *     Analytics.InvalidWindow — the analytics window ends before it starts
                 *
                 *     Analytics.WindowTooLong — the analytics window exceeds the maximum span
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/analytics/match-events": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Raw match event timestamps (admin)
         * @description Every surviving match allocation in a date window across one or more clients, as raw UTC timestamps with the organisation, bill and provenance bucket - the shape of matching through the day, not a daily count. Unit=Lines returns one row per allocation; Unit=Bills collapses to one row per bill per bucket, timestamped at its earliest allocation. NOTE: allocations are hard-deleted when a reviewer unpicks a match and nothing audits them, so this is a view of matches that STILL EXIST, not of every match ever made - which flatters the automatic buckets, since removals disproportionately correct engine mistakes. The JSON response is capped and reports totalCount and truncated; format=csv is uncapped. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query: {
                    From: string;
                    To: string;
                    ClientIds?: string[];
                    OrganisationId?: string;
                    Format?: string;
                    Unit?: components["schemas"]["MatchAnalyticsUnit"];
                    Buckets?: components["schemas"]["MatchOutcomeBucket"][];
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["MatchEventsResponse"];
                    };
                };
                /**
                 * @description Analytics.ScopeRequired — admin analytics must be scoped to at least one client
                 *
                 *     Analytics.TooManyClients — too many clients requested in one analytics call
                 *
                 *     Analytics.InvalidWindow — the analytics window ends before it starts
                 *
                 *     Analytics.WindowTooLong — the analytics window exceeds the maximum span
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/analytics/match-group-timing": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Time from match group created to first allocation (admin)
         * @description One row per match group CREATED in the window: how long it sat between the group being opened and the first allocation being written against it (gapSeconds), which bucket that first allocation fell in, and how the group's allocations split three ways - Automatic (the engine committed it: AutoSku, AutoSimilarity or AutoLinkedPo), SuggestionApproved (a reviewer accepted a suggestion) and Manual (a reviewer made the link themselves). Groups with NO allocations at all ARE included, with a null firstAllocationAt, gapSeconds and firstAllocationBucket and zero counts - they are usually the finding, since a view of only the groups that worked cannot show the ones nothing has been done to. The gap is WALL-CLOCK, not working hours: a group created on a Friday evening and matched on Monday morning reads as the whole weekend, so read a long tail as a calendar question before reading it as a queue one. A negative gap (an allocation timestamped before its own group) is clamped to 0. Like /admin/analytics/match-events this sees allocations that STILL EXIST - they are hard-deleted and unaudited - so a group whose only match was later unpicked reads as untouched. format=csv is uncapped. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query: {
                    From: string;
                    To: string;
                    ClientIds?: string[];
                    OrganisationId?: string;
                    Format?: string;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["MatchGroupTimingRow"][];
                    };
                };
                /**
                 * @description Analytics.ScopeRequired — admin analytics must be scoped to at least one client
                 *
                 *     Analytics.TooManyClients — too many clients requested in one analytics call
                 *
                 *     Analytics.InvalidWindow — the analytics window ends before it starts
                 *
                 *     Analytics.WindowTooLong — the analytics window exceeds the maximum span
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/analytics/match-outcomes-daily": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Daily match outcomes by method (admin)
         * @description Per organisation per day, how matches were made, split five ways: AutoSku (engine, product code), AutoSimilarity (engine, auto-accepted description match), AutoLinkedPo (engine, an order reached through a delivery note that quoted it), Confirmed (a reviewer accepted a suggestion) and Manual. Every day in the window is returned, including quiet ones, so a gap reads as a gap. Unit=Bills counts a bill once per bucket rather than once per line. Like /admin/analytics/match-events this counts matches that STILL EXIST - allocations are hard-deleted and unaudited. inconsistentRows counts rows recorded as both manual and engine-accepted, a state no write path produces; non-zero means the automation figures are over-reported somewhere. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query: {
                    From: string;
                    To: string;
                    ClientIds?: string[];
                    OrganisationId?: string;
                    Format?: string;
                    Unit?: components["schemas"]["MatchAnalyticsUnit"];
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["MatchOutcomesDailyResponse"];
                    };
                };
                /**
                 * @description Analytics.ScopeRequired — admin analytics must be scoped to at least one client
                 *
                 *     Analytics.TooManyClients — too many clients requested in one analytics call
                 *
                 *     Analytics.InvalidWindow — the analytics window ends before it starts
                 *
                 *     Analytics.WindowTooLong — the analytics window exceeds the maximum span
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/organisations/{organisationId}/agent/stats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Agent usage stats for an organisation (admin)
         * @description Aggregate agent usage: conversation counts by agent type, message counts by role, total token usage. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organisationId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["AdminAgentStatsResponse"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/agent/conversations/{conversationId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get agent conversation detail (admin)
         * @description Returns a single agent conversation with system prompt, agent surface info, token totals and the tool names available to the agent. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    conversationId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["AdminConversationDetailResponse"];
                    };
                };
                /** @description Conversation.NotFound — conversation does not exist */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/agent/conversations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List all agent conversations across organisations (admin)
         * @description Lists recent agent conversations across every organisation, with optional agent-type, organisation, and user filtering. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    Cursor?: string;
                    Limit?: number | string;
                    AgentType?: components["schemas"]["AgentType"];
                    OrganisationId?: string;
                    UserId?: string;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfAdminConversationResponse"];
                    };
                };
                /** @description Agent.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/agent/conversations/{conversationId}/messages": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List messages for an agent conversation (admin)
         * @description Paged message history for an agent conversation. Exposes tool-call and tool-result payloads plus token usage. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    Cursor?: string;
                    Limit?: number | string;
                };
                header?: never;
                path: {
                    conversationId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfAdminAgentMessageResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Conversation.NotFound — conversation does not exist */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/organisations/{organisationId}/agent/conversations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List agent conversations for an organisation (admin)
         * @description Lists all agent conversations for an organisation across all users, with optional agent-type and user filtering. Requires admin access.
         *
         *     **Authentication.** A Dolfin staff (admin) API key in the `x-dolfin-api-key` header.
         */
        get: {
            parameters: {
                query?: {
                    Cursor?: string;
                    Limit?: number | string;
                    AgentType?: components["schemas"]["AgentType"];
                    UserId?: string;
                };
                header?: never;
                path: {
                    organisationId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfAdminConversationResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/whatsapp/connection": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get WhatsApp connection
         * @description The Client's connected WhatsApp Business number, which sends bill approvals and enrolment codes to users, and invoices and reminders for every one of the Client's organisations: its status, display name, quality rating, messaging tier and the approval status of each message template. Also returns the settings the Facebook SDK needs to start Embedded Signup. Readable by any portal user of the Client; only Client admins may connect or disconnect.
         *
         *     **Authentication.** A JWT Bearer token for a client administrator (Admin or Owner). Dolfin staff may instead use an admin API key with the `x-dolfin-client-id` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["WhatsAppConnectionStateResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        /**
         * Connect WhatsApp number
         * @description Finish Meta's Embedded Signup for the Client's own WhatsApp Business number, which sends bill approvals and enrolment codes to users, and invoices and reminders for every one of the Client's organisations. Send the WABA id from the signup's FINISH message and the number verified in it. Dolfin registers the number for sending, which takes a few minutes (the connection is Connecting until then), then creates the message templates, which Meta reviews. Connecting again replaces the current number. Caller must be Admin/Owner of the Client.
         *
         *     **Authentication.** A JWT Bearer token for a client administrator (Admin or Owner). Dolfin staff may instead use an admin API key with the `x-dolfin-client-id` header.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["ConnectWhatsAppRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["WhatsAppConnectionResponse"];
                    };
                };
                /** @description WhatsApp.Invalid — the request is missing or has an invalid WhatsApp field */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Member.Forbidden — caller is not an Admin or Owner of this Client
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description WhatsApp.NumberInUse — the WhatsApp number is already connected to another Client or organisation */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description WhatsApp.ConnectFailed — WhatsApp (through Twilio) refused to register the number; the detail carries the reason */
                502: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Service Unavailable
                 *
                 *     WhatsApp.NotConfigured — WhatsApp is not configured in this environment
                 */
                503: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        /**
         * Disconnect WhatsApp number
         * @description Stop sending from the Client's WhatsApp number. Bill approvals, invoices and reminders go by email from then on. The number stays registered on the Client's own WhatsApp Business account, and can be connected again. Caller must be Admin/Owner of the Client.
         *
         *     **Authentication.** A JWT Bearer token for a client administrator (Admin or Owner). Dolfin staff may instead use an admin API key with the `x-dolfin-client-id` header.
         */
        delete: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["WhatsAppConnectionResponse"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Member.Forbidden — caller is not an Admin or Owner of this Client
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description WhatsApp.NotConnected — no WhatsApp number is connected */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/whatsapp/connection/events": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /**
         * Choose WhatsApp events
         * @description Switch individual events on or off for the Client's WhatsApp number: the invoice send and each reminder stage, and bills awaiting approval. A switched-off event goes by email instead. Only supplied events change; all are on until switched off. Kept across a disconnect. Caller must be Admin/Owner of the Client.
         *
         *     **Authentication.** A JWT Bearer token for a client administrator (Admin or Owner). Dolfin staff may instead use an admin API key with the `x-dolfin-client-id` header.
         */
        patch: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["PatchWhatsAppEventsRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["WhatsAppConnectionResponse"];
                    };
                };
                /** @description WhatsApp.Invalid — the request is missing or has an invalid WhatsApp field */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Member.Forbidden — caller is not an Admin or Owner of this Client
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description WhatsApp.NotConnected — no WhatsApp number is connected */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        trace?: never;
    };
    "/v1/webhook-subscriptions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List webhook subscriptions
         * @description List the calling Client's webhook subscriptions. Signing secrets are never returned by this endpoint.
         *
         *     **Authentication.** A JWT Bearer token for a client administrator (Admin or Owner). Dolfin staff may instead use an admin API key with the `x-dolfin-client-id` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["WebhookSubscriptionResponse"][];
                    };
                };
            };
        };
        put?: never;
        /**
         * Create webhook subscription
         * @description Subscribe to webhook events for the calling Client. The signing secret is returned only once — store it securely.
         *
         *     **Authentication.** A JWT Bearer token for a client administrator (Admin or Owner). Dolfin staff may instead use an admin API key with the `x-dolfin-client-id` header.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["CreateWebhookSubscriptionRequest"];
                };
            };
            responses: {
                /** @description Created */
                201: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["WebhookSubscriptionWithSecretResponse"];
                    };
                };
                /**
                 * @description Webhook.InvalidUrl — when the supplied URL is not an absolute https URL
                 *
                 *     Webhook.NoEventTypes — when event_types is empty
                 *
                 *     Webhook.EventTypeUnknown — is not a known webhook event type
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Member.Forbidden — caller is not a Developer, Admin or Owner of this Client */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Webhook.SubscriptionLimitReached — when the Client already has the max number of subscriptions */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/webhook-subscriptions/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get webhook subscription
         * @description **Authentication.** A JWT Bearer token for a client administrator (Admin or Owner). Dolfin staff may instead use an admin API key with the `x-dolfin-client-id` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["WebhookSubscriptionResponse"];
                    };
                };
                /** @description Webhook.SubscriptionNotFound — when the subscription does not exist or does not belong to the calling Client */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        /**
         * Delete webhook subscription
         * @description **Authentication.** A JWT Bearer token for a client administrator (Admin or Owner). Dolfin staff may instead use an admin API key with the `x-dolfin-client-id` header.
         */
        delete: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description No Content */
                204: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Member.Forbidden — caller is not a Developer, Admin or Owner of this Client */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Webhook.SubscriptionNotFound — when the subscription does not exist or does not belong to the calling Client */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        /**
         * Update webhook subscription
         * @description Update url, event_types, or active flag. Reactivating a subscription resets consecutive_failures to zero.
         *
         *     **Authentication.** A JWT Bearer token for a client administrator (Admin or Owner). Dolfin staff may instead use an admin API key with the `x-dolfin-client-id` header.
         */
        patch: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["PatchWebhookSubscriptionRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["WebhookSubscriptionResponse"];
                    };
                };
                /**
                 * @description Webhook.InvalidUrl — when the supplied URL is not an absolute https URL
                 *
                 *     Webhook.NoEventTypes — when event_types is empty
                 *
                 *     Webhook.EventTypeUnknown — is not a known webhook event type
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Member.Forbidden — caller is not a Developer, Admin or Owner of this Client */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Webhook.SubscriptionNotFound — when the subscription does not exist or does not belong to the calling Client */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        trace?: never;
    };
    "/v1/webhook-subscriptions/{id}/deliveries": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List webhook deliveries
         * @description List recent deliveries for a subscription, newest first.
         *
         *     **Authentication.** A JWT Bearer token for a client administrator (Admin or Owner). Dolfin staff may instead use an admin API key with the `x-dolfin-client-id` header.
         */
        get: {
            parameters: {
                query?: {
                    limit?: number | string;
                };
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["WebhookDeliveryResponse"][];
                    };
                };
                /** @description Member.Forbidden — caller is not a Developer, Admin or Owner of this Client */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Webhook.SubscriptionNotFound — when the subscription does not exist or does not belong to the calling Client */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/webhook-subscriptions/{id}/deliveries/{deliveryId}/retry": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Retry a webhook delivery
         * @description Manually requeue a failed (or pending) delivery for immediate dispatch.
         *
         *     **Authentication.** A JWT Bearer token for a client administrator (Admin or Owner). Dolfin staff may instead use an admin API key with the `x-dolfin-client-id` header.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path: {
                    id: string;
                    deliveryId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["WebhookDeliveryResponse"];
                    };
                };
                /** @description Member.Forbidden — caller is not a Developer, Admin or Owner of this Client */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Webhook.DeliveryNotFound — when the delivery does not exist or does not belong to the calling Client */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Webhook.DeliveryNotRetryable — when the delivery is already in Delivered status */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/webhook-subscriptions/{id}/rotate-secret": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Rotate webhook signing secret
         * @description Generate a new signing secret for the subscription. The previous secret is invalidated immediately. The new secret is returned only once.
         *
         *     **Authentication.** A JWT Bearer token for a client administrator (Admin or Owner). Dolfin staff may instead use an admin API key with the `x-dolfin-client-id` header.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["WebhookSubscriptionWithSecretResponse"];
                    };
                };
                /** @description Member.Forbidden — caller is not a Developer, Admin or Owner of this Client */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Webhook.SubscriptionNotFound — when the subscription does not exist or does not belong to the calling Client */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/client/spend-categories": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List client spend categories
         * @description The calling client's own custom spend categories — excludes Dolfin system defaults, includes archived rows. These cascade to every organisation under the client.
         *
         *     **Authentication.** A JWT Bearer token for a client administrator (Admin or Owner). Dolfin staff may instead use an admin API key with the `x-dolfin-client-id` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["SpendCategoryResponse"][];
                    };
                };
            };
        };
        put?: never;
        /**
         * Create client spend category
         * @description Add a custom spend category for the calling client. Admin/Owner only. The key is normalised (trimmed, lower-cased, spaces → underscores) and may not shadow a Dolfin system default. Cascades to every organisation under the client.
         *
         *     **Authentication.** A JWT Bearer token for a client administrator (Admin or Owner). Dolfin staff may instead use an admin API key with the `x-dolfin-client-id` header.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["CreateSpendCategoryRequest"];
                };
            };
            responses: {
                /** @description Created */
                201: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["SpendCategoryResponse"];
                    };
                };
                /**
                 * @description SpendCategory.MissingKey — key is missing or blank after normalisation
                 *
                 *     SpendCategory.MissingDisplayName — display name is missing
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Member.Forbidden — caller is not an Admin or Owner of this Client */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description SpendCategory.ReservedKey — key collides with a Dolfin system default
                 *
                 *     SpendCategory.DuplicateKey — a category with this key already exists for the client
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/client/spend-categories/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /**
         * Update client spend category
         * @description Rename a category, set its default spend class or GL account code, or archive it. Admin/Owner only. The key is immutable; archiving removes it from the offered set while historical bills keep their stored key.
         *
         *     **Authentication.** A JWT Bearer token for a client administrator (Admin or Owner). Dolfin staff may instead use an admin API key with the `x-dolfin-client-id` header.
         */
        patch: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["PatchSpendCategoryRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["SpendCategoryResponse"];
                    };
                };
                /** @description Member.Forbidden — caller is not an Admin or Owner of this Client */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description SpendCategory.NotFound — no such category for this client */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        trace?: never;
    };
    "/v1/settings/ap": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get AP settings
         * @description Retrieve the Client's accounts-payable settings. Readable by any signed-in portal user with client OR organisation context (org-scoped callers resolve their owning client); not available to API keys. Only Client admins may change the values via PATCH.
         *
         *     **Authentication.** A JWT Bearer token. API keys are not accepted.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ApSettingsResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /**
         * Patch AP settings
         * @description Partially update the Client's accounts-payable settings. Covers the three-way-matching knobs (rounding tolerance, fuzzy line/supplier thresholds, the supplier name/address weighting, the date-proximity window, the header- and line-affinity weights, the per-route purchase-order and delivery-note auto-match switches, and the fuzzy auto-accept controls) plus the client-level AP config: the AP notification-email kill switch, pay-by-bank opt-in, the bill payment link mode and bring-your-own link template, the bill-approval link TTL, and the Gmail/pay-by-bank redirect-host allowlists. Applies to every organisation under the client. Only supplied fields change; a settings row is created on first write. Caller must be Admin/Owner of the Client.
         *
         *     **Authentication.** A JWT Bearer token for a client administrator (Admin or Owner). Dolfin staff may instead use an admin API key with the `x-dolfin-client-id` header.
         */
        patch: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["PatchApSettingsRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ApSettingsResponse"];
                    };
                };
                /** @description ApSettings.Invalid — an AP settings value is out of its allowed range */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Member.Forbidden — caller is not an Admin or Owner of this Client
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description ApSettings.PaymentLinkModeNotAllowed — Dolfin payment links need pay-by-bank enabled and the ap.payments module */
                422: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        trace?: never;
    };
    "/v1/settings/ar": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get AR settings
         * @description Retrieve the Client's accounts-receivable settings (applied to every organisation under the client) — currently the AR-email kill switch. Readable by any signed-in portal user with client OR organisation context (org-scoped callers resolve their owning client); not available to API keys. Only Client admins may change the values via PATCH.
         *
         *     **Authentication.** A JWT Bearer token. API keys are not accepted.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ArSettingsResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /**
         * Patch AR settings
         * @description Partially update the Client's accounts-receivable settings — AR emails, the payment-link mode and format, the WhatsApp tone on the client's own link, and which optional fields the invoice PDF shows. Applies to every organisation under the client. Only supplied fields change; a settings row is created on first write. Caller must be Admin/Owner of the Client.
         *
         *     **Authentication.** A JWT Bearer token for a client administrator (Admin or Owner). Dolfin staff may instead use an admin API key with the `x-dolfin-client-id` header.
         */
        patch: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["PatchArSettingsRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ArSettingsResponse"];
                    };
                };
                /** @description ArSettings.Invalid — an AR settings value is out of its allowed range */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Member.Forbidden — caller is not an Admin or Owner of this Client
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        trace?: never;
    };
    "/v1/settings/ar/pdf-preview": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Preview invoice PDF display options
         * @description Renders a sample invoice PDF with fixed placeholder data in the chosen layout and display options, without saving anything. Options left out fall back to the client's saved settings, and the layout defaults to Classic. Readable by any signed-in portal user with client or organisation context.
         *
         *     **Authentication.** A JWT Bearer token. API keys are not accepted.
         */
        post: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["PreviewArSettingsInvoicePdfRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description OrganisationArSettings.Invalid — an organisation AR settings value is out of its allowed range */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/organisations/search": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Search organisations
         * @description Fuzzy-search the calling client's organisations by id, name, contact email, tax number, or company registration number. Uses PostgreSQL trigram similarity; results are ordered by descending match score.
         *
         *     **Authentication.** A JWT Bearer token for a client administrator (Admin or Owner). Dolfin staff may instead use an admin API key with the `x-dolfin-client-id` header.
         */
        get: {
            parameters: {
                query: {
                    q: string;
                    limit?: number | string;
                };
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["OrganisationSearchHit"][];
                    };
                };
                /** @description Organisation.SearchQueryRequired — a non-empty search query is required */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/client/members": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Client members
         * @description List portal members of the calling Client.
         *
         *     **Authentication.** A JWT Bearer token for a client administrator (Admin or Owner). Dolfin staff may instead use an admin API key with the `x-dolfin-client-id` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["MemberResponse"][];
                    };
                };
                /** @description Client.Forbidden — caller is not a member of the specified Client */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/client/members/{userId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * Remove Client member
         * @description Remove a member's UserClient row. Admin/Owner only, except a member may remove themselves.
         *
         *     **Authentication.** A JWT Bearer token for a client administrator (Admin or Owner). Dolfin staff may instead use an admin API key with the `x-dolfin-client-id` header.
         */
        delete: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path: {
                    userId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description No Content */
                204: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /**
                 * @description Member.Forbidden — caller is not an Admin or Owner of this Client
                 *
                 *     Member.RoleAboveCaller — cannot assign or modify a role higher than your own
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Member.NotFound — user is not a member of this Client */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Member.CannotRemoveSoleOwner — cannot remove the only Owner */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        /**
         * Update Client member role
         * @description Change a member's ClientRole. Admin/Owner only. Cannot demote the only Owner.
         *
         *     **Authentication.** A JWT Bearer token for a client administrator (Admin or Owner). Dolfin staff may instead use an admin API key with the `x-dolfin-client-id` header.
         */
        patch: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path: {
                    userId: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["UpdateMemberRoleRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["MemberResponse"];
                    };
                };
                /**
                 * @description Member.Forbidden — caller is not an Admin or Owner of this Client
                 *
                 *     Member.RoleAboveCaller — cannot assign or modify a role higher than your own
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Member.NotFound — user is not a member of this Client */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Member.CannotDemoteSoleOwner — cannot change the only Owner's role */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        trace?: never;
    };
    "/v1/settings/expenses": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get expense settings
         * @description Retrieve the Client's expense settings: whether coded expenses wait for review before posting, whether they are pushed as drafts, the thresholds the receipt matcher uses, and how far back transactions are pulled when a card is first connected. Applies to every organisation under the Client. Readable by any signed-in portal user with client OR organisation context (org-scoped callers resolve their owning client); not available to API keys. Only Client admins may change the values via PATCH.
         *
         *     **Authentication.** A JWT Bearer token. API keys are not accepted.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ClientExpenseSettingsResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /**
         * Patch expense settings
         * @description Partially update the Client's expense settings. Covers the review-before-post gate, whether expenses are pushed as drafts, the receipt-matching thresholds (score, ambiguity margin, amount tolerances and date window) and the card backfill window. Applies to every organisation under the Client. Only supplied fields change; a settings row is created on first write. A value outside its allowed range is rejected rather than clamped. Caller must be Admin/Owner of the Client.
         *
         *     **Authentication.** A JWT Bearer token for a client administrator (Admin or Owner). Dolfin staff may instead use an admin API key with the `x-dolfin-client-id` header.
         */
        patch: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["PatchClientExpenseSettingsRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ClientExpenseSettingsResponse"];
                    };
                };
                /** @description ClientExpenseSettings.Invalid — an expense settings value is out of its allowed range */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Member.Forbidden — caller is not an Admin or Owner of this Client
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        trace?: never;
    };
    "/v1/demo/seed": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Start the demo
         * @description Seeds the demo organisation as its made-up business: connects the demo accounting platform, bank and Stripe, adds 12 months of activity and builds the books. Returns at once; poll the demo status for progress. A no-op while it is already seeding. The body's preset is required when the demo has none yet (status shows preset null). Only for a demo organisation.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: {
                content: {
                    "application/json": null | components["schemas"]["SeedDemoRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["DemoStatusResponse"];
                    };
                };
                /** @description Demo.PresetRequired — the demo has no preset yet; name one of Cafe, Agency, Ecommerce or Wholesale */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Organisation.InsufficientRole — caller's organisation role is below the level this action requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Demo.NotFound — organisation does not exist, is not a demo, or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Demo.AlreadySeeded — the demo has already been seeded; reset it to start again */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/demo/status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get the demo's status
         * @description Where the demo organisation's seeding stands, step by step, plus why it failed and when the demo expires. Only for a demo organisation.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["DemoStatusResponse"];
                    };
                };
                /** @description Demo.NotFound — organisation does not exist, is not a demo, or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/demo/reset": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Reset the demo
         * @description Removes every change made in the demo and seeds the same business again, dated to today. Users, memberships and sign-in are kept. Refused while it is seeding. Only for a demo organisation.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["DemoStatusResponse"];
                    };
                };
                /** @description Organisation.InsufficientRole — caller's organisation role is below the level this action requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Demo.NotFound — organisation does not exist, is not a demo, or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Demo.PurgeBlocked — a row still references the demo's data, so nothing was removed
                 *
                 *     Demo.SeedingInProgress — the demo is being seeded; try again once it is ready or has failed
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/client/stats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get client stats
         * @description Aggregated counts (organisations, users, invoices, bills, expenses, receipts, …) across every Organisation owned by the calling Client. Cached server-side; values can lag real state by up to an hour.
         *
         *     **Authentication.** A JWT Bearer token for a client administrator (Admin or Owner). Dolfin staff may instead use an admin API key with the `x-dolfin-client-id` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ClientStatsResponse"];
                    };
                };
                /** @description Client.Forbidden — caller is not a member of the specified Client */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/client": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /**
         * Patch client settings
         * @description Update the calling Client's branding (LogoUrl, PrimaryColour). Client-level AP config (bill-approval TTL, Gmail connector, pay-by-bank) is managed via PATCH /settings/ap; the AR-email kill switch via PATCH /settings/ar. Caller must be Admin/Owner of the Client.
         *
         *     **Authentication.** A JWT Bearer token for a client administrator (Admin or Owner). Dolfin staff may instead use an admin API key with the `x-dolfin-client-id` header.
         */
        patch: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["PatchClientRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ClientResponse"];
                    };
                };
                /** @description Client.InvalidColour — PrimaryColour must be a valid hex colour (e.g. #2DD4BF) */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Member.Forbidden — caller is not an Admin or Owner of this Client */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Client.NotFound — the client does not exist or is not visible to the caller */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        trace?: never;
    };
    "/v1/client/invites": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Client invites
         * @description List un-accepted invites for the calling Client. Includes expired invites (Status=Expired) so they can be resent or revoked from the UI.
         *
         *     **Authentication.** A JWT Bearer token for a client administrator (Admin or Owner). Dolfin staff may instead use an admin API key with the `x-dolfin-client-id` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ClientInviteResponse"][];
                    };
                };
            };
        };
        put?: never;
        /**
         * Create Client invite
         * @description Generate a portal-membership invite for the given email and role. Returns the raw token once — store the link immediately.
         *
         *     **Authentication.** A JWT Bearer token for a client administrator (Admin or Owner). Dolfin staff may instead use an admin API key with the `x-dolfin-client-id` header.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["CreateClientInviteRequest"];
                };
            };
            responses: {
                /** @description Created */
                201: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ClientInviteWithTokenResponse"];
                    };
                };
                /** @description ClientInvite.InvalidEmail — email is missing or malformed */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Member.Forbidden — caller is not an Admin or Owner of this Client
                 *
                 *     ClientInvite.RoleAboveCaller — cannot invite a member at a role higher than your own
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description ClientInvite.AlreadyMember — a user with this email is already a member
                 *
                 *     ClientInvite.AlreadyInvited — an outstanding invite already exists for this email
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/client/invites/{inviteId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * Revoke Client invite
         * @description Delete a pending invite. Admin/Owner only.
         *
         *     **Authentication.** A JWT Bearer token for a client administrator (Admin or Owner). Dolfin staff may instead use an admin API key with the `x-dolfin-client-id` header.
         */
        delete: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path: {
                    inviteId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description No Content */
                204: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Member.Forbidden — caller is not an Admin or Owner of this Client */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description ClientInvite.NotFound — invite does not exist or does not belong to this Client */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/books/current/bank-lines": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List bank lines
         * @description Booked bank transactions in the current book, newest first, with how each is resolved. Filter by status (Uncategorised is the review queue), bank account, the ledger account a line sits in, or booked date (from/to, inclusive).
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    /** @description Only lines in this status, e.g. Uncategorised for the review queue. */
                    Status?: components["schemas"]["BookBankLineStatus"];
                    /** @description Only lines on this connected bank account. */
                    BankAccountId?: string;
                    /** @description Only lines sitting in this ledger account, as postedLedgerAccountId reports it. */
                    LedgerAccountId?: string;
                    /** @description Only lines booked on or after this day (YYYY-MM-DD). */
                    From?: string;
                    /** @description Only lines booked on or before this day (YYYY-MM-DD). */
                    To?: string;
                    /** @description Opaque pagination cursor from a previous page. */
                    Cursor?: string;
                    /** @description Page size, 1 to 100. Defaults to 20. */
                    Limit?: number | string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfBankLineResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Books.NotFound — book does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/books/current/bank-lines/summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Count bank lines by status
         * @description For every tracked bank account in the current book, with its name, how many bank lines are in each status (uncategorised, possible duplicate, matched, categorised, ignored, and how many were matched or categorised automatically), optionally only lines booked from/to (inclusive). Accounts with no lines are listed with zeros.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    /** @description Only lines booked on or after this day (YYYY-MM-DD). */
                    From?: string;
                    /** @description Only lines booked on or before this day (YYYY-MM-DD). */
                    To?: string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BankLineSummaryResponse"][];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Books.NotFound — book does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/books/current/bank-lines/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get a bank line
         * @description One booked bank transaction in the current book and how it is resolved, as in the list. A closed book's lines can still be read.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the bank line. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BankLineResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Books.NotFound — book does not exist or belongs to a different organisation
                 *
                 *     Books.BankLineNotFound — bank line does not exist in the organisation's current book
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/books/current/bank-lines/{id}/candidates": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List match candidates for a bank line
         * @description Dolfin payments (invoice payments, bill payments, Stripe payouts) already in the books on the line's bank account for the same amount and direction, within a month, not matched to another line. Nearest date first.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the bank line. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BankLineCandidateResponse"][];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Books.NotFound — book does not exist or belongs to a different organisation
                 *
                 *     Books.BankLineNotFound — bank line does not exist in the organisation's current book
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/books/current/bank-lines/{id}/match": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Match a bank line to a payment
         * @description Matches the line to one of its candidates. The payment already posted to the bank, so nothing new posts: the line's Uncategorised entry is reversed, and a categorisation is undone first.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the bank line. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["MatchBankLineRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BankLineResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Books.NotFound — book does not exist or belongs to a different organisation
                 *
                 *     Books.BankLineNotFound — bank line does not exist in the organisation's current book
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Books.NotActive — the book is not active: it is still in setup, or closed
                 *
                 *     Books.BankLineInvalidState — the bank line's status does not allow this action
                 *
                 *     Books.MatchCandidateNotFound — the payment is not a match candidate for this bank line
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/books/current/bank-lines/{id}/categorise": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Categorise a bank line
         * @description Reclassifies an Uncategorised or Categorised line to a ledger account: posts an entry moving the gross out of Uncategorised, with the VAT in the given tax rate split to the book's VAT account. Re-categorising reverses the previous categorisation first.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the bank line. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["CategoriseBankLineRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BankLineResponse"];
                    };
                };
                /**
                 * @description Books.InvalidCategorisation — the bank line cannot be categorised to that account or tax rate
                 *
                 *     Books.UnknownLedgerAccount — a line names a ledger account or tax rate outside the organisation's chart
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Books.NotFound — book does not exist or belongs to a different organisation
                 *
                 *     Books.BankLineNotFound — bank line does not exist in the organisation's current book
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Books.NotActive — the book is not active: it is still in setup, or closed
                 *
                 *     Books.BankLineInvalidState — the bank line's status does not allow this action
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/books/current/bank-lines/{id}/reset": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Undo a bank line's resolution
         * @description Puts a Matched or Categorised line back in Uncategorised (reversing the categorisation, or posting the Uncategorised entry again for a match), or an ignored duplicate back to PossibleDuplicate.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the bank line. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BankLineResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Books.NotFound — book does not exist or belongs to a different organisation
                 *
                 *     Books.BankLineNotFound — bank line does not exist in the organisation's current book
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Books.NotActive — the book is not active: it is still in setup, or closed
                 *
                 *     Books.BankLineInvalidState — the bank line's status does not allow this action
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/books/current/bank-lines/{id}/confirm-duplicate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Resolve a possible duplicate bank line
         * @description For a PossibleDuplicate line: a duplicate is ignored and stays out of the books; otherwise the line is matched to a payment when exactly one fits, or posted to Uncategorised.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the bank line. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["ConfirmBankLineDuplicateRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BankLineResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Books.NotFound — book does not exist or belongs to a different organisation
                 *
                 *     Books.BankLineNotFound — bank line does not exist in the organisation's current book
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Books.NotActive — the book is not active: it is still in setup, or closed
                 *
                 *     Books.BankLineInvalidState — the bank line's status does not allow this action
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/books/current/bank-lines/groups": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List groups of uncategorised bank lines
         * @description Uncategorised bank lines in the current book grouped by payee (counterparty, else description) and direction, two or more lines to a group, largest total first, with the account most of them are suggested to. One decision can then categorise a whole group.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BankLineGroupResponse"][];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Books.NotFound — book does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/books/current/bank-lines/groups/categorise": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Categorise a group of bank lines
         * @description Categorises every Uncategorised line in the group to the account, all or none, as categorising each line would post. With createRule, also saves a rule matching the group's payee and direction, which then applies to Uncategorised lines already in the book and to new ones.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["CategoriseBankLineGroupRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CategoriseBankLineGroupResponse"];
                    };
                };
                /**
                 * @description Books.InvalidCategorisation — the bank line cannot be categorised to that account or tax rate
                 *
                 *     Books.UnknownLedgerAccount — a line names a ledger account or tax rate outside the organisation's chart
                 *
                 *     Books.InvalidRule — the rule needs a name, a value to match, an amount range whose minimum is not above its maximum, and an account and tax rate from the organisation's chart
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Books.NotFound — book does not exist or belongs to a different organisation
                 *
                 *     Books.BankLineGroupNotFound — no Uncategorised bank lines in the current book belong to that group
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Books.NotActive — the book is not active: it is still in setup, or closed
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/books/current/bank-lines/{id}/accept-suggestion": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Accept a bank line's suggestion
         * @description Categorises an Uncategorised line to its suggested account and tax rate, exactly as categorising it by hand would post.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the bank line. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BankLineResponse"];
                    };
                };
                /**
                 * @description Books.InvalidCategorisation — the bank line cannot be categorised to that account or tax rate
                 *
                 *     Books.UnknownLedgerAccount — a line names a ledger account or tax rate outside the organisation's chart
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Books.NotFound — book does not exist or belongs to a different organisation
                 *
                 *     Books.BankLineNotFound — bank line does not exist in the organisation's current book
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Books.NotActive — the book is not active: it is still in setup, or closed
                 *
                 *     Books.BankLineInvalidState — the bank line's status does not allow this action
                 *
                 *     Books.NoSuggestion — the bank line has no suggested account to accept
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/books/current": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get the current book
         * @description Returns the organisation's open set of books (in setup or active), or the most recently closed one when none is open: its status, start date, close date, reporting basis, control accounts, bank-account mapping, setup checklist (what is still missing) and posting progress (how many documents are posted, waiting, skipped or failed).
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BookResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Books.NotFound — book does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /**
         * Update the current book
         * @description Sets control accounts and the bank-account mapping while the book is in setup, or the close date once it is active, and the default reporting basis at any time. Control accounts and mapping lock when the book is activated. The Stripe clearing and fees accounts must be the ones in the receivables settings; when those have none, choosing them here sets them there too.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        patch: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["UpdateBookRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BookResponse"];
                    };
                };
                /**
                 * @description Books.InvalidSettings — a setting names an account outside the chart, a bank account that does not fit, or a close date out of range
                 *
                 *     ArAccounting.LedgerAccountNotFound — when a referenced ledger account is not an active account in the organisation's synced chart of accounts
                 *
                 *     ArAccounting.StripeClearingAccountInvalid — when the Stripe clearing account is not a current asset (Xero) or a current asset or bank account (QuickBooks), or is the deposit account itself
                 *
                 *     ArAccounting.StripeClearingPaymentsDisabled — when the Xero account chosen for Stripe clearing does not have "Enable payments to this account" switched on, so Xero would refuse invoice payments into it
                 *
                 *     ArAccounting.StripeFeesAccountNotExpense — when the Stripe fees account is not an expense account
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Books.NotFound — book does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Books.NotActive — the book is not active: it is still in setup, or closed
                 *
                 *     Books.ControlAccountsLocked — control accounts and bank mapping are locked once the book is active; close it and start a new one to change them
                 *
                 *     ArAccounting.NotConnected — when the organisation has no callable accounting connection
                 *
                 *     ArAccounting.StripeClearingHasUnsettledPayments — when the Stripe clearing account would change, or be removed, while recent Stripe payments already recorded in the accounting platform are still waiting for their payout: Stripe has not paid them out yet, or their payout has not reached the accounting platform
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description ArAccounting.StripeUnavailable — when Stripe could not be asked which card payments it has already paid out, so a Stripe clearing change cannot be checked
                 *
                 *     ArAccounting.PlatformUnavailable — when the accounting platform could not be reached to check the chosen account
                 */
                502: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        trace?: never;
    };
    "/v1/books/start-dates": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get valid book start dates
         * @description The range a new book's start date can take: every first of a month from earliest to latest. Earliest comes from the connected bank accounts' fetched transaction history; latest is the current month.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BookStartDatesResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/books": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Start books
         * @description Starts a set of books on the connected accounting platform's chart, from a start date. The control accounts are pre-filled from the chart for confirmation; the platform's trial balance at the day before the start date becomes the opening balances.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["StartBookRequest"];
                };
            };
            responses: {
                /** @description Created */
                201: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BookResponse"];
                    };
                };
                /** @description Books.InvalidStartDate — the start date must be the first day of a month, not in the future, and inside every tracked bank account's fetched history */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Books.AlreadyExists — the organisation already has an open book; close it before starting another
                 *
                 *     Books.AccountingNotConnected — books need a working accounting connection with a company
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/books/current/opening-balances": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Import opening balances
         * @description Reads the accounting platform's trial balance at the opening-balance date and posts it as the opening entry. Rows without an account go to the opening-balance difference account. A platform with no balances at that date (a new business) is imported with no entry. Only possible while the book is in setup: importing again after the platform's figures changed reverses the previous opening entry and posts a new revision; an unchanged trial balance posts nothing.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["OpeningBalancesResponse"];
                    };
                };
                /**
                 * @description Books.InvalidSettings — a setting names an account outside the chart, a bank account that does not fit, or a close date out of range
                 *
                 *     Books.UnknownLedgerAccount — a line names a ledger account or tax rate outside the organisation's chart
                 *
                 *     Books.EntryUnbalanced — the entry's debits do not equal its credits
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Books.NotFound — book does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Books.NotActive — the book is not active: it is still in setup, or closed
                 *
                 *     Books.NotInSetup — the book is no longer in setup
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Books.PlatformReportFailed — the accounting platform did not return the report */
                502: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/books/current/activate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Activate the current book
         * @description Activates a book whose setup checklist is complete, then posts every document dated on or after the start date in the background. From then on invoices, bills, expenses and bank lines post as they happen.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BookResponse"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Books.NotFound — book does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Books.NotInSetup — the book is no longer in setup
                 *
                 *     Books.SetupIncomplete — the setup checklist is not complete
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/books/current/close": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Close the current book
         * @description Closes the open book. A closed book is read-only and takes no more postings; a new book can then be started.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BookResponse"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Books.NotFound — book does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/books/current/trial-balance": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get the trial balance
         * @description Trial balance of the books at a date: each account's debit or credit balance, on accrual or cash basis (the book's reporting basis unless basis is given). With compare=platform (accrual only) it adds the connected accounting platform's balance and the difference per account, to find where the books and the platform disagree.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    /** @description Report date, YYYY-MM-DD: balances at the end of that day. Defaults to today. */
                    Date?: string;
                    /** @description 'platform' adds the connected accounting platform's figures and the difference per account. Accrual basis only: ignored on cash basis. */
                    Compare?: string;
                    /** @description Accrual (income and costs when invoiced and billed) or Cash (when paid, pro rata to each payment). Defaults to the book's reporting basis. */
                    Basis?: components["schemas"]["ReportingBasis"];
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["TrialBalanceResponse"];
                    };
                };
                /** @description Books.InvalidPeriod — the report date or period is out of range, or compare is not 'platform' */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Books.NotFound — book does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Books.PlatformReportFailed — the accounting platform did not return the report */
                502: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/books/current/profit-and-loss": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get the profit and loss
         * @description Profit and loss for a period: revenue and expense accounts, each row in a section (revenue, cost of sales, operating expenses, other income, other expenses), with gross profit and net profit. Accrual basis counts invoices and bills on their dates; cash basis counts them when paid, pro rata to each payment. Defaults to the book's reporting basis. compare=platform (accrual only) adds the connected accounting platform's figures.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query: {
                    /** @description First day of the period, YYYY-MM-DD. On or after the book's start date, or the first day of the financial year the books open in (which includes the year-to-date opening balances). */
                    From: string;
                    /** @description Last day of the period, YYYY-MM-DD. */
                    To: string;
                    /** @description 'platform' adds the connected accounting platform's figures and the difference per account. Accrual basis only: ignored on cash basis. */
                    Compare?: string;
                    /** @description Accrual (income and costs when invoiced and billed) or Cash (when paid, pro rata to each payment). Defaults to the book's reporting basis. */
                    Basis?: components["schemas"]["ReportingBasis"];
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ProfitAndLossResponse"];
                    };
                };
                /** @description Books.InvalidPeriod — the report date or period is out of range, or compare is not 'platform' */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Books.NotFound — book does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Books.PlatformReportFailed — the accounting platform did not return the report */
                502: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/books/current/balance-sheet": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get the balance sheet
         * @description Balance sheet at a date: assets, liabilities and equity (including the current year's earnings), each row in a current, non-current or equity section, working capital, and whether it balances, on accrual or cash basis (the book's reporting basis unless basis is given). compare=platform (accrual only) adds the connected accounting platform's figures.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    /** @description Report date, YYYY-MM-DD. Defaults to today. */
                    Date?: string;
                    /** @description 'platform' adds the connected accounting platform's figures and the difference per account. Accrual basis only: ignored on cash basis. */
                    Compare?: string;
                    /** @description Accrual (income and costs when invoiced and billed) or Cash (when paid, pro rata to each payment). Defaults to the book's reporting basis. */
                    Basis?: components["schemas"]["ReportingBasis"];
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BalanceSheetResponse"];
                    };
                };
                /** @description Books.InvalidPeriod — the report date or period is out of range, or compare is not 'platform' */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Books.NotFound — book does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Books.PlatformReportFailed — the accounting platform did not return the report */
                502: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/books/current/monthly-summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get income and expenses by month
         * @description Per calendar month from the book's start (or from) to this month (or to): income, expenses, net, revenue, cost of sales, gross profit, operating expenses and the number of journal entries, in one call. Each month's net and gross profit equal the profit and loss report's for that month, so use it for month-on-month trends and margins. Every month is listed, with zeros where nothing posted.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    /** @description First month, as any day in it (YYYY-MM-DD). Defaults to the book's start date; months before the start are left out, because the books hold only the year-to-date opening balances there. */
                    From?: string;
                    /** @description Last month, as any day in it (YYYY-MM-DD). Defaults to today. */
                    To?: string;
                    /** @description Accrual (income and costs when invoiced and billed) or Cash (when paid, pro rata to each payment). Defaults to the book's reporting basis. */
                    Basis?: components["schemas"]["ReportingBasis"];
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["MonthlySummaryResponse"];
                    };
                };
                /** @description Books.InvalidPeriod — the report date or period is out of range, or compare is not 'platform' */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Books.NotFound — book does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/books/current/vat-summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get the VAT summary
         * @description Estimated VAT for a period (a VAT quarter) from the books: VAT on sales, VAT on purchases, net VAT owed or due back, and net sales and purchases (the UK return's boxes 1, 4, 5, 6 and 7), with a row per tax rate. Read from the VAT account's lines, by entry date on accrual basis, or when paid on cash basis (the book's reporting basis unless basis is given). An estimate, not a filed return: the response lists what it leaves out, and the accountant files.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query: {
                    /** @description First day of the period, YYYY-MM-DD (usually the VAT quarter's first day). On or after the book's start date. */
                    From: string;
                    /** @description Last day of the period, YYYY-MM-DD. */
                    To: string;
                    /** @description Accrual (VAT on invoices and bills by their dates) or Cash (VAT counted when paid, pro rata to each payment, as for the cash accounting scheme). Defaults to the book's reporting basis. */
                    Basis?: components["schemas"]["ReportingBasis"];
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["VatSummaryResponse"];
                    };
                };
                /** @description Books.InvalidPeriod — the report date or period is out of range, or compare is not 'platform' */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Books.NotFound — book does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/books/current/cash-flow": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get the cash flow analysis
         * @description Per calendar month in the period and per bank account in the books: opening and closing balance, money in, money out and net, with the net split by what each movement was for (customer receipts, supplier payments, income, expenses, tax, transfers, uncategorised, financing, assets, card payouts or other), read from the other side of its journal entry, and for a categorised bank line from the accounts it was categorised to. Month totals across the accounts too. Closing balances equal the trial balance's on the same basis. A period starting before the book's start date starts on it.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query: {
                    /** @description First day of the period, YYYY-MM-DD. A day before the book's start date is moved to the start date. */
                    From: string;
                    /** @description Last day of the period, YYYY-MM-DD. The last month ends on it. */
                    To: string;
                    /** @description Accrual (income and costs when invoiced and billed) or Cash (when paid, pro rata to each payment). Defaults to the book's reporting basis. On cash basis a customer's or supplier's payment shows as the income, expenses and VAT it settled. */
                    Basis?: components["schemas"]["ReportingBasis"];
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CashFlowResponse"];
                    };
                };
                /** @description Books.InvalidPeriod — the report date or period is out of range, or compare is not 'platform' */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Books.NotFound — book does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/books/current/journal-entries": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List journal entries
         * @description The general ledger: journal entries in the books, newest accounting date first, with their lines. Filter by ledger account, date range or source document type. On cash basis each payment shows the income, expenses and VAT it released from its invoice or bill. Filtered to one ledger account and no source type, it also gives the account's opening and closing balance for the range and its balance after each entry.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    /** @description Opaque pagination cursor. Pass back `next` or `previous` from a previous page's cursors. */
                    Cursor?: string;
                    /** @description Page size, 1 to 100. Defaults to 20. */
                    Limit?: number | string;
                    /** @description Only entries with a line on this ledger account. */
                    AccountId?: string;
                    /** @description Only entries dated on or after this day, YYYY-MM-DD. */
                    From?: string;
                    /** @description Only entries dated on or before this day, YYYY-MM-DD. */
                    To?: string;
                    /** @description Only entries from this kind of source document. */
                    SourceType?: components["schemas"]["JournalSourceType"];
                    /** @description Only entries of this source document (its id: the invoice, bill, expense, bank transaction...). */
                    SourceId?: string;
                    /** @description Cash lists each entry as it counts on cash basis: a payment carries the income, expenses and VAT it released from its document (pro rata), and invoices and bills, which release nothing until paid, are left out. Accrual lists the entries as posted. Defaults to the book's reporting basis. */
                    Basis?: components["schemas"]["ReportingBasis"];
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["JournalEntryPage"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Books.NotFound — book does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/books/current/journal-entries/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get a journal entry
         * @description One journal entry with its lines, the source document it came from, and every other entry of that source (reversals and re-posts).
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the journal entry. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["JournalEntryDetailResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Books.NotFound — book does not exist or belongs to a different organisation
                 *
                 *     Books.EntryNotFound — journal entry does not exist or belongs to a different book
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/books/current/postings": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List postings
         * @description Whether each source document (invoice, bill, expense, bank line, payment) is in the books: waiting, posted, skipped or failed, with the reason. The posting issues are status=Failed (can be retried once the cause is fixed) and status=Skipped (left out of the books, for example a currency other than the books'); each reason says why.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    /** @description Opaque pagination cursor. Pass back `next` or `previous` from a previous page's cursors. */
                    Cursor?: string;
                    /** @description Page size, 1 to 100. Defaults to 20. */
                    Limit?: number | string;
                    /** @description Only postings in this status. */
                    Status?: components["schemas"]["PostingStatus"];
                    /** @description Only postings of this kind of source document. */
                    SourceType?: components["schemas"]["JournalSourceType"];
                    /** @description Only the posting of this source document (its id). */
                    SourceId?: string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfPostingResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Books.NotFound — book does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/books/current/postings/{id}/retry": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Retry a posting
         * @description Queues a waiting, skipped or failed document for posting again, after its cause has been fixed.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the posting. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PostingResponse"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Books.NotFound — book does not exist or belongs to a different organisation
                 *
                 *     Books.PostingNotFound — posting does not exist or belongs to a different organisation
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Books.PostingNotRetryable — the posting is already posted, so there is nothing to retry */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/books/guides": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Books guides
         * @description The Books guides: short how-tos for bookkeeping tasks such as closing a month, preparing a VAT quarter or checking whether a dividend can be paid. Each has a topic, a title and a one-line summary.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BookGuideSummary"][];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/books/guides/{topic}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get a Books guide
         * @description One Books guide with its content in Markdown: the steps, checks and caveats for a bookkeeping task.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description The guide's topic, e.g. month-end-close. */
                    topic: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BookGuideResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Books.GuideNotFound — there is no Books guide on that topic */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/books/current/rules": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List categorisation rules
         * @description The current book's categorisation rules in the order they are tried, with how many bank lines each has categorised.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BookRuleResponse"][];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Books.NotFound — book does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        /**
         * Create a categorisation rule
         * @description Creates a rule on the current book: bank lines whose description or counterparty contains (or equals) the value, optionally only one direction and amount range, are categorised to the account automatically. Runs over the book's Uncategorised lines straight away, then on every new line.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["CreateBookRuleRequest"];
                };
            };
            responses: {
                /** @description Created */
                201: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BookRuleResponse"];
                    };
                };
                /** @description Books.InvalidRule — the rule needs a name, a value to match, an amount range whose minimum is not above its maximum, and an account and tax rate from the organisation's chart */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Books.NotFound — book does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Conflict — another change to the same record landed first; retry the request */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/books/current/rules/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * Delete a categorisation rule
         * @description Deletes the rule. Lines it already categorised stay categorised.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        delete: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the rule. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description No Content */
                204: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Books.NotFound — book does not exist or belongs to a different organisation
                 *
                 *     Books.RuleNotFound — categorisation rule does not exist in the organisation's current book
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        /**
         * Update a categorisation rule
         * @description Changes the fields given, including turning the rule off or on. An enabled rule runs over the book's Uncategorised lines again; lines it already categorised are left as they are.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        patch: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the rule. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["UpdateBookRuleRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BookRuleResponse"];
                    };
                };
                /** @description Books.InvalidRule — the rule needs a name, a value to match, an amount range whose minimum is not above its maximum, and an account and tax rate from the organisation's chart */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Books.NotFound — book does not exist or belongs to a different organisation
                 *
                 *     Books.RuleNotFound — categorisation rule does not exist in the organisation's current book
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Conflict — another change to the same record landed first; retry the request */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        trace?: never;
    };
    "/v1/auth/login": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Login
         * @description Authenticate an existing user by verifying an OAuth access token and returning a session. The access token is short-lived; an HttpOnly refresh cookie is set alongside it for POST /auth/refresh.
         *
         *     **Authentication.** None — this endpoint is public (e.g. a webhook or tokened link).
         */
        post: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["LoginRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["AuthResponse"];
                    };
                };
                /** @description Auth.UnsupportedProvider — OAuth provider is not supported; use 'google' or 'microsoft' */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Auth.InvalidOAuthToken — the OAuth access token is invalid or expired
                 *
                 *     Auth.InvalidCredentials — user account associated with the auth code no longer exists
                 */
                401: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/auth/logout": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Sign out
         * @description Revoke the session behind the HttpOnly refresh cookie and clear it. Always succeeds.
         *
         *     **Authentication.** None — this endpoint is public (e.g. a webhook or tokened link).
         */
        post: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description No Content */
                204: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/auth/refresh": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Refresh session
         * @description Exchange the HttpOnly refresh cookie set at sign-in for a fresh short-lived access token. The cookie is rotated on every call; a missing, expired, revoked or replayed cookie returns 401 and is cleared.
         *
         *     **Authentication.** None — this endpoint is public (e.g. a webhook or tokened link).
         */
        post: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["AuthResponse"];
                    };
                };
                /**
                 * @description Auth.InvalidRefreshToken — the refresh token is missing, expired, or revoked; sign in again
                 *
                 *     Auth.InvalidCredentials — user account associated with the auth code no longer exists
                 */
                401: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/auth/register": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Register
         * @description Register a new user account by verifying an OAuth access token, optionally consuming a magic link invitation.
         *
         *     **Authentication.** None — this endpoint is public (e.g. a webhook or tokened link).
         */
        post: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["RegisterRequest"];
                };
            };
            responses: {
                /** @description Created */
                201: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["AuthResponse"];
                    };
                };
                /**
                 * @description Auth.UnsupportedProvider — OAuth provider is not supported; use 'google' or 'microsoft'
                 *
                 *     Auth.InvalidMagicLink — the magic link token is invalid or expired
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Auth.InvalidOAuthToken — the OAuth access token is invalid or expired */
                401: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Auth.UserAlreadyInOrganisation — the OAuth identity is already registered in this organisation */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/auth/sandbox-handoff": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Mint a sandbox-handoff auth code
         * @description Authenticated portal users (or any Bearer caller with org access) can exchange this for a session JWT scoped to one Org. Returns the code + URL the portal should open.
         *
         *     **Authentication.** A JWT Bearer token. API keys are not accepted.
         */
        post: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["SandboxHandoffRequest"];
                };
            };
            responses: {
                /** @description Created */
                201: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["SandboxHandoffResponse"];
                    };
                };
                /** @description Handoff.MissingOrganisationId — body's organisationId is empty */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Handoff.NoOrgAccess — caller lacks UserOrganisation membership and is not Admin/Owner of the owning Client */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Organisation.NotFound — the organisation does not exist or could not be resolved */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/api-keys": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List API keys
         * @description List the calling Client's API keys with cursor-based pagination. Portal-only. Raw keys are never returned.
         *
         *     **Authentication.** A JWT Bearer token for a client administrator (Admin or Owner). Dolfin staff may instead use an admin API key with the `x-dolfin-client-id` header.
         */
        get: {
            parameters: {
                query?: {
                    ClientId?: string;
                    Cursor?: string;
                    Limit?: number | string;
                };
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfApiKeyResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        /**
         * Create API key
         * @description Mint a new API key for the calling Client. Portal-only — the caller must be Developer, Admin, or Owner of the active Client.
         *
         *     **Authentication.** A JWT Bearer token for a client administrator (Admin or Owner). Dolfin staff may instead use an admin API key with the `x-dolfin-client-id` header.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["CreateApiKeyRequest"];
                };
            };
            responses: {
                /** @description Created */
                201: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CreateApiKeyResponse"];
                    };
                };
                /** @description ApiKey.ExpiresAtInPast — ExpiresAt is not in the future */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Member.Forbidden — caller is not an Admin or Owner of this Client */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/api-keys/{id}/revoke": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Revoke API key
         * @description Revoke an active API key so it can no longer be used. Portal-only — the caller must be Developer, Admin, or Owner of the active Client.
         *
         *     **Authentication.** A JWT Bearer token for a client administrator (Admin or Owner). Dolfin staff may instead use an admin API key with the `x-dolfin-client-id` header.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description No Content */
                204: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Member.Forbidden — caller is not an Admin or Owner of this Client */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description ApiKey.NotFound — API key does not exist or does not belong to this Client */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description ApiKey.AlreadyRevoked — key is already revoked */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/agent/books": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Chat with the Books agent
         * @description Agent - Books: the general ledger, its reports and the bank lines to categorise.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["AgentRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /**
                 * @description Agent.MissingMessage — message is required
                 *
                 *     Agent.MessageTooLong — message exceeds 8000 characters
                 *
                 *     Agent.PagePathTooLong — page path exceeds 500 characters
                 *
                 *     Agent.PageTitleTooLong — page title exceeds 120 characters
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Conversation.Forbidden — conversation belongs to a different user
                 *
                 *     Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Conversation.NotFound — conversation does not exist */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Conversation.WrongAgent — conversation was started with a different agent type */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/me/whatsapp-enrolment": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get my WhatsApp enrolment
         * @description Whether the signed-in user receives notifications (such as bills awaiting their approval) on WhatsApp, and on which number.
         *
         *     **Authentication.** A JWT Bearer token. API keys are not accepted.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["WhatsAppEnrolmentResponse"];
                    };
                };
                /** @description WhatsApp.ClientContextRequired — the caller's Client could not be told: send the organisation header */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        /**
         * Start WhatsApp enrolment
         * @description Start receiving notifications on WhatsApp. Returns a one-time code and the Client's WhatsApp number: send the code to that number from your own WhatsApp within 15 minutes, and the number you send it from is enrolled. Calling again issues a new code; an enrolled number keeps working until a new one is verified.
         *
         *     **Authentication.** A JWT Bearer token. API keys are not accepted.
         */
        post: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["WhatsAppEnrolmentResponse"];
                    };
                };
                /** @description WhatsApp.ClientContextRequired — the caller's Client could not be told: send the organisation header */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description WhatsApp.NotConnected — no WhatsApp number is connected */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        /**
         * Stop WhatsApp notifications
         * @description Remove the signed-in user's WhatsApp enrolment. Notifications go by email only from then on.
         *
         *     **Authentication.** A JWT Bearer token. API keys are not accepted.
         */
        delete: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description No Content */
                204: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description WhatsApp.ClientContextRequired — the caller's Client could not be told: send the organisation header */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/organisations/{organisationId}/users": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List organisation users
         * @description List users belonging to a specific organisation, including their role.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token. When your credential grants access to more than one client, select one with the `x-dolfin-client-id` header.
         */
        get: {
            parameters: {
                query?: {
                    /** @description Opaque pagination cursor. Pass back `next` or `previous` from a previous page's cursors. */
                    Cursor?: string;
                    /** @description Page size, 1 to 100. Defaults to 20. */
                    Limit?: number | string;
                    /** @description Exact match on email address. */
                    Email?: string;
                    /** @description Case-insensitive text matched anywhere in the member's name or email, for pickers that narrow as you type. */
                    Search?: string;
                };
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfOrganisationUserResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Organisation.Forbidden — the specified organisation does not belong to this client */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        /**
         * Create user
         * @description Add a user to an organisation, creating the user account if it does not already exist. Caller must be Admin or Owner of the organisation (a Client's own API key always may). Defaults to the Member role; a caller may not grant a role above their own.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token. When your credential grants access to more than one client, select one with the `x-dolfin-client-id` header.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["CreateUserRequest"];
                };
            };
            responses: {
                /** @description Created */
                201: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CreateUserResponse"];
                    };
                };
                /**
                 * @description User.MissingEmail — email address is required
                 *
                 *     User.InvalidEmail — email address is not valid
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Organisation.Forbidden — the specified organisation does not belong to this client
                 *
                 *     User.Forbidden — caller is not Admin or Owner of this organisation
                 *
                 *     User.RoleAboveCaller — cannot assign or modify a role higher than your own
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description User.AlreadyInOrganisation — user is already a member of this organisation */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/users": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List users in my organisation
         * @description List users belonging to the caller's active organisation, including their role.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    /** @description Opaque pagination cursor. Pass back `next` or `previous` from a previous page's cursors. */
                    Cursor?: string;
                    /** @description Page size, 1 to 100. Defaults to 20. */
                    Limit?: number | string;
                    /** @description Exact match on email address. */
                    Email?: string;
                    /** @description Case-insensitive text matched anywhere in the member's name or email, for pickers that narrow as you type. */
                    Search?: string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfOrganisationUserResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        /**
         * Add user to my organisation
         * @description Add a user to the caller's active organisation (creating the user account if it does not already exist). Caller must be Admin or Owner of the organisation.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["CreateOrganisationUserRequest"];
                };
            };
            responses: {
                /** @description Created */
                201: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CreateUserResponse"];
                    };
                };
                /**
                 * @description User.MissingEmail — email address is required
                 *
                 *     User.InvalidEmail — email address is not valid
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description User.Forbidden — caller is not Admin or Owner of this organisation
                 *
                 *     User.RoleAboveCaller — cannot assign or modify a role higher than your own
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description User.AlreadyInOrganisation — user is already a member of this organisation */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/users/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get user
         * @description Retrieve a user visible to the caller — either a member of any organisation under the caller's client (API-key or client-admin Bearer) or a member of the caller's active organisation (Bearer org user). The Organisations list is scoped to the same visibility lens.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token; the organisation is determined without the `x-dolfin-organisation-id` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    /** @description Id of the user. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["GetUserResponse"];
                    };
                };
                /** @description User.NotFound — user does not exist or is not visible to the caller */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        /**
         * Remove user from my organisation
         * @description Remove a user's membership from the caller's active organisation. Admin/Owner only. Cannot remove yourself, a member whose role is above your own, or the last Owner.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        delete: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description No Content */
                204: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /**
                 * @description User.Forbidden — caller is not Admin or Owner of this organisation
                 *
                 *     User.RoleAboveCaller — cannot assign or modify a role higher than your own
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description User.NotInOrganisation — user is not a member of this organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description User.CannotRemoveSelf — caller cannot remove themselves from the organisation
                 *
                 *     User.CannotRemoveLastOwner — cannot remove the last Owner of the organisation
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/users/{id}/role": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /**
         * Update user role in my organisation
         * @description Change a member's OrganisationRole in the caller's active organisation. Admin/Owner only. Cannot demote the only Owner.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        patch: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["PatchOrganisationUserRoleRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["OrganisationUserResponse"];
                    };
                };
                /** @description User.MissingRole — role is required */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description User.Forbidden — caller is not Admin or Owner of this organisation
                 *
                 *     User.RoleAboveCaller — cannot assign or modify a role higher than your own
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description User.NotInOrganisation — user is not a member of this organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description User.LastOwner — cannot demote the last Owner of the organisation */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        trace?: never;
    };
    "/v1/tax-rates": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List tax rates
         * @description List the merged set of platform-managed country defaults plus the organisation's own tax rates.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    /** @description Partial, case-insensitive match on the rate code. */
                    Code?: string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfTaxRateResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        /**
         * Create tax rate
         * @description Create a new tax rate for the organisation.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["CreateTaxRateRequest"];
                };
            };
            responses: {
                /** @description Created */
                201: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["TaxRateResponse"];
                    };
                };
                /**
                 * @description TaxRate.MissingCode — tax rate code is required
                 *
                 *     TaxRate.MissingName — tax rate name is required
                 *
                 *     TaxRate.InvalidRate — rate must be between 0 and 100
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description TaxRate.DuplicateCode — a tax rate with this code already exists in the organisation */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/tax-rates/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get tax rate
         * @description Retrieve a single tax rate (org-owned or country default) by its identifier.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["TaxRateResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description TaxRate.NotFound — a referenced tax rate does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        /**
         * Update tax rate
         * @description Replace all mutable fields on an existing tax rate.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        put: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the tax rate. Must be an organisation-owned rate — country defaults are read-only. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["UpdateTaxRateRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["TaxRateResponse"];
                    };
                };
                /**
                 * @description TaxRate.MissingCode — tax rate code is required
                 *
                 *     TaxRate.MissingName — tax rate name is required
                 *
                 *     TaxRate.InvalidRate — rate must be between 0 and 100
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description TaxRate.NotFound — a referenced tax rate does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description TaxRate.ReadOnly — tax rate is a platform-managed country default and cannot be deleted
                 *
                 *     TaxRate.DuplicateCode — a tax rate with this code already exists in the organisation
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        post?: never;
        /**
         * Delete tax rate
         * @description Delete a tax rate from the organisation.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        delete: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description No Content */
                204: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description TaxRate.NotFound — a referenced tax rate does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description TaxRate.ReadOnly — tax rate is a platform-managed country default and cannot be deleted
                 *
                 *     TaxRate.InUse — tax rate is referenced by an active recurring invoice schedule and cannot be deleted
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/suppliers/{id}/confirm-bank-details": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Confirm a supplier's bank details for pay-by-bank
         * @description An admin confirms the supplier's bank details are correct before the organisation can pay this supplier's bills by bank. The request echoes back the details the admin reviewed; confirmation is rejected if the stored details have changed in the meantime. Any later edit to the supplier's identifying bank fields clears the confirmation.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["ConfirmSupplierBankDetailsRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["SupplierResponse"];
                    };
                };
                /** @description Supplier.BankDetailsInvalid — stored bank details fail validation and cannot be confirmed */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Supplier.NotFound — supplier does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Supplier.BankDetailsChanged — stored bank details differ from the ones the admin reviewed */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/suppliers": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List suppliers
         * @description List suppliers for the organisation with optional name or email filtering and cursor-based pagination.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    /** @description Opaque pagination cursor. Pass back `next` or `previous` from a previous page's cursors. */
                    Cursor?: string;
                    /** @description Page size, 1 to 100. Defaults to 20. */
                    Limit?: number | string;
                    /** @description Partial, case-insensitive match on supplier name. */
                    Name?: string;
                    /** @description Exact match on supplier email. */
                    Email?: string;
                    /** @description Returns only records written at or after this UTC instant — the reconciliation filter for a client keeping its own copy in sync. Take the watermark from when your sync run STARTED, not when it finished, so a record edited mid-run is caught on the next one. Ordering and paging are unchanged. */
                    UpdatedSince?: string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfSupplierResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        /**
         * Create supplier
         * @description Create a new supplier for the organisation.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["CreateSupplierRequest"];
                };
            };
            responses: {
                /** @description Created */
                201: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["SupplierResponse"];
                    };
                };
                /**
                 * @description Supplier.MissingName — supplier name is required
                 *
                 *     Supplier.InvalidCountry — country code is not a valid ISO 3166-1 alpha-2 code
                 *
                 *     Supplier.LedgerAccountNotFound — when the default ledger account is not an active account in the organisation's synced chart of accounts
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Supplier.DuplicateName — a supplier with this name already exists in the organisation */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/suppliers/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get supplier
         * @description Retrieve a single supplier by ID.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the supplier. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["SupplierResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Supplier.NotFound — supplier does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /**
         * Patch supplier
         * @description Partially update a supplier's details.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        patch: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the supplier to update. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["PatchSupplierRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["SupplierResponse"];
                    };
                };
                /**
                 * @description Supplier.MissingName — supplier name is required
                 *
                 *     Supplier.InvalidCountry — country code is not a valid ISO 3166-1 alpha-2 code
                 *
                 *     Supplier.LedgerAccountNotFound — when the default ledger account is not an active account in the organisation's synced chart of accounts
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Supplier.NotFound — supplier does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Supplier.DuplicateName — a supplier with this name already exists in the organisation */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        trace?: never;
    };
    "/v1/supplier-credit-notes/{creditNoteId}/applications": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List supplier credit applications
         * @description List the bills a supplier credit note has been netted against, newest first.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the supplier credit note. */
                    creditNoteId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["SupplierCreditApplicationResponse"][];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        /**
         * Apply supplier credit to a bill
         * @description Net (part of) an issued supplier credit note against a bill the organisation owes the same supplier. Reduces the bill's outstanding balance and draws down the credit note's available balance.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the issued supplier credit note to apply. */
                    creditNoteId: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["ApplySupplierCreditRequest"];
                };
            };
            responses: {
                /** @description Created */
                201: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["SupplierCreditApplicationResponse"];
                    };
                };
                /** @description SupplierCreditNote.InvalidAmount — supplier credit note amount must be greater than zero */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description SupplierCreditNote.NotFound — no supplier credit note with that id for this organisation
                 *
                 *     SupplierCreditNote.BillNotFound — no bill with that id for this organisation
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description SupplierCreditNote.NotIssued — the supplier credit note must be issued before its credit can be applied
                 *
                 *     SupplierCreditNote.ExceedsAvailable — the amount exceeds the credit note's available balance
                 *
                 *     SupplierCreditNote.SupplierMismatch — the bill belongs to a different supplier than the credit note
                 *
                 *     SupplierCreditNote.CurrencyMismatch — the bill currency differs from the credit note currency
                 *
                 *     SupplierCreditNote.BillNotCreditable — supplier credit can only be applied to a bill that is awaiting approval, approved, scheduled, or payment-failed
                 *
                 *     SupplierCreditNote.ExceedsBillOutstanding — the amount exceeds the bill's outstanding balance
                 *
                 *     SupplierCreditNote.CommandFailed — the supplier credit note command was rejected by the saga (state conflict)
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/suppliers/{supplierId}/credit-notes": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Create supplier credit note
         * @description Create a supplier (AP) credit note in Draft against a supplier. Amount is the gross (tax-inclusive) credit, positive. Issue it separately to make the credit available; apply it to a bill to net it down.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the supplier the credit note is against. */
                    supplierId: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["CreateSupplierCreditNoteRequest"];
                };
            };
            responses: {
                /** @description Created */
                201: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["SupplierCreditNoteResponse"];
                    };
                };
                /**
                 * @description SupplierCreditNote.InvalidAmount — supplier credit note amount must be greater than zero
                 *
                 *     SupplierCreditNote.InvalidCurrency — currency code is not valid
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description SupplierCreditNote.SupplierNotFound — no supplier with that id for this organisation
                 *
                 *     SupplierCreditNote.BillNotFound — no bill with that id for this organisation
                 *
                 *     TaxRate.NotFound — a referenced tax rate does not exist or belongs to a different organisation
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description SupplierCreditNote.SupplierMismatch — the bill belongs to a different supplier than the credit note
                 *
                 *     SupplierCreditNote.CommandFailed — the supplier credit note command was rejected by the saga (state conflict)
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/supplier-credit-notes/{creditNoteId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get supplier credit note
         * @description Get a single supplier credit note by id.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the supplier credit note. */
                    creditNoteId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["SupplierCreditNoteResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description SupplierCreditNote.NotFound — no supplier credit note with that id for this organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        /**
         * Delete supplier credit note
         * @description Delete a Draft supplier credit note. Issued or applied notes cannot be deleted, and neither can a note delivered over an e-invoicing network — that document belongs to the supplier who sent it.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        delete: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the Draft supplier credit note to delete. */
                    creditNoteId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description No Content */
                204: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description SupplierCreditNote.NotFound — no supplier credit note with that id for this organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description SupplierCreditNote.AlreadyIssued — the supplier credit note is already issued and cannot be modified or deleted
                 *
                 *     SupplierCreditNote.NotDeletableEInvoice — the supplier credit note arrived over an e-invoicing network and cannot be deleted
                 *
                 *     SupplierCreditNote.CommandFailed — the supplier credit note command was rejected by the saga (state conflict)
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/suppliers/{supplierId}/credit": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get supplier credit balance
         * @description Get the available supplier-credit balance per currency for a supplier — what the supplier currently owes the organisation in credit.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the supplier. */
                    supplierId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["SupplierCreditBalanceResponse"][];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/suppliers/{supplierId}/credit/ledger": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get supplier credit ledger
         * @description Get the movements that built a supplier's credit balance — credit notes issued (+) and applications to bills (−), newest first, with cursor-based pagination.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    /** @description Opaque pagination cursor. Pass back `next` or `previous` from a previous page's cursors. */
                    Cursor?: string;
                    /** @description Page size, 1 to 100. Defaults to 20. */
                    Limit?: number | string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the supplier. */
                    supplierId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfSupplierCreditLedgerEntryResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/supplier-credit-notes/{creditNoteId}/issue": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Issue supplier credit note
         * @description Issue a Draft supplier credit note. This makes its credit available against the supplier (no bill is touched) and the note becomes immutable.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the Draft supplier credit note to issue. */
                    creditNoteId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["SupplierCreditNoteResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description SupplierCreditNote.NotFound — no supplier credit note with that id for this organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description SupplierCreditNote.AlreadyIssued — the supplier credit note is already issued and cannot be modified or deleted
                 *
                 *     SupplierCreditNote.OriginalBillMissing — the credit note credits an invoice that is not a bill on file, so it cannot be issued
                 *
                 *     SupplierCreditNote.CommandFailed — the supplier credit note command was rejected by the saga (state conflict)
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/bills/{billId}/credit-applications": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List a bill's supplier-credit applications
         * @description List the supplier credit notes netted against a bill, newest first. Each entry links to its supplier credit note.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the bill. */
                    billId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["SupplierCreditApplicationResponse"][];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/supplier-credit-notes": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List supplier credit notes
         * @description List the organisation's supplier credit notes, newest first, optionally filtered by supplier, currency, or status.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    /** @description Opaque pagination cursor. Pass back `next` or `previous` from a previous page's cursors. */
                    Cursor?: string;
                    /** @description Page size, 1 to 100. Defaults to 20. */
                    Limit?: number | string;
                    /** @description Returns only credit notes against this supplier. */
                    SupplierId?: string;
                    /** @description ISO 4217 currency filter, e.g. GBP. */
                    Currency?: string;
                    /** @description Filter by status: Draft, Issued, PartiallyApplied, or Applied. */
                    Status?: components["schemas"]["SupplierCreditNoteState"];
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfSupplierCreditNoteResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/supplier-credit-notes/{creditNoteId}/applications/{applicationId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * Reverse a supplier credit application
         * @description Reverse a previously-applied netting: un-credits the bill and returns the credit to the note's available balance.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        delete: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the supplier credit note the application belongs to. */
                    creditNoteId: string;
                    /** @description Id of the application to reverse. */
                    applicationId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description No Content */
                204: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description SupplierCreditNote.ApplicationNotFound — no active credit application with that id on this credit note */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description SupplierCreditNote.BillNotReversible — the credit's bill is no longer in a state where the netting can be reversed
                 *
                 *     SupplierCreditNote.ReversalInProgress — a reversal of this credit application is already in progress
                 *
                 *     SupplierCreditNote.CommandFailed — the supplier credit note command was rejected by the saga (state conflict)
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/payables/categories": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Resolved spend categories
         * @description The categories an organisation may classify against: Dolfin system defaults unioned with the organisation's client's custom categories (defaults first). Read-only; each row's `source` is `system` or `client`.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ResolvedCategoryResponse"][];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/payables/spend-summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Spend summary
         * @description The CFO view of spend over a period, aggregated from confirmed line-item classification: totals with the committed-vs-variable split, by category (AI/Intelligence broken out), by spend class, by supplier and by tag — every block per currency, never summed across currencies and never a blended grand total — plus a period-over-period delta vs the prior equal window. Counts bills from Approved onward, dated by when the spend was incurred (invoice date). Both query params are optional; the default range is the trailing 30 days (UTC).
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    /** @description Start of the period (yyyy-MM-dd), inclusive. Defaults with `to` to the trailing 30 days. */
                    from?: string;
                    /** @description End of the period (yyyy-MM-dd), inclusive. Defaults to today. */
                    to?: string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["SpendSummaryResponse"];
                    };
                };
                /** @description SpendSummary.InvalidDateRange — `from` is after `to` */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/recurring-invoices/{id}/cancel": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Cancel recurring invoice schedule
         * @description Cancel a schedule permanently. No further invoices are generated; already-generated invoices are unaffected. Terminal — a cancelled schedule cannot be resumed.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the schedule to cancel. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["RecurringInvoiceScheduleResponse"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description RecurringInvoice.NotFound — schedule does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description RecurringInvoice.Terminal — schedule is already Completed or Cancelled */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/recurring-invoices": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List recurring invoice schedules
         * @description List recurring-invoice schedules for the organisation with optional status and customer filtering.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    /** @description Opaque pagination cursor. Pass back `next` or `previous` from a previous page's cursors. */
                    Cursor?: string;
                    /** @description Page size, 1 to 100. Defaults to 20. */
                    Limit?: number | string;
                    /** @description Schedule statuses to include. Pass one or more of Active, Paused, Completed, Cancelled; omit for all. */
                    Statuses?: components["schemas"]["RecurringScheduleStatus"][];
                    /** @description Only schedules billing this customer. */
                    CustomerId?: string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfRecurringInvoiceScheduleResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        /**
         * Create recurring invoice schedule
         * @description Create a recurring-invoice schedule (contract). Invoices are generated from the schedule's template on the cadence — occurrence N falls on StartDate plus N intervals (month-end clamped). With AutoSend each occurrence is generated and emailed in one step; otherwise occurrences land as Draft for review. Admin-gated because an AutoSend schedule sends email without further review.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["CreateRecurringInvoiceScheduleRequest"];
                };
            };
            responses: {
                /** @description Created */
                201: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["RecurringInvoiceScheduleResponse"];
                    };
                };
                /**
                 * @description RecurringInvoice.MissingCustomerId — customer ID is required
                 *
                 *     RecurringInvoice.InvalidCurrency — currency code is not valid
                 *
                 *     RecurringInvoice.MissingStartDate — start date is required
                 *
                 *     RecurringInvoice.InvalidCadence — cadence must be Weekly, Monthly, Quarterly, or Annually
                 *
                 *     RecurringInvoice.InvalidTotalOccurrences — total occurrences must be at least 1
                 *
                 *     RecurringInvoice.InvalidPaymentTerms — payment terms (in days) are out of the allowed range
                 *
                 *     RecurringInvoice.MissingLineItems — at least one line item is required
                 *
                 *     Currency.NotFoundByCode — the specified currency is not supported
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Customer.NotFound — customer does not exist or belongs to a different organisation
                 *
                 *     Organisation.NotFound — the organisation does not exist or could not be resolved
                 *
                 *     Product.NotFound — a referenced product does not exist or belongs to a different organisation
                 *
                 *     TaxRate.NotFound — a referenced tax rate does not exist or belongs to a different organisation
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Invoice.InvalidDiscount — a discount value is negative, a percentage above 100, missing for its discount type, or supplied when there is no discount
                 *
                 *     Invoice.DiscountExceedsAmount — a fixed discount is larger than the amount it applies to
                 *
                 *     Invoice.EarlyPaymentDiscountInvalid — an early payment discount needs its type, value and expiry date together (or none of them), with a non-negative value of at most 2 decimal places
                 *
                 *     Invoice.EarlyPaymentDiscountExceedsAmount — an early payment discount is a percentage above 100, or a fixed amount not less than the invoice total
                 *
                 *     Invoice.EarlyPaymentDiscountExpiryInvalid — an early payment discount's expiry date is before the issue date or after the due date
                 */
                422: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/recurring-invoices/from-contract": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Extract recurring-invoice terms from a contract
         * @description Upload a contract as a PDF or image — PNG, JPEG, GIF, or WebP (multipart/form-data, field name 'file') — and get back the recurring-billing terms (customer, currency, cadence, start date, line items) as NAMES — this does not create anything. Resolve the names to ids (customers, products, tax rates) and POST /recurring-invoices to create the schedule. Required fields the contract omits are listed in missingFields; currency falls back to the organisation default. Admin-gated. Max 5 MB.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "multipart/form-data": {
                        file?: components["schemas"]["IFormFile"];
                    };
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ExtractedContractTerms"];
                    };
                };
                /**
                 * @description Contract.TooLarge — the contract exceeds the 5 MB upload limit
                 *
                 *     Contract.ExtractionFailed — the document was empty, an unsupported file type, unreadable, or yielded no schedule fields
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/recurring-invoices/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get recurring invoice schedule
         * @description Get a recurring-invoice schedule by id. Generated invoices are listable via GET /invoices?recurringScheduleId={id}.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the recurring-invoice schedule. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["RecurringInvoiceScheduleResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description RecurringInvoice.NotFound — schedule does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /**
         * Edit recurring invoice schedule
         * @description Edit a schedule's template. Changes only affect future occurrences — already-generated invoices are untouched (edit a Draft occurrence via PATCH /invoices/{id}). Memo, AutoSend, TotalOccurrences, and LineItems are always editable; StartDate and Cadence only before the first invoice is generated. CustomerId and Currency are immutable — a different counterparty or currency is a new schedule.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        patch: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["PatchRecurringInvoiceScheduleRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["RecurringInvoiceScheduleResponse"];
                    };
                };
                /**
                 * @description RecurringInvoice.InvalidTotalOccurrences — total occurrences must be at least 1
                 *
                 *     RecurringInvoice.MissingStartDate — start date is required
                 *
                 *     RecurringInvoice.InvalidCadence — cadence must be Weekly, Monthly, Quarterly, or Annually
                 *
                 *     RecurringInvoice.InvalidPaymentTerms — payment terms (in days) are out of the allowed range
                 *
                 *     RecurringInvoice.MissingLineItems — at least one line item is required
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description RecurringInvoice.NotFound — schedule does not exist or belongs to a different organisation
                 *
                 *     Organisation.NotFound — the organisation does not exist or could not be resolved
                 *
                 *     Product.NotFound — a referenced product does not exist or belongs to a different organisation
                 *
                 *     TaxRate.NotFound — a referenced tax rate does not exist or belongs to a different organisation
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description RecurringInvoice.Terminal — schedule is already Completed or Cancelled
                 *
                 *     RecurringInvoice.AnchorLocked — StartDate/Cadence cannot change after the first invoice is generated
                 *
                 *     RecurringInvoice.TotalOccurrencesBelowGenerated — total occurrences cannot be below the number already generated
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Invoice.InvalidDiscount — a discount value is negative, a percentage above 100, missing for its discount type, or supplied when there is no discount
                 *
                 *     Invoice.DiscountExceedsAmount — a fixed discount is larger than the amount it applies to
                 *
                 *     Invoice.EarlyPaymentDiscountInvalid — an early payment discount needs its type, value and expiry date together (or none of them), with a non-negative value of at most 2 decimal places
                 *
                 *     Invoice.EarlyPaymentDiscountExceedsAmount — an early payment discount is a percentage above 100, or a fixed amount not less than the invoice total
                 *
                 *     Invoice.EarlyPaymentDiscountExpiryInvalid — an early payment discount's expiry date is before the issue date or after the due date
                 */
                422: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        trace?: never;
    };
    "/v1/recurring-invoices/{id}/pause": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Pause recurring invoice schedule
         * @description Pause an Active schedule. No invoices are generated while paused; resume recomputes the next run from the anchor, skipping occurrences missed while paused.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the Active schedule to pause. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["RecurringInvoiceScheduleResponse"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description RecurringInvoice.NotFound — schedule does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description RecurringInvoice.NotActive — only Active schedules can be paused */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/recurring-invoices/{id}/resume": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Resume recurring invoice schedule
         * @description Resume a Paused schedule. The next run is recomputed from the anchor: occurrences whose dates passed while paused are skipped (not back-filled) — at most the single most-recently-due occurrence generates immediately. If the occurrence count was exhausted while paused, the schedule completes instead.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the Paused schedule to resume. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["RecurringInvoiceScheduleResponse"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description RecurringInvoice.NotFound — schedule does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description RecurringInvoice.NotPaused — only Paused schedules can be resumed */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/receivables/outstanding": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Outstanding receivables
         * @description Everything the organisation is owed (issued, not fully paid), aged into buckets and grouped by customer, with per-currency totals and a recommendation.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    /** @description Optional ISO date (yyyy-MM-dd) to age against. Defaults to today. */
                    asOf?: string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["OutstandingResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/receivables/overdue": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Overdue receivables
         * @description Overdue receivables grouped by customer, each tiered (gentle/firm/final/escalation) with a suggested action and tone, last-reminder timing, and payment behaviour.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    /** @description Optional ISO date (yyyy-MM-dd) to age against. Defaults to today. */
                    asOf?: string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["OverdueResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/receivables/summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Receivables summary
         * @description A one-call receivables briefing: outstanding totals per currency, the five most overdue customers with a suggested action, cash received in the last 30 days with the trend against the 30 before, and the oldest draft invoices.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    /** @description Optional ISO date (yyyy-MM-dd) to age against. Defaults to today. */
                    asOf?: string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ReceivablesSummaryResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/receivables/received": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Total received summary
         * @description Cash collected (succeeded payments) over a fixed window, with the trend vs the prior equal-length window, a per-bucket time series, a Stripe-vs-Manual split, and top customers.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    /** @description Lookback window: Last7Days, Last30Days, Last90Days, Last12Months, MonthToDate, QuarterToDate, YearToDate. Defaults to Last30Days. */
                    period?: components["schemas"]["LookbackPeriod"];
                    /** @description Optional 3-letter ISO currency for the primary view (Summary/Trend/Buckets). Defaults to the organisation's default currency; ReceivedByCurrency always covers every currency regardless. */
                    currency?: string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ReceivedResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/purchase-orders": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List purchase orders
         * @description List purchase orders for the organisation, optionally filtered by supplier, with cursor-based pagination.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    Cursor?: string;
                    Limit?: number | string;
                    SupplierId?: string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfPurchaseOrderResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        /**
         * Create purchase order
         * @description Create a purchase order with its lines for the organisation. POs are trusted platform data and do not require approval. The PO number is unique per organisation — creating a second PO with an existing number returns 409; to replace an existing PO's lines, PUT /purchase-orders/by-number/{poNumber}.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["CreatePurchaseOrderRequest"];
                };
            };
            responses: {
                /** @description Created */
                201: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PurchaseOrderResponse"];
                    };
                };
                /**
                 * @description PurchaseOrder.InvalidCurrency — currency code is not valid
                 *
                 *     PurchaseOrder.NumberRequired — a purchase order requires a PO number
                 *
                 *     PurchaseOrder.NoLines — a purchase order must have at least one line
                 *
                 *     PurchaseOrder.InvalidLine — a purchase-order line is missing a description or a valid quantity
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description PurchaseOrder.SupplierNotFound — the referenced supplier does not exist in this organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description PurchaseOrder.DuplicateNumber — a purchase order with this PO number already exists in the organisation */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/purchase-orders/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get purchase order
         * @description Retrieve a purchase order and its lines by ID.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PurchaseOrderResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description PurchaseOrder.NotFound — purchase order does not exist or belongs to another organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        /**
         * Update purchase order
         * @description Replace a purchase order's header and lines. Lines with a known id are updated, lines with no id are added, and omitted lines are removed. Closed/cancelled orders are immutable, and a line already matched to a bill cannot be removed or have its ordered quantity reduced below the matched amount.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        put: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["UpdatePurchaseOrderRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PurchaseOrderResponse"];
                    };
                };
                /**
                 * @description PurchaseOrder.InvalidCurrency — currency code is not valid
                 *
                 *     PurchaseOrder.NumberRequired — a purchase order requires a PO number
                 *
                 *     PurchaseOrder.NoLines — a purchase order must have at least one line
                 *
                 *     PurchaseOrder.InvalidLine — a purchase-order line is missing a description or a valid quantity
                 *
                 *     PurchaseOrder.LineNotFound — a referenced purchase-order line does not belong to this purchase order
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description PurchaseOrder.NotFound — purchase order does not exist or belongs to another organisation
                 *
                 *     PurchaseOrder.SupplierNotFound — the referenced supplier does not exist in this organisation
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description PurchaseOrder.NotEditable — the purchase order is in a terminal status (closed or cancelled) and cannot be edited
                 *
                 *     PurchaseOrder.LineHasAllocations — a purchase-order line that is already matched to a bill cannot be removed
                 *
                 *     PurchaseOrder.QuantityBelowAllocated — quantity ordered cannot be reduced below the quantity already matched to bills
                 *
                 *     PurchaseOrder.MatchedTermsLocked — currency and supplier cannot change while any line is matched to a bill
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/purchase-orders/{id}/matched-bills": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List bills matched to a purchase order
         * @description Bills with at least one line allocated against this purchase order, with their match-group status.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["MatchedBillView"][];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description PurchaseOrder.NotFound — purchase order does not exist or belongs to another organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/purchase-orders/{id}/close": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Close purchase order
         * @description Mark a purchase order as done/fulfilled (terminal Closed). Stops future matching but keeps existing allocations. Already-terminal orders are rejected.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PurchaseOrderResponse"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description PurchaseOrder.NotFound — purchase order does not exist or belongs to another organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description PurchaseOrder.AlreadyTerminal — the purchase order is already closed or cancelled and cannot change status */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/purchase-orders/{id}/cancel": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Cancel purchase order
         * @description Mark a purchase order as void (terminal Cancelled). Stops future matching but keeps existing allocations. Already-terminal orders are rejected.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PurchaseOrderResponse"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description PurchaseOrder.NotFound — purchase order does not exist or belongs to another organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description PurchaseOrder.AlreadyTerminal — the purchase order is already closed or cancelled and cannot change status */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/purchase-orders/by-number/{poNumber}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Replace purchase order by PO number
         * @description Replace a purchase order's header and lines, addressing it by its PO number rather than its internal id — the idempotent ingest path for re-uploading a PO. Lines with a known id are updated, lines with no id are added, and omitted lines are removed. The PO number in the body must match the route; renames go through PUT /purchase-orders/{id}. Closed/cancelled orders are immutable, and a line already matched to a bill cannot be removed or have its ordered quantity reduced below the matched amount.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        put: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description The PO number of the purchase order to replace. It must already exist in the organisation. */
                    poNumber: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["UpdatePurchaseOrderRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PurchaseOrderResponse"];
                    };
                };
                /**
                 * @description PurchaseOrder.NumberMismatch — the PO number in the body does not match the PO number in the route
                 *
                 *     PurchaseOrder.InvalidCurrency — currency code is not valid
                 *
                 *     PurchaseOrder.NumberRequired — a purchase order requires a PO number
                 *
                 *     PurchaseOrder.NoLines — a purchase order must have at least one line
                 *
                 *     PurchaseOrder.InvalidLine — a purchase-order line is missing a description or a valid quantity
                 *
                 *     PurchaseOrder.LineNotFound — a referenced purchase-order line does not belong to this purchase order
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description PurchaseOrder.NotFound — purchase order does not exist or belongs to another organisation
                 *
                 *     PurchaseOrder.SupplierNotFound — the referenced supplier does not exist in this organisation
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description PurchaseOrder.DuplicateNumber — a purchase order with this PO number already exists in the organisation
                 *
                 *     PurchaseOrder.NotEditable — the purchase order is in a terminal status (closed or cancelled) and cannot be edited
                 *
                 *     PurchaseOrder.LineHasAllocations — a purchase-order line that is already matched to a bill cannot be removed
                 *
                 *     PurchaseOrder.QuantityBelowAllocated — quantity ordered cannot be reduced below the quantity already matched to bills
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/products/bulk": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Bulk create products
         * @description Create many products at once from a CSV file. The first row must be a header row using the product field names as column names: name, unitPrice and currency are required; description and type are optional (type defaults to Product). The upload is all-or-nothing: if any row is invalid, NO products are created and the response lists every problem found, under the problem detail's `data.errors` as objects of { row, column, code, message }, where `row` is the 1-based position among the data rows below the header. Fix every listed row and upload the file again.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "multipart/form-data": {
                        file?: components["schemas"]["IFormFile"];
                    };
                };
            };
            responses: {
                /** @description Created */
                201: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BulkCreateProductsResponse"];
                    };
                };
                /**
                 * @description Product.BulkFileRequired — a CSV file is required
                 *
                 *     Product.BulkUnsupportedFileType — the uploaded file is not a CSV
                 *
                 *     Product.BulkFileTooLarge — the uploaded file exceeds the maximum size
                 *
                 *     Product.BulkEmpty — the uploaded file contains no product rows
                 *
                 *     Product.BulkInvalidHeader — the CSV header row is missing a required column or contains an unrecognised one
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Product.BulkTooManyRows — the uploaded file contains more product rows than one upload accepts
                 *
                 *     Product.BulkMalformedRow — a row in the uploaded file could not be parsed as CSV, so no products were created
                 *
                 *     Product.BulkValidationFailed — one or more rows in the uploaded file are invalid, so no products were created
                 */
                422: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/products": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List products
         * @description List products for the organisation with optional name, type and currency filtering. Filter by currency to show only products an invoice in that currency can accept.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    /** @description Opaque pagination cursor. Pass back `next` or `previous` from a previous page's cursors. */
                    Cursor?: string;
                    /** @description Page size, 1 to 100. Defaults to 20. */
                    Limit?: number | string;
                    /** @description Partial, case-insensitive match on the product name. */
                    Name?: string;
                    /** @description Product type to filter by: Product or Service. */
                    Type?: string;
                    /** @description ISO 4217 currency code. Returns only products an invoice in that currency can use. */
                    Currency?: string;
                    /** @description Returns only records written at or after this UTC instant — the reconciliation filter for a client keeping its own copy in sync. Take the watermark from when your sync run STARTED, not when it finished, so a record edited mid-run is caught on the next one. Ordering and paging are unchanged. */
                    UpdatedSince?: string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfProductResponse"];
                    };
                };
                /**
                 * @description Product.InvalidType — a product type value is not one of the supported product types
                 *
                 *     Pagination.InvalidCursor — the cursor value is invalid
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        /**
         * Create product
         * @description Create a new product or service that can be added to invoice line items.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["CreateProductRequest"];
                };
            };
            responses: {
                /** @description Created */
                201: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ProductResponse"];
                    };
                };
                /**
                 * @description Product.MissingName — product name is required
                 *
                 *     Product.NameTooLong — product name exceeds 256 characters
                 *
                 *     Product.InvalidType — a product type value is not one of the supported product types
                 *
                 *     Product.InvalidPrice — unit price must be greater than or equal to zero
                 *
                 *     Product.InvalidCurrency — currency code is not valid
                 *
                 *     ArAccounting.LedgerAccountNotFound — when a referenced ledger account is not an active account in the organisation's synced chart of accounts
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Product.DuplicateName — a product with this name already exists in the organisation */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/products/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get product
         * @description Retrieve a single product by its identifier.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the product. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ProductResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Product.NotFound — a referenced product does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        /**
         * Update product
         * @description Replace all mutable fields on an existing product.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        put: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the product. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["UpdateProductRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ProductResponse"];
                    };
                };
                /**
                 * @description Product.MissingName — product name is required
                 *
                 *     Product.NameTooLong — product name exceeds 256 characters
                 *
                 *     Product.InvalidType — a product type value is not one of the supported product types
                 *
                 *     Product.InvalidPrice — unit price must be greater than or equal to zero
                 *
                 *     Product.InvalidCurrency — currency code is not valid
                 *
                 *     ArAccounting.LedgerAccountNotFound — when a referenced ledger account is not an active account in the organisation's synced chart of accounts
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Product.NotFound — a referenced product does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Product.DuplicateName — a product with this name already exists in the organisation */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        post?: never;
        /**
         * Delete product
         * @description Delete a product, failing if it is referenced by any invoice line item.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        delete: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the product. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description No Content */
                204: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Product.NotFound — a referenced product does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Product.HasInvoices — product cannot be deleted because it is referenced by invoice line items
                 *
                 *     Product.HasRecurringSchedules — product cannot be deleted because it is referenced by recurring invoice schedules
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/products/search": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Search products
         * @description Fuzzy-search products by id, name, or description. Uses PostgreSQL trigram similarity.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query: {
                    /** @description Text to match against the product's id, name or description. Required. */
                    q: string;
                    /** @description Maximum number of results, 1 to 20. Defaults to 5. */
                    limit?: number | string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ProductSearchHit"][];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/organisations/{id}/payment-account/link": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Create payment account onboarding link
         * @description Returns a short-lived Stripe-hosted onboarding URL. The Client redirects the SMB to this URL; Stripe collects KYC and redirects back to the supplied ReturnUrl. Use this as an alternative to the embedded-components session when the Client does not want to embed Stripe.js. The returned link is single-use and expires; call this endpoint each time onboarding resumes.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token; the organisation is determined without the `x-dolfin-organisation-id` header.
         */
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["CreatePaymentAccountLinkRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PaymentAccountLinkResponse"];
                    };
                };
                /**
                 * @description PaymentAccountLink.MissingReturnUrl — ReturnUrl is required
                 *
                 *     PaymentAccountLink.InvalidReturnUrl — ReturnUrl must be a valid absolute http(s) URL
                 *
                 *     PaymentAccountLink.MissingRefreshUrl — RefreshUrl is required
                 *
                 *     PaymentAccountLink.InvalidRefreshUrl — RefreshUrl must be a valid absolute http(s) URL
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Payment.Forbidden — caller does not have permission to configure payments for this organisation
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Organisation.NotFound — the organisation does not exist or could not be resolved */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description PaymentAccount.NotEnabled — organisation does not have a payment account; enable it first
                 *
                 *     PaymentAccount.Disconnected — payment account is disconnected; reset the integration and re-run onboarding
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description PaymentAccount.ProviderError — Stripe returned an error while creating the account link */
                502: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/organisations/{id}/payment-account/session": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Create payment account onboarding session
         * @description Returns a short-lived client secret that the frontend hands to Stripe's embedded ConnectAccountOnboarding component. The secret is single-use and expires; call this endpoint each time the onboarding component is mounted.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token; the organisation is determined without the `x-dolfin-organisation-id` header.
         */
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PaymentAccountSessionResponse"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Payment.Forbidden — caller does not have permission to configure payments for this organisation
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Organisation.NotFound — the organisation does not exist or could not be resolved */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description PaymentAccount.NotEnabled — organisation does not have a payment account; enable it first
                 *
                 *     PaymentAccount.Disconnected — payment account is disconnected; reset the integration and re-run onboarding
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description PaymentAccount.ProviderError — Stripe returned an error while creating the account link */
                502: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/i/{token}/checkout-session": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Create payment checkout session
         * @description Creates a Stripe PaymentIntent on the organisation's connected account via direct charge. Revenue share is applied via application_fee_amount. Returns the client_secret for Stripe.js to confirm the payment on the hosted payment page.
         *
         *     **Authentication.** None — this endpoint is public (e.g. a webhook or tokened link).
         */
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    token: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CheckoutSessionResponse"];
                    };
                };
                /**
                 * @description Demo.OutboundBlocked — this is a demo, so nothing is sent outside Dolfin
                 *
                 *     Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Payment.InvalidToken — the payment link is invalid or has expired
                 *
                 *     Organisation.NotFound — the organisation does not exist or could not be resolved
                 *
                 *     Client.NotFound — the client does not exist or is not visible to the caller
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Payment.InvoiceNotPayable — the invoice is voided or already paid
                 *
                 *     Payment.AlreadySubmitted — a payment for this invoice is already being processed
                 *
                 *     PaymentAccount.NotEnabled — organisation does not have a payment account; enable it first
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Payment.ProviderError — Stripe returned an error while creating the payment intent */
                502: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/organisations/{id}/payment-account/enable": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Enable payment account
         * @description Creates a payment account for the organisation. Returns the account identifier and initial status. Idempotent — returns existing account if one is already attached.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token; the organisation is determined without the `x-dolfin-organisation-id` header.
         */
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PaymentAccountResponse"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Payment.Forbidden — caller does not have permission to configure payments for this organisation
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Organisation.NotFound — the organisation does not exist or could not be resolved */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description PaymentAccount.ProviderError — Stripe returned an error while creating the account link */
                502: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/organisations/{id}/payment-account/status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get payment account status
         * @description Returns the current payment account status for the organisation. Refreshes from the payment provider when the stored status is not yet Active so the UI can reflect live onboarding progress without waiting for a webhook.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token; the organisation is determined without the `x-dolfin-organisation-id` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PaymentAccountResponse"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Payment.Forbidden — caller does not have permission to configure payments for this organisation
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Organisation.NotFound — the organisation does not exist or could not be resolved */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/invoices/{id}/payments": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List payments for an invoice
         * @description Returns all recorded payments against the invoice — both Stripe-originated (via webhook) and SMB-recorded manual payments. Ordered newest first.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["InvoicePaymentResponse"][];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Invoice.NotFound — no invoice with that id for this organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        /**
         * Record a manual payment against an invoice
         * @description Used when the customer pays off-platform (bank transfer, cash, cheque). Dispatches MarkInvoicePaid with Source=Manual — the saga handles the state transition (PartiallyPaid or Paid) via the same path as Stripe-originated payments.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["RecordInvoicePaymentRequest"];
                };
            };
            responses: {
                /** @description Created */
                201: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["InvoicePaymentResponse"];
                    };
                };
                /**
                 * @description Invoice.InvalidPaymentAmount — payment amount must be greater than zero, in whole minor units of the currency
                 *
                 *     Invoice.InvalidPaymentReference — payment reference is at most 100 characters
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Invoice.NotFound — no invoice with that id for this organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Invoice.NotInPayableState — invoice is not in Issued or PartiallyPaid status
                 *
                 *     Invoice.OverPayment — payment amount exceeds the outstanding balance
                 *
                 *     Invoice.CommandFailed — the invoice command was rejected by the saga (state conflict)
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/organisations/{id}/payment-account": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * Reset payment account
         * @description Clears the stored payment account so onboarding can be restarted. Only permitted when the account is currently Disconnected.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token; the organisation is determined without the `x-dolfin-organisation-id` header.
         */
        delete: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PaymentAccountResponse"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Payment.Forbidden — caller does not have permission to configure payments for this organisation
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Organisation.NotFound — the organisation does not exist or could not be resolved */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description PaymentAccount.NotResettable — payment account is not Disconnected; only a Disconnected account can be reset */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/payables/outstanding": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Outstanding payables
         * @description Everything the organisation owes (bills in Approved or Scheduled), aged into buckets and grouped by supplier, with per-currency totals, an in-review pipeline figure, and a recommendation.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    /** @description Optional ISO date (yyyy-MM-dd) to age against. Defaults to today. */
                    asOf?: string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["OutstandingPayablesResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/payables/overdue": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Overdue payables
         * @description Overdue bills grouped by supplier, each with urgency (low/medium/high/critical), a state-aware suggested action (schedule_payment/confirm_or_reschedule/wait), and the organisation's payment timing toward that supplier.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    /** @description Optional ISO date (yyyy-MM-dd) to age against. Defaults to today. */
                    asOf?: string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["OverduePayablesResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/payables/paid": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Total paid summary
         * @description Cash paid out (bills marked Paid) over a fixed window, with the trend vs the prior equal-length window, the payment-timing block (average days to pay, on-terms rate), a per-bucket time series, a payment-method split, and top suppliers.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    /** @description Lookback window: Last7Days, Last30Days, Last90Days, Last12Months, MonthToDate, QuarterToDate, YearToDate. Defaults to Last30Days. */
                    period?: components["schemas"]["LookbackPeriod"];
                    /** @description Optional 3-letter ISO currency for the primary view (Summary/Trend/PaymentTiming/Buckets). Defaults to the organisation's default currency; PaidByCurrency always covers every currency regardless. */
                    currency?: string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PaidResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/payables/summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Payables summary
         * @description A one-call payables briefing: outstanding totals per currency, the five most overdue suppliers with a suggested action, cash paid in the last 30 days with the trend against the 30 before, and the bills waiting for review or approval, marking those the caller can approve.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    /** @description Optional ISO date (yyyy-MM-dd) to age against. Defaults to today. */
                    asOf?: string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PayablesSummaryResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/organisations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List organisations
         * @description List organisations belonging to the authenticated client.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token. When your credential grants access to more than one client, select one with the `x-dolfin-client-id` header.
         */
        get: {
            parameters: {
                query?: {
                    Cursor?: string;
                    Limit?: number | string;
                    Name?: string;
                };
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfOrganisationResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        /**
         * Create organisation
         * @description Create an organisation under the authenticated client. An optional externalReference makes repeated creates return the same organisation within that client.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token. When your credential grants access to more than one client, select one with the `x-dolfin-client-id` header.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["CreateOrganisationRequest"];
                };
            };
            responses: {
                /** @description Created */
                201: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["OrganisationResponse"];
                    };
                };
                /**
                 * @description Organisation.MissingName — organisation name is required
                 *
                 *     Organisation.InvalidExternalReference — external reference must be 1 to 200 characters
                 *
                 *     Organisation.MissingClientId — client ID is required
                 *
                 *     Organisation.MissingIndustryId — industry ID is required
                 *
                 *     Organisation.MissingContactEmail — contact email is required
                 *
                 *     Organisation.InvalidContactEmail — contact email is not a valid email address
                 *
                 *     Organisation.InvalidCountry — country code is not a valid ISO 3166-1 alpha-2 code
                 *
                 *     Currency.NotFoundByCode — the specified currency is not supported
                 *
                 *     Organisation.ClientNotFound — specified client does not exist
                 *
                 *     Organisation.InvalidIndustryId — specified industry does not exist
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Company.ClientMismatch — the company and the organisation belong to different clients */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/organisations/{organisationId}/settings/ar": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get an organisation's AR settings
         * @description Retrieve an organisation's accounts-receivable defaults: payment terms, late payment fee, invoice message tone, automatic reminder schedule, and the bank details shown on invoices. These are the starting values for new invoices, each of which may override them. Returns platform defaults when the organisation has not customised anything yet.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token; the organisation is determined without the `x-dolfin-organisation-id` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organisationId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["OrganisationArSettingsResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /**
         * Patch an organisation's AR settings
         * @description Partially update an organisation's accounts-receivable defaults. Only supplied fields change; a settings row is created on first write. Invoice defaults apply to new invoices; the email layout applies to all future sends, including reminders for existing invoices.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token; the organisation is determined without the `x-dolfin-organisation-id` header.
         */
        patch: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organisationId: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["PatchOrganisationArSettingsRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["OrganisationArSettingsResponse"];
                    };
                };
                /** @description OrganisationArSettings.Invalid — an organisation AR settings value is out of its allowed range */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["HttpValidationProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        trace?: never;
    };
    "/v1/organisations/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get organisation
         * @description Retrieve a single organisation by its identifier.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token; the organisation is determined without the `x-dolfin-organisation-id` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["OrganisationResponse"];
                    };
                };
                /** @description Organisation.NotFound — the organisation does not exist or could not be resolved */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        /**
         * Update organisation
         * @description Replace all mutable fields on an existing organisation.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token; the organisation is determined without the `x-dolfin-organisation-id` header.
         */
        put: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["PutOrganisationRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["OrganisationResponse"];
                    };
                };
                /**
                 * @description Organisation.MissingName — organisation name is required
                 *
                 *     Organisation.MissingIndustryId — industry ID is required
                 *
                 *     Organisation.InvalidIndustryId — specified industry does not exist
                 *
                 *     Organisation.MissingContactEmail — contact email is required
                 *
                 *     Organisation.InvalidContactEmail — contact email is not a valid email address
                 *
                 *     Organisation.InvalidCountry — country code is not a valid ISO 3166-1 alpha-2 code
                 *
                 *     Organisation.InvalidColour — primary colour must be a valid hex colour
                 *
                 *     Currency.NotFoundByCode — the specified currency is not supported
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Organisation.InsufficientRole — caller's organisation role is below the level this action requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Organisation.NotFound — the organisation does not exist or could not be resolved */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Organisation.TaxIdentityLocked — the tax number and country cannot change while the organisation is registered for e-invoicing */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /**
         * Patch organisation
         * @description Partially update an organisation's profile, settings, or bank details.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token; the organisation is determined without the `x-dolfin-organisation-id` header.
         */
        patch: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["PatchOrganisationRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["OrganisationResponse"];
                    };
                };
                /**
                 * @description Organisation.MissingName — organisation name is required
                 *
                 *     Organisation.MissingIndustryId — industry ID is required
                 *
                 *     Organisation.InvalidIndustryId — specified industry does not exist
                 *
                 *     Organisation.InvalidContactEmail — contact email is not a valid email address
                 *
                 *     Organisation.InvalidCountry — country code is not a valid ISO 3166-1 alpha-2 code
                 *
                 *     Organisation.InvalidColour — primary colour must be a valid hex colour
                 *
                 *     Currency.NotFoundByCode — the specified currency is not supported
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Organisation.InsufficientRole — caller's organisation role is below the level this action requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Organisation.NotFound — the organisation does not exist or could not be resolved */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Organisation.TaxIdentityLocked — the tax number and country cannot change while the organisation is registered for e-invoicing */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        trace?: never;
    };
    "/v1/organisations/{organisationId}/settings/ar/email-preview": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Preview an invoice email layout with sample data
         * @description Renders an unsaved layout using the organisation's branding and deterministic sample data. Does not create invoices, payment tokens, or send email.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token; the organisation is determined without the `x-dolfin-organisation-id` header.
         */
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organisationId: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["PreviewOrganisationInvoiceEmailRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["InvoiceEmailPreviewResponse"];
                    };
                };
                /** @description OrganisationArSettings.Invalid — an organisation AR settings value is out of its allowed range */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.Forbidden — the specified organisation does not belong to this client
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Organisation.NotFound — the organisation does not exist or could not be resolved */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Invoice.EmailPreviewFailed — The selected email layout could not be rendered. Check its Postmark alias and template configuration. */
                502: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/mcp/{organisationId}/sessions/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get a single MCP session with its invocations
         * @description **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token; the organisation is determined without the `x-dolfin-organisation-id` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organisationId: string;
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["McpSessionDetailResponse"];
                    };
                };
                /** @description Mcp.SessionNotFound — session does not exist or belongs to another API key */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/mcp/{organisationId}/sessions/{sessionId}/invocations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Page through invocations of a single MCP session
         * @description Returns tool invocations for an MCP session in chronological order. Use this for sessions with many calls where the inline list on the session detail endpoint would be too large.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token; the organisation is determined without the `x-dolfin-organisation-id` header.
         */
        get: {
            parameters: {
                query?: {
                    Cursor?: string;
                    Limit?: number | string;
                };
                header?: never;
                path: {
                    organisationId: string;
                    sessionId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfMcpToolInvocationResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Mcp.SessionNotFound — session does not exist or belongs to another API key */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/mcp/{organisationId}/sessions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List MCP sessions for the organisation
         * @description Returns MCP sessions for the organisation, ordered by most recent activity. Each session is one connection from an MCP host (Claude Desktop, Cursor, claude.ai, ...). Within each session, see invocations for the tool calls made.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token; the organisation is determined without the `x-dolfin-organisation-id` header.
         */
        get: {
            parameters: {
                query?: {
                    Cursor?: string;
                    Limit?: number | string;
                };
                header?: never;
                path: {
                    organisationId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfMcpSessionSummaryResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/match-groups/{id}/allocations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Add allocation
         * @description Allocate a bill line against a PO line (price) and/or a delivery-note line (receipt quantity) on NET. At least one counterpart is required. Enforces the double-allocation guard (Σ matched quantity ≤ ordered on the counterpart line). A quantity above what the bill line was billed for is allowed — an order or delivery is matched as the document states it, and the difference is reported as a variance; the net a purchase-order allocation books is capped at what the bill line still owes. A quantity of zero is allowed too, and records a nil delivery: the counterpart line is bound to the bill line, none of it is claimed, and the whole billed quantity reports as a receipt-quantity variance for the reviewer to accept or dispute. Used both to allocate a counterpart yourself and to confirm one the engine suggested — you do not say which: the service records how the match was found, and the confidence it was found at, from its own suggestions for that line at the moment you post. Re-posting the same bill line and counterpart updates that allocation in place and leaves how it was originally found unchanged.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["AddAllocationRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["MatchGroupView"];
                    };
                };
                /**
                 * @description Match.NoLineSpecified — an allocation must reference a purchase-order line, a delivery-note line, or both
                 *
                 *     Match.InvalidQuantity — matched quantity cannot be negative
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Match.GroupNotFound — match group does not exist or belongs to another organisation
                 *
                 *     Match.BillLineNotFound — the bill line does not exist on this match group's bill
                 *
                 *     Match.PoLineNotFound — the referenced purchase-order line does not exist in this organisation
                 *
                 *     Match.DnLineNotFound — the referenced delivery-note line does not exist in this organisation
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Match.NothingLeftToMatch — the counterpart line has no quantity left to match; supply an explicit quantity to match part or none of it
                 *
                 *     Match.OverAllocation — allocation would exceed the purchase-order line's ordered quantity
                 *
                 *     Match.DnOverReceipt — allocation would exceed the delivery-note line's received quantity
                 *
                 *     Match.DnLineHeld — the delivery-note line's received quantity is already matched to another bill
                 *
                 *     Match.BillNotInReview — the bill is not in review; reopen it before changing its match
                 *
                 *     Match.CurrencyMismatch — the purchase order is in a different currency from the bill
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/bills/{billId}/match-group": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get a bill's match group
         * @description The three-way match group for a bill (derived variances + fuzzy suggestions). 404 when the bill has no match group yet.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    billId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["MatchGroupView"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Match.NoGroupForBill — no match group exists for this bill yet */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/client/match-stats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get three-way match stats for the client
         * @description How much of the three-way matching across every organisation you own was done automatically, how much a reviewer did by hand, and how much is still unmatched — by line count and by billed value, with the match-group lifecycle counts and the fuzzy-confidence distribution behind them. Cached server-side for up to an hour: read `asOf` for when the figures were materialised, and treat the variance count as a health indicator rather than a work queue.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token. When your credential grants access to more than one client, select one with the `x-dolfin-client-id` header.
         */
        get: {
            parameters: {
                query?: {
                    period?: components["schemas"]["MatchStatsPeriod"];
                };
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["MatchStatsResponse"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Client.Forbidden — caller is not a member of the specified Client
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/match-groups/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get match group
         * @description The review unit: bill lines, allocations, and DERIVED price-vs-PO variances (computed at read time, never stored), plus fuzzy PO-line suggestions for unmatched lines.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["MatchGroupView"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Match.GroupNotFound — match group does not exist or belongs to another organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/match-stats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get three-way match stats
         * @description How much of this organisation's three-way matching was done automatically, how much a reviewer did by hand, and how much is still unmatched — by line count and by billed value, with the match-group lifecycle counts and the fuzzy-confidence distribution behind them. Cached server-side for up to an hour: read `asOf` for when the figures were materialised, and treat the variance count as a health indicator rather than a work queue.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token. When your credential grants access to more than one client, select one with the `x-dolfin-client-id` header.
         */
        get: {
            parameters: {
                query?: {
                    period?: components["schemas"]["MatchStatsPeriod"];
                };
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["MatchStatsResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/match-groups/{id}/allocations/{allocationId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * Remove allocation
         * @description Unmatch a bill line from its PO line and/or DN line by deleting the allocation. The Allocation→line FKs are Restrict, so deleting the allocation is the only unmatch path. Re-derives the match-group status and returns the refreshed view.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        delete: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                    allocationId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["MatchGroupView"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Match.GroupNotFound — match group does not exist or belongs to another organisation
                 *
                 *     Match.AllocationNotFound — the allocation does not exist on this match group
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Match.BillNotInReview — the bill is not in review; reopen it before changing its match */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/match-groups/{id}/resolve": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Resolve a match line
         * @description Record a resolution against ONE bill line's variance (billLineId in the body): accept / accept_and_update_catalog settle that line whatever the variance kind (price, short delivery, or over-order surplus); dispute / request_credit_note keep the bill blocked. Once every varianced line is accept-resolved the group settles and emits the BillMatchResolved fact (an audit / webhook record of the settlement). This does NOT auto-approve the bill: it leaves PendingReview only when re-submitted, at which point the submit-time match gate re-evaluates the now-clean group. accept_and_update_catalog only records the intent — it does not mutate any catalog. Re-posting overrides a line's prior decision; DELETE the resolution to undo.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["ResolveMatchRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["MatchGroupView"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Match.GroupNotFound — match group does not exist or belongs to another organisation
                 *
                 *     Match.BillLineNotFound — the bill line does not exist on this match group's bill
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Match.BillNotInReview — the bill is not in review; reopen it before changing its match */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/match-groups/{id}/resolutions/{billLineId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * Undo a line resolution
         * @description Clear the recorded resolution on a bill line (the "Undo" action). Idempotent — undoing an already-clear line just returns the refreshed view. The group's status re-derives.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        delete: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                    billLineId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["MatchGroupView"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Match.GroupNotFound — match group does not exist or belongs to another organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Match.BillNotInReview — the bill is not in review; reopen it before changing its match */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/invoices": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List invoices
         * @description List invoices for the organisation with optional status, customer, and date filtering.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    /** @description Opaque pagination cursor. Pass back `next` or `previous` from a previous page's cursors. */
                    Cursor?: string;
                    /** @description Page size, 1 to 100. Defaults to 20. */
                    Limit?: number | string;
                    /** @description Invoice states to include. Pass one or more (e.g. Draft, Issued, Paid, Overdue); omit for all. */
                    States?: components["schemas"]["InvoiceState"][];
                    /** @description Only invoices billed to this customer. */
                    CustomerId?: string;
                    /** @description Only invoices issued on or after this date. */
                    IssueDateFrom?: string;
                    /** @description Only invoices issued on or before this date. */
                    IssueDateTo?: string;
                    /** @description Only invoices generated by this recurring-invoice schedule. */
                    RecurringScheduleId?: string;
                    /** @description Returns only records written at or after this UTC instant — the reconciliation filter for a client keeping its own copy in sync. Take the watermark from when your sync run STARTED, not when it finished, so a record edited mid-run is caught on the next one. Ordering and paging are unchanged. */
                    UpdatedSince?: string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfInvoiceResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        /**
         * Create invoice
         * @description Create a new invoice with line items for the organisation.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["CreateInvoiceRequest"];
                };
            };
            responses: {
                /** @description Created */
                201: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["InvoiceResponse"];
                    };
                };
                /**
                 * @description Invoice.MissingCustomerId — customer ID is required
                 *
                 *     Invoice.InvalidCurrency — currency code is not valid
                 *
                 *     Invoice.MissingLineItems — at least one line item is required
                 *
                 *     Currency.NotFoundByCode — the specified currency is not supported
                 *
                 *     Invoice.ProductCurrencyMismatch — a line item's product is priced in a different currency than the invoice
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Demo.LimitReached — the demo has reached its limit of documents of this kind; reset it to start again
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Customer.NotFound — customer does not exist or belongs to a different organisation
                 *
                 *     Organisation.NotFound — the organisation does not exist or could not be resolved
                 *
                 *     Product.NotFound — a referenced product does not exist or belongs to a different organisation
                 *
                 *     TaxRate.NotFound — a referenced tax rate does not exist or belongs to a different organisation
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Invoice.CommandFailed — the invoice command was rejected by the saga (state conflict)
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Invoice.InvalidCcRecipients — a CC recipient is not a valid email address
                 *
                 *     Invoice.InvalidPaymentTerms — payment terms (in days) are out of the allowed range
                 *
                 *     Invoice.InvalidDiscount — a discount value is negative, a percentage above 100, missing for its discount type, or supplied when there is no discount
                 *
                 *     Invoice.DiscountExceedsAmount — a fixed discount is larger than the amount it applies to
                 *
                 *     Invoice.EarlyPaymentDiscountInvalid — an early payment discount needs its type, value and expiry date together (or none of them), with a non-negative value of at most 2 decimal places
                 *
                 *     Invoice.EarlyPaymentDiscountExceedsAmount — an early payment discount is a percentage above 100, or a fixed amount not less than the invoice total
                 *
                 *     Invoice.EarlyPaymentDiscountExpiryInvalid — an early payment discount's expiry date is before the issue date or after the due date
                 */
                422: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/invoices/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get invoice
         * @description Retrieve a single invoice with its full line-item detail.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the invoice. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["InvoiceResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Invoice.NotFound — no invoice with that id for this organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        /**
         * Void invoice
         * @description Void an invoice. Dispatches VoidInvoice to the saga — the row is retained with Status = Void.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        delete: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the invoice to void. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description No Content */
                204: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Invoice.NotFound — no invoice with that id for this organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Invoice.CommandFailed — the invoice command was rejected by the saga (state conflict)
                 *
                 *     Invoice.VoidRequiresCreditNote — the invoice was sent as an e-invoice, so it is corrected with a credit note rather than voided
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        /**
         * Patch invoice
         * @description Partially update an invoice's fields or line items.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        patch: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the invoice to edit. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["PatchInvoiceRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["InvoiceResponse"];
                    };
                };
                /**
                 * @description Invoice.MissingCustomerId — customer ID is required
                 *
                 *     Invoice.InvalidCurrency — currency code is not valid
                 *
                 *     Invoice.MissingLineItems — at least one line item is required
                 *
                 *     Currency.NotFoundByCode — the specified currency is not supported
                 *
                 *     Invoice.ProductCurrencyMismatch — a line item's product is priced in a different currency than the invoice
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Invoice.NotFound — no invoice with that id for this organisation
                 *
                 *     Invoice.LineItemNotFound — a referenced line item does not exist on this invoice
                 *
                 *     Customer.NotFound — customer does not exist or belongs to a different organisation
                 *
                 *     Organisation.NotFound — the organisation does not exist or could not be resolved
                 *
                 *     Product.NotFound — a referenced product does not exist or belongs to a different organisation
                 *
                 *     TaxRate.NotFound — a referenced tax rate does not exist or belongs to a different organisation
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Invoice.CommandFailed — the invoice command was rejected by the saga (state conflict)
                 *
                 *     Invoice.NotEditable — invoice is not in Draft status
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Invoice.InvalidCcRecipients — a CC recipient is not a valid email address
                 *
                 *     Invoice.InvalidPaymentTerms — payment terms (in days) are out of the allowed range
                 *
                 *     Invoice.InvalidDiscount — a discount value is negative, a percentage above 100, missing for its discount type, or supplied when there is no discount
                 *
                 *     Invoice.DiscountExceedsAmount — a fixed discount is larger than the amount it applies to
                 *
                 *     Invoice.EarlyPaymentDiscountInvalid — an early payment discount needs its type, value and expiry date together (or none of them), with a non-negative value of at most 2 decimal places
                 *
                 *     Invoice.EarlyPaymentDiscountExceedsAmount — an early payment discount is a percentage above 100, or a fixed amount not less than the invoice total
                 *
                 *     Invoice.EarlyPaymentDiscountExpiryInvalid — an early payment discount's expiry date is before the issue date or after the due date
                 */
                422: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        trace?: never;
    };
    "/v1/invoices/{invoiceId}/emails/{emailId}/content": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get sent invoice email content
         * @description Returns the subject and body of an invoice email as it was rendered when it was sent. Content is read from what was stored at send time and is never regenerated from the invoice's current data or the current template, so an invoice edited after sending does not change what this returns. Emails sent before content was captured (and the rare send whose render failed) return 200 with contentAvailable=false and contentUnavailableReason=NotCaptured rather than an error — the send record itself is still described, so callers can show the delivery status alongside the notice.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    invoiceId: string;
                    emailId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["InvoiceEmailContentResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Invoice.NotFound — no invoice with that id for this organisation
                 *
                 *     Invoice.EmailNotFound — no email send record with that id on this invoice
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/invoices/{id}/email-preview": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Preview invoice email
         * @description Returns the rendered email that will be sent for this invoice: by its send while it is a Draft, or by a re-send while it is Issued or PartiallyPaid. Optional ?tone= and ?industryGroup= query parameters let callers rehearse a different catalogue cell without changing the organisation's defaults; when omitted, the organisation's DefaultInvoiceMessageTone and its industry group are used. Optional ?subject=, ?previewText=, ?greetingLine= and ?openingBodyMarkdown= mirror the SendInvoiceOverrides fields so the caller can preview the exact email that would be sent with those overrides.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    tone?: components["schemas"]["InvoiceTone"];
                    industryGroup?: components["schemas"]["MerchantCategoryGroup"];
                    subject?: string;
                    previewText?: string;
                    greetingLine?: string;
                    openingBodyMarkdown?: string;
                    cc?: string[];
                    replyTo?: string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["InvoiceEmailPreviewResponse"];
                    };
                };
                /** @description Invoice.CustomerMissingEmail — the customer has no email address */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Invoice.NotFound — no invoice with that id for this organisation
                 *
                 *     Organisation.NotFound — the organisation does not exist or could not be resolved
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Invoice.NotPreviewable — invoice is paid, credited or void, so there is no email to preview */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Invoice.InvalidCcRecipients — a CC recipient is not a valid email address
                 *
                 *     Invoice.InvalidReplyTo — the Reply-To address is not a valid email address
                 */
                422: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/invoices/{id}/pdf": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get invoice PDF
         * @description Generate and download a PDF rendering of the invoice. Includes a scan-to-pay QR when the organisation's payment account is active.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Invoice.NotFound — no invoice with that id for this organisation
                 *
                 *     Organisation.NotFound — the organisation does not exist or could not be resolved
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/invoices/{id}/send-plan": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get invoice send plan
         * @description Describe what sending this invoice will do, without changing anything. For a Draft: whether it goes over the organisation's e-invoicing network and to which address, whether a PDF copy is emailed and to whom, and every problem that stops the send, each with where it is fixed (the customer, the organisation, or the invoice). The e-invoice is checked against the network's rules exactly as the send will build it. POST /invoices/{id}/send refuses with the same problems while any remain. For an issued invoice (Issued or PartiallyPaid) the same, except that a delivery already on the network is shown with its status and is not sent again. Pass eInvoice and email to see the plan for the channel choices the send will be given.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    /** @description The send's eInvoice choice: Auto (default) or Skip. */
                    eInvoice?: components["schemas"]["InvoiceEInvoiceChoice"];
                    /** @description The send's email choice: AfterNetwork (default), Now or Skip. */
                    email?: components["schemas"]["InvoiceEmailChoice"];
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the invoice. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["InvoiceSendPlan"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Invoice.NotFound — no invoice with that id for this organisation
                 *
                 *     Organisation.NotFound — the organisation does not exist or could not be resolved
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Invoice.NotSendable — invoice is paid, credited or void, so there is nothing to send */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Invoice.EarlyPaymentDiscountExceedsAmount — an early payment discount is a percentage above 100, or a fixed amount not less than the invoice total
                 *
                 *     Invoice.EarlyPaymentDiscountInvalid — an early payment discount needs its type, value and expiry date together (or none of them), with a non-negative value of at most 2 decimal places
                 *
                 *     Invoice.EarlyPaymentDiscountExpiryInvalid — an early payment discount's expiry date is before the issue date or after the due date
                 */
                422: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/invoices/{id}/issue": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Issue invoice
         * @description Issue a Draft invoice: it gets its issue date and due date, its tax rates are fixed, and it can no longer be edited. Nothing is delivered to the customer — call POST /invoices/{id}/send to deliver it (send also issues a Draft itself, so issuing first is only needed when delivery happens later or elsewhere). When the organisation is registered for e-invoicing, the invoice is checked against its network's rules first, so an issued invoice can always be sent there; a problem is returned while the invoice is still a Draft.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the draft invoice to issue. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["InvoiceResponse"];
                    };
                };
                /** @description Invoice.TaxRateRequiredForAccounting — a line has no tax rate, which the connected accounting platform needs on every line */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Invoice.NotFound — no invoice with that id for this organisation
                 *
                 *     Organisation.NotFound — the organisation does not exist or could not be resolved
                 *
                 *     Customer.NotFound — customer does not exist or belongs to a different organisation
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Invoice.NotIssuable — invoice is not in Draft status, so it is already issued (or void)
                 *
                 *     Invoice.CommandFailed — the invoice command was rejected by the saga (state conflict)
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Invoice.EarlyPaymentDiscountExceedsAmount — an early payment discount is a percentage above 100, or a fixed amount not less than the invoice total
                 *
                 *     Invoice.EarlyPaymentDiscountInvalid — an early payment discount needs its type, value and expiry date together (or none of them), with a non-negative value of at most 2 decimal places
                 *
                 *     Invoice.EarlyPaymentDiscountExpiryInvalid — an early payment discount's expiry date is before the issue date or after the due date
                 *
                 *     EInvoicing.CustomerNotAddressable — this customer has no e-invoicing address to deliver to
                 *
                 *     EInvoicing.DocumentInvalid — the invoice is not valid as an e-invoice
                 *
                 *     EInvoicing.TotalsMismatch — the calculated totals do not match this invoice
                 *
                 *     EInvoicing.SellerNotRegistered — this organisation is not registered to send e-invoices
                 *
                 *     EInvoicing.CountryNotSupported — e-invoicing is not available in this organisation's country yet
                 */
                422: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description EInvoicing.ProviderUnavailable — the e-invoicing provider could not be reached */
                502: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/invoices/audit-logs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List recent invoice activity
         * @description Paged audit-log feed across every invoice in the organisation, newest first: state transitions, reminder outcomes, and display fields for rendering an activity feed.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    Cursor?: string;
                    Limit?: number | string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfInvoiceActivityResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/invoices/{invoiceId}/audit-logs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List audit logs for an invoice
         * @description Paged audit-log history for an invoice: state transitions, reminder outcomes, and the actor behind each step.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    Cursor?: string;
                    Limit?: number | string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    invoiceId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfInvoiceAuditLogResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Invoice.NotFound — no invoice with that id for this organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/invoices/{id}/emails": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List invoice emails
         * @description Returns the timeline of email send attempts and lifecycle events for this invoice.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["InvoiceEmailResponse"][];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Invoice.NotFound — no invoice with that id for this organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/invoices/{id}/whatsapp-messages": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List invoice WhatsApp messages
         * @description The invoice's WhatsApp messages, newest first: the first send and each reminder, with delivery status. A Skipped message was never sent, and its reason says why the email went instead.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the invoice. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["InvoiceWhatsAppMessageResponse"][];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Invoice.NotFound — no invoice with that id for this organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/invoices/email-preview": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Preview the email for an unsaved invoice
         * @description Renders the email an invoice would be sent with, from invoice data that has not been saved (e.g. a "New invoice" form), for a live preview. Every field is optional: anything not filled in yet is shown as a placeholder — [Customer] until a customer is chosen, [Amount] until there is a currency and at least one line item with a product and a quantity (lines still missing either are left out of the total), and always [Invoice number], since none is allocated until the invoice is created. Values that are supplied are checked as on create: the customer, products and tax rates must belong to the organisation, and totals are calculated exactly as on create. Branding, template, defaults and overrides behave as they do for GET /invoices/{id}/email-preview and send. Nothing is persisted: no invoice is created, no invoice number is allocated, no payment token is minted and no email is sent.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["PreviewUnsavedInvoiceEmailRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["InvoiceEmailPreviewResponse"];
                    };
                };
                /**
                 * @description Invoice.ProductCurrencyMismatch — a line item's product is priced in a different currency than the invoice
                 *
                 *     Currency.NotFound — currency is not a supported currency
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Customer.NotFound — customer does not exist or belongs to a different organisation
                 *
                 *     Product.NotFound — a referenced product does not exist or belongs to a different organisation
                 *
                 *     TaxRate.NotFound — a referenced tax rate does not exist or belongs to a different organisation
                 *
                 *     Organisation.NotFound — the organisation does not exist or could not be resolved
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Invoice.InvalidDiscount — a discount value is negative, a percentage above 100, missing for its discount type, or supplied when there is no discount
                 *
                 *     Invoice.DiscountExceedsAmount — a fixed discount is larger than the amount it applies to
                 *
                 *     Invoice.InvalidPaymentTerms — payment terms (in days) are out of the allowed range
                 *
                 *     Invoice.InvalidCcRecipients — a CC recipient is not a valid email address
                 *
                 *     Invoice.InvalidReplyTo — the Reply-To address is not a valid email address
                 */
                422: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/invoices/pdf-preview": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Preview an unsaved invoice PDF
         * @description Renders the same PDF layout used for downloads and email attachments. All invoice fields are optional; incomplete data uses placeholders. PdfTemplate optionally previews a settings choice without saving it. No invoice, number or payment token is created.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["PreviewUnsavedInvoicePdfRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /**
                 * @description Invoice.ProductCurrencyMismatch — a line item's product is priced in a different currency than the invoice
                 *
                 *     Currency.NotFound — currency is not a supported currency
                 *
                 *     OrganisationArSettings.Invalid — an organisation AR settings value is out of its allowed range
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Customer.NotFound — customer does not exist or belongs to a different organisation
                 *
                 *     Product.NotFound — a referenced product does not exist or belongs to a different organisation
                 *
                 *     TaxRate.NotFound — a referenced tax rate does not exist or belongs to a different organisation
                 *
                 *     Invoice.NotFound — no invoice with that id for this organisation
                 *
                 *     Organisation.NotFound — the organisation does not exist or could not be resolved
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Invoice.InvalidDiscount — a discount value is negative, a percentage above 100, missing for its discount type, or supplied when there is no discount
                 *
                 *     Invoice.DiscountExceedsAmount — a fixed discount is larger than the amount it applies to
                 *
                 *     Invoice.InvalidPaymentTerms — payment terms (in days) are out of the allowed range
                 *
                 *     Invoice.InvalidCcRecipients — a CC recipient is not a valid email address
                 */
                422: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/invoices/{id}/send": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Send invoice
         * @description Deliver an invoice to the customer, issuing it first if it is still a Draft. When the organisation is registered for e-invoicing and the customer can be reached on its network, the invoice is sent over that network, and its PDF copy email goes out only once the network confirms delivery (Delivered or MadeAvailable); otherwise the PDF is emailed straight away. An invoice already on the network is never sent there twice, and sending an issued invoice again re-sends its email. Nothing is delivered from this request itself: it returns the invoice, and delivery follows. Call GET /invoices/{id}/send-plan first to see where the invoice will go and anything that stops the send; this endpoint refuses with the same problems, and a Draft stays a Draft until they are fixed. The optional request body lets the caller override individual fields of the email (Subject, PreviewText, GreetingLine, or OpeningBody Markdown) per send; any field omitted is resolved from the catalogue using the organisation's DefaultInvoiceMessageTone and industry. Reminders are scheduled when the first email goes out. The body's eInvoice and email fields choose the channels for this send: skip the network where the law allows it, email the PDF now rather than after the network's verdict, or send no email.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the invoice to send. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    "application/json": null | components["schemas"]["SendInvoiceOverrides"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["InvoiceResponse"];
                    };
                };
                /**
                 * @description Invoice.CustomerMissingEmail — the customer has no email address
                 *
                 *     Invoice.TaxRateRequiredForAccounting — a line has no tax rate, which the connected accounting platform needs on every line
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 *
                 *     Demo.OutboundBlocked — this is a demo, so nothing is sent outside Dolfin
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Invoice.NotFound — no invoice with that id for this organisation
                 *
                 *     Organisation.NotFound — the organisation does not exist or could not be resolved
                 *
                 *     Customer.NotFound — customer does not exist or belongs to a different organisation
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Invoice.CommandFailed — the invoice command was rejected by the saga (state conflict)
                 *
                 *     Invoice.NotSendable — invoice is paid, credited or void, so there is nothing to send
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Invoice.EarlyPaymentDiscountExceedsAmount — an early payment discount is a percentage above 100, or a fixed amount not less than the invoice total
                 *
                 *     Invoice.EarlyPaymentDiscountInvalid — an early payment discount needs its type, value and expiry date together (or none of them), with a non-negative value of at most 2 decimal places
                 *
                 *     Invoice.EarlyPaymentDiscountExpiryInvalid — an early payment discount's expiry date is before the issue date or after the due date
                 *
                 *     EInvoicing.CustomerNotAddressable — this customer has no e-invoicing address to deliver to
                 *
                 *     EInvoicing.DocumentInvalid — the invoice is not valid as an e-invoice
                 *
                 *     EInvoicing.TotalsMismatch — the calculated totals do not match this invoice
                 *
                 *     EInvoicing.SellerNotRegistered — this organisation is not registered to send e-invoices
                 *
                 *     EInvoicing.CountryNotSupported — e-invoicing is not available in this organisation's country yet
                 *
                 *     Invoice.InvalidCcRecipients — a CC recipient is not a valid email address
                 *
                 *     Invoice.InvalidReplyTo — the Reply-To address is not a valid email address
                 *
                 *     EInvoicing.NetworkRequired — the law makes the e-invoicing network the only channel for this invoice, so it cannot be sent by email only
                 *
                 *     EInvoicing.EmailMustWaitForNetwork — the PDF copy cannot be emailed before the network's verdict on this invoice (Italy, SDI)
                 */
                422: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description EInvoicing.ProviderUnavailable — the e-invoicing provider could not be reached */
                502: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/invoices/{invoiceId}/reminders/{reminderId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get a single invoice reminder
         * @description **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    invoiceId: string;
                    reminderId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["InvoiceReminderResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description InvoiceReminder.NotFound — reminder does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/invoices/{invoiceId}/reminders": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List reminders for an invoice
         * @description Returns all reminders (any status) for the invoice, oldest scheduled first.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    invoiceId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["InvoiceReminderResponse"][];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        /**
         * Send a payment reminder now
         * @description Immediately emails a payment reminder for the invoice — rendering the chaser copy that matches how overdue it is, or the supplied subject/message overrides — and records it. Idempotent within 60 seconds.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the invoice to send a payment reminder for. */
                    invoiceId: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    "application/json": null | components["schemas"]["SendReminderRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["InvoiceReminderResponse"];
                    };
                };
                /** @description Invoice.CustomerMissingEmail — the customer has no email address */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Demo.OutboundBlocked — this is a demo, so nothing is sent outside Dolfin
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Invoice.NotFound — no invoice with that id for this organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description InvoiceReminder.InvoiceNotRemindable — the invoice is not Issued or PartiallyPaid */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Invoice.RecipientInactive — the recipient address is suppressed at the email provider */
                422: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Invoice.EmailSendFailed — the email provider rejected the send */
                502: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/industries": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List industries
         * @description List all available industry classifications. Group is the broad MerchantCategoryGroup useful for grouping the picker UI.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token; the organisation is determined without the `x-dolfin-organisation-id` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["IndustryResponse"][];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/gmail-connections": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Gmail connections
         * @description Returns all non-revoked Gmail connections for the active organisation, newest first.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["GmailConnectionResponse"][];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        /**
         * Begin Gmail OAuth
         * @description Starts a Gmail OAuth flow (Pattern B, Dolfin-hosted redirect). Returns the Google authorization URL to send the browser to; Google redirects back to Dolfin's fixed callback, which finalises the connection and 302s to the supplied returnUrl with gmailStatus + connectionId.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["InitiateGmailConnectionRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["InitiateGmailConnectionResponse"];
                    };
                };
                /**
                 * @description Gmail.InvalidRedirectUri — returnUrl is not a valid absolute https URL
                 *
                 *     Gmail.RedirectHostNotAllowed — returnUrl host is not on the client's allowlist
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Client.GmailConnectorNotEnabled — the calling client does not have the Gmail connector enabled
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Organisation.NotFound — the organisation does not exist or could not be resolved */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Gmail.CallbackUrlNotConfigured — the environment has no Gmail OAuth callback URL configured */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/gmail-connections/{id}/candidates/{candidateId}/dismiss": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Dismiss a Gmail candidate
         * @description Marks the candidate as dismissed so it is excluded from future candidate listings.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                    candidateId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description No Content */
                204: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Gmail.CandidateNotFound — candidate does not exist on this connection or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Gmail.CandidateNotInCandidateState — candidate has already been imported, dismissed or filtered */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/gmail-connections/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get a Gmail connection
         * @description Returns a single Gmail connection scoped to the active organisation.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["GmailConnectionResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Gmail.ConnectionNotFound — connection does not exist */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        /**
         * Revoke a Gmail connection
         * @description Revokes the refresh token at Google, deletes the secret-manager entry, redacts the email address, and marks the connection Revoked. Idempotent — repeating the call on an already-revoked connection is a no-op.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        delete: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description No Content */
                204: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Gmail.ConnectionNotFound — connection does not exist */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/gmail-connections/{id}/candidates/import": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Import selected Gmail candidates
         * @description Publishes an ImportGmailCandidates message. The background consumer downloads each attachment, hands it to the Bill saga, and marks the candidate Imported.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["ImportCandidatesRequest"];
                };
            };
            responses: {
                /** @description Accepted */
                202: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ImportStartedResponse"];
                    };
                };
                /** @description Gmail.NoCandidatesSelected — candidateIds must contain at least one id */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Gmail.ConnectionNotFound — connection does not exist */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/gmail-connections/{id}/candidates": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List Gmail bill candidates
         * @description Paged list of attachments classified by the backfill consumer. Defaults to State=Candidate (review queue). Pass State=Imported/Dismissed/Failed/Filtered to see past activity, or State=All to skip filtering. Cursor follows the standard keyset pagination convention.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query: {
                    Cursor?: string;
                    PageSize: number | string;
                    State: components["schemas"]["GmailCandidateStateFilter"];
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfGmailCandidateResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Gmail.ConnectionNotFound — connection does not exist */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/gmail-connections/{id}/backfill": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Start a Gmail backfill
         * @description Publishes a StartGmailBackfill message that triggers the background consumer to list recent messages with attachments, classify candidates, and persist them for review.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["StartBackfillRequest"];
                };
            };
            responses: {
                /** @description Accepted */
                202: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BackfillStartedResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Gmail.ConnectionNotFound — connection does not exist */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Gmail.BackfillAlreadyInProgress — a backfill is already running for this connection */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/gmail-connections/{id}/sync": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Trigger a Gmail sync
         * @description Publishes a PollGmailConnection message so the background consumer walks Gmail's history since LastHistoryId (or falls back to a 24-hour catch-up window). Same pipeline runs on the 12-hour scheduler.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description Accepted */
                202: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["SyncStartedResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Gmail.ConnectionNotFound — connection does not exist */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/card-connections/enrollment-session": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Start card enrollment
         * @description Creates a short-lived session for the card provider's hosted enrollment component. Embed it in your own UI: the card details are captured by the provider, so no card number ever reaches Dolfin or your servers. Call POST /card-connections/sync once the cardholder finishes. Pass the provider the organisation chose from GET /card-providers; when omitted, Sandbox clients get a sample card and others the default provider. A sample card has no component: the response has enrollmentCompleted set, the card is already linked and its recent transactions imported.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: {
                content: {
                    "application/json": null | components["schemas"]["CreateCardEnrollmentSessionRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ConnectSessionResponse"];
                    };
                };
                /** @description Expense.CardProviderNotAvailable — when the requested card provider is not offered to this organisation (the sample provider is for Sandbox clients only) */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Service Unavailable
                 *
                 *     Expense.ProviderNotConfigured — when the card or accounting provider is not configured for this environment
                 */
                503: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/card-connections/sync": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Sync linked cards
         * @description Reconciles Dolfin's card list with the card provider. Call this after a cardholder completes enrollment — enrollment finishes in the cardholder's browser, so this is how Dolfin learns the card exists.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CardConnectionResponse"][];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Service Unavailable
                 *
                 *     Expense.ProviderNotConfigured — when the card or accounting provider is not configured for this environment
                 */
                503: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/card-providers": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List card providers
         * @description Lists the card providers this organisation can link a card through, for a "link a card" picker. A provider this environment is not yet set up for is listed with isAvailable false. Sandbox clients also get the sample provider, which links a generated card instantly.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CardProviderResponse"][];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/card-connections/{id}/simulated-transactions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Simulate a card transaction
         * @description Adds a purchase to a sample card, as if the card had just been used. It goes through the same path as real card spend: it becomes an expense, is coded, and is matched against receipts. Sample cards only — a real card's transactions come from the card network.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    "application/json": null | components["schemas"]["SimulateCardTransactionRequest"];
                };
            };
            responses: {
                /** @description Created */
                201: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CardTransactionResponse"];
                    };
                };
                /** @description Request.InvalidBody — the request body is missing, malformed, or omits a required property */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description CardConnection.NotFound — when the card connection does not exist or belongs to another organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description CardConnection.SimulationNotSupported — when transactions are simulated on a card that is not a sample card */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Service Unavailable
                 *
                 *     Expense.ProviderNotConfigured — when the card or accounting provider is not configured for this environment
                 */
                503: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/card-connections/backfill": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Import recent card history
         * @description Imports the last 30 days of transactions for the organisation's linked cards, so a newly linked card is not an empty screen until its next use. Safe to call more than once: transactions already held are recognised and skipped rather than duplicated. Pass cardConnectionId to limit the import to one card.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: {
                content: {
                    "application/json": null | components["schemas"]["BackfillCardTransactionsRequest"];
                };
            };
            responses: {
                /** @description Accepted */
                202: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CardBackfillResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description CardConnection.NotFound — when the card connection does not exist or belongs to another organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Service Unavailable
                 *
                 *     Expense.ProviderNotConfigured — when the card or accounting provider is not configured for this environment
                 */
                503: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/card-connections": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List linked cards
         * @description Lists the organisation's linked cards and the accounting accounts each one posts to.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    IncludeRemoved?: boolean;
                    /** @description Only cards held by this organisation member. */
                    HolderUserId?: string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CardConnectionResponse"][];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/card-connections/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get a linked card
         * @description Returns a single linked card and its accounting configuration.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CardConnectionResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description CardConnection.NotFound — when the card connection does not exist or belongs to another organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        /**
         * Unlink a card
         * @description Unlinks the card. Its transactions and expenses are retained — they are financial history, and removing the card does not un-spend the money.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        delete: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description No Content */
                204: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description CardConnection.NotFound — when the card connection does not exist or belongs to another organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        /**
         * Configure a linked card
         * @description Sets the card's nickname and the accounts its spend posts to. The clearing account is the credit side of every expense on this card and is required before anything can be posted; the default expense account is the fallback used when a transaction's merchant category code has no mapping.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        patch: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["UpdateCardConnectionRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CardConnectionResponse"];
                    };
                };
                /** @description CardConnection.ClearingAccountNotPayable — when the clearing account is not a bank or credit card account, so the accounting platform cannot pay card spend from it */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description CardConnection.NotFound — when the card connection does not exist or belongs to another organisation
                 *
                 *     CardConnection.LedgerAccountNotFound — when a referenced ledger account does not exist in this organisation
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        trace?: never;
    };
    "/v1/card-connections/{id}/holder": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Assign a card to a member
         * @description Makes an organisation member the card's holder. Spend captured from now on is attributed to them; spend already captured keeps its spender, except that expenses on the card with no spender yet are attributed to the new holder. Approval policies scoped to people are re-evaluated for those expenses. Needs an organisation admin.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        put: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["AssignCardHolderRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CardConnectionResponse"];
                    };
                };
                /** @description CardConnection.HolderNotInOrganisation — when the user assigned as the card's holder is not a member of this organisation */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description CardConnection.NotFound — when the card connection does not exist or belongs to another organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Conflict — another change to the same record landed first; retry the request */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        post?: never;
        /**
         * Unassign a card
         * @description Removes the card's holder, for a shared card or one whose holder has left. Spend already captured keeps its spender; new spend has none. Needs an organisation admin.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        delete: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CardConnectionResponse"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description CardConnection.NotFound — when the card connection does not exist or belongs to another organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/expenses/{id}/spender": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Set who spent an expense
         * @description Attributes one expense to an organisation member, replacing whoever it was attributed to. For spend on a shared card, or a card that changed hands. On an expense not yet posted, approval routing is re-run, since a policy may be scoped to the person; a posted expense only has its attribution updated. Needs an organisation admin.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        put: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["SetExpenseSpenderRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ExpenseResponse"];
                    };
                };
                /** @description Expense.SpenderNotInOrganisation — when the user given as the expense's spender is not a member of this organisation */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Expense.NotFound — when the expense does not exist or belongs to another organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Expense.InvalidTransition — when the requested action is not valid in the expense's current state
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/card-transactions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List card transactions
         * @description Lists card transactions received from the card network, newest first. This is the raw feed as the network reported it; for coding and posting state, use /expenses.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    Cursor?: string;
                    Limit?: number | string;
                    CardConnectionId?: string;
                    Status?: components["schemas"]["CardTransactionStatus"];
                    From?: string;
                    To?: string;
                    Mcc?: string;
                    MinAmount?: number | string;
                    MaxAmount?: number | string;
                    Search?: string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfCardTransactionResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/card-transactions/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get a card transaction
         * @description Returns a single card transaction as received from the card network.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CardTransactionResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description CardTransaction.NotFound — when the card transaction does not exist or belongs to another organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/expenses": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List expenses
         * @description Lists card spend, most recent spend first — ordered by when the card was used, not when Dolfin recorded it, so imported history sits in date order. Every card transaction becomes an expense — spend is captured whether or not a receipt is ever uploaded. Filter with flagged=true for the work queue: every expense with an open flag, including one already posted whose card amount changed afterwards, needsReceipt=true for spend still missing paperwork, merchantId for one merchant's spend, vatBlockedReason=NoSupplierVatNumber for receipts worth chasing for a proper VAT invoice, spenderUserId for one person's spend, and mine=true for the signed-in user's own.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    /** @description Opaque pagination cursor. Pass back `next` or `previous` from a previous page's cursors. */
                    Cursor?: string;
                    /** @description Page size, 1 to 100. Defaults to 20. */
                    Limit?: number | string;
                    /** @description Only expenses in this state: Captured, Coded, PendingReview (waiting for approval), Posting, Posted, Flagged or PostFailed. */
                    State?: components["schemas"]["ExpenseState"];
                    /** @description Only expenses with an open flag: Flagged ones, and posted ones flagged afterwards that nobody has resolved yet. */
                    Flagged?: boolean;
                    /** @description Only spend still missing a receipt. */
                    NeedsReceipt?: boolean;
                    /** @description Only personal spend (true) or only business spend (false). */
                    IsPersonal?: boolean;
                    /** @description Only spend on this card. */
                    CardConnectionId?: string;
                    /** @description Only expenses with a coding line on this ledger account. */
                    LedgerAccountId?: string;
                    /** @description Only spend at this merchant, however the card network spelled it. See GET /merchants. */
                    MerchantId?: string;
                    /** @description Only spend on or after this time (UTC), by when the card was used. */
                    From?: string;
                    /** @description Only spend on or before this time (UTC), by when the card was used. */
                    To?: string;
                    /** @description Only expenses with a line whose VAT can (true) or cannot (false) be reclaimed. */
                    VatReclaimable?: boolean;
                    /** @description Only expenses with a line whose VAT reclaim is blocked for this reason, e.g. NoSupplierVatNumber. */
                    VatBlockedReason?: components["schemas"]["VatReclaimBlockedReason"];
                    /** @description Only spend attributed to this organisation member. */
                    SpenderUserId?: string;
                    /** @description Only the signed-in user's own spend. Needs a user session; an API key has no 'me'. */
                    Mine?: boolean;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfExpenseResponse"];
                    };
                };
                /**
                 * @description Pagination.InvalidCursor — the cursor value is invalid
                 *
                 *     Expense.MineRequiresUser — when mine=true is used by a caller with no user identity, such as an API key
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/expenses/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get an expense
         * @description Returns an expense with its coding lines, the underlying card transaction, and how its account was chosen. When the account was learned from the organisation's history, the similar expenses that decided it are included.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the expense. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ExpenseResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Expense.NotFound — when the expense does not exist or belongs to another organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /**
         * Update an expense
         * @description Updates the memo, or marks the expense as personal. Marking personal re-codes it to the organisation's personal / director's-loan account and blocks VAT reclaim on every line — the spend still reaches the ledger, it is simply not a business expense.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        patch: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["PatchExpenseRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ExpenseResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Expense.NotFound — when the expense does not exist or belongs to another organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Expense.InvalidTransition — when the requested action is not valid in the expense's current state
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        trace?: never;
    };
    "/v1/expenses/{id}/lines": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Replace an expense's coding
         * @description Replaces the coding lines wholesale — the way to split one card transaction across several accounts or tax codes. The lines must total the card transaction amount; a split that does not reconcile is rejected rather than posted. Lines set this way are treated as human-owned and are never overwritten by an automatic re-code.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        put: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["ReplaceExpenseLinesRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ExpenseResponse"];
                    };
                };
                /** @description Expense.LinesDoNotReconcile — when the supplied coding lines do not total the card transaction amount */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Expense.NotFound — when the expense does not exist or belongs to another organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Expense.InvalidTransition — when the requested action is not valid in the expense's current state
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/expenses/{id}/attach-receipt": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Attach a receipt to an expense
         * @description Attaches an uploaded receipt to this expense and re-codes from its lines. Once the expense has been sent to the accounting platform, a receipt can still be added if it has none (it is uploaded to the entry), but an existing receipt cannot be replaced.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["AttachReceiptRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ExpenseResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Expense.NotFound — when the expense does not exist or belongs to another organisation
                 *
                 *     Receipt.NotFound — when the receipt does not exist or belongs to another organisation
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Receipt.AlreadyMatched — when the receipt is already attached to an expense
                 *
                 *     Expense.InvalidTransition — when the requested action is not valid in the expense's current state
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/expenses/{id}/receipt": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * Detach an expense's receipt
         * @description Removes the receipt from this expense. The expense stays in the ledger and falls back to coding from the merchant category code — it loses the detail, not the spend. Refused once the expense has been sent to the accounting platform: the receipt is the evidence behind that entry.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        delete: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ExpenseResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Expense.NotFound — when the expense does not exist or belongs to another organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Receipt.NotMatched — when the receipt is not attached to the expense
                 *
                 *     Expense.InvalidTransition — when the requested action is not valid in the expense's current state
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/expenses/{id}/match-candidates": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List match candidates for an expense
         * @description Returns unmatched receipts that might belong to this expense, ranked by score.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["MatchCandidateResponse"][];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Expense.NotFound — when the expense does not exist or belongs to another organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/expenses/{id}/approve": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Approve an expense for posting
         * @description Releases an expense that is waiting for review, sending it to the accounting platform. When the approval policy that sent it to review names approvers, only those members or an organisation admin may approve it; otherwise any member may.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the expense to approve. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ExpenseResponse"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Expense.NotFound — when the expense does not exist or belongs to another organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Expense.InvalidTransition — when the requested action is not valid in the expense's current state
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/expenses/{id}/retry-post": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Retry a failed post
         * @description Pushes an expense to the accounting platform again after a previous attempt was rejected. Valid only for an expense whose post failed — an expense waiting for review is released with /approve instead, and one whose card transaction has not settled yet posts on its own once the final amount arrives.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the expense whose post failed. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description Accepted */
                202: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ExpenseResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Expense.NotFound — when the expense does not exist or belongs to another organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Expense.InvalidTransition — when the requested action is not valid in the expense's current state
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/expenses/{id}/resolve-flag": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Resolve a flagged expense
         * @description Accepts a flagged expense as it stands and continues. The expense re-codes first, so a flag caused by a mapping that has since been fixed resolves itself rather than being overridden. On an expense already sent to the accounting platform, resolving its flag (an amount that changed after posting) records that the entry was amended by hand; nothing is re-posted. Accepting a PolicyViolation overrides the organisation's own approval policy, so it needs an organisation admin.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the flagged expense. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ExpenseResponse"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Expense.NotFound — when the expense does not exist or belongs to another organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Expense.InvalidTransition — when the requested action is not valid in the expense's current state
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/expenses/{id}/recode": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Re-code an expense
         * @description Re-runs coding against the current mappings, accounts and receipt. Useful after changing a merchant-category mapping or re-syncing the chart of accounts.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ExpenseResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Expense.NotFound — when the expense does not exist or belongs to another organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Expense.InvalidTransition — when the requested action is not valid in the expense's current state
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/expenses/{id}/audit-logs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List an expense's history
         * @description Returns everything that happened to this expense in order: capture, receipt matches and how each was made, flags, review, and posting attempts with the accounting platform's own responses.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ExpenseAuditLogResponse"][];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Expense.NotFound — when the expense does not exist or belongs to another organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/mcc-mappings": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List merchant category mappings
         * @description Returns the effective mapping for every known merchant category code: this organisation's own overrides, then any inherited from the platform, then Dolfin's defaults. The source field says which applied, so you can show inherited values distinctly from ones set here.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["MccMappingResponse"][];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/mcc-mappings/unmapped": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List unmapped merchant category codes
         * @description Returns merchant category codes seen on this organisation's spend that resolve to no account, with how many transactions and how much money each represents, largest first. This is the setup checklist — mapping the top few covers most spend.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["UnmappedMccResponse"][];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/mcc-mappings/{mcc}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Map a merchant category code
         * @description Maps a merchant category code to an expense account for this organisation. Expenses already waiting on this code are re-coded immediately, so mapping a code clears the backlog behind it rather than only affecting future spend.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        put: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    mcc: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["UpsertMccMappingRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["MccMappingResponse"];
                    };
                };
                /** @description MccMapping.InvalidMcc — when the merchant category code is not four digits */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description MccMapping.LedgerAccountNotFound — when a referenced ledger account does not exist in this organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        post?: never;
        /**
         * Remove a merchant category mapping
         * @description Removes this organisation's override for a merchant category code, reverting to the inherited default. Affected expenses are re-coded.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        delete: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    mcc: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description No Content */
                204: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description MccMapping.NotFound — when no mapping exists for the merchant category code */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/client/mcc-mappings": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List platform merchant category defaults
         * @description Returns the platform-level merchant category defaults that cascade to every organisation. These name an account CODE rather than an account id, because each organisation connects its own accounting platform and account ids are not shared between them.
         *
         *     **Authentication.** A JWT Bearer token for a client administrator (Admin or Owner). Dolfin staff may instead use an admin API key with the `x-dolfin-client-id` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ClientMccMappingResponse"][];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/client/mcc-mappings/{mcc}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Set a platform merchant category default
         * @description Sets a platform-level default mapping a merchant category code to an account code. Applied to any organisation whose chart of accounts contains that code and which has not set its own override; organisations without the code fall through to their card's default account.
         *
         *     **Authentication.** A JWT Bearer token for a client administrator (Admin or Owner). Dolfin staff may instead use an admin API key with the `x-dolfin-client-id` header.
         */
        put: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path: {
                    mcc: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["UpsertClientMccMappingRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ClientMccMappingResponse"];
                    };
                };
                /** @description MccMapping.InvalidMcc — when the merchant category code is not four digits */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Member.Forbidden — caller is not an Admin or Owner of this Client
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        post?: never;
        /**
         * Remove a platform merchant category default
         * @description Removes a platform-level default. Organisations fall back to Dolfin's defaults.
         *
         *     **Authentication.** A JWT Bearer token for a client administrator (Admin or Owner). Dolfin staff may instead use an admin API key with the `x-dolfin-client-id` header.
         */
        delete: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path: {
                    mcc: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description No Content */
                204: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Member.Forbidden — caller is not an Admin or Owner of this Client
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description MccMapping.NotFound — when no mapping exists for the merchant category code */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/merchants": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List merchants
         * @description Lists the merchants the organisation's cards have been used at, most recently used first, with how much was spent at each and how many expenses that was. A merchant groups every way the card networks spelled it ("SUMUP *BLUE ANCHOR" and "ZETTLE_*BLUEANC" are one merchant). Search with q, which matches the name or any spelling.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    Cursor?: string;
                    Limit?: number | string;
                    /** @description Search the merchant's name and every spelling of it, case-insensitively. */
                    Q?: string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfMerchantResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/merchants/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get a merchant
         * @description Returns a merchant with its spend and every spelling of it the organisation has seen, including which spellings were recognised automatically as the same merchant. List its expenses with GET /expenses?merchantId={id}.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["MerchantDetailResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Expense.MerchantNotFound — when the merchant does not exist or belongs to another organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/receipts": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List receipts
         * @description Lists uploaded receipts, newest first. Filter with matchStatus=Unmatched for the receipt inbox — receipts still waiting to be paired with a card transaction.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    Cursor?: string;
                    Limit?: number | string;
                    MatchStatus?: components["schemas"]["ReceiptMatchStatus"];
                    ExtractionStatus?: components["schemas"]["ReceiptExtractionStatus"];
                    MissingVatNumber?: boolean;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfReceiptResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        /**
         * Upload a receipt
         * @description Uploads a receipt as a PDF or a JPEG, PNG, WebP or HEIC image. A HEIC/HEIF photo (the iPhone camera default) is converted to JPEG on upload, so the stored receipt's contentType and fileName describe the JPEG. Extraction runs asynchronously; once it completes, Dolfin automatically looks for a matching card transaction. A receipt uploaded before its transaction arrives waits in the inbox and is matched when the transaction lands.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "multipart/form-data": {
                        file?: components["schemas"]["IFormFile"];
                    };
                };
            };
            responses: {
                /** @description Accepted */
                202: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ReceiptResponse"];
                    };
                };
                /**
                 * @description Receipt.FileRequired — when no file was supplied on the upload
                 *
                 *     Receipt.FileTooLarge — uploaded file exceeds the 20 MB maximum
                 *
                 *     Receipt.UnsupportedFileType — only PDF and image uploads are supported
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Demo.LimitReached — the demo has reached its limit of documents of this kind; reset it to start again
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/receipts/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get a receipt
         * @description Returns a receipt with its extracted header fields and lines.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ReceiptResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Receipt.NotFound — when the receipt does not exist or belongs to another organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        /**
         * Delete a receipt
         * @description Deletes an unmatched receipt. A receipt attached to an expense that has been sent to the accounting platform cannot be deleted — it is the evidence behind a ledger entry and VAT records must be retained.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        delete: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description No Content */
                204: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Receipt.NotFound — when the receipt does not exist or belongs to another organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Receipt.AlreadyMatched — when the receipt is already attached to an expense */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/receipts/{id}/file-url": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get a receipt file URL
         * @description Returns a short-lived signed URL for the original receipt file.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ReceiptFileUrlResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Receipt.NotFound — when the receipt does not exist or belongs to another organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/receipts/{id}/retry-extraction": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Retry receipt extraction
         * @description Re-runs field extraction over a receipt whose first attempt failed or read badly.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description Accepted */
                202: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ReceiptResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Receipt.NotFound — when the receipt does not exist or belongs to another organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/receipts/{id}/match-candidates": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List match candidates for a receipt
         * @description Returns card transactions this receipt might belong to, ranked by score. These are exactly the candidates the automatic matcher considered, so a receipt that was not matched automatically shows here with the reason visible in the scores.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["MatchCandidateResponse"][];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Receipt.NotFound — when the receipt does not exist or belongs to another organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/receipts/{id}/match": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Match a receipt to an expense
         * @description Attaches a receipt to an expense by hand. The expense re-codes from the receipt's lines, so its VAT position and account split follow the receipt rather than the merchant category default.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["MatchReceiptRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ReceiptResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Receipt.NotFound — when the receipt does not exist or belongs to another organisation
                 *
                 *     Expense.NotFound — when the expense does not exist or belongs to another organisation
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Receipt.AlreadyMatched — when the receipt is already attached to an expense
                 *
                 *     Expense.InvalidTransition — when the requested action is not valid in the expense's current state
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/expenses/aggregate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Aggregate expenses
         * @description Totals the card spend a plain-language search matches. The query is read exactly as by the search endpoint, and the totals cover every match rather than a top page: a count, net totals per billing currency (refunds netted, pending amounts shown), the date range, an optional breakdown by merchant, month, ledger account or spender, and the ten largest expenses. Voided transactions are excluded and personal spend is reported separately. Amounts are never summed across currencies. The response says how the set was matched (by meaning, by name, or both) and sets `capped` when a matching signal reached its candidate limit, so the total may be incomplete.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    /** @description What to total, in plain language, read exactly as search reads it: "software", "taxis over €50 last month", "client lunches this quarter". Dates, amounts and currency become exact filters; the rest is matched by meaning and by merchant name. */
                    Q?: string;
                    /** @description Earliest spend date included (yyyy-MM-dd). Replaces any start date read from the query. */
                    From?: string;
                    /** @description Latest spend date included (yyyy-MM-dd). Replaces any end date read from the query. */
                    To?: string;
                    /** @description Break the totals down by Merchant, Month, LedgerAccount or Spender. Omit for totals only. */
                    GroupBy?: components["schemas"]["ExpenseAggregateGroupBy"];
                    /** @description Only the signed-in user's own spend. Needs a user session; an API key has no 'me'. */
                    Mine?: boolean;
                    /** @description Only spend attributed to this organisation member. Combined with mine=true, only when it is the signed-in user. */
                    SpenderUserId?: string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ExpenseAggregateResponse"];
                    };
                };
                /**
                 * @description Expense.SearchQueryRequired — when the search query is missing or blank
                 *
                 *     Expense.InvalidDateRange — when `from` is after `to`
                 *
                 *     Expense.MineRequiresUser — when mine=true is used by a caller with no user identity, such as an API key
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/expenses/search": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Search expenses
         * @description Searches card spend with a plain-language query and returns the best matches first. Dates, amounts, currency and "without a receipt" are read out of the query and applied as exact filters; what remains is matched by meaning against the merchant, the receipt's line items and the memo, and by name against the merchant, the card descriptor and the memo. The response says how the query was read, so a caller can show the filters that were applied. Not paginated: it returns the top matches.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    /** @description What to look for, in plain language: "client lunches", "taxis over €50 last month", "software subscriptions without a receipt". Dates, amounts and currency in the query become exact filters; the rest is matched by meaning against the merchant, receipt lines and memo. */
                    Q?: string;
                    /** @description Maximum number of results. Default 20, clamped to 1–50. */
                    Limit?: number | string;
                    /** @description Only the signed-in user's own spend. Needs a user session; an API key has no 'me'. */
                    Mine?: boolean;
                    /** @description Only spend attributed to this organisation member. Combined with mine=true, only when it is the signed-in user. */
                    SpenderUserId?: string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ExpenseSearchResponse"];
                    };
                };
                /**
                 * @description Expense.SearchQueryRequired — when the search query is missing or blank
                 *
                 *     Expense.MineRequiresUser — when mine=true is used by a caller with no user identity, such as an API key
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/expenses/reports/spend": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Expense spend report
         * @description Card spend over a period, in each card's billing currency: net totals, a time series, the change against the previous period of the same length, and breakdowns by merchant category family and label, top merchants (flagging those first used in the period), spender, card, and domestic versus foreign merchants. Voided and declined transactions are excluded, refunds are netted on their own date, and personal spend is reported separately. Amounts are never summed across currencies.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    /** @description The window to report on, ending today (UTC). Default Last30Days. Bucket granularity follows from it: daily for Last7Days and MonthToDate, weekly for Last30Days, Last90Days and QuarterToDate, monthly for Last12Months and YearToDate. */
                    Period?: components["schemas"]["LookbackPeriod"];
                    /** @description ISO 4217 code of the primary currency, which orders rows and drives single-currency figures. Defaults to the organisation's default currency. Rows in every currency are returned regardless. */
                    Currency?: string;
                    /** @description Only the signed-in user's own spend. Needs a user session; an API key has no 'me'. */
                    Mine?: boolean;
                    /** @description Only spend attributed to this organisation member. Combined with mine=true, only when it is the signed-in user. */
                    SpenderUserId?: string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ExpenseSpendReport"];
                    };
                };
                /** @description Expense.MineRequiresUser — when mine=true is used by a caller with no user identity, such as an API key */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/expenses/reports/compliance": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Expense compliance report
         * @description What stands between card spend and a closed month. For the period: receipt coverage, expenses with no receipt by value, age and spender, how many receipts were matched automatically, expenses in each state, open flags by reason, and how expenses were coded. Plus posting progress for the previous calendar month, whatever the period.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    /** @description The window to report on, ending today (UTC). Default Last30Days. Bucket granularity follows from it: daily for Last7Days and MonthToDate, weekly for Last30Days, Last90Days and QuarterToDate, monthly for Last12Months and YearToDate. */
                    Period?: components["schemas"]["LookbackPeriod"];
                    /** @description ISO 4217 code of the primary currency, which orders rows and drives single-currency figures. Defaults to the organisation's default currency. Rows in every currency are returned regardless. */
                    Currency?: string;
                    /** @description Only the signed-in user's own spend. Needs a user session; an API key has no 'me'. */
                    Mine?: boolean;
                    /** @description Only spend attributed to this organisation member. Combined with mine=true, only when it is the signed-in user. */
                    SpenderUserId?: string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ExpenseComplianceReport"];
                    };
                };
                /** @description Expense.MineRequiresUser — when mine=true is used by a caller with no user identity, such as an API key */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/expenses/reports/vat": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Expense VAT report
         * @description VAT on card spend over a period, in each card's billing currency: the VAT that can be reclaimed, the spend whose VAT cannot be reclaimed grouped by reason, and an estimate of the VAT lost to missing receipts at the organisation's standard rate. The estimate is omitted for a country Dolfin has no standard rate for.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    /** @description The window to report on, ending today (UTC). Default Last30Days. Bucket granularity follows from it: daily for Last7Days and MonthToDate, weekly for Last30Days, Last90Days and QuarterToDate, monthly for Last12Months and YearToDate. */
                    Period?: components["schemas"]["LookbackPeriod"];
                    /** @description ISO 4217 code of the primary currency, which orders rows and drives single-currency figures. Defaults to the organisation's default currency. Rows in every currency are returned regardless. */
                    Currency?: string;
                    /** @description Only the signed-in user's own spend. Needs a user session; an API key has no 'me'. */
                    Mine?: boolean;
                    /** @description Only spend attributed to this organisation member. Combined with mine=true, only when it is the signed-in user. */
                    SpenderUserId?: string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ExpenseVatReport"];
                    };
                };
                /** @description Expense.MineRequiresUser — when mine=true is used by a caller with no user identity, such as an API key */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/expenses/reports/approvals": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Expense approval report
         * @description How approval of card spend is going. The current approval queue by approver with the oldest wait; and for the period, what decided whether each expense needed approval, how long approvals took (median, mean and 90th percentile), how often each approval policy matched, and who has the most policy violations.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    /** @description The window to report on, ending today (UTC). Default Last30Days. Bucket granularity follows from it: daily for Last7Days and MonthToDate, weekly for Last30Days, Last90Days and QuarterToDate, monthly for Last12Months and YearToDate. */
                    Period?: components["schemas"]["LookbackPeriod"];
                    /** @description ISO 4217 code of the primary currency, which orders rows and drives single-currency figures. Defaults to the organisation's default currency. Rows in every currency are returned regardless. */
                    Currency?: string;
                    /** @description Only the signed-in user's own spend. Needs a user session; an API key has no 'me'. */
                    Mine?: boolean;
                    /** @description Only spend attributed to this organisation member. Combined with mine=true, only when it is the signed-in user. */
                    SpenderUserId?: string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ExpenseApprovalReport"];
                    };
                };
                /** @description Expense.MineRequiresUser — when mine=true is used by a caller with no user identity, such as an API key */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/expenses/summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Expense summary
         * @description A one-call briefing on card spend: totals and the trend per currency for the period, and the work waiting on someone now: expenses waiting for approval (marking those the caller can approve), open flags by reason, posts the accounting platform refused, and business spend in the period still missing a receipt. Each queue gives its count and its five longest-waiting expenses, org-wide whatever the period. Amounts are in each card's billing currency and never summed across currencies.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    /** @description The window spend and missing receipts cover, ending on asOf. Default MonthToDate. The approval, flag and post-failure queues are the current backlog whatever the period. */
                    Period?: components["schemas"]["LookbackPeriod"];
                    /** @description ISO 4217 code of the primary currency, which orders rows. Defaults to the organisation's default currency. Rows in every currency are returned regardless. */
                    Currency?: string;
                    /** @description Only the signed-in user's own spend and queued expenses. Needs a user session; an API key has no 'me'. */
                    Mine?: boolean;
                    /** @description Only spend and queued expenses attributed to this organisation member. Combined with mine=true, only when it is the signed-in user. */
                    SpenderUserId?: string;
                    /** @description Optional ISO date (yyyy-MM-dd) the period ends on and waiting days are counted to. Defaults to today (UTC). */
                    asOf?: string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ExpenseSummaryResponse"];
                    };
                };
                /** @description Expense.MineRequiresUser — when mine=true is used by a caller with no user identity, such as an API key */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/expenses/policy-documents": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List expense policy documents
         * @description Lists every uploaded version of the organisation's expense policy, newest first.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ExpensePolicyDocumentResponse"][];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        /**
         * Upload an expense policy document
         * @description Uploads the organisation's expense policy as a PDF, plain text or Word (.docx) file, as the `file` form field. Its text is read immediately; a scanned PDF with no text layer is refused. The policy is then compiled in the background into proposed approval policies, each citing the clause it enforces. Nothing applies until an organisation admin confirms the document. Each upload is a new version, numbered from 1.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "multipart/form-data": {
                        file?: components["schemas"]["IFormFile"];
                    };
                };
            };
            responses: {
                /** @description Accepted */
                202: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ExpensePolicyDocumentResponse"];
                    };
                };
                /**
                 * @description ExpensePolicyDocument.FileRequired — a policy document file is required
                 *
                 *     ExpensePolicyDocument.FileTooLarge — the policy document is larger than 2 MB
                 *
                 *     ExpensePolicyDocument.UnsupportedFileType — only PDF, plain text and Word (.docx) documents are supported
                 *
                 *     ExpensePolicyDocument.LegacyWordFormat — legacy .doc files are not supported; save the document as .docx or PDF
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description ExpensePolicyDocument.NoText — the document contains no readable text (a scanned PDF needs a text layer)
                 *
                 *     ExpensePolicyDocument.TextTooLong — the document's text is longer than 200,000 characters
                 */
                422: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/expenses/policy-documents/upload-url": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Get an upload URL for an expense policy document
         * @description Step 1 of 2 for uploading a policy document without multipart: returns a short-lived signed URL to send the file's bytes to. Then call POST /expenses/policy-documents/from-upload with the returned objectName.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["CreateExpensePolicyDocumentUploadUrlRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ExpensePolicyDocumentUploadUrlResponse"];
                    };
                };
                /**
                 * @description ExpensePolicyDocument.FileNameRequired — a file name is required
                 *
                 *     ExpensePolicyDocument.UnsupportedFileType — only PDF, plain text and Word (.docx) documents are supported
                 *
                 *     ExpensePolicyDocument.LegacyWordFormat — legacy .doc files are not supported; save the document as .docx or PDF
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/expenses/policy-documents/from-upload": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Finalise an expense policy document upload
         * @description Step 2 of 2: creates the policy document from a file sent to a signed upload URL. Behaves exactly like the multipart upload from here on.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["FinaliseExpensePolicyDocumentUploadRequest"];
                };
            };
            responses: {
                /** @description Accepted */
                202: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ExpensePolicyDocumentResponse"];
                    };
                };
                /**
                 * @description ExpensePolicyDocument.FileTooLarge — the policy document is larger than 2 MB
                 *
                 *     ExpensePolicyDocument.UnsupportedFileType — only PDF, plain text and Word (.docx) documents are supported
                 *
                 *     ExpensePolicyDocument.LegacyWordFormat — legacy .doc files are not supported; save the document as .docx or PDF
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description ExpensePolicyDocument.UploadNotFound — no uploaded file was found for that upload reference */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description ExpensePolicyDocument.NoText — the document contains no readable text (a scanned PDF needs a text layer)
                 *
                 *     ExpensePolicyDocument.TextTooLong — the document's text is longer than 200,000 characters
                 */
                422: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/expenses/policy-documents/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get an expense policy document
         * @description Fetches a policy document with its proposed approval policies, each compared with the current policies (Added, Changed or Unchanged), the current policies confirming would delete, and the clauses that cannot be enforced automatically.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the expense policy document. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ExpensePolicyDocumentResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description ExpensePolicyDocument.NotFound — policy document does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/expenses/policy-documents/{id}/retry": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Retry compiling an expense policy document
         * @description Compiles a policy document again after a failure. Only valid when its status is Failed.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description Accepted */
                202: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ExpensePolicyDocumentResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description ExpensePolicyDocument.NotFound — policy document does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description ExpensePolicyDocument.NotRetryable — only a failed policy document can be compiled again */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/expenses/policy-documents/{id}/confirm": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Confirm an expense policy document
         * @description Makes the document's proposed policies, as edited by the reviewer, the organisation's document-sourced approval policies. A proposal with the same name as a current document-sourced policy updates it and raises its version; current document-sourced policies left out are deleted; policies created by hand are never touched. Earlier document versions become Superseded. Only the latest version, while it is waiting for review, can be confirmed.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    "application/json": null | components["schemas"]["ConfirmExpensePolicyDocumentRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ExpensePolicyDocumentResponse"];
                    };
                };
                /**
                 * @description ExpenseApprovalPolicy.NameRequired — a policy name of at most 120 characters is required
                 *
                 *     ExpenseApprovalPolicy.InvalidPriorityOrder — priority order must be between 0 and 1000
                 *
                 *     ExpenseApprovalPolicy.InvalidAmountRange — the lower amount bound must not exceed the upper bound
                 *
                 *     ExpenseApprovalPolicy.CurrencyRequired — a currency is required when an amount condition is set
                 *
                 *     ExpenseApprovalPolicy.InvalidMcc — a merchant category code is not four digits
                 *
                 *     ExpenseApprovalPolicy.TooManyConditions — a condition list holds more than the maximum number of entries
                 *
                 *     ExpenseApprovalPolicy.TooManyApprovers — more than the maximum number of approvers were supplied
                 *
                 *     ExpenseApprovalPolicy.ApproverNotInOrganisation — a supplied approver is not a member of this organisation
                 *
                 *     ExpenseApprovalPolicy.MerchantNotInOrganisation — a supplied merchant does not belong to this organisation
                 *
                 *     ExpenseApprovalPolicy.CardNotInOrganisation — a supplied card connection does not belong to this organisation
                 *
                 *     ExpenseApprovalPolicy.SpenderNotInOrganisation — a supplied spender is not a member of this organisation
                 *
                 *     ExpenseApprovalPolicy.LimitReached — the per-organisation expense approval policy limit has been reached
                 *
                 *     Currency.NotFoundByCode — the specified currency is not supported
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description ExpensePolicyDocument.NotFound — policy document does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description ExpensePolicyDocument.NotReadyForReview — the policy document is not waiting for review
                 *
                 *     ExpensePolicyDocument.NotLatestVersion — a newer version of the policy document has been uploaded
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/expenses/approval-policies": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List expense approval policies
         * @description Lists the organisation's expense approval policies, active and inactive, in priority order (lowest number first). When an expense's amount is final, the highest-priority matching policy decides whether it posts automatically, waits for approval, or is flagged as a policy violation.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ExpenseApprovalPolicyResponse"][];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        /**
         * Create expense approval policy
         * @description Creates an expense approval policy at version 1. It applies to every expense routed after it is created; expenses already waiting for review or flagged are re-evaluated the next time they change.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["UpsertExpenseApprovalPolicyRequest"];
                };
            };
            responses: {
                /** @description Created */
                201: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ExpenseApprovalPolicyResponse"];
                    };
                };
                /**
                 * @description ExpenseApprovalPolicy.NameRequired — a policy name of at most 120 characters is required
                 *
                 *     ExpenseApprovalPolicy.InvalidPriorityOrder — priority order must be between 0 and 1000
                 *
                 *     ExpenseApprovalPolicy.InvalidAmountRange — the lower amount bound must not exceed the upper bound
                 *
                 *     ExpenseApprovalPolicy.CurrencyRequired — a currency is required when an amount condition is set
                 *
                 *     ExpenseApprovalPolicy.InvalidMcc — a merchant category code is not four digits
                 *
                 *     ExpenseApprovalPolicy.TooManyConditions — a condition list holds more than the maximum number of entries
                 *
                 *     ExpenseApprovalPolicy.TooManyApprovers — more than the maximum number of approvers were supplied
                 *
                 *     ExpenseApprovalPolicy.ApproverNotInOrganisation — a supplied approver is not a member of this organisation
                 *
                 *     ExpenseApprovalPolicy.MerchantNotInOrganisation — a supplied merchant does not belong to this organisation
                 *
                 *     ExpenseApprovalPolicy.CardNotInOrganisation — a supplied card connection does not belong to this organisation
                 *
                 *     ExpenseApprovalPolicy.SpenderNotInOrganisation — a supplied spender is not a member of this organisation
                 *
                 *     ExpenseApprovalPolicy.LimitReached — the per-organisation expense approval policy limit has been reached
                 *
                 *     Currency.NotFoundByCode — the specified currency is not supported
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/expenses/approval-policies/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get expense approval policy
         * @description Fetches a single expense approval policy, including its revision number.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the expense approval policy. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ExpenseApprovalPolicyResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description ExpenseApprovalPolicy.NotFound — expense approval policy does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        /**
         * Update expense approval policy
         * @description Replaces an expense approval policy's configuration and increments its version. Expenses already posted keep the decision they were posted under; expenses still open are re-evaluated the next time they change.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        put: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["UpsertExpenseApprovalPolicyRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ExpenseApprovalPolicyResponse"];
                    };
                };
                /**
                 * @description ExpenseApprovalPolicy.NameRequired — a policy name of at most 120 characters is required
                 *
                 *     ExpenseApprovalPolicy.InvalidPriorityOrder — priority order must be between 0 and 1000
                 *
                 *     ExpenseApprovalPolicy.InvalidAmountRange — the lower amount bound must not exceed the upper bound
                 *
                 *     ExpenseApprovalPolicy.CurrencyRequired — a currency is required when an amount condition is set
                 *
                 *     ExpenseApprovalPolicy.InvalidMcc — a merchant category code is not four digits
                 *
                 *     ExpenseApprovalPolicy.TooManyConditions — a condition list holds more than the maximum number of entries
                 *
                 *     ExpenseApprovalPolicy.TooManyApprovers — more than the maximum number of approvers were supplied
                 *
                 *     ExpenseApprovalPolicy.ApproverNotInOrganisation — a supplied approver is not a member of this organisation
                 *
                 *     ExpenseApprovalPolicy.MerchantNotInOrganisation — a supplied merchant does not belong to this organisation
                 *
                 *     ExpenseApprovalPolicy.CardNotInOrganisation — a supplied card connection does not belong to this organisation
                 *
                 *     ExpenseApprovalPolicy.SpenderNotInOrganisation — a supplied spender is not a member of this organisation
                 *
                 *     Currency.NotFoundByCode — the specified currency is not supported
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description ExpenseApprovalPolicy.NotFound — expense approval policy does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        post?: never;
        /**
         * Delete expense approval policy
         * @description Deletes an expense approval policy. Expenses it was applied to keep a record of the decision, including the policy's name and version.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        delete: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description No Content */
                204: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description ExpenseApprovalPolicy.NotFound — expense approval policy does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/e-invoicing": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get e-invoicing status
         * @description Retrieve the organisation's e-invoicing registration status, its assigned network address once registered, and any outstanding actions. Returns a status of NotStarted, together with details prefilled from the organisation, when no registration has been submitted.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["EInvoicingRegistrationResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Organisation.NotFound — the organisation does not exist or could not be resolved */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/received-e-invoices/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get a received e-invoice
         * @description One electronic invoice received for this organisation, with the bill or supplier credit note it became, or the reason it became neither. Its faults list is where anything the document asserted that a bill cannot fully hold is recorded — a part payment, a document-level discount, bank details differing from the supplier on file. Those are not errors and do not stop the bill being reviewed and approved normally.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description The e-invoice id. A bill ingested from the network carries it as eInvoiceId. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["OrganisationEInvoiceResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description EInvoicing.ReceivedEInvoiceNotFound — no e-invoice with this id was received for this organisation
                 *
                 *     Organisation.NotFound — the organisation does not exist or could not be resolved
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/received-e-invoices": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List received e-invoices
         * @description Electronic invoices received for this organisation over an e-invoicing network, newest first. Keyset-paginated: follow meta.cursors.next for the next page. Each carries the bill it became, or the reason it could not become one. A document is listed here whether or not it produced a bill, so an invoice a sender insists they transmitted can be accounted for. Filter by networkReference to find a document by the id the network gave it (for SDI, the IdentificativoSdI).
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    /** @description Opaque pagination cursor. Pass back `next` or `previous` from a previous page's cursors. */
                    cursor?: string;
                    /** @description Page size, 1 to 200. Defaults to 50. */
                    limit?: number | string;
                    /** @description The id the e-invoicing network gave the document (for SDI, the IdentificativoSdI). Returns only the document with that reference. */
                    networkReference?: string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfOrganisationEInvoiceResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Organisation.NotFound — the organisation does not exist or could not be resolved */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/e-invoicing/registration": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Register for e-invoicing
         * @description Submit the organisation for registration as an e-invoicing participant. Every field is optional and defaults to the organisation's own details; supply a value only to override it for this registration. Returns 202 with the registration in the ActionRequired state — registration completes once the proof-of-ownership document has been uploaded.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: {
                content: {
                    "application/json": null | components["schemas"]["SubmitEInvoicingRegistrationRequest"];
                };
            };
            responses: {
                /** @description Accepted */
                202: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["EInvoicingRegistrationResponse"];
                    };
                };
                /**
                 * @description EInvoicing.MissingLegalName — a registered legal name is required to register for e-invoicing
                 *
                 *     EInvoicing.MissingTaxNumber — a tax number is required to register for e-invoicing
                 *
                 *     EInvoicing.MissingAddress — a complete registered address is required to register for e-invoicing
                 *
                 *     EInvoicing.MissingContactEmail — a contact email is required to register for e-invoicing
                 *
                 *     EInvoicing.InvalidCountry — country code is not a valid ISO 3166-1 alpha-2 code
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Organisation.NotFound — the organisation does not exist or could not be resolved */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description EInvoicing.AlreadyRegistered — this organisation is already registered for e-invoicing
                 *
                 *     EInvoicing.RegistrationInProgress — a registration is already in progress for this organisation
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description EInvoicing.CountryNotSupported — e-invoicing is not available in this organisation's country yet
                 *
                 *     EInvoicing.ProviderRejected — the e-invoicing provider rejected the document
                 */
                422: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description EInvoicing.ProviderUnavailable — the e-invoicing provider could not be reached */
                502: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Service Unavailable
                 *
                 *     EInvoicing.NotConfigured — e-invoicing is not configured for this environment
                 */
                503: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        /**
         * Unregister from e-invoicing
         * @description Withdraw the organisation from its e-invoicing network. It stops receiving documents, its network address is released, and its tax number and country can be edited again. Returns 202 with the registration in the Unregistering state; it moves to Unregistered when the network confirms, or back to Registered with faults if the network refuses. An unregistered organisation can register again.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        delete: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description Accepted */
                202: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["EInvoicingRegistrationResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description EInvoicing.RegistrationNotFound — this organisation has no e-invoicing registration */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description EInvoicing.NotRegistered — this organisation is not registered for e-invoicing, so there is nothing to withdraw
                 *
                 *     EInvoicing.UnregistrationInProgress — a withdrawal from e-invoicing is already in progress for this organisation
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description EInvoicing.CountryNotSupported — e-invoicing is not available in this organisation's country yet
                 *
                 *     EInvoicing.UnregisterNotSupported — withdrawing from e-invoicing is not available in this organisation's country yet
                 *
                 *     EInvoicing.ProviderRejected — the e-invoicing provider rejected the document
                 */
                422: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description EInvoicing.ProviderUnavailable — the e-invoicing provider could not be reached */
                502: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Service Unavailable
                 *
                 *     EInvoicing.NotConfigured — e-invoicing is not configured for this environment
                 */
                503: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/e-invoicing/registration/documents": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Upload proof of ownership
         * @description Upload a signed proof-of-ownership PDF to satisfy the proof_of_ownership_required action and complete registration. The provider verifies the document and finishes the registration; the organisation's status moves to Processing, then Registered.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "multipart/form-data": {
                        file?: components["schemas"]["IFormFile"];
                    };
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["EInvoicingRegistrationResponse"];
                    };
                };
                /**
                 * @description EInvoicing.MissingDocument — no document was supplied in the upload
                 *
                 *     EInvoicing.UnsupportedDocumentType — only PDF documents are accepted for proof of ownership
                 *
                 *     EInvoicing.DocumentTooLarge — the uploaded document exceeds the maximum allowed size
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description EInvoicing.RegistrationNotFound — this organisation has no e-invoicing registration */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description EInvoicing.DocumentNotExpected — this registration is not waiting for a document upload
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description EInvoicing.CountryNotSupported — e-invoicing is not available in this organisation's country yet
                 *
                 *     EInvoicing.ProviderRejected — the e-invoicing provider rejected the document
                 */
                422: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description EInvoicing.ProviderUnavailable — the e-invoicing provider could not be reached */
                502: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Service Unavailable
                 *
                 *     EInvoicing.NotConfigured — e-invoicing is not configured for this environment
                 */
                503: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/invoices/{invoiceId}/credit-notes/{creditNoteId}/e-invoice/send": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Send a credit note as an e-invoice
         * @description Sends an issued credit note over the same e-invoicing network as the invoice it credits (in Italy, as a TD04 through SDI). This normally happens automatically; use this when the automatic send was refused - for example the customer's routing code was missing - and the data has since been corrected. The invoice's own e-invoice must have been delivered (or made available). Sending a credit note that is already on its way answers with its delivery; one already delivered is refused.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the invoice the credit note credits. */
                    invoiceId: string;
                    /** @description Id of the credit note. */
                    creditNoteId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["OutboundEInvoiceView"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 *
                 *     Demo.OutboundBlocked — this is a demo, so nothing is sent outside Dolfin
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description CreditNote.NotFound — no credit note with that id on this invoice for this organisation
                 *
                 *     Organisation.NotFound — the organisation does not exist or could not be resolved
                 *
                 *     Customer.NotFound — customer does not exist or belongs to a different organisation
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description EInvoicing.CreditNoteNotSendable — a credit note is sent as an e-invoice only once it is issued and its invoice's e-invoice was delivered
                 *
                 *     EInvoicing.AlreadyDelivered — this invoice has already been sent as an e-invoice
                 *
                 *     EInvoicing.DeliveryNotRetryable — this delivery cannot be retried; the document itself was refused
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description EInvoicing.CountryNotSupported — e-invoicing is not available in this organisation's country yet
                 *
                 *     EInvoicing.SellerNotRegistered — this organisation is not registered to send e-invoices
                 *
                 *     EInvoicing.CustomerNotAddressable — this customer has no e-invoicing address to deliver to
                 *
                 *     EInvoicing.DocumentInvalid — the invoice is not valid as an e-invoice
                 *
                 *     EInvoicing.TotalsMismatch — the calculated totals do not match this invoice
                 *
                 *     EInvoicing.ProviderRejected — the e-invoicing provider rejected the document
                 */
                422: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description EInvoicing.ProviderUnavailable — the e-invoicing provider could not be reached */
                502: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Service Unavailable
                 *
                 *     EInvoicing.SendNotConfigured — sending e-invoices is not configured for this organisation's country
                 */
                503: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/invoices/{invoiceId}/credit-notes/{creditNoteId}/e-invoice": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get a credit note's e-invoice delivery
         * @description Reports whether a credit note was sent electronically and how that went. A credit note is sent automatically, over the same network, when the invoice it credits was delivered as an e-invoice - on issue, or once that invoice's delivery is confirmed if it was still awaiting the network's verdict. Not found means it has not been sent: the invoice was never e-invoiced, or its e-invoice has not been confirmed yet.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the invoice the credit note credits. */
                    invoiceId: string;
                    /** @description Id of the credit note. */
                    creditNoteId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["OutboundEInvoiceView"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description EInvoicing.DeliveryNotFound — this invoice has not been sent as an e-invoice */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Conflict — another change to the same record landed first; retry the request */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/invoices/{invoiceId}/credit-notes/{creditNoteId}/e-invoice/resend": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Resend a credit note's e-invoice
         * @description Sends a credit note's failed or abandoned electronic delivery again, or sends it for the first time when its automatic send was refused. When nothing reached the network the document is rebuilt from the current customer and organisation details, so correct those first. When the recipient may already hold the document, the same document is sent again instead. A document the network refused is not sent again unchanged.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the invoice the credit note credits. */
                    invoiceId: string;
                    /** @description Id of the credit note. */
                    creditNoteId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["OutboundEInvoiceView"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 *
                 *     Demo.OutboundBlocked — this is a demo, so nothing is sent outside Dolfin
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description CreditNote.NotFound — no credit note with that id on this invoice for this organisation
                 *
                 *     Organisation.NotFound — the organisation does not exist or could not be resolved
                 *
                 *     Customer.NotFound — customer does not exist or belongs to a different organisation
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description EInvoicing.CreditNoteNotSendable — a credit note is sent as an e-invoice only once it is issued and its invoice's e-invoice was delivered
                 *
                 *     EInvoicing.DeliveryNotResendable — this delivery cannot be sent again: it is in flight or delivered, or the network refused a document that has not changed since
                 *
                 *     EInvoicing.DeliveryNotRetryable — this delivery cannot be retried; the document itself was refused
                 *
                 *     EInvoicing.AlreadyDelivered — this invoice has already been sent as an e-invoice
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description EInvoicing.CountryNotSupported — e-invoicing is not available in this organisation's country yet
                 *
                 *     EInvoicing.SellerNotRegistered — this organisation is not registered to send e-invoices
                 *
                 *     EInvoicing.CustomerNotAddressable — this customer has no e-invoicing address to deliver to
                 *
                 *     EInvoicing.DocumentInvalid — the invoice is not valid as an e-invoice
                 *
                 *     EInvoicing.TotalsMismatch — the calculated totals do not match this invoice
                 *
                 *     EInvoicing.ProviderRejected — the e-invoicing provider rejected the document
                 */
                422: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description EInvoicing.ProviderUnavailable — the e-invoicing provider could not be reached */
                502: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Service Unavailable
                 *
                 *     EInvoicing.SendNotConfigured — sending e-invoices is not configured for this organisation's country
                 */
                503: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/invoices/{invoiceId}/credit-notes/{creditNoteId}/e-invoice/retry": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Retry a credit note's failed e-invoice delivery (deprecated)
         * @description Deprecated alias for POST /invoices/{invoiceId}/credit-notes/{creditNoteId}/e-invoice/resend; identical behaviour.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the invoice the credit note credits. */
                    invoiceId: string;
                    /** @description Id of the credit note. */
                    creditNoteId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["OutboundEInvoiceView"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 *
                 *     Demo.OutboundBlocked — this is a demo, so nothing is sent outside Dolfin
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description CreditNote.NotFound — no credit note with that id on this invoice for this organisation
                 *
                 *     Organisation.NotFound — the organisation does not exist or could not be resolved
                 *
                 *     Customer.NotFound — customer does not exist or belongs to a different organisation
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description EInvoicing.CreditNoteNotSendable — a credit note is sent as an e-invoice only once it is issued and its invoice's e-invoice was delivered
                 *
                 *     EInvoicing.DeliveryNotResendable — this delivery cannot be sent again: it is in flight or delivered, or the network refused a document that has not changed since
                 *
                 *     EInvoicing.DeliveryNotRetryable — this delivery cannot be retried; the document itself was refused
                 *
                 *     EInvoicing.AlreadyDelivered — this invoice has already been sent as an e-invoice
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description EInvoicing.CountryNotSupported — e-invoicing is not available in this organisation's country yet
                 *
                 *     EInvoicing.SellerNotRegistered — this organisation is not registered to send e-invoices
                 *
                 *     EInvoicing.CustomerNotAddressable — this customer has no e-invoicing address to deliver to
                 *
                 *     EInvoicing.DocumentInvalid — the invoice is not valid as an e-invoice
                 *
                 *     EInvoicing.TotalsMismatch — the calculated totals do not match this invoice
                 *
                 *     EInvoicing.ProviderRejected — the e-invoicing provider rejected the document
                 */
                422: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description EInvoicing.ProviderUnavailable — the e-invoicing provider could not be reached */
                502: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Service Unavailable
                 *
                 *     EInvoicing.SendNotConfigured — sending e-invoices is not configured for this organisation's country
                 */
                503: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/invoices/{invoiceId}/credit-notes/{creditNoteId}/e-invoice/correct-and-resubmit": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Correct and resubmit a credit note's e-invoice (deprecated)
         * @description Deprecated alias for POST /invoices/{invoiceId}/credit-notes/{creditNoteId}/e-invoice/resend; identical behaviour.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the invoice the credit note credits. */
                    invoiceId: string;
                    /** @description Id of the credit note. */
                    creditNoteId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["OutboundEInvoiceView"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 *
                 *     Demo.OutboundBlocked — this is a demo, so nothing is sent outside Dolfin
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description CreditNote.NotFound — no credit note with that id on this invoice for this organisation
                 *
                 *     Organisation.NotFound — the organisation does not exist or could not be resolved
                 *
                 *     Customer.NotFound — customer does not exist or belongs to a different organisation
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description EInvoicing.CreditNoteNotSendable — a credit note is sent as an e-invoice only once it is issued and its invoice's e-invoice was delivered
                 *
                 *     EInvoicing.DeliveryNotResendable — this delivery cannot be sent again: it is in flight or delivered, or the network refused a document that has not changed since
                 *
                 *     EInvoicing.DeliveryNotRetryable — this delivery cannot be retried; the document itself was refused
                 *
                 *     EInvoicing.AlreadyDelivered — this invoice has already been sent as an e-invoice
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description EInvoicing.CountryNotSupported — e-invoicing is not available in this organisation's country yet
                 *
                 *     EInvoicing.SellerNotRegistered — this organisation is not registered to send e-invoices
                 *
                 *     EInvoicing.CustomerNotAddressable — this customer has no e-invoicing address to deliver to
                 *
                 *     EInvoicing.DocumentInvalid — the invoice is not valid as an e-invoice
                 *
                 *     EInvoicing.TotalsMismatch — the calculated totals do not match this invoice
                 *
                 *     EInvoicing.ProviderRejected — the e-invoicing provider rejected the document
                 */
                422: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description EInvoicing.ProviderUnavailable — the e-invoicing provider could not be reached */
                502: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Service Unavailable
                 *
                 *     EInvoicing.SendNotConfigured — sending e-invoices is not configured for this organisation's country
                 */
                503: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/outbound-e-invoices": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List sent e-invoices
         * @description Invoices this organisation has sent over an e-invoicing network, newest first. Each entry carries the network it travelled over, whether it was accepted, and what the network said if it was not. Filter by state to see only the deliveries that need attention. Filter by networkReference to find a document by the id the network gave it (for SDI, the IdentificativoSdI on its receipts) - invoices and credit notes alike, including the id of an earlier attempt that was rejected and corrected. Keyset-paginated: follow meta.cursors.next for the next page.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    cursor?: string;
                    limit?: number | string;
                    state?: components["schemas"]["OutboundEInvoiceState"];
                    networkReference?: string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfOutboundEInvoiceView"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Conflict — another change to the same record landed first; retry the request */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/invoices/{id}/e-invoice/send": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Send an invoice as an e-invoice
         * @description Converts an issued invoice into an electronic invoice and sends it over the network that serves the organisation's country — Peppol, or a government hub such as Italy's SDI. The invoice must already be issued, and the organisation's country must be set up for sending. The document is validated before anything is sent, so an invoice that cannot be represented electronically is refused while it can still be corrected. Delivery itself is asynchronous: this returns as soon as the network has accepted the document for processing, and the delivery's state is reported on the invoice. Sending the same invoice twice is refused.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the invoice. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["OutboundEInvoiceView"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 *
                 *     Demo.OutboundBlocked — this is a demo, so nothing is sent outside Dolfin
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Invoice.NotFound — no invoice with that id for this organisation
                 *
                 *     Organisation.NotFound — the organisation does not exist or could not be resolved
                 *
                 *     Customer.NotFound — customer does not exist or belongs to a different organisation
                 *
                 *     EInvoicing.DeliveryNotFound — this invoice has not been sent as an e-invoice
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description EInvoicing.InvoiceNotSendable — only an issued invoice can be sent as an e-invoice
                 *
                 *     EInvoicing.AlreadyDelivered — this invoice has already been sent as an e-invoice
                 *
                 *     EInvoicing.DeliveryNotRetryable — this delivery cannot be retried; the document itself was refused
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description EInvoicing.CountryNotSupported — e-invoicing is not available in this organisation's country yet
                 *
                 *     EInvoicing.SellerNotRegistered — this organisation is not registered to send e-invoices
                 *
                 *     EInvoicing.CustomerNotAddressable — this customer has no e-invoicing address to deliver to
                 *
                 *     EInvoicing.DocumentInvalid — the invoice is not valid as an e-invoice
                 *
                 *     EInvoicing.TotalsMismatch — the calculated totals do not match this invoice
                 *
                 *     EInvoicing.ProviderRejected — the e-invoicing provider rejected the document
                 */
                422: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description EInvoicing.ProviderUnavailable — the e-invoicing provider could not be reached */
                502: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Service Unavailable
                 *
                 *     EInvoicing.SendNotConfigured — sending e-invoices is not configured for this organisation's country
                 */
                503: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/invoices/{id}/e-invoice/resend": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Resend an e-invoice
         * @description Sends an invoice's failed or abandoned electronic delivery again. When nothing reached the network (the recipient could not be found, the network refused the document, or the send never started) the document is rebuilt from the current customer and organisation details, so correct those first. When the recipient may already hold the document, the same document is sent again instead. A document the network refused is not sent again unchanged. An invoice the network accepted is corrected with a credit note.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the invoice. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["OutboundEInvoiceView"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 *
                 *     Demo.OutboundBlocked — this is a demo, so nothing is sent outside Dolfin
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Invoice.NotFound — no invoice with that id for this organisation
                 *
                 *     Organisation.NotFound — the organisation does not exist or could not be resolved
                 *
                 *     Customer.NotFound — customer does not exist or belongs to a different organisation
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description EInvoicing.InvoiceNotSendable — only an issued invoice can be sent as an e-invoice
                 *
                 *     EInvoicing.DeliveryNotResendable — this delivery cannot be sent again: it is in flight or delivered, or the network refused a document that has not changed since
                 *
                 *     EInvoicing.DeliveryNotRetryable — this delivery cannot be retried; the document itself was refused
                 *
                 *     EInvoicing.AlreadyDelivered — this invoice has already been sent as an e-invoice
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description EInvoicing.CountryNotSupported — e-invoicing is not available in this organisation's country yet
                 *
                 *     EInvoicing.SellerNotRegistered — this organisation is not registered to send e-invoices
                 *
                 *     EInvoicing.CustomerNotAddressable — this customer has no e-invoicing address to deliver to
                 *
                 *     EInvoicing.DocumentInvalid — the invoice is not valid as an e-invoice
                 *
                 *     EInvoicing.TotalsMismatch — the calculated totals do not match this invoice
                 *
                 *     EInvoicing.ProviderRejected — the e-invoicing provider rejected the document
                 */
                422: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description EInvoicing.ProviderUnavailable — the e-invoicing provider could not be reached */
                502: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Service Unavailable
                 *
                 *     EInvoicing.SendNotConfigured — sending e-invoices is not configured for this organisation's country
                 */
                503: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/invoices/{id}/e-invoice/retry": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Retry a failed e-invoice delivery (deprecated)
         * @description Deprecated alias for POST /invoices/{id}/e-invoice/resend; identical behaviour.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the invoice. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["OutboundEInvoiceView"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 *
                 *     Demo.OutboundBlocked — this is a demo, so nothing is sent outside Dolfin
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Invoice.NotFound — no invoice with that id for this organisation
                 *
                 *     Organisation.NotFound — the organisation does not exist or could not be resolved
                 *
                 *     Customer.NotFound — customer does not exist or belongs to a different organisation
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description EInvoicing.InvoiceNotSendable — only an issued invoice can be sent as an e-invoice
                 *
                 *     EInvoicing.DeliveryNotResendable — this delivery cannot be sent again: it is in flight or delivered, or the network refused a document that has not changed since
                 *
                 *     EInvoicing.DeliveryNotRetryable — this delivery cannot be retried; the document itself was refused
                 *
                 *     EInvoicing.AlreadyDelivered — this invoice has already been sent as an e-invoice
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description EInvoicing.CountryNotSupported — e-invoicing is not available in this organisation's country yet
                 *
                 *     EInvoicing.SellerNotRegistered — this organisation is not registered to send e-invoices
                 *
                 *     EInvoicing.CustomerNotAddressable — this customer has no e-invoicing address to deliver to
                 *
                 *     EInvoicing.DocumentInvalid — the invoice is not valid as an e-invoice
                 *
                 *     EInvoicing.TotalsMismatch — the calculated totals do not match this invoice
                 *
                 *     EInvoicing.ProviderRejected — the e-invoicing provider rejected the document
                 */
                422: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description EInvoicing.ProviderUnavailable — the e-invoicing provider could not be reached */
                502: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Service Unavailable
                 *
                 *     EInvoicing.SendNotConfigured — sending e-invoices is not configured for this organisation's country
                 */
                503: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/invoices/{id}/e-invoice/correct-and-resubmit": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Correct and resubmit an e-invoice (deprecated)
         * @description Deprecated alias for POST /invoices/{id}/e-invoice/resend; identical behaviour.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the invoice. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["OutboundEInvoiceView"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 *
                 *     Demo.OutboundBlocked — this is a demo, so nothing is sent outside Dolfin
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Invoice.NotFound — no invoice with that id for this organisation
                 *
                 *     Organisation.NotFound — the organisation does not exist or could not be resolved
                 *
                 *     Customer.NotFound — customer does not exist or belongs to a different organisation
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description EInvoicing.InvoiceNotSendable — only an issued invoice can be sent as an e-invoice
                 *
                 *     EInvoicing.DeliveryNotResendable — this delivery cannot be sent again: it is in flight or delivered, or the network refused a document that has not changed since
                 *
                 *     EInvoicing.DeliveryNotRetryable — this delivery cannot be retried; the document itself was refused
                 *
                 *     EInvoicing.AlreadyDelivered — this invoice has already been sent as an e-invoice
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description EInvoicing.CountryNotSupported — e-invoicing is not available in this organisation's country yet
                 *
                 *     EInvoicing.SellerNotRegistered — this organisation is not registered to send e-invoices
                 *
                 *     EInvoicing.CustomerNotAddressable — this customer has no e-invoicing address to deliver to
                 *
                 *     EInvoicing.DocumentInvalid — the invoice is not valid as an e-invoice
                 *
                 *     EInvoicing.TotalsMismatch — the calculated totals do not match this invoice
                 *
                 *     EInvoicing.ProviderRejected — the e-invoicing provider rejected the document
                 */
                422: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description EInvoicing.ProviderUnavailable — the e-invoicing provider could not be reached */
                502: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Service Unavailable
                 *
                 *     EInvoicing.SendNotConfigured — sending e-invoices is not configured for this organisation's country
                 */
                503: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/invoices/{id}/e-invoice": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get an invoice's e-invoice delivery
         * @description Reports whether an invoice was sent electronically and how that went: which network carried it, whether it has been accepted, and what the network said if it was not.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the invoice. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["OutboundEInvoiceView"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description EInvoicing.DeliveryNotFound — this invoice has not been sent as an e-invoice */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Conflict — another change to the same record landed first; retry the request */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/delivery-notes": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List delivery notes
         * @description List delivery notes for the organisation, optionally filtered by supplier, with cursor-based pagination.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    Cursor?: string;
                    Limit?: number | string;
                    SupplierId?: string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfDeliveryNoteResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        /**
         * Create delivery note
         * @description Create a delivery note with its received lines for the organisation. Delivery notes are trusted platform data and do not require approval.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["CreateDeliveryNoteRequest"];
                };
            };
            responses: {
                /** @description Created */
                201: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["DeliveryNoteResponse"];
                    };
                };
                /**
                 * @description DeliveryNote.NumberRequired — a delivery note requires a DN number
                 *
                 *     DeliveryNote.NoLines — a delivery note must have at least one line
                 *
                 *     DeliveryNote.InvalidLine — a delivery-note line is missing a description or a valid quantity
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description DeliveryNote.SupplierNotFound — the referenced supplier does not exist in this organisation
                 *
                 *     DeliveryNote.PurchaseOrderNotFound — the referenced purchase order does not exist in this organisation
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/delivery-notes/{id}/close": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Close delivery note
         * @description Mark a delivery note as done (terminal Closed). Stops future matching but keeps existing allocations. Already-terminal notes are rejected.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["DeliveryNoteResponse"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description DeliveryNote.NotFound — delivery note does not exist or belongs to another organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description DeliveryNote.AlreadyTerminal — the delivery note is already closed or cancelled and cannot change status */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/delivery-notes/{id}/cancel": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Cancel delivery note
         * @description Mark a delivery note as void (terminal Cancelled). Stops future matching but keeps existing allocations. Already-terminal notes are rejected.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["DeliveryNoteResponse"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description DeliveryNote.NotFound — delivery note does not exist or belongs to another organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description DeliveryNote.AlreadyTerminal — the delivery note is already closed or cancelled and cannot change status */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/delivery-notes/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get delivery note
         * @description Retrieve a delivery note and its lines by ID.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["DeliveryNoteResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description DeliveryNote.NotFound — delivery note does not exist or belongs to another organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        /**
         * Update delivery note
         * @description Replace a delivery note's header and lines. Lines with a known id are updated, lines with no id are added, and omitted lines are removed. Closed/cancelled notes are immutable, and a line already matched to a bill cannot be removed or have its received quantity reduced below the matched amount.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        put: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["UpdateDeliveryNoteRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["DeliveryNoteResponse"];
                    };
                };
                /**
                 * @description DeliveryNote.NumberRequired — a delivery note requires a DN number
                 *
                 *     DeliveryNote.NoLines — a delivery note must have at least one line
                 *
                 *     DeliveryNote.InvalidLine — a delivery-note line is missing a description or a valid quantity
                 *
                 *     DeliveryNote.LineNotFound — a referenced delivery-note line does not belong to this delivery note
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description DeliveryNote.NotFound — delivery note does not exist or belongs to another organisation
                 *
                 *     DeliveryNote.SupplierNotFound — the referenced supplier does not exist in this organisation
                 *
                 *     DeliveryNote.PurchaseOrderNotFound — the referenced purchase order does not exist in this organisation
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description DeliveryNote.NotEditable — the delivery note is in a terminal status (closed or cancelled) and cannot be edited
                 *
                 *     DeliveryNote.LineHasAllocations — a delivery-note line that is already matched to a bill cannot be removed
                 *
                 *     DeliveryNote.QuantityBelowMatched — quantity received cannot be reduced below the quantity already matched to bills
                 *
                 *     DeliveryNote.MatchedSupplierLocked — supplier cannot change while any line is matched to a bill
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/delivery-notes/{id}/matched-bills": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List bills matched to a delivery note
         * @description Bills with at least one line allocated against this delivery note, with their match-group status.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["MatchedBillView"][];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description DeliveryNote.NotFound — delivery note does not exist or belongs to another organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/customers": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List customers
         * @description List customers for the organisation with optional name or email filtering and cursor-based pagination.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    /** @description Opaque pagination cursor. Pass back `next` or `previous` from a previous page's cursors. */
                    Cursor?: string;
                    /** @description Page size, 1 to 100. Defaults to 20. */
                    Limit?: number | string;
                    /** @description Partial, case-insensitive match on the customer name. */
                    Name?: string;
                    /** @description Exact match on the customer email. */
                    Email?: string;
                    /** @description Returns only records written at or after this UTC instant — the reconciliation filter for a client keeping its own copy in sync. Take the watermark from when your sync run STARTED, not when it finished, so a record edited mid-run is caught on the next one. Ordering and paging are unchanged. */
                    UpdatedSince?: string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfCustomerResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        /**
         * Create customer
         * @description Create a new customer record for the organisation.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["CreateCustomerRequest"];
                };
            };
            responses: {
                /** @description Created */
                201: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CustomerResponse"];
                    };
                };
                /**
                 * @description Customer.MissingName — customer name is required
                 *
                 *     Customer.InvalidElectronicAddress — the customer's e-invoicing address is not valid for its scheme
                 *
                 *     Customer.EInvoicingCountryRequired — a customer who receives e-invoices needs a country that matches their e-invoicing address
                 *
                 *     Customer.InvalidWhatsAppPhone — the WhatsApp number is not a valid international phone number
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/customers/{id}/whatsapp-consent": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Record customer WhatsApp consent
         * @description Record that the customer agreed to receive invoices and reminders on WhatsApp, at the WhatsApp number set on the customer. The caller attests to the consent, and is recorded as having given it. Clears an earlier opt-out. Changing the customer's WhatsApp number withdraws consent again.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the customer. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CustomerResponse"];
                    };
                };
                /** @description Customer.WhatsAppPhoneRequired — the customer has no WhatsApp number to record consent for */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Customer.NotFound — customer does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        /**
         * Withdraw customer WhatsApp consent
         * @description Record that the customer no longer wants WhatsApp messages. Invoices and reminders go by email from then on, whatever the customer's preferred channel.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        delete: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the customer. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CustomerResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Customer.NotFound — customer does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/customers/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get customer
         * @description Retrieve a single customer by its identifier.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the customer. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CustomerResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Customer.NotFound — customer does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        /**
         * Update customer
         * @description Replace all mutable fields on an existing customer.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        put: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the customer to update. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["UpdateCustomerRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CustomerResponse"];
                    };
                };
                /**
                 * @description Customer.MissingName — customer name is required
                 *
                 *     Customer.InvalidElectronicAddress — the customer's e-invoicing address is not valid for its scheme
                 *
                 *     Customer.EInvoicingCountryRequired — a customer who receives e-invoices needs a country that matches their e-invoicing address
                 *
                 *     Customer.InvalidWhatsAppPhone — the WhatsApp number is not a valid international phone number
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Customer.NotFound — customer does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        post?: never;
        /**
         * Delete customer
         * @description Delete a customer, failing if the customer has associated invoices.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        delete: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the customer to delete. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description No Content */
                204: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Customer.NotFound — customer does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Customer.HasInvoices — customer cannot be deleted because it has associated invoices
                 *
                 *     Customer.HasRecurringSchedules — customer cannot be deleted because it has recurring invoice schedules
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/customers/search": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Search customers
         * @description Fuzzy-search customers by id, name, email, tax number, postal code, or address. Uses PostgreSQL trigram similarity.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query: {
                    /** @description Text to match against the customer's id, name, email, tax number, postal code or address. Required. */
                    q: string;
                    /** @description Maximum number of results, 1 to 20. Defaults to 5. */
                    limit?: number | string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CustomerSearchHit"][];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/currencies/available": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List available currencies
         * @description List all supported currencies available to be enabled by any organisation.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token; the organisation is determined without the `x-dolfin-organisation-id` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CurrencyResponse"][];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/invoices/{invoiceId}/credit-notes": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List credit notes
         * @description List the credit notes raised against an invoice, newest first.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the invoice whose credit notes to list. */
                    invoiceId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CreditNoteResponse"][];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        /**
         * Create credit note
         * @description Create a credit note in Draft against an Issued or PartiallyPaid invoice. The amount must not exceed the invoice's outstanding balance. Issue it separately to apply it to the balance.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the invoice to credit. */
                    invoiceId: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["CreateCreditNoteRequest"];
                };
            };
            responses: {
                /** @description Created */
                201: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CreditNoteResponse"];
                    };
                };
                /**
                 * @description CreditNote.InvalidAmount — credit note amount must be greater than zero, in whole minor units of the currency
                 *
                 *     CreditNote.TaxRateRequired — the invoice's lines carry different tax rates, so the credit's rate must be given
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description CreditNote.InvoiceNotFound — no invoice with that id for this organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description CreditNote.InvoiceNotCreditable — credit notes can only be raised against Issued or PartiallyPaid invoices
                 *
                 *     CreditNote.ExceedsOutstanding — the credit amount exceeds the invoice's outstanding balance
                 *
                 *     CreditNote.CommandFailed — the credit note command was rejected by the saga (state conflict)
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/invoices/{invoiceId}/credit-notes/{creditNoteId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get credit note
         * @description Retrieve a single credit note on an invoice.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    invoiceId: string;
                    creditNoteId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CreditNoteResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description CreditNote.NotFound — no credit note with that id on this invoice for this organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        /**
         * Delete draft credit note
         * @description Delete a Draft credit note. Issued credit notes are immutable and cannot be deleted.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        delete: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the invoice the credit note is against. */
                    invoiceId: string;
                    /** @description Id of the draft credit note to delete. */
                    creditNoteId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description No Content */
                204: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description CreditNote.NotFound — no credit note with that id on this invoice for this organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description CreditNote.AlreadyIssued — the credit note is already issued and is immutable
                 *
                 *     CreditNote.CommandFailed — the credit note command was rejected by the saga (state conflict)
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/credit-notes/{creditNoteId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get credit note by id
         * @description Retrieve a single credit note by its id, without knowing its invoice. The response names the invoice it credits (invoiceId).
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the credit note. */
                    creditNoteId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CreditNoteResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description CreditNote.NotFound — no credit note with that id on this invoice for this organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/invoices/{invoiceId}/credit-notes/{creditNoteId}/issue": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Issue credit note
         * @description Issue a Draft credit note. This applies it to the invoice's outstanding balance and makes the credit note immutable. If the credit zeroes the balance, the invoice moves to Credited.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the invoice the credit note is against. */
                    invoiceId: string;
                    /** @description Id of the draft credit note to issue. */
                    creditNoteId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CreditNoteResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description CreditNote.NotFound — no credit note with that id on this invoice for this organisation
                 *
                 *     CreditNote.InvoiceNotFound — no invoice with that id for this organisation
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description CreditNote.AlreadyIssued — the credit note is already issued and is immutable
                 *
                 *     CreditNote.InvoiceNotCreditable — credit notes can only be raised against Issued or PartiallyPaid invoices
                 *
                 *     CreditNote.ExceedsOutstanding — the credit amount exceeds the invoice's outstanding balance
                 *
                 *     CreditNote.CommandFailed — the credit note command was rejected by the saga (state conflict)
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/credit-notes": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List credit notes
         * @description List the organisation's credit notes, newest first, optionally filtered by customer or invoice.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    Cursor?: string;
                    Limit?: number | string;
                    CustomerId?: string;
                    InvoiceId?: string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfCreditNoteResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/companies/{companyId}/bills": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List a company's unassigned bills
         * @description List the bills received against this company that have not been assigned to an organisation. A bill leaves this list as soon as it is assigned, whether automatically or by hand, and is then retrievable from GET /bills/{billId} under the same identifier. Use the status filter to see bills whose document could not be read, or ones that were discarded.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token. When your credential grants access to more than one client, select one with the `x-dolfin-client-id` header.
         */
        get: {
            parameters: {
                query?: {
                    Cursor?: string;
                    Limit?: number | string;
                    /** @description Only return bills in this state. Omit to see everything waiting, which is the usual case. */
                    Status?: components["schemas"]["CompanyInboxBillStatus"];
                };
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path: {
                    companyId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfCompanyInboxBillResponse"];
                    };
                };
                /**
                 * @description Company.MissingClientId — client ID is required
                 *
                 *     Pagination.InvalidCursor — the cursor value is invalid
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Company.NotFound — the company does not exist or belongs to a different client */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        /**
         * Upload a bill to a company
         * @description Upload a PDF or image to a company when you do not know which of its organisations the bill belongs to. The document is read asynchronously and the delivery address printed on it is matched against the company's organisations. A confident match is assigned automatically; anything else waits in the company's inbox to be assigned. The identifier returned here is the bill's identifier and does not change when it is assigned.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token. When your credential grants access to more than one client, select one with the `x-dolfin-client-id` header.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path: {
                    companyId: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "multipart/form-data": {
                        file?: components["schemas"]["IFormFile"];
                    };
                };
            };
            responses: {
                /** @description Accepted */
                202: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CompanyBillCreatedResponse"];
                    };
                };
                /**
                 * @description Company.MissingClientId — client ID is required
                 *
                 *     Bill.FileTooLarge — uploaded file exceeds the 20 MB maximum
                 *
                 *     Bill.UnsupportedFileType — file type is not supported; accepted: PDF, PNG, JPEG, TIFF, GIF, BMP, WEBP
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Company.NotFound — the company does not exist or belongs to a different client */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/companies/{companyId}/bills/{billId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get an unassigned company bill
         * @description Retrieve a single bill waiting in the company's inbox, including the candidate organisations it might belong to. Once assigned, retrieve it from GET /bills/{billId} instead.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token. When your credential grants access to more than one client, select one with the `x-dolfin-client-id` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path: {
                    companyId: string;
                    billId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CompanyInboxBillResponse"];
                    };
                };
                /** @description Company.MissingClientId — client ID is required */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description CompanyInboxBill.NotFound — the company bill does not exist or belongs to a different client */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/companies/{companyId}/bills/{billId}/file-url": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get an unassigned company bill's document URL
         * @description Generate a short-lived signed URL for the document of a bill waiting in the company's inbox. Deciding which organisation a bill belongs to usually means looking at it — particularly when no delivery address could be read, which leaves no candidate organisations to choose from. Once the bill is assigned, use GET /bills/{billId}/file-url instead.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token. When your credential grants access to more than one client, select one with the `x-dolfin-client-id` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path: {
                    companyId: string;
                    billId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BillFileUrlResponse"];
                    };
                };
                /** @description Company.MissingClientId — client ID is required */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description CompanyInboxBill.NotFound — the company bill does not exist or belongs to a different client
                 *
                 *     CompanyInboxBill.NoFile — the company bill has no uploaded document
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/companies/{companyId}/bills/{billId}/assign": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Assign a company bill to an organisation
         * @description Assign a bill waiting in the company's inbox to one of that company's organisations. The bill becomes an ordinary bill for that organisation, keeping the same identifier, and supplier matching and duplicate detection run against it for the first time. The move is atomic: it either becomes that organisation's bill or stays in the inbox. If two people assign the same bill at once, exactly one succeeds and the other receives a conflict.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token. When your credential grants access to more than one client, select one with the `x-dolfin-client-id` header.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path: {
                    companyId: string;
                    billId: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["AssignCompanyBillRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CompanyBillAssignedResponse"];
                    };
                };
                /** @description Company.MissingClientId — client ID is required */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description CompanyInboxBill.NotFound — the company bill does not exist or belongs to a different client
                 *
                 *     CompanyInboxBill.OrganisationNotInCompany — the target organisation is not part of this company
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description CompanyInboxBill.NotAwaitingOrganisation — the bill is not awaiting routing — it is still extracting, was discarded, or has already been routed
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/companies/{companyId}/bills/{billId}/discard": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Discard a company bill
         * @description Reject a bill in the company's inbox — for example one that is not this company's at all. It is kept, marked as discarded, so there is a record of why it never reached a ledger.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token. When your credential grants access to more than one client, select one with the `x-dolfin-client-id` header.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path: {
                    companyId: string;
                    billId: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    "application/json": null | components["schemas"]["DiscardCompanyBillRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CompanyInboxBillResponse"];
                    };
                };
                /** @description Company.MissingClientId — client ID is required */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description CompanyInboxBill.NotFound — the company bill does not exist or belongs to a different client */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/companies/{companyId}/bills/{billId}/retry-extraction": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Retry reading a company bill's document
         * @description Re-run document extraction for a bill whose document could not be read.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token. When your credential grants access to more than one client, select one with the `x-dolfin-client-id` header.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path: {
                    companyId: string;
                    billId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description Accepted */
                202: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CompanyInboxBillResponse"];
                    };
                };
                /** @description Company.MissingClientId — client ID is required */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description CompanyInboxBill.NotFound — the company bill does not exist or belongs to a different client */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description CompanyInboxBill.NotRetryable — extraction can only be retried for a bill whose extraction failed */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/companies/{companyId}/inbound-email-address": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get a company's bill-forwarding email address
         * @description The email address suppliers' bills can be forwarded to for this company. Forward the group's accounts-payable mailbox here and each bill is read and routed to the organisation its delivery address belongs to. Only senders on the company's allowlist are accepted — see GET /companies/{companyId}/allowed-senders.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token. When your credential grants access to more than one client, select one with the `x-dolfin-client-id` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path: {
                    companyId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["InboundEmailAddressResponse"];
                    };
                };
                /** @description Company.MissingClientId — client ID is required */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Company.NotFound — the company does not exist or belongs to a different client */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Company.NoInboundEmailToken — this company has no bill-forwarding address yet */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/companies/{companyId}/allowed-senders": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List a company's allowed bill-forwarding senders
         * @description The email addresses and domains allowed to forward bills to this company's address. Unlike an organisation, a company has no users, so this list is the whole gate: until something is on it, every forward is rejected and recorded in the rejections list.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token. When your credential grants access to more than one client, select one with the `x-dolfin-client-id` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path: {
                    companyId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BillAllowedSenderResponse"][];
                    };
                };
                /** @description Company.MissingClientId — client ID is required */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Company.NotFound — the company does not exist or belongs to a different client */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        /**
         * Allow a sender to forward bills to a company
         * @description Adds an email address or whole domain to the company's forwarding allowlist. Because a company address can produce a bill for any of its organisations, allow only senders you trust to bill the whole group.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token. When your credential grants access to more than one client, select one with the `x-dolfin-client-id` header.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path: {
                    companyId: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["AddBillAllowedSenderRequest"];
                };
            };
            responses: {
                /** @description Created */
                201: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BillAllowedSenderResponse"];
                    };
                };
                /**
                 * @description Company.MissingClientId — client ID is required
                 *
                 *     BillAllowedSender.Invalid — the allowed sender address or domain is not valid
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Company.NotFound — the company does not exist or belongs to a different client */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description BillAllowedSender.Duplicate — this sender is already on the allowlist */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/companies/{companyId}/allowed-senders/{senderId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * Remove a company's allowed bill-forwarding sender
         * @description Future forwards from that sender are no longer accepted for this company.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token. When your credential grants access to more than one client, select one with the `x-dolfin-client-id` header.
         */
        delete: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path: {
                    companyId: string;
                    senderId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description No Content */
                204: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Company.MissingClientId — client ID is required */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Company.NotFound — the company does not exist or belongs to a different client
                 *
                 *     BillAllowedSender.NotFound — no allowed sender exists with this id for this organisation
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/companies/{companyId}/forwarding-rejections": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List forwards this company rejected
         * @description Emails that reached this company's forwarding address but were not accepted, because the sender is not on the allowlist or the message failed email authentication. Only metadata is kept — the attachments are not stored. This is where a new company's first forwards land, so it is the place to find out who is trying to send and allow them.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token. When your credential grants access to more than one client, select one with the `x-dolfin-client-id` header.
         */
        get: {
            parameters: {
                query?: {
                    /** @description Maximum rejections to return, newest first. 1-100, default 20. */
                    Limit?: number | string;
                };
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path: {
                    companyId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BillForwardingRejectionResponse"][];
                    };
                };
                /** @description Company.MissingClientId — client ID is required */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Company.NotFound — the company does not exist or belongs to a different client */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/companies": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List companies
         * @description List the parent companies belonging to the authenticated client, newest first.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token. When your credential grants access to more than one client, select one with the `x-dolfin-client-id` header.
         */
        get: {
            parameters: {
                query?: {
                    Cursor?: string;
                    Limit?: number | string;
                    Name?: string;
                };
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfCompanyResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        /**
         * Create company
         * @description Create a parent company under the authenticated client. A company groups organisations that belong to the same multi-site business, so that bills addressed to the group rather than to a specific site can be received and then routed to the right organisation. Companies are optional: organisations that are not part of a group need one.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token. When your credential grants access to more than one client, select one with the `x-dolfin-client-id` header.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["CreateCompanyRequest"];
                };
            };
            responses: {
                /** @description Created */
                201: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CompanyResponse"];
                    };
                };
                /**
                 * @description Company.MissingName — company name is required
                 *
                 *     Company.MissingClientId — client ID is required
                 *
                 *     Company.InvalidContactEmail — contact email is not a valid email address
                 *
                 *     Company.InvalidCountry — country code is not a valid ISO 3166-1 alpha-2 code
                 *
                 *     Organisation.ClientNotFound — specified client does not exist
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/companies/{companyId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get company
         * @description Retrieve a single company by its identifier.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token. When your credential grants access to more than one client, select one with the `x-dolfin-client-id` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path: {
                    companyId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CompanyResponse"];
                    };
                };
                /** @description Company.MissingClientId — client ID is required */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Company.NotFound — the company does not exist or belongs to a different client */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /**
         * Patch company
         * @description Partially update a company. Fields that are omitted are left unchanged.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token. When your credential grants access to more than one client, select one with the `x-dolfin-client-id` header.
         */
        patch: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path: {
                    companyId: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["PatchCompanyRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CompanyResponse"];
                    };
                };
                /**
                 * @description Company.MissingName — company name is required
                 *
                 *     Company.MissingClientId — client ID is required
                 *
                 *     Company.InvalidContactEmail — contact email is not a valid email address
                 *
                 *     Company.InvalidCountry — country code is not a valid ISO 3166-1 alpha-2 code
                 *
                 *     Company.InvalidAutoAssign — an automatic-routing override is outside the allowed 0-1 range
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Company.NotFound — the company does not exist or belongs to a different client */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        trace?: never;
    };
    "/v1/companies/{companyId}/inbound-emails": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List emails sent to this company's forwarding address
         * @description Every email that reached this company's bill-forwarding address, whether or not it became a bill, newest first. Each row carries its attachments and, for any that were not taken, the reason — so an invoice that never appeared can be accounted for. Filter with 'ingested' to see only the emails that produced nothing. Attachment content is not stored, only its name, type and size.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token. When your credential grants access to more than one client, select one with the `x-dolfin-client-id` header.
         */
        get: {
            parameters: {
                query?: {
                    /** @description True for emails that produced at least one bill, false for those that produced none. Omit for both. */
                    Ingested?: boolean;
                    /** @description Narrower than 'ingested': Ingested, PartiallyIngested, NoBillAttachments, Rejected, Failed or Received. */
                    Status?: components["schemas"]["InboundEmailStatus"];
                    /** @description Only emails received on or after this date. */
                    ReceivedFrom?: string;
                    /** @description Only emails received on or before this date. */
                    ReceivedTo?: string;
                    Cursor?: string;
                    Limit?: number | string;
                };
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path: {
                    companyId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfInboundEmailResponse"];
                    };
                };
                /**
                 * @description Company.MissingClientId — client ID is required
                 *
                 *     Pagination.InvalidCursor — the cursor value is invalid
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Company.NotFound — the company does not exist or belongs to a different client */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/companies/{companyId}/organisations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List a company's organisations
         * @description List the organisations that belong to this company — the set a bill received against the company can be routed to.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token. When your credential grants access to more than one client, select one with the `x-dolfin-client-id` header.
         */
        get: {
            parameters: {
                query?: {
                    Cursor?: string;
                    Limit?: number | string;
                    Name?: string;
                };
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path: {
                    companyId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfOrganisationResponse"];
                    };
                };
                /**
                 * @description Company.MissingClientId — client ID is required
                 *
                 *     Pagination.InvalidCursor — the cursor value is invalid
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Company.NotFound — the company does not exist or belongs to a different client */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/organisations/{organisationId}/company": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Assign an organisation to a company
         * @description Link an existing organisation to a parent company. Both must belong to the same client. If the organisation is already linked to a different company, unlink it first.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token. When your credential grants access to more than one client, select one with the `x-dolfin-client-id` header.
         */
        put: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path: {
                    organisationId: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["PutOrganisationCompanyRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["OrganisationResponse"];
                    };
                };
                /** @description Company.MissingClientId — client ID is required */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Organisation.NotFound — the organisation does not exist or could not be resolved */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Company.ClientMismatch — the company and the organisation belong to different clients
                 *
                 *     Company.OrganisationAlreadyLinked — the organisation is already linked to a different company; unlink it first
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        post?: never;
        /**
         * Remove an organisation from its company
         * @description Unlink an organisation from its parent company; it reverts to a standalone organisation. Bills already assigned to the organisation are unaffected. Succeeds even if the organisation has no company.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token. When your credential grants access to more than one client, select one with the `x-dolfin-client-id` header.
         */
        delete: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path: {
                    organisationId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["OrganisationResponse"];
                    };
                };
                /** @description Company.MissingClientId — client ID is required */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Organisation.NotFound — the organisation does not exist or could not be resolved */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/me/client": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get active client settings
         * @description Returns the full Client record for the caller's active pinned Client. Bearer + portal: caller's UserClient membership; API key: the key's pinned Client.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token. When your credential grants access to more than one client, select one with the `x-dolfin-client-id` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target client. Required when your credential grants access to more than one client; omit when it resolves a single client. */
                    "x-dolfin-client-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ClientResponse"];
                    };
                };
                /** @description Client.NotFound — the client does not exist or is not visible to the caller */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/bills/{id}/approve": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Approve bill
         * @description Approve a bill. Only bills in NeedsApproval state.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the bill to approve. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BillResponse"];
                    };
                };
                /** @description Bill.TransitionFailed — bill is not in a state that allows this transition */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Bill.NotFound — bill does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Bill.DuplicateNotDismissed — bill appears to duplicate an earlier bill and must be confirmed as not a duplicate before it can be approved
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/bills/{id}/attachments": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List bill attachments
         * @description List the supporting files the supplier sent with a bill received as an e-invoice, such as timesheets, delivery notes or their own PDF of the invoice. Each comes with a short-lived signed download URL. A bill that was uploaded or emailed returns an empty list. The bill's own document is not included; use file-url for that.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BillAttachmentResponse"][];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Bill.NotFound — bill does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/bills/allowed-senders": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List allowed bill-forwarding senders
         * @description Returns the email addresses and domains explicitly allowed to forward bills into this organisation's inbound address. The organisation's own users are always allowed and are not listed here.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BillAllowedSenderResponse"][];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        /**
         * Allow a bill-forwarding sender
         * @description Adds an email address or whole domain to the allowlist of senders permitted to forward bills into this organisation's inbound address. Forwards from allowed senders are imported automatically; forwards from anyone else are dropped and recorded in the 'senders waiting' list.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["AddBillAllowedSenderRequest"];
                };
            };
            responses: {
                /** @description Created */
                201: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BillAllowedSenderResponse"];
                    };
                };
                /** @description BillAllowedSender.Invalid — the allowed sender address or domain is not valid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description BillAllowedSender.Duplicate — this sender is already on the allowlist */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/bills/allowed-senders/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * Remove an allowed bill-forwarding sender
         * @description Removes an email address or domain from the bill-forwarding allowlist. Future forwards from that sender are no longer imported automatically.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        delete: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the allowed-sender entry to remove. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description No Content */
                204: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description BillAllowedSender.NotFound — no allowed sender exists with this id for this organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/bills/forwarding-rejections": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List bill forwards awaiting sender approval
         * @description Returns recent bills forwarded to this organisation's inbound address that were dropped because the sender is not yet allowed (or failed email authentication) — the 'senders waiting' feed. Each entry identifies the sender so a user can allow them. Attachments are not stored; allowing a sender imports their future forwards, not these dropped ones.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    /** @description How many of the most recent rejections to return, 1 to 100. Defaults to 100. */
                    limit?: number | string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BillForwardingRejectionResponse"][];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/bills/{id}/payments": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List bank payments for a bill
         * @description Returns all open-banking payment attempts for the bill, newest first.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the bill. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BillPaymentResponse"][];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        /**
         * Record a bill payment
         * @description Record a payment made outside Dolfin (cash, bank transfer, cheque, card) against an approved bill, for part or all of what is outstanding, with an optional reference and note. The bill moves to PartiallyPaid, or Paid once its payments and supplier credit cover the total.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the bill the payment is against. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["RecordBillPaymentRequest"];
                };
            };
            responses: {
                /** @description Created */
                201: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BillPaymentRecordResponse"];
                    };
                };
                /**
                 * @description Bill.InvalidPaymentAmount — payment amount must be greater than zero, in whole minor units of the currency
                 *
                 *     Bill.InvalidPaymentDetails — the payment method cannot be Credit (use confirm-paid), the reference is at most 100 characters and the note at most 500
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Bill.NotFound — bill does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Bill.NotPayable — bill is not in Approved, Scheduled, PartiallyPaid or PaymentFailed state, so it cannot take a payment
                 *
                 *     Bill.OverPayment — payment amount exceeds the bill's outstanding balance
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/bills/{id}/payment-records": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List bill payments
         * @description List the payments against a bill, newest first: payments recorded by hand and pay-by-bank payments the bank completed. Removed manual payments are not listed.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the bill whose payments to list. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BillPaymentRecordResponse"][];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Bill.NotFound — bill does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/bills/{id}/payments/{paymentId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * Remove a bill payment
         * @description Remove a manual payment recorded in error. The bill's paid amount drops by the payment, and the bill returns to PartiallyPaid, or Approved when no payment is left. Pay-by-bank payments cannot be removed.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        delete: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                    paymentId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description No Content */
                204: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Bill.TransitionFailed — bill is not in a state that allows this transition */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Bill.NotFound — bill does not exist or belongs to a different organisation
                 *
                 *     Bill.PaymentNotFound — the bill has no payment with that id, or it was already removed
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Bill.PaymentNotDeletable — pay-by-bank payments cannot be removed; only manually recorded payments can
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/bills/{id}/confirm-paid": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Confirm bill paid
         * @description Confirm that an approved, scheduled or partially paid bill has been paid in full outside Dolfin: records one payment of everything outstanding, made by Cash, BankTransfer, Cheque, Card or Other, and marks the bill Paid. Use Credit when supplier credit notes cover the whole bill; no payment is recorded then. To record part of the amount, a reference or a note, record a bill payment instead.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the bill to mark paid. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["ConfirmBillPaidRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BillResponse"];
                    };
                };
                /** @description Bill.TransitionFailed — bill is not in a state that allows this transition */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Bill.NotFound — bill does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Conflict — another change to the same record landed first; retry the request */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/bills": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List bills
         * @description List bills for the organisation with optional state, supplier, invoice number, bill PO number, tag, duplicate-flag, and date filtering.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    /** @description Opaque pagination cursor. Pass back `next` or `previous` from a previous page's cursors. */
                    Cursor?: string;
                    /** @description Page size, 1 to 100. Defaults to 20. */
                    Limit?: number | string;
                    /** @description Bill states to include. Pass one or more (e.g. PendingReview, NeedsApproval, Approved). */
                    States?: components["schemas"]["BillState"][];
                    SupplierId?: string;
                    /** @description Exact match on invoice number. */
                    InvoiceNumber?: string;
                    /** @description Returns bills quoting this purchase-order reference among the ones printed on them (billPoNumbers), matched exactly as extracted — punctuation and case must match the document. Use normalisedBillPoNumber to search without knowing how the document punctuated it. */
                    BillPoNumber?: string;
                    /** @description Punctuation-insensitive version of billPoNumber: your value is upper-cased and stripped of non-alphanumerics before comparing, so "PO-01750", "po 01750" and "PO01750" all find a bill printed as "PO 01750". Matches a bill that quotes this order alongside others. */
                    NormalisedBillPoNumber?: string;
                    /** @description Only bills carrying this tag (case-insensitive). */
                    Tag?: string;
                    DueDateFrom?: string;
                    DueDateTo?: string;
                    /** @description Populate matchSummary on each bill in the response — its three-way match status and the purchase orders and delivery notes it is matched to. Off by default: it costs two extra lookups for the page and is only meaningful for organisations that raise purchase orders. For per-line variances and match suggestions, fetch a bill's match group instead. */
                    IncludeMatch?: boolean;
                    /** @description Filter by whether the bill was flagged as a possible duplicate of an earlier bill: true returns only flagged bills (the possible-duplicates queue), false only unflagged ones. Omit for all bills. Flagged bills that were since confirmed as not duplicates are still included by true, since they keep their link to the other bill. */
                    Duplicate?: boolean;
                    /** @description Returns only records written at or after this UTC instant — the reconciliation filter for a client keeping its own copy in sync. Take the watermark from when your sync run STARTED, not when it finished, so a record edited mid-run is caught on the next one. Ordering and paging are unchanged. */
                    UpdatedSince?: string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfBillResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        /**
         * Upload bill
         * @description Upload a PDF or image file to create a new bill. OCR processing is queued asynchronously.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "multipart/form-data": {
                        file?: components["schemas"]["IFormFile"];
                    };
                };
            };
            responses: {
                /** @description Accepted */
                202: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BillCreatedResponse"];
                    };
                };
                /**
                 * @description Bill.FileTooLarge — uploaded file exceeds the 20 MB maximum
                 *
                 *     Bill.UnsupportedFileType — file type is not supported; accepted: PDF, PNG, JPEG, TIFF, GIF, BMP, WEBP
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Demo.LimitReached — the demo has reached its limit of documents of this kind; reset it to start again
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Conflict — another change to the same record landed first; retry the request */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/bills/{id}/dismiss-duplicate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Confirm bill is not a duplicate
         * @description Confirm that a bill flagged as a possible duplicate is a genuinely separate invoice, allowing it to be approved. The link to the bill it was flagged against is kept for the record. If the bill really is a duplicate, void it instead. Bills that were never flagged are unaffected.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BillResponse"];
                    };
                };
                /** @description Bill.TransitionFailed — bill is not in a state that allows this transition */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Bill.NotFound — bill does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Conflict — another change to the same record landed first; retry the request */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/bills/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get bill
         * @description Retrieve a single bill with its full detail including line items and supplier.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    /** @description Populate matchSummary on the bill — its three-way match status and the purchase orders and delivery notes it is matched to. Off by default: it costs two extra lookups and is only meaningful for organisations that raise purchase orders. For per-line variances and match suggestions, fetch the bill's match group instead. */
                    IncludeMatch?: boolean;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the bill. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BillResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Bill.NotFound — bill does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /**
         * Patch bill
         * @description Update extracted fields on a bill during review. Only bills in PendingReview state can be edited. Only the fields provided are changed; omitted fields are left as they are. When lineItems is sent, lines with an id update that line, lines without an id are added, and existing lines left out of the list are deleted.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        patch: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the bill. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["PatchBillRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BillResponse"];
                    };
                };
                /**
                 * @description Bill.InvalidAmount — amount value is not valid
                 *
                 *     Bill.InvalidCurrency — currency code is not valid
                 *
                 *     Bill.PatchFailed — bill is not in PendingReview state or bank detail validation failed
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Bill.NotFound — bill does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Bill.SupplierCreditApplied — supplier credit is applied to this bill, so its supplier and currency cannot change and its total cannot drop below the credited amount
                 *
                 *     Bill.NotEditableEInvoice — bill arrived as an e-invoice and its contents cannot be changed
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        trace?: never;
    };
    "/v1/bills/{id}/file-url": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get bill file URL
         * @description Get a short-lived URL for the bill's document. For an uploaded or emailed bill this is a signed link to the stored file; for one received over an e-invoicing network it is a link to the document held by the network provider. Returns bill.no_file when the bill has no document to show.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BillFileUrlResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Bill.NotFound — bill does not exist or belongs to a different organisation
                 *
                 *     Bill.NoFile — bill has no document to show
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/bills/inbound-email-address": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get the inbound bill email address for the current organisation
         * @description Returns the unique email address the organisation and its allowed senders can forward bills to. The address carries a per-org secret 3-word token that routes the mail; only forwards from the org's own users or explicitly-allowed senders (and passing email authentication) are imported — everything else is dropped and recorded in the 'senders waiting' list.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["InboundEmailAddressResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Organisation.NotFound — the organisation does not exist or could not be resolved */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/bills/audit-logs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List recent bill activity
         * @description Paged audit-log feed across every bill in the organisation, newest first: state transitions, OCR outcomes, field updates, and display fields for rendering an activity feed.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    Cursor?: string;
                    Limit?: number | string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfBillActivityResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/bills/{billId}/audit-logs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List audit logs for a bill
         * @description Paged audit-log history for a bill: state transitions, actor, and bill snapshot at each step.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    Cursor?: string;
                    Limit?: number | string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    billId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfBillAuditLogResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Bill.NotFound — bill does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/bills/inbound-emails": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List emails sent to your bill forwarding address
         * @description Every email that reached this organisation's bill-forwarding address, whether or not it became a bill, newest first. Each row carries its attachments and, for any that were not taken, the reason — so an invoice that never appeared can be accounted for. Filter with 'ingested' to see only the emails that produced nothing. Attachment content is not stored, only its name, type and size.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    /** @description True for emails that produced at least one bill, false for those that produced none. Omit for both. */
                    Ingested?: boolean;
                    /** @description Narrower than 'ingested': Ingested, PartiallyIngested, NoBillAttachments, Rejected, Failed or Received. */
                    Status?: components["schemas"]["InboundEmailStatus"];
                    /** @description Only emails received on or after this date. */
                    ReceivedFrom?: string;
                    /** @description Only emails received on or before this date. */
                    ReceivedTo?: string;
                    Cursor?: string;
                    Limit?: number | string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfInboundEmailResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/bills/{id}/reject": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Reject bill
         * @description Reject a bill with an optional reason. Only bills in NeedsApproval state.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["RejectBillRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BillResponse"];
                    };
                };
                /** @description Bill.TransitionFailed — bill is not in a state that allows this transition */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Bill.NotFound — bill does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Conflict — another change to the same record landed first; retry the request */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/bills/{id}/reopen": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Reopen rejected bill
         * @description Re-open a rejected bill for editing. Only bills in Rejected state.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BillResponse"];
                    };
                };
                /** @description Bill.TransitionFailed — bill is not in a state that allows this transition */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Bill.NotFound — bill does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Conflict — another change to the same record landed first; retry the request */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/bills/{id}/reclassify": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Re-classify a bill
         * @description Re-runs the agent spend-classification pass on a bill in review (PendingReview or NeedsApproval). Every line item that has not been explicitly confirmed by a human is re-classified from scratch — prior agent suggestions and auto-applied picks are replaced; a reviewer's confirmation is never overwritten. Classification is asynchronous: the response returns the bill as it stands now, and the refreshed suggestions arrive a moment later over SignalR (`billClassified`). Use after correcting a description or supplier, or when the first pass got it wrong.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description The bill to re-classify. Must be in review (PendingReview or NeedsApproval). */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BillResponse"];
                    };
                };
                /** @description Bill.TransitionFailed — bill is not in a state that allows this transition */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Bill.NotFound — bill does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Conflict — another change to the same record landed first; retry the request */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/bills/{id}/retry-extraction": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Retry bill extraction
         * @description Retry extraction for a bill in the ExtractionFailed state.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description Accepted */
                202: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BillResponse"];
                    };
                };
                /** @description Bill.TransitionFailed — bill is not in a state that allows this transition */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Bill.NotFound — bill does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Bill.NotEditableEInvoice — bill arrived as an e-invoice and its contents cannot be changed
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/bills/{id}/retry-ocr": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Retry bill extraction (legacy alias)
         * @description Deprecated alias for POST /bills/{id}/retry-extraction; identical behaviour.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description Accepted */
                202: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BillResponse"];
                    };
                };
                /** @description Bill.TransitionFailed — bill is not in a state that allows this transition */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Bill.NotFound — bill does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Conflict — another change to the same record landed first; retry the request */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/bills/{id}/schedule-payment": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Schedule bill payment
         * @description Schedule a payment date and method for an approved bill.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the bill to schedule payment for. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["ScheduleBillPaymentRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BillResponse"];
                    };
                };
                /** @description Bill.TransitionFailed — bill is not in a state that allows this transition */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Bill.NotFound — bill does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Conflict — another change to the same record landed first; retry the request */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/bills/{id}/submit-review": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Submit bill review
         * @description Submit a reviewed bill for approval. Only bills in PendingReview state.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the bill to submit for approval. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BillResponse"];
                    };
                };
                /** @description Bill.TransitionFailed — bill is not in a state that allows this transition */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Bill.NotFound — bill does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Conflict — another change to the same record landed first; retry the request */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/bills/{id}/validate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Validate a bill
         * @description Checks a bill's internal consistency: line items reconcile to the subtotal, subtotal + tax equals the total, required header fields are present, and bank details are well-formed. Returns 200 { valid: true } when the bill is consistent, or a 400 ValidationProblem listing every issue — each with a machine-readable code on the `codes` sidecar — so the caller can decide which to act on. Read-only: it never alters the bill.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the bill to validate. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BillValidationResponse"];
                    };
                };
                /** @description Bill.ValidationFailed — bill failed one or more consistency checks; see the errors map and codes sidecar */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Bill.NotFound — bill does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/bills/{id}/void": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Void bill
         * @description Permanently void a bill with an optional reason. Allowed from ExtractionFailed, PendingReview, NeedsApproval or Rejected. Terminal — start over with a fresh upload.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["VoidBillRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BillResponse"];
                    };
                };
                /** @description Bill.TransitionFailed — bill is not in a state that allows this transition */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Bill.NotFound — bill does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Conflict — another change to the same record landed first; retry the request */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/bank-payments/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get a bank payment
         * @description Returns the current status of an open-banking bill payment, including multi-authorisation progress for business accounts that need a second approver.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the bank payment. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BillPaymentResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description BankPayment.NotFound — payment does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/bills/{id}/pay/bank": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Pay a bill by bank (open banking)
         * @description Initiates a Yapily pay-by-bank payment for an approved bill: the response carries the bank authorisation URL the payer must open, plus the mandatory Yapily Connect disclosure to render on the consent screen. Requires the client to have opted in to pay-by-bank and the supplier's bank details to be confirmed. After bank authorisation the user is redirected to returnUrl (host must be allowlisted on the client). Pays the bill's whole outstanding amount unless amount is given; a part payment leaves the bill PartiallyPaid and payable for the rest. Send an idempotencyKey to make retries safe: the same key returns the original attempt instead of starting another. A payment of the same amount as one completed for the bill in the last 24 hours is refused unless allowDuplicate is true.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the approved bill to pay. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["InitiateBillBankPaymentRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["InitiateBillBankPaymentResponse"];
                    };
                };
                /**
                 * @description Bill.TransitionFailed — bill is not in a state that allows this transition
                 *
                 *     Bill.InvalidPaymentAmount — payment amount must be greater than zero, in whole minor units of the currency
                 *
                 *     BankPayment.InvalidIdempotencyKey — the idempotency key must be 1 to 64 characters
                 *
                 *     BankPayment.InvalidPayerIban — payerIban is not a valid IBAN
                 *
                 *     ValidationProblem — supplier bank details fail validation; per-field errors with machine-readable `codes`
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     BankPayment.RedirectHostNotAllowed — returnUrl host not on the client allowlist
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Bill.NotFound — bill does not exist or belongs to a different organisation
                 *
                 *     BankPayment.PayerAccountNotFound — paying bank account does not exist or belongs to a different organisation
                 */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Bill.OverPayment — payment amount exceeds the bill's outstanding balance
                 *
                 *     BankPayment.IdempotencyKeyReused — the idempotency key was already used for a payment of a different bill or amount
                 *
                 *     BankPayment.PossibleDuplicate — a payment of the same amount for this bill completed in the last 24 hours; resend with allowDuplicate to pay it again
                 *
                 *     BankPayment.PayByBankNotEnabled — the client has not opted in to pay-by-bank
                 *
                 *     BankPayment.SupplierBankDetailsNotVerified — supplier bank details not confirmed by an admin
                 *
                 *     BankPayment.MissingSupplier — bill has no resolved supplier
                 *
                 *     BankPayment.MissingBankDetails — supplier has no bank details for the bill's currency (sort code and account number for GBP, IBAN for EUR)
                 *
                 *     BankPayment.NothingToPay — the bill has no outstanding balance to pay
                 *
                 *     BankPayment.NotRetryable — an earlier payment attempt for this bill has been authorised and may still move money; it can't be replaced until it completes or fails
                 *
                 *     BankPayment.UnsupportedCurrency — bill is not GBP or EUR
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description BankPayment.InstitutionCurrencyUnsupported — the chosen bank can't pay bills in this currency (see the bank's supportedCurrencies)
                 *
                 *     BankPayment.PayerAccountRequired — the chosen bank needs the paying account: give payerBankAccountId or payerIban
                 *
                 *     BankPayment.PayerAccountMismatch — the paying account is not in the bill's currency or not held at the chosen bank
                 */
                422: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description BankPayment.ProviderError — Yapily rejected the authorisation request */
                502: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Service Unavailable
                 *
                 *     BankPayment.NotConfigured — pay-by-bank is not enabled for this environment
                 */
                503: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/bank-payments/institutions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List banks available for pay-by-bank
         * @description Returns the institutions the organisation's payer can pay bills from via open banking, plus the mandatory Yapily Connect disclosure that MUST be rendered verbatim on the consent screen. Sandbox-mode clients see Yapily sandbox institutions.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PaymentInstitutionsResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Service Unavailable
                 *
                 *     BankPayment.NotConfigured — pay-by-bank is not enabled for this environment
                 */
                503: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/bank-details/countries/{code}/profile": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get bank-detail field profile for a country
         * @description Returns per-field requirements, labels, patterns and payment-rail capabilities for the given ISO 3166-1 alpha-2 country code.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token; the organisation is determined without the `x-dolfin-organisation-id` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    code: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CountryBankProfile"];
                    };
                };
                /** @description CountryProfile.NotFound — no bank-detail profile exists for this country code */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/bank-details/countries": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List supported bank-detail countries
         * @description Returns the list of countries for which structured bank-detail profiles are available.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token; the organisation is determined without the `x-dolfin-organisation-id` header.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CountryBankProfileSummary"][];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/bank-details/validate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Validate bank details
         * @description Returns per-field validation errors for a BankDetails payload. Pure format/checksum check — no database lookup.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **or** a JWT Bearer token; the organisation is determined without the `x-dolfin-organisation-id` header.
         */
        post: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["BankDetails"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BankDetailsValidationResult"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/bank-connections/institutions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List banks available to connect
         * @description Returns the UK banks whose accounts can be connected over open banking (balances where the bank offers them), and the Yapily Connect disclosure that must be shown verbatim before the account holder is sent to their bank. Sandbox clients see Yapily sandbox banks.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BankInstitutionsResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Service Unavailable
                 *
                 *     BankConnection.NotConfigured — bank connections are not available for this environment
                 */
                503: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/bank-connections": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List bank connections
         * @description Every bank connection of the organisation, newest first, each with its state and the accounts read through it. Returned whole: an organisation has a handful.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfBankConnectionResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        /**
         * Connect a bank
         * @description Starts a read-only open-banking connection to one of the organisation's banks. The response carries the bank authorisation URL the account holder must open, and the Yapily Connect disclosure to show first. After the bank, the holder is sent to returnUrl with bankConnectionId and status (connected or failed) appended; poll the connection for its outcome. Requires an organisation admin.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["StartBankConnectionRequest"];
                };
            };
            responses: {
                /** @description Created */
                201: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BankConnectionAuthorisationResponse"];
                    };
                };
                /**
                 * @description BankConnection.InstitutionUnsupported — institution is not available for connecting accounts (UK institutions supporting accounts and balances only)
                 *
                 *     BankConnection.InvalidReturnUrl — returnUrl must be an absolute http(s) URL on the client's allowed redirect hosts
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description BankConnection.DemoConnectedForYou — in a demo organisation the bank is connected for it, so no other bank can be connected
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description BankConnection.ProviderError — the open-banking provider rejected the request */
                502: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Service Unavailable
                 *
                 *     BankConnection.NotConfigured — bank connections are not available for this environment
                 */
                503: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/bank-connections/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get a bank connection
         * @description One bank connection with its state, consent dates and accounts. Poll this after the account holder returns from their bank: it moves to Connected once the accounts are read, or to Failed.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the bank connection. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BankConnectionResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description BankConnection.NotFound — bank connection does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        /**
         * Disconnect a bank
         * @description Disconnects the bank: the connection becomes Disconnected at once, its accounts drop out of the bank accounts list, and the consent is withdrawn at the provider. Not for a connection that already failed, was revoked or was disconnected. Requires an organisation admin.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        delete: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the bank connection. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BankConnectionResponse"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description BankConnection.NotFound — bank connection does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description BankConnection.InvalidState — the bank connection is not in a state that allows this action
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/bank-connections/{id}/reconfirm": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Reconfirm a bank connection
         * @description Records the account holder's 90-day reconfirmation of continued access, moving reconfirmBy forward. Only for a Connected connection. A bank that cannot take a reconfirmation moves the connection to Reauthorising instead; reauthorise it at the bank. Requires an organisation admin.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the bank connection. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BankConnectionResponse"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description BankConnection.NotFound — bank connection does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description BankConnection.InvalidState — the bank connection is not in a state that allows this action
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description BankConnection.ProviderError — the open-banking provider rejected the request */
                502: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/bank-connections/{id}/reauthorise": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Reauthorise a bank connection
         * @description Asks the bank for a new authorisation of an Expired (or Reauthorising) connection and returns the authorisation URL for the account holder, with the disclosure to show first. Completing it returns the connection to Connected with the same accounts. Requires an organisation admin.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the bank connection. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["ReauthoriseBankConnectionRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BankConnectionAuthorisationResponse"];
                    };
                };
                /** @description BankConnection.InvalidReturnUrl — returnUrl must be an absolute http(s) URL on the client's allowed redirect hosts */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description BankConnection.NotFound — bank connection does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description BankConnection.InvalidState — the bank connection is not in a state that allows this action
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description BankConnection.ProviderError — the open-banking provider rejected the request */
                502: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/bank-accounts": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List bank accounts
         * @description The organisation's connected bank accounts with identifiers and latest balance, across every connection that is not Disconnected or Revoked. Each carries its connection's state: balances only refresh while it is Connected. Returned whole.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfBankAccountResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/bank-accounts/{id}/transactions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List bank account transactions
         * @description Transactions on one connected bank account, newest first, synced from the bank: up to 90 days back when the account is first connected, then daily while its connection is Connected. Pending transactions may change or disappear on a later sync. Not available once the connection is Disconnected or Revoked.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    /** @description Opaque pagination cursor. Pass back `next` or `previous` from a previous page's cursors. */
                    Cursor?: string;
                    /** @description Page size, 1 to 100. Defaults to 50. */
                    Limit?: number | string;
                    /** @description Only transactions booked at or after this UTC instant. */
                    From?: string;
                    /** @description Only transactions booked at or before this UTC instant. */
                    To?: string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the bank account. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfBankTransactionResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description BankAccount.NotFound — bank account does not exist, belongs to a different organisation, or its connection was disconnected or revoked */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/auth/codes": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Create auth code
         * @description Issue a short-lived authorisation code that a user can exchange for an access token. The token covers every organisation the user belongs to under the calling Client (memberships under other Clients are never included); the runtime org is selected via the x-dolfin-organisation-id header.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) only — server-to-server. Bearer tokens are not accepted.
         */
        post: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["CreateAuthCodeRequest"];
                };
            };
            responses: {
                /** @description Created */
                201: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["CreateAuthCodeResponse"];
                    };
                };
                /** @description User.MissingUserId — user ID is required */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description User.NotInClient — user is not a member of any organisation under this client */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/auth/exchange": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Exchange code
         * @description Exchange a short-lived authorisation code for a fresh access token.
         *
         *     **Authentication.** None — this endpoint is public (e.g. a webhook or tokened link).
         */
        post: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["ExchangeRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["AuthResponse"];
                    };
                };
                /** @description Auth.NotUserScopedToken — auth code is not user-scoped; use POST /auth/register for org-scoped tokens */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Auth.InvalidAuthCode — auth code is invalid, expired, or already used
                 *
                 *     Auth.InvalidCredentials — user account associated with the auth code no longer exists
                 */
                401: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/me": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get current user with Organisation + Client memberships
         * @description Returns the calling Bearer user, their Organisation memberships (sandbox), and their Client memberships (portal). The JWT carries IDs + roles for authorization; this endpoint surfaces names, Live/Sandbox client type and the modules each Client holds, for UI rendering. Modules are read per request, so re-fetch /me after a Module.NotEntitled 403 rather than waiting for a new token.
         *
         *     **Authentication.** A JWT Bearer token. API keys are not accepted.
         */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["MeResponse"];
                    };
                };
                /** @description Unauthorized — no valid Bearer token */
                401: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Auth.UserNoLongerExists — Bearer token's user id does not match any User row */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/accounting/receivables-settings": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get invoice accounting settings
         * @description Returns how the organisation's invoices are pushed into its accounting platform: whether one is connected, the default income account invoice revenue posts to, and the bank account payments are deposited into.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ArAccountingSettingsResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /**
         * Update invoice accounting settings
         * @description Sets the default income account invoice revenue posts to and the bank account payments are deposited into, from the synced chart of accounts. Issued invoices are pushed to the accounting platform automatically once a default income account is set. Choosing a Stripe clearing and a Stripe fees account records Stripe card payments into clearing and pushes each Stripe payout as clearing to the deposit account, less Stripe's fees.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        patch: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["UpdateArAccountingSettingsRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ArAccountingSettingsResponse"];
                    };
                };
                /**
                 * @description ArAccounting.LedgerAccountNotFound — when a referenced ledger account is not an active account in the organisation's synced chart of accounts
                 *
                 *     ArAccounting.DepositAccountNotBank — when the deposit account is not a bank account
                 *
                 *     ArAccounting.StripeClearingAccountInvalid — when the Stripe clearing account is not a current asset (Xero) or a current asset or bank account (QuickBooks), or is the deposit account itself
                 *
                 *     ArAccounting.StripeClearingPaymentsDisabled — when the Xero account chosen for Stripe clearing does not have "Enable payments to this account" switched on, so Xero would refuse invoice payments into it
                 *
                 *     ArAccounting.StripeFeesAccountNotExpense — when the Stripe fees account is not an expense account
                 *
                 *     Request.InvalidBody — the request body is missing, malformed, or omits a required property
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description ArAccounting.NotConnected — when the organisation has no callable accounting connection
                 *
                 *     ArAccounting.StripeAccountsLocked — when the Stripe clearing or fees account would change, or be removed, while they are locked for the organisation; the problem detail says how to release them
                 *
                 *     ArAccounting.StripeClearingHasUnsettledPayments — when the Stripe clearing account would change, or be removed, while recent Stripe payments already recorded in the accounting platform are still waiting for their payout: Stripe has not paid them out yet, or their payout has not reached the accounting platform
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description ArAccounting.StripeUnavailable — when Stripe could not be asked which card payments it has already paid out, so a Stripe clearing change cannot be checked
                 *
                 *     ArAccounting.PlatformUnavailable — when the accounting platform could not be reached to check the chosen account
                 */
                502: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        trace?: never;
    };
    "/v1/accounting/tax-rate-mappings": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List tax rate mappings
         * @description Lists every tax rate an invoice line can carry, with the accounting platform tax rate each one posts as. An invoice using an unmapped rate cannot be pushed until the rate is mapped.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["TaxRateMappingResponse"][];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/accounting/tax-rate-mappings/{taxRateId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Map a tax rate
         * @description Sets the accounting platform tax rate a Dolfin tax rate posts as when invoices are pushed, replacing any earlier choice.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        put: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the Dolfin tax rate. */
                    taxRateId: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["SetTaxRateMappingRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["TaxRateMappingResponse"];
                    };
                };
                /** @description ArAccounting.AccountingTaxRateNotFound — when the referenced accounting platform tax rate is not an active rate synced for this organisation */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description ArAccounting.TaxRateNotFound — when the tax rate does not exist or belongs to another organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        post?: never;
        /**
         * Unmap a tax rate
         * @description Removes a tax rate's mapping. Invoices using the rate cannot be pushed until it is mapped again. Removing a mapping that does not exist succeeds.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        delete: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the Dolfin tax rate. */
                    taxRateId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description No Content */
                204: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description ArAccounting.TaxRateNotFound — when the tax rate does not exist or belongs to another organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/invoices/{id}/accounting/push": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Push an invoice to the accounting platform
         * @description Pushes an issued invoice to the organisation's accounting platform (Xero, QuickBooks), then every payment, credit note and void recorded against it that is not there yet. Issued invoices are pushed automatically; use this for one issued before the platform was connected, or to retry one whose push failed. Runs in the background: the response is the invoice's sync status now, and GET /invoices/{id} shows how it went.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the invoice. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description Accepted */
                202: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["AccountingDocumentSyncResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Invoice.NotFound — no invoice with that id for this organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description ArAccounting.InvoiceNotPushable — when the invoice is a draft, or was voided without ever reaching the accounting platform
                 *
                 *     ArAccounting.NotConnected — when the organisation has no callable accounting connection
                 *
                 *     ArAccounting.NotConfigured — when no default income account has been chosen, so nothing can be pushed yet
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/ap/approval-policies": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List approval policies
         * @description List the organisation's approval policies (active and inactive), ordered by priority (lowest first).
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ApprovalPolicyResponse"][];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        /**
         * Create approval policy
         * @description Create an approval policy for the organisation. Evaluated at bill submit-review to auto-approve, route for review, or auto-void.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["UpsertApprovalPolicyRequest"];
                };
            };
            responses: {
                /** @description Created */
                201: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ApprovalPolicyResponse"];
                    };
                };
                /**
                 * @description ApprovalPolicy.NameRequired — a policy name is required
                 *
                 *     ApprovalPolicy.InvalidPriorityOrder — priority order must be between 0 and 1000
                 *
                 *     ApprovalPolicy.InvalidAmountRange — the lower amount bound must not exceed the upper bound
                 *
                 *     ApprovalPolicy.CurrencyRequired — a currency is required when an amount condition is set
                 *
                 *     Currency.NotFoundByCode — the specified currency is not supported
                 *
                 *     ApprovalPolicy.TooManyApprovers — more than the maximum number of approvers were supplied
                 *
                 *     ApprovalPolicy.ApproverNotInOrganisation — a supplied approver is not a member of this organisation
                 *
                 *     ApprovalPolicy.SupplierNotInOrganisation — a supplied supplier does not belong to this organisation
                 *
                 *     ApprovalPolicy.LimitReached — the per-organisation approval policy limit has been reached
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/ap/approval-policies/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get approval policy
         * @description Retrieve a single approval policy by id.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the approval policy. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ApprovalPolicyResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description ApprovalPolicy.NotFound — approval policy does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        /**
         * Update approval policy
         * @description Replace an approval policy's configuration. In-flight bills are unaffected — they carry a snapshot of the decision made at submit time.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        put: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the approval policy. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["UpsertApprovalPolicyRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ApprovalPolicyResponse"];
                    };
                };
                /**
                 * @description ApprovalPolicy.NameRequired — a policy name is required
                 *
                 *     ApprovalPolicy.InvalidPriorityOrder — priority order must be between 0 and 1000
                 *
                 *     ApprovalPolicy.InvalidAmountRange — the lower amount bound must not exceed the upper bound
                 *
                 *     ApprovalPolicy.CurrencyRequired — a currency is required when an amount condition is set
                 *
                 *     Currency.NotFoundByCode — the specified currency is not supported
                 *
                 *     ApprovalPolicy.TooManyApprovers — more than the maximum number of approvers were supplied
                 *
                 *     ApprovalPolicy.ApproverNotInOrganisation — a supplied approver is not a member of this organisation
                 *
                 *     ApprovalPolicy.SupplierNotInOrganisation — a supplied supplier does not belong to this organisation
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description ApprovalPolicy.NotFound — approval policy does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        post?: never;
        /**
         * Delete approval policy
         * @description Delete an approval policy. Bills it has already been applied to keep their snapshot and are unaffected.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        delete: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the approval policy. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description No Content */
                204: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description ApprovalPolicy.NotFound — approval policy does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/accounting/payables-settings": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get bill accounting settings
         * @description Returns how the organisation's bills are pushed into its accounting platform: whether one is connected, the default expense account bill lines post to, and the account bill payments are paid from.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ApAccountingSettingsResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /**
         * Update bill accounting settings
         * @description Sets the default expense account bill lines post to and the bank or credit card account bill payments are paid from, from the synced chart of accounts. Approved bills are pushed to the accounting platform automatically once a default expense account is set.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        patch: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["UpdateApAccountingSettingsRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ApAccountingSettingsResponse"];
                    };
                };
                /**
                 * @description ApAccounting.LedgerAccountNotFound — when a referenced ledger account is not an active account in the organisation's synced chart of accounts
                 *
                 *     ApAccounting.PaymentAccountNotPayable — when the bill payment account is not a bank or credit card account
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description ApAccounting.NotConnected — when the organisation has no callable accounting connection */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        trace?: never;
    };
    "/v1/bills/{id}/accounting/coding": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /**
         * Set where bill lines go in the books
         * @description Sets the ledger account and accounting platform tax rate of bill lines, overriding the supplier's default account, the organisation's default expense account and the tax rate Dolfin would choose. Accepted from review until the bill is in the accounting platform, including after approval, so a bill whose push failed on its coding can be fixed and pushed again. Once it is there, change it there.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        patch: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the bill. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["SetBillCodingRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["BillResponse"];
                    };
                };
                /**
                 * @description Bill.TransitionFailed — bill is not in a state that allows this transition
                 *
                 *     ApAccounting.LineNotFound — when a line id is not a line of this bill
                 *
                 *     ApAccounting.LedgerAccountNotFound — when a referenced ledger account is not an active account in the organisation's synced chart of accounts
                 *
                 *     ApAccounting.AccountingTaxRateNotFound — when the referenced accounting platform tax rate is not an active rate synced for this organisation
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Bill.NotFound — bill does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description ApAccounting.AlreadySynced — when the bill is already in the accounting platform, so its coding can only be changed there
                 *
                 *     Request.Conflict — another change to the same record landed first; retry the request
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Request.Failed — the command failed while being processed */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Gateway Timeout
                 *
                 *     Request.Timeout — the command did not complete in time; it may still be applied
                 */
                504: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        trace?: never;
    };
    "/v1/bills/{id}/accounting/push": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Push a bill to the accounting platform
         * @description Pushes an approved bill to the organisation's accounting platform (Xero, QuickBooks), with its supplier and original document, then its payment and any supplier credit applied to it that is not there yet. Approved bills are pushed automatically; use this for one approved before the platform was connected, or to retry one whose push failed. Runs in the background: the response is the bill's sync status now, and GET /bills/{id} shows how it went.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    /** @description Id of the bill. */
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description Accepted */
                202: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["AccountingDocumentSyncResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Bill.NotFound — bill does not exist or belongs to a different organisation */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description ApAccounting.BillNotPushable — when the bill has not been approved, so it is not pushed yet
                 *
                 *     ApAccounting.NotConnected — when the organisation has no callable accounting connection
                 *
                 *     ApAccounting.NotConfigured — when no default expense account has been chosen, so nothing can be pushed yet
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/agent/ar": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Chat with AR agent
         * @description Agent - AR
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["AgentRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /**
                 * @description Agent.MissingMessage — message is required
                 *
                 *     Agent.MessageTooLong — message exceeds 8000 characters
                 *
                 *     Agent.PagePathTooLong — page path exceeds 500 characters
                 *
                 *     Agent.PageTitleTooLong — page title exceeds 120 characters
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Conversation.Forbidden — conversation belongs to a different user */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Conversation.NotFound — conversation does not exist */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Conversation.WrongAgent — conversation was started with a different agent type */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/agent/ap": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Chat with AP agent
         * @description Agent - AP
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["AgentRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /**
                 * @description Agent.MissingMessage — message is required
                 *
                 *     Agent.MessageTooLong — message exceeds 8000 characters
                 *
                 *     Agent.PagePathTooLong — page path exceeds 500 characters
                 *
                 *     Agent.PageTitleTooLong — page title exceeds 120 characters
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Conversation.Forbidden — conversation belongs to a different user */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Conversation.NotFound — conversation does not exist */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Conversation.WrongAgent — conversation was started with a different agent type */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/agent/actions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Run a suggested action
         * @description Runs one suggested action from an agent reply (a `suggestion` event, or a message's `suggestions`): calls the named agent tool with its input, as the caller, and records the call in the conversation so the agent's next turn knows it happened. The tool applies the same authorisation, module and organisation checks as its REST endpoint, and its own errors are returned unchanged with their status.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["AgentActionRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["AgentActionResponse"];
                    };
                };
                /** @description Agent.UnknownTool — tool is not an agent tool on the conversation's agent */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Conversation.Forbidden — conversation belongs to a different user */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Conversation.NotFound — conversation does not exist */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/agent/conversations/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get agent conversation
         * @description Returns the conversation's metadata. For message history use GET /agent/conversations/{id}/messages.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ConversationDetailResponse"];
                    };
                };
                /** @description Conversation.NotFound — conversation does not exist */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        /**
         * Delete conversation
         * @description Hard-deletes the conversation and cascades to its messages.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        delete: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description No Content */
                204: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Conversation.NotFound — conversation does not exist */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        /**
         * Rename conversation
         * @description Updates the conversation title. Pass an empty string to restore the auto-generated title on the next message.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        patch: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["PatchConversationRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ConversationDetailResponse"];
                    };
                };
                /** @description Agent.TitleTooLong — title exceeds 120 characters */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Conversation.NotFound — conversation does not exist */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        trace?: never;
    };
    "/v1/agent/conversations/{id}/messages": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List conversation messages
         * @description Paged message history for a conversation — useful for long conversations where the detail endpoint's inline messages would be too large.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    Cursor?: string;
                    Limit?: number | string;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path: {
                    id: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfConversationMessageResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Conversation.NotFound — conversation does not exist */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/agent/conversations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List agent conversations
         * @description Returns the caller's conversations ordered by most recent activity. Filter by `agentType` to scope to AR, AP, or All.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    Cursor?: string;
                    Limit?: number | string;
                    AgentType?: components["schemas"]["AgentType"];
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["PagedResponseOfConversationSummaryResponse"];
                    };
                };
                /** @description Pagination.InvalidCursor — the cursor value is invalid */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/accounting/connection-session": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Start an accounting connection
         * @description Creates a session for the accounting provider's hosted connect flow. Embed it in your own UI under your own branding — the accounting platform's credentials are held by the provider and never pass through Dolfin or your servers. Supply redirectUri to control where the consumer lands afterwards.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: {
                content: {
                    "application/json": null | components["schemas"]["CreateAccountingConnectionSessionRequest"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["ConnectSessionResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Service Unavailable
                 *
                 *     Expense.ProviderNotConfigured — when the card or accounting provider is not configured for this environment
                 */
                503: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/accounting/connection": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get the accounting connection
         * @description Returns the organisation's accounting connection, when it last synced, and whether a re-sync is allowed yet. Use lastSyncedAt and canSyncNow to render freshness and to disable your own sync control rather than letting a request fail.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["AccountingConnectionResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        /**
         * Disconnect the accounting platform
         * @description Disconnects the accounting platform: the credentials held for it are revoked and nothing more is posted. Synced accounts and already-posted expenses are kept; expenses waiting to post stay waiting until a platform is connected again with POST /accounting/connection-session. Reconnecting to a different company retires the accounts synced from the old one. Organisation admins only. Disconnecting an organisation with no connection succeeds.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        delete: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description No Content */
                204: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /**
                 * @description Module.NotEntitled — the client's plan does not include the module this endpoint requires
                 *
                 *     Organisation.InsufficientRole — caller's organisation role is below the level this action requires
                 */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Expense.AccountingDisconnectFailed — when the accounting provider could not revoke the connection; nothing was changed, so try again */
                502: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/accounting/sync": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Sync accounting data
         * @description Pulls the chart of accounts, tax rates and tracking categories from the connected accounting platform. Rate-limited: a sync requested too soon after the last one returns a conflict with the time remaining, so poll lastSyncedAt rather than retrying.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description Accepted */
                202: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["AccountingSyncResponse"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Expense.AccountingNotConnected — when the organisation has no callable accounting connection
                 *
                 *     Expense.SyncThrottled — when an accounting sync was requested inside the minimum interval since the last one
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Expense.SyncFailed — when the accounting platform rejected or failed the sync */
                502: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/accounting/ledger-accounts": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List ledger accounts
         * @description Returns the organisation's chart of accounts as last synced. Filter by classification=expense for the accounts expenses are coded to. This is the source for card configuration and merchant-category mapping.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: {
                    /** @description Only accounts of this classification, e.g. expense, revenue, asset, liability or equity. */
                    Classification?: string;
                    /** @description Matches the account name or code, case-insensitively. */
                    Search?: string;
                    /** @description Include archived accounts. Defaults to false. */
                    IncludeInactive?: boolean;
                };
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["LedgerAccountResponse"][];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        /**
         * Create a ledger account
         * @description Creates an account in the organisation's connected accounting platform and adds it to the synced chart of accounts straight away, so spend can be coded to it without leaving Dolfin. Expense-side accounts, and a current asset that accepts payments (such as a Stripe clearing account), can be created here. A platform that requires account codes (Xero) needs a code; if the platform refuses the account, its own message is returned.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody: {
                content: {
                    "application/json": components["schemas"]["CreateLedgerAccountRequest"];
                };
            };
            responses: {
                /** @description Created */
                201: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["LedgerAccountResponse"];
                    };
                };
                /**
                 * @description Request.InvalidBody — the request body is missing, malformed, or omits a required property
                 *
                 *     Expense.LedgerAccountCodeRequired — when the connected accounting platform requires an account code and none was given
                 */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Expense.AccountingNotConnected — when the organisation has no callable accounting connection
                 *
                 *     Expense.LedgerAccountNameTaken — when the organisation's chart of accounts already has an active account with that name
                 */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Expense.LedgerAccountRejected — when the accounting platform refused to create the account; the message is the platform's own */
                422: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
                /**
                 * @description Service Unavailable
                 *
                 *     Expense.ProviderNotConfigured — when the card or accounting provider is not configured for this environment
                 */
                503: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/accounting/tax-rates": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List accounting tax rates
         * @description Returns the tax rates available in the connected accounting platform. The code is what gets applied to a pushed expense line, so tax codes on mappings and coding overrides must come from this list rather than being typed by hand.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["AccountingTaxRateResponse"][];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/accounting/tracking-categories": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List tracking categories
         * @description Returns project, department and cost-centre dimensions from the connected accounting platform. Synced and readable now; assigning them to expense lines is not yet supported.
         *
         *     **Authentication.** An API key (`x-dolfin-api-key`) **together with** the `x-dolfin-organisation-id` header identifying the organisation, **or** a JWT Bearer token that carries the organisation in its claims.
         */
        get: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Target organisation. **Required when authenticating with an API key**; omit for Bearer callers (resolved from the token). */
                    "x-dolfin-organisation-id"?: string;
                };
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["TrackingCategoryResponse"][];
                    };
                };
                /** @description Module.NotEntitled — the client's plan does not include the module this endpoint requires */
                403: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/problem+json": components["schemas"]["ProblemDetails"];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
}
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        /** @description The organisation's connection to its accounting platform. */
        AccountingConnectionResponse: {
            /** @description Connection status: Pending, Callable, Broken or Revoked. Only a Callable connection can be synced or posted to. */
            status?: components["schemas"]["AccountingConnectionStatus"];
            /** @description The connected accounting platform, e.g. xero or quickbooks. */
            serviceId?: null | string;
            /** @description Display name of the connected platform. */
            serviceDisplayName?: null | string;
            /** @description URL of the connected platform's icon. */
            serviceIconUrl?: null | string;
            /** @description The company's own id within the platform: the QuickBooks realm id or the Xero tenant id. */
            companyId?: null | string;
            /** @description Name of the company in the accounting platform that expenses post to. */
            companyName?: null | string;
            /** @description The company's registered legal name, where the platform holds one. */
            companyLegalName?: null | string;
            /** @description The company's country as the platform reports it, usually an ISO 3166 alpha-2 code such as GB. */
            companyCountry?: null | string;
            /** @description The company's base currency as an ISO 4217 code, e.g. GBP. */
            companyCurrency?: null | string;
            /**
             * Format: int32
             * @description Month the company's financial year starts, 1 (January) to 12.
             */
            financialYearStartMonth?: null | number | string;
            /** @description The company's sales tax (VAT) registration number, where the platform holds one. */
            companySalesTaxNumber?: null | string;
            /** @description How the books are kept, as the platform reports it: accrual or cash. */
            accountingMethod?: null | string;
            /**
             * Format: date-time
             * @description When the connection was first established.
             */
            connectedAt?: null | string;
            /**
             * Format: date-time
             * @description When accounts, tax rates and tracking categories were last synced. Use this to show how fresh the data is and to decide whether a re-sync is worth offering.
             */
            lastSyncedAt?: null | string;
            /** @description Why the last sync failed, when it did. */
            lastSyncError?: null | string;
            /**
             * Format: int32
             * @description Number of ledger accounts held from the last sync.
             */
            ledgerAccountCount?: number | string;
            /**
             * Format: int32
             * @description Number of tax rates held from the last sync.
             */
            taxRateCount?: number | string;
            /**
             * Format: int32
             * @description Number of tracking categories held from the last sync.
             */
            trackingCategoryCount?: number | string;
            /** @description Whether a re-sync is currently allowed. Syncs are rate-limited to protect the accounting platform. */
            canSyncNow?: boolean;
            /**
             * Format: int32
             * @description Seconds until a re-sync is allowed, when one is not allowed yet.
             */
            retryAfterSeconds?: null | number | string;
            /**
             * Format: uuid
             * @description The account personal spend is posted to.
             */
            personalLedgerAccountId?: null | string;
        };
        /** @enum {unknown} */
        AccountingConnectionStatus: "Pending" | "Callable" | "Broken" | "Revoked";
        /** @description Where a document stands in the organisation's accounting platform (Xero, QuickBooks). Absent when it has never been pushed. */
        AccountingDocumentSyncResponse: {
            /** @description Waiting: held until the invoice or bill it belongs to is in the accounting platform (lastError may say what else it waits for). Pending: being pushed now. Synced: in the platform. Failed: the platform refused it, could not be reached, or a person needs to act in the platform; lastError says why, and pushing the invoice or bill again retries it. Skipped: nothing to push, for example a payment wholly beyond what the invoice was owed. */
            status?: components["schemas"]["AccountingSyncStatus"];
            /** @description The accounting platform it went to, e.g. "xero" or "quickbooks". */
            platform: string;
            /** @description The document's id in the accounting platform, once it is there. */
            platformId?: null | string;
            /** @description A link that opens the document in the accounting platform's own web app, for invoices, credit notes, bills and supplier credit notes that are there. Null otherwise. */
            url?: null | string;
            /** @description Why the last push failed, was skipped or is waiting, in the accounting platform's own words where it gave any. Null once synced. */
            lastError?: null | string;
            /**
             * Format: int32
             * @description How many times it has been pushed.
             */
            attempts?: number | string;
            /**
             * Format: date-time
             * @description When the last push was attempted (UTC).
             */
            lastAttemptAt?: null | string;
            /**
             * Format: date-time
             * @description When it reached the accounting platform (UTC).
             */
            syncedAt?: null | string;
        };
        /** @description Result of an accounting data sync. */
        AccountingSyncResponse: {
            /**
             * Format: int32
             * @description Number of ledger accounts synced.
             */
            ledgerAccounts?: number | string;
            /**
             * Format: int32
             * @description Number of tax rates synced.
             */
            taxRates?: number | string;
            /**
             * Format: int32
             * @description Number of tracking categories synced.
             */
            trackingCategories?: number | string;
            /**
             * Format: date-time
             * @description When the sync completed.
             */
            syncedAt?: string;
        };
        /**
         * @description Waiting: held until the document it belongs to (its invoice or bill) is in the accounting platform. Pending: being pushed now. Synced: in the platform. Failed: the platform refused it, could not be reached, or it needs a person to act in the platform; lastError says why, and pushing the invoice or bill again retries it. Skipped: nothing to push, for example a payment wholly beyond what the invoice was owed.
         * @enum {unknown}
         */
        AccountingSyncStatus: "Waiting" | "Pending" | "Synced" | "Failed" | "Skipped";
        /** @description A tax rate from the organisation's accounting platform. The code is what gets applied to a pushed expense line. */
        AccountingTaxRateResponse: {
            /**
             * Format: uuid
             * @description Unique identifier of the tax rate within Dolfin.
             */
            id?: string;
            /** @description The tax code the accounting platform expects on a transaction line. */
            code: string;
            /** @description Human-readable name of the tax rate. */
            name?: null | string;
            /**
             * Format: double
             * @description Rate as a percentage.
             */
            rate?: null | number | string;
            /** @description What the platform says the rate is for, where it says: Xero's OUTPUT (sales) or INPUT (purchases), for example. Null when the platform gives no type (QuickBooks). */
            type?: null | string;
            /** @description The platform's own description of the rate, where it gives one (QuickBooks: "Standard", "Exempt From VAT"). */
            description?: null | string;
            /** @description Whether the rate is still active in the accounting platform. */
            isActive?: boolean;
            /**
             * Format: date-time
             * @description When the rate was last synced.
             */
            syncedAt?: string;
        };
        ActivityAnalyticsAdminResponse: {
            scope: components["schemas"]["ActivityScope"];
            /** Format: uuid */
            clientId?: null | string;
            /** Format: uuid */
            organisationId?: null | string;
            /** Format: date-time */
            asOf: string;
            totals: components["schemas"]["ActivityResourceTotal"][];
            months: components["schemas"]["ActivityPeriod"][];
            weeks: components["schemas"]["ActivityPeriod"][];
            organisations: components["schemas"]["ActivityOrganisation"][];
        };
        ActivityOrganisation: {
            /** Format: uuid */
            organisationId: string;
            organisationName: string;
            /** Format: uuid */
            clientId: string;
            clientName: string;
            /** Format: date-time */
            firstActivityAt?: null | string;
            /** Format: date-time */
            lastActiveAt?: null | string;
            /** Format: int32 */
            total: number | string;
            resources: components["schemas"]["ActivityResourceTotal"][];
            months: components["schemas"]["ActivityOrganisationPeriod"][];
            weeks: components["schemas"]["ActivityOrganisationPeriod"][];
        };
        ActivityOrganisationPeriod: {
            /** Format: date */
            start: string;
            /** Format: int32 */
            total: number | string;
            counts: components["schemas"]["ActivityResourceTotal"][];
        };
        ActivityPeriod: {
            /** Format: date */
            start: string;
            /** Format: int32 */
            activeOrganisations: number | string;
            /** Format: int32 */
            total: number | string;
            counts: components["schemas"]["ActivityResourceCount"][];
        };
        /** @enum {unknown} */
        ActivityResource: "Bills" | "Invoices" | "Customers" | "Suppliers" | "Products" | "TaxRates" | "PurchaseOrders" | "DeliveryNotes" | "CreditNotes" | "SupplierCreditNotes" | "Expenses" | "Receipts";
        ActivityResourceCount: {
            resource: components["schemas"]["ActivityResource"];
            /** Format: int32 */
            count: number | string;
        };
        ActivityResourceTotal: {
            resource: components["schemas"]["ActivityResource"];
            /** Format: int32 */
            count: number | string;
            /** Format: date-time */
            firstCreatedAt?: null | string;
            /** Format: date-time */
            lastCreatedAt?: null | string;
        };
        /** @enum {unknown} */
        ActivityScope: "Global" | "Client" | "Organisation";
        /** @enum {unknown} */
        ActorType: "User" | "System";
        /** @description Allocates a bill line against a purchase-order line (price) and/or a delivery-note line (receipt quantity). At least one counterpart is required. */
        AddAllocationRequest: {
            /**
             * Format: uuid
             * @description The bill line being matched.
             */
            billLineId: string;
            /**
             * Format: uuid
             * @description The purchase-order line to match against (the price dimension). Optional, but at least one of purchase-order or delivery-note line is required.
             */
            poLineId?: null | string;
            /**
             * Format: uuid
             * @description The delivery-note line to match against (the receipt-quantity dimension). Optional, but at least one of purchase-order or delivery-note line is required.
             */
            dnLineId?: null | string;
            /**
             * Format: double
             * @description Quantity to match on this allocation. Optional — omit it to match the whole of what this counterpart line can still give, which is what a reviewer accepting an order or a delivery outright means: the document is matched as it states itself, even where that exceeds the quantity billed, and the difference is reported as a variance. Supply a quantity only to match part of the counterpart. Zero is a valid quantity and must be supplied explicitly: it records a nil delivery — the item was expected and none of it arrived — binding the counterpart line to the bill line so the whole billed quantity is reported as a variance rather than the line reading unmatched. Omitting the quantity when the counterpart has none left to give is rejected instead.
             */
            matchedQuantity?: null | number | string;
        };
        AddBillAllowedSenderRequest: {
            /** @description Whether Value is a full email address ('Address') or a whole domain ('Domain'). */
            kind: components["schemas"]["BillAllowedSenderKind"];
            /** @description The email address (accounts@vendor.com) or bare domain (vendor.com) to allow. */
            value: string;
        };
        Address: {
            line1?: null | string;
            line2?: null | string;
            city?: null | string;
            state?: null | string;
            postalCode?: null | string;
            /** @description ISO 3166-1 alpha-2 country code (e.g. GB, US, DE) */
            country?: null | string;
            isEmpty?: boolean;
        };
        AddUserToOrganisationRequest: {
            role?: null | components["schemas"]["OrganisationRole"];
        };
        AdminAgentMessageResponse: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            conversationId?: string;
            role?: components["schemas"]["AgentMessageRole"];
            content?: null | string;
            toolCallsJson?: null | string;
            toolResultsJson?: null | string;
            truncated?: boolean;
            /** Format: int32 */
            inputTokens?: null | number | string;
            /** Format: int32 */
            outputTokens?: null | number | string;
            /** Format: date-time */
            createdAt?: string;
        };
        AdminAgentStatsResponse: {
            /** Format: uuid */
            organisationId?: string;
            /** Format: int32 */
            totalConversations?: number | string;
            conversationsByAgentType: {
                [key: string]: number | string;
            };
            /** Format: int32 */
            totalMessages?: number | string;
            messagesByRole: {
                [key: string]: number | string;
            };
            /** Format: int32 */
            totalInputTokens?: number | string;
            /** Format: int32 */
            totalOutputTokens?: number | string;
            /** Format: int32 */
            truncatedMessageCount?: number | string;
            /** Format: int32 */
            activeUserCount?: number | string;
        };
        AdminConversationDetailResponse: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            organisationId?: string;
            /** Format: uuid */
            userId?: null | string;
            agentType?: components["schemas"]["AgentType"];
            agentSurface: string;
            systemPrompt: string;
            availableTools: string[];
            title?: null | string;
            /** Format: int32 */
            messageCount?: number | string;
            /** Format: int32 */
            truncatedMessageCount?: number | string;
            /** Format: int32 */
            totalInputTokens?: number | string;
            /** Format: int32 */
            totalOutputTokens?: number | string;
            /** Format: date-time */
            firstMessageAt?: null | string;
            /** Format: date-time */
            lastMessageAt?: null | string;
            /** Format: date-time */
            createdAt?: string;
            /** Format: date-time */
            updatedAt?: string;
        };
        AdminConversationResponse: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            organisationId?: string;
            /** Format: uuid */
            userId?: null | string;
            agentType?: components["schemas"]["AgentType"];
            title?: null | string;
            /** Format: int32 */
            messageCount?: number | string;
            /** Format: int32 */
            totalInputTokens?: number | string;
            /** Format: int32 */
            totalOutputTokens?: number | string;
            /** Format: date-time */
            createdAt?: string;
            /** Format: date-time */
            updatedAt?: string;
        };
        AdminCreateApiKeyRequest: {
            /** Format: uuid */
            clientId: string;
            name?: null | string;
            /** Format: date-time */
            expiresAt?: null | string;
        };
        AdminInvoiceEmailResponse: {
            /** Format: uuid */
            organisationId: string;
            /** Format: uuid */
            invoiceId: string;
            /** Format: uuid */
            id: string;
            recipient: string;
            status: string;
            /** Format: uuid */
            messageId: null | string;
            /** Format: date-time */
            createdAt: string;
            /** Format: date-time */
            sentAt: null | string;
            /** Format: date-time */
            deliveredAt: null | string;
            /** Format: date-time */
            bouncedAt: null | string;
            /** Format: date-time */
            spamComplaintAt: null | string;
            bounceType: null | string;
            bounceDescription: null | string;
        };
        AdminInvoiceReminderResponse: {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            invoiceId: string;
            /** Format: uuid */
            organisationId: string;
            offset: null | components["schemas"]["InvoiceReminderOffset"];
            /** Format: date-time */
            scheduledAt: string;
            status: components["schemas"]["InvoiceReminderStatus"];
            subject: null | string;
            body: null | string;
            /** Format: date-time */
            createdAt: string;
            /** Format: date-time */
            updatedAt: string;
            /** Format: date-time */
            sentAt: null | string;
            /** Format: date-time */
            cancelledAt: null | string;
            failureReason: null | string;
        };
        /** @description A suggested action to run, as the agent offered it. */
        AgentActionRequest: {
            /**
             * Format: uuid
             * @description The conversation the suggestion came from. The call is recorded there.
             */
            conversationId: string;
            /** @description The suggestion's id, for tracing. Optional. */
            suggestionId?: null | string;
            /** @description The agent tool to call, from the suggestion's tool. */
            tool: string;
            /** @description The tool's input, from the suggestion's input. */
            input?: components["schemas"]["JsonElement"];
        };
        /** @description The result of a suggested action that ran successfully. */
        AgentActionResponse: {
            data?: null | components["schemas"]["JsonElement"];
            /** @description Records the result mentions, as in the agent's refs event. */
            refs?: components["schemas"]["AgentRef"][];
            /** @description Follow-up actions the result offers (e.g. send an invoice just issued). They replace the suggestion that ran. */
            suggestions?: components["schemas"]["AgentSuggestion"][];
        };
        /** @enum {unknown} */
        AgentMessageRole: "User" | "Assistant" | "Tool";
        AgentPage: {
            /** @description The page's path with its query string, e.g. /invoices?status=Overdue. At most 500 characters. */
            path: string;
            /** @description The page's name as the person sees it, e.g. Profit and loss. At most 120 characters. */
            title: string;
        };
        /** @description A record a tool returned. The chat links every exact mention of label in the reply to it. */
        AgentRef: {
            /** @description What the record is. */
            type: components["schemas"]["AgentRefType"];
            /**
             * Format: uuid
             * @description Id of the record.
             */
            id: string;
            /** @description The text that appears in the reply, e.g. the invoice number INV-0011, a supplier's bill number, an expense as merchant and amount (Pret A Manger £4.50), or a merchant's name. */
            label: string;
        };
        /**
         * @description What a ref points at: invoice (a sales invoice), bill (a supplier bill), expense (card spend) or merchant (where card spend was made).
         * @enum {unknown}
         */
        AgentRefType: "invoice" | "bill" | "expense" | "merchant";
        AgentRequest: {
            /** Format: uuid */
            conversationId?: null | string;
            message: string;
            page?: null | components["schemas"]["AgentPage"];
        };
        /** @description A one-click action offered under the agent's reply. Run it with POST /v1/agent/actions. */
        AgentSuggestion: {
            /** @description Stable id of the suggestion: the same tool and input always give the same id. */
            id: string;
            /** @description The agent tool to call. */
            tool: string;
            /** @description The tool's input, as the tool's own arguments. */
            input: components["schemas"]["JsonElement"];
            /** @description Button text, e.g. 'Send reminder · Acme · INV-0011'. */
            label: string;
            /** @description Why it is suggested, e.g. '23 days overdue'. Optional. */
            reason: null | string;
            /** @description True when the tool changes data, so the user confirms before it runs. */
            confirm: boolean;
            /**
             * @description True once the user has run it from the chat; it is shown as done and not offered again.
             * @default false
             */
            done: boolean;
        };
        /** @enum {unknown} */
        AgentType: "Ar" | "Ap" | "All" | "Books";
        AgingBucket: {
            /** Format: double */
            amount?: number | string;
            /**
             * Format: int32
             * @description Invoices for receivables, bills for payables.
             */
            count?: number | string;
        };
        AgingBuckets: {
            /** @description Issued but not yet due. */
            current?: components["schemas"]["AgingBucket"];
            d1To30?: components["schemas"]["AgingBucket"];
            d31To60?: components["schemas"]["AgingBucket"];
            d61To90?: components["schemas"]["AgingBucket"];
            d90Plus?: components["schemas"]["AgingBucket"];
        };
        AnalyticsOrganisationRow: {
            /** Format: uuid */
            clientId: string;
            clientName: string;
            clientType: components["schemas"]["ClientType"];
            /** Format: uuid */
            organisationId: string;
            organisationName: string;
            /** Format: date-time */
            createdAt: string;
            /** Format: uuid */
            companyId: null | string;
            companyName: null | string;
            /** Format: int32 */
            bills: number | string;
            /** Format: int32 */
            purchaseOrders: number | string;
            /** Format: int32 */
            deliveryNotes: number | string;
            /** Format: int32 */
            totalDocuments: number | string;
        };
        /** @enum {unknown} */
        AnnualRevenue: "Under100k" | "OneHundredToFiveHundredK" | "FiveHundredKToTwoM" | "TwoMPlus" | null;
        /** @description How the organisation's bills are pushed into its accounting platform. */
        ApAccountingSettingsResponse: {
            /** @description True when an accounting platform is connected and callable. Nothing can be pushed, or chosen here, until it is. */
            connected?: boolean;
            /** @description The connected accounting platform, e.g. "xero" or "quickbooks". Null when none is connected. */
            platform?: null | string;
            /** @description The currency the accounting company keeps its books in. Only bills in this currency can be pushed. */
            companyCurrency?: null | string;
            /**
             * Format: uuid
             * @description The ledger account bill lines post to when neither the line nor its supplier names one. Approved bills are pushed automatically once this is set.
             */
            defaultExpenseLedgerAccountId?: null | string;
            /**
             * Format: uuid
             * @description The bank or credit card ledger account bill payments are recorded as paid from. Payments are not pushed until this is set.
             */
            billPaymentLedgerAccountId?: null | string;
        };
        ApiKeyResponse: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            clientId: string;
            keyPrefix: string;
            name?: null | string;
            /** Format: date-time */
            createdAt?: string;
            /** Format: uuid */
            createdBy?: null | string;
            /** Format: date-time */
            expiresAt?: null | string;
            /** Format: date-time */
            revokedAt?: null | string;
        };
        /**
         * @description Which payment link approved bills carry. None: no link. Dolfin: a Dolfin-hosted pay-by-bank page (open banking), which needs pay-by-bank enabled. BringYourOwn: the client's own link, expanded from defaultBillPaymentLinkUrl.
         * @enum {unknown}
         */
        ApPaymentLinkMode: "None" | "Dolfin" | "BringYourOwn";
        /** @description The approval policy, and the revision of it, that decided an expense's routing. */
        AppliedExpenseApprovalPolicyResponse: {
            /**
             * Format: uuid
             * @description Policy id. The policy may since have been deleted.
             */
            id: string;
            /** @description The policy's name when it was applied. */
            name: string;
            /**
             * Format: int32
             * @description The policy's version when it was applied.
             */
            version: number | string;
        };
        ApplySupplierCreditRequest: {
            /**
             * Format: uuid
             * @description The bill to net this credit against. Must belong to the same supplier and currency.
             */
            billId?: string;
            /**
             * Format: double
             * @description Amount of credit to apply. Must be > 0, <= the credit note's available balance, and <= the bill's outstanding balance.
             */
            amount?: number | string;
        };
        /** @enum {unknown} */
        ApprovalPolicyAction: "AutoApprove" | "AlwaysReview" | "AutoVoid";
        ApprovalPolicyResponse: {
            /** Format: uuid */
            id: string;
            name: string;
            /**
             * Format: int32
             * @description 0–1000, lower wins. Also the UI sort order.
             */
            priorityOrder: number | string;
            active: boolean;
            /** Format: double */
            amountGte?: null | number | string;
            /** Format: double */
            amountLte?: null | number | string;
            /** @description ISO 4217. Set when an amount condition is present; scopes the policy to this currency. */
            currency?: null | string;
            /** @description Empty ⇒ global policy (any supplier). Otherwise the policy is supplier-specific. */
            supplierIds: string[];
            supplierStanding: components["schemas"]["SupplierStanding"];
            action: components["schemas"]["ApprovalPolicyAction"];
            /** @description Approvers for AlwaysReview. Empty ⇒ no designated approver (admins action in-app). */
            approverUserIds: string[];
            /** Format: date-time */
            createdAt: string;
            /** Format: date-time */
            updatedAt: string;
        };
        /** @description A bill in the approval queue: waiting for its extracted fields to be reviewed, or for approval. */
        ApprovalQueueBill: {
            /**
             * Format: uuid
             * @description Id of the bill.
             */
            billId?: string;
            /** @description The supplier's own invoice number for the bill, when one was extracted. */
            invoiceNumber?: null | string;
            /** @description The matched supplier's name, else the supplier name read off the document. */
            supplierName: string;
            /**
             * Format: double
             * @description The bill's total, in its currency.
             */
            totalAmount?: number | string;
            /** @description 3-letter ISO currency of the bill. */
            currency: string;
            /** @description PendingReview (its fields need checking before it can be submitted) or NeedsApproval (submitted, waiting for an approver). */
            state?: components["schemas"]["BillState"];
            /**
             * Format: int32
             * @description Whole days the bill has waited in its current step, as of the summary's asOf date: since it was submitted for approval, or since it arrived for a bill still in review.
             */
            daysWaiting?: number | string;
            /** @description True when the caller can approve this bill right now: it is NeedsApproval, the caller is an organisation Admin or Owner, a trusted Client caller or one of its designated approvers, and it is not a duplicate still waiting to be dismissed. */
            awaitingYou?: boolean;
            /** @description True when the bill is flagged as a possible duplicate of another bill and the flag hasn't been dismissed. It can't be approved until someone dismisses the flag. */
            possibleDuplicate?: boolean;
        };
        /** @description Bills waiting on someone in the organisation before they become a liability to pay. */
        ApprovalQueueSummary: {
            /**
             * Format: int32
             * @description Number of bills in PendingReview or NeedsApproval.
             */
            count?: number | string;
            /** @description Up to 5 of those bills, the longest waiting first. */
            oldest?: components["schemas"]["ApprovalQueueBill"][];
        };
        AppSignIns: {
            app: components["schemas"]["SignInApp"];
            /** Format: int32 */
            signIns: number | string;
        };
        ApSettingsResponse: {
            /** @description Client-level kill switch for outbound AP (bill) notification emails. When false, no approval-request emails are sent to approvers and no approved/rejected notices are sent to the submitter; bills still move through approval exactly as before and the client notifies its users out-of-band. Default true. */
            apEmailsEnabled: boolean;
            /** @description Client-level opt-in to the Yapily pay-by-bank flow for this client's organisations. Manual confirm-paid is always available regardless; this gates only open-banking payment initiation. Default false. */
            payByBankEnabled: boolean;
            /** @description Which payment link approved bills carry: None (no link), Dolfin (a Dolfin-hosted pay-by-bank page) or BringYourOwn (defaultBillPaymentLinkUrl expanded per bill). Default None. */
            paymentLinkMode: components["schemas"]["ApPaymentLinkMode"];
            /** @description Bring-your-own payment link template, used when paymentLinkMode is BringYourOwn. Null when unset, in which case bills carry no link in that mode. */
            defaultBillPaymentLinkUrl?: null | string;
            /** @description The template tokens supported in defaultBillPaymentLinkUrl. */
            supportedBillPaymentLinkTokens?: string[];
            /** @description Cosmetic subdomain label for the bill-forwarding address (bills.<token>@<slug>.accountspayable.co). Null when unset — the address then falls back to a slug of the client name. Not a routing key. */
            billForwardingSlug?: null | string;
            /**
             * Format: int32
             * @description Token TTL for bill-approval links, in days: a link expires this many days after the bill's due date (falling back through invoice date → created date). Default 14.
             */
            billReviewTimeAfterDueDate: number | string;
            /** @description Client-level opt-out for duplicate bill detection. When enabled, a newly extracted bill is checked against the organisation's existing bills for the same supplier and invoice number; a match is flagged on the bill and blocks approval until it is confirmed as not a duplicate. No bill is ever voided automatically. Default true. */
            duplicateBillDetectionEnabled: boolean;
            /** @description Client-level opt-in to the Gmail bill-ingestion connector for this client's organisations. Default false. */
            gmailConnectorEnabled: boolean;
            /** @description Hosts the Gmail connector OAuth flow may redirect back to after authorisation (bare hostnames, no scheme/port/path). Empty = none allowed. */
            gmailAllowedRedirectHosts: string[];
            /** @description Hosts the pay-by-bank and bank connection flows may redirect back to after bank authorisation (bare hostnames, no scheme/port/path). Empty = only Dolfin's own pages. */
            paymentAllowedRedirectHosts: string[];
            /**
             * Format: double
             * @description Per-line rounding tolerance (in the bill's currency) for three-way matching. Line amounts within this of each other are treated as reconciled. Default 0.01 (1p).
             */
            matchRoundingTolerance: number | string;
            /**
             * Format: double
             * @description Minimum description-similarity score (0-1) for the matching engine to suggest a fuzzy PO/DN line match. Exact SKU matches bypass this. Lower it if genuine matches are not being offered because the bill wording differs from the supplier's. Default 0.6.
             */
            matchSimilarityThreshold: number | string;
            /**
             * Format: int32
             * @description How many days a purchase order's expected delivery date may fall BEFORE the bill's invoice date and still score full marks on date. Beyond it the date score tapers linearly to zero at 30 days from the invoice date. 0-30 inclusive; 0 means only same-day-or-later orders score full marks.
             */
            poMatchWindowDaysBefore: number | string;
            /**
             * Format: int32
             * @description How many days a purchase order's expected delivery date may fall AFTER the bill's invoice date and still score full marks. Expected delivery legitimately lands either side of an invoice, which is why this is separate from the before window. Beyond it the score tapers to zero at 30 days. 0-30 inclusive.
             */
            poMatchWindowDaysAfter: number | string;
            /**
             * Format: int32
             * @description How many days a delivery note's received date may fall BEFORE the bill's invoice date and still score full marks. Usually the larger of the delivery pair: goods are received before they are invoiced, and one bill often covers a period of drops. Beyond it the score tapers to zero at 30 days. 0-30 inclusive.
             */
            dnMatchWindowDaysBefore: number | string;
            /**
             * Format: int32
             * @description How many days a delivery note's received date may fall AFTER the bill's invoice date and still score full marks. Usually small — an invoice raised before the period's final delivery is normal, a note from the following month is not. Beyond it the score tapers to zero at 30 days. 0-30 inclusive.
             */
            dnMatchWindowDaysAfter: number | string;
            /**
             * Format: double
             * @description Minimum combined supplier-match score (0-1) to suggest a fuzzy supplier link. Exact tax-id/email/name matches bypass this and auto-link. Default 0.7.
             */
            supplierMatchSimilarityThreshold: number | string;
            /**
             * Format: double
             * @description Relative weight of supplier-name similarity in the combined supplier-match score. Normalised against the address weight, so the two need not sum to 1. Default 0.7.
             */
            supplierMatchNameWeight: number | string;
            /**
             * Format: double
             * @description Relative weight of delivery-address similarity in the combined supplier-match score. Normalised against the name weight. Default 0.3.
             */
            supplierMatchAddressWeight: number | string;
            /** @description When true, bill lines are matched against purchase orders automatically — both exact SKU matches and confident fuzzy ones. When false, nothing is allocated against a purchase order without a reviewer, including an identical SKU; suggestions are still offered and can be linked by hand. Default true. */
            poAutoMatchEnabled: boolean;
            /** @description When true, bill lines are matched against delivery notes automatically — both exact SKU matches and confident fuzzy ones. When false, nothing is allocated against a delivery note without a reviewer, including an identical SKU; suggestions are still offered and can be linked by hand. Default true. */
            dnAutoMatchEnabled: boolean;
            /**
             * Format: double
             * @description Match score (0-1) at or above which a single, unambiguous fuzzy candidate is accepted automatically when auto-accept is enabled. Deliberately conservative, so only strong matches corroborated by price, quantity, currency and date are accepted without a reviewer; must be >= MatchSimilarityThreshold. Default 0.90.
             */
            matchAutoAcceptThreshold: number | string;
            /**
             * Format: double
             * @description How much to raise the score of suggestions from a purchase order or delivery note a reviewer has already linked elsewhere on the same bill, since the rest of a bill usually comes off the same document. A fraction: 0.1 scores them 10% higher, 0 disables it. Applied last, to the finished score, and capped at a perfect 1.0. Only ever affects the order and score of suggestions — an uplifted candidate is never matched automatically. Default 0.1.
             */
            manualLinkSameDocumentBoost: number | string;
            /**
             * Format: double
             * @description How much to raise the score of suggestions whose line description matches one a reviewer has already confirmed for this bill line, on any document. This is what carries a split delivery: 12 billed units arriving as 2, 3, 4 and 3 across four delivery notes that each list the identical line. A fraction: 0.1 scores them 10% higher, 0 disables it. Applied last, to the finished score, and capped at a perfect 1.0. Only ever affects the order and score of suggestions — an uplifted candidate is never matched automatically. Default 0.1.
             */
            manualLinkSameItemBoost: number | string;
            /**
             * Format: double
             * @description Unit-price tolerance for auto-matching, as a fraction of the ordered price (0.03 = 3%). Does double duty: a confident fuzzy match whose price gap exceeds this is still allocated but left for a reviewer instead of being auto-settled, and within this band a price gap does not reduce match confidence at all (beyond it, it does). 0 means any price gap past the rounding tolerance needs a human. Default 0.03 (price is scrutinised tighter than quantity).
             */
            matchMaxPriceVarianceFraction: number | string;
            /**
             * Format: double
             * @description Receipt-quantity tolerance for auto-matching against a delivery note, as a fraction of the billed quantity (0.05 = 5%). Does double duty: a confident fuzzy match whose billed-vs-received gap exceeds this is allocated but left for a reviewer instead of auto-settled, and only an over-receipt beyond this band reduces match confidence (a short delivery never does). 0 means any receipt gap past the rounding tolerance needs a human. Default 0.05.
             */
            matchMaxReceiptQuantityVarianceFraction: number | string;
            /**
             * Format: double
             * @description Order-quantity tolerance for auto-matching against a purchase order, as a fraction of the ordered quantity (0.05 = 5%). Does double duty: a confident fuzzy match billed beyond the order by more than this is allocated but left for a reviewer instead of auto-settled, and only an over-order beyond this band reduces match confidence (billing at or below the order never does). 0 means any over-order past the rounding tolerance needs a human. Default 0.05.
             */
            matchMaxOrderQuantityVarianceFraction: number | string;
            /** @description When true, a bill received against a company whose delivery address matches one of that company's organisations clearly enough is assigned to it automatically. When false, every company bill waits in the company inbox for someone to assign it. Only affects bills uploaded or forwarded to a company; bills sent straight to an organisation are unaffected. Default true. */
            companyAutoAssignEnabled: boolean;
            /**
             * Format: double
             * @description Match score (0-1) the best matching organisation must reach for a company's bill to be assigned to it automatically. Below this the bill waits in the company inbox. Raise it if bills are being assigned to the wrong site; lower it if too many are waiting. Default 0.90.
             */
            companyAutoAssignThreshold: number | string;
            /**
             * Format: double
             * @description Minimum lead (0-1) the best matching organisation must have over the runner-up for a company's bill to be assigned automatically. Two sites in the same postcode district both score highly, and assigning on a near-tie is how a bill lands on the wrong one, so a close call always waits for a person. Default 0.10.
             */
            companyAutoAssignMargin: number | string;
        };
        /** @description How the organisation's invoices are pushed into its accounting platform. */
        ArAccountingSettingsResponse: {
            /** @description True when an accounting platform is connected and callable. Nothing can be pushed, or chosen here, until it is. */
            connected?: boolean;
            /** @description The connected accounting platform, e.g. "xero" or "quickbooks". Null when none is connected. */
            platform?: null | string;
            /** @description The currency the accounting company keeps its books in. Only invoices in this currency can be pushed. */
            companyCurrency?: null | string;
            /**
             * Format: uuid
             * @description The ledger account invoice lines post their revenue to, unless the line's product names its own. Invoices are pushed automatically once this is set.
             */
            defaultIncomeLedgerAccountId?: null | string;
            /**
             * Format: uuid
             * @description The bank ledger account invoice payments are recorded as deposited into. Payments are not pushed until this is set.
             */
            depositLedgerAccountId?: null | string;
            /**
             * Format: uuid
             * @description The ledger account Stripe card payments are recorded into before Stripe pays them out. When set, each Stripe payout is pushed as one document moving its net amount from here to the deposit account, with Stripe's fees. Null: Stripe payments are recorded straight into the deposit account and payouts are not pushed.
             */
            stripeClearingLedgerAccountId?: null | string;
            /**
             * Format: uuid
             * @description The expense ledger account Stripe's fees on each payout are posted to, with no VAT. Payouts are not pushed until this is set too.
             */
            stripeFeesLedgerAccountId?: null | string;
        };
        ArSettingsResponse: {
            /** @description Client-level kill switch for outbound AR (invoice) emails. When false, sending an invoice still issues it, but no customer email is dispatched and no reminders are scheduled — the client handles delivery out-of-band. Default true. */
            arEmailsEnabled: boolean;
            /** @description Whether this client uses integrated Dolfin/Stripe payments. When true (default), invoices carry a Dolfin-generated payment link. When false, the client brings its own payment link (see defaultPaymentLinkUrl). */
            integratedPaymentsEnabled: boolean;
            /** @description Bring-your-own payment link template, used only when integrated payments are off. Supports the tokens {invoiceId}, {organisationId} and {invoiceNumber}, expanded per invoice. Null when not set. */
            defaultPaymentLinkUrl?: null | string;
            /** @description Tone of the WhatsApp messages sent on the client's own payment link (integrated payments off, defaultPaymentLinkUrl set). One tone for the whole client, because Meta reviews each of those templates: changing it, or the part of defaultPaymentLinkUrl before its first token, submits new templates, and those invoices go by email until Meta approves them. Messages with Dolfin's payment link use each organisation's own tone. */
            whatsAppMessageTone: components["schemas"]["InvoiceTone"];
            /** @description Which optional fields appear on every invoice PDF the client's organisations produce. Applied when the PDF is rendered, so a change also affects invoices already sent. Every flag defaults to true. */
            pdfDisplayOptions: components["schemas"]["InvoicePdfDisplayOptions"];
            /** @description The template tokens supported in defaultPaymentLinkUrl. */
            supportedPaymentLinkTokens?: string[];
        };
        /** @description The organisation member to make the holder. */
        AssignCardHolderRequest: {
            /**
             * Format: uuid
             * @description The user to assign. Must be a member of the organisation.
             */
            userId: string;
        };
        AssignCompanyBillRequest: {
            /**
             * Format: uuid
             * @description The organisation to assign this bill to. It must be one of this company's organisations — see GET /companies/{companyId}/organisations.
             */
            organisationId: string;
        };
        AttachReceiptRequest: {
            /** Format: uuid */
            receiptId: string;
        };
        AuthClient: {
            /**
             * Format: uuid
             * @description Your Dolfin platform identifier
             */
            clientId: string;
            /** @description Your Dolfin platform name */
            clientName: string;
            type: components["schemas"]["ClientType"];
            role: components["schemas"]["ClientRole"];
        };
        AuthOrganisation: {
            /** Format: uuid */
            organisationId: string;
            organisationName: string;
            role: components["schemas"]["OrganisationRole"];
            /** @description The type of the client that owns the organisation: Live, Sandbox (vendors' test environments) or Demo (simulated connections and made-up data). */
            clientType: components["schemas"]["ClientType"];
        };
        AuthResponse: {
            /** @description Your Dolfin issued bearer token */
            token: string;
            /**
             * Format: uuid
             * @description Unique identifier for the user the token has been issued for
             */
            userId: string;
            /** @description Email of the user the token has been issued for */
            email: string;
            /** @description Organisation memberships for the user */
            organisations: components["schemas"]["AuthOrganisation"][];
            /** @description Client memberships for the user (portal access) */
            clients: components["schemas"]["AuthClient"][];
        };
        /** @enum {unknown} */
        AvgInvoicesPerMonth: "OneToTen" | "ElevenToFifty" | "FiftyToOneHundred" | "OneHundredPlus" | null;
        /** @enum {unknown} */
        AvgInvoiceValue: "Under500" | "FiveHundredToFiveK" | "FiveKToFiftyK" | "Over50k" | null;
        BackfillCardTransactionsRequest: {
            /** Format: uuid */
            cardConnectionId?: null | string;
        };
        BackfillStartedResponse: {
            /** Format: uuid */
            jobId: string;
        };
        /** @description Balance sheet at a date, on accrual or cash basis, grouped by account classification. On cash basis invoices and bills raised in the books create no debtors or creditors; opening balances still do until paid. */
        BalanceSheetResponse: {
            /**
             * Format: date
             * @description Report date.
             */
            date?: string;
            /** @description The basis the figures are on: Accrual or Cash. */
            basis?: components["schemas"]["ReportingBasis"];
            /** @description Currency of every amount. */
            currency?: string;
            /** @description True when the platform columns are filled. */
            compared?: boolean;
            /** @description Assets, liabilities, then equity (which includes the current year's earnings). */
            groups?: components["schemas"]["StatementGroup"][];
            /**
             * Format: double
             * @description Total assets.
             */
            totalAssets?: number | string;
            /**
             * Format: double
             * @description Total liabilities and equity.
             */
            totalLiabilitiesAndEquity?: number | string;
            /** @description True when assets equal liabilities plus equity. */
            balanced?: boolean;
            /**
             * Format: double
             * @description The platform's total assets (compare only).
             */
            platformTotalAssets?: null | number | string;
            /**
             * Format: double
             * @description The platform's total liabilities and equity (compare only).
             */
            platformTotalLiabilitiesAndEquity?: null | number | string;
            /**
             * Format: double
             * @description Current assets less current liabilities: the rows in the CurrentAssets section less those in the CurrentLiabilities section.
             */
            workingCapital?: number | string;
            /**
             * Format: double
             * @description The platform's working capital (compare only).
             */
            platformWorkingCapital?: null | number | string;
        };
        /**
         * @description Where a balance sheet row sits on the statement. CurrentAssets and NonCurrentAssets rows are in the asset group; CurrentLiabilities and NonCurrentLiabilities rows in the liability group; Equity rows in the equity group.
         * @enum {unknown}
         */
        BalanceSheetSection: "CurrentAssets" | "NonCurrentAssets" | "CurrentLiabilities" | "NonCurrentLiabilities" | "Equity" | null;
        /** @description A bank account read from a bank connection. */
        BankAccountResponse: {
            /**
             * Format: uuid
             * @description Bank account id. Stable across reconnecting the same account.
             */
            id: string;
            /**
             * Format: uuid
             * @description The connection the account is currently read through.
             */
            bankConnectionId: string;
            /** @description State of that connection. Balances are only refreshed while it is Connected. */
            connectionState: components["schemas"]["BankConnectionState"];
            /** @description Account name or nickname as the bank gives it. */
            name: string;
            /** @description Account type as the bank describes it, e.g. 'Business - Current'. */
            type?: null | string;
            /** @description ISO 4217 currency code. */
            currency: string;
            /** @description UK sort code, six digits. */
            sortCode?: null | string;
            /** @description UK account number. */
            accountNumber?: null | string;
            /** @description IBAN, where the bank gives one. */
            iban?: null | string;
            /** @description BIC, where the bank gives one. */
            bic?: null | string;
            /**
             * Format: double
             * @description Latest balance in the account currency. Null until one has been read.
             */
            balance?: null | number | string;
            /** @description Which balance the bank reported, e.g. INTERIM_AVAILABLE or CLOSING_BOOKED. Available balances are preferred. */
            balanceType?: null | string;
            /**
             * Format: date-time
             * @description When the balance applied (UTC), as the bank reports it.
             */
            balanceAsOf?: null | string;
            /**
             * Format: date-time
             * @description When the account's transactions were last synced (UTC). Null until the first sync, which runs right after connecting; then daily while the connection is Connected.
             */
            transactionsSyncedAt?: null | string;
            /**
             * Format: date-time
             * @description When Dolfin last updated the account (UTC).
             */
            updatedAt: string;
        };
        BankConnectionAdminResponse: {
            connection: components["schemas"]["BankConnectionResponse"];
            clientType: components["schemas"]["ClientType"];
            /** Format: uuid */
            yapilyConsentId?: null | string;
            hasStoredConsentToken: boolean;
            /** Format: int32 */
            consecutiveAccessDenied: number | string;
            /** Format: date-time */
            reconfirmationDueNotifiedFor?: null | string;
            /** Format: uuid */
            createdByUserId?: null | string;
            events: components["schemas"]["BankConnectionEventAdminResponse"][];
        };
        /** @description A bank authorisation link: send the account holder to authorisationUrl to approve access at their bank. */
        BankConnectionAuthorisationResponse: {
            /**
             * Format: uuid
             * @description Bank connection id.
             */
            id: string;
            /** @description Connection state: AwaitingAuthorisation for a new connection, Reauthorising for a reauthorisation. */
            state: components["schemas"]["BankConnectionState"];
            /** @description The bank's authorisation page. Only the account holder can complete it. */
            authorisationUrl: string;
            /**
             * Format: date-time
             * @description When the authorisation link stops working (UTC). Afterwards the connection fails as abandoned, or stays expired.
             */
            authorisationExpiresAt: string;
            /** @description Disclosure to render before redirecting. */
            disclosure: components["schemas"]["BankConnectionDisclosureResponse"];
        };
        /** @description The Yapily Connect disclosure. Regulatory requirement: show the text verbatim, with links to the terms and the privacy notice, on the step before sending the account holder to their bank. */
        BankConnectionDisclosureResponse: {
            /** @description Disclosure text, to render verbatim. */
            text: string;
            /** @description Yapily Connect end-user terms. */
            termsUrl: string;
            /** @description Yapily Connect privacy notice. */
            privacyUrl: string;
        };
        BankConnectionEventAdminResponse: {
            /** Format: uuid */
            id: string;
            fromState: null | components["schemas"]["BankConnectionState"];
            toState: components["schemas"]["BankConnectionState"];
            reason: null | components["schemas"]["BankConnectionFailureReason"];
            providerCode: null | string;
            /** Format: date-time */
            at: string;
        };
        /**
         * @description Why a bank connection failed. UserRejected: the account holder declined or cancelled at their bank. BankError: the bank or open-banking provider reported an error. Abandoned: authorisation was not completed within an hour. InvalidConsent: the bank rejected or invalidated the consent. Unknown: no more specific reason is known.
         * @enum {unknown}
         */
        BankConnectionFailureReason: "UserRejected" | "BankError" | "Abandoned" | "InvalidConsent" | "Unknown" | null;
        /** @description A connection to one bank: a read-only consent to read the organisation's accounts there. */
        BankConnectionResponse: {
            /**
             * Format: uuid
             * @description Bank connection id.
             */
            id: string;
            /** @description Where the connection is in its lifecycle. */
            state: components["schemas"]["BankConnectionState"];
            /** @description Institution id. */
            institutionId: string;
            /** @description Bank display name. */
            institutionName: string;
            failureReason?: null | components["schemas"]["BankConnectionFailureReason"];
            /** @description The provider's raw code for the last failure or lapse, e.g. the bank's error code or a consent status such as EXPIRED. */
            providerCode?: null | string;
            /** @description The provider's description of the last failure, where it gave one. */
            providerMessage?: null | string;
            /**
             * Format: date-time
             * @description When the current bank authorisation link stops working (UTC). Only meaningful while waiting for authorisation.
             */
            authorisationExpiresAt?: null | string;
            /**
             * Format: date-time
             * @description When the consent expires (UTC).
             */
            expiresAt?: null | string;
            /**
             * Format: date-time
             * @description UK 90-day reconfirmation deadline (UTC). Reconfirm before it, or the connection expires and must be reauthorised at the bank.
             */
            reconfirmBy?: null | string;
            /**
             * Format: date-time
             * @description When access was last confirmed (UTC).
             */
            lastConfirmedAt?: null | string;
            /**
             * Format: date-time
             * @description When the connection was started (UTC).
             */
            createdAt: string;
            /**
             * Format: date-time
             * @description When the connection first became Connected (UTC).
             */
            connectedAt?: null | string;
            /**
             * Format: date-time
             * @description When the connection last changed (UTC).
             */
            updatedAt: string;
            /** @description Accounts read through this connection. */
            accounts: components["schemas"]["BankAccountResponse"][];
        };
        /**
         * @description Where a bank connection is in its lifecycle. Initiated: being set up. AwaitingAuthorisation: waiting for the account holder at their bank. AwaitingFurtherAuthorisation: the bank needs another approval, for example a second holder of a business account. Connected: accounts are readable. Failed: authorisation did not complete (terminal; start a new connection). Expired: access lapsed or the 90-day reconfirmation was missed; reauthorise to restore it. Reauthorising: waiting for the account holder to authorise again. Revoked: access was withdrawn at the bank (terminal). Disconnected: the organisation disconnected it (terminal).
         * @enum {unknown}
         */
        BankConnectionState: "Initiated" | "AwaitingAuthorisation" | "AwaitingFurtherAuthorisation" | "Connected" | "Failed" | "Expired" | "Reauthorising" | "Revoked" | "Disconnected";
        BankDetails: {
            accountHolderName?: null | string;
            /** @description Domestic account number: 7-8 digits in the UK, 4-17 digits in the US. */
            accountNumber?: null | string;
            /** @description UK sort code, 6 digits (e.g. 00-00-00). */
            sortCode?: null | string;
            /** @description US ABA routing number, 9 digits. */
            routingNumber?: null | string;
            iban?: null | string;
            /** @description BIC/SWIFT code, for international wires. */
            bicSwift?: null | string;
            /** @description ISO 3166-1 alpha-2 country code (e.g. GB, US, DE) */
            country?: null | string;
            /** @description ISO 4217 currency code (e.g. GBP, USD, EUR) */
            currency?: null | string;
        };
        BankDetailsValidationResult: {
            isValid: boolean;
            errors: components["schemas"]["ValidationError"][];
            canonical: null | components["schemas"]["BankDetails"];
        };
        BankFieldSpec: {
            requirement: components["schemas"]["FieldRequirement"];
            label?: null | string;
            placeholder?: null | string;
            helpText?: null | string;
            /** Format: int32 */
            minLength?: null | number | string;
            /** Format: int32 */
            maxLength?: null | number | string;
            pattern?: null | string;
            example?: null | string;
            /** Format: int32 */
            displayOrder?: number | string;
        };
        /** @description A bank whose accounts can be connected. */
        BankInstitutionResponse: {
            /** @description Institution id, passed as institutionId when starting a connection. */
            id: string;
            /** @description Short display name. */
            name: string;
            /** @description Full name, when the bank gives one. */
            fullName: null | string;
            /** @description URL of the bank's logo, when there is one. */
            iconUrl: null | string;
        };
        /** @description Banks the organisation can connect, and the disclosure to show before connecting. */
        BankInstitutionsResponse: {
            /** @description UK banks that support reading accounts and balances. */
            institutions: components["schemas"]["BankInstitutionResponse"][];
            /** @description Disclosure to render on the consent step. */
            disclosure: components["schemas"]["BankConnectionDisclosureResponse"];
        };
        /** @description A Dolfin payment already in the books on the line's bank account, for the same amount and direction. */
        BankLineCandidateResponse: {
            /** @description InvoicePayment, Bill (its payment) or StripePayout. Pass it to match. */
            sourceType: components["schemas"]["JournalSourceType"];
            /**
             * Format: uuid
             * @description Id of the invoice payment, bill or Stripe payout. Pass it to match.
             */
            sourceId: string;
            /**
             * Format: uuid
             * @description Id of the journal entry that posted the payment.
             */
            journalEntryId: string;
            /**
             * Format: date
             * @description The payment's accounting date.
             */
            date: string;
            /**
             * Format: double
             * @description Unsigned amount, equal to the bank line's.
             */
            amount: number | string;
            /** @description The payment entry's description. */
            description: string;
        };
        /**
         * @description Where a suggestion came from: Rule (one of the organisation's rules), Learned (how people filed this payee before) or Model (read from the line and the chart).
         * @enum {unknown}
         */
        BankLineCategorisationMethod: "Rule" | "Learned" | "Model" | null;
        /**
         * @description High: applied automatically. Medium and Low: shown as a suggestion for a person to accept.
         * @enum {unknown}
         */
        BankLineConfidence: "High" | "Medium" | "Low" | null;
        /**
         * @description In: money received. Out: money paid.
         * @enum {unknown}
         */
        BankLineDirection: "In" | "Out";
        /** @description Uncategorised bank lines from the same payee in the same direction. */
        BankLineGroupResponse: {
            /** @description The payee, normalised (upper case, no digits or punctuation). Pass it with direction to categorise the group. */
            key: string;
            /** @description Counterparty when the lines carry one, else Description: the field a rule made from the group reads. */
            field: components["schemas"]["BookRuleField"];
            /** @description In (money received) or Out (money paid). */
            direction: components["schemas"]["BankLineDirection"];
            /** @description The payee as the bank most often writes it. */
            name: string;
            /**
             * Format: int32
             * @description How many Uncategorised lines are in the group.
             */
            count: number | string;
            /**
             * Format: double
             * @description Sum of the lines' unsigned amounts, in GBP.
             */
            total: number | string;
            /**
             * Format: uuid
             * @description The account most of the group's lines are suggested to, if any.
             */
            suggestedLedgerAccountId: null | string;
            /**
             * Format: uuid
             * @description The tax rate that goes with the suggested account.
             */
            suggestedAccountingTaxRateId: null | string;
            /** @description Ids of the lines in the group, newest first. */
            lineIds: string[];
        };
        /** @description A booked bank transaction in the books and how it is resolved. */
        BankLineResponse: {
            /**
             * Format: uuid
             * @description Id of the bank line.
             */
            id: string;
            /**
             * Format: uuid
             * @description Id of the synced bank transaction behind the line.
             */
            bankTransactionId: string;
            /**
             * Format: uuid
             * @description Id of the connected bank account the transaction is on.
             */
            bankAccountId: string;
            /**
             * Format: date-time
             * @description When the bank booked the transaction (UTC).
             */
            bookedAt: string;
            /**
             * Format: double
             * @description Signed amount in the line's currency: negative is money out.
             */
            amount: number | string;
            /** @description ISO 4217 currency code. */
            currency: string;
            /** @description The bank's description of the transaction. */
            description: null | string;
            /** @description The bank's payment reference. */
            reference: null | string;
            /** @description The other party, when the bank reports one. */
            counterpartyName: null | string;
            /** @description Uncategorised (parked in the Uncategorised account), Matched (to a Dolfin payment, nothing posted), Categorised (reclassified to an account), PossibleDuplicate (held, nothing posted) or Ignored (a confirmed duplicate). */
            status: components["schemas"]["BookBankLineStatus"];
            matchedSourceType: null | components["schemas"]["JournalSourceType"];
            /**
             * Format: uuid
             * @description Id of the matched invoice payment, bill or Stripe payout.
             */
            matchedSourceId: null | string;
            /**
             * Format: uuid
             * @description Ledger account the line is categorised to.
             */
            ledgerAccountId: null | string;
            /**
             * Format: uuid
             * @description Tax rate the categorisation applied.
             */
            accountingTaxRateId: null | string;
            resolvedBy: null | components["schemas"]["BookBankLineResolvedBy"];
            /**
             * Format: date-time
             * @description When the line was resolved (UTC).
             */
            resolvedAt: null | string;
            /**
             * Format: uuid
             * @description The live entry parking the line in Uncategorised, if any.
             */
            suspenseEntryId: null | string;
            /**
             * Format: uuid
             * @description The account Dolfin suggests (or, when ResolvedBy is Auto, applied) for the line.
             */
            suggestedLedgerAccountId: null | string;
            /**
             * Format: uuid
             * @description The tax rate that goes with the suggested account.
             */
            suggestedAccountingTaxRateId: null | string;
            /**
             * Format: double
             * @description How sure the suggestion is, 0 to 1.
             */
            suggestionConfidence: null | number | string;
            confidence: null | components["schemas"]["BankLineConfidence"];
            categorisationMethod: null | components["schemas"]["BankLineCategorisationMethod"];
            /**
             * Format: uuid
             * @description Id of the rule that made the suggestion, when CategorisationMethod is Rule.
             */
            ruleId: null | string;
            /** @description Name of that rule. */
            ruleName: null | string;
            /**
             * Format: date-time
             * @description When a person undid an automatic result on this line; from then on suggestions are only shown, never applied.
             */
            autoRejectedAt: null | string;
            /** @description The bank's name for the account the transaction is on. */
            bankAccountName: null | string;
            /**
             * Format: uuid
             * @description The ledger account the transaction sits in, opposite the bank account: the categorised account, the Uncategorised account while unresolved, for a matched line the account its payment posted to (for example accounts receivable, accounts payable or Stripe clearing), or for a matched transfer the ledger account of the bank account the money came from. Null for possible and confirmed duplicates.
             */
            postedLedgerAccountId: null | string;
            /**
             * Format: uuid
             * @description The live journal entry that puts the transaction in the books: the categorisation entry, the entry parking it in Uncategorised, or the matched payment's entry. Null for possible and confirmed duplicates.
             */
            journalEntryId: null | string;
            matchedDocumentType: null | components["schemas"]["JournalSourceType"];
            /**
             * Format: uuid
             * @description Id of that invoice or bill.
             */
            matchedDocumentId: null | string;
            /** @description The invoice or bill number, for example INV-00029. */
            matchedDocumentNumber: null | string;
            /** @description The customer on that invoice, or the supplier on that bill. */
            matchedCounterpartyName: null | string;
        };
        /** @description How many of a tracked bank account's lines are in each status. */
        BankLineSummaryResponse: {
            /**
             * Format: uuid
             * @description Id of the connected bank account.
             */
            bankAccountId: string;
            /** @description The bank's name for the account. */
            bankAccountName: null | string;
            /**
             * Format: int32
             * @description Lines parked in Uncategorised: the review queue.
             */
            uncategorised: number | string;
            /**
             * Format: int32
             * @description Lines held as possible duplicates, waiting for a person.
             */
            possibleDuplicate: number | string;
            /**
             * Format: int32
             * @description Lines matched to a Dolfin payment.
             */
            matched: number | string;
            /**
             * Format: int32
             * @description Lines categorised to an account.
             */
            categorised: number | string;
            /**
             * Format: int32
             * @description Confirmed duplicates kept out of the books.
             */
            ignored: number | string;
            /**
             * Format: int32
             * @description Of the Matched lines, those Dolfin matched without a person.
             */
            autoMatched: number | string;
            /**
             * Format: int32
             * @description Of the Categorised lines, those Dolfin categorised without a person (a rule, history or a confident suggestion).
             */
            autoCategorised: number | string;
        };
        /** @description A transaction on a connected bank account, synced from the bank. */
        BankTransactionResponse: {
            /**
             * Format: uuid
             * @description Dolfin's transaction id.
             */
            id: string;
            /**
             * Format: uuid
             * @description The bank account the transaction is on.
             */
            bankAccountId: string;
            /** @description The bank's own transaction id, where it gives one. Many UK banks do not. */
            providerTransactionId?: null | string;
            /** @description Booked once settled at the bank. A Pending transaction may still change or disappear, and is replaced by its booked version on a later sync. */
            status: components["schemas"]["BankTransactionStatus"];
            /**
             * Format: date-time
             * @description When the bank booked the transaction (UTC); for a pending one, when it was made.
             */
            bookedAt: string;
            /**
             * Format: date-time
             * @description When the funds became, or stop being, available (UTC), where the bank says.
             */
            valueAt?: null | string;
            /**
             * Format: double
             * @description Amount in the account currency. Negative is money out of the account, positive is money in.
             */
            amount: number | string;
            /** @description ISO 4217 currency code. */
            currency: string;
            /** @description The bank's description of the transaction. */
            description?: null | string;
            /** @description Payment reference, where the bank gives one. */
            reference?: null | string;
            /** @description Who the money went to or came from: the merchant, payee or payer name, where the bank gives one. */
            counterpartyName?: null | string;
            /** @description ISO 18245 merchant category code for card payments, where the bank gives one. */
            merchantCategoryCode?: null | string;
            /**
             * Format: double
             * @description The account balance straight after this transaction, where the bank gives one.
             */
            balanceAfter?: null | number | string;
        };
        /**
         * @description Booked once settled at the bank; Pending may still change or disappear.
         * @enum {unknown}
         */
        BankTransactionStatus: "Booked" | "Pending";
        BillActivityResponse: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            billId?: string;
            /** Format: uuid */
            actorId?: null | string;
            actorType?: components["schemas"]["ActorType"];
            fromState?: null | components["schemas"]["BillState"];
            toState?: null | components["schemas"]["BillState"];
            action?: components["schemas"]["BillEventType"];
            /** Format: date-time */
            createdAt?: string;
            /** Format: uuid */
            supplierId?: null | string;
            supplierName?: null | string;
            invoiceNumber?: null | string;
            /** Format: double */
            totalAmount?: number | string;
            currency: string;
        };
        /** @enum {unknown} */
        BillAllowedSenderKind: "Address" | "Domain";
        BillAllowedSenderResponse: {
            /** Format: uuid */
            id: string;
            /** @description Whether Value is a full email address or a whole domain. */
            kind: components["schemas"]["BillAllowedSenderKind"];
            /** @description The allowed email address or domain (lowercased). */
            value: string;
            /** Format: date-time */
            createdAt: string;
        };
        /** @description A supporting file the supplier sent with the bill's e-invoice, such as a timesheet, a delivery note or their own PDF of the invoice. Separate from the bill's document, which file-url returns. */
        BillAttachmentResponse: {
            /** @description Identifier of the file. Stable for the life of the bill. */
            id: string;
            /** @description File name as the supplier sent it. */
            fileName: string;
            /** @description MIME type of the file, e.g. application/pdf. Null when the supplier did not state one. */
            mimeType?: null | string;
            /**
             * Format: int64
             * @description Size of the file in bytes.
             */
            size?: number | string;
            /** @description What the supplier said the file is. Null when they gave no description. */
            description?: null | string;
            /** @description Short-lived signed URL that downloads the file. It needs no Authorization header and expires after 15 minutes, so fetch the list again for a fresh one rather than storing it. */
            downloadUrl?: null | string;
        };
        BillAuditLogResponse: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            billId?: string;
            /** Format: uuid */
            organisationId?: string;
            /** Format: uuid */
            actorId?: null | string;
            actorType?: components["schemas"]["ActorType"];
            fromState?: null | components["schemas"]["BillState"];
            toState?: null | components["schemas"]["BillState"];
            action?: components["schemas"]["BillEventType"];
            billSnapshot?: null | string;
            /** Format: date-time */
            createdAt?: string;
        };
        BillCreatedResponse: {
            /** Format: uuid */
            id?: string;
            state?: components["schemas"]["BillState"];
        };
        /** @enum {unknown} */
        BillEventType: "BillCreated" | "BillStateChanged" | "BillOcrCompleted" | "BillOcrFailed" | "BillFieldsUpdated";
        /** @enum {unknown} */
        BillExtractionMode: "Ocr" | "Llm";
        /** @enum {unknown} */
        BillExtractionModel: "GeminiFlash" | "ClaudeSonnet" | "ClaudeHaiku";
        BillFileUrlResponse: {
            url: string;
            fileType?: null | string;
        };
        /** @enum {unknown} */
        BillForwardingRejectionReason: "SenderNotAllowed" | "AuthenticationFailed";
        BillForwardingRejectionResponse: {
            /** Format: uuid */
            id: string;
            /** @description The sender the dropped forward came from. */
            fromAddress: string;
            fromDomain: string;
            subject: null | string;
            /**
             * Format: int32
             * @description Number of attachments on the dropped email.
             */
            attachmentCount: number | string;
            /** @description Short 'name (type)' summary of the attachments — the bytes are not stored. */
            attachmentSummary: null | string;
            /** @description Why it was dropped: SenderNotAllowed or AuthenticationFailed. */
            reason: components["schemas"]["BillForwardingRejectionReason"];
            /** @description Overall email-auth (DKIM/DMARC) verdict for the sender: Pass, Fail or Unknown. */
            authResult: components["schemas"]["EmailAuthResult"];
            /** @description Aligned-DKIM check: Pass (valid signature from the sender's domain), Fail, or Unknown. Render as a per-check tick/cross. */
            dkimResult: components["schemas"]["EmailAuthResult"];
            /** @description Aligned-SPF check: Pass (SPF passed for the sender's domain), Fail, or Unknown. Render as a per-check tick/cross. */
            spfResult: components["schemas"]["EmailAuthResult"];
            /**
             * Format: date-time
             * @description When the dropped forward was received.
             */
            receivedAt: string;
        };
        /** @description One bill line's account and tax rate in the accounting platform. */
        BillLineCodingRequest: {
            /**
             * Format: uuid
             * @description Id of the bill line.
             */
            lineId?: string;
            /**
             * Format: uuid
             * @description Id of an active ledger account (from GET /accounting/ledger-accounts) the line posts to. Null uses the supplier's default account, else the organisation's default expense account.
             */
            ledgerAccountId?: null | string;
            /**
             * Format: uuid
             * @description Id of an active accounting platform tax rate (from GET /accounting/tax-rates) the line posts at. Null lets Dolfin choose the purchase rate that charges the VAT printed on the line.
             */
            accountingTaxRateId?: null | string;
        };
        BillLineItemResponse: {
            /** Format: uuid */
            id?: string;
            description: string;
            /** @description Optional product code / SKU as printed on the document. The exact-match key for three-way matching against PO/DN lines; null when the document omits it. */
            sku?: null | string;
            /** Format: double */
            quantity?: number | string;
            /** @description Optional unit of measure as it appears on the document (e.g. kg, box, hrs). */
            unit?: null | string;
            unitOfMeasure?: null | components["schemas"]["UnitOfMeasure"];
            /** Format: double */
            unitPrice?: number | string;
            /**
             * Format: double
             * @description Tax rate as a percentage (e.g. 20 for 20%). Descriptive metadata only — TaxAmount is the authoritative figure and is not derived from this rate.
             */
            taxRate?: number | string;
            /** Format: double */
            taxAmount?: number | string;
            /** Format: double */
            subTotal?: number | string;
            /** Format: int32 */
            sortOrder?: number | string;
            category?: null | string;
            spendClass?: null | components["schemas"]["SpendClass"];
            tags?: string[];
            categoryConfirmed?: boolean;
            spendClassConfirmed?: boolean;
            suggestedCategory?: null | string;
            /** Format: double */
            categoryConfidence?: null | number | string;
            suggestedSpendClass?: null | components["schemas"]["SpendClass"];
            /** Format: double */
            spendClassConfidence?: null | number | string;
            /**
             * Format: uuid
             * @description The ledger account chosen for this line when the bill is pushed to the accounting platform, overriding the supplier's default account and the organisation's default expense account. Null uses those defaults.
             */
            ledgerAccountId?: null | string;
            /**
             * Format: uuid
             * @description The accounting platform tax rate chosen for this line. Null lets Dolfin choose the purchase rate that charges the VAT printed on the line.
             */
            accountingTaxRateId?: null | string;
        };
        BillLlmExtractionResponse: {
            /**
             * Format: uuid
             * @description The bill this extraction record belongs to.
             */
            billId: string;
            /**
             * Format: uuid
             * @description The organisation the bill belongs to. Null only while a document that arrived in a company inbox is still waiting to be routed — extraction happens before an organisation is chosen, and this is filled in once one is.
             */
            organisationId?: null | string;
            /**
             * Format: uuid
             * @description The company whose inbox the document arrived in. Null for bills uploaded or emailed straight to an organisation. A routed company bill carries both: the company paid for the extraction, and the organisation is who it turned out to be for.
             */
            companyId?: null | string;
            /** @description The model id the extraction ran against, as the provider reports it served — e.g. "claude-sonnet-5", "claude-haiku-4-5", or the concrete Gemini version a "-latest" alias resolved to. */
            model: string;
            /**
             * Format: int32
             * @description Uncached input tokens billed at the full input rate.
             */
            inputTokens?: number | string;
            /**
             * Format: int32
             * @description Output tokens generated by the model.
             */
            outputTokens?: number | string;
            /**
             * Format: int32
             * @description Input tokens served from the prompt cache (0 until prompt caching is enabled).
             */
            cacheReadTokens?: number | string;
            /**
             * Format: int32
             * @description Input tokens written to the prompt cache (0 until prompt caching is enabled).
             */
            cacheCreationTokens?: number | string;
            /**
             * Format: double
             * @description USD cost of the input side (incl. cache read/write tiers). Null if the model has no configured price.
             */
            inputCostUsd?: null | number | string;
            /**
             * Format: double
             * @description USD cost of the output tokens. Null if the model has no configured price.
             */
            outputCostUsd?: null | number | string;
            /**
             * Format: double
             * @description Total USD cost of the extraction (input + output). Null if the model has no configured price.
             */
            totalCostUsd?: null | number | string;
            /** @description The effort level the request ran with (Anthropic only; empty for Gemini). */
            effort: string;
            /** @description Whether extended/adaptive thinking was enabled for the request. */
            thinkingEnabled?: boolean;
            /**
             * Format: int32
             * @description The max output tokens the request was configured with.
             */
            maxTokens?: number | string;
            /**
             * Format: double
             * @description Wall-clock duration of the LLM API call, in milliseconds.
             */
            durationMs?: number | string;
            /**
             * Format: date-time
             * @description When the extraction ran (UTC).
             */
            extractedAt?: string;
        };
        /** @description Stored three-way match facts for a bill: the match group's lifecycle status and the purchase orders and delivery notes its confirmed allocations point at. Per-line detail and variances are not here — fetch the bill's match group for those. */
        BillMatchSummary: {
            /** @description Lifecycle status of the bill's match: Open (a match group exists but nothing is allocated yet), Variance (a flagged difference awaits a human decision), Resolved (every line settled — either a clean match or a human-accepted variance), or Synced (exported). */
            status: components["schemas"]["MatchGroupStatus"];
            /** @description Distinct purchase orders this bill has confirmed allocations against, ordered by number. Empty when the match group exists but nothing is matched yet, or when only delivery notes are matched. More than one entry means the bill spans several orders. */
            matchedPurchaseOrders: components["schemas"]["MatchedDocumentRef"][];
            /** @description Distinct delivery notes this bill has confirmed allocations against, ordered by number. Empty on a two-way (price-only) match, where the receipt side was never matched. */
            matchedDeliveryNotes: components["schemas"]["MatchedDocumentRef"][];
        };
        /**
         * @description How a bill payment was made. PayByBank is a payment made through Dolfin's pay-by-bank flow; the rest were recorded by hand.
         * @enum {unknown}
         */
        BillPaymentMethod: "Cash" | "BankTransfer" | "Cheque" | "Card" | "Other" | "PayByBank";
        /**
         * @description How a bill payment was made: recorded by hand, or paid by bank through Dolfin.
         * @enum {unknown}
         */
        BillPaymentProvider: "Manual" | "PayByBank";
        /** @description A payment against a bill: one recorded by hand, or a pay-by-bank payment the bank completed. */
        BillPaymentRecordResponse: {
            /**
             * Format: uuid
             * @description Id of the payment. Pass it to remove a manual payment.
             */
            id?: string;
            /**
             * Format: uuid
             * @description Id of the bill the payment is against.
             */
            billId?: string;
            /** @description Manual for a payment recorded by hand (removable); PayByBank for one made through Dolfin's pay-by-bank flow. */
            provider?: components["schemas"]["BillPaymentProvider"];
            /**
             * Format: double
             * @description Amount paid, in the bill's currency.
             */
            amount?: number | string;
            /** @description ISO 4217 currency code of the payment. */
            currency: string;
            /**
             * Format: date
             * @description The day the payment was made.
             */
            paidOn?: string;
            /** @description How the payment was made. */
            method?: components["schemas"]["BillPaymentMethod"];
            /** @description The payment's reference: the one entered for a manual payment, or the reference sent to the supplier's bank for a pay-by-bank payment. */
            reference?: null | string;
            /** @description Note entered with a manual payment. */
            note?: null | string;
            /**
             * Format: date-time
             * @description When the payment was recorded in Dolfin.
             */
            createdAt?: string;
            /**
             * Format: uuid
             * @description The user who recorded or started the payment; null when an API key or Dolfin itself did.
             */
            createdBy?: null | string;
            accountingSync?: null | components["schemas"]["AccountingDocumentSyncResponse"];
        };
        BillPaymentResponse: {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            billId: string;
            /** Format: uuid */
            supplierId?: null | string;
            status: components["schemas"]["BillPaymentStatus"];
            institutionId: string;
            /** Format: double */
            amount: number | string;
            currency: string;
            reference: string;
            payeeName: string;
            yapilyStatus?: null | string;
            isoStatus?: null | string;
            multiAuthorisationStatus?: null | string;
            /** Format: int32 */
            multiAuthorisationsRequired?: null | number | string;
            /** Format: int32 */
            multiAuthorisationsReceived?: null | number | string;
            authorisationUrl?: null | string;
            /** Format: date-time */
            authorisationExpiresAt?: null | string;
            errorMessage?: null | string;
            /** Format: date-time */
            createdAt?: string;
            /** Format: date-time */
            executedAt?: null | string;
            /** Format: date-time */
            completedAt?: null | string;
            /** Format: date-time */
            failedAt?: null | string;
        };
        /** @enum {unknown} */
        BillPaymentStatus: "Initiating" | "AwaitingAuthorisation" | "Authorised" | "Pending" | "Completed" | "Failed" | "Expired" | "Abandoned";
        BillResponse: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            organisationId?: string;
            state?: components["schemas"]["BillState"];
            source?: components["schemas"]["BillSource"];
            /**
             * Format: uuid
             * @description The e-invoice this bill was ingested from, when Source is EInvoice; null otherwise. Fetch it for anything the document asserted that the bill could not fully hold — a part payment, a document-level discount, bank details that differ from the supplier record. Those are recorded once, on the e-invoice, and are not errors: the bill is reviewed normally.
             */
            eInvoiceId?: null | string;
            fileName?: null | string;
            rawFileType?: null | string;
            /** Format: uuid */
            supplierId?: null | string;
            /**
             * Format: uuid
             * @description Suggested supplier match. Auto-accepted as the Supplier on review submit if Supplier is not set. Found in tiers: exact tax id / email, then exact name, then a fuzzy weighted name + delivery-address match.
             */
            suggestedMatchedSupplierId?: null | string;
            /**
             * Format: double
             * @description Confidence (0-1) of SuggestedMatchedSupplierId: 1.0 for a tax-id/email hit, ~0.95 for an exact name, and the computed weighted score for a fuzzy hit. Null when there is no suggestion. Use it to grade how the suggestion is surfaced (e.g. ask for confirmation below a threshold).
             */
            suggestedMatchedSupplierConfidence?: null | number | string;
            supplierName?: null | string;
            supplierEmail?: null | string;
            supplierPhone?: null | string;
            supplierAddress?: null | string;
            /** @description Ship-to / delivery address as printed on the bill, weighed against the supplier's address in fuzzy matching. */
            deliveryAddress?: null | string;
            supplierAddressDetail?: null | components["schemas"]["Address"];
            deliveryAddressDetail?: null | components["schemas"]["Address"];
            supplierTaxId?: null | string;
            supplierWebsite?: null | string;
            supplierRegistrationNumber?: null | string;
            invoiceNumber?: null | string;
            /** @description Every buyer purchase-order reference printed on the bill — "PO Number", "Order No", or the equivalent in the document's own language — in the order printed. One bill often covers several orders ("P.O. PO-A/ PO-B"), which is why this is a list. This is what the DOCUMENT claims, extracted and unverified: it is not a link to a purchase order, and three-way matching does not use it. Empty when the bill quotes no order reference, and always empty on bills extracted by OCR rather than an LLM. */
            billPoNumbers?: string[];
            /** @description billPoNumbers with punctuation removed and upper-cased ("PO 01750" → "PO01750"), so the same order found on differently-punctuated documents shares one search key. Derived and read-only — correct billPoNumbers and this follows. Filter on it with ?normalisedBillPoNumber=, which normalises your query the same way and matches a bill quoting that order among any others. Shorter than billPoNumbers when a reference is punctuation-only, so do not read the two by index. */
            normalisedBillPoNumbers?: string[];
            /** Format: date-time */
            invoiceDate?: null | string;
            /** Format: date-time */
            dueDate?: null | string;
            /** @description ISO 4217 currency code (e.g. GBP, USD, EUR) */
            currency?: string;
            /** Format: double */
            subTotal?: number | string;
            /** Format: double */
            taxAmount?: number | string;
            /** Format: double */
            totalAmount?: number | string;
            /**
             * Format: double
             * @description Supplier credit netted against this bill.
             */
            amountCredited?: number | string;
            /**
             * Format: double
             * @description Sum of the payments against this bill: manual payments and a completed pay-by-bank payment. List them with GET /bills/{id}/payment-records.
             */
            amountPaid?: number | string;
            /**
             * Format: double
             * @description What's left to pay (TotalAmount − AmountPaid − AmountCredited). This is what pay-by-bank and a payment without an amount charge.
             */
            outstanding?: number | string;
            paymentTerms?: null | string;
            paymentRef?: null | string;
            bankDetails?: components["schemas"]["BankDetails"];
            /**
             * Format: float
             * @description Extraction confidence (0-1) reported by the extractor. Null until extraction completes.
             */
            confidence?: null | number | string;
            /** Format: uuid */
            approvedBy?: null | string;
            /** Format: date-time */
            approvedAt?: null | string;
            /** Format: uuid */
            rejectedBy?: null | string;
            /** Format: date-time */
            rejectedAt?: null | string;
            rejectionReason?: null | string;
            /**
             * Format: uuid
             * @description Set when Voided. A null VoidedBy with a non-null VoidedAt ⇒ policy auto-void.
             */
            voidedBy?: null | string;
            /** Format: date-time */
            voidedAt?: null | string;
            voidReason?: null | string;
            /**
             * Format: uuid
             * @description The earlier bill this one appears to duplicate — same organisation, same supplier, same invoice number. Null when no duplicate was found. While set and not yet confirmed as a false alarm, the bill cannot be approved; confirm it is not a duplicate to clear that, or void it.
             */
            duplicateOfBillId?: null | string;
            /**
             * Format: date-time
             * @description When the possible duplicate was detected, which happens automatically just after the bill's document is extracted.
             */
            duplicateDetectedAt?: null | string;
            duplicateMatchBasis?: null | components["schemas"]["DuplicateMatchBasis"];
            /**
             * Format: date-time
             * @description When someone confirmed this bill is not a duplicate. Once set, the bill can be approved; duplicateOfBillId is kept so the link to the other bill stays visible.
             */
            duplicateDismissedAt?: null | string;
            /**
             * Format: uuid
             * @description The approval policy applied at submit-review, if any (UI badge).
             */
            appliedApprovalPolicyId?: null | string;
            appliedApprovalPolicyName?: null | string;
            /** @description Deterministic explanation of the approval decision. */
            approvalReasoning?: null | string;
            /** @description Users this bill was routed to for approval — the pending reviewers while in NeedsApproval. */
            resolvedApproverUserIds?: string[];
            /** Format: date-time */
            paymentDate?: null | string;
            paymentMethod?: null | string;
            /** Format: date-time */
            paidAt?: null | string;
            /** @description Pay-by-bank payments (bank payment ids) that completed but could not be applied to this bill: a second payment after the bill was already paid, or a payment on a bill that is no longer payable. Each is a probable duplicate payment to recover from the supplier. Empty when there are none. */
            unreconciledBillPaymentIds?: string[];
            /** @description Link the organisation can use to pay this bill: a Dolfin-hosted pay-by-bank page, or the client's own payment link when the client brings its own. Present from approval onwards (including once paid, when the page shows the bill as paid); null before approval, on rejected or voided bills, and when the client has payment links turned off. */
            paymentLinkUrl?: null | string;
            /** Format: date-time */
            createdAt?: string;
            /** Format: uuid */
            createdBy?: null | string;
            /** Format: date-time */
            updatedAt?: string;
            /** Format: uuid */
            updatedBy?: null | string;
            matchSummary?: null | components["schemas"]["BillMatchSummary"];
            accountingSync?: null | components["schemas"]["AccountingDocumentSyncResponse"];
            paymentAccountingSync?: null | components["schemas"]["AccountingDocumentSyncResponse"];
            documentAccountingSync?: null | components["schemas"]["AccountingDocumentSyncResponse"];
            supplier?: null | components["schemas"]["SupplierResponse"];
            lineItems?: components["schemas"]["BillLineItemResponse"][];
            /** @description Distinct union of the line items' tags, baked at submit-review — for bill-level filtering. */
            tags?: string[];
        };
        /** @enum {unknown} */
        BillSource: "Upload" | "Email" | "Webhook" | "EInvoice";
        /** @enum {unknown} */
        BillState: "Created" | "Extracting" | "PendingReview" | "NeedsApproval" | "Approved" | "Rejected" | "Scheduled" | "Paid" | "ExtractionFailed" | "PaymentInProgress" | "PaymentFailed" | "Voided" | "PartiallyPaid" | "OcrProcessing" | "OcrFailed";
        BillSummary: {
            /** Format: uuid */
            billId?: string;
            invoiceNumber?: null | string;
            /** Format: double */
            totalAmount?: number | string;
            /** Format: date */
            dueDate?: null | string;
            /** Format: int32 */
            daysOverdue?: number | string;
            state: string;
        };
        BillValidationResponse: {
            /** @description True when the bill passed every validation check. When validation fails the endpoint returns 400 with the issues instead, so this is always true in a 200 response. */
            valid?: boolean;
        };
        /** @description One platform bank account's mapping. */
        BookBankAccountRequest: {
            /**
             * Format: uuid
             * @description The platform's bank-type ledger account.
             */
            ledgerAccountId: string;
            /**
             * Format: uuid
             * @description The connected bank account whose transactions check it. Null when not tracked.
             */
            bankAccountId: null | string;
            /** @description False marks the account as not tracked: payments still post to it, but its balance is not checked against a bank feed. */
            tracked: boolean;
        };
        /** @description A platform bank-type account in the books. */
        BookBankAccountResponse: {
            /**
             * Format: uuid
             * @description The platform's bank-type ledger account.
             */
            ledgerAccountId?: string;
            /** @description Account code, when the platform has codes. */
            code?: null | string;
            /** @description Account name. */
            name?: string;
            /** @description True when the account has a balance in the opening balances, so it must be mapped before activation. */
            inOpeningBalances?: boolean;
            /** @description True once mapped to a bank account or marked not tracked. */
            mapped?: boolean;
            /**
             * Format: uuid
             * @description The connected bank account that checks it, if any.
             */
            bankAccountId?: null | string;
            /** @description False when marked not tracked, or not mapped yet. */
            tracked?: boolean;
        };
        /** @enum {unknown} */
        BookBankLineResolvedBy: "Auto" | "Person" | null;
        /** @enum {unknown} */
        BookBankLineStatus: "Uncategorised" | "Matched" | "Categorised" | "PossibleDuplicate" | "Ignored";
        /** @description The setup checklist. Activation needs every step done. */
        BookChecklist: {
            /** @description The start date is set (always true once a book exists). */
            startDate?: boolean;
            /** @description Accounts receivable, accounts payable, VAT, uncategorised, opening-balance difference and retained earnings accounts are set. */
            controlAccounts?: boolean;
            /** @description Every bank-type account in the opening balances is mapped to a bank account or marked not tracked. */
            bankMapping?: boolean;
            /** @description The opening balances are imported. */
            openingBalances?: boolean;
            /** @description The book is active. */
            activated?: boolean;
            /** @description What is still missing, in words. */
            missing?: string[];
        };
        /** @enum {unknown} */
        BookClosedReason: "ClosedByPerson" | "PlatformCompanyChanged" | null;
        /** @description Control and system accounts (ledger account ids). Pre-filled from the chart when the book starts. */
        BookControlAccounts: {
            /**
             * Format: uuid
             * @description Accounts receivable.
             */
            accountsReceivableLedgerAccountId?: null | string;
            /**
             * Format: uuid
             * @description Accounts payable.
             */
            accountsPayableLedgerAccountId?: null | string;
            /**
             * Format: uuid
             * @description VAT control.
             */
            vatLedgerAccountId?: null | string;
            /**
             * Format: uuid
             * @description Uncategorised bank lines (suspense).
             */
            uncategorisedLedgerAccountId?: null | string;
            /**
             * Format: uuid
             * @description Stripe clearing. Optional.
             */
            stripeClearingLedgerAccountId?: null | string;
            /**
             * Format: uuid
             * @description Stripe fees. Optional.
             */
            stripeFeesLedgerAccountId?: null | string;
            /**
             * Format: uuid
             * @description Opening-balance difference.
             */
            openingBalanceDifferenceLedgerAccountId?: null | string;
            /**
             * Format: uuid
             * @description Retained earnings.
             */
            retainedEarningsLedgerAccountId?: null | string;
        };
        /** @description A Books guide with its content. */
        BookGuideResponse: {
            /** @description The guide's topic, used to fetch it, e.g. month-end-close. */
            topic: string;
            /** @description The guide's title. */
            title: string;
            /** @description One line on what the guide covers. */
            summary: string;
            /** @description The guide itself, in Markdown. */
            markdown: string;
        };
        /** @description A Books guide: a short how-to for a bookkeeping task such as closing a month or preparing a VAT quarter. */
        BookGuideSummary: {
            /** @description The guide's topic, used to fetch it, e.g. month-end-close. */
            topic: string;
            /** @description The guide's title. */
            title: string;
            /** @description One line on what the guide covers. */
            summary: string;
        };
        /** @description How far posting has got. Total is 0 for a moment after activation, while the documents to post are counted. */
        BookPostingProgress: {
            /**
             * Format: int32
             * @description Source documents known to the books.
             */
            total?: number | string;
            /**
             * Format: int32
             * @description Posted.
             */
            posted?: number | string;
            /**
             * Format: int32
             * @description Skipped, with a reason (for example a currency other than GBP).
             */
            skipped?: number | string;
            /**
             * Format: int32
             * @description Failed, with a reason; can be retried.
             */
            failed?: number | string;
            /**
             * Format: int32
             * @description Waiting for a prerequisite or a turn.
             */
            waiting?: number | string;
            /**
             * Format: int32
             * @description Being posted now.
             */
            inFlight?: number | string;
            /**
             * Format: date-time
             * @description When the documents to post had all been counted. Null while the backfill is still counting; once set, Total is final, and 0 means there was nothing to post.
             */
            backfilledAt?: null | string;
        };
        /** @description A set of books and how far its setup has got. */
        BookResponse: {
            /**
             * Format: uuid
             * @description Book id.
             */
            id?: string;
            /** @description Setup, Active or Closed. */
            status?: components["schemas"]["BookStatus"];
            /**
             * Format: date
             * @description First day of the books.
             */
            startDate?: string;
            /**
             * Format: date
             * @description The day before the start date; the opening balances are the platform's trial balance at its end.
             */
            openingBalanceDate?: string;
            /**
             * Format: date
             * @description Lock date, if set.
             */
            closeDate?: null | string;
            /** @description Currency of every amount in the books. */
            baseCurrency?: string;
            /** @description The basis reports use when none is asked for: Accrual or Cash. */
            reportingBasis?: components["schemas"]["ReportingBasis"];
            /** @description The accounting platform company the books' chart comes from. */
            platformCompanyId?: string;
            /** @description Control and system accounts. */
            controlAccounts?: components["schemas"]["BookControlAccounts"];
            /** @description The platform's bank-type accounts and how each is mapped. */
            bankAccounts?: components["schemas"]["BookBankAccountResponse"][];
            /**
             * Format: uuid
             * @description The opening-balance entry currently in force, if imported.
             */
            openingBalancesEntryId?: null | string;
            /** @description Setup steps and whether each is done. */
            checklist?: components["schemas"]["BookChecklist"];
            progress?: null | components["schemas"]["BookPostingProgress"];
            /**
             * Format: date-time
             * @description When the book was activated.
             */
            activatedAt?: null | string;
            /**
             * Format: date-time
             * @description When the book was closed.
             */
            closedAt?: null | string;
            closedReason?: null | components["schemas"]["BookClosedReason"];
        };
        /**
         * @description Which text on the bank line a rule reads.
         * @enum {unknown}
         */
        BookRuleField: "Description" | "Counterparty";
        /**
         * @description Contains: the text includes the value anywhere. Equals: the text is the value, ignoring case, digits and punctuation.
         * @enum {unknown}
         */
        BookRuleOperator: "Contains" | "Equals";
        /** @description A categorisation rule: bank lines it matches are filed under its account automatically. */
        BookRuleResponse: {
            /**
             * Format: uuid
             * @description Id of the rule.
             */
            id: string;
            /** @description The rule's name, shown on the lines it categorises. */
            name: string;
            /**
             * Format: int32
             * @description Order the rules are tried in, lowest first; the first match wins.
             */
            priority: number | string;
            /** @description The bank line text the rule reads: Description or Counterparty. */
            field: components["schemas"]["BookRuleField"];
            /** @description Contains or Equals, ignoring case. */
            operator: components["schemas"]["BookRuleOperator"];
            /** @description The text to look for. */
            value: string;
            direction: null | components["schemas"]["BankLineDirection"];
            /**
             * Format: double
             * @description Only lines of at least this unsigned amount.
             */
            minAmount: null | number | string;
            /**
             * Format: double
             * @description Only lines of at most this unsigned amount.
             */
            maxAmount: null | number | string;
            /**
             * Format: uuid
             * @description Id of the ledger account matching lines are filed under.
             */
            ledgerAccountId: string;
            /**
             * Format: uuid
             * @description Id of the tax rate the amounts include, if any.
             */
            accountingTaxRateId: null | string;
            /** @description Whether the rule runs. */
            isEnabled: boolean;
            /**
             * Format: int32
             * @description How many lines the rule has categorised.
             */
            hitCount: number | string;
            /**
             * Format: date-time
             * @description When the rule last categorised a line (UTC).
             */
            lastHitAt: null | string;
            /**
             * Format: date-time
             * @description When the rule was created (UTC).
             */
            createdAt: string;
            /**
             * Format: date-time
             * @description When the rule was last changed (UTC).
             */
            updatedAt: string;
        };
        /** @description A refusal to start a book, as the start request would return it. */
        BookStartBlock: {
            /** @description The error code, e.g. Books.AccountingNotConnected. */
            code?: string;
            /** @description What is missing, in words. */
            detail?: string;
        };
        /** @description The start dates a new book can take: every first of a month from earliest to latest. */
        BookStartDatesResponse: {
            /**
             * Format: date
             * @description Earliest start date the connected bank accounts' fetched history allows; null when no account has history yet, so no lower bound applies.
             */
            earliest?: null | string;
            /**
             * Format: date
             * @description Latest start date: the first day of the current month.
             */
            latest?: string;
            blockedReason?: null | components["schemas"]["BookStartBlock"];
        };
        /** @enum {unknown} */
        BookStatus: "Setup" | "Active" | "Closed";
        BrowserSignIns: {
            browser: components["schemas"]["DeviceBrowser"];
            /** Format: int32 */
            signIns: number | string;
        };
        BulkCreateProductsResponse: {
            /**
             * Format: int32
             * @description How many products were created. Equal to the number of data rows in the file, since an upload either creates all of them or none.
             */
            created?: number | string;
            /** @description The created products, in file order. */
            products?: components["schemas"]["ProductResponse"][];
        };
        /** @enum {unknown} */
        BusinessType: "SoleTrader" | "LimitedCompany" | "LLP" | "Partnership" | null;
        /** @description Result of importing recent card history. */
        CardBackfillResponse: {
            /**
             * Format: int32
             * @description How many transactions were read from the card provider.
             */
            transactionsFetched?: number | string;
            /**
             * Format: int32
             * @description How many were new. Transactions already held are skipped, so calling this again is safe.
             */
            transactionsImported?: number | string;
            /** @description True when the import stopped at its page limit before reaching the end of the window, so older transactions may be missing. */
            truncated?: boolean;
        };
        /** @description A card the organisation has linked, and the accounting configuration that decides where its spend posts. */
        CardConnectionResponse: {
            /**
             * Format: uuid
             * @description Unique identifier of the card connection.
             */
            id?: string;
            /**
             * Format: uuid
             * @description The organisation that owns the card.
             */
            organisationId?: string;
            /** @description The card provider the card is linked through. Fake cards are generated samples, available to Sandbox clients only. */
            provider?: components["schemas"]["CardProvider"];
            /** @description Card network, e.g. VISA or MASTERCARD. */
            network?: null | string;
            /** @description Last four digits of the card. The full number is never held by Dolfin — card capture is scoped to the card provider. */
            last4?: null | string;
            /**
             * Format: int32
             * @description Expiry month, if the provider supplied one.
             */
            expiryMonth?: null | number | string;
            /**
             * Format: int32
             * @description Expiry year, if the provider supplied one.
             */
            expiryYear?: null | number | string;
            /** @description User-set nickname for the card, e.g. "Ops card". */
            displayName?: null | string;
            /** @description Connection status: Pending, Active, Broken (needs re-enrolment) or Removed. */
            status?: components["schemas"]["CardConnectionStatus"];
            /**
             * Format: uuid
             * @description The account spend on this card is credited to — the card's clearing account. Required before any expense on this card can be posted.
             */
            clearingLedgerAccountId?: null | string;
            /**
             * Format: uuid
             * @description Fallback expense account used when a transaction's merchant category code has no mapping. Without it, an unmapped code flags the expense for review.
             */
            defaultExpenseLedgerAccountId?: null | string;
            holder?: null | components["schemas"]["ExpensePersonResponse"];
            /**
             * Format: date-time
             * @description When the card was enrolled.
             */
            enrolledAt?: null | string;
            /**
             * Format: date-time
             * @description When the card connection was created.
             */
            createdAt?: string;
            /**
             * Format: date-time
             * @description When the card connection was last updated.
             */
            updatedAt?: string;
        };
        /** @enum {unknown} */
        CardConnectionStatus: "Pending" | "Active" | "Broken" | "Removed";
        /** @enum {unknown} */
        CardProvider: "Fake" | "Legacy";
        /** @description A card provider an organisation can link a card through. */
        CardProviderResponse: {
            /** @description Identifier to pass as provider when starting enrollment. */
            provider?: components["schemas"]["CardProvider"];
            /** @description Name to show in a provider picker. */
            name: string;
            /** @description One-line explanation of what linking through this provider involves. */
            description: string;
            /** @description True for the sample provider, which generates a card and its spend instead of linking a real one. */
            isSample?: boolean;
            /** @description False when this environment is not yet set up for the provider; starting enrollment with it would fail. */
            isAvailable?: boolean;
        };
        /** @description A card transaction received from the card network. Read-only: this is a mirror of provider data, not something Dolfin edits. */
        CardTransactionResponse: {
            /**
             * Format: uuid
             * @description Unique identifier of the card transaction.
             */
            id?: string;
            /**
             * Format: uuid
             * @description The card the transaction was made on.
             */
            cardConnectionId?: string;
            /**
             * Format: uuid
             * @description The expense created for this transaction. Null only for declined authorisations, which never become expenses.
             */
            expenseId?: null | string;
            /** @description Transaction status. Pending means a financial message is still expected; Settled means the amount is final; Voided means the authorisation was reversed; Declined means no funds moved. */
            status?: components["schemas"]["CardTransactionStatus"];
            /** @description Merchant name as printed by the card network. Often abbreviated or prefixed by the payment processor. */
            descriptor?: null | string;
            /** @description Cleaner merchant name where the provider supplied enrichment data. Advisory only. */
            enrichedMerchantName?: null | string;
            /** @description Merchant logo URL where the provider supplied enrichment data. */
            merchantLogoUrl?: null | string;
            /** @description Currency the merchant charged in (ISO 4217). Always present. */
            transactionCurrency: string;
            /**
             * Format: double
             * @description Authorised (held) amount in the transaction currency. Always present; zero once a hold is released.
             */
            transactionHoldAmount?: number | string;
            /**
             * Format: double
             * @description Settled amount in the transaction currency. Always present, and zero until the transaction clears — read it together with status rather than treating zero as unknown.
             */
            transactionSettledAmount?: number | string;
            /** @description Currency the cardholder's account is billed in (ISO 4217). Differs from the transaction currency on foreign purchases. Always present. */
            billingCurrency: string;
            /**
             * Format: double
             * @description Settled amount in the billing currency. Always present, and zero until the transaction clears.
             */
            billingSettledAmount?: number | string;
            /**
             * Format: double
             * @description The amount that actually moved: the authorised hold while the transaction is pending, the settled amount once it has cleared, been voided or been declined. This is the figure matching and coding use, and the one to display.
             */
            effectiveAmount?: number | string;
            /** @description Merchant category code — the four-digit code the card network assigns the merchant. The key expenses are coded from. */
            mcc?: null | string;
            /** @description Human-readable label derived from the merchant category code. */
            mccLabel?: null | string;
            /** @description Merchant city, where the network supplied one. */
            acceptorCity?: null | string;
            /** @description Merchant country as an ISO 3166 alpha-3 code. */
            acceptorCountry?: null | string;
            /**
             * Format: date-time
             * @description When the transaction occurred.
             */
            transactionOccurrenceDate?: null | string;
            /**
             * Format: date-time
             * @description When Dolfin received the transaction.
             */
            ingestedAt?: string;
            /** @description Whether a receipt has been matched to this transaction's expense. */
            hasReceipt?: boolean;
        };
        /** @enum {unknown} */
        CardTransactionStatus: "Pending" | "Voided" | "Settled" | "Declined";
        /** @description One bank account's cash flow in a month. */
        CashFlowAccount: {
            /**
             * Format: uuid
             * @description Ledger account id of the bank account.
             */
            ledgerAccountId?: string;
            /** @description Account code, when the platform has codes. */
            code?: null | string;
            /** @description Account name. */
            name?: string;
            /**
             * Format: double
             * @description Balance at the end of the day before the period.
             */
            opening?: number | string;
            /**
             * Format: double
             * @description Balance at the end of the period. Equals the trial balance at that date on the same basis.
             */
            closing?: number | string;
            /**
             * Format: double
             * @description Money paid in during the period, positive.
             */
            moneyIn?: number | string;
            /**
             * Format: double
             * @description Money paid out during the period, positive.
             */
            moneyOut?: number | string;
            /**
             * Format: double
             * @description Money in less money out: closing less opening.
             */
            net?: number | string;
            /** @description Net split by what each movement was for, money in positive. Sums to net. Categories with nothing are left out. */
            byCategory?: components["schemas"]["CashFlowCategoryAmount"][];
        };
        /**
         * @description What a bank movement was for, read from the other side of its journal entry. CustomerReceipts: the receivables control account. SupplierPayments: the payables control account. Income: an income account posted directly. Expenses: an expense or cost of sales account. Tax: the VAT account. Transfers: another bank account in the books. Uncategorised: the uncategorised (suspense) account, for bank lines not yet categorised (a categorised bank line counts under the accounts it was categorised to). Financing: equity, loans and other liabilities. Assets: other assets, such as fixed assets. CardPayouts: card payments paid out by Stripe, net of fees. Other: anything else. An entry with several other-side lines is split in proportion to them.
         * @enum {unknown}
         */
        CashFlowCategory: "CustomerReceipts" | "SupplierPayments" | "Income" | "Expenses" | "Tax" | "Transfers" | "Uncategorised" | "Financing" | "Assets" | "CardPayouts" | "Other";
        /** @description The part of a movement that went to or came from one kind of account. */
        CashFlowCategoryAmount: {
            /** @description What the money was for. */
            category?: components["schemas"]["CashFlowCategory"];
            /**
             * Format: double
             * @description Amount, money in positive.
             */
            amount?: number | string;
        };
        /** @description One calendar month's cash flow: the bank accounts together, then each account. */
        CashFlowMonth: {
            /**
             * Format: date
             * @description The month, as its first day.
             */
            month?: string;
            /**
             * Format: date
             * @description First day counted: the month's first day, or the period's start in its first month.
             */
            from?: string;
            /**
             * Format: date
             * @description Last day counted: the month's last day, or the period's end in its last month.
             */
            to?: string;
            /** @description Every bank account in the books, in code then name order. A transfer between two of them shows on both, so it nets to zero in the month's totals. */
            accounts?: components["schemas"]["CashFlowAccount"][];
            /**
             * Format: double
             * @description Balance at the end of the day before the period.
             */
            opening?: number | string;
            /**
             * Format: double
             * @description Balance at the end of the period. Equals the trial balance at that date on the same basis.
             */
            closing?: number | string;
            /**
             * Format: double
             * @description Money paid in during the period, positive.
             */
            moneyIn?: number | string;
            /**
             * Format: double
             * @description Money paid out during the period, positive.
             */
            moneyOut?: number | string;
            /**
             * Format: double
             * @description Money in less money out: closing less opening.
             */
            net?: number | string;
            /** @description Net split by what each movement was for, money in positive. Sums to net. Categories with nothing are left out. */
            byCategory?: components["schemas"]["CashFlowCategoryAmount"][];
        };
        /** @description Why the bank accounts' balances moved, month by month: each month's money in and out per bank account in the books, broken down by what was on the other side of each movement. */
        CashFlowResponse: {
            /**
             * Format: date
             * @description First day of the period (the book's start date when the period asked for began before it).
             */
            from?: string;
            /**
             * Format: date
             * @description Last day of the period.
             */
            to?: string;
            /** @description The basis the figures are on: Accrual or Cash. */
            basis?: components["schemas"]["ReportingBasis"];
            /** @description Currency of every amount. */
            currency?: string;
            /** @description Every calendar month in the period, oldest first, zero-filled. */
            months?: components["schemas"]["CashFlowMonth"][];
        };
        /** @description A group of Uncategorised lines to file under one account, optionally saving a rule for next time. */
        CategoriseBankLineGroupRequest: {
            /** @description The group's key, as the groups list gives it. */
            key: string;
            /** @description The group's direction: In or Out. */
            direction: components["schemas"]["BankLineDirection"];
            /**
             * Format: uuid
             * @description Id of the ledger account to file every line in the group under.
             */
            ledgerAccountId: string;
            /**
             * Format: uuid
             * @description Id of the accounting tax rate the amounts include; leave out for no VAT.
             */
            accountingTaxRateId?: null | string;
            /**
             * @description True also saves a rule (payee equals the key, same direction, same account and tax rate) so future lines like these are categorised automatically.
             * @default false
             */
            createRule: boolean;
            /** @description Name for the new rule; defaults to the key. */
            ruleName?: null | string;
        };
        /** @description What categorising a group did. */
        CategoriseBankLineGroupResponse: {
            /**
             * Format: int32
             * @description How many lines were categorised.
             */
            categorised: number | string;
            /** @description Ids of the lines categorised. */
            lineIds: string[];
            rule: null | components["schemas"]["BookRuleResponse"];
        };
        /** @description The account to file the bank line under, with an optional tax rate. */
        CategoriseBankLineRequest: {
            /**
             * Format: uuid
             * @description Id of the ledger account (from the organisation's chart of accounts) to file the line under.
             */
            ledgerAccountId: string;
            /**
             * Format: uuid
             * @description Id of the accounting tax rate the amount includes. VAT is split out of the gross to the book's VAT account; leave out for no VAT.
             */
            accountingTaxRateId?: null | string;
        };
        CheckoutSessionResponse: {
            clientSecret: string;
            publishableKey: string;
            connectedAccountId: string;
            /** Format: double */
            amount?: number | string;
            currency: string;
        };
        ClearedBillMatches: {
            /** Format: int32 */
            matchGroupsRemoved: number | string;
            /** Format: int32 */
            allocationsRemoved: number | string;
        };
        ClientActiveOrganisations: {
            /** Format: uuid */
            clientId: string;
            clientName: string;
            /** Format: int32 */
            activeOrganisations: number | string;
        };
        ClientAdminResponse: {
            /** Format: uuid */
            sourceClientId?: null | string;
            /** Format: date-time */
            clonedAt?: null | string;
            /** Format: uuid */
            id?: string;
            name: string;
            type?: components["schemas"]["ClientType"];
            /** Format: double */
            paymentRevenueSharePercent?: number | string;
            /** Format: double */
            dolfinRevenueSharePercent?: number | string;
            logoUrl?: null | string;
            primaryColour?: null | string;
            /** @description The modules this client is entitled to, such as "ar", "ap" or "ap.payments". Use it to hide features the client has not purchased instead of calling and handling a 403. Re-fetch after a 403 that names a module — entitlements are resolved per request, so this list always matches what the API will actually allow. */
            modules?: string[];
            /** Format: date-time */
            createdAt?: string;
            /** Format: uuid */
            createdBy?: null | string;
            /** Format: date-time */
            updatedAt?: string;
            /** Format: uuid */
            updatedBy?: null | string;
        };
        /** @description Client-level settings for the expenses workflow, applied to every organisation under the Client. */
        ClientExpenseSettingsResponse: {
            /** @description Whether a coded expense waits for a person to release it before posting. When false, coded expenses post automatically once the card transaction settles. */
            requireReviewBeforePost?: boolean;
            /** @description Whether expenses are pushed as drafts in the accounting platform rather than posted transactions. */
            postAsDraft?: boolean;
            /**
             * Format: double
             * @description Minimum score for an automatic receipt match, between 0 and 1.
             */
            matchScoreThreshold?: number | string;
            /**
             * Format: double
             * @description How far the best candidate must lead the runner-up before an automatic match is made. Near-ties are handed to a person instead.
             */
            matchScoreMargin?: number | string;
            /**
             * Format: double
             * @description Absolute amount tolerance for reconciling a receipt to a transaction.
             */
            matchAmountToleranceAbsolute?: number | string;
            /**
             * Format: double
             * @description Proportional amount tolerance, applied alongside the absolute one — the larger wins. This is what absorbs tips and service charges.
             */
            matchAmountTolerancePercent?: number | string;
            /**
             * Format: int32
             * @description How many days either side of a transaction a receipt may be dated and still match.
             */
            matchDateWindowDays?: number | string;
            /**
             * Format: int32
             * @description How far back transactions are pulled when a card is first connected.
             */
            backfillWindowDays?: number | string;
        };
        ClientInviteResponse: {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            clientId: string;
            email: string;
            role: components["schemas"]["ClientRole"];
            /** Format: date-time */
            createdAt: string;
            /** Format: date-time */
            expiresAt: string;
            /** Format: uuid */
            invitedBy: null | string;
            /** @description Pending if still within its validity window, Expired if past ExpiresAt. Accepted invites are not returned (they appear as members). */
            status: components["schemas"]["ClientInviteStatus"];
        };
        /** @enum {unknown} */
        ClientInviteStatus: "Pending" | "Expired";
        ClientInviteWithTokenResponse: {
            token: string;
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            clientId: string;
            email: string;
            role: components["schemas"]["ClientRole"];
            /** Format: date-time */
            createdAt: string;
            /** Format: date-time */
            expiresAt: string;
            /** Format: uuid */
            invitedBy: null | string;
            /** @description Pending if still within its validity window, Expired if past ExpiresAt. Accepted invites are not returned (they appear as members). */
            status: components["schemas"]["ClientInviteStatus"];
        };
        ClientMccMappingResponse: {
            mcc: string;
            ledgerAccountCode: string;
            taxCode?: null | string;
            categoryLabel?: null | string;
            isVatReclaimable?: boolean;
        };
        ClientModuleAuditLogResponse: {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            clientId: string;
            /** @description The module that moved, such as "ap.payments". */
            moduleKey: string;
            /** @description Whether the client held the module before this change. */
            fromState?: components["schemas"]["ModuleGrantState"];
            /** @description Whether the client holds it after. A row with "NotGranted" here is a revocation. */
            toState?: components["schemas"]["ModuleGrantState"];
            /**
             * Format: uuid
             * @description Groups every row written by one staff action, so an edit that changed several modules reads back as one change rather than several coincidences.
             */
            changeSetId?: string;
            /**
             * Format: uuid
             * @description The Dolfin staff user who made the change, when one could be identified.
             */
            actorId?: null | string;
            /** @description What kind of actor this was: "StaffUser" (a named person), "AdminApiKey" (staff acting through the shared key, which identifies no person), or "System" (client creation or a migration). Both of the latter leave the actor id null for different reasons. */
            actorType?: components["schemas"]["ModuleGrantActorType"];
            /** @description Why the change was made, if the staff member said. Free text. */
            reason?: null | string;
            /** Format: date-time */
            createdAt: string;
        };
        ClientModuleResponse: {
            /** @description The module key the client holds, such as "ap.payments". */
            key: string;
            /** @description The area key this module belongs to, or null for a top-level area. */
            parentKey?: null | string;
            /** @description The module's catalogue status. A Deprecated module here is still fully honoured — it just cannot be granted to anyone new. */
            status?: components["schemas"]["ModuleStatus"];
            /** @description The commercial name of the module. */
            displayName: string;
            /**
             * Format: date-time
             * @description When this grant was made. Preserved across edits: re-sending a module the client already holds does not reset it.
             */
            grantedAt?: string;
            /**
             * Format: uuid
             * @description The Dolfin staff user who made the grant, or null when it was made by the first-migration backfill or with the shared admin API key (which identifies no person).
             */
            grantedBy?: null | string;
        };
        ClientResponse: {
            /** Format: uuid */
            id?: string;
            name: string;
            type?: components["schemas"]["ClientType"];
            /** Format: double */
            paymentRevenueSharePercent?: number | string;
            /** Format: double */
            dolfinRevenueSharePercent?: number | string;
            logoUrl?: null | string;
            primaryColour?: null | string;
            /** @description The modules this client is entitled to, such as "ar", "ap" or "ap.payments". Use it to hide features the client has not purchased instead of calling and handling a 403. Re-fetch after a 403 that names a module — entitlements are resolved per request, so this list always matches what the API will actually allow. */
            modules?: string[];
            /** Format: date-time */
            createdAt?: string;
            /** Format: uuid */
            createdBy?: null | string;
            /** Format: date-time */
            updatedAt?: string;
            /** Format: uuid */
            updatedBy?: null | string;
        };
        /** @enum {unknown} */
        ClientRole: "Member" | "Developer" | "Admin" | "Owner";
        ClientStatsResponse: {
            /** Format: uuid */
            clientId: string;
            /** Format: date-time */
            asOf: string;
            /** Format: int32 */
            organisations: number | string;
            /** Format: int32 */
            users: number | string;
            /** Format: int32 */
            portalMembers: number | string;
            /** Format: int32 */
            apiKeys: number | string;
            /** Format: int32 */
            webhookSubscriptions: number | string;
            /** Format: int32 */
            invoices: number | string;
            /** Format: int32 */
            bills: number | string;
            /** Format: int32 */
            customers: number | string;
            /** Format: int32 */
            suppliers: number | string;
            /** Format: int32 */
            products: number | string;
            /** Format: int32 */
            taxRates: number | string;
            /** Format: int32 */
            purchaseOrders: number | string;
            /** Format: int32 */
            deliveryNotes: number | string;
            /** Format: int32 */
            creditNotes: number | string;
            /** Format: int32 */
            supplierCreditNotes: number | string;
            /** Format: int32 */
            expenses: number | string;
            /** Format: int32 */
            receipts: number | string;
        };
        /** @enum {unknown} */
        ClientType: "Live" | "Sandbox" | "Demo";
        /** @description Options for a match-testing clone. Every field is optional; an omitted body clones the whole client with every bill in scope. */
        CloneForMatchTestingRequest: {
            /** @description Name for the clone. Defaults to the source client's name plus a dated "(match test yyyy-MM-dd)" marker. */
            name?: null | string;
            /** @description Which bills to pull back. AllBills (default) includes bills the engine never grouped, which is where a settings change most often shows up. GroupedOnly narrows to bills that already have a match group in the source. */
            population?: components["schemas"]["RewindPopulation"];
            /**
             * Format: date-time
             * @description Optional lower bound on Bill.CreatedAt. Bounds what is COPIED as well as what is re-matched, so narrowing it genuinely makes the run smaller.
             */
            createdFrom?: null | string;
            /**
             * Format: date-time
             * @description Optional upper bound on Bill.CreatedAt.
             */
            createdTo?: null | string;
            /** @description What the clone reproduces. Rewound (default) copies the documents and re-runs matching immediately, so the clone shows this client's bills matched under current settings; the matches the source already has are NOT carried over. Verbatim copies everything as-is INCLUDING the source's existing match groups, allocations, line resolutions and line stats, leaves bills in their real states and documents at their real statuses, and runs NOTHING — tune AP settings on the clone, then re-run it with the rematch endpoint and compare against this baseline. A Verbatim run allows a larger bill scope because it never runs the matcher, but the rematch endpoint keeps the smaller bound, so a baseline above that bound can only be re-run in CreatedFrom/CreatedTo windows. */
            mode?: components["schemas"]["CloneMode"];
        };
        /**
         * @default Rewound
         * @enum {unknown}
         */
        CloneMode: "Rewound" | "Verbatim";
        CompanyAdminResponse: {
            /** Format: uuid */
            clientId?: string;
            /** Format: uuid */
            id?: string;
            /** @description Display name of the parent group, e.g. "Ozone Coffee". */
            name: string;
            /** @description Head office address. Used to recognise group-level bills, which are never routed automatically to an individual site. */
            addressLine1?: null | string;
            addressLine2?: null | string;
            city?: null | string;
            postalCode?: null | string;
            /** @description ISO 3166-1 alpha-2 country code (e.g. GB, US, DE) */
            country?: null | string;
            /** @description Contact address for notifications about bills awaiting routing. */
            contactEmail?: null | string;
            /**
             * Format: double
             * @description Overrides the client-wide automatic-routing score for this company only. Null means the client setting applies. Useful when one group's bills carry messier addresses than the rest.
             */
            autoAssignThreshold?: null | number | string;
            /**
             * Format: double
             * @description Overrides the client-wide automatic-routing margin for this company only. Null means the client setting applies.
             */
            autoAssignMargin?: null | number | string;
            /** Format: date-time */
            createdAt?: string;
            /** Format: uuid */
            createdBy?: null | string;
            /** Format: date-time */
            updatedAt?: string;
            /** Format: uuid */
            updatedBy?: null | string;
        };
        CompanyBillAssignedResponse: {
            /**
             * Format: uuid
             * @description The bill's identifier — unchanged by the assignment. Retrieve it from GET /bills/{billId} from now on.
             */
            billId?: string;
            /** Format: uuid */
            organisationId?: string;
        };
        CompanyBillCreatedResponse: {
            /** Format: uuid */
            id?: string;
            status?: components["schemas"]["CompanyInboxBillStatus"];
        };
        CompanyInboxBillAdminResponse: {
            /** Format: uuid */
            clientId?: string;
            /**
             * Format: date-time
             * @description When the router last ran over this bill.
             */
            routedAt?: null | string;
            /**
             * Format: int32
             * @description How many times extraction has been retried after failing.
             */
            extractionRetryCount?: number | string;
            /** Format: date-time */
            discardedAt?: null | string;
            /** Format: uuid */
            discardedBy?: null | string;
            discardReason?: null | string;
            /** Format: uuid */
            createdBy?: null | string;
            /**
             * Format: uuid
             * @description Identifier of the bill. It does not change when the bill is routed: the same id retrieves the bill from GET /bills/{billId} afterwards.
             */
            id?: string;
            /** Format: uuid */
            companyId?: string;
            /** @description Where the bill is in the inbox. AwaitingOrganisation means it needs routing; ExtractionFailed means the document could not be read; Discarded means someone rejected it. */
            status?: components["schemas"]["CompanyInboxBillStatus"];
            /** @description How the bill arrived — an API upload, or the company's bill-forwarding email address. */
            source?: components["schemas"]["BillSource"];
            routingOutcome?: null | components["schemas"]["CompanyRoutingOutcome"];
            /**
             * Format: uuid
             * @description The organisation the bill most likely belongs to, if one stood out. Present even when confidence was too low to route automatically.
             */
            suggestedOrganisationId?: null | string;
            /**
             * Format: double
             * @description How confident the address match was, from 0 to 1.
             */
            suggestedOrganisationConfidence?: null | number | string;
            /** @description The candidate organisations, best match first, so a reviewer can pick rather than search. */
            candidates?: components["schemas"]["CompanyInboxBillCandidateResponse"][];
            supplierName?: null | string;
            supplierEmail?: null | string;
            supplierAddress?: null | string;
            /** @description The delivery address exactly as printed on the document. */
            deliveryAddress?: null | string;
            deliveryAddressDetail?: null | components["schemas"]["Address"];
            invoiceNumber?: null | string;
            billPoNumbers?: string[];
            /** Format: date-time */
            invoiceDate?: null | string;
            /** Format: date-time */
            dueDate?: null | string;
            /** @description ISO 4217 currency code (e.g. GBP, USD, EUR) */
            currency?: string;
            /** Format: double */
            subTotal?: number | string;
            /** Format: double */
            taxAmount?: number | string;
            /** Format: double */
            totalAmount?: number | string;
            /** @description Name of the uploaded document, when there is one. Its contents are retrieved from GET /companies/{companyId}/bills/{billId}/file-url — null here means there is no document to fetch. */
            fileName?: null | string;
            /** @description Media type of the uploaded document, e.g. application/pdf. */
            fileType?: null | string;
            /**
             * Format: float
             * @description Extraction confidence reported by the document reader, from 0 to 1.
             */
            confidence?: null | number | string;
            /** @description Why extraction failed, when it did. */
            extractionError?: null | string;
            /** Format: date-time */
            createdAt?: string;
            /** Format: date-time */
            updatedAt?: string;
        };
        CompanyInboxBillCandidateResponse: {
            /** Format: uuid */
            organisationId?: string;
            /**
             * Format: double
             * @description Match strength from 0 to 1.
             */
            score?: number | string;
            /** @description Which signal produced the score: "postcode" for an exact postcode match, "address" for address text overlap, or "name" where the site's name appears in the delivery block. */
            basis: string;
        };
        CompanyInboxBillResponse: {
            /**
             * Format: uuid
             * @description Identifier of the bill. It does not change when the bill is routed: the same id retrieves the bill from GET /bills/{billId} afterwards.
             */
            id?: string;
            /** Format: uuid */
            companyId?: string;
            /** @description Where the bill is in the inbox. AwaitingOrganisation means it needs routing; ExtractionFailed means the document could not be read; Discarded means someone rejected it. */
            status?: components["schemas"]["CompanyInboxBillStatus"];
            /** @description How the bill arrived — an API upload, or the company's bill-forwarding email address. */
            source?: components["schemas"]["BillSource"];
            routingOutcome?: null | components["schemas"]["CompanyRoutingOutcome"];
            /**
             * Format: uuid
             * @description The organisation the bill most likely belongs to, if one stood out. Present even when confidence was too low to route automatically.
             */
            suggestedOrganisationId?: null | string;
            /**
             * Format: double
             * @description How confident the address match was, from 0 to 1.
             */
            suggestedOrganisationConfidence?: null | number | string;
            /** @description The candidate organisations, best match first, so a reviewer can pick rather than search. */
            candidates?: components["schemas"]["CompanyInboxBillCandidateResponse"][];
            supplierName?: null | string;
            supplierEmail?: null | string;
            supplierAddress?: null | string;
            /** @description The delivery address exactly as printed on the document. */
            deliveryAddress?: null | string;
            deliveryAddressDetail?: null | components["schemas"]["Address"];
            invoiceNumber?: null | string;
            billPoNumbers?: string[];
            /** Format: date-time */
            invoiceDate?: null | string;
            /** Format: date-time */
            dueDate?: null | string;
            /** @description ISO 4217 currency code (e.g. GBP, USD, EUR) */
            currency?: string;
            /** Format: double */
            subTotal?: number | string;
            /** Format: double */
            taxAmount?: number | string;
            /** Format: double */
            totalAmount?: number | string;
            /** @description Name of the uploaded document, when there is one. Its contents are retrieved from GET /companies/{companyId}/bills/{billId}/file-url — null here means there is no document to fetch. */
            fileName?: null | string;
            /** @description Media type of the uploaded document, e.g. application/pdf. */
            fileType?: null | string;
            /**
             * Format: float
             * @description Extraction confidence reported by the document reader, from 0 to 1.
             */
            confidence?: null | number | string;
            /** @description Why extraction failed, when it did. */
            extractionError?: null | string;
            /** Format: date-time */
            createdAt?: string;
            /** Format: date-time */
            updatedAt?: string;
        };
        /** @enum {unknown} */
        CompanyInboxBillStatus: "Extracting" | "ExtractionFailed" | "AwaitingOrganisation" | "Discarded";
        CompanyResponse: {
            /** Format: uuid */
            id?: string;
            /** @description Display name of the parent group, e.g. "Ozone Coffee". */
            name: string;
            /** @description Head office address. Used to recognise group-level bills, which are never routed automatically to an individual site. */
            addressLine1?: null | string;
            addressLine2?: null | string;
            city?: null | string;
            postalCode?: null | string;
            /** @description ISO 3166-1 alpha-2 country code (e.g. GB, US, DE) */
            country?: null | string;
            /** @description Contact address for notifications about bills awaiting routing. */
            contactEmail?: null | string;
            /**
             * Format: double
             * @description Overrides the client-wide automatic-routing score for this company only. Null means the client setting applies. Useful when one group's bills carry messier addresses than the rest.
             */
            autoAssignThreshold?: null | number | string;
            /**
             * Format: double
             * @description Overrides the client-wide automatic-routing margin for this company only. Null means the client setting applies.
             */
            autoAssignMargin?: null | number | string;
            /** Format: date-time */
            createdAt?: string;
            /** Format: uuid */
            createdBy?: null | string;
            /** Format: date-time */
            updatedAt?: string;
            /** Format: uuid */
            updatedBy?: null | string;
        };
        /** @enum {unknown} */
        CompanyRoutingOutcome: "AutoAssigned" | "BelowThreshold" | "Ambiguous" | "HeadOffice" | "MultipleDeliveryAddresses" | "NoDeliveryAddress" | "NoOrganisations" | "AutoAssignDisabled" | null;
        /** @description Whether a possible duplicate really is one. */
        ConfirmBankLineDuplicateRequest: {
            /** @description True: a duplicate, ignored and kept out of the books. False: a real transaction, matched or posted to Uncategorised. */
            isDuplicate: boolean;
        };
        ConfirmBillPaidRequest: {
            paymentMethod: components["schemas"]["ManualPaymentMethod"];
        };
        /** @description The clause a confirmed policy enforces. */
        ConfirmedExpensePolicyClause: {
            /** @description The clause, quoted from the document. */
            quote?: string;
            /**
             * Format: int32
             * @description Page the clause appears on, for PDF documents.
             */
            page?: null | number | string;
        };
        /** @description A proposal as confirmed by the reviewer, possibly edited. */
        ConfirmedExpensePolicyProposal: {
            clause?: null | components["schemas"]["ConfirmedExpensePolicyClause"];
            /** @description Display name, up to 120 characters. */
            name?: string;
            /**
             * Format: int32
             * @description 0–1000; lower numbers win when several policies match. Also the display order.
             */
            priorityOrder?: number | string;
            /** @description Inactive policies are kept but never applied. Defaults to true. */
            active?: boolean;
            /**
             * Format: double
             * @description Match expenses of at least this amount, in `currency`. Judged on what the card was charged in its billing currency, the figure that posts to the accounting platform.
             */
            amountGte?: null | number | string;
            /**
             * Format: double
             * @description Match expenses of at most this amount, in `currency`. Judged on what the card was charged in its billing currency, the figure that posts to the accounting platform.
             */
            amountLte?: null | number | string;
            /** @description ISO 4217 code. Required when an amount bound is set; the policy then only matches spend on cards billed in this currency, with no conversion. A purchase made abroad is judged on its billed amount, not the foreign amount. */
            currency?: null | string;
            /** @description Four-digit merchant category codes to match. Empty matches any category. */
            mccCodes?: string[];
            /** @description Merchants to match. Empty matches any merchant. A merchant-, card- or person-specific policy takes precedence over one that applies to all. */
            merchantIds?: string[];
            /** @description Linked cards to match. Empty matches any card. A merchant-, card- or person-specific policy takes precedence over one that applies to all. */
            cardConnectionIds?: string[];
            /** @description Organisation members whose spend to match, by who spent it. Empty matches anyone, including spend with no spender. A merchant-, card- or person-specific policy takes precedence over one that applies to all. */
            spenderUserIds?: string[];
            /** @description Match by whether a receipt is attached. Defaults to Any. */
            receiptCondition?: components["schemas"]["ExpenseReceiptCondition"];
            /** @description Match business spend, personal spend, or both. Defaults to Any. */
            personalSpend?: components["schemas"]["ExpensePersonalSpendCondition"];
            /** @description What happens to a matching expense. Defaults to RequireApproval. */
            action?: components["schemas"]["ExpenseApprovalPolicyAction"];
            /** @description Up to 5 organisation members who may approve, for RequireApproval only (ignored otherwise). Empty means any member allowed to approve expenses. */
            approverUserIds?: string[];
        };
        /** @description Confirms a policy document's proposals, making them the organisation's document-sourced approval policies. */
        ConfirmExpensePolicyDocumentRequest: {
            /** @description The policies to create, as edited by the reviewer. Omit to confirm the proposals exactly as compiled. Anything left out is not created. */
            policies?: null | components["schemas"]["ConfirmedExpensePolicyProposal"][];
        };
        ConfirmSupplierBankDetailsRequest: {
            sortCode: null | string;
            accountNumber: null | string;
            iban?: null | string;
            routingNumber?: null | string;
        };
        /** @description A session for embedding a provider's hosted connect flow in your own application. */
        ConnectSessionResponse: {
            /** @description Short-lived session token to hand to the provider's embedded component. */
            token: string;
            /** @description URL of the provider's hosted flow, where one is offered. */
            url?: null | string;
            /**
             * Format: date-time
             * @description When the session expires.
             */
            expiresAt?: null | string;
            /** @description The card provider the session is for. */
            provider?: components["schemas"]["CardProvider"];
            /** @description True when the provider enrolled the card without a hosted component (the Fake provider in Sandbox). The card is already linked and its recent history imported: skip the embedded component and refresh the card list. */
            enrollmentCompleted?: boolean;
            /**
             * Format: uuid
             * @description The linked card, when enrollmentCompleted is true.
             */
            cardConnectionId?: null | string;
        };
        /** @description The number Embedded Signup set up, to register for sending. */
        ConnectWhatsAppRequest: {
            /** @description waba_id from the WA_EMBEDDED_SIGNUP FINISH message. Required, except where the connection state has a sandboxNumber. */
            wabaId?: null | string;
            /** @description The number verified in Embedded Signup, in international format, e.g. +44 7700 900123. Signup does not return it, so ask for it before starting. Required, except where the connection state has a sandboxNumber. */
            phoneNumber?: null | string;
            /** @description The name customers see on WhatsApp, as entered in Embedded Signup. It must follow Meta's display name guidelines (Meta reviews it). Defaults to the business's name in Dolfin. */
            displayName?: null | string;
        };
        ConversationDetailResponse: {
            /** Format: uuid */
            id?: string;
            agentType?: components["schemas"]["AgentType"];
            title?: null | string;
            /** Format: date-time */
            createdAt?: string;
            /** Format: date-time */
            updatedAt?: string;
        };
        ConversationMessageResponse: {
            /** Format: uuid */
            id?: string;
            role?: components["schemas"]["AgentMessageRole"];
            content?: null | string;
            toolCallsJson?: null | string;
            toolResultsJson?: null | string;
            actions?: null | components["schemas"]["ToolAction"][];
            /** @description Records the reply mentions; the chat links each exact mention of a label. Null when there are none. */
            refs?: null | components["schemas"]["AgentRef"][];
            /** @description One-click actions offered under the reply. Run one with POST /v1/agent/actions. Null when there are none. */
            suggestions?: null | components["schemas"]["AgentSuggestion"][];
            truncated?: boolean;
            /** Format: date-time */
            createdAt?: string;
        };
        ConversationSummaryResponse: {
            /** Format: uuid */
            id?: string;
            agentType?: components["schemas"]["AgentType"];
            title?: null | string;
            lastMessagePreview?: null | string;
            /** Format: int32 */
            messageCount?: number | string;
            /** Format: date-time */
            createdAt?: string;
            /** Format: date-time */
            updatedAt?: string;
        };
        CountryBankProfile: {
            /** @description ISO 3166-1 alpha-2 country code (e.g. GB, US, DE) */
            countryCode: string;
            countryName: string;
            /** @description ISO 4217 currency codes (e.g. GBP, USD, EUR) */
            defaultCurrencies: string[];
            accountHolderName: components["schemas"]["BankFieldSpec"];
            accountNumber?: null | components["schemas"]["BankFieldSpec"];
            sortCode?: null | components["schemas"]["BankFieldSpec"];
            routingNumber?: null | components["schemas"]["BankFieldSpec"];
            iban?: null | components["schemas"]["BankFieldSpec"];
            bicSwift?: null | components["schemas"]["BankFieldSpec"];
            rails: components["schemas"]["PaymentRailSupport"];
        };
        CountryBankProfileSummary: {
            /** @description ISO 3166-1 alpha-2 country code (e.g. GB, US, DE) */
            countryCode: string;
            countryName: string;
            /** @description ISO 4217 currency codes (e.g. GBP, USD, EUR) */
            defaultCurrencies: string[];
        };
        CountrySignIns: {
            country: null | string;
            /** Format: int32 */
            signIns: number | string;
        };
        CountryTaxRateAdminResponse: {
            /** Format: uuid */
            id?: string;
            countryCode: string;
            code: string;
            name: string;
            /** Format: double */
            rate?: number | string;
            /** Format: date-time */
            effectiveFrom?: string;
            /** Format: date-time */
            effectiveTo?: null | string;
        };
        CreateAccountingConnectionSessionRequest: {
            redirectUri?: null | string;
        };
        CreateApiKeyRequest: {
            name?: null | string;
            /** Format: date-time */
            expiresAt?: null | string;
        };
        CreateApiKeyResponse: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            clientId: string;
            rawKey: string;
            keyPrefix: string;
            name?: null | string;
            /** Format: date-time */
            createdAt?: string;
            /** Format: date-time */
            expiresAt?: null | string;
        };
        CreateAuthCodeRequest: {
            /** Format: uuid */
            userId?: string;
        };
        CreateAuthCodeResponse: {
            code: string;
            /** Format: date-time */
            expiresAt?: string;
        };
        /** @description A new categorisation rule. */
        CreateBookRuleRequest: {
            /** @description Name shown on the lines the rule categorises, up to 128 characters. */
            name: string;
            /** @description The bank line text to read: Description or Counterparty. */
            field: components["schemas"]["BookRuleField"];
            /** @description Contains (anywhere in the text) or Equals (the whole text, ignoring case, digits and punctuation). */
            operator: components["schemas"]["BookRuleOperator"];
            /** @description The text to look for, e.g. TESCO. */
            value: string;
            /**
             * Format: uuid
             * @description Id of the ledger account matching lines are filed under.
             */
            ledgerAccountId: string;
            /**
             * Format: uuid
             * @description Id of the accounting tax rate the amounts include; leave out for no VAT.
             */
            accountingTaxRateId?: null | string;
            direction?: null | components["schemas"]["BankLineDirection"];
            /**
             * Format: double
             * @description Only lines of at least this unsigned amount.
             */
            minAmount?: null | number | string;
            /**
             * Format: double
             * @description Only lines of at most this unsigned amount.
             */
            maxAmount?: null | number | string;
            /**
             * Format: int32
             * @description Order the rules are tried in, lowest first. Defaults to after every existing rule.
             */
            priority?: null | number | string;
            /**
             * @description Whether the rule runs. Defaults to true.
             * @default true
             */
            isEnabled: boolean;
        };
        /** @description Which card provider to link a card through. */
        CreateCardEnrollmentSessionRequest: {
            provider?: null | components["schemas"]["CardProvider"];
        };
        CreateClientInviteRequest: {
            email: string;
            role: components["schemas"]["ClientRole"];
        };
        CreateClientRequest: {
            name: string;
            type?: null | components["schemas"]["ClientType"];
            /** Format: double */
            paymentRevenueSharePercent?: null | number | string;
            /** Format: double */
            dolfinRevenueSharePercent?: null | number | string;
        };
        CreateCompanyRequest: {
            /** @description Display name of the parent group, e.g. "Ozone Coffee". */
            name: string;
            /** @description Head office address line 1. Supplying the head office address lets Dolfin recognise group-level bills delivered there and hold them for manual routing instead of assigning them to whichever site shares the address. */
            addressLine1?: null | string;
            addressLine2?: null | string;
            city?: null | string;
            postalCode?: null | string;
            /** @description ISO 3166-1 alpha-2 country code (e.g. GB, US, DE) */
            country?: null | string;
            /** @description Contact address for notifications about bills awaiting routing. */
            contactEmail?: null | string;
        };
        CreateCreditNoteRequest: {
            /**
             * Format: double
             * @description Amount to credit, in the invoice's currency. Must be greater than zero and must not exceed the invoice's outstanding balance.
             */
            amount?: number | string;
            /** @description Optional human-readable reason for the credit (e.g. "returned goods", "customer dispute", "goodwill"). */
            reason?: null | string;
            /**
             * Format: uuid
             * @description Optional id of a specific line item on the invoice this credit relates to. When supplied, that line's frozen tax rate is inherited (unless taxRateId overrides it) and recorded as provenance.
             */
            invoiceLineItemId?: null | string;
            /**
             * Format: uuid
             * @description Optional tax rate to apply to the credit (an id from GET /tax-rates — an org rate or a country default). Overrides the line item's rate when both are given. When omitted and no line item is supplied, the credit takes the invoice's rate when every line shares one; an invoice with lines at different rates requires it (or invoiceLineItemId); an invoice whose lines carry no rate gives a zero-rated credit.
             */
            taxRateId?: null | string;
        };
        CreateCustomerRequest: {
            name: string;
            email?: null | string;
            phone?: null | string;
            taxNumber?: null | string;
            addressLine1?: null | string;
            addressLine2?: null | string;
            city?: null | string;
            state?: null | string;
            postalCode?: null | string;
            /** @description ISO 3166-1 alpha-2 country code (e.g. GB, US, DE) */
            country?: null | string;
            electronicAddressScheme?: null | components["schemas"]["EInvoiceAddressScheme"];
            /** @description Where electronic invoices are delivered: a Peppol participant id such as 0208:0455341259, an Italian codice destinatario such as M5UXCR5, or a PEC address. This is a routing address, not a tax identifier. */
            electronicAddress?: null | string;
            /** @description The customer's WhatsApp number in international format, e.g. +447700900123. Changing it withdraws any WhatsApp consent recorded for the previous number. */
            whatsAppPhone?: null | string;
            preferredChannel?: null | components["schemas"]["CustomerChannel"];
        };
        /** @description A single received line on a delivery note. */
        CreateDeliveryNoteLineRequest: {
            /** @description Caller's own reference for this line (a reverse pointer to the platform's record). Optional and free-form — it is stored and echoed back verbatim on every response, and is never used to match the line against bills or to identify the line on update. */
            externalRef?: null | string;
            /** @description Line description. */
            description: string;
            /** @description Product SKU, used as the exact-match key against bill lines. Optional. */
            sku?: null | string;
            /**
             * Format: double
             * @description Quantity received on this line. Zero is allowed and meaningful: it records an item that was expected but did not arrive, so the shortfall can be matched and reported against the bill instead of the line being left off the note. Negative is rejected.
             */
            quantityReceived?: number | string;
            /** @description Unit of measure (e.g. each, kg). Optional. */
            unit?: null | string;
            /**
             * Format: int32
             * @description Display order of the line within the note. Stored and returned exactly as supplied — it is never renumbered. Lines are returned sorted by this value, with ties broken by line id. Values need not be unique or contiguous, but duplicates make the relative order of the tied lines arbitrary.
             */
            sortOrder?: number | string;
        };
        /** @description Creates a delivery note with its received lines. */
        CreateDeliveryNoteRequest: {
            /**
             * Format: uuid
             * @description Supplier the goods were received from. Optional — may be assigned later.
             */
            supplierId?: null | string;
            /** @description Caller's own reference for the note (a reverse pointer to the platform's record). Optional. */
            externalRef?: null | string;
            /** @description Human delivery-note number. Required. */
            dnNumber?: null | string;
            /**
             * Format: uuid
             * @description The purchase order this note was despatched against. Optional, and worth supplying: once a line on this note is matched to a bill line, the engine looks for the same item on this order and matches that too, in preference to scoring the order against the bill. It says which order to look at, not which line — the item must appear on the order (same product code, else the same description) or no purchase-order match is made from it. The authoritative binding is always line-level, through allocations.
             */
            purchaseOrderId?: null | string;
            /**
             * Format: date-time
             * @description When the goods were received. Optional.
             */
            receivedAt?: null | string;
            /** @description The received lines. At least one is required. */
            lines?: components["schemas"]["CreateDeliveryNoteLineRequest"][];
        };
        CreateDemoAdminRequest: {
            /** @description Prospect's name, used in the invitation email. */
            prospectName?: string;
            /** @description Prospect's email: they sign in as Admin of the demo organisation, and the invitation is sent here. */
            prospectEmail?: string;
            /** @description Name of the made-up business the demo organisation is created as. */
            companyName?: string;
            preset?: null | components["schemas"]["DemoPreset"];
            /** @description Email the prospect a "Try Dolfin Books" invitation with the link. Defaults to true. */
            sendEmail?: boolean;
            /**
             * Format: uuid
             * @description The Demo client to create it under. Defaults to the shared "Dolfin Demo" client.
             */
            clientId?: null | string;
        };
        /** @description Requests a signed URL to upload a policy document to. */
        CreateExpensePolicyDocumentUploadUrlRequest: {
            /** @description Original file name including extension: .pdf, .txt or .docx. */
            fileName?: string;
            /** @description MIME type. Optional when the extension is unambiguous. */
            contentType?: null | string;
        };
        CreateInvoiceLineItemRequest: {
            /**
             * Format: uuid
             * @description When patching an invoice, the id of an existing line item to update. Omit to add a new line.
             */
            id?: null | string;
            /**
             * Format: uuid
             * @description Id of the product on this line. Resolve a product name to its id with a product search first; never pass a name.
             */
            productId?: string;
            /**
             * Format: double
             * @description Quantity of the product. Must be greater than 0.
             */
            quantity?: number | string;
            /**
             * Format: uuid
             * @description Tax rate for this line: an organisation-owned rate or a country default, both listed by GET /tax-rates. Country defaults are read-only but can be picked by id.
             */
            taxRateId?: null | string;
            /**
             * Format: double
             * @description Optional fixed unit price for this line. When omitted the product's current unit price is used.
             */
            unitPriceOverride?: null | number | string;
            /** @description How DiscountValue is interpreted for this line. Omit (or send None) for no line discount. */
            discountType?: components["schemas"]["DiscountType"];
            /**
             * Format: double
             * @description The line discount: a percentage (0-100) or a cash amount, per DiscountType. At most 2 decimal places, and a cash amount at most the currency's own (whole yen for JPY) — a finer value is rejected rather than rounded. It applies to this line's quantity x unit price, and reduces the amount tax is charged on. May equal that amount but not exceed it. Must be omitted when DiscountType is None.
             */
            discountValue?: null | number | string;
        };
        CreateInvoiceRequest: {
            /**
             * Format: uuid
             * @description Id of the customer being invoiced. Resolve a customer's name or email to its id with a customer search first; never pass a name.
             */
            customerId: string;
            /** @description ISO 4217 currency code (e.g. GBP, USD, EUR) */
            currency: string;
            memo?: null | string;
            /** @description CC recipients for the invoice email and its reminders. Omit to use the organisation's default CC list; pass an empty list for no CC. Each must be a valid email. */
            ccEmails?: null | string[];
            /**
             * Format: int32
             * @description Payment terms in days (0-365) — the number of days from issue to due date. 0 means due on receipt. Omit to use the organisation's default payment terms, which is snapshotted onto the invoice at creation.
             */
            paymentTermsDays?: null | number | string;
            /** @description How DiscountValue is interpreted for the invoice-level discount. Omit (or send None) for no invoice-level discount. */
            discountType?: components["schemas"]["DiscountType"];
            /**
             * Format: double
             * @description The invoice-level discount: a percentage (0-100) or a cash amount, per DiscountType. At most 2 decimal places, and a cash amount at most the currency's own (whole yen for JPY) — a finer value is rejected rather than rounded. It applies to the invoice total after any per-line discounts, and is apportioned across the lines before tax, so tax is charged on the discounted amount. May equal the amount it applies to (giving a zero-total invoice) but not exceed it. Must be omitted when DiscountType is None.
             */
            discountValue?: null | number | string;
            earlyPaymentDiscount?: null | components["schemas"]["EarlyPaymentDiscountRequest"];
            /** @description The invoice lines. At least one is required. Each line's description and unit price come from its product unless overridden. */
            lineItems: components["schemas"]["CreateInvoiceLineItemRequest"][];
        };
        /** @description A new account for the organisation's chart of accounts. */
        CreateLedgerAccountRequest: {
            /** @description The account's name as it will appear in the accounting platform, e.g. "Staff welfare". Required, at most 100 characters, and unique among the organisation's active accounts. */
            name: string;
            /** @description The kind of account. Expense (the default) for everyday running costs; OtherExpense for costs outside normal operations; CostOfSales for costs directly tied to what the organisation sells; CurrentAsset for a current asset that payments can be recorded into, such as a Stripe clearing account (in Xero it is created with "Enable payments to this account" on). */
            type?: components["schemas"]["NewLedgerAccountType"];
            /** @description The account number, e.g. "429". Required by platforms that key accounts on a code (Xero); optional otherwise. At most 20 characters. */
            code?: null | string;
        };
        CreateMagicLinkRequest: {
            /** Format: uuid */
            organisationId?: string;
            label?: null | string;
            /** Format: int32 */
            expiresInDays?: null | number | string;
        };
        CreateMagicLinkResponse: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            organisationId?: null | string;
            token: string;
            label?: null | string;
            /** Format: date-time */
            createdAt?: string;
            /** Format: date-time */
            expiresAt?: string;
        };
        CreateOrganisationRequest: {
            /** @description Stable caller reference, unique within the authenticated client. Repeated creates with this reference return the original organisation. */
            externalReference?: null | string;
            name: string;
            /** Format: uuid */
            industryId: string;
            /** @description ISO 3166-1 alpha-2 country code (e.g. GB, US, DE) */
            country: string;
            contactEmail: string;
            /** @description ISO 4217 currency code (e.g. GBP, USD, EUR). Must be one of the currencies returned by GET /currencies/available. */
            defaultCurrency?: null | string;
            /**
             * Format: uuid
             * @description Optional parent company to create this organisation under, for a site belonging to a multi-site business. Must belong to the same client. Leave unset for a standalone organisation.
             */
            companyId?: null | string;
        };
        CreateOrganisationUserRequest: {
            email: string;
            name?: null | string;
            role?: null | components["schemas"]["OrganisationRole"];
        };
        CreatePaymentAccountLinkRequest: {
            /** @description Absolute http(s) URL Stripe redirects to once onboarding completes. */
            returnUrl: string;
            /** @description Absolute http(s) URL Stripe redirects to if the link expires or needs to be refreshed. */
            refreshUrl: string;
        };
        CreateProductRequest: {
            /** @description Product or service name, unique within the organisation. Up to 256 characters. */
            name: string;
            /** @description Optional longer description of the product or service. */
            description?: null | string;
            /**
             * Format: double
             * @description Price per unit, in the product's currency. Zero is valid — use it for comped items, free shipping lines and £0 trial SKUs. A negative price is rejected with Product.InvalidPrice, as is omitting the field or sending null.
             */
            unitPrice: number | string;
            /** @description ISO 4217 currency code (e.g. GBP, USD, EUR) */
            currency: string;
            /** @description Whether this is a physical product or a service. Defaults to Product. */
            type?: components["schemas"]["ProductType"];
            /**
             * Format: uuid
             * @description Id of the accounting platform income ledger account (from GET /accounting/ledger-accounts) this product's invoice lines post their revenue to when invoices are pushed to the accounting platform. Null uses the organisation's default income account.
             */
            incomeLedgerAccountId?: null | string;
        };
        /** @description A single line to order on a purchase order. */
        CreatePurchaseOrderLineRequest: {
            /** @description Caller's own reference for this line (a reverse pointer to the platform's record). Optional and free-form — it is stored and echoed back verbatim on every response, and is never used to match the line against bills or to identify the line on update. */
            externalRef?: null | string;
            /** @description Line description. */
            description: string;
            /** @description Product SKU, used as the exact-match key against bill lines. Optional. */
            sku?: null | string;
            /**
             * Format: double
             * @description Quantity to order.
             */
            quantityOrdered?: number | string;
            /** @description Unit of measure (e.g. each, kg). Optional. */
            unit?: null | string;
            /**
             * Format: double
             * @description Ordered unit price (ex-tax).
             */
            unitPrice?: number | string;
            /**
             * Format: double
             * @description Tax rate to apply, as a percentage.
             */
            taxRate?: number | string;
            /**
             * Format: double
             * @description Tax amount for the line.
             */
            taxAmount?: number | string;
            /**
             * Format: double
             * @description Net (ex-tax) line total.
             */
            subTotal?: number | string;
            /**
             * Format: int32
             * @description Display order of the line within the order. Stored and returned exactly as supplied — it is never renumbered. Lines are returned sorted by this value, with ties broken by line id. Values need not be unique or contiguous, but duplicates make the relative order of the tied lines arbitrary.
             */
            sortOrder?: number | string;
        };
        /** @description Creates a purchase order with its lines. */
        CreatePurchaseOrderRequest: {
            /**
             * Format: uuid
             * @description Supplier the order is raised against. Optional — may be assigned later.
             */
            supplierId?: null | string;
            /** @description Caller's own reference for the order (a reverse pointer to the platform's record). Optional. */
            externalRef?: null | string;
            /** @description Human purchase-order number printed on the order. Required. */
            poNumber?: null | string;
            /** @description ISO 4217 currency code. Defaults to GBP. */
            currency?: string;
            /**
             * Format: date-time
             * @description Date the order was raised. Optional.
             */
            orderDate?: null | string;
            /**
             * Format: date-time
             * @description Expected delivery date. Optional.
             */
            expectedDeliveryDate?: null | string;
            /** @description The ordered lines. At least one is required. */
            lines?: components["schemas"]["CreatePurchaseOrderLineRequest"][];
        };
        CreateRecurringInvoiceScheduleRequest: {
            /**
             * Format: uuid
             * @description Id of the customer being billed. Resolve a customer's name or email to its id with a customer search first. The customer needs an email address if AutoSend is true.
             */
            customerId: string;
            /** @description ISO 4217 currency code (e.g. GBP, USD, EUR) */
            currency: string;
            memo?: null | string;
            /**
             * Format: int32
             * @description Payment terms in days (0-365) applied to every generated invoice — the due date is this many days after each occurrence's issue date. 0 means due on receipt. Omit to use the organisation's default payment terms.
             */
            paymentTermsDays?: null | number | string;
            /**
             * Format: date-time
             * @description Date of the first invoice. Subsequent occurrences fall on this date plus N intervals (month-end clamped).
             */
            startDate?: string;
            /** @description How often an invoice is generated: Weekly, Monthly, Quarterly, or Annually. */
            cadence?: components["schemas"]["RecurrenceCadence"];
            /**
             * Format: int32
             * @description Total number of invoices to generate. Omit to run until paused or cancelled.
             */
            totalOccurrences?: null | number | string;
            /** @description True: each occurrence is generated and emailed in one step. False: occurrences land as Draft for review. */
            autoSend?: boolean;
            /** @description How DiscountValue is interpreted for the invoice-level discount applied to every occurrence. Omit (or send None) for no invoice-level discount. */
            discountType?: components["schemas"]["DiscountType"];
            /**
             * Format: double
             * @description The invoice-level discount applied to every generated invoice: a percentage (0-100) or a cash amount, per DiscountType. At most 2 decimal places. Resolved afresh at each occurrence, so a percentage keeps tracking the contract value as product prices move — while a fixed amount that comes to exceed a repriced occurrence causes that one occurrence to be skipped.
             */
            discountValue?: null | number | string;
            earlyPaymentDiscount?: null | components["schemas"]["RecurringEarlyPaymentDiscount"];
            /** @description The line-item template billed on every occurrence. At least one is required. */
            lineItems: components["schemas"]["RecurringInvoiceLineItemRequest"][];
        };
        CreateSpendCategoryRequest: {
            key: string;
            displayName: string;
            defaultSpendClass: null | components["schemas"]["SpendClass"];
            glAccountCode: null | string;
        };
        CreateSupplierCreditNoteRequest: {
            /**
             * Format: double
             * @description Gross (tax-inclusive) credit amount. Must be greater than zero.
             */
            amount?: number | string;
            /** @description ISO 4217 currency code (e.g. GBP, USD, EUR). */
            currency: string;
            /**
             * Format: uuid
             * @description Optional tax rate to apply (an org rate or country default). Omit for a zero-rated credit; the net/tax split is computed from it.
             */
            taxRateId?: null | string;
            /**
             * Format: uuid
             * @description Optional id of the bill this credit relates to — header-level provenance only.
             */
            originalBillId?: null | string;
            /** @description Optional human-readable reason for the credit. */
            reason?: null | string;
        };
        CreateSupplierRequest: {
            name: string;
            email?: null | string;
            phone?: null | string;
            website?: null | string;
            taxNumber?: null | string;
            registrationNumber?: null | string;
            address?: null | components["schemas"]["Address"];
            bankDetails?: null | components["schemas"]["BankDetails"];
            /** @description Default payment terms, e.g. 'Net 30'. */
            paymentTermsDefault?: null | string;
            /**
             * Format: uuid
             * @description Id of an active ledger account (from GET /accounting/ledger-accounts) this supplier's bills post to in the accounting platform when a line names none of its own.
             */
            defaultLedgerAccountId?: null | string;
        };
        CreateTaxRateRequest: {
            /** @description Short code, e.g. "VAT20". Must be unique within the organisation. */
            code: string;
            /** @description Human-readable name, e.g. "VAT 20%". */
            name: string;
            /**
             * Format: double
             * @description Percentage from 0 to 100, e.g. 20 for 20%.
             */
            rate?: number | string;
        };
        CreateUserRequest: {
            email: string;
            name?: null | string;
            role?: null | components["schemas"]["OrganisationRole"];
        };
        CreateUserResponse: {
            /** Format: uuid */
            userId?: string;
            email: string;
            name?: null | string;
            /** Format: uuid */
            organisationId?: string;
            role?: components["schemas"]["OrganisationRole"];
        };
        CreateWebhookSubscriptionRequest: {
            url: string;
            eventTypes: ("bill.created" | "bill.updated" | "bill.ocr_failed" | "bill.pending_review" | "bill.needs_approval" | "bill.approved" | "bill.rejected" | "bill.scheduled" | "bill.paid" | "bill.voided" | "bill.payment_failed" | "bill.payment_in_progress" | "invoice.created" | "invoice.updated" | "invoice.sent" | "invoice.partially_paid" | "invoice.paid" | "invoice.voided" | "invoice.credited" | "credit_note.issued" | "match_group.created" | "match_group.variance" | "match_group.resolved" | "supplier_credit_note.issued" | "supplier_credit_note.blocked" | "supplier_credit.applied" | "supplier_credit.reversed" | "bill.credited" | "bill.duplicate_detected" | "recurring_invoice.generation_failed" | "e_invoice.ingested" | "e_invoice.rejected" | "e_invoicing_registration.action_required" | "e_invoicing_registration.registered" | "e_invoicing_registration.failed" | "e_invoicing_registration.unregistered" | "outbound_e_invoice.delivered" | "outbound_e_invoice.made_available" | "outbound_e_invoice.failed" | "outbound_e_invoice.abandoned" | "company_bill.awaiting_organisation" | "customer.created" | "customer.updated" | "customer.deleted" | "supplier.created" | "supplier.updated" | "product.created" | "product.updated" | "product.deleted" | "tax_rate.created" | "tax_rate.updated" | "tax_rate.deleted" | "approval_policy.created" | "approval_policy.updated" | "approval_policy.deleted" | "expense.posted" | "expense.flagged" | "expense.pending_review" | "expense.matched" | "expense.post_failed" | "card_transaction.created" | "card_connection.broken" | "invoice.issued" | "expense_approval_policy.created" | "expense_approval_policy.updated" | "expense_approval_policy.deleted" | "expense_policy_document.ready_for_review" | "expense_policy_document.failed" | "accounting_sync.succeeded" | "accounting_sync.failed" | "whatsapp_connection.updated" | "bank_connection.connected" | "bank_connection.failed" | "bank_connection.expired" | "bank_connection.revoked" | "bank_connection.reconfirmation_due" | "bill.partially_paid" | "bill.payment_recorded" | "bill.payment_abandoned")[];
        };
        /**
         * @description Why the credit note was raised, when the system raised it. None for a credit note created by hand (its free-text reason says why).
         * @enum {unknown}
         */
        CreditNoteReason: "None" | "EarlyPaymentDiscount";
        CreditNoteResponse: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            organisationId?: string;
            /** Format: uuid */
            invoiceId?: string;
            documentNumber?: null | string;
            /** Format: double */
            amount?: number | string;
            /**
             * Format: double
             * @description Net (ex-tax) portion of the credit. NetAmount + TaxAmount == Amount.
             */
            netAmount?: number | string;
            /**
             * Format: double
             * @description VAT/tax portion of the credit.
             */
            taxAmount?: number | string;
            accountingSync?: null | components["schemas"]["AccountingDocumentSyncResponse"];
            /**
             * Format: uuid
             * @description Soft reference to the tax rate applied (an org rate or country default). Null on a zero-rated credit.
             */
            taxRateId?: null | string;
            taxRateSnapshot?: null | components["schemas"]["TaxRateSnapshotResponse"];
            /**
             * Format: uuid
             * @description Optional id of the specific invoice line item this credit relates to.
             */
            invoiceLineItemId?: null | string;
            /** @description ISO 4217 currency code (e.g. GBP, USD, EUR) — always equal to the invoice currency */
            currency: string;
            reason?: null | string;
            /** @description Why the credit note was raised, when the system raised it: EarlyPaymentDiscount for the credit issued automatically when a customer pays an invoice at its early payment discount. None for a credit note created by hand. */
            reasonCode?: components["schemas"]["CreditNoteReason"];
            status?: components["schemas"]["CreditNoteState"];
            /** Format: date-time */
            issuedAt?: null | string;
            /** Format: date-time */
            createdAt?: string;
            /** Format: uuid */
            createdBy?: null | string;
            /** Format: date-time */
            updatedAt?: string;
            /** Format: uuid */
            updatedBy?: null | string;
        };
        /** @enum {unknown} */
        CreditNoteState: "Draft" | "Issuing" | "Issued";
        CurrencyAging: {
            currency: string;
            buckets: components["schemas"]["AgingBuckets"];
        };
        CurrencyResponse: {
            /** Format: uuid */
            id?: string;
            /** @description ISO 4217 currency code (e.g. GBP, USD, EUR) */
            code: string;
            name: string;
            symbol: string;
            /** Format: int32 */
            decimalPlaces?: number | string;
        };
        CurrencyTotal: {
            currency: string;
            /** Format: double */
            amount: number | string;
            /**
             * Format: int32
             * @description Invoices for receivables, bills for payables.
             */
            count: number | string;
        };
        /**
         * @description How a customer prefers to receive invoices and reminders.
         * @enum {unknown}
         */
        CustomerChannel: "Email" | "WhatsApp" | "Both";
        CustomerReceived: {
            /** Format: uuid */
            customerId?: string;
            customerName: string;
            /** Format: double */
            received?: number | string;
            /** Format: int32 */
            paymentCount?: number | string;
        };
        CustomerResponse: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            organisationId?: string;
            name: string;
            email?: null | string;
            phone?: null | string;
            taxNumber?: null | string;
            addressLine1?: null | string;
            addressLine2?: null | string;
            city?: null | string;
            state?: null | string;
            postalCode?: null | string;
            /** @description ISO 3166-1 alpha-2 country code (e.g. GB, US, DE) */
            country?: null | string;
            electronicAddressScheme?: null | components["schemas"]["EInvoiceAddressScheme"];
            /** @description Where electronic invoices are delivered. A routing address, not a tax identifier. */
            electronicAddress?: null | string;
            /** @description Whether an electronic invoice can be routed to this customer, which is what an e-invoicing control should be enabled on. True once both the scheme and the address are set. It answers whether an address is on file, not whether a send will succeed: a customer outside Italy can be invoiced over Italy's network without one, and an address that exists can still be refused by the network. */
            canReceiveEInvoices?: boolean;
            /** @description The customer's WhatsApp number in international form with the plus (e.g. +447700900123), as an update accepts it. */
            whatsAppPhone?: null | string;
            /** @description How the customer receives invoices and reminders. */
            preferredChannel?: components["schemas"]["CustomerChannel"];
            /**
             * Format: date-time
             * @description When the customer's consent to WhatsApp messages was recorded. Null when there is none.
             */
            whatsAppConsentAt?: null | string;
            whatsAppConsentSource?: null | components["schemas"]["WhatsAppConsentSource"];
            /**
             * Format: date-time
             * @description When the customer opted out of WhatsApp messages (by replying STOP, or an organisation user withdrawing consent). Null when they have not.
             */
            whatsAppOptedOutAt?: null | string;
            /** @description Whether consent is recorded and has not been withdrawn since. */
            hasWhatsAppConsent?: boolean;
            /** Format: date-time */
            createdAt?: string;
            /** Format: uuid */
            createdBy?: null | string;
            /** Format: date-time */
            updatedAt?: string;
            /** Format: uuid */
            updatedBy?: null | string;
        };
        CustomerSearchHit: {
            /** Format: uuid */
            id?: string;
            name: string;
            email?: null | string;
            /** Format: double */
            score?: number | string;
        };
        /** @description A single received line on a delivery note. */
        DeliveryNoteLineResponse: {
            /**
             * Format: uuid
             * @description Unique identifier of the line, and the only key that identifies it on update. Send it back in the update request to edit this line in place rather than replacing it.
             */
            id?: string;
            /** @description Caller's own reference for this line, echoed back verbatim. Null when none was supplied. */
            externalRef?: null | string;
            /** @description Line description. */
            description: string;
            /** @description Product SKU, used as the exact-match key against bill lines. Optional. */
            sku?: null | string;
            /**
             * Format: double
             * @description Quantity received on this line.
             */
            quantityReceived?: number | string;
            /** @description Unit of measure (e.g. each, kg), if recorded. */
            unit?: null | string;
            unitOfMeasure?: null | components["schemas"]["UnitOfMeasure"];
            /**
             * Format: int32
             * @description Display order of the line within the note, exactly as supplied — never renumbered. Lines are returned sorted by this value, with ties broken by line id.
             */
            sortOrder?: number | string;
            /**
             * Format: double
             * @description Total quantity matched against this line across all bills. Null on list responses (not computed there); populated on the detail (get-by-id) response.
             */
            matchedQuantity?: null | number | string;
            /** @description True once the matched quantity covers the whole received quantity. Null when MatchedQuantity is not computed (list responses) — null means 'unknown', not 'unmatched'. */
            fullyMatched?: null | boolean;
        };
        /** @description A delivery note and its received lines. */
        DeliveryNoteResponse: {
            /**
             * Format: uuid
             * @description Unique identifier of the delivery note.
             */
            id?: string;
            /**
             * Format: uuid
             * @description The organisation that owns the delivery note.
             */
            organisationId?: string;
            /**
             * Format: uuid
             * @description The supplier the goods were received from, if assigned.
             */
            supplierId?: null | string;
            /** @description Caller's own reference for the note (a reverse pointer to the platform's record), if any. */
            externalRef?: null | string;
            /** @description Human delivery-note number. Required and unique within the organisation. */
            dnNumber: string;
            /**
             * Format: uuid
             * @description The purchase order this note was despatched against, if one was provided. It drives matching: once a line on this note is matched to a bill line, the engine looks for the same item on this order and matches that too, in preference to scoring the order against the bill. It says which order to look at, not which line — the item must appear on the order (same product code, else the same description) or no purchase-order match is made from it. The authoritative binding is always line-level, through allocations.
             */
            purchaseOrderId?: null | string;
            /**
             * Format: date-time
             * @description When the goods were received, if recorded.
             */
            receivedAt?: null | string;
            /** @description Lifecycle status: Draft, Open, PartiallyMatched, FullyMatched (all derived from matching), or the manual terminal states Closed / Cancelled. */
            status?: components["schemas"]["DeliveryNoteStatus"];
            /** @description The received lines, in display order. */
            lines?: components["schemas"]["DeliveryNoteLineResponse"][];
            /**
             * Format: date-time
             * @description When the delivery note was created.
             */
            createdAt?: string;
            /**
             * Format: date-time
             * @description When the delivery note was last updated.
             */
            updatedAt?: string;
        };
        /**
         * @description Lifecycle status of a delivery note. Draft, Open, PartiallyMatched and FullyMatched are derived from matching (and reverse as allocations change); Closed and Cancelled are manual terminal states a human sets.
         * @enum {unknown}
         */
        DeliveryNoteStatus: "Draft" | "Open" | "PartiallyMatched" | "FullyMatched" | "Closed" | "Cancelled" | null;
        DemoAdminResponse: {
            /** Format: uuid */
            organisationId?: string;
            companyName: string;
            prospectName?: null | string;
            prospectEmail: string;
            preset?: null | components["schemas"]["DemoPreset"];
            status?: null | components["schemas"]["DemoStatus"];
            step?: null | components["schemas"]["DemoStep"];
            error?: null | string;
            /** Format: date-time */
            createdAt?: string;
            /** Format: date-time */
            expiresAt?: null | string;
            /**
             * Format: date-time
             * @description When a sign-in link for this demo was last used. Null if the prospect has never signed in.
             */
            lastSignInAt?: null | string;
            /** @description Documents the prospect has created against the demo's caps. Seeded documents don't count. */
            usage: components["schemas"]["DemoUsageResponse"];
        };
        DemoLinkAdminResponse: {
            /** Format: uuid */
            organisationId?: string;
            /** @description Single-use sign-in link to the sandbox's "Try Dolfin Books" page, valid until the demo expires, or for 30 days when it never does. */
            magicLinkUrl: string;
            /** Format: date-time */
            expiresAt?: string;
            /** @description Whether the invitation email was handed to the email provider. */
            emailSent?: boolean;
        };
        /**
         * @description The made-up business a demo organisation is seeded as.
         * @enum {unknown}
         */
        DemoPreset: "Cafe" | "Agency" | "Ecommerce" | "Wholesale" | null;
        /**
         * @description Where a demo organisation's seeding stands.
         * @enum {unknown}
         */
        DemoStatus: "NotStarted" | "Seeding" | "Ready" | "Failed" | null;
        DemoStatusResponse: {
            /** @description The made-up business's name. */
            companyName: string;
            preset?: null | components["schemas"]["DemoPreset"];
            /**
             * Format: date
             * @description The books' start date: the actual book's once one exists, else the first of the month twelve months back, which seeding will use.
             */
            startDate?: string;
            status?: components["schemas"]["DemoStatus"];
            step?: null | components["schemas"]["DemoStep"];
            /** @description Every step in the order they run, for the progress view. */
            steps: components["schemas"]["DemoStepResponse"][];
            /** @description Why seeding failed. Set only when status is Failed. */
            error?: null | string;
            /** Format: date-time */
            expiresAt?: null | string;
        };
        /**
         * @description The seeding step a demo organisation is on, in order.
         * @enum {unknown}
         */
        DemoStep: "Documents" | "Accounting" | "Bank" | "Stripe" | "Books" | null;
        DemoStepResponse: {
            key?: components["schemas"]["DemoStep"];
            label: string;
            state?: components["schemas"]["DemoStepState"];
        };
        /**
         * @description Where one seeding step stands.
         * @enum {unknown}
         */
        DemoStepState: "Pending" | "Active" | "Done" | "Failed";
        /** @description Documents the prospect has created since the demo was last seeded, each kind capped at Limit. */
        DemoUsageResponse: {
            /** Format: int32 */
            bills?: number | string;
            /** Format: int32 */
            invoices?: number | string;
            /** Format: int32 */
            receipts?: number | string;
            /**
             * Format: int32
             * @description The cap on each kind; the next create past it is refused with Demo.LimitReached.
             */
            limit?: number | string;
            /**
             * Format: int32
             * @description Lines added to the demo's bank since it was seeded.
             */
            bankTransactions?: number | string;
            /**
             * Format: int32
             * @description The cap on added bank lines; the next one past it is refused with Demo.LimitReached.
             */
            bankTransactionLimit?: number | string;
        };
        /** @enum {unknown} */
        DeviceBrowser: "Chrome" | "Edge" | "Safari" | "Firefox" | "Other";
        /** @enum {unknown} */
        DeviceOs: "Windows" | "MacOs" | "Ios" | "Android" | "Linux" | "ChromeOs" | "Other";
        /** @enum {unknown} */
        DeviceType: "Desktop" | "Mobile" | "Tablet" | "Bot" | "Unknown";
        DeviceTypeSignIns: {
            deviceType: components["schemas"]["DeviceType"];
            /** Format: int32 */
            signIns: number | string;
        };
        DiscardCompanyBillRequest: {
            /** @description Why the bill is being discarded, kept for the record. */
            reason?: null | string;
        };
        /** @enum {unknown} */
        DiscountType: "None" | "Percentage" | "Fixed";
        DocumentVolumeDailyRow: {
            /** Format: date */
            date: string;
            /** Format: uuid */
            clientId: string;
            clientName: string;
            clientType: components["schemas"]["ClientType"];
            /** Format: uuid */
            organisationId: string;
            organisationName: string;
            /** Format: int32 */
            bills: number | string;
            /** Format: int32 */
            purchaseOrders: number | string;
            /** Format: int32 */
            deliveryNotes: number | string;
            /** Format: int32 */
            total: number | string;
        };
        /** @description A draft invoice: created but not issued, so the customer has not been billed yet. */
        DraftInvoiceSummary: {
            /**
             * Format: uuid
             * @description Id of the draft invoice.
             */
            invoiceId?: string;
            /** @description The invoice number allocated when the draft was created. */
            invoiceNumber?: null | string;
            /**
             * Format: uuid
             * @description Id of the customer the draft bills.
             */
            customerId?: string;
            /** @description Name of the customer the draft bills. */
            customerName: string;
            /** @description 3-letter ISO currency of the draft. */
            currency: string;
            /**
             * Format: double
             * @description The draft's total, in its currency.
             */
            totalAmount?: number | string;
            /**
             * Format: date-time
             * @description When the draft was created (UTC).
             */
            createdAt?: string;
            /**
             * Format: int32
             * @description Whole days since the draft was created, as of the summary's asOf date.
             */
            daysSinceCreated?: number | string;
        };
        /** @description Draft invoices: work not yet billed. */
        DraftsSummary: {
            /**
             * Format: int32
             * @description Number of draft invoices.
             */
            count?: number | string;
            /** @description Up to 5 drafts, oldest first. */
            oldest?: components["schemas"]["DraftInvoiceSummary"][];
        };
        /** @enum {unknown} */
        DuplicateMatchBasis: "SupplierId" | "SupplierName" | "SupplierTaxId" | null;
        /** @description An early payment discount: money off the invoice total if the customer pays by a date. The invoice is issued at full price; until the expiry date the online payment link charges the discounted amount, and when the customer pays it in time a credit note is issued automatically for the discount. */
        EarlyPaymentDiscountRequest: {
            /** @description How Value is interpreted. Send None (with no value or expiry date) to remove the discount. */
            type?: components["schemas"]["DiscountType"];
            /**
             * Format: double
             * @description A percentage (0-100) of the invoice total including tax, or a cash amount in the invoice currency that is less than that total, per Type. At most 2 decimal places. Must be omitted when Type is None.
             */
            value?: null | number | string;
            /**
             * Format: date
             * @description The last day (yyyy-MM-dd) the customer can pay the discounted amount. Must fall between the invoice's issue date and its due date. Required unless Type is None.
             */
            expiresOn?: null | string;
        };
        /** @description The invoice's early payment discount. Null when the invoice has none. */
        EarlyPaymentDiscountResponse: {
            /** @description How Value is interpreted: Percentage of the invoice total including tax, or a Fixed cash amount. */
            type?: components["schemas"]["DiscountType"];
            /**
             * Format: double
             * @description The discount as it was entered: a percentage (0-100) or a cash amount, per Type.
             */
            value?: null | number | string;
            /**
             * Format: date
             * @description The last day (yyyy-MM-dd) the customer can pay the discounted amount.
             */
            expiresOn?: null | string;
            /**
             * Format: double
             * @description The discount as a cash amount off the invoice total including tax, in the invoice currency. Fixed once the invoice is issued.
             */
            amount?: number | string;
            /**
             * Format: double
             * @description What the customer pays by the expiry date: TotalAmount - Amount.
             */
            discountedTotal?: number | string;
        };
        /**
         * @description How a customer receives electronic invoices: which network, and therefore what kind of address is on file.
         * @enum {unknown}
         */
        EInvoiceAddressScheme: "Peppol" | "ItalianSdiCode" | "ItalianSdiPec" | null;
        /** @description One thing about a received document that could not be fully honoured. Not an error: a document carrying faults was accepted, and the bill or credit note it became is reviewed and paid like any other. A fault says the document asserted something there was nowhere to put, or something that disagrees with a record already on file. */
        EInvoiceFault: {
            /** @description What kind of fault this is. Stable across releases and safe to switch on — new members are added over time, so treat an unrecognised code as a generic fault and show its message. */
            code: components["schemas"]["EInvoiceFaultCode"];
            /** @description The fault in words, written to be shown to a person. Carries the specifics the code cannot — both sides of a disagreement, the two figures in a part payment, the invoice number a credit note named. Display this rather than deriving your own text from the code. */
            message: string;
            /** @description How much attention the fault deserves. Note: context, nothing is wrong. Warning: worth checking before approving. Stop: do not pay until someone has confirmed out of band — reserved for the bank-details faults. */
            severity?: components["schemas"]["EInvoiceFaultSeverity"];
        };
        /**
         * @description The catalogue of things that can be said about a received document. Members are never renamed or removed once shipped, and new ones are added as new situations are recognised — treat an unrecognised value as a generic fault rather than failing. Legacy marks a fault recorded before codes existed; only its message is meaningful.
         * @enum {unknown}
         */
        EInvoiceFaultCode: "NoTotals" | "NoLineItems" | "PartPayment" | "DocumentDiscount" | "DocumentCharge" | "TotalsUnbalanced" | "Instalments" | "CreditNoteTotalsAdjusted" | "CreditNoteLineLevel" | "CreditNoteMultipleInvoices" | "CreditNoteNonInvoiceReference" | "CreditNoteParentMissing" | "CreditNoteParentNotCreditable" | "CreditNoteParentCurrencyMismatch" | "SupplierNameOnlyMatch" | "SupplierFuzzyNearMatch" | "SupplierMissing" | "SupplierTaxNumberDiffers" | "SupplierParticipantDiffers" | "SupplierEmailDiffers" | "SupplierAddressDiffers" | "BankDetailsDiffer" | "BankDetailsNotComparable" | "LateRouting" | "Unroutable" | "Unreadable" | "UnsupportedDocumentType" | "Legacy" | "SupplierNameCollision" | "CreditNoteNegativeAmounts" | "CreditNoteMixedTaxRates" | "SupplierPossibleDuplicate" | "SupplierIdentityUnresolved";
        /**
         * @description How much attention a fault deserves: Note (context), Warning (check before approving), Stop (do not pay until confirmed out of band).
         * @enum {unknown}
         */
        EInvoiceFaultSeverity: "Note" | "Warning" | "Stop";
        /** @enum {unknown} */
        EInvoicingNetwork: "Peppol" | "Sdi" | null;
        /** @description A network address at which an organisation receives documents. */
        EInvoicingParticipantResponse: {
            /** @description Identifier scheme, e.g. "0208" for a Belgian company number or "9932" for a UK VAT number. */
            scheme: string;
            /** @description The participant identifier itself. */
            code: string;
        };
        /** @description The party details a registration was, or would be, submitted with. */
        EInvoicingPartyResponse: {
            /** @description Registered legal name. */
            legalName?: null | string;
            /** @description Trading name, when it differs from the legal name. */
            tradingName?: null | string;
            taxNumber?: null | string;
            companyRegistrationNumber?: null | string;
            addressLine1?: null | string;
            addressLine2?: null | string;
            city?: null | string;
            /** @description Province, state or county. */
            addressRegion?: null | string;
            postalCode?: null | string;
            /** @description ISO 3166-1 alpha-2 country code (e.g. GB, BE, DE) */
            country?: null | string;
            contactEmail?: null | string;
        };
        EInvoicingRegistrationAdminResponse: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            organisationId?: string;
            organisationName?: null | string;
            /** Format: uuid */
            clientId?: null | string;
            state?: components["schemas"]["EInvoicingRegistrationState"];
            network?: components["schemas"]["EInvoicingNetwork"];
            legalName?: null | string;
            taxCountry?: null | string;
            taxNumber?: null | string;
            electronicAddress?: null | string;
            electronicAddressScheme?: null | string;
            /** Format: int32 */
            submissionCount?: number | string;
            providerJobId?: null | string;
            providerState?: null | string;
            faults?: components["schemas"]["ProviderFaultDetail"][];
            ownershipDocumentName?: null | string;
            /** Format: date-time */
            ownershipDocumentUploadedAt?: null | string;
            /** Format: date-time */
            submittedAt?: null | string;
            /** Format: date-time */
            registeredAt?: null | string;
            /** Format: date-time */
            failedAt?: null | string;
            /** Format: date-time */
            lastCallbackAt?: null | string;
            /** Format: date-time */
            createdAt?: string;
            /** Format: date-time */
            updatedAt?: string;
        };
        /** @description E-invoicing registration status for an organisation, including any outstanding actions. */
        EInvoicingRegistrationResponse: {
            /**
             * Format: uuid
             * @description Registration identifier. Null when the organisation has never submitted one.
             */
            id?: null | string;
            /** @description Whether a registration exists at all, and if so how far it has got. */
            status: components["schemas"]["EInvoicingRegistrationStatus"];
            network?: null | components["schemas"]["EInvoicingNetwork"];
            participant?: null | components["schemas"]["EInvoicingParticipantResponse"];
            /** @description Steps that require a human before registration can continue. Empty when nothing is outstanding. */
            requiredActions?: components["schemas"]["EInvoicingRequiredActionResponse"][];
            /** @description What went wrong when registration failed — or, on a registered organisation, when a withdrawal from the network failed. Empty otherwise. */
            faults?: components["schemas"]["ProviderFaultDetail"][];
            /** @description The details that were submitted, or a prefill from the organisation when none have been. */
            party: components["schemas"]["EInvoicingPartyResponse"];
            /** @description Whether this organisation's details are complete enough to submit a registration. */
            canSubmit: boolean;
            /** Format: date-time */
            submittedAt?: null | string;
            /** Format: date-time */
            registeredAt?: null | string;
        };
        /** @enum {unknown} */
        EInvoicingRegistrationState: "Submitted" | "ActionRequired" | "Processing" | "Registered" | "Failed" | "Unregistering" | "Unregistered";
        /** @enum {unknown} */
        EInvoicingRegistrationStatus: "NotStarted" | "Submitted" | "ActionRequired" | "Processing" | "Registered" | "Failed" | "Unregistering" | "Unregistered";
        /** @description Something a human must do before registration can continue. */
        EInvoicingRequiredActionResponse: {
            /** @description Stable machine-readable code for the action, e.g. "proof_of_ownership_required". */
            code: string;
            /** @description Human-readable explanation of what is needed. */
            detail: string;
        };
        /** @enum {unknown} */
        EmailAuthResult: "Unknown" | "Pass" | "Fail";
        /** @enum {unknown} */
        EmployeeCount: "OneToTen" | "ElevenToFifty" | "FiftyOneToTwoHundred" | "TwoHundredToOneThousand" | "OneThousandPlus" | null;
        ExchangeRequest: {
            code: string;
        };
        /** @description One expense counted in an aggregate. */
        ExpenseAggregateContributor: {
            /**
             * Format: uuid
             * @description The expense's id.
             */
            expenseId?: string;
            /**
             * Format: date
             * @description When the card was used.
             */
            spendDate?: string;
            /** @description The merchant's name. */
            merchantName?: null | string;
            /** @description ISO 4217 billing currency. */
            currency: string;
            /**
             * Format: double
             * @description Billed amount: the authorised hold while pending, the settled amount after. Negative for a refund.
             */
            amount?: number | string;
            /** @description Which search signal matched it. */
            matchedBy?: components["schemas"]["ExpenseSearchSignal"];
        };
        /** @description One group of an expense aggregate breakdown. */
        ExpenseAggregateGroup: {
            /** @description The group's key: a merchant id (or 'name:' plus the merchant name when unmatched), a month as yyyy-MM, a ledger account id, or a user id. Null for uncoded spend or cards with no holder. */
            key?: null | string;
            /** @description A display name for the group. */
            name: string;
            /** @description The group's spend per billing currency. The expense count is of expenses with spend in this group; by ledger account, a split expense is counted in each account it touches. */
            byCurrency?: components["schemas"]["ExpenseCurrencyAmount"][];
        };
        /**
         * @description How to break an expense aggregate down.
         * @enum {unknown}
         */
        ExpenseAggregateGroupBy: "Merchant" | "Month" | "LedgerAccount" | "Spender" | null;
        /** @description Totals over every expense a natural-language search matches, per billing currency, with how well the set was matched. */
        ExpenseAggregateResponse: {
            /** @description How the query was read: the filters applied exactly (including explicit from/to), and the words matched by meaning and name. */
            interpretation: components["schemas"]["ExpenseSearchInterpretation"];
            /** @description True when expenses were matched by meaning as well as by name. False when meaning-based search is not available, so only merchant names, card descriptors and memos were matched and a paraphrase can miss. */
            semanticRanking?: boolean;
            /** @description True when a matching signal returned as many candidates as it takes (50), so more expenses may match than were summed. Narrow the query (a date range, a more specific phrase) to get a complete total. */
            capped?: boolean;
            /**
             * Format: int32
             * @description Expenses the query matched, before voided transactions and personal spend are set aside.
             */
            matchCount?: number | string;
            /**
             * Format: int32
             * @description Matches found by meaning only. Zero for a filters-only query.
             */
            matchedByMeaningOnly?: number | string;
            /**
             * Format: int32
             * @description Matches found by merchant name, card descriptor or memo only. Zero for a filters-only query.
             */
            matchedByNameOnly?: number | string;
            /**
             * Format: int32
             * @description Matches found by both meaning and name. Zero for a filters-only query.
             */
            matchedByBoth?: number | string;
            /**
             * Format: int32
             * @description Expenses counted in the totals: business spend on settled or pending transactions.
             */
            expenseCount?: number | string;
            /**
             * Format: int32
             * @description Matched expenses left out because their card transaction was voided.
             */
            excludedVoidedCount?: number | string;
            /** @description The primary currency (the organisation's default), listed first. Rows in every currency are returned. */
            currency: string;
            /** @description True when the counted spend is in more than one billing currency. Totals are never summed across currencies. */
            mixedCurrency?: boolean;
            /** @description Business spend per billing currency. Excludes voided transactions and personal spend; refunds are netted. */
            totals?: components["schemas"]["ExpenseSpendTotal"][];
            /** @description Matched personal spend on company cards, per currency, never included in the totals. */
            personal?: components["schemas"]["ExpenseCurrencyAmount"][];
            /**
             * Format: date
             * @description Spend date of the earliest counted expense. Null when none was counted.
             */
            firstSpendDate?: null | string;
            /**
             * Format: date
             * @description Spend date of the latest counted expense. Null when none was counted.
             */
            lastSpendDate?: null | string;
            groupBy?: null | components["schemas"]["ExpenseAggregateGroupBy"];
            /** @description The breakdown of the totals; per currency, the groups' amounts sum exactly to the totals. Null unless groupBy was given. Months are in date order; other groups by primary-currency amount, largest first. By ledger account, an expense whose lines are coded to several accounts counts in each of them, so the groups' expense counts can add up to more than the totals' while the amounts still match. */
            groups?: null | components["schemas"]["ExpenseAggregateGroup"][];
            /** @description The ten largest counted expenses by billed amount, so the set can be checked for a wrong inclusion. */
            topContributors?: components["schemas"]["ExpenseAggregateContributor"][];
        };
        /**
         * @description What decided whether an expense needed approval.
         * @enum {unknown}
         */
        ExpenseApprovalOutcome: "AutoApprove" | "RequireApproval" | "Flag" | "NoPolicy";
        /** @description Expenses with one approval outcome. */
        ExpenseApprovalOutcomeCount: {
            /** @description The outcome. */
            outcome?: components["schemas"]["ExpenseApprovalOutcome"];
            /**
             * Format: int32
             * @description Number of expenses.
             */
            count?: number | string;
            /** @description Their value, per currency. */
            byCurrency?: components["schemas"]["ExpenseCurrencyAmount"][];
        };
        /**
         * @description What happens to an expense the policy matches.
         * @enum {unknown}
         */
        ExpenseApprovalPolicyAction: "AutoApprove" | "RequireApproval" | "Flag" | null;
        /** @description Matches for one approval policy. */
        ExpenseApprovalPolicyHits: {
            /**
             * Format: uuid
             * @description The policy's id.
             */
            policyId?: string;
            /** @description The policy's name when it last matched. */
            name?: null | string;
            action?: null | components["schemas"]["ExpenseApprovalPolicyAction"];
            /**
             * Format: int32
             * @description Number of expenses it matched.
             */
            matchCount?: number | string;
            /** @description Their value, per currency. */
            byCurrency?: components["schemas"]["ExpenseCurrencyAmount"][];
        };
        /** @description An expense approval policy: a rule that decides whether a matching expense posts automatically, waits for approval, or is flagged as a policy violation. */
        ExpenseApprovalPolicyResponse: {
            /**
             * Format: uuid
             * @description Policy id.
             */
            id: string;
            /** @description Display name. */
            name: string;
            /**
             * Format: int32
             * @description Revision number. Starts at 1 and increases by one every time the policy changes.
             */
            version: number | string;
            /**
             * Format: int32
             * @description 0–1000; lower numbers win when several policies match. Also the display order.
             */
            priorityOrder: number | string;
            /** @description Inactive policies are kept but never applied. */
            active: boolean;
            /**
             * Format: double
             * @description Matches expenses of at least this amount, in `currency`, judged on what the card was charged in its billing currency.
             */
            amountGte?: null | number | string;
            /**
             * Format: double
             * @description Matches expenses of at most this amount, in `currency`, judged on what the card was charged in its billing currency.
             */
            amountLte?: null | number | string;
            /** @description ISO 4217 code. Set when an amount bound is set; the policy then only matches spend on cards billed in this currency. */
            currency?: null | string;
            /** @description Merchant category codes matched. Empty matches any category. */
            mccCodes: string[];
            /** @description Merchants matched. Empty matches any merchant. */
            merchantIds: string[];
            /** @description Linked cards matched. Empty matches any card. */
            cardConnectionIds: string[];
            /** @description Organisation members whose spend is matched. Empty matches anyone. */
            spenderUserIds: string[];
            /** @description Whether the policy matches expenses with a receipt, without one, or either. */
            receiptCondition: components["schemas"]["ExpenseReceiptCondition"];
            /** @description Whether the policy matches business spend, personal spend, or both. */
            personalSpend: components["schemas"]["ExpensePersonalSpendCondition"];
            /** @description What happens to a matching expense. */
            action: components["schemas"]["ExpenseApprovalPolicyAction"];
            /** @description Members who may approve, for RequireApproval. Empty means any member allowed to approve expenses. */
            approverUserIds: string[];
            /**
             * Format: uuid
             * @description The uploaded policy document this policy was created from, if any.
             */
            sourceDocumentId?: null | string;
            clause?: null | components["schemas"]["ExpensePolicyClauseRefResponse"];
            /**
             * Format: date-time
             * @description When the policy was created (UTC).
             */
            createdAt: string;
            /**
             * Format: date-time
             * @description When the policy last changed (UTC).
             */
            updatedAt: string;
        };
        /** @description The approval queue. */
        ExpenseApprovalQueue: {
            /**
             * Format: int32
             * @description Expenses waiting for approval.
             */
            count?: number | string;
            /** @description Their value, per currency. */
            byCurrency?: components["schemas"]["ExpenseCurrencyAmount"][];
            /** @description Waiting expenses per named approver. An expense with several approvers counts under each; one with none named is under a row with no approver, meaning anyone allowed to approve expenses. */
            byApprover?: components["schemas"]["ExpenseApproverQueue"][];
        };
        /** @description How approval of card spend is going: the current queue, what decided each expense, how long approvals take, which policies match, and who breaks policy. */
        ExpenseApprovalReport: {
            /**
             * Format: date
             * @description The date the report was computed for (UTC).
             */
            asOf?: string;
            /** @description The requested period. */
            period?: components["schemas"]["LookbackPeriod"];
            /**
             * Format: date
             * @description First day of the period, inclusive.
             */
            periodStart?: string;
            /**
             * Format: date
             * @description Last day of the period, inclusive.
             */
            periodEnd?: string;
            /** @description The primary currency: the requested one, else the organisation's default. */
            currency: string;
            /** @description The expenses waiting for approval right now, whatever the period. */
            pending: components["schemas"]["ExpenseApprovalQueue"];
            /** @description What decided whether each expense in the period needed approval. */
            outcomes?: components["schemas"]["ExpenseApprovalOutcomeCount"][];
            /** @description How long approvals given during the period took, from first waiting to being approved. */
            timeToApprove: components["schemas"]["ExpenseTimeToApprove"];
            /** @description How often each approval policy matched expenses in the period. */
            byPolicy?: components["schemas"]["ExpenseApprovalPolicyHits"][];
            /** @description The ten people with the most policy violations in the period. */
            violationsBySpender?: components["schemas"]["ExpensePolicyViolationsBySpender"][];
        };
        /** @description The expenses one approver can release. */
        ExpenseApproverQueue: {
            approver?: null | components["schemas"]["ExpenseReportPerson"];
            /**
             * Format: int32
             * @description Number of expenses waiting.
             */
            count?: number | string;
            /**
             * Format: date-time
             * @description When the longest-waiting of them started waiting (UTC).
             */
            oldestWaitingSince?: null | string;
        };
        /** @description One entry in an expense's history. */
        ExpenseAuditLogResponse: {
            /**
             * Format: uuid
             * @description Unique identifier of the entry.
             */
            id?: string;
            /** @description What happened, e.g. expense.captured, expense.receipt_attached, expense.posted. */
            event: string;
            /** @description The state the expense moved into, when the entry marks a transition. */
            toState?: null | string;
            /** @description Human-readable description of what changed. */
            detail?: null | string;
            /**
             * Format: uuid
             * @description Who did it. Null for anything the system did on its own, which is most of it by design.
             */
            actorUserId?: null | string;
            /**
             * Format: date-time
             * @description When it happened.
             */
            createdAt?: string;
        };
        /** @description Posting progress for one closed calendar month. */
        ExpenseCloseReadiness: {
            /**
             * Format: date
             * @description First day of the month.
             */
            monthStart?: string;
            /**
             * Format: date
             * @description Last day of the month.
             */
            monthEnd?: string;
            /**
             * Format: int32
             * @description Expenses in the month.
             */
            expenseCount?: number | string;
            /**
             * Format: int32
             * @description Of those, how many have posted to the accounting platform.
             */
            postedCount?: number | string;
            /**
             * Format: double
             * @description PostedCount / ExpenseCount, 0 to 1. Null when the month has no expenses.
             */
            postedRate?: null | number | string;
            /** @description The expenses not yet posted, by state. */
            blocking?: components["schemas"]["ExpenseStateCount"][];
        };
        /** @description How expenses were coded. */
        ExpenseCodingCompliance: {
            /** @description Expenses by the step that chose their account. */
            bySource?: components["schemas"]["ExpenseCodingSourceCount"][];
            /**
             * Format: double
             * @description Share of coded expenses whose account was chosen without a person, 0 to 1. Null when none are coded.
             */
            autoCodingRate?: null | number | string;
        };
        /** @enum {unknown} */
        ExpenseCodingSource: "None" | "Personal" | "OrgMapping" | "History" | "ClientMapping" | "CardDefault" | "Human";
        /** @description Expenses coded by one step. */
        ExpenseCodingSourceCount: {
            /** @description The step that chose the account. */
            source?: components["schemas"]["ExpenseCodingSource"];
            /**
             * Format: int32
             * @description Number of expenses.
             */
            count?: number | string;
        };
        /** @description What stands between the organisation's card spend and a closed month: missing receipts, expenses in each state, open flags, how much is automated, and last month's posting progress. */
        ExpenseComplianceReport: {
            /**
             * Format: date
             * @description The date the report was computed for (UTC).
             */
            asOf?: string;
            /** @description The requested period. */
            period?: components["schemas"]["LookbackPeriod"];
            /**
             * Format: date
             * @description First day of the period, inclusive.
             */
            periodStart?: string;
            /**
             * Format: date
             * @description Last day of the period, inclusive.
             */
            periodEnd?: string;
            /** @description The primary currency: the requested one, else the organisation's default. */
            currency: string;
            /** @description True when spend in the period is in more than one currency. */
            mixedCurrency?: boolean;
            /** @description Receipt coverage for business spend in the period. Personal spend needs no receipt and is left out. */
            receipts: components["schemas"]["ExpenseReceiptCompliance"];
            /** @description Expenses in the period by state. */
            states?: components["schemas"]["ExpenseStateCount"][];
            /** @description Expenses in the period with an open flag, by reason: flagged ones, and posted ones flagged afterwards (an amount that changed after posting) that nobody has resolved yet. */
            openFlags?: components["schemas"]["ExpenseFlagCount"][];
            /** @description How expenses in the period were coded to accounts. */
            coding: components["schemas"]["ExpenseCodingCompliance"];
            /** @description Posting progress for the previous calendar month, whatever the requested period. */
            closeReadiness: components["schemas"]["ExpenseCloseReadiness"];
        };
        /** @description An amount in one currency. */
        ExpenseCurrencyAmount: {
            /** @description ISO 4217 currency code of the card's billing currency. */
            currency: string;
            /**
             * Format: double
             * @description Amount in that currency.
             */
            amount?: number | string;
            /**
             * Format: int32
             * @description Number of expenses behind the amount.
             */
            expenseCount?: number | string;
        };
        /** @description Open flags for one reason. */
        ExpenseFlagCount: {
            /** @description Why the expenses are flagged. */
            reason?: components["schemas"]["ExpenseFlagReason"];
            /**
             * Format: int32
             * @description Number of flagged expenses.
             */
            count?: number | string;
        };
        /** @description Expenses with an open flag. The queue is the organisation's current backlog, whatever the period. */
        ExpenseFlagQueueSummary: {
            /**
             * Format: int32
             * @description Number of expenses with an open flag: flagged ones, and posted ones flagged afterwards that nobody has resolved yet.
             */
            count?: number | string;
            /** @description Open flags by reason. */
            byReason?: components["schemas"]["ExpenseFlagCount"][];
            /** @description Up to 5 of them, flagged longest ago first. */
            oldest?: components["schemas"]["ExpenseQueueItem"][];
        };
        /** @enum {unknown} */
        ExpenseFlagReason: "AmbiguousMatch" | "AmountVariance" | "UnmappedMcc" | "MissingAccountingConfiguration" | "AmountChangedAfterPost" | "TaxRateUnresolved" | "PolicyViolation" | null;
        ExpenseLineRequest: {
            /** Format: double */
            amount: number | string;
            /** Format: uuid */
            ledgerAccountId?: null | string;
            description?: null | string;
            taxCode?: null | string;
            /** Format: double */
            taxRate?: null | number | string;
            /** Format: double */
            taxAmount?: null | number | string;
            /** Format: uuid */
            trackingCategoryId?: null | string;
        };
        /** @description One coded line of an expense — what actually gets pushed to the accounting platform. */
        ExpenseLineResponse: {
            /**
             * Format: uuid
             * @description Unique identifier of the line.
             */
            id?: string;
            /**
             * Format: int32
             * @description Position of the line within the expense.
             */
            lineNumber?: number | string;
            /** @description Line description. */
            description?: null | string;
            /**
             * Format: double
             * @description Gross amount for the line. Lines must total the card transaction amount.
             */
            amount?: number | string;
            /**
             * Format: double
             * @description Tax rate as a percentage, where known.
             */
            taxRate?: null | number | string;
            /**
             * Format: double
             * @description Tax amount for the line, where known.
             */
            taxAmount?: null | number | string;
            /**
             * Format: uuid
             * @description The expense account this line is debited to.
             */
            ledgerAccountId?: null | string;
            /** @description The accounting platform's own tax code applied to the line. */
            taxCode?: null | string;
            /** @description The platform's name for the tax rate the line posts at, e.g. "20.0% S" or "Zero Rated Expenses". */
            taxRateName?: null | string;
            /** @description Why no tax rate could be chosen for the line, when none could. The expense is flagged TaxRateUnresolved and will not post while any line has one. */
            taxRateIssue?: null | string;
            /**
             * Format: uuid
             * @description Project, department or cost-centre dimension. Reserved — not set in v1.
             */
            trackingCategoryId?: null | string;
            /** @description Where the coding came from: ReceiptLine, MccDefault or Manual. Manual coding is never overwritten by an automatic re-code. */
            source?: components["schemas"]["ExpenseLineSource"];
            /** @description Whether VAT on this line can be reclaimed. */
            isVatReclaimable?: boolean;
            vatReclaimBlockedReason?: null | components["schemas"]["VatReclaimBlockedReason"];
        };
        /** @enum {unknown} */
        ExpenseLineSource: "ReceiptLine" | "MccDefault" | "Manual" | "Balancing";
        /** @enum {unknown} */
        ExpenseMatchSource: "None" | "Auto" | "Manual";
        /** @description The merchant an expense was made at. */
        ExpenseMerchantResponse: {
            /**
             * Format: uuid
             * @description Unique identifier of the merchant. Use it with GET /merchants/{id} and to filter GET /expenses.
             */
            id?: string;
            /** @description The merchant's name, cleaned of payment-processor prefixes and store numbers. */
            displayName?: null | string;
            /** @description Merchant logo URL, where the card provider supplied one. */
            logoUrl?: null | string;
        };
        /** @description One person's expenses with no receipt. */
        ExpenseMissingReceiptsBySpender: {
            spender?: null | components["schemas"]["ExpenseReportPerson"];
            /**
             * Format: int32
             * @description Number of their expenses with no receipt.
             */
            missingCount?: number | string;
            /** @description Their value, per currency. */
            byCurrency?: components["schemas"]["ExpenseCurrencyAmount"][];
        };
        /** @description Merchants first used during the period, in one currency. */
        ExpenseNewMerchants: {
            /** @description ISO 4217 billing currency. */
            currency: string;
            /**
             * Format: int32
             * @description Number of merchants first used in the period.
             */
            merchantCount?: number | string;
            /**
             * Format: double
             * @description Net spend at those merchants in the period.
             */
            total?: number | string;
        };
        /**
         * @description Whether the policy applies to business spend, personal spend, or both.
         * @enum {unknown}
         */
        ExpensePersonalSpendCondition: "Any" | "Business" | "Personal";
        /** @description An organisation member, as a card holder or an expense's spender. */
        ExpensePersonResponse: {
            /**
             * Format: uuid
             * @description The user's id.
             */
            userId?: string;
            /** @description The user's display name, where they have one. */
            name?: null | string;
            /** @description The user's email address. */
            email?: null | string;
        };
        /** @description The clause of an uploaded policy document that a policy enforces. */
        ExpensePolicyClauseRefResponse: {
            /** @description The clause, quoted verbatim from the document. */
            quote: string;
            /**
             * Format: int32
             * @description Page the clause appears on. Only set for PDF documents.
             */
            page?: null | number | string;
        };
        /** @description An uploaded expense policy document and what it was compiled into. */
        ExpensePolicyDocumentResponse: {
            /**
             * Format: uuid
             * @description Document id.
             */
            id: string;
            /**
             * Format: int32
             * @description Version of the organisation's policy document, starting at 1.
             */
            version: number | string;
            /** @description Original file name. */
            fileName: string;
            /** @description MIME type of the uploaded file. */
            contentType: string;
            /**
             * Format: int64
             * @description Size of the uploaded file in bytes.
             */
            sizeBytes?: number | string;
            /**
             * Format: int32
             * @description Number of pages, for PDF documents.
             */
            pageCount?: null | number | string;
            /** @description Where the document is in its lifecycle. */
            status: components["schemas"]["ExpensePolicyDocumentStatus"];
            /** @description Why compiling failed, when Status is Failed. */
            failureReason?: null | string;
            /**
             * Format: int32
             * @description Number of policies proposed.
             */
            proposedPolicyCount?: number | string;
            /**
             * Format: int32
             * @description Number of clauses that cannot be enforced automatically.
             */
            unenforceableClauseCount?: number | string;
            /** @description Proposed policies, on the detail response. */
            proposals?: null | components["schemas"]["ExpensePolicyProposalResponse"][];
            /** @description Clauses that cannot be enforced automatically, on the detail response. */
            unenforceableClauses?: null | components["schemas"]["UnenforceableExpensePolicyClauseResponse"][];
            /** @description Current document-sourced policies that confirming would delete, on the detail response while the document is waiting for review. */
            removedPolicies?: null | components["schemas"]["RemovedExpensePolicyResponse"][];
            /**
             * Format: date-time
             * @description When the document was compiled (UTC).
             */
            compiledAt?: null | string;
            /**
             * Format: date-time
             * @description When an admin confirmed the document (UTC).
             */
            confirmedAt?: null | string;
            /**
             * Format: uuid
             * @description Who confirmed the document.
             */
            confirmedBy?: null | string;
            /**
             * Format: date-time
             * @description When the document was uploaded (UTC).
             */
            createdAt: string;
            /**
             * Format: uuid
             * @description Who uploaded the document.
             */
            createdBy?: null | string;
        };
        /**
         * @description Where an uploaded expense policy document is in its lifecycle.
         * @enum {unknown}
         */
        ExpensePolicyDocumentStatus: "Compiling" | "ReadyForReview" | "Confirmed" | "Failed" | "Superseded";
        /** @description Signed upload URL for a policy document. Send the raw file bytes to `uploadUrl` with `httpMethod` and the header `Content-Type: {contentType}`, then finalise with `objectName`. */
        ExpensePolicyDocumentUploadUrlResponse: {
            /** @description One-shot signed URL to send the file to. */
            uploadUrl: string;
            /** @description HTTP method to use with the URL. */
            httpMethod: string;
            /** @description Reference to pass when finalising the upload. */
            objectName: string;
            /** @description Content-Type header the upload must carry. */
            contentType: string;
            /**
             * Format: date-time
             * @description When the URL stops working (UTC).
             */
            expiresAt: string;
        };
        /**
         * @description How a proposed policy compares with the organisation's current document-sourced policies.
         * @enum {unknown}
         */
        ExpensePolicyProposalChange: "Added" | "Changed" | "Unchanged";
        /** @description An approval policy proposed from an uploaded policy document. Not applied until an organisation admin confirms the document. */
        ExpensePolicyProposalResponse: {
            /** @description Proposed policy name. Confirming replaces a current document-sourced policy with the same name. */
            name: string;
            /**
             * Format: int32
             * @description 0–1000; lower numbers win. Follows the order of the clauses in the document.
             */
            priorityOrder?: number | string;
            /** @description What happens to a matching expense. */
            action?: components["schemas"]["ExpenseApprovalPolicyAction"];
            /**
             * Format: double
             * @description Matches expenses of at least this amount, in `currency`.
             */
            amountGte?: null | number | string;
            /**
             * Format: double
             * @description Matches expenses of at most this amount, in `currency`.
             */
            amountLte?: null | number | string;
            /** @description ISO 4217 code of the amount condition. */
            currency?: null | string;
            /** @description Merchant category codes matched. Empty matches any category. */
            mccCodes: string[];
            /** @description Merchants matched. Empty matches any merchant. */
            merchantIds: string[];
            /** @description Approvers resolved from the names in the document, for RequireApproval. */
            approverUserIds: string[];
            /** @description Whether the policy matches expenses with a receipt, without one, or either. */
            receiptCondition?: components["schemas"]["ExpenseReceiptCondition"];
            /** @description Whether the policy matches business spend, personal spend, or both. */
            personalSpend?: components["schemas"]["ExpensePersonalSpendCondition"];
            /** @description The clause this policy enforces, quoted from the document. */
            clause: components["schemas"]["ExpensePolicyClauseRefResponse"];
            /** @description Warnings to review before confirming that do not block it, such as an approver named only by role. */
            notes: string[];
            /** @description What the document names that could not be matched to this organisation, such as an unknown merchant, category or approver. Applying the proposal without it would make the rule broader than the document says, so it cannot be confirmed as compiled: edit it to fill the gap, or leave it out. */
            unresolved: string[];
            /** @description How this proposal compares with the current policies. */
            change?: components["schemas"]["ExpensePolicyProposalChange"];
            /**
             * Format: uuid
             * @description The current policy this proposal would replace, when Change is Changed or Unchanged.
             */
            existingPolicyId?: null | string;
        };
        /** @description One person's policy violations. */
        ExpensePolicyViolationsBySpender: {
            spender?: null | components["schemas"]["ExpenseReportPerson"];
            /**
             * Format: int32
             * @description Number of their expenses flagged as a policy violation.
             */
            count?: number | string;
        };
        /** @description An expense waiting on someone: for approval, with an open flag, or after a failed post. */
        ExpenseQueueItem: {
            /**
             * Format: uuid
             * @description Id of the expense.
             */
            expenseId?: string;
            /** @description The merchant's name: the recognised merchant's display name, else the name the card network printed. Null when there is neither. */
            merchant?: null | string;
            /**
             * Format: uuid
             * @description Id of the recognised merchant. Null until the merchant has been resolved.
             */
            merchantId?: null | string;
            /**
             * Format: double
             * @description Billed amount: the authorised hold while the transaction is pending, the settled amount after.
             */
            amount?: number | string;
            /** @description ISO 4217 code of the card's billing currency. */
            currency: string;
            /**
             * Format: date-time
             * @description When the card was used.
             */
            transactionDate?: null | string;
            spender?: null | components["schemas"]["ExpenseReportPerson"];
            /** @description The expense's state. */
            state?: components["schemas"]["ExpenseState"];
            flagReason?: null | components["schemas"]["ExpenseFlagReason"];
            /** @description Why the last post attempt failed, as the accounting platform reported it. */
            postFailureReason?: null | string;
            /**
             * Format: int32
             * @description How many times Dolfin has tried to send it to the accounting platform.
             */
            postAttemptCount?: number | string;
            /**
             * Format: int32
             * @description Whole days it has waited, as of the summary's asOf date: since review was requested, since it was flagged, or since the last post attempt.
             */
            daysWaiting?: number | string;
            /** @description True when the caller can approve it right now: it is waiting for review and the caller is one of its named approvers, an organisation admin or owner, or a trusted Client caller; or no approvers are named, so any member may. */
            awaitingYou?: boolean;
            /** @description True when its flag can be accepted as it stands by any member: an ambiguous receipt match or a receipt amount that differs from the card. Other flags need a configuration fix or an admin. */
            canResolve?: boolean;
            /** @description True when its post failed and fewer than 3 attempts have been made, so retrying is worth it. After 3, explain the failure reason instead. */
            canRetry?: boolean;
        };
        /** @description Expenses waiting in one queue. The queue is the organisation's current backlog, whatever the period. */
        ExpenseQueueSummary: {
            /**
             * Format: int32
             * @description Number of expenses in the queue.
             */
            count?: number | string;
            /** @description Up to 5 of them, the longest waiting first. */
            oldest?: components["schemas"]["ExpenseQueueItem"][];
        };
        /**
         * @description How old an expense without a receipt is, counted from the day the card was used.
         * @enum {unknown}
         */
        ExpenseReceiptAge: "Days0To7" | "Days8To30" | "Days31Plus";
        /** @description Expenses with no receipt in one age band. */
        ExpenseReceiptAging: {
            /** @description The age band. */
            bucket?: components["schemas"]["ExpenseReceiptAge"];
            /**
             * Format: int32
             * @description Number of expenses in the band.
             */
            count?: number | string;
            /** @description Their value, per currency. */
            byCurrency?: components["schemas"]["ExpenseCurrencyAmount"][];
        };
        /** @description Receipt coverage. */
        ExpenseReceiptCompliance: {
            /**
             * Format: int32
             * @description Business expenses in the period.
             */
            expenseCount?: number | string;
            /**
             * Format: int32
             * @description Of those, how many have a receipt.
             */
            withReceiptCount?: number | string;
            /**
             * Format: double
             * @description WithReceiptCount / ExpenseCount, 0 to 1. Null when there are no expenses.
             */
            coverageRate?: null | number | string;
            /**
             * Format: int32
             * @description Business expenses with no receipt.
             */
            missingCount?: number | string;
            /** @description Value of the expenses with no receipt, per currency. */
            missing?: components["schemas"]["ExpenseCurrencyAmount"][];
            /** @description Expenses with no receipt by age. */
            aging?: components["schemas"]["ExpenseReceiptAging"][];
            /** @description The ten people with the most expenses missing a receipt. */
            bySpender?: components["schemas"]["ExpenseMissingReceiptsBySpender"][];
            /**
             * Format: double
             * @description Of the expenses with a receipt, the share matched automatically rather than by a person, 0 to 1. Null when none have a receipt.
             */
            autoMatchRate?: null | number | string;
        };
        /**
         * @description Whether the policy applies to expenses with or without a receipt.
         * @enum {unknown}
         */
        ExpenseReceiptCondition: "Any" | "Attached" | "Missing";
        /**
         * @description Bucket granularity, derived from the period.
         * @enum {unknown}
         */
        ExpenseReportGranularity: "Daily" | "Weekly" | "Monthly";
        /** @description A user the report attributes spend, receipts or approvals to. */
        ExpenseReportPerson: {
            /**
             * Format: uuid
             * @description The user's id. Null for spend on a card with no holder assigned.
             */
            userId?: null | string;
            /** @description The user's display name, where they have one. */
            name?: null | string;
            /** @description The user's email address. */
            email?: null | string;
        };
        /** @description A unit of card spend: one card transaction, its coding, and optionally a matched receipt. */
        ExpenseResponse: {
            /**
             * Format: uuid
             * @description Unique identifier of the expense.
             */
            id?: string;
            /**
             * Format: uuid
             * @description The organisation the spend belongs to.
             */
            organisationId?: string;
            /**
             * Format: uuid
             * @description The card the spend was made on.
             */
            cardConnectionId?: string;
            /** @description Last four digits of the card the spend was made on, to tell cards apart in a list. */
            cardLast4?: null | string;
            /** @description Network of the card the spend was made on, e.g. VISA or MASTERCARD. */
            cardNetwork?: null | string;
            /** @description The card's nickname, where the organisation has given it one (e.g. "Ops card"). */
            cardDisplayName?: null | string;
            spender?: null | components["schemas"]["ExpensePersonResponse"];
            /**
             * Format: uuid
             * @description The card transaction this expense was created from. Every expense has exactly one.
             */
            cardTransactionId?: string;
            /**
             * Format: uuid
             * @description The receipt shown as the primary one, where a receipt has been matched.
             */
            primaryReceiptId?: null | string;
            /** @description Lifecycle state: Captured, Coded, PendingReview, Posting, Posted, Flagged or PostFailed. */
            state?: components["schemas"]["ExpenseState"];
            /** @description How the receipt was matched: None, Auto or Manual. */
            matchSource?: components["schemas"]["ExpenseMatchSource"];
            /**
             * Format: double
             * @description Confidence of an automatic match, between 0 and 1. Null for a manual match — a human's choice has no score.
             */
            matchScore?: null | number | string;
            /**
             * Format: double
             * @description Amount of the expense, following the card transaction: the settled amount once settled, the authorised amount before that.
             */
            amount?: number | string;
            /** @description Currency of the expense (ISO 4217). Always present — it is carried from the card transaction, which cannot lack one. */
            currency: string;
            /** @description Merchant name as the card network printed it. */
            merchantName?: null | string;
            merchant?: null | components["schemas"]["ExpenseMerchantResponse"];
            /** @description Merchant category code from the card network. */
            mcc?: null | string;
            /** @description Human-readable spend category derived from the merchant category code. For display only — coding is driven by the category code itself. */
            spendCategoryLabel?: null | string;
            /** @description Free-text note added by a user. */
            memo?: null | string;
            /** @description Whether this was personal spend on a company card. Personal spend posts to the organisation's personal/director's-loan account and is never VAT reclaimable. */
            isPersonal?: boolean;
            /** @description Whether a receipt is still outstanding. An expense can be posted without one — spend is captured either way. */
            needsReceipt?: boolean;
            flagReason?: null | components["schemas"]["ExpenseFlagReason"];
            /** @description Explanation of the flag, in the terms a person can act on. */
            flagDetail?: null | string;
            /**
             * Format: date-time
             * @description When the expense was flagged.
             */
            flaggedAt?: null | string;
            appliedApprovalPolicy?: null | components["schemas"]["AppliedExpenseApprovalPolicyResponse"];
            /** @description Plain-language explanation of the routing decision, e.g. which policy matched and what it does. */
            approvalReasoning?: null | string;
            /** @description Members who may approve this expense while it waits for review, besides organisation admins. Empty means any member may. */
            pendingApproverUserIds?: string[];
            /** @description The identifier the accounting platform gave the posted expense. */
            apideckExpenseId?: null | string;
            /**
             * Format: date-time
             * @description When the expense was posted to the accounting platform.
             */
            postedAt?: null | string;
            /** @description The accounting platform the expense was posted to, e.g. quickbooks or xero. Set once posted. */
            accountingPlatform?: null | string;
            /** @description The reference written on the posted entry, e.g. DLF-1a2b3c4d5e6f7a8b. Search for it in the accounting platform to find the entry: QuickBooks shows it as the Ref no., Xero as the Reference. */
            accountingReference?: null | string;
            /** @description A link that opens the posted entry in the accounting platform's web app. The person must be signed in to the platform. Null where the platform has no link for it. */
            accountingUrl?: null | string;
            /** @description The account in the accounting platform that the spend was paid from: the card's account when the expense was posted. */
            paidFromAccountName?: null | string;
            /** @description Why the last post attempt failed, as reported by the accounting platform. */
            postFailureReason?: null | string;
            /**
             * Format: int32
             * @description How many times Dolfin has tried to send the expense to the accounting platform. A failed post can be retried; after 3 failures the platform is likely to keep refusing it until the reason is fixed.
             */
            postAttemptCount?: number | string;
            /** @description The coding: which accounts and tax codes this expense posts against. */
            lines?: components["schemas"]["ExpenseLineResponse"][];
            /** @description How the account was chosen: None (nothing could, so the expense is flagged), Personal, OrgMapping (the organisation's rule for this merchant category), History (learned from the organisation's own similar expenses that a person coded), ClientMapping, CardDefault, or Human (a person set the lines). */
            codingSource?: components["schemas"]["ExpenseCodingSource"];
            /** @description Whether a person has confirmed this expense's account, by setting its lines, approving it for posting, or accepting a flag. Confirmed expenses are what learned coding learns from. */
            codingConfirmed?: boolean;
            learnedCoding?: null | components["schemas"]["LearnedCodingResponse"];
            cardTransaction?: null | components["schemas"]["CardTransactionResponse"];
            /**
             * Format: date-time
             * @description When the card was used — the date to show and sort spend by. Differs from createdAt for imported history, which is recorded on the day the card was linked.
             */
            transactionDate?: null | string;
            /**
             * Format: date-time
             * @description When the expense was recorded in Dolfin.
             */
            createdAt?: string;
            /**
             * Format: date-time
             * @description When the expense was last updated.
             */
            updatedAt?: string;
        };
        /** @description How the search query was read: the filters applied exactly, and the words ranked by meaning. */
        ExpenseSearchInterpretation: {
            /** @description The words left to match by meaning once dates, amounts and currency are taken out, e.g. "taxis" from "taxis over €50 last month". Null when the query was filters only. */
            text?: null | string;
            /**
             * Format: date
             * @description Earliest spend date included (yyyy-MM-dd), from phrases like "since March" or "last month". Null when the query gives no start.
             */
            from?: null | string;
            /**
             * Format: date
             * @description Latest spend date included (yyyy-MM-dd). Null when the query gives no end.
             */
            to?: null | string;
            /**
             * Format: double
             * @description Smallest amount included, in the expense's own currency, from phrases like "over 50". Null when there is no lower bound.
             */
            amountMin?: null | number | string;
            /**
             * Format: double
             * @description Largest amount included, in the expense's own currency, from phrases like "under 20". Null when there is no upper bound.
             */
            amountMax?: null | number | string;
            /** @description ISO 4217 currency code, only when the query names one or uses its symbol ("€" is EUR, "£" is GBP). Null otherwise. */
            currency?: null | string;
            /** @description True when the query asks for spend still missing a receipt, e.g. "without a receipt". Null otherwise. */
            needsReceipt?: null | boolean;
        };
        /** @description Expenses matching a natural-language search, best match first. */
        ExpenseSearchResponse: {
            /** @description How the query was read: the filters applied exactly, and the words ranked by meaning. */
            interpretation: components["schemas"]["ExpenseSearchInterpretation"];
            /** @description True when results were ranked by meaning as well as by name. False when meaning-based search is not available in this environment, so only merchant names, card descriptors and memos were matched. */
            semanticRanking?: boolean;
            /** @description Matching expenses, best match first; most recent first when the query was filters only. At most `limit` items. */
            data: components["schemas"]["ExpenseResponse"][];
        };
        /**
         * @description Which search signal matched an expense.
         * @enum {unknown}
         */
        ExpenseSearchSignal: "Both" | "Meaning" | "Name" | "Filter";
        /** @description Spend in one bucket of the time series. */
        ExpenseSpendBucket: {
            /**
             * Format: date
             * @description First day of the bucket.
             */
            periodStart?: string;
            /**
             * Format: date
             * @description Last day of the bucket.
             */
            periodEnd?: string;
            /** @description ISO 4217 billing currency. */
            currency: string;
            /**
             * Format: double
             * @description Net spend in the bucket.
             */
            total?: number | string;
            /**
             * Format: int32
             * @description Number of expenses in the bucket.
             */
            expenseCount?: number | string;
        };
        /** @description Spend on one card. */
        ExpenseSpendByCard: {
            /**
             * Format: uuid
             * @description The card connection's id.
             */
            cardConnectionId?: string;
            /** @description The card's display name. */
            displayName?: null | string;
            /** @description Last four digits of the card number. */
            last4?: null | string;
            /** @description ISO 4217 billing currency. */
            currency: string;
            /**
             * Format: double
             * @description Net spend.
             */
            total?: number | string;
            /**
             * Format: int32
             * @description Number of expenses.
             */
            expenseCount?: number | string;
        };
        /** @description Spend at home or abroad. */
        ExpenseSpendByLocation: {
            /** @description Domestic, foreign or unknown. */
            scope?: components["schemas"]["ExpenseSpendLocation"];
            /** @description ISO 4217 billing currency. */
            currency: string;
            /**
             * Format: double
             * @description Net spend.
             */
            total?: number | string;
            /**
             * Format: int32
             * @description Number of expenses.
             */
            expenseCount?: number | string;
        };
        /** @description Spend by one person. */
        ExpenseSpendBySpender: {
            spender?: null | components["schemas"]["ExpenseReportPerson"];
            /** @description ISO 4217 billing currency. */
            currency: string;
            /**
             * Format: double
             * @description Net spend.
             */
            total?: number | string;
            /**
             * Format: int32
             * @description Number of expenses.
             */
            expenseCount?: number | string;
        };
        /** @description Spend in one merchant category family. */
        ExpenseSpendCategory: {
            /** @description The category family. */
            family?: components["schemas"]["ExpenseSpendFamily"];
            /** @description ISO 4217 billing currency. */
            currency: string;
            /**
             * Format: double
             * @description Net spend in the family.
             */
            total?: number | string;
            /**
             * Format: int32
             * @description Number of expenses in the family.
             */
            expenseCount?: number | string;
            /** @description The category labels inside the family, largest first. Labels reflect the organisation's own category mappings. */
            labels?: components["schemas"]["ExpenseSpendCategoryLabel"][];
        };
        /** @description Spend under one category label. */
        ExpenseSpendCategoryLabel: {
            /** @description The category label shown on the expense, e.g. "Travel — Rail". */
            label: string;
            /**
             * Format: double
             * @description Net spend under the label.
             */
            total?: number | string;
            /**
             * Format: int32
             * @description Number of expenses under the label.
             */
            expenseCount?: number | string;
        };
        /**
         * @description The broad kind of spend a merchant category code belongs to.
         * @enum {unknown}
         */
        ExpenseSpendFamily: "Travel" | "Meals" | "Entertainment" | "Motor" | "Office" | "Supplies" | "Telecoms" | "Software" | "Marketing" | "Professional" | "Facilities" | "Logistics" | "Training" | "Financial" | "Insurance" | "Government" | "Uncategorised";
        /**
         * @description Where the card was used, relative to the organisation's own country.
         * @enum {unknown}
         */
        ExpenseSpendLocation: "Domestic" | "Foreign" | "Unknown";
        /** @description Spend at one merchant. */
        ExpenseSpendMerchant: {
            /**
             * Format: uuid
             * @description The normalised merchant's id. Null when the transaction was never matched to a merchant; such rows group by name.
             */
            merchantId?: null | string;
            /** @description The merchant's display name. */
            name: string;
            /** @description URL of the merchant's logo, where known. */
            logoUrl?: null | string;
            /** @description ISO 4217 billing currency. */
            currency: string;
            /**
             * Format: double
             * @description Net spend at the merchant.
             */
            total?: number | string;
            /**
             * Format: int32
             * @description Number of expenses at the merchant.
             */
            expenseCount?: number | string;
            /** @description True when the organisation's first expense at this merchant falls inside the period. */
            isNew?: boolean;
        };
        /** @description Card spend over a period: totals, a time series, the change against the previous period, and breakdowns by category, merchant, spender, card and location. */
        ExpenseSpendReport: {
            /**
             * Format: date
             * @description The date the report was computed for (UTC).
             */
            asOf?: string;
            /** @description The requested period. */
            period?: components["schemas"]["LookbackPeriod"];
            /**
             * Format: date
             * @description First day of the period, inclusive.
             */
            periodStart?: string;
            /**
             * Format: date
             * @description Last day of the period, inclusive.
             */
            periodEnd?: string;
            /** @description Granularity of the buckets. */
            granularity?: components["schemas"]["ExpenseReportGranularity"];
            /** @description The primary currency: the requested one, else the organisation's default. Rows in every currency are still returned. */
            currency: string;
            /** @description True when spend in the period is in more than one currency. */
            mixedCurrency?: boolean;
            /** @description Business spend per currency. Excludes voided and declined transactions and personal spend; refunds are netted. */
            totals?: components["schemas"]["ExpenseSpendTotal"][];
            /** @description Change against the previous period of the same length, per currency. */
            trend?: components["schemas"]["ExpenseSpendTrend"][];
            /** @description Spend per bucket and currency. Every bucket in the period is present, zero-filled. */
            buckets?: components["schemas"]["ExpenseSpendBucket"][];
            /** @description Spend by merchant category family, with the category labels inside each family. */
            byCategory?: components["schemas"]["ExpenseSpendCategory"][];
            /** @description The ten merchants with the most spend in each currency. */
            topMerchants?: components["schemas"]["ExpenseSpendMerchant"][];
            /** @description Merchants the organisation first spent with during the period, per currency. */
            newMerchants?: components["schemas"]["ExpenseNewMerchants"][];
            /** @description The ten people with the most spend in each currency. A row with no user is spend on cards with no holder. */
            bySpender?: components["schemas"]["ExpenseSpendBySpender"][];
            /** @description Spend per card. */
            byCard?: components["schemas"]["ExpenseSpendByCard"][];
            /** @description Spend at merchants in the organisation's country versus abroad. */
            byLocation?: components["schemas"]["ExpenseSpendByLocation"][];
            /** @description Personal spend on company cards, reported separately and never included in the totals above. */
            personal?: components["schemas"]["ExpenseCurrencyAmount"][];
        };
        /** @description Business spend in one currency. */
        ExpenseSpendTotal: {
            /** @description ISO 4217 billing currency. */
            currency: string;
            /**
             * Format: double
             * @description Net spend: purchases less refunds.
             */
            total?: number | string;
            /**
             * Format: int32
             * @description Number of expenses, refunds included.
             */
            expenseCount?: number | string;
            /**
             * Format: double
             * @description Refunds in the period, as a negative amount.
             */
            refundTotal?: number | string;
            /**
             * Format: double
             * @description The part of the total still pending settlement, counted at its authorised amount.
             */
            pendingTotal?: number | string;
        };
        /** @description Change in spend against the previous period of the same length. */
        ExpenseSpendTrend: {
            /** @description ISO 4217 billing currency. */
            currency: string;
            /**
             * Format: date
             * @description First day of the previous period.
             */
            previousPeriodStart?: string;
            /**
             * Format: date
             * @description Last day of the previous period.
             */
            previousPeriodEnd?: string;
            /**
             * Format: double
             * @description Net spend in the previous period.
             */
            previousTotal?: number | string;
            /**
             * Format: double
             * @description This period's total minus the previous period's.
             */
            deltaAmount?: number | string;
            /**
             * Format: double
             * @description The change as a fraction of the previous total (0.12 = 12%). Null when the previous total is zero.
             */
            deltaPercent?: null | number | string;
            /** @description Up, down or flat. */
            direction?: components["schemas"]["ExpenseTrendDirection"];
        };
        /** @enum {unknown} */
        ExpenseState: "Captured" | "Coded" | "PendingReview" | "Posting" | "Posted" | "Flagged" | "PostFailed";
        /** @description Expenses in one state. */
        ExpenseStateCount: {
            /** @description The expense state. */
            state?: components["schemas"]["ExpenseState"];
            /**
             * Format: int32
             * @description Number of expenses.
             */
            count?: number | string;
            /** @description Their value, per currency. */
            byCurrency?: components["schemas"]["ExpenseCurrencyAmount"][];
        };
        /** @description Business spend in the period still missing a receipt. */
        ExpenseSummaryMissingReceipts: {
            /**
             * Format: int32
             * @description Number of business expenses in the period with no receipt.
             */
            count?: number | string;
            /** @description Their value, per currency. */
            amountByCurrency?: components["schemas"]["ExpenseCurrencyAmount"][];
            /** @description The three people with the most expenses missing a receipt. */
            topSpenders?: components["schemas"]["ExpenseMissingReceiptsBySpender"][];
        };
        /** @description A one-call briefing on card expenses: what was spent in the period, and what is waiting on someone now. */
        ExpenseSummaryResponse: {
            /**
             * Format: date
             * @description The date the summary was computed for (UTC).
             */
            asOf?: string;
            /** @description The requested period. */
            period?: components["schemas"]["LookbackPeriod"];
            /**
             * Format: date
             * @description First day of the period, inclusive.
             */
            periodStart?: string;
            /**
             * Format: date
             * @description Last day of the period, inclusive.
             */
            periodEnd?: string;
            /** @description The primary currency: the requested one, else the organisation's default. */
            currency: string;
            /** @description True when spend in the period is in more than one currency. */
            mixedCurrency?: boolean;
            /** @description Spend totals and trend for the period. */
            spend: components["schemas"]["ExpenseSummarySpend"];
            /** @description Expenses waiting for approval, the longest waiting first, with whether each is waiting on the caller. */
            approvals: components["schemas"]["ExpenseQueueSummary"];
            /** @description Expenses with an open flag, by reason and oldest first. */
            flags: components["schemas"]["ExpenseFlagQueueSummary"];
            /** @description Expenses whose post to the accounting platform failed, oldest attempt first. */
            postFailures: components["schemas"]["ExpenseQueueSummary"];
            /** @description Business spend in the period still missing a receipt. */
            missingReceipts: components["schemas"]["ExpenseSummaryMissingReceipts"];
        };
        /** @description Spend in the period, per currency. */
        ExpenseSummarySpend: {
            /** @description Business spend per currency, as in the spend report. */
            totals?: components["schemas"]["ExpenseSpendTotal"][];
            /** @description Change against the previous period of the same length, per currency. */
            trend?: components["schemas"]["ExpenseSpendTrend"][];
        };
        /** @description Time from an expense first waiting for approval to its approval, in hours. */
        ExpenseTimeToApprove: {
            /**
             * Format: int32
             * @description Approvals given during the period.
             */
            reviewedCount?: number | string;
            /**
             * Format: double
             * @description Median hours to approve. Null when nothing was approved.
             */
            medianHours?: null | number | string;
            /**
             * Format: double
             * @description Mean hours to approve. Null when nothing was approved.
             */
            averageHours?: null | number | string;
            /**
             * Format: double
             * @description 90th-percentile hours to approve. Null when nothing was approved.
             */
            p90Hours?: null | number | string;
        };
        /**
         * @description Direction of change against the previous period. Flat means a change under 2%.
         * @enum {unknown}
         */
        ExpenseTrendDirection: "Up" | "Down" | "Flat";
        /** @description An estimate of VAT lost to missing receipts. */
        ExpenseVatAtRiskEstimate: {
            /**
             * Format: double
             * @description The standard VAT rate used, as a fraction (0.20 = 20%).
             */
            rate?: number | string;
            /** @description The organisation's country, ISO 3166-1 alpha-2. */
            country: string;
            /** @description Estimated VAT per currency: gross spend × rate ÷ (1 + rate). */
            amounts?: components["schemas"]["ExpenseCurrencyAmount"][];
        };
        /** @description Spend whose VAT is blocked for one reason, in one currency. */
        ExpenseVatBlocked: {
            /** @description Why the VAT cannot be reclaimed. */
            reason?: components["schemas"]["VatReclaimBlockedReason"];
            /** @description ISO 4217 billing currency. */
            currency: string;
            /**
             * Format: double
             * @description Gross spend on the blocked lines.
             */
            grossSpend?: number | string;
            /**
             * Format: double
             * @description VAT recorded on those lines, where a receipt itemised it. Null when none was recorded (for example when there is no receipt).
             */
            knownVatAmount?: null | number | string;
            /**
             * Format: int32
             * @description Number of expenses with a line blocked for this reason.
             */
            expenseCount?: number | string;
        };
        /** @description VAT on card spend over a period: what can be reclaimed, what cannot and why, and an estimate of VAT lost to missing receipts. */
        ExpenseVatReport: {
            /**
             * Format: date
             * @description The date the report was computed for (UTC).
             */
            asOf?: string;
            /** @description The requested period. */
            period?: components["schemas"]["LookbackPeriod"];
            /**
             * Format: date
             * @description First day of the period, inclusive.
             */
            periodStart?: string;
            /**
             * Format: date
             * @description Last day of the period, inclusive.
             */
            periodEnd?: string;
            /** @description The primary currency: the requested one, else the organisation's default. */
            currency: string;
            /** @description True when spend in the period is in more than one currency. */
            mixedCurrency?: boolean;
            /** @description Reclaimable VAT per billing currency, from expense lines eligible for reclaim. */
            reclaimable?: components["schemas"]["ExpenseCurrencyAmount"][];
            /** @description Spend whose VAT cannot be reclaimed, by reason and currency. */
            blocked?: components["schemas"]["ExpenseVatBlocked"][];
            estimatedVatAtRisk?: null | components["schemas"]["ExpenseVatAtRiskEstimate"];
        };
        ExtendDemoAdminRequest: {
            /**
             * Format: int32
             * @description Days to add to the demo's expiry, 1 to 365. Counted from now when the demo has already expired.
             */
            days?: number | string;
        };
        ExtractedContractLineItem: {
            /** @description The product or service billed each occurrence, exactly as named on the contract. */
            productName?: null | string;
            /**
             * Format: double
             * @description Units billed each occurrence.
             */
            quantity?: null | number | string;
            /**
             * Format: double
             * @description Fixed price billed EACH occurrence if the contract states one; null bills the product's standard price. If the contract gives only a total like "£30,000 over 12 months", divide to a per-occurrence amount only when unambiguous — otherwise leave this null and record the total in sourceQuotes.
             */
            unitPriceOverride?: null | number | string;
            /** @description Name of the applicable tax rate, e.g. "Standard"; null if no tax applies. */
            taxRateName?: null | string;
        };
        ExtractedContractTerms: {
            /** @description The party being billed, exactly as named on the contract. */
            customerName?: null | string;
            /** @description Billing contact email if the contract states one; helps disambiguate the customer. */
            customerEmail?: null | string;
            /** @description Billing currency as an ISO 4217 code, e.g. "GBP", "USD", "EUR". Null if the contract is silent. */
            currency?: null | string;
            /** @description Short free-text note for each generated invoice, e.g. the contract or PO reference. */
            memo?: null | string;
            /**
             * Format: date-time
             * @description Date of the first invoice, as an ISO 8601 calendar date (YYYY-MM-DD).
             */
            startDate?: null | string;
            cadence?: null | components["schemas"]["RecurrenceCadence"];
            /**
             * Format: int32
             * @description Total number of invoices to generate, e.g. 12 for a 12-month contract. Null if open-ended.
             */
            totalOccurrences?: null | number | string;
            /** @description One entry per recurring charge on the contract. */
            lineItems?: components["schemas"]["ExtractedContractLineItem"][];
            /** @description Per-field provenance, keyed by field name: the exact contract text each value came from. */
            sourceQuotes?: {
                [key: string]: string;
            };
            /** @description Per-field confidence 0-1, keyed by field name: your confidence in each value you filled. */
            confidence?: {
                [key: string]: number | string;
            };
            missingFields?: string[];
        };
        /** @enum {unknown} */
        FieldRequirement: "Hidden" | "Optional" | "Required";
        /** @description Finalises a policy document sent to a signed upload URL. */
        FinaliseExpensePolicyDocumentUploadRequest: {
            /** @description The `objectName` returned with the upload URL. */
            objectName?: string;
            /** @description Original file name including extension. */
            fileName?: string;
        };
        GetUserOrganisationResponse: {
            /** Format: uuid */
            organisationId?: string;
            role: components["schemas"]["OrganisationRole"];
            /** Format: date-time */
            joinedAt?: string;
        };
        GetUserResponse: {
            /** Format: uuid */
            id?: string;
            email: string;
            name?: null | string;
            /** Format: date-time */
            createdAt?: string;
            organisations?: components["schemas"]["GetUserOrganisationResponse"][];
        };
        /** @enum {unknown} */
        GmailAuditLogEventType: "ConnectionCreated" | "ConnectionRevoked" | "ReauthRequired" | "CandidateDetected" | "CandidateImported";
        GmailAuditLogResponse: {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            organisationId: string;
            /** Format: uuid */
            gmailConnectionId?: null | string;
            /** Format: uuid */
            gmailCandidateId?: null | string;
            eventType: components["schemas"]["GmailAuditLogEventType"];
            /** Format: uuid */
            actorUserId?: null | string;
            metadata: string;
            /** Format: uuid */
            billId?: null | string;
            /** Format: date-time */
            createdAt: string;
        };
        GmailCandidateResponse: {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            gmailConnectionId: string;
            /** Format: date-time */
            messageInternalDate: string;
            senderEmail?: null | string;
            subject?: null | string;
            fileName: string;
            contentType: string;
            /** Format: int64 */
            fileSizeBytes: number | string;
            /** Format: float */
            classifierConfidence: number | string;
            classifierReason?: null | string;
            state: components["schemas"]["GmailIngestedAttachmentState"];
            /** Format: uuid */
            billId?: null | string;
            /** Format: date-time */
            createdAt: string;
        };
        /** @enum {unknown} */
        GmailCandidateStateFilter: "Candidate" | "Imported" | "Dismissed" | "Failed" | "Filtered" | "All";
        GmailConnectionAdminListItem: {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            organisationId: string;
            emailAddress: string;
            status: components["schemas"]["GmailConnectionStatus"];
            /** Format: date-time */
            lastSyncedAt?: null | string;
            /** Format: date-time */
            accessTokenExpiresAt?: null | string;
            accessTokenExpired: boolean;
            hasRefreshToken: boolean;
            /** Format: date-time */
            watchExpiresAt?: null | string;
            watchExpired: boolean;
            /** Format: date-time */
            createdAt: string;
        };
        GmailConnectionAdminResponse: {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            organisationId: string;
            emailAddress: string;
            googleSubject: string;
            status: components["schemas"]["GmailConnectionStatus"];
            /** Format: uint64 */
            lastHistoryId?: null | number | string;
            /** Format: date-time */
            lastSyncedAt?: null | string;
            /** Format: int64 */
            secondsSinceLastSync?: null | number | string;
            /** Format: date-time */
            accessTokenExpiresAt?: null | string;
            accessTokenExpired: boolean;
            hasRefreshToken: boolean;
            refreshTokenSecretRef?: null | string;
            /** Format: date-time */
            watchExpiresAt?: null | string;
            watchExpired: boolean;
            /** Format: date-time */
            backfilledSince?: null | string;
            /** Format: date-time */
            backfilledUntil?: null | string;
            attachmentCounts: components["schemas"]["GmailIngestedAttachmentCounts"];
            datadogTracesUrl: string;
            /** Format: date-time */
            createdAt: string;
            /** Format: uuid */
            createdBy?: null | string;
            /** Format: date-time */
            updatedAt: string;
            /** Format: uuid */
            updatedBy?: null | string;
        };
        GmailConnectionResponse: {
            /** Format: uuid */
            id: string;
            emailAddress: string;
            status: components["schemas"]["GmailConnectionStatus"];
            /** Format: date-time */
            lastSyncedAt?: null | string;
            /** Format: date-time */
            backfilledSince?: null | string;
            /** Format: date-time */
            backfilledUntil?: null | string;
            /** Format: date-time */
            createdAt: string;
        };
        /** @enum {unknown} */
        GmailConnectionStatus: "Connected" | "NeedsReauth" | "Revoked" | "Backfilling" | "Pending";
        GmailIngestedAttachmentCounts: {
            /** Format: int32 */
            candidate: number | string;
            /** Format: int32 */
            imported: number | string;
            /** Format: int32 */
            filtered: number | string;
            /** Format: int32 */
            failed: number | string;
            /** Format: int32 */
            dismissed: number | string;
            /** Format: int32 */
            failedLast24h: number | string;
        };
        /** @enum {unknown} */
        GmailIngestedAttachmentState: "Candidate" | "Imported" | "Filtered" | "Failed" | "Dismissed";
        HiddenClientSettingsResponse: {
            /** @description How inbound bill documents are extracted into structured fields: 'Ocr' (Google Document AI) or 'Llm' (vision extraction, which falls back to OCR on failure). Applies to every organisation under the client. Default 'Ocr'. */
            billExtractionMode: components["schemas"]["BillExtractionMode"];
            /** @description Which LLM performs extraction when the mode is 'Llm': 'GeminiFlash' (default), 'ClaudeSonnet', or 'ClaudeHaiku'. Ignored when the mode is 'Ocr'. */
            billExtractionModel: components["schemas"]["BillExtractionModel"];
        };
        HttpValidationProblemDetails: {
            type?: null | string;
            title?: null | string;
            /** Format: int32 */
            status?: null | number | string;
            detail?: null | string;
            instance?: null | string;
            errors?: {
                [key: string]: string[];
            };
        };
        /** Format: binary */
        IFormFile: string;
        ImportCandidatesRequest: {
            candidateIds?: string[];
        };
        ImportStartedResponse: {
            /** Format: uuid */
            jobId: string;
            candidateIds: string[];
        };
        InboundEmailAddressResponse: {
            address: string;
        };
        InboundEmailAttachmentResponse: {
            /** Format: uuid */
            id: string;
            /** @description The attachment's file name as the sender's mail client wrote it. */
            fileName: string;
            /** @description The content type the sender declared. Mail gateways frequently send a perfectly ordinary PDF as 'application/octet-stream'. */
            declaredContentType: string;
            /** @description The content type we resolved it to, falling back to the file extension when the declared type is generic. Null when the file is not a document we accept. */
            resolvedContentType: null | string;
            /**
             * Format: int64
             * @description Size in bytes as reported by the sender.
             */
            sizeBytes: number | string;
            /** @description Whether this attachment became a bill. */
            ingested: boolean;
            skipReason: null | components["schemas"]["InboundEmailAttachmentSkipReason"];
            /**
             * Format: uuid
             * @description The bill created from this attachment, when it went straight to an organisation.
             */
            billId: null | string;
            /**
             * Format: uuid
             * @description The company inbox bill created from this attachment, when it is waiting to be routed to a site.
             */
            companyInboxBillId: null | string;
        };
        /** @enum {unknown} */
        InboundEmailAttachmentSkipReason: "InlineImage" | "UnsupportedFileType" | "FileTooLarge" | "InvalidContent" | "UploadFailed" | null;
        /** @enum {unknown} */
        InboundEmailRejectionReason: "SenderNotAllowed" | "AuthenticationFailed" | "TokenNotResolved" | "TenantNotFound" | null;
        InboundEmailResponse: {
            /** Format: uuid */
            id: string;
            /** @description The sending mail provider's unique id for this message. Quote it when asking us to trace an email. */
            messageId: string;
            /** @description Who the email came from. Shown for identification only, and not something we trust. */
            fromAddress: string;
            fromDomain: string;
            /** @description The email's subject line. */
            subject: null | string;
            /** @description The forwarding address the email actually reached. */
            toAddress: null | string;
            /**
             * Format: date-time
             * @description When the email arrived.
             */
            receivedAt: string;
            /** @description What became of the email: Ingested (every document became a bill), PartiallyIngested (some did not), NoBillAttachments (nothing on it could be read as a bill), Rejected (refused before we looked at the attachments), Failed, or Received (still being processed). */
            status: components["schemas"]["InboundEmailStatus"];
            rejectionReason: null | components["schemas"]["InboundEmailRejectionReason"];
            /**
             * Format: int32
             * @description Everything attached to the email, including signature images and files we cannot read.
             */
            attachmentCount: number | string;
            /**
             * Format: int32
             * @description How many of those attachments became bills. Zero against a non-zero AttachmentCount is the case worth looking at.
             */
            ingestedCount: number | string;
            /** @description Overall email-auth (DKIM/DMARC) verdict for the sender: Pass, Fail or Unknown. */
            authResult: components["schemas"]["EmailAuthResult"];
            /** @description Aligned-DKIM check: Pass, Fail or Unknown. Render as a per-check tick or cross. */
            dkimResult: components["schemas"]["EmailAuthResult"];
            /** @description Aligned-SPF check: Pass, Fail or Unknown. Render as a per-check tick or cross. */
            spfResult: components["schemas"]["EmailAuthResult"];
            /** @description Each attachment, whether or not it was taken, with the reason it was skipped. The attachment bytes themselves are not stored. */
            attachments: components["schemas"]["InboundEmailAttachmentResponse"][];
        };
        /** @enum {unknown} */
        InboundEmailStatus: "Received" | "Ingested" | "PartiallyIngested" | "NoBillAttachments" | "Rejected" | "Failed";
        InboxRoutingCompanyRow: {
            /** Format: uuid */
            clientId: string;
            clientName: string;
            clientType: components["schemas"]["ClientType"];
            /** Format: uuid */
            companyId: string;
            companyName: string;
            routed: components["schemas"]["InboxRoutingRouted"];
            unrouted: components["schemas"]["InboxRoutingUnrouted"];
            /** Format: double */
            manualShareOfAssigned: null | number | string;
            /** Format: double */
            nonAutoShareOfArrivals: null | number | string;
            lag: components["schemas"]["InboxRoutingLag"];
        };
        InboxRoutingLag: {
            /** Format: int32 */
            coveredRows: number | string;
            /** Format: int32 */
            totalRoutedRows: number | string;
            /** Format: int32 */
            thresholdSeconds: number | string;
            /** Format: int32 */
            withinThresholdCount: number | string;
            /** Format: int32 */
            overThresholdCount: number | string;
            /** Format: double */
            timedManualShare: null | number | string;
            /** Format: int32 */
            disagreementCount: number | string;
        };
        InboxRoutingRouted: {
            /** Format: int32 */
            auto: number | string;
            /** Format: int32 */
            manual: number | string;
            /** Format: int32 */
            total: number | string;
            /** Format: int32 */
            manualMatchingSuggestion: number | string;
            /** Format: int32 */
            manualAgainstSuggestion: number | string;
            /** Format: int32 */
            manualNoSuggestion: number | string;
        };
        InboxRoutingUnrouted: {
            /** Format: int32 */
            awaitingOrganisation: number | string;
            /** Format: int32 */
            extracting: number | string;
            /** Format: int32 */
            extractionFailed: number | string;
            /** Format: int32 */
            discarded: number | string;
            /** Format: int32 */
            total: number | string;
            byOutcome: {
                [key: string]: number | string;
            };
            /** Format: date-time */
            oldestWaitingSince: null | string;
        };
        IndustryResponse: {
            /** Format: uuid */
            id?: string;
            /** @description 4-digit ISO 18245 MCC */
            code: string;
            displayName: string;
            /** @description Stripe snake_case category slug (e.g. "veterinary_services") */
            slug: string;
            group?: components["schemas"]["MerchantCategoryGroup"];
        };
        InitiateBillBankPaymentRequest: {
            /** @description Yapily institution id the payer banks with, from the bank-payments institutions list (e.g. 'starling-sandbox'). */
            institutionId: string;
            /** @description Absolute URL the payer is sent back to after authorising at their bank. Host must be on the client's payment redirect allowlist. */
            returnUrl: string;
            /**
             * Format: double
             * @description Amount to pay, in the bill's currency. Greater than zero, at most the outstanding amount, at most 2 decimal places. Omit to pay everything outstanding.
             */
            amount?: null | number | string;
            /** @description Your key for this payment, 1 to 64 characters (for example a UUID). Sending the same key again returns the original attempt instead of starting another, so a retry never pays twice. Use a new key for each new payment. */
            idempotencyKey?: null | string;
            /** @description Set to true to pay the same amount as a payment for this bill that completed in the last 24 hours. Without it that payment is refused as a possible duplicate. */
            allowDuplicate?: null | boolean;
            /**
             * Format: uuid
             * @description For a EUR bill at a bank whose payerAccountRequired is true: id of the organisation's connected bank account to pay from. It must be in the bill's currency and held at the chosen bank. Ignored when the bank doesn't need the paying account.
             */
            payerBankAccountId?: null | string;
            /** @description For a EUR bill at a bank whose payerAccountRequired is true, when no connected account is used: the IBAN of the account to pay from. */
            payerIban?: null | string;
            /** @description Name on the paying account. Defaults to the organisation's legal name. */
            payerName?: null | string;
        };
        InitiateBillBankPaymentResponse: {
            /** Format: uuid */
            billPaymentId: string;
            authorisationUrl: string;
            /** Format: date-time */
            expiresAt: string;
            disclosure: components["schemas"]["YapilyDisclosure"];
        };
        InitiateGmailConnectionRequest: {
            returnUrl: string;
        };
        InitiateGmailConnectionResponse: {
            authUrl: string;
            state: string;
            /** Format: uuid */
            connectionId: string;
        };
        InvoiceActivityResponse: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            invoiceId?: string;
            /** Format: uuid */
            actorId?: null | string;
            actorType?: components["schemas"]["ActorType"];
            fromState?: null | components["schemas"]["InvoiceState"];
            toState?: null | components["schemas"]["InvoiceState"];
            action?: components["schemas"]["InvoiceEventType"];
            /** Format: date-time */
            createdAt?: string;
            documentNumber: string;
            /** Format: uuid */
            customerId?: string;
            customerName: string;
            /** Format: double */
            totalAmount?: number | string;
            currency: string;
        };
        InvoiceAuditLogResponse: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            invoiceId?: string;
            /** Format: uuid */
            organisationId?: string;
            /** Format: uuid */
            actorId?: null | string;
            actorType?: components["schemas"]["ActorType"];
            fromState?: null | components["schemas"]["InvoiceState"];
            toState?: null | components["schemas"]["InvoiceState"];
            action?: components["schemas"]["InvoiceEventType"];
            /** Format: date-time */
            createdAt?: string;
        };
        /**
         * @description A delivery channel of an invoice.
         * @enum {unknown}
         */
        InvoiceDeliveryChannel: "EInvoice" | "Email";
        /** @description One channel of an invoice's delivery and where it stands. */
        InvoiceDeliveryResponse: {
            /** @description The channel: EInvoice (the electronic document over the network) or Email (the PDF copy). */
            channel?: components["schemas"]["InvoiceDeliveryChannel"];
            /** @description Where the channel stands. EInvoice: Pending (not sent yet), InFlight (with the network, verdict to come), Delivered, MadeAvailable (issued and held for the recipient), Failed. Email: Pending (waiting for the network, or queued), Sent, Failed, NotSentDemo (a demo organisation: recorded, never sent). */
            status?: components["schemas"]["InvoiceDeliveryStatus"];
            network?: null | components["schemas"]["EInvoicingNetwork"];
            /** @description Where it goes: the network address (EInvoice) or the email address (Email). */
            to?: null | string;
            /** @description For a Failed e-invoice: whether POST /invoices/{id}/e-invoice/resend can send it again. Null for email. */
            canResend?: null | boolean;
            /** @description Why it failed, in words that can be shown to the user. Null unless Failed. */
            failureReason?: null | string;
            /**
             * Format: date-time
             * @description When the channel last changed: sent, delivered or failed.
             */
            at?: null | string;
        };
        /**
         * @description Where a delivery channel stands.
         * @enum {unknown}
         */
        InvoiceDeliveryStatus: "Pending" | "InFlight" | "Delivered" | "MadeAvailable" | "Sent" | "Failed" | "NotSentDemo";
        /**
         * @description Whether this send goes over the e-invoicing network. Auto: whenever the customer can be reached there. Skip: email only, where the law allows it.
         * @enum {unknown}
         */
        InvoiceEInvoiceChoice: "Auto" | "Skip" | null;
        /**
         * @description When this send's PDF copy email goes out. AfterNetwork: once the network confirms delivery (or now, when not e-invoiced). Now: immediately. Skip: no email.
         * @enum {unknown}
         */
        InvoiceEmailChoice: "AfterNetwork" | "Now" | "Skip";
        InvoiceEmailContentResponse: {
            /** Format: uuid */
            emailId: string;
            /** Format: uuid */
            invoiceId: string;
            recipient: string;
            cc: string[];
            status: string;
            /** Format: date-time */
            sentAt: null | string;
            contentAvailable: boolean;
            subject: null | string;
            htmlBody: null | string;
            textBody: null | string;
            contentUnavailableReason: null | string;
        };
        /** @enum {unknown} */
        InvoiceEmailMessageKind: "Invoice" | "Reminder";
        InvoiceEmailPreviewResponse: {
            subject: string;
            previewText: string;
            greetingLine: string;
            openingBodyMarkdown: string;
            openingBodyHtml: string;
            htmlBody: string;
            textBody: string;
            cc: string[];
            replyTo: null | string;
        };
        InvoiceEmailResponse: {
            /** Format: uuid */
            id: string;
            recipient: string;
            status: string;
            /** Format: uuid */
            messageId: null | string;
            /** Format: date-time */
            createdAt: string;
            /** Format: date-time */
            sentAt: null | string;
            /** Format: date-time */
            deliveredAt: null | string;
            /** Format: date-time */
            bouncedAt: null | string;
            /** Format: date-time */
            spamComplaintAt: null | string;
            bounceType: null | string;
            bounceDescription: null | string;
        };
        /** @enum {unknown} */
        InvoiceEmailStatus: "Queued" | "Sent" | "Delivered" | "Bounced" | "SpamComplaint" | "Failed" | "Inactive" | null;
        /** @enum {unknown} */
        InvoiceEmailTemplate: "Classic" | "Minimal" | "Branded";
        /** @enum {unknown} */
        InvoiceEventType: "InvoiceCreated" | "InvoiceStateChanged" | "InvoiceSent" | "InvoicePaid" | "InvoiceVoided" | "InvoiceReminderSent" | "InvoiceReminderFailed" | "CreditNoteIssued" | "InvoiceFieldsUpdated" | "InvoiceIssued";
        InvoiceLineItemResponse: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            productId?: string;
            productName?: null | string;
            /** Format: uuid */
            taxRateId?: null | string;
            taxRateSnapshot?: null | components["schemas"]["TaxRateSnapshotResponse"];
            description: string;
            /** Format: double */
            quantity?: number | string;
            /** Format: double */
            unitPrice?: number | string;
            /**
             * Format: double
             * @description Tax charged on TaxableAmount, i.e. after this line's discount and its share of any invoice-level discount.
             */
            taxAmount?: number | string;
            /**
             * Format: double
             * @description This line before any discount: quantity x unit price.
             */
            subTotal?: number | string;
            /** @description How DiscountValue is interpreted for this line. */
            discountType?: components["schemas"]["DiscountType"];
            /**
             * Format: double
             * @description The line discount as it was entered: a percentage (0-100) or a cash amount, per DiscountType. Null when the line has no discount.
             */
            discountValue?: null | number | string;
            /**
             * Format: double
             * @description The line discount resolved to a cash amount in the invoice currency.
             */
            discountAmount?: number | string;
            /**
             * Format: double
             * @description This line's share of the invoice-level discount, apportioned across the lines in proportion to their value after their own discounts.
             */
            allocatedInvoiceDiscount?: number | string;
            /**
             * Format: double
             * @description The amount tax is charged on: SubTotal - DiscountAmount - AllocatedInvoiceDiscount.
             */
            taxableAmount?: number | string;
        };
        InvoicePaymentResponse: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            invoiceId?: string;
            /** Format: uuid */
            organisationId?: string;
            accountingSync?: null | components["schemas"]["AccountingDocumentSyncResponse"];
            /** Format: double */
            amount?: number | string;
            currency: string;
            status: string;
            provider?: components["schemas"]["PaymentProvider"];
            providerReference: string;
            chargeReference?: null | string;
            /** Format: double */
            applicationFeeAmount?: number | string;
            notes?: null | string;
            /** @description Reference entered with a manual payment, such as a cheque number or bank reference. Null for card payments. */
            reference?: null | string;
            receiptUrl?: null | string;
            receiptEmail?: null | string;
            paymentMethod?: null | components["schemas"]["PaymentMethodDetailsResponse"];
            billing?: null | components["schemas"]["PaymentBillingDetailsResponse"];
            risk?: null | components["schemas"]["PaymentRiskResponse"];
            /** Format: date-time */
            succeededAt?: null | string;
            /** Format: date-time */
            createdAt?: string;
        };
        /** @description Which optional fields appear on every invoice PDF the client's organisations produce. Each flag only hides a field the PDF would otherwise print; a field that has no value is never printed. The sender name, customer name, invoice number, dates, line items, totals and payment reference always appear. */
        InvoicePdfDisplayOptions: {
            /** @description Show the organisation's logo. Default true. */
            showLogo?: boolean;
            /** @description Show the organisation's contact email. Default true. */
            showSenderEmail?: boolean;
            /** @description Show the organisation's phone number (Classic and Branded layouts). Default true. */
            showSenderPhone?: boolean;
            /** @description Show the organisation's website (Classic and Branded layouts). Default true. */
            showSenderWebsite?: boolean;
            /** @description Show the organisation's tax (VAT) number. VAT invoices may be required to show it. Default true. */
            showSenderTaxNumber?: boolean;
            /** @description Show the organisation's company registration number. Default true. */
            showSenderRegistrationNumber?: boolean;
            /** @description Show the organisation's first address line. Default true. */
            showSenderAddressLine1?: boolean;
            /** @description Show the organisation's second address line. Default true. */
            showSenderAddressLine2?: boolean;
            /** @description Show the organisation's town or city. Default true. */
            showSenderCity?: boolean;
            /** @description Show the organisation's state, county or region. Default false. */
            showSenderState?: boolean;
            /** @description Show the organisation's postcode. Default true. */
            showSenderPostalCode?: boolean;
            /** @description Show the organisation's country. Default false. */
            showSenderCountry?: boolean;
            /** @description Show the customer's first address line. VAT invoices may be required to show the address. Default true. */
            showCustomerAddressLine1?: boolean;
            /** @description Show the customer's second address line. Default true. */
            showCustomerAddressLine2?: boolean;
            /** @description Show the customer's town or city. Default true. */
            showCustomerCity?: boolean;
            /** @description Show the customer's state, county or region. Default false. */
            showCustomerState?: boolean;
            /** @description Show the customer's postcode. Default true. */
            showCustomerPostalCode?: boolean;
            /** @description Show the customer's country. Default false. */
            showCustomerCountry?: boolean;
            /** @description Show the customer's tax (VAT) number. Default true. */
            showCustomerTaxNumber?: boolean;
            /** @description Show the invoice notes (memo). Default true. */
            showNotes?: boolean;
            /** @description Show the bank account holder name in Payment Details. Default true. */
            showBankAccountName?: boolean;
            /** @description Show the UK sort code in Payment Details. Default true. */
            showSortCode?: boolean;
            /** @description Show the US routing number in Payment Details. Default true. */
            showRoutingNumber?: boolean;
            /** @description Show the domestic account number in Payment Details. Default true. */
            showAccountNumber?: boolean;
            /** @description Show the IBAN in Payment Details. Default true. */
            showIban?: boolean;
            /** @description Show the BIC/SWIFT code in Payment Details. Default true. */
            showBicSwift?: boolean;
            /** @description Show the scan-to-pay QR code and payment link. Default true. */
            showPaymentQrCode?: boolean;
        };
        /** @enum {unknown} */
        InvoicePdfTemplate: "Classic" | "Minimal" | "Branded";
        /** @enum {unknown} */
        InvoiceReminderOffset: "OneWeekBefore" | "TwoDaysBefore" | "OnDueDate" | "TwoDaysAfter" | "OneWeekAfter";
        InvoiceReminderResponse: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            invoiceId?: string;
            offset?: null | components["schemas"]["InvoiceReminderOffset"];
            /** Format: date-time */
            scheduledAt?: string;
            status?: components["schemas"]["InvoiceReminderStatus"];
            subject?: null | string;
            body?: null | string;
            /** Format: date-time */
            createdAt?: string;
            /** Format: date-time */
            updatedAt?: string;
            /** Format: date-time */
            sentAt?: null | string;
            /** Format: date-time */
            cancelledAt?: null | string;
            failureReason?: null | string;
        };
        /** @enum {unknown} */
        InvoiceReminderStatus: "Pending" | "Sent" | "Cancelled" | "Failed";
        InvoiceResponse: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            organisationId?: string;
            /** Format: uuid */
            customerId?: string;
            documentNumber?: null | string;
            /** @description ISO 4217 currency code (e.g. GBP, USD, EUR) */
            currency: string;
            /** Format: date-time */
            issueDate?: string;
            /** Format: date-time */
            dueDate?: null | string;
            status?: components["schemas"]["InvoiceState"];
            /**
             * Format: double
             * @description Total of the line items before any discount: the sum of each line's quantity x unit price.
             */
            subTotal?: number | string;
            /** @description How DiscountValue is interpreted for the invoice-level discount. */
            discountType?: components["schemas"]["DiscountType"];
            /**
             * Format: double
             * @description The invoice-level discount as it was entered: a percentage (0-100) or a cash amount, per DiscountType. Null when there is no invoice-level discount.
             */
            discountValue?: null | number | string;
            /**
             * Format: double
             * @description The invoice-level discount resolved to a cash amount in the invoice currency.
             */
            discountAmount?: number | string;
            /**
             * Format: double
             * @description Total of the per-line discounts, in the invoice currency.
             */
            lineDiscountTotal?: number | string;
            /**
             * Format: double
             * @description Every discount on this invoice: LineDiscountTotal + DiscountAmount.
             */
            discountTotal?: number | string;
            earlyPaymentDiscount?: null | components["schemas"]["EarlyPaymentDiscountResponse"];
            /**
             * Format: double
             * @description Tax charged on the discounted amounts, not on SubTotal: an invoice-level discount is apportioned across the lines before tax.
             */
            taxAmount?: number | string;
            /**
             * Format: double
             * @description The amount due: SubTotal - DiscountTotal + TaxAmount.
             */
            totalAmount?: number | string;
            /**
             * Format: double
             * @description Total payments received against this invoice.
             */
            amountPaid?: number | string;
            /**
             * Format: double
             * @description Total of issued credit notes applied to this invoice.
             */
            amountCredited?: number | string;
            /**
             * Format: double
             * @description Remaining balance: TotalAmount - payments received - issued credit notes. Negative when the invoice is overpaid.
             */
            outstanding?: number | string;
            /**
             * Format: double
             * @description Money received beyond what was owed, which the organisation owes back to its customer: a card payment that arrived after the invoice was already settled, or for more than its balance. Included in AmountPaid. 0 when nothing was overpaid.
             */
            amountOverpaid?: number | string;
            /**
             * Format: uuid
             * @description Set when this invoice was generated from a recurring schedule; null for hand-made invoices.
             */
            recurringScheduleId?: null | string;
            /** Format: int32 */
            recurringOccurrenceNumber?: null | number | string;
            memo?: null | string;
            /** @description Per-invoice CC recipients. Null means the organisation's default CC list is used; an empty list means no CC. */
            ccEmails?: null | string[];
            /**
             * Format: int32
             * @description Payment terms in days (0-365) snapshotted onto this invoice; the due date is this many days after the issue date. Snapshotted from the organisation default at creation unless overridden. 0 means due on receipt.
             */
            paymentTermsDays?: null | number | string;
            /** @description True when this invoice was sent over its country's e-invoicing network (see GET /invoices/{id}/e-invoice for how that delivery went). Its PDF copy email is sent only once the network confirms delivery. False for invoices sent by email only, and for drafts. */
            deliverAsEInvoice?: boolean;
            /** @description Where the invoice's PDF copy email goes (or went), as chosen when it was sent. Null when no email was planned, for example when the customer has no email address or invoice emails are turned off. */
            pdfCopyTo?: null | string;
            /** @description How the invoice has been delivered, one entry per channel planned when it was sent: its e-invoice over the network and its PDF copy email. Present on GET /invoices/{id}; null in lists and on other responses. Empty for a Draft or an invoice sent nowhere. */
            deliveries?: null | components["schemas"]["InvoiceDeliveryResponse"][];
            accountingSync?: null | components["schemas"]["AccountingDocumentSyncResponse"];
            /** Format: date-time */
            createdAt?: string;
            /** Format: uuid */
            createdBy?: null | string;
            /** Format: date-time */
            updatedAt?: string;
            /** Format: uuid */
            updatedBy?: null | string;
            paymentUrl?: null | string;
            customer?: null | components["schemas"]["CustomerResponse"];
            lineItems?: components["schemas"]["InvoiceLineItemResponse"][];
        };
        /** @enum {unknown} */
        InvoiceSendFix: "Customer" | "Organisation" | "Invoice" | null;
        /** @description What sending this invoice will do: whether it goes over an e-invoicing network, whether a PDF copy is emailed, and any problem that must be fixed before it can be sent. Nothing changes until the invoice is sent. */
        InvoiceSendPlan: {
            eInvoice?: null | components["schemas"]["InvoiceSendPlanEInvoice"];
            email?: null | components["schemas"]["InvoiceSendPlanEmail"];
            whatsApp?: null | components["schemas"]["InvoiceSendPlanWhatsApp"];
            /** @description When the organisation sends e-invoices but this invoice will go by email only, why — for example, a customer abroad with no network address. */
            emailOnlyReason?: null | string;
            /** @description Everything that stops the send. Empty when the invoice can be sent. */
            problems?: components["schemas"]["InvoiceSendProblem"][];
            /** @description True when there are no problems and the invoice can be sent. */
            canSend?: boolean;
        };
        /** @description Where the e-invoicing network will deliver the invoice. */
        InvoiceSendPlanEInvoice: {
            /** @description The network the invoice is sent over. */
            network?: components["schemas"]["EInvoicingNetwork"];
            /** @description The kind of address the network delivers to, for example peppol, it-sdi-code or it-sdi-pec. */
            recipientScheme?: null | string;
            /** @description The customer's address on the network: a Peppol participant id, an SDI recipient code, or a PEC address. */
            recipientAddress?: null | string;
            status?: null | components["schemas"]["OutboundEInvoiceState"];
            /** @description True when the law makes the network the only channel for this invoice, so eInvoice: Skip is refused. */
            required?: boolean;
        };
        /** @description Who the PDF copy email goes to. */
        InvoiceSendPlanEmail: {
            /** @description The customer's email address. */
            to: string;
            /** @description Addresses copied on the email and on its reminders. */
            cc?: string[];
            /** @description When the email goes out: AfterNetwork (once the network confirms delivery, or now when the invoice is not e-invoiced) or Now. */
            timing?: components["schemas"]["InvoiceEmailChoice"];
        };
        /** @description Whether the invoice also goes to the customer on WhatsApp with this send. */
        InvoiceSendPlanWhatsApp: {
            /** @description The customer's WhatsApp number in international format, e.g. +447700900123. Null when they have none. */
            to?: null | string;
            /** @description True when the WhatsApp message goes out with this send. */
            willSend?: boolean;
            /** @description Why it does not go out, in words to show the user, e.g. the customer has not agreed to WhatsApp messages. Null when it does. */
            reason?: null | string;
        };
        /** @description Something that stops the invoice being sent, and where to fix it. */
        InvoiceSendProblem: {
            /** @description The machine-readable error code, as returned by the send endpoint if it were called now. */
            code: string;
            /** @description What is wrong, in words that can be shown to the user. */
            message: string;
            fix?: null | components["schemas"]["InvoiceSendFix"];
        };
        /** @enum {unknown} */
        InvoiceState: "Draft" | "Issued" | "Paid" | "Void" | "PartiallyPaid" | "Credited";
        InvoiceSummary: {
            /** Format: uuid */
            invoiceId?: string;
            invoiceNumber?: null | string;
            /** Format: double */
            totalAmount?: number | string;
            /** Format: double */
            outstanding?: number | string;
            /** Format: date */
            dueDate?: null | string;
            /** Format: int32 */
            daysOverdue?: number | string;
            status: string;
        };
        /** @enum {unknown} */
        InvoiceTone: "Friendly" | "Direct" | "Formal";
        /** @description One WhatsApp message about an invoice. */
        InvoiceWhatsAppMessageResponse: {
            /** Format: uuid */
            id?: string;
            kind?: components["schemas"]["WhatsAppMessageKind"];
            /**
             * Format: uuid
             * @description The reminder this message was for, when it was one.
             */
            invoiceReminderId?: null | string;
            /** @description The number it went (or would have gone) to, international digits without the plus. */
            to?: null | string;
            status?: components["schemas"]["WhatsAppMessageStatus"];
            /** @description Why a Skipped message was not sent (demo, connection_not_connected, module_disabled, event_disabled, no_whatsapp_number, opted_out, no_consent, template_not_approved, no_link), or WhatsApp's error code and message for a Failed one. */
            reason?: null | string;
            /** Format: date-time */
            createdAt?: string;
            /** Format: date-time */
            sentAt?: null | string;
            /** Format: date-time */
            deliveredAt?: null | string;
            /** Format: date-time */
            readAt?: null | string;
            /** Format: date-time */
            failedAt?: null | string;
        };
        /** @description A journal entry with the other entries of its source. */
        JournalEntryDetailResponse: {
            /**
             * Format: uuid
             * @description The entry that reverses this one, if any.
             */
            reversedByEntryId?: null | string;
            /** @description Every entry of the same source document, oldest first, this one included: the reversal chain. */
            sourceEntries?: components["schemas"]["JournalEntrySummary"][];
            /**
             * Format: uuid
             * @description Entry id.
             */
            id?: string;
            /**
             * Format: date
             * @description Accounting date.
             */
            entryDate?: string;
            /**
             * Format: date
             * @description The date the source asked for, when the close date moved the entry later.
             */
            originalDate?: null | string;
            /**
             * Format: date-time
             * @description When it was written.
             */
            postedAt?: string;
            /** @description Kind of source document. */
            sourceType?: components["schemas"]["JournalSourceType"];
            /**
             * Format: uuid
             * @description Id of the source document (the book itself for opening balances, the bank transaction for a bank line).
             */
            sourceId?: string;
            /** @description What happened to the source. */
            sourceEvent?: components["schemas"]["JournalSourceEvent"];
            /**
             * Format: int32
             * @description 0 for a source event's first entry; one more after each re-post.
             */
            revision?: number | string;
            /**
             * Format: uuid
             * @description The entry this one reverses.
             */
            reversesEntryId?: null | string;
            documentType?: null | components["schemas"]["JournalSourceType"];
            /**
             * Format: uuid
             * @description Id of that document (for a bank line, the bank line's id). Null with documentType.
             */
            documentId?: null | string;
            /**
             * Format: uuid
             * @description The bank line matched to this entry's source document (a payment or payout), if any.
             */
            matchedBankLineId?: null | string;
            /** @description Description. */
            description?: string;
            /** @description Lines, in order. Debits equal credits. */
            lines?: components["schemas"]["JournalLineResponse"][];
            /** @description Cash-basis listings only: true when the lines are what this entry released of its document's income, expenses and VAT (a payment's share, pro rata), with the bank side as posted, rather than the lines as posted. */
            released?: boolean;
            /**
             * Format: double
             * @description Listings filtered to one ledger account (and to no source): the account's balance after this entry, as the trial balance counts it, in the account's natural sign (assets and expenses debit positive; liabilities, equity and revenue credit positive). Income and expense accounts restart from zero on each financial year's first day, and retained earnings takes in the year before's result then. Null otherwise.
             */
            runningBalance?: null | number | string;
        };
        /** @description A page of the general ledger. Filtered to one ledger account (and to no source), it carries the account's balance at the start and end of the date range, in the account's natural sign, and each entry its running balance. */
        JournalEntryPage: {
            /**
             * Format: double
             * @description The account's balance at the start of the range, before its first day's entries. On a financial year's first day an income or expense account opens at zero. Null unless filtered to one account and no source.
             */
            openingBalance?: null | number | string;
            /**
             * Format: double
             * @description The account's balance at the end of the range: the trial balance's for its last day (with no end given, the later of today and the last entry), which is the running balance after the range's last entry. Null unless filtered to one account and no source.
             */
            closingBalance?: null | number | string;
            data?: components["schemas"]["JournalEntryResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        /** @description A journal entry. Entries are never edited: corrections are reversals and new revisions. */
        JournalEntryResponse: {
            /**
             * Format: uuid
             * @description Entry id.
             */
            id?: string;
            /**
             * Format: date
             * @description Accounting date.
             */
            entryDate?: string;
            /**
             * Format: date
             * @description The date the source asked for, when the close date moved the entry later.
             */
            originalDate?: null | string;
            /**
             * Format: date-time
             * @description When it was written.
             */
            postedAt?: string;
            /** @description Kind of source document. */
            sourceType?: components["schemas"]["JournalSourceType"];
            /**
             * Format: uuid
             * @description Id of the source document (the book itself for opening balances, the bank transaction for a bank line).
             */
            sourceId?: string;
            /** @description What happened to the source. */
            sourceEvent?: components["schemas"]["JournalSourceEvent"];
            /**
             * Format: int32
             * @description 0 for a source event's first entry; one more after each re-post.
             */
            revision?: number | string;
            /**
             * Format: uuid
             * @description The entry this one reverses.
             */
            reversesEntryId?: null | string;
            documentType?: null | components["schemas"]["JournalSourceType"];
            /**
             * Format: uuid
             * @description Id of that document (for a bank line, the bank line's id). Null with documentType.
             */
            documentId?: null | string;
            /**
             * Format: uuid
             * @description The bank line matched to this entry's source document (a payment or payout), if any.
             */
            matchedBankLineId?: null | string;
            /** @description Description. */
            description?: string;
            /** @description Lines, in order. Debits equal credits. */
            lines?: components["schemas"]["JournalLineResponse"][];
            /** @description Cash-basis listings only: true when the lines are what this entry released of its document's income, expenses and VAT (a payment's share, pro rata), with the bank side as posted, rather than the lines as posted. */
            released?: boolean;
            /**
             * Format: double
             * @description Listings filtered to one ledger account (and to no source): the account's balance after this entry, as the trial balance counts it, in the account's natural sign (assets and expenses debit positive; liabilities, equity and revenue credit positive). Income and expense accounts restart from zero on each financial year's first day, and retained earnings takes in the year before's result then. Null otherwise.
             */
            runningBalance?: null | number | string;
        };
        /** @description An entry in a source's history. */
        JournalEntrySummary: {
            /**
             * Format: uuid
             * @description Entry id.
             */
            id?: string;
            /**
             * Format: date
             * @description Accounting date.
             */
            entryDate?: string;
            /** @description What happened to the source. */
            sourceEvent?: components["schemas"]["JournalSourceEvent"];
            /**
             * Format: int32
             * @description Revision.
             */
            revision?: number | string;
            /**
             * Format: uuid
             * @description The entry it reverses.
             */
            reversesEntryId?: null | string;
        };
        /** @description One side of a journal entry. */
        JournalLineResponse: {
            /**
             * Format: int32
             * @description 1-based position.
             */
            lineNumber?: number | string;
            /**
             * Format: uuid
             * @description Ledger account id.
             */
            ledgerAccountId?: string;
            /** @description Account code, when the platform has codes. */
            accountCode?: null | string;
            /** @description Account name. */
            accountName?: string;
            /**
             * Format: double
             * @description Debit amount, or 0.
             */
            debit?: number | string;
            /**
             * Format: double
             * @description Credit amount, or 0.
             */
            credit?: number | string;
            /**
             * Format: uuid
             * @description Platform tax rate, if any.
             */
            accountingTaxRateId?: null | string;
            /**
             * Format: uuid
             * @description Customer, if any.
             */
            customerId?: null | string;
            /**
             * Format: uuid
             * @description Supplier, if any.
             */
            supplierId?: null | string;
            /** @description Line description. */
            description?: null | string;
        };
        /** @enum {unknown} */
        JournalSourceEvent: "OpeningBalances" | "InvoiceIssued" | "InvoicePaid" | "InvoiceVoided" | "CreditNoteIssued" | "EarlyPaymentDiscount" | "BillApproved" | "BillLineRecoded" | "BillPaid" | "SupplierCreditIssued" | "SupplierCreditApplied" | "SupplierCreditReversed" | "ExpenseCodingSettled" | "BankLineSuspense" | "BankLineCategorised" | "BankLineMatched" | "StripePayoutPaid" | "Manual" | "Reversal";
        /** @enum {unknown} */
        JournalSourceType: "OpeningBalances" | "Invoice" | "InvoicePayment" | "CreditNote" | "Bill" | "SupplierCreditNote" | "Expense" | "BankLine" | "StripePayout" | "Manual" | "BillPayment";
        JsonElement: unknown;
        /** @description A similar expense that a person coded, used as evidence for learned coding. */
        LearnedCodingNeighbourResponse: {
            /**
             * Format: uuid
             * @description The similar expense.
             */
            expenseId?: string;
            /** @description Its merchant name as the card network printed it. */
            merchantName?: null | string;
            /** @description Whether it was spent at the same merchant as the expense being coded. One decision about the same merchant is enough to code the next purchase there; merely similar spend needs several agreeing decisions. */
            sameMerchant?: boolean;
            /**
             * Format: double
             * @description Its amount.
             */
            amount?: number | string;
            /** @description Its currency (ISO 4217). */
            currency: string;
            /**
             * Format: date-time
             * @description When its card was used.
             */
            transactionDate?: null | string;
            /** @description The account a person coded it to. */
            ledgerAccountName?: null | string;
        };
        /** @description The evidence behind an account learned from the organisation's history. */
        LearnedCodingResponse: {
            /**
             * Format: uuid
             * @description The account the similar expenses pointed to.
             */
            ledgerAccountId?: string;
            /** @description Name of that account. */
            ledgerAccountName?: null | string;
            /**
             * Format: double
             * @description The account's share of the vote, between 0 and 1, weighted by how similar and how recent each expense is.
             */
            voteShare?: number | string;
            /** @description The similar expenses a person coded, nearest first. */
            similarExpenses?: components["schemas"]["LearnedCodingNeighbourResponse"][];
        };
        /** @description An account from the organisation's chart of accounts, synced from their accounting platform. */
        LedgerAccountResponse: {
            /**
             * Format: uuid
             * @description Unique identifier of the account within Dolfin.
             */
            id?: string;
            /** @description The account number or code as it appears in the accounting platform. */
            displayId?: null | string;
            /** @description Account name. */
            name: string;
            /** @description Account classification, e.g. expense, asset, liability. */
            classification?: null | string;
            /** @description Account type as the accounting platform reports it. */
            accountType?: null | string;
            /** @description Account currency (ISO 4217). */
            currency?: null | string;
            /** @description Whether the account is still active in the accounting platform. Accounts that disappear are deactivated, never deleted, so historical coding keeps its meaning. */
            isActive?: boolean;
            /** @description The parent account in the accounting platform's own hierarchy, where the account is nested under another. */
            parentAccountId?: null | string;
            /** @description The accounting platform's own identifier for the account, as brokered by the integration provider. Useful when reconciling against the platform directly. */
            externalId?: null | string;
            /**
             * Format: date-time
             * @description When the account was last synced.
             */
            syncedAt?: string;
        };
        /**
         * @description Which bucket a bill line falls in — the same eight-way classification the match statistics are built from, so a drill-through can never disagree with the tile it was reached from.
         * @enum {unknown}
         */
        LineBucket: "AutoExact" | "AutoFuzzy" | "Assisted" | "Manual" | "AcceptedNoMatch" | "Disputed" | "CandidateWaiting" | "NoCandidate";
        LineItemTaxRateUpdate: {
            /**
             * Format: uuid
             * @description Id of an existing line item on the schedule.
             */
            lineItemId?: string;
            /**
             * Format: uuid
             * @description Tax rate to apply to the line item, or null to remove tax from it.
             */
            taxRateId?: null | string;
        };
        LoginRequest: {
            accessToken: string;
            provider: string;
        };
        /** @enum {unknown} */
        LookbackPeriod: "Last7Days" | "Last30Days" | "Last90Days" | "Last12Months" | "MonthToDate" | "QuarterToDate" | "YearToDate";
        MagicLinkResponse: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            organisationId?: null | string;
            label?: null | string;
            /** Format: date-time */
            createdAt?: string;
            /** Format: date-time */
            expiresAt?: string;
            /** Format: date-time */
            usedAt?: null | string;
        };
        /** @enum {unknown} */
        ManualPaymentMethod: "Cash" | "BankTransfer" | "Cheque" | "Card" | "Other" | "Credit";
        /** @description A confirmed match allocation: a bill line tied to a purchase-order line and/or delivery-note line, with how it was matched (auto vs manual) and who recorded it. This is a stored fact — not a derived suggestion. */
        MatchAllocationAdminView: {
            /**
             * Format: uuid
             * @description Unique identifier of the allocation.
             */
            id: string;
            /**
             * Format: uuid
             * @description The bill line this allocation hangs off.
             */
            billLineId: string;
            /** @description Description of the bill line that was matched. */
            billLineDescription: string;
            /**
             * Format: double
             * @description Quantity matched on this allocation (net basis).
             */
            matchedQuantity: number | string;
            /**
             * Format: double
             * @description Net (ex-tax) amount matched on this allocation, in Currency.
             */
            matchedAmount: number | string;
            /** @description ISO 4217 currency of MatchedAmount — the bill's currency (matching is done in the bill's currency). */
            currency: string;
            /** @description How the allocation was matched: Manual (chosen by a reviewer), Exact (auto-matched by SKU), or Fuzzy (a description-similarity match). Read it with AutoAccepted: Fuzzy alone does not say whether a human was involved. */
            matchMethod: components["schemas"]["MatchMethod"];
            /** @description True when the engine accepted this Fuzzy match itself, with no reviewer - a high-confidence, unambiguous match above the auto-accept threshold. False on a Fuzzy match a reviewer confirmed, and always false for Exact and Manual. This is the only way to tell the two kinds of Fuzzy apart, and it is the difference between automation and assistance. */
            autoAccepted: boolean;
            /**
             * Format: double
             * @description Similarity score recorded when the match was made, or null when none was. What it measures depends on who made the match, so read it together with AutoAccepted. On an engine auto-accept (AutoAccepted true) it is the raw pre-boost score the auto-accept decision was actually taken on, and is directly comparable against the client's auto-accept threshold. On a match a reviewer created or confirmed it is whatever the suggestion they acted on displayed, which includes the same-document boost, so it reads higher than the score the engine would have judged and must NOT be compared against the threshold. Usually null for Exact and Manual, which are not scored - but a reviewer supplying a confidence has it stored regardless of method, so a Manual row can carry one.
             */
            matchConfidence?: null | number | string;
            engineVerdict?: null | components["schemas"]["MatchAutoVerdict"];
            /**
             * Format: double
             * @description The engine's own best score for this bill line when the reviewer matched it, or null when it had no candidate. Unlike MatchConfidence this one is directly comparable against the client's auto-accept threshold: it is the raw, pre-boost score the engine judged on.
             */
            engineTopConfidence?: null | number | string;
            /**
             * Format: double
             * @description The runner-up's raw score at the same moment, or null when there was at most one candidate. With the auto-accept margin, this is what an Ambiguous verdict is about — how near the near-tie was.
             */
            engineRunnerUpConfidence?: null | number | string;
            /**
             * Format: date-time
             * @description When the engine's position above was computed. It is refreshed asynchronously, so it can trail the allocation by moments; a much older value means the group had not changed in a while.
             */
            engineVerdictComputedAt?: null | string;
            /**
             * Format: uuid
             * @description The purchase order this allocation matches against, if any.
             */
            purchaseOrderId?: null | string;
            /** @description Human purchase-order number, if matched to a PO line. */
            poNumber?: null | string;
            /** @description Description of the matched purchase-order line, if any. */
            poLineDescription?: null | string;
            /**
             * Format: uuid
             * @description The delivery note this allocation matches against, if any.
             */
            deliveryNoteId?: null | string;
            /** @description Human delivery-note number, if matched to a DN line. */
            dnNumber?: null | string;
            /** @description Description of the matched delivery-note line, if any. */
            dnLineDescription?: null | string;
            /**
             * Format: date-time
             * @description When the allocation was recorded.
             */
            createdAt: string;
            /**
             * Format: uuid
             * @description The user who recorded a manual/fuzzy allocation; null when the engine auto-matched it.
             */
            createdBy?: null | string;
            /**
             * Format: date-time
             * @description When the allocation was last updated.
             */
            updatedAt: string;
            /**
             * Format: uuid
             * @description The user who last updated the allocation, if any.
             */
            updatedBy?: null | string;
        };
        /** @description A confirmed match between a bill line and a purchase-order line (price) and/or a delivery-note line (receipt quantity). The purchase-order row owns the net; a delivery-note-only row is receipt-only. */
        MatchAllocationView: {
            /**
             * Format: uuid
             * @description Unique identifier of this allocation.
             */
            id: string;
            /**
             * Format: uuid
             * @description The matched purchase-order line, when this allocation pins one.
             */
            poLineId?: null | string;
            /**
             * Format: uuid
             * @description The parent purchase order of the matched line.
             */
            poId?: null | string;
            /** @description Human purchase-order number, for labelling and linking. Null when this allocation has no purchase-order counterpart (a delivery-note-only row). */
            poNumber?: null | string;
            /** @description Description of the matched purchase-order line. */
            poLineDescription?: null | string;
            /** @description SKU of the matched purchase-order line, if any. */
            poSku?: null | string;
            /**
             * Format: double
             * @description Unit price on the matched purchase-order line.
             */
            orderedUnitPrice?: null | number | string;
            /**
             * Format: uuid
             * @description The matched delivery-note line, when this allocation pins one.
             */
            dnLineId?: null | string;
            /**
             * Format: uuid
             * @description The parent delivery note of the matched line.
             */
            dnId?: null | string;
            /** @description Human delivery-note number, for labelling and linking. Null when this allocation has no delivery-note counterpart. */
            dnNumber?: null | string;
            /** @description Description of the matched delivery-note line. */
            dnLineDescription?: null | string;
            /**
             * Format: double
             * @description Quantity received on the matched delivery-note line.
             */
            quantityReceived?: null | number | string;
            /**
             * Format: double
             * @description Quantity matched by this allocation.
             */
            matchedQuantity: number | string;
            /**
             * Format: double
             * @description Net amount matched by this allocation.
             */
            matchedAmount: number | string;
            /** @description How the match was made: Exact (by SKU), Fuzzy (a confirmed suggestion) or Manual. */
            matchMethod: components["schemas"]["MatchMethod"];
            /**
             * Format: double
             * @description Fuzzy match confidence (0–1) when MatchMethod is Fuzzy; null otherwise. The description trigram similarity recorded when the suggestion was confirmed.
             */
            matchConfidence?: null | number | string;
            /** @description True when the matching engine accepted this fuzzy match automatically, without a reviewer — a high-confidence, unambiguous description match with no competing candidate. Only ever true for a Fuzzy allocation; Exact and Manual allocations are always false. */
            autoAccepted: boolean;
        };
        /**
         * @description Whether a match is counted once per bill line (every allocation) or once per bill.
         * @enum {unknown}
         */
        MatchAnalyticsUnit: "Lines" | "Bills";
        /**
         * @description Why the matching engine did or did not match a bill line by itself. Read together with the confidences recorded next to it: the verdict says which bar the line failed, the confidences say by how much.
         * @enum {unknown}
         */
        MatchAutoVerdict: "Allocated" | "NoSupplier" | "RouteDisabled" | "NoCandidate" | "BelowThreshold" | "Ambiguous" | "CounterpartTooLarge" | "Eligible" | null;
        /** @description The Dolfin payment to match the bank line to, taken from the line's candidates. */
        MatchBankLineRequest: {
            /** @description InvoicePayment, Bill or StripePayout, as the candidate gives it. */
            sourceType: components["schemas"]["JournalSourceType"];
            /**
             * Format: uuid
             * @description Id of the invoice payment, bill or Stripe payout, as the candidate gives it.
             */
            sourceId: string;
        };
        /** @description One purchase-order or delivery-note line, scored against the search text by the same name metric the matching engine uses to find candidates. */
        MatchCandidateAdminRow: {
            /** @description Which side of the match this line came from. */
            documentType: components["schemas"]["MatchCandidateDocumentType"];
            /**
             * Format: uuid
             * @description The organisation the document belongs to.
             */
            organisationId: string;
            /**
             * Format: uuid
             * @description Supplier on the document. Null when none has been resolved — such a document can never be a candidate for any bill, because the engine only ever looks at the billed supplier's documents.
             */
            supplierId?: null | string;
            /** @description Supplier name, for display. */
            supplierName?: null | string;
            /**
             * Format: uuid
             * @description The purchase order or delivery note this line sits on. Use it to open the document.
             */
            documentId: string;
            /** @description Human document number — the PO number or delivery-note number printed on the paperwork. */
            documentNumber: string;
            /** @description The platform's own reference for the document, if it supplied one. */
            externalRef?: null | string;
            /**
             * Format: date-time
             * @description The document's own date: the order date on a purchase order, the received date on a delivery note. This is a first-class part of why a match is or is not a good one — the engine scores date proximity to the invoice date, and an order raised after the invoice is excluded outright — so it is shown next to every candidate rather than left on the document page.
             */
            documentDate?: null | string;
            /**
             * Format: date-time
             * @description Expected delivery date on a purchase order — the date term the engine actually scores on this route. Always null for a delivery note.
             */
            expectedDeliveryDate?: null | string;
            orderStatus?: null | components["schemas"]["PurchaseOrderStatus"];
            deliveryStatus?: null | components["schemas"]["DeliveryNoteStatus"];
            /**
             * Format: uuid
             * @description The candidate line itself.
             */
            lineId: string;
            /** @description Description as it appears on the purchase order or delivery note. This is what was scored — and it is routinely not the wording on the bill, which is the whole reason matching is fuzzy. */
            description: string;
            /** @description Product code on the candidate line, if any. */
            sku?: null | string;
            /**
             * Format: double
             * @description Quantity on the line: ordered on a purchase order, received on a delivery note.
             */
            quantity: number | string;
            /**
             * Format: double
             * @description How much of that quantity is already allocated to some bill line.
             */
            quantityMatched: number | string;
            /**
             * Format: double
             * @description What is left to match. Zero means the line is fully consumed — which is very often the answer to the support question, because a consumed line is not a candidate however well it scores.
             */
            quantityRemaining: number | string;
            /**
             * Format: double
             * @description How much of this candidate line is allocated to the bill line the search was anchored to (billLineId). Greater than zero means THIS line already holds it — the candidate is not missing, it is the match. Zero alongside a non-zero quantityMatched is the opposite finding and the one that explains a shortfall: the goods are spoken for by a different bill line. Null when the caller named no bill line, because a search run from anywhere else is in no position to say whose it is.
             */
            quantityMatchedToBillLine?: null | number | string;
            unitOfMeasure?: null | components["schemas"]["UnitOfMeasure"];
            /**
             * Format: double
             * @description Unit price on a purchase-order line. Always null for a delivery note — a delivery note prices nothing.
             */
            unitPrice?: null | number | string;
            /**
             * Format: double
             * @description Net line total on a purchase-order line — the amount allocations are drawn against. Always null for a delivery note.
             */
            lineNet?: null | number | string;
            /** @description Currency of the purchase order. Null for a delivery note. Worth reading: currency is a HARD FILTER on the order route, so an order in a different currency from the bill is not a candidate at any confidence. */
            currency?: null | string;
            /**
             * Format: double
             * @description Name similarity between the search text and this line (0–1), by the same four-view metric the engine gates candidates on: trigram containment both ways, edit distance, and a normalised token-set view that ignores word order. An exact product-code match scores 1.0 outright. This is the term the client's SIMILARITY threshold is compared against — a line below it was never offered to anyone. On a supplier who sends the same wording every week it is 1.0 for every candidate and tells you nothing; that is what `confidence` is for.
             */
            nameSimilarity: number | string;
            /**
             * Format: double
             * @description The composed score — the exact number the matching engine would have ranked this candidate by, and the one an API caller sees on a suggestion: name, price, quantity, date and single-fill summed at their real weights, using this client's own date windows and variance tolerances. Compare it against the auto-accept threshold. Null when the search named no billLineId, because without a bill line there is nothing to score a candidate AGAINST — no billed quantity, no unit price, no invoice date — and a number invented in their absence would be worse than none.
             */
            confidence?: null | number | string;
            terms?: null | components["schemas"]["MatchCandidateScoreTerms"];
            /**
             * Format: double
             * @description Symmetric trigram similarity over the raw descriptions. Never gates anything; the engine carries it to break ties deterministically, and it is shown here for the same reason it is logged — a generic search term scores a flat 1.0 against dozens of variants, and this is what tells them apart.
             */
            specificity: number | string;
            /** @description True when the search text is exactly this line's product code, so the wording was never judged and Confidence is 1.0 by definition. */
            skuMatch: boolean;
            /** @description Whether the engine could offer this line at all today: the document is Open or PartiallyMatched and some quantity is still unconsumed. A high-confidence row with this false is the explanation a support engineer came for — the counterpart exists, it just is not available. */
            availableToMatch: boolean;
        };
        /**
         * @description Which side of the three-way match a candidate line came from.
         * @enum {unknown}
         */
        MatchCandidateDocumentType: "PurchaseOrder" | "DeliveryNote";
        /** @description A candidate pairing between a receipt and a card transaction, with the score that produced it. */
        MatchCandidateResponse: {
            /**
             * Format: uuid
             * @description The candidate card transaction.
             */
            cardTransactionId?: null | string;
            /**
             * Format: uuid
             * @description The expense the candidate transaction belongs to.
             */
            expenseId?: null | string;
            /**
             * Format: uuid
             * @description The candidate receipt.
             */
            receiptId?: null | string;
            /**
             * Format: double
             * @description Overall match score between 0 and 1.
             */
            score?: number | string;
            /** @description Whether the amounts agree within the organisation's tolerance. A confident pairing outside tolerance is matched but flagged rather than posted. */
            withinAmountTolerance?: boolean;
            /**
             * Format: double
             * @description Amount of the candidate.
             */
            amount?: null | number | string;
            /** @description Currency of the candidate (ISO 4217). */
            currency?: null | string;
            /** @description Merchant name of the candidate. */
            merchantName?: null | string;
            /**
             * Format: date-time
             * @description Date of the candidate.
             */
            date?: null | string;
        };
        /** @description One candidate's composed score, decomposed. The weights are not fixed constants across routes: an absent price or date gives its weight to name, so nameWeight is the effective weight actually used rather than the declared one — a delivery note, which carries no price, reads 0.80 where a purchase order reads 0.70. */
        MatchCandidateScoreTerms: {
            /**
             * Format: double
             * @description Name similarity (0–1) — the same value as the row's nameSimilarity, repeated here so the sum can be checked without leaving the object.
             */
            name: number | string;
            /**
             * Format: double
             * @description The effective weight applied to the name term, after any absent term handed its weight over.
             */
            nameWeight: number | string;
            /**
             * Format: double
             * @description How close the candidate's unit price is to the billed one (0–1). Null on a delivery note, which carries no price, and on an order line with no usable price — its weight goes to name.
             */
            price?: null | number | string;
            /**
             * Format: double
             * @description How close the candidate's quantity is to the billed quantity (0–1).
             */
            quantity: number | string;
            /**
             * Format: double
             * @description How close the candidate's own date falls to the bill's invoice date (0–1). Null when either date is missing — its weight goes to name. On a purchase order this is scored on the EXPECTED DELIVERY date, not the order date.
             */
            date?: null | number | string;
            /**
             * Format: double
             * @description 1 when this candidate could settle everything the bill line still owes on its own, 0 when it could not. The one term that is not a measure of similarity — it asks about shape.
             */
            singleFill: number | string;
        };
        /** @description A fuzzy delivery-note-line suggestion for a bill line with no exact match — the receipt-quantity counterpart of a purchase-order suggestion. */
        MatchDnSuggestionView: {
            /**
             * Format: uuid
             * @description The bill line this suggestion is for.
             */
            billLineId: string;
            /**
             * Format: uuid
             * @description The suggested delivery-note line.
             */
            dnLineId: string;
            /**
             * Format: uuid
             * @description The parent delivery note of the suggested line — for labelling and linking.
             */
            dnId: string;
            /** @description Human delivery-note number of the suggested line. */
            dnNumber: string;
            /** @description Description of the suggested delivery-note line. */
            dnLineDescription: string;
            /** @description SKU of the suggested delivery-note line, if any. */
            dnSku?: null | string;
            /**
             * Format: double
             * @description Quantity received on the suggested line.
             */
            quantityReceived: number | string;
            /**
             * Format: double
             * @description What the suggested delivery-note line can still give — received minus everything already allocated against it, expressed in the BILL line's unit. This is the quantity that would be allocated: matching takes a counterpart's whole remaining quantity or none of it. A delivery note is shared across bills, so this is routinely less than quantityReceived.
             */
            quantityRemaining: number | string;
            /**
             * Format: date-time
             * @description Date the suggested delivery note was received. Null when the note carries no date. It is a scoring term as well as a label: the confidence below multiplies by how close it falls to the bill's invoice date.
             */
            dnReceivedAt?: null | string;
            /**
             * Format: double
             * @description Match confidence (0–1): the bidirectional trigram line-description similarity between the bill and delivery-note lines, multiplied by how close the delivery note's receipt date is to the bill's invoice date. A delivery note carries no price, so unlike a purchase-order suggestion there is no price term. Only suggestions whose raw description similarity exceeds MatchSimilarityThreshold (default 0.7) are returned; date proximity then grades and ranks them and never excludes a candidate. Every candidate reaching MatchAutoAcceptThreshold is matched automatically rather than suggested — one delivery routinely arrives in several notes that all describe the same goods and therefore score alike. A candidate can still clear that bar and not be taken: matching is whole-or-nothing, so a note far larger than what the line still owes is left for the bill it belongs to.
             */
            confidence: number | string;
            /** @description True when this suggestion's confidence was raised because someone already linked another line of this bill to the same delivery note — the rest of a bill usually arrives on the same delivery. A boosted suggestion is never matched automatically, however high its confidence: it is only ranked higher for a reviewer to confirm. */
            manualLinkBoosted?: boolean;
        };
        /** @description A bill matched to a purchase order (or delivery note): the bill has at least one line allocated against the document. Used by the matched-bills listings. */
        MatchedBillView: {
            /**
             * Format: uuid
             * @description The matched bill.
             */
            billId: string;
            /**
             * Format: uuid
             * @description The match group that ties this bill to the document.
             */
            matchGroupId: string;
            /** @description Lifecycle status of the match group: Open (nothing to settle), Variance (a flagged difference awaits a decision), Resolved (settled) or Synced (exported — not reachable yet). */
            matchGroupStatus: components["schemas"]["MatchGroupStatus"];
            /** @description Supplier invoice number on the bill, if captured. */
            invoiceNumber?: null | string;
            /** @description Name of the bill's supplier, if known. */
            supplierName?: null | string;
            /** @description The bill's own workflow state (e.g. PendingReview, NeedsApproval) — the same value, and the same type, the bill endpoints return. */
            state: components["schemas"]["BillState"];
            /**
             * Format: double
             * @description Total (gross) amount on the bill.
             */
            totalAmount: number | string;
        };
        /** @description A purchase order or delivery note that a bill is matched to. */
        MatchedDocumentRef: {
            /**
             * Format: uuid
             * @description Unique identifier of the purchase order or delivery note. Use it to fetch the full document.
             */
            id: string;
            /** @description The document's human-readable number as issued by Dolfin (the PO number or delivery-note number). */
            number: string;
            /** @description The document's identifier in your own system, if one was supplied when it was created. Null when the document originated in Dolfin. Use it to reconcile a matched bill back to your ERP without storing Dolfin ids. */
            externalRef?: null | string;
        };
        MatchEventRow: {
            /** Format: date-time */
            createdAt: string;
            /** Format: uuid */
            clientId: string;
            clientName: string;
            clientType: components["schemas"]["ClientType"];
            /** Format: uuid */
            organisationId: string;
            organisationName: string;
            /** Format: uuid */
            billId: string;
            /** Format: uuid */
            matchGroupId: string;
            /** Format: uuid */
            billLineId: null | string;
            bucket: components["schemas"]["MatchOutcomeBucket"];
            method: components["schemas"]["MatchMethod"];
            autoAccepted: boolean;
            /** Format: double */
            confidence: null | number | string;
        };
        MatchEventsResponse: {
            rows: components["schemas"]["MatchEventRow"][];
            /** Format: int32 */
            totalCount: number | string;
            truncated: boolean;
            /** Format: int32 */
            inconsistentRows: number | string;
        };
        /** @description How a match group's lines were matched and where they stand. Every line falls in exactly one of AutoExact / AutoFuzzy / Assisted / Manual / Unmatched, so those five sum to Lines. */
        MatchGroupAdminCounters: {
            /**
             * Format: int32
             * @description Bill lines in the group.
             */
            lines: number | string;
            /**
             * Format: int32
             * @description Lines that are settled: cleanly matched with no outstanding difference, or with their difference accepted. A disputed line or one awaiting a credit note is recorded but NOT reconciled — it still blocks the bill. This is the same rule the reviewer's own progress indicator uses.
             */
            reconciled: number | string;
            /**
             * Format: int32
             * @description Lines the engine matched unattended on an identical SKU.
             */
            autoExact: number | string;
            /**
             * Format: int32
             * @description Lines the engine matched unattended on description similarity, above the auto-accept threshold with no close rival.
             */
            autoFuzzy: number | string;
            /**
             * Format: int32
             * @description Lines where the engine found the counterpart and a reviewer confirmed it.
             */
            assisted: number | string;
            /**
             * Format: int32
             * @description Lines where a reviewer picked a counterpart the engine did not offer. These are the ones worth reading the suggestions on — they are where matching cost the most human time.
             */
            manual: number | string;
            /**
             * Format: int32
             * @description Lines with no allocation at all. Counted once even if resolved — see AcceptedNoMatch and Disputed for what happened to them instead.
             */
            unmatched: number | string;
            /**
             * Format: int32
             * @description Unmatched lines closed by accepting them as billed — the right outcome for delivery charges and one-off buys no order covers.
             */
            acceptedNoMatch: number | string;
            /**
             * Format: int32
             * @description Unmatched lines disputed or sent for a credit note.
             */
            disputed: number | string;
            /**
             * Format: int32
             * @description Unmatched lines with no decision recorded — what is actually left to do.
             */
            openUnmatched: number | string;
            /**
             * Format: int32
             * @description Allocations recorded on the group. Higher than the matched line count whenever a line is tied to both a purchase order and a delivery note.
             */
            allocations: number | string;
            /**
             * Format: int32
             * @description Lines billed at a different unit price from the one ordered.
             */
            priceVariance: number | string;
            /**
             * Format: int32
             * @description Lines where the quantity billed does not match the quantity delivered.
             */
            receiptQuantityVariance: number | string;
            /**
             * Format: int32
             * @description Lines billed for more than the purchase order authorises.
             */
            overBilling: number | string;
            /**
             * Format: int32
             * @description Lines carrying at least one of the three differences. Lower than their sum when a line has more than one kind at once.
             */
            anyVariance: number | string;
            /**
             * Format: int32
             * @description Lines that still need a person: a difference with no decision recorded against it, a line only partly covered, or one raised as a dispute or credit-note request. Exactly the lines the group's Variance status is derived from, and what blocks the bill.
             */
            unresolvedVariance: number | string;
            /**
             * Format: int32
             * @description Per-line decisions recorded on the group as it stands.
             */
            resolutions: number | string;
            /**
             * Format: int32
             * @description Unmatched lines the engine currently has at least one suggestion for. Live, not snapshot — counted from the suggestions in the view below, which were scored on this request.
             */
            linesWithSuggestions: number | string;
            /**
             * Format: double
             * @description The best suggestion confidence across the whole group, or null when nothing is suggested. Compare it against Settings.AutoAcceptThreshold to see how far the engine is from being able to finish the group by itself.
             */
            topSuggestionConfidence?: null | number | string;
        };
        /** @description Everything about one match group: the reviewer's own derived view (lines, allocations, variances and ranked suggestions), the bill it belongs to, the matching thresholds in force, and a count of how the lines were matched. Requires admin access. */
        MatchGroupAdminView: {
            /**
             * Format: uuid
             * @description Unique identifier of the match group.
             */
            id: string;
            /**
             * Format: uuid
             * @description The organisation the match group belongs to.
             */
            organisationId: string;
            /**
             * Format: uuid
             * @description The client that owns the organisation. Matching thresholds are set per client, so this is the scope the Settings below belong to.
             */
            clientId: string;
            /** @description Lifecycle status of the match group. */
            status: components["schemas"]["MatchGroupStatus"];
            bill?: null | components["schemas"]["MatchGroupBillHeader"];
            /** @description How the group's lines were matched and where they stand. Derived from the same view below, in one pass, so the tiles and the table can never disagree. */
            counters: components["schemas"]["MatchGroupAdminCounters"];
            /** @description The client's matching thresholds as they stand now. Read every confidence in the view against these: a suggestion below AutoAcceptThreshold was never eligible for automatic matching. They can be changed at any time and are NOT necessarily the ones in force when this group was matched. */
            settings: components["schemas"]["MatchStatsSettings"];
            /** @description The reviewer's own view of the match, unchanged: every bill line with its derived price and quantity variances, its allocations, its recorded resolution, and the ranked fuzzy purchase-order and delivery-note suggestions for the lines still unmatched. */
            view: components["schemas"]["MatchGroupView"];
            /** @description The same allocations the view above carries, with the engine diagnostics the reviewer is not shown: why the engine did not make each human match itself, and the raw scores behind that. Join to the view's allocations by id. */
            allocations: components["schemas"]["MatchAllocationAdminView"][];
            /**
             * Format: date-time
             * @description When the matching engine last judged this group, or null if it never has. Read it against the response itself: the View below is LIVE — its suggestions and confidences were scored on this request — whereas the stored verdicts on the allocations are a snapshot taken at this moment by the last matching run. When the two disagree, this is usually why, and the answer is to re-run matching rather than to look for a scoring fault.
             */
            engineJudgedAt?: null | string;
            /**
             * Format: date-time
             * @description When the match group was created.
             */
            createdAt: string;
            /**
             * Format: date-time
             * @description When the match group was last updated.
             */
            updatedAt: string;
        };
        /** @description The bill a match group is reviewing. */
        MatchGroupBillHeader: {
            /**
             * Format: uuid
             * @description The bill (references Bill.CorrelationId).
             */
            billId: string;
            /** @description Supplier invoice number, if captured. */
            invoiceNumber?: null | string;
            /**
             * Format: uuid
             * @description The confirmed supplier, if one has been resolved.
             */
            supplierId?: null | string;
            /**
             * Format: uuid
             * @description The supplier suggested by extraction, when none is confirmed. A bill with neither can never match: the candidate pool is built per supplier.
             */
            suggestedSupplierId?: null | string;
            /** @description Supplier name as it appears on the bill. */
            supplierName?: null | string;
            /** @description ISO 4217 currency of the bill. Matching is done in the bill's currency. */
            currency: string;
            /**
             * Format: date-time
             * @description Invoice date on the bill. The header affinity term scores candidates partly on how close this is to a purchase order's expected delivery date.
             */
            invoiceDate?: null | string;
            /**
             * Format: date-time
             * @description Payment due date on the bill.
             */
            dueDate?: null | string;
            /**
             * Format: double
             * @description Net (ex-tax) total.
             */
            subTotal: number | string;
            /**
             * Format: double
             * @description Tax total.
             */
            taxAmount: number | string;
            /**
             * Format: double
             * @description Gross total.
             */
            totalAmount: number | string;
            /** @description The bill's own workflow state. A match group only accepts writes while the bill is in review, so this explains a group that looks editable but is not. */
            state: components["schemas"]["BillState"];
        };
        /**
         * @description Lifecycle status of a match group: Open (nothing to settle), Variance (a flagged difference awaits a decision), Resolved (settled), or Synced (exported to accounting — not reachable yet).
         * @enum {unknown}
         */
        MatchGroupStatus: "Open" | "Variance" | "Resolved" | "Synced";
        /** @description A match group summarised for lists: the bill under review, who it belongs to, its lifecycle status, and how much of it is matched. The derived per-line price/quantity variances and the fuzzy suggestions are not included — fetch the match group by id for those. */
        MatchGroupSummaryResponse: {
            /**
             * Format: uuid
             * @description Unique identifier of the match group.
             */
            id: string;
            /**
             * Format: uuid
             * @description The organisation the match group belongs to. Needed to open anything underneath it.
             */
            organisationId: string;
            /**
             * Format: uuid
             * @description The client that owns the organisation.
             */
            clientId: string;
            /**
             * Format: uuid
             * @description The bill under review (references Bill.CorrelationId).
             */
            billId: string;
            /** @description Supplier invoice number on the bill, if captured. */
            invoiceNumber?: null | string;
            /**
             * Format: uuid
             * @description The supplier the bill resolved to - confirmed if review has happened, otherwise the OCR suggestion. Null when neither has been resolved to a supplier record, which is why it can be absent while SupplierName is present: a name can be read off a document with no supplier behind it.
             */
            supplierId?: null | string;
            /** @description Supplier on the bill, confirmed or OCR-suggested. */
            supplierName?: null | string;
            /** @description ISO 4217 currency of the bill. Matching is done in the bill's currency. */
            currency: string;
            /**
             * Format: double
             * @description Net (ex-tax) total of the bill, in Currency.
             */
            billedNet: number | string;
            /** @description Lifecycle status: Open (nothing to settle), Variance (a flagged difference awaits a decision), Resolved (settled), or Synced (exported — not reachable yet). */
            status: components["schemas"]["MatchGroupStatus"];
            /**
             * Format: int32
             * @description Number of allocations (bill-line ↔ PO/DN-line links) recorded on the group.
             */
            allocationCount: number | string;
            /**
             * Format: int32
             * @description Bill lines on the bill under review.
             */
            lineCount: number | string;
            /**
             * Format: int32
             * @description Bill lines with at least one allocation. Counted per line, not per allocation, so a line matched to both a purchase order and a delivery note counts once.
             */
            matchedLineCount: number | string;
            /**
             * Format: int32
             * @description Bill lines carrying at least one difference — price, receipt quantity, or over-ordering. Read from the per-line snapshot, which is refreshed whenever the group changes.
             */
            varianceLineCount: number | string;
            /**
             * Format: int32
             * @description Per-line human decisions currently recorded on the group (accepted, disputed, or credit note requested). A snapshot of what stands now, not a history.
             */
            resolutionCount: number | string;
            /**
             * Format: date-time
             * @description When the match group was created.
             */
            createdAt: string;
            /**
             * Format: date-time
             * @description When the match group was last updated.
             */
            updatedAt: string;
        };
        MatchGroupTimingRow: {
            /** Format: uuid */
            matchGroupId: string;
            /** Format: uuid */
            billId: string;
            /** Format: uuid */
            clientId: string;
            clientName: string;
            /** Format: uuid */
            organisationId: string;
            organisationName: string;
            /** Format: date-time */
            groupCreatedAt: string;
            /** Format: date-time */
            firstAllocationAt: null | string;
            /** Format: double */
            gapSeconds: null | number | string;
            firstAllocationBucket: null | components["schemas"]["MatchOutcomeBucket"];
            /** Format: int32 */
            automatic: number | string;
            /** Format: int32 */
            suggestionApproved: number | string;
            /** Format: int32 */
            manual: number | string;
            /** Format: int32 */
            allocationCount: number | string;
        };
        /** @description A bill's three-way match: each bill line with its allocations and derived price/quantity variances (computed at read time, never stored), plus fuzzy purchase-order and delivery-note suggestions for lines that still need matching. */
        MatchGroupView: {
            /**
             * Format: uuid
             * @description Unique identifier of this match group.
             */
            id: string;
            /**
             * Format: uuid
             * @description The bill under review.
             */
            billId: string;
            /** @description Lifecycle status of the match: Open (nothing to settle), Variance (a flagged difference awaits a human decision), Resolved (settled), or Synced (exported — not reachable yet). */
            status: components["schemas"]["MatchGroupStatus"];
            /**
             * Format: double
             * @description Per-line rounding tolerance, in the bill's currency, that every variance was judged against. Configured per organisation; a difference within tolerance is treated as clean.
             */
            tolerance: number | string;
            /** @description True when every line is fully allocated with no outstanding variance. */
            isClean: boolean;
            /** @description One entry per bill line, carrying its allocations and derived variances. */
            lines: components["schemas"]["MatchLineView"][];
            /** @description Fuzzy purchase-order-line suggestions for bill lines with no exact (SKU) match. Derived, never stored; confirm one (POST an allocation) to create a real match. */
            suggestions: components["schemas"]["MatchSuggestionView"][];
            /** @description Fuzzy delivery-note-line suggestions — the receipt-quantity counterpart of Suggestions. Lets the UI ask 'which delivery does this line belong to?' without the caller knowing line ids. */
            dnSuggestions: components["schemas"]["MatchDnSuggestionView"][];
        };
        /** @description One bill line, with everything needed to navigate to the documents behind it. */
        MatchLineAdminRow: {
            /**
             * Format: uuid
             * @description The organisation the bill belongs to.
             */
            organisationId: string;
            /**
             * Format: uuid
             * @description The bill. Use it to open the bill page.
             */
            billId: string;
            /**
             * Format: uuid
             * @description The bill line, so the bill page can scroll to and highlight the exact row.
             */
            billLineId: string;
            /** @description Line description as it appears on the bill. */
            description: string;
            /**
             * Format: double
             * @description Net amount billed on this line.
             */
            billedNet: number | string;
            /** @description Currency of the bill this line belongs to. */
            currency: string;
            /** @description Which bucket the line falls in - the same classification the statistics use. */
            bucket: components["schemas"]["LineBucket"];
            /**
             * Format: uuid
             * @description The match group this line's bill belongs to.
             */
            matchGroupId: string;
            /** @description Lifecycle status of that match group. */
            matchGroupStatus: components["schemas"]["MatchGroupStatus"];
            /**
             * Format: date-time
             * @description When the match group was created. This is the sort key - newest first, with the bill-line id breaking ties inside a group - so it is also what the page cursor is built from.
             */
            matchGroupCreatedAt: string;
            /**
             * Format: uuid
             * @description Supplier on the bill, confirmed or OCR-suggested. Null when none has been resolved yet, which is itself why a line can never be actionable.
             */
            supplierId?: null | string;
            /** @description Supplier name, for display. */
            supplierName?: null | string;
            engineVerdict?: null | components["schemas"]["MatchAutoVerdict"];
            /**
             * Format: double
             * @description The engine's own best score for the line at that moment, or null when it had none. Raw and directly comparable against the client's auto-accept threshold.
             */
            engineTopConfidence?: null | number | string;
            /** @description Purchase orders this line is allocated against. Empty on an unmatched line. */
            purchaseOrders: components["schemas"]["MatchedDocumentRef"][];
            /** @description Delivery notes this line is allocated against. Empty on an unmatched line. */
            deliveryNotes: components["schemas"]["MatchedDocumentRef"][];
        };
        /**
         * @description Which lines to list. The buckets match the statistics surface exactly - the same classification code produces both, so a filter here can never disagree with the count it was reached from.
         * @enum {unknown}
         */
        MatchLineStateFilter: "All" | "Actionable" | "Starved" | "Matched" | "Accepted" | "Disputed";
        /** @description One bill line within a match group: its billed figures, derived price/quantity variances, backing allocations and any recorded resolution. */
        MatchLineView: {
            /**
             * Format: uuid
             * @description The bill line this row describes.
             */
            billLineId: string;
            /** @description Bill line description, as it appears on the bill. */
            description: string;
            /** @description Product code on the bill line, when the extraction captured one. A candidate carrying the same code is treated as a certain identity match, so its name never has to be judged. */
            sku?: null | string;
            /**
             * Format: double
             * @description Quantity billed on this line.
             */
            billedQuantity: number | string;
            unitOfMeasure?: null | components["schemas"]["UnitOfMeasure"];
            /**
             * Format: double
             * @description Unit price billed on this line.
             */
            billedUnitPrice: number | string;
            /**
             * Format: double
             * @description Net (ex-tax) amount billed on this line.
             */
            billedNet: number | string;
            /**
             * Format: double
             * @description Quantity allocated against purchase-order lines (the priced dimension).
             */
            allocatedQuantity: number | string;
            /**
             * Format: double
             * @description Net amount allocated against purchase-order lines (the dimension that owns the net).
             */
            allocatedNet: number | string;
            /**
             * Format: double
             * @description Billed net not yet covered by a purchase-order allocation (billedNet − allocatedNet).
             */
            unallocatedNet: number | string;
            /** @description True when the line's net is fully covered, within tolerance. */
            fullyAllocated: boolean;
            /**
             * Format: double
             * @description Billed unit price minus the ordered unit price. Null when the line has no purchase-order match; positive means billed above the order.
             */
            priceVariancePerUnit?: null | number | string;
            /**
             * Format: double
             * @description Total price variance across the matched quantity. Null when the line has no purchase-order match.
             */
            priceVarianceTotal?: null | number | string;
            /** @description True when the price variance exceeds tolerance. */
            hasPriceVariance: boolean;
            /**
             * Format: double
             * @description Quantity matched against delivery-note lines (the receipt dimension). Null when the line has no delivery-note match.
             */
            receivedQuantity?: null | number | string;
            /**
             * Format: double
             * @description Billed quantity minus received quantity. Null when there is no delivery-note match; positive means billed more than was delivered.
             */
            quantityVariance?: null | number | string;
            /** @description True when the billed-vs-received quantity variance exceeds tolerance. */
            hasQuantityVariance: boolean;
            /**
             * Format: double
             * @description Total quantity ordered across the distinct purchase-order lines this bill line is matched to. Null when the line has no purchase-order match.
             */
            orderedQuantity?: null | number | string;
            /**
             * Format: double
             * @description Billed quantity minus ordered quantity. Positive means billed for more than the purchase order authorises (a surplus).
             */
            quantityOverOrdered?: null | number | string;
            /** @description True when the line is billed for more than was ordered, beyond tolerance — the surplus clears by allocating a second purchase-order line or by accepting it. */
            hasOverBillingVariance: boolean;
            /** @description The purchase-order and delivery-note allocations backing this line. */
            allocations: components["schemas"]["MatchAllocationView"][];
            resolution?: null | components["schemas"]["MatchResolutionView"];
            /** @description True when this line is what holds the match group open, and a person still has to act on it. Read this to decide whether to offer Accept / Dispute on the line — it is the one field that answers that question. It accounts for differences already settled: a line whose price and quantity differences all sit inside the tolerances configured for this client, and whose net is covered once those differences are taken into account, is finished and reads false even though the individual amounts may still be non-zero. A line someone has already accepted reads false; one raised as a dispute or a credit-note request reads true until it is settled. A group is in Variance if and only if at least one of its lines reads true. */
            requiresReview: boolean;
        };
        /**
         * @description How an allocation was matched: Manual (chosen by a reviewer), Exact (auto-matched by product code), Fuzzy (a description-similarity match), or LinkedPoMatch (an order reached through the delivery note that quoted it, rather than by scoring the order against the bill).
         * @enum {unknown}
         */
        MatchMethod: "Manual" | "Exact" | "Fuzzy" | "LinkedPoMatch";
        /**
         * @description How an allocation came to exist, flattened to one value for analytics: AutoSku (engine, matched on product code), AutoSimilarity (engine, auto-accepted description match), AutoLinkedPo (engine, an order reached through a delivery note that quoted it), Confirmed (a reviewer accepted a suggestion), or Manual (a reviewer made the link themselves).
         * @enum {unknown}
         */
        MatchOutcomeBucket: "AutoSku" | "AutoSimilarity" | "AutoLinkedPo" | "Confirmed" | "Manual";
        MatchOutcomeDailyRow: {
            /** Format: date */
            date: string;
            /** Format: uuid */
            clientId: string;
            clientName: string;
            clientType: components["schemas"]["ClientType"];
            /** Format: uuid */
            organisationId: string;
            organisationName: string;
            /** Format: int32 */
            autoSku: number | string;
            /** Format: int32 */
            autoSimilarity: number | string;
            /** Format: int32 */
            autoLinkedPo: number | string;
            /** Format: int32 */
            confirmed: number | string;
            /** Format: int32 */
            manual: number | string;
            /** Format: int32 */
            total: number | string;
        };
        MatchOutcomesDailyResponse: {
            rows: components["schemas"]["MatchOutcomeDailyRow"][];
            /** Format: int32 */
            inconsistentRows: number | string;
        };
        /**
         * @description How a seeded bill line was designed to match.
         * @enum {unknown}
         */
        MatchPracticeLane: "SkuExact" | "FuzzyAuto" | "SuggestedManual" | "NoSuggestion" | "UnmatchedCharge" | "Manual";
        /**
         * @description What the engine actually did with a seeded bill line.
         * @enum {unknown}
         */
        MatchPracticeOutcome: "AutoMatchedOnSku" | "AutoMatchedOnSimilarity" | "Suggested" | "NothingOffered";
        /**
         * @description Which shape of three-way-match practice data to seed. Both scenarios are deterministic: the same suppliers, items, wording and prices every call. Only document numbers and dates move.
         * @enum {unknown}
         */
        MatchPracticeScenario: "ManualSet" | "MixedMatchTypes";
        MatchReceiptRequest: {
            /** Format: uuid */
            expenseId: string;
        };
        /**
         * @description How a bill line's variance was resolved. Accept settles the line whatever the variance kind (price, short delivery, or over-order surplus). AcceptAndUpdateCatalog also records a catalog-write intent. RequestCreditNote and Dispute keep the line (and so the bill) blocked.
         * @enum {unknown}
         */
        MatchResolutionAction: "Accept" | "AcceptAndUpdateCatalog" | "RequestCreditNote" | "Dispute";
        /** @description A human decision recorded against a bill line's variance. */
        MatchResolutionView: {
            /** @description The resolution taken (e.g. Accept, RequestCreditNote, Dispute). */
            action: components["schemas"]["MatchResolutionAction"];
            /**
             * Format: uuid
             * @description The user who recorded the resolution, if known.
             */
            resolvedBy?: null | string;
            /**
             * Format: date-time
             * @description When the resolution was recorded.
             */
            resolvedAt?: null | string;
            /** @description Optional free-text note captured with the resolution. */
            notes?: null | string;
        };
        MatchRewindResult: {
            /** Format: int32 */
            billsRewound: number | string;
            /** Format: int32 */
            matchGroupsCreated: number | string;
            /** Format: int32 */
            exactAllocations: number | string;
            /** Format: int32 */
            fuzzyAllocations: number | string;
            /** Format: int32 */
            autoAccepted: number | string;
            /** Format: int32 */
            linesUnallocated: number | string;
            /** Format: int32 */
            contaminatedPoLines: number | string;
            /** @default true */
            matchingRan: boolean;
        };
        /** @description Bill-level coverage for the window. */
        MatchStatsBills: {
            /**
             * Format: int32
             * @description Bills created in the window.
             */
            total: number | string;
            /**
             * Format: int32
             * @description Bills with a match group — the ones every line figure below is drawn from. A group is only opened when the supplier has an open purchase order or delivery note to correlate against.
             */
            withMatchGroup: number | string;
            /**
             * Format: int32
             * @description Bills with no match group: no purchase order or delivery note to match against, or a credit note (matching skips negative bills). Counted by bill creation date against groups counted by group creation date, so treat it as a ratio rather than an exact difference.
             */
            withoutMatchGroup: number | string;
        };
        /** @description One band of the fuzzy-match confidence distribution. */
        MatchStatsConfidenceBucket: {
            /**
             * Format: double
             * @description Lower bound of the band, inclusive.
             */
            from: number | string;
            /**
             * Format: double
             * @description Upper bound of the band. Exclusive except on the topmost band, which includes 1.0.
             */
            to: number | string;
            /**
             * Format: int32
             * @description Allocations in this band the engine accepted automatically.
             */
            autoAccepted: number | string;
            /**
             * Format: int32
             * @description Allocations in this band a reviewer confirmed. A large count close below the auto-accept threshold is the signal that the threshold could safely come down.
             */
            humanConfirmed: number | string;
        };
        /** @description Purchase orders and delivery notes with quantity still unconsumed — the supply side of matching, which the bill-side figures cannot show. */
        MatchStatsCounterparts: {
            /**
             * Format: int32
             * @description Purchase orders with quantity still unmatched (Open or PartiallyMatched). These are what make a bill line actionable.
             */
            purchaseOrdersWithCapacity: number | string;
            /**
             * Format: int32
             * @description Of those, the ones nothing has ever matched against. A high count means orders are being loaded but the bills are not arriving, or are not correlating to them.
             */
            purchaseOrdersUntouched: number | string;
            /**
             * Format: int32
             * @description Delivery notes with receipt quantity still unmatched (Open or PartiallyMatched).
             */
            deliveryNotesWithCapacity: number | string;
            /**
             * Format: int32
             * @description Of those, the ones nothing has ever matched against.
             */
            deliveryNotesUntouched: number | string;
        };
        /** @description The line buckets weighted by billed net rather than line count, for one bill currency. */
        MatchStatsCurrencyValue: {
            /** @description ISO 4217 currency of the bills these totals come from. */
            currency: string;
            /**
             * Format: double
             * @description Billed net on matched lines.
             */
            matched: number | string;
            /**
             * Format: double
             * @description Billed net on matched lines the engine matched unattended.
             */
            automated: number | string;
            /**
             * Format: double
             * @description Billed net on lines closed without a match (accepted or disputed).
             */
            dispositioned: number | string;
            /**
             * Format: double
             * @description Billed net on lines still open.
             */
            open: number | string;
            /**
             * Format: double
             * @description Automated / Matched, or null when nothing matched in this currency.
             */
            automationOfMatched?: null | number | string;
        };
        /** @description Match-group lifecycle counts for the window. */
        MatchStatsGroups: {
            /**
             * Format: int32
             * @description Match groups created in the window.
             */
            total: number | string;
            /**
             * Format: int32
             * @description Groups with nothing allocated yet.
             */
            open: number | string;
            /**
             * Format: int32
             * @description Groups with a flagged difference awaiting a decision. These block the bill from leaving review, so this is the most operationally urgent figure here — but it is up to an hour stale, so it is a health indicator, not a work queue.
             */
            variance: number | string;
            /**
             * Format: int32
             * @description Groups fully settled.
             */
            resolved: number | string;
            /**
             * Format: int32
             * @description Resolved groups that never needed a human: every allocation was made by the engine and every resolution was recorded by the auto-settle gate.
             */
            straightThrough: number | string;
            /**
             * Format: int32
             * @description Resolved groups that matched clean — no line ever needed a resolution recorded at all. Strictly stronger than straight-through.
             */
            cleanFirstPass: number | string;
            /**
             * Format: double
             * @description StraightThrough / Resolved, or null when nothing resolved in the window.
             */
            straightThroughRate?: null | number | string;
            /**
             * Format: double
             * @description CleanFirstPass / Resolved, or null when nothing resolved in the window.
             */
            cleanFirstPassRate?: null | number | string;
        };
        /** @description Every bill line inside a match group, classified into exactly one bucket. */
        MatchStatsLines: {
            /**
             * Format: int32
             * @description Total bill lines across every match group in the window.
             */
            total: number | string;
            /** @description Lines with at least one confirmed allocation. */
            matched: components["schemas"]["MatchStatsMatchedLines"];
            /** @description Lines with no allocation. */
            unmatched: components["schemas"]["MatchStatsUnmatchedLines"];
        };
        /** @description Why a human had to match the lines a human matched, by line. Counts cover the Assisted and Manual buckets only — the lines the engine did not complete by itself. They sum to Total. */
        MatchStatsManualCauses: {
            /**
             * Format: int32
             * @description Lines a reviewer matched: Lines.Matched.Assisted + Lines.Matched.Manual. The denominator for everything below.
             */
            total: number | string;
            /**
             * Format: int32
             * @description Nothing resembling the line existed to offer. The counterpart document is missing or its wording has nothing in common with the bill's — a document-capture problem, not a matching one, and no threshold change touches it.
             */
            noCandidate: number | string;
            /**
             * Format: int32
             * @description The bill had no supplier resolved, so no candidate pool existed at all. Fix extraction or supplier matching, not the thresholds.
             */
            noSupplier: number | string;
            /**
             * Format: int32
             * @description Auto-matching was switched off, so the engine was never allowed to try. These are a configuration choice showing up as reviewer effort.
             */
            routeDisabled: number | string;
            /**
             * Format: int32
             * @description The engine found the right sort of thing but scored it under the auto-accept threshold. The actionable bucket: read it with NearMiss to see how many a small threshold cut would recover.
             */
            belowThreshold: number | string;
            /**
             * Format: int32
             * @description The engine cleared the threshold but two candidates were too close to separate, so it declined rather than guess. Lowering the threshold will NOT recover these — the margin blocked them, and the underlying cause is usually genuinely duplicate catalogue lines.
             */
            ambiguous: number | string;
            /**
             * Format: int32
             * @description The engine scored a counterpart highly enough but every one of them was too large to take. Matching is whole-or-nothing — a counterpart's whole remaining quantity is allocated or none of it is, never a part-quantity no document states — so an order or note far bigger than what the line still owes is left for the bill it belongs to rather than half-claimed. A small bill line against a big standing order is the shape. Lowering the threshold recovers none of these; they are reviewer effort by design, and a large count means bills are being cut finer than the documents behind them.
             */
            counterpartTooLarge: number | string;
            /**
             * Format: int32
             * @description The engine had cleared every bar and still did not hold the line — the counterpart's remaining quantity went to another bill first, or matching had not run again since. Any sustained count here is worth investigating: these should have been automatic.
             */
            eligible: number | string;
            /**
             * Format: int32
             * @description No verdict was captured — the match predates this being recorded, or the line's snapshot had not been computed when the reviewer matched it. Reported rather than folded into another bucket, so a large Unknown is visible as missing data instead of being read as a real cause.
             */
            unknown: number | string;
            /**
             * Format: double
             * @description Mean of the engine's best score across the lines where it had one, or null when it never did. Read against Settings.AutoAcceptThreshold: a figure sitting just under it means the engine is close on most of what reviewers are doing by hand.
             */
            averageEngineConfidence?: null | number | string;
            /**
             * Format: int32
             * @description Lines the engine scored within NearMissBand below the auto-accept threshold. The concrete version of 'the threshold is too high': roughly how many of these a reviewer would stop seeing if the threshold dropped by that much. Roughly, because a lower threshold also admits matches that are wrong — this sizes the prize, it does not argue for taking it.
             */
            nearMiss: number | string;
            /**
             * Format: double
             * @description How far below the auto-accept threshold NearMiss reaches, as a confidence delta.
             */
            nearMissBand: number | string;
        };
        /** @description Matched lines by who made the match. A line with several allocations is counted once, under the most human-involved of them — one manual link makes the whole line manual, because the reviewer still had to open it and decide. That makes the automation figures a floor, not a ceiling. */
        MatchStatsMatchedLines: {
            /**
             * Format: int32
             * @description Matched by the engine on an exact SKU match, unattended.
             */
            autoExact: number | string;
            /**
             * Format: int32
             * @description Matched by the engine on description similarity, unattended — a high-confidence, unambiguous match that cleared the auto-accept threshold.
             */
            autoFuzzy: number | string;
            /**
             * Format: int32
             * @description The engine suggested the match and a reviewer confirmed it. The engine did the finding; a human did the deciding.
             */
            assisted: number | string;
            /**
             * Format: int32
             * @description A reviewer picked a counterpart the engine never offered — the lines that cost the most human time and where better matching would pay off most.
             */
            manual: number | string;
            /**
             * Format: int32
             * @description AutoExact + AutoFuzzy + Assisted + Manual.
             */
            total: number | string;
        };
        /** @enum {unknown} */
        MatchStatsPeriod: "Last30Days" | "Last90Days" | "MonthToDate";
        /** @description Rates derived from the line buckets. Each is null when its denominator is zero — never silently zero. */
        MatchStatsRates: {
            /**
             * Format: double
             * @description Of the lines that got matched, the share the engine matched unattended: (AutoExact + AutoFuzzy) / Matched.Total. Narrower than Automation, which is the headline: this one says nothing about how much of the bill matching reached in the first place.
             */
            automationOfMatched?: null | number | string;
            /**
             * Format: double
             * @description Assisted / Matched.Total — the share of matches the engine found and a reviewer only confirmed. A measure of suggestion quality: high is good, it means the engine is doing the search.
             */
            assist?: null | number | string;
            /**
             * Format: double
             * @description Manual / Matched.Total — the share of matches the engine contributed nothing to.
             */
            manual?: null | number | string;
            /**
             * Format: double
             * @description Matched.Total / Lines.Total — matched share of every line, including lines nothing could ever match. Always lower than the addressable figure; report it, don't lead with it.
             */
            grossCoverage?: null | number | string;
            /**
             * Format: double
             * @description (AcceptedNoMatch + Disputed) / Lines.Total — lines closed without a match.
             */
            disposition?: null | number | string;
            /**
             * Format: double
             * @description (AutoExact + AutoFuzzy) / (Matched.Total + CandidateWaiting) — automation over the lines that could plausibly be matched at all. The headline figure: it excludes lines nothing could ever match, so a supplier who bills a delivery charge on every invoice does not drag it down for ever.
             */
            automation?: null | number | string;
            /**
             * Format: double
             * @description Matched.Total / (Matched.Total + CandidateWaiting) — matched share of the addressable lines.
             */
            matchCoverage?: null | number | string;
            /**
             * Format: double
             * @description CandidateWaiting / (Matched.Total + CandidateWaiting) — the share of addressable lines still waiting on someone. The one figure here that is a call to action rather than a health check.
             */
            waiting?: null | number | string;
            /**
             * Format: double
             * @description NoCandidate / Lines.Total — how much of the billed surface matching is structurally blind to. If it climbs, the cause is usually upstream (orders not loaded) rather than the matcher.
             */
            noCounterpart?: null | number | string;
        };
        /** @description Per-line resolutions currently recorded. A snapshot, not a history: resolutions are overwritten on change, deleted on undo, and cleared automatically whenever a line's allocations change — so this is what stands now on groups created in the window, not what was decided during it. */
        MatchStatsResolutions: {
            /**
             * Format: int32
             * @description Lines accepted as billed.
             */
            accept: number | string;
            /**
             * Format: int32
             * @description Lines accepted with the catalogue price updated to match.
             */
            acceptAndUpdateCatalog: number | string;
            /**
             * Format: int32
             * @description Lines where a credit note was requested from the supplier.
             */
            requestCreditNote: number | string;
            /**
             * Format: int32
             * @description Lines disputed with the supplier.
             */
            dispute: number | string;
            /**
             * Format: int32
             * @description Resolutions recorded by the engine's auto-settle gate, with no reviewer involved.
             */
            autoSettled: number | string;
            /**
             * Format: int32
             * @description Resolutions recorded by a reviewer.
             */
            humanSettled: number | string;
            /**
             * Format: int32
             * @description Total resolutions recorded.
             */
            total: number | string;
        };
        /** @description How much of an organisation's (or client's) three-way matching the engine did unattended, how much a reviewer did by hand, and how much is still unmatched — by line count and by billed value. */
        MatchStatsResponse: {
            /** @description Whether these figures cover a whole client or a single organisation. */
            scope: components["schemas"]["MatchStatsScope"];
            /**
             * Format: uuid
             * @description The client these figures cover. Null on the organisation-scoped surface.
             */
            clientId?: null | string;
            /**
             * Format: uuid
             * @description The organisation these figures cover. Null on the client-scoped surface.
             */
            organisationId?: null | string;
            /**
             * Format: date-time
             * @description When these figures were materialised. They are cached for up to an hour, so this can trail the present — render it rather than assuming the numbers are live.
             */
            asOf: string;
            /** @description The lookback window these figures cover. */
            period: components["schemas"]["MatchStatsPeriod"];
            /**
             * Format: date
             * @description First day of the window (UTC), inclusive.
             */
            from: string;
            /**
             * Format: date
             * @description Last day of the window (UTC), inclusive.
             */
            to: string;
            /** @description Bill-level coverage: how many bills matching even applies to. */
            bills: components["schemas"]["MatchStatsBills"];
            /** @description Match-group lifecycle counts and the straight-through rates derived from them. */
            groups: components["schemas"]["MatchStatsGroups"];
            /** @description Every bill line in the window, classified into exactly one bucket. */
            lines: components["schemas"]["MatchStatsLines"];
            /** @description Rates derived from the line buckets, by line count. A rate is null when its denominator is zero — never silently zero, so 'no data' and 'nothing automated' stay distinguishable. */
            rates: components["schemas"]["MatchStatsRates"];
            /** @description The same buckets weighted by billed net instead of line count, one entry per bill currency. Never summed across currencies — no exchange rates are applied. */
            value: components["schemas"]["MatchStatsCurrencyValue"][];
            /** @description Recorded per-line resolutions, split by whether a human or the auto-settle gate recorded them. */
            resolutions: components["schemas"]["MatchStatsResolutions"];
            /** @description Confidence distribution of fuzzy matches, split by whether the engine accepted them automatically or a reviewer confirmed them. Use it to judge whether the auto-accept threshold is set right: a fat band of human-confirmed matches just below the threshold means reviewers are rubber-stamping the engine and the threshold could come down. */
            confidence: components["schemas"]["MatchStatsConfidenceBucket"][];
            /** @description The order and delivery side: documents still carrying quantity nothing has claimed. The counterpart to every bill-side figure above. */
            counterparts: components["schemas"]["MatchStatsCounterparts"];
            /** @description Which kinds of difference the flagged lines actually have, and how close the engine came on the lines it could not settle. Read from a snapshot refreshed whenever a match group changes. */
            variance: components["schemas"]["MatchStatsVariance"];
            /** @description Why a human had to match the lines a human matched. The counterpart to the automation rates: those say how much reviewer time matching costs, this says what would have to change to reduce it. */
            manualCauses: components["schemas"]["MatchStatsManualCauses"];
            /** @description The client's current matching thresholds. Every rate above depends on them, and they can be changed mid-window — these are the settings as they stand now, not necessarily the ones that produced the figures. */
            settings: components["schemas"]["MatchStatsSettings"];
        };
        /**
         * @description Whether the figures cover a whole client or a single organisation.
         * @enum {unknown}
         */
        MatchStatsScope: "Client" | "Organisation";
        /** @description The client's current matching thresholds, echoed so the rates above can be read in context. */
        MatchStatsSettings: {
            /**
             * Format: double
             * @description Confidence at or above which a fuzzy match is accepted with no reviewer. This is the only bar: every candidate clearing it is matched as the document states it, and the net booked against the bill line never exceeds what that line was billed.
             */
            autoAcceptThreshold: number | string;
            /**
             * Format: double
             * @description Minimum description similarity for a candidate to be suggested at all.
             */
            similarityThreshold: number | string;
            /**
             * Format: double
             * @description Per-line rounding tolerance, in the bill's currency, that variances are judged against.
             */
            roundingTolerance: number | string;
            /** @description Whether purchase-order auto-matching is switched on. */
            poAutoMatchEnabled: boolean;
            /** @description Whether delivery-note auto-matching is switched on. */
            dnAutoMatchEnabled: boolean;
        };
        /** @description Lines with no allocation, by what happened to them instead. */
        MatchStatsUnmatchedLines: {
            /**
             * Format: int32
             * @description Closed by accepting the line without a counterpart — the correct outcome for delivery charges, services and one-off buys that no purchase order covers. Not a gap.
             */
            acceptedNoMatch: number | string;
            /**
             * Format: int32
             * @description Closed by disputing the line or requesting a credit note.
             */
            disputed: number | string;
            /**
             * Format: int32
             * @description Still open: no allocation and no recorded decision. The sum of CandidateWaiting and NoCandidate.
             */
            open: number | string;
            /**
             * Format: int32
             * @description Open lines whose supplier still has unconsumed purchase-order or delivery-note quantity — the actionable backlog, the lines a reviewer can do something about right now. Measured at supplier level, so it answers 'is there anywhere for this line to go', not 'is there a lookalike'.
             */
            candidateWaiting: number | string;
            /**
             * Format: int32
             * @description Open lines whose supplier has no unconsumed order or delivery quantity left. Nothing will match these without a new document arriving, so reviewer time spent on them is wasted — the usual outcome is to accept the line as billed.
             */
            noCandidate: number | string;
            /**
             * Format: int32
             * @description AcceptedNoMatch + Disputed + Open.
             */
            total: number | string;
        };
        /** @description The shape of the differences matching found, plus how near the engine came on what it could not match. Both come from a per-line snapshot rather than being derived per request, which is what keeps this affordable across a whole client. */
        MatchStatsVariance: {
            /**
             * Format: int32
             * @description Lines billed at a different unit price from the one ordered.
             */
            priceVariance: number | string;
            /**
             * Format: int32
             * @description Lines where the quantity billed does not match the quantity delivered.
             */
            receiptQuantityVariance: number | string;
            /**
             * Format: int32
             * @description Lines billed for more than the purchase order authorises.
             */
            overBilling: number | string;
            /**
             * Format: int32
             * @description Lines carrying at least one of the three differences above. Lower than their sum whenever a line has more than one kind at once.
             */
            anyVariance: number | string;
            /**
             * Format: int32
             * @description Lines whose billed net is fully covered by allocations, within tolerance.
             */
            fullyAllocated: number | string;
            /**
             * Format: int32
             * @description Unmatched lines the engine has at least one similarity suggestion for. A QUALITY signal, not a work queue: suggestions are scored against a candidate pool that a different bill can consume without this line being reprojected, so this can overstate. Use CandidateWaiting, which reads live capacity, to decide what is actionable.
             */
            withSuggestion: number | string;
            /**
             * Format: double
             * @description Average of the best suggestion confidence across those lines, or null when there are none. A figure sitting just under the auto-accept threshold means the engine is nearly there.
             */
            averageTopConfidence?: null | number | string;
            /**
             * Format: date-time
             * @description When the oldest snapshot row in this window was last recomputed, or null when there are none. Rows refresh whenever their match group changes; a very old value means little has moved.
             */
            oldestComputedAt?: null | string;
        };
        /** @description A fuzzy purchase-order-line suggestion for a bill line with no exact (SKU) match, scored by description similarity. Confirm it by creating an allocation. */
        MatchSuggestionView: {
            /**
             * Format: uuid
             * @description The bill line this suggestion is for.
             */
            billLineId: string;
            /**
             * Format: uuid
             * @description The suggested purchase-order line.
             */
            poLineId: string;
            /**
             * Format: uuid
             * @description The parent purchase order of the suggested line — for labelling and linking. Two purchase orders can carry the same line description, so the number/id disambiguate them.
             */
            poId: string;
            /** @description Human purchase-order number of the suggested line. */
            poNumber: string;
            /** @description Description of the suggested purchase-order line. */
            poLineDescription: string;
            /** @description SKU of the suggested purchase-order line, if any. */
            poSku?: null | string;
            /**
             * Format: double
             * @description Quantity ordered on the suggested line.
             */
            quantityOrdered: number | string;
            /**
             * Format: double
             * @description What the suggested purchase-order line can still give — ordered minus everything already allocated against it, expressed in the BILL line's unit. This is the quantity that would be allocated: matching takes a counterpart's whole remaining quantity or none of it, never a part of it that no document states. It is routinely less than quantityOrdered, because a purchase order is shared across bills.
             */
            quantityRemaining: number | string;
            /**
             * Format: double
             * @description Unit price on the suggested line.
             */
            orderedUnitPrice: number | string;
            /**
             * Format: date-time
             * @description Date the suggested purchase order was raised. Null when the order carries no date. This is the order date, not the expected delivery date: it is the one that says whether the order could precede the bill at all, and an order post-dating the invoice is excluded from suggestion entirely.
             */
            poOrderDate?: null | string;
            /**
             * Format: double
             * @description Match confidence (0–1): the line-description similarity between the bill and purchase-order lines, graded by how far the two documents corroborate each other. Description similarity is a bidirectional trigram measure, so a wordy bill line still matches a short catalogue name. It is then multiplied by a header score (currency match and invoice-date-to-expected-delivery proximity) and a line score (unit-price and ordered-quantity proximity), so an identically-named order at a very different price does not read as a full match. Only lines whose raw description similarity exceeds MatchSimilarityThreshold (default 0.7) are suggested at all; the header and line scores then grade and rank them and never exclude a candidate. Every candidate reaching MatchAutoAcceptThreshold is matched automatically rather than suggested — several purchase orders routinely settle one bill line, so a close second is a second match rather than a reason to stand down. A candidate can still clear that bar and not be taken: matching is whole-or-nothing, so an order far larger than what the line still owes is left for the bill it belongs to.
             */
            confidence: number | string;
            /** @description True when this suggestion's confidence was raised because someone already linked another line of this bill to the same purchase order — the rest of a bill usually comes off the same order. A boosted suggestion is never matched automatically, however high its confidence: it is only ranked higher for a reviewer to confirm. */
            manualLinkBoosted?: boolean;
        };
        MatchTestCloneResponse: {
            /** Format: uuid */
            clientId: string;
            name: string;
            organisationIds: string[];
            /** Format: int32 */
            suppliersCopied: number | string;
            /** Format: int32 */
            billsCopied: number | string;
            /** Format: int32 */
            purchaseOrdersCopied: number | string;
            /** Format: int32 */
            deliveryNotesCopied: number | string;
            /** Format: int32 */
            unmatchableDocumentsCopied: number | string;
            rewind: components["schemas"]["MatchRewindResult"];
        };
        /** @description How a merchant category code resolves to an account for this organisation. */
        MccMappingResponse: {
            /** @description The four-digit merchant category code. */
            mcc: string;
            /** @description Human-readable label for the category. */
            label: string;
            /** @description Where the mapping came from: OrganisationOverride (set here), ClientDefault (inherited from the platform), Seed (a Dolfin default with no account), or Unmapped. */
            source: string;
            /**
             * Format: uuid
             * @description The account spend with this category code is coded to.
             */
            ledgerAccountId?: null | string;
            /** @description Name of the mapped account. */
            ledgerAccountName?: null | string;
            /** @description Code of the mapped account. */
            ledgerAccountCode?: null | string;
            /** @description Tax code applied to lines coded through this mapping. */
            taxCode?: null | string;
            /** @description Whether VAT on spend in this category can be reclaimed at all. Entertainment is the common false. */
            isVatReclaimable?: boolean;
        };
        McpSessionDetailResponse: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            organisationId?: string;
            /** Format: uuid */
            apiKeyId?: null | string;
            mcpSessionId: string;
            /** Format: date-time */
            startedAt?: string;
            /** Format: date-time */
            lastCallAt?: string;
            /** Format: int32 */
            callCount?: number | string;
            invocations: components["schemas"]["McpToolInvocationResponse"][];
        };
        McpSessionSummaryResponse: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            apiKeyId?: null | string;
            mcpSessionId: string;
            /** Format: date-time */
            startedAt?: string;
            /** Format: date-time */
            lastCallAt?: string;
            /** Format: int32 */
            callCount?: number | string;
        };
        McpToolInvocationResponse: {
            /** Format: uuid */
            id?: string;
            toolName: string;
            argumentsJson?: null | string;
            resultJson?: null | string;
            success?: boolean;
            /** Format: int32 */
            durationMs?: number | string;
            traceId?: null | string;
            /** Format: date-time */
            createdAt?: string;
        };
        MeClient: {
            /** Format: uuid */
            id: string;
            name: string;
            type: string;
            role: string;
            modules: string[];
        };
        MemberResponse: {
            /** Format: uuid */
            userId: string;
            email: string;
            name?: null | string;
            role: components["schemas"]["ClientRole"];
            /** Format: date-time */
            joinedAt: string;
        };
        MeOrganisation: {
            /** Format: uuid */
            id: string;
            name: string;
            /** Format: uuid */
            clientId: string;
            clientType: string;
            role: string;
            modules: string[];
            /** @description True for a demo organisation: made-up data, every outside connection simulated, and most changes turned off. */
            isDemo?: boolean;
            demoStatus?: null | components["schemas"]["DemoStatus"];
            /**
             * Format: date-time
             * @description When a demo organisation is deleted. Null for an organisation that is not a demo.
             */
            demoExpiresAt?: null | string;
        };
        /** @description One spelling of a merchant, as recognised from card transactions. */
        MerchantAliasResponse: {
            /** @description The spelling after cleaning: payment-processor prefixes, store numbers and punctuation removed. */
            descriptor: string;
            /** @description Up to three descriptors exactly as the card network printed them. */
            seenAs?: string[];
            /** @description How the spelling was linked to the merchant: New (it was the first spelling of a new merchant) or Similar (recognised automatically as a variant of the merchant's name, in a compatible category). */
            method?: components["schemas"]["MerchantMatchMethod"];
            /**
             * Format: double
             * @description For a Similar match, how different the two spellings were in meaning, from 0 (identical). Null otherwise.
             */
            distance?: null | number | string;
            /**
             * Format: date-time
             * @description When the spelling was first seen.
             */
            firstSeenAt?: string;
        };
        /** @enum {unknown} */
        MerchantCategoryGroup: "Agriculture" | "ContractedServices" | "Transportation" | "Utilities" | "RetailStores" | "Clothing" | "MiscellaneousRetail" | "FinancialServices" | "PersonalServices" | "BusinessServices" | "ProfessionalServices" | "Government" | "Entertainment" | "Travel" | null;
        /** @description A merchant with every spelling of it the organisation has seen. */
        MerchantDetailResponse: {
            /** @description Every spelling of the merchant, oldest first. */
            aliases?: components["schemas"]["MerchantAliasResponse"][];
            /**
             * Format: uuid
             * @description Unique identifier of the merchant.
             */
            id?: string;
            /** @description The merchant's name, cleaned of payment-processor prefixes and store numbers. */
            displayName?: null | string;
            /** @description Merchant logo URL, where the card provider supplied one. */
            logoUrl?: null | string;
            /** @description The merchant category code most recently seen for this merchant. */
            mcc?: null | string;
            /** @description Human-readable category for that code. */
            categoryLabel?: null | string;
            /** @description Country the merchant was seen in, where the card network said. */
            country?: null | string;
            /**
             * Format: int32
             * @description How many expenses were spent at this merchant.
             */
            expenseCount?: number | string;
            /** @description Total spent at this merchant, one entry per currency, largest first. */
            spend?: components["schemas"]["MerchantSpendResponse"][];
            /**
             * Format: int32
             * @description How many different spellings of this merchant the card networks have used.
             */
            aliasCount?: number | string;
            /**
             * Format: date-time
             * @description When the merchant was first seen.
             */
            firstSeenAt?: string;
            /**
             * Format: date-time
             * @description When a card was last used at the merchant.
             */
            lastSeenAt?: null | string;
        };
        /**
         * @description How a card descriptor was resolved to a merchant.
         * @enum {unknown}
         */
        MerchantMatchMethod: "New" | "Similar";
        /** @description A merchant the organisation's cards have been used at. */
        MerchantResponse: {
            /**
             * Format: uuid
             * @description Unique identifier of the merchant.
             */
            id?: string;
            /** @description The merchant's name, cleaned of payment-processor prefixes and store numbers. */
            displayName?: null | string;
            /** @description Merchant logo URL, where the card provider supplied one. */
            logoUrl?: null | string;
            /** @description The merchant category code most recently seen for this merchant. */
            mcc?: null | string;
            /** @description Human-readable category for that code. */
            categoryLabel?: null | string;
            /** @description Country the merchant was seen in, where the card network said. */
            country?: null | string;
            /**
             * Format: int32
             * @description How many expenses were spent at this merchant.
             */
            expenseCount?: number | string;
            /** @description Total spent at this merchant, one entry per currency, largest first. */
            spend?: components["schemas"]["MerchantSpendResponse"][];
            /**
             * Format: int32
             * @description How many different spellings of this merchant the card networks have used.
             */
            aliasCount?: number | string;
            /**
             * Format: date-time
             * @description When the merchant was first seen.
             */
            firstSeenAt?: string;
            /**
             * Format: date-time
             * @description When a card was last used at the merchant.
             */
            lastSeenAt?: null | string;
        };
        /** @description Money spent at a merchant in one currency. */
        MerchantSpendResponse: {
            /** @description Currency (ISO 4217). */
            currency: string;
            /**
             * Format: double
             * @description Total amount spent in that currency.
             */
            amount?: number | string;
        };
        MeResponse: {
            /** Format: uuid */
            userId: string;
            email: string;
            name?: null | string;
            organisations: components["schemas"]["MeOrganisation"][];
            clients: components["schemas"]["MeClient"][];
        };
        MethodPaidTotal: {
            /** @description Bill.PaymentMethod free text; blank normalises to 'Unspecified'. */
            method: string;
            /** Format: double */
            paid?: number | string;
            /** Format: int32 */
            billCount?: number | string;
        };
        MethodSignIns: {
            method: components["schemas"]["SignInMethod"];
            /** Format: int32 */
            signIns: number | string;
        };
        MethodTotal: {
            /** @description Stripe | Manual */
            method: string;
            /** Format: double */
            received?: number | string;
            /** Format: int32 */
            paymentCount?: number | string;
        };
        MintDemoLinkAdminRequest: {
            /** @description Email the new link to the prospect. */
            sendEmail?: boolean;
        };
        /** @enum {unknown} */
        ModuleGrantActorType: "System" | "StaffUser" | "AdminApiKey";
        /** @enum {unknown} */
        ModuleGrantState: "NotGranted" | "Granted";
        ModuleResponse: {
            /** @description The immutable module key, such as "ap" or "ap.payments". This never changes once the module is active — display name and description are the mutable labels. */
            key: string;
            /** @description The area key this module belongs to ("ap" for "ap.payments"), or null for a top-level area. Group by this in the UI. It carries no authorisation meaning: holding an area does not grant its features. */
            parentKey?: null | string;
            /** @description Preview (reserved, not sellable), Active (live and grantable), or Deprecated (hidden from new grants, still fully functional for existing holders). */
            status?: components["schemas"]["ModuleStatus"];
            /** @description Whether this module can be added to a client's grants. False for Preview and Deprecated — an existing Deprecated grant is still honoured, it just cannot be handed out again. */
            grantable?: boolean;
            /** @description The commercial name shown to staff and clients. */
            displayName: string;
            /** @description What the module covers, in the words used when selling it. */
            description: string;
            /** Format: date */
            introducedOn?: string;
            /** Format: date */
            deprecatedOn?: null | string;
        };
        /** @enum {unknown} */
        ModuleStatus: "Preview" | "Active" | "Deprecated";
        /** @description One month's profit and loss in brief. Net equals the profit and loss report's net profit for that month. */
        MonthlySummaryMonth: {
            /**
             * Format: date
             * @description The month, as its first day.
             */
            month?: string;
            /**
             * Format: double
             * @description Revenue accounts' total for the month (credit positive; negative if credits such as credit notes exceed income).
             */
            income?: number | string;
            /**
             * Format: double
             * @description Expense accounts' total for the month, cost of sales included (debit positive).
             */
            expenses?: number | string;
            /**
             * Format: double
             * @description Income less expenses.
             */
            net?: number | string;
            /**
             * Format: double
             * @description Accounts in the profit and loss report's Revenue section (credit positive); other income is not included.
             */
            revenue?: number | string;
            /**
             * Format: double
             * @description Accounts in the profit and loss report's CostOfSales section (debit positive).
             */
            costOfSales?: number | string;
            /**
             * Format: double
             * @description Revenue less cost of sales. Equals the profit and loss report's gross profit for that month.
             */
            grossProfit?: number | string;
            /**
             * Format: double
             * @description Accounts in the profit and loss report's OperatingExpenses section (debit positive).
             */
            operatingExpenses?: number | string;
            /**
             * Format: int32
             * @description Journal entries dated in the month, reversals included, opening balances not.
             */
            entryCount?: number | string;
        };
        /** @description Income and expenses per calendar month, for the period selector's bars. */
        MonthlySummaryResponse: {
            /** @description The basis the figures are on: Accrual or Cash. */
            basis?: components["schemas"]["ReportingBasis"];
            /** @description Currency of every amount. */
            currency?: string;
            /** @description Every month in the range, oldest first, zero-filled. */
            months?: components["schemas"]["MonthlySummaryMonth"][];
        };
        /**
         * @description The kinds of account that can be created: expense-side accounts for coding spend, or a current asset that accepts payments.
         * @default Expense
         * @enum {unknown}
         */
        NewLedgerAccountType: "Expense" | "OtherExpense" | "CostOfSales" | "CurrentAsset";
        /** @description One trial-balance row and where it posted. */
        OpeningBalanceRow: {
            /** @description The platform's account id, if the row has one. */
            platformAccountId?: null | string;
            /** @description Account code, when the platform has codes. */
            code?: null | string;
            /** @description Account name as the platform reports it. */
            name?: string;
            /**
             * Format: uuid
             * @description The ledger account it posted to; the opening-balance difference account when unmapped.
             */
            ledgerAccountId?: null | string;
            /** @description True when the platform gave no account, or one missing from the synced chart. */
            unmapped?: boolean;
            /**
             * Format: double
             * @description Debit balance.
             */
            debit?: number | string;
            /**
             * Format: double
             * @description Credit balance.
             */
            credit?: number | string;
        };
        /** @description The opening balances imported from the platform's trial balance. */
        OpeningBalancesResponse: {
            /**
             * Format: date
             * @description The date of the trial balance (the opening-balance date).
             */
            date?: string;
            /** @description The platform report's currency. */
            currency?: null | string;
            /**
             * Format: uuid
             * @description The opening-balance entry in force; null when the platform had no balances (a new business).
             */
            entryId?: null | string;
            /**
             * Format: int32
             * @description Revision of the opening-balance entry: 0 for the first import, one more for each re-import. Null with no entry.
             */
            revision?: null | number | string;
            /** @description False when the trial balance was unchanged since the last import, so nothing was posted. */
            reimported?: boolean;
            /** @description One row per trial-balance line. */
            rows?: components["schemas"]["OpeningBalanceRow"][];
            /**
             * Format: double
             * @description Sum of debits.
             */
            totalDebit?: number | string;
            /**
             * Format: double
             * @description Sum of credits.
             */
            totalCredit?: number | string;
            /**
             * Format: double
             * @description Net amount posted to the opening-balance difference account for unmapped rows (debit positive).
             */
            unmappedNet?: number | string;
        };
        OrganisationAdminResponse: {
            /** Format: uuid */
            clientId?: string;
            /** Format: uuid */
            id?: string;
            name: string;
            /**
             * Format: uuid
             * @description Parent company this organisation belongs to, when it is one site of a multi-site business. Null for a standalone organisation.
             */
            companyId?: null | string;
            /** Format: uuid */
            industryId?: string;
            industryCode?: null | string;
            industryDisplayName?: null | string;
            contactEmail: string;
            phone?: null | string;
            website?: null | string;
            addressLine1?: null | string;
            addressLine2?: null | string;
            city?: null | string;
            /** @description Province, state or county. */
            addressRegion?: null | string;
            postalCode?: null | string;
            /** @description ISO 3166-1 alpha-2 country code (e.g. GB, US, DE) */
            country: string;
            taxNumber?: null | string;
            companyRegistrationNumber?: null | string;
            vatRegistered?: null | boolean;
            /** @description Registered legal name, when it differs from the trading name in Name. */
            legalName?: null | string;
            businessType?: null | components["schemas"]["BusinessType"];
            /** Format: int32 */
            incorporationYear?: null | number | string;
            employeeCount?: null | components["schemas"]["EmployeeCount"];
            annualRevenue?: null | components["schemas"]["AnnualRevenue"];
            avgInvoicesPerMonth?: null | components["schemas"]["AvgInvoicesPerMonth"];
            avgInvoiceValue?: null | components["schemas"]["AvgInvoiceValue"];
            primaryPaymentMethod?: null | components["schemas"]["PrimaryPaymentMethod"];
            primaryColour?: null | string;
            logoUrl?: null | string;
            /** @description ISO 4217 currency code (e.g. GBP, USD, EUR) */
            defaultCurrency?: null | string;
            hasBeenOnboarded?: boolean;
            /** @description True for a demo organisation: made-up data, every outside connection simulated, and most changes turned off. */
            isDemo?: boolean;
            demoStatus?: null | components["schemas"]["DemoStatus"];
            /**
             * Format: date-time
             * @description When a demo organisation is deleted. Null for an organisation that is not a demo.
             */
            demoExpiresAt?: null | string;
            /** Format: date-time */
            createdAt?: string;
            /** Format: uuid */
            createdBy?: null | string;
            /** Format: date-time */
            updatedAt?: string;
            /** Format: uuid */
            updatedBy?: null | string;
        };
        OrganisationAdminSearchHit: {
            /** Format: uuid */
            clientId?: string;
            /** Format: uuid */
            id?: string;
            name: string;
            contactEmail?: null | string;
            /**
             * Format: uuid
             * @description The parent company this organisation already belongs to, if any. Null means it is standalone and can be added to a company.
             */
            companyId?: null | string;
            /**
             * Format: double
             * @description Trigram similarity of the query to the organisation, between 0 and 1. Higher is a closer match.
             */
            score?: number | string;
        };
        /** @description An organisation's accounts-receivable defaults. Each value is the starting point for new invoices; individual invoices may override them. */
        OrganisationArSettingsResponse: {
            /** @description PDF layout copied onto new invoices at draft creation. Defaults to Classic; independent of the email layout. */
            invoicePdfTemplate?: components["schemas"]["InvoicePdfTemplate"];
            /** @description Layout used for future invoice and reminder emails. Defaults to Classic. */
            invoiceEmailTemplate: components["schemas"]["InvoiceEmailTemplate"];
            /**
             * Format: int32
             * @description Default number of days between an invoice's issue date and its due date. Copied onto each new invoice, which may then override it. 0 means due on receipt. Null means the platform default of 30 days applies.
             */
            defaultPaymentTermsDays?: null | number | string;
            /**
             * Format: double
             * @description Percentage fee applied to overdue invoices. Not currently applied automatically.
             */
            latePaymentFee?: null | number | string;
            /** @description Tone used to compose invoice and reminder emails, unless overridden for an individual send. */
            defaultInvoiceMessageTone: components["schemas"]["InvoiceTone"];
            /** @description Reminder schedule applied automatically when an invoice is sent, unless the send call supplies its own. An empty list disables automatic reminders. */
            defaultReminderOffsets: components["schemas"]["InvoiceReminderOffset"][];
            /** @description The organisation's own bank details, shown in the payment details section of the invoice PDF. */
            bankDetails?: components["schemas"]["BankDetails"];
            /** @description Default CC recipients added to every invoice email and its reminders, unless an invoice overrides them. */
            defaultInvoiceCcEmails: string[];
            /** @description Reply-To address for invoice and reminder emails. When null, the organisation's contact email is used. */
            defaultReplyToEmail?: null | string;
            /** @description Prefix for generated invoice numbers, e.g. "INV" produces INV-0001. */
            invoiceNumberPrefix: string;
            /**
             * Format: int64
             * @description The next invoice sequence number that will be allocated for this organisation.
             */
            invoiceNumberNextValue: number | string;
            /**
             * Format: int32
             * @description Minimum digit width of the invoice number sequence, zero-padded (e.g. 4 → 0001).
             */
            invoiceNumberPadding: number | string;
            /** @description Prefix for generated credit note numbers, e.g. "CN" produces CN-00000001. */
            creditNoteNumberPrefix: string;
            /**
             * Format: int64
             * @description The next credit note sequence number that will be allocated for this organisation.
             */
            creditNoteNumberNextValue: number | string;
            /**
             * Format: int32
             * @description Minimum digit width of the credit note number sequence, zero-padded (e.g. 8 → 00000001).
             */
            creditNoteNumberPadding: number | string;
        };
        /** @description An electronic invoice received for this organisation over an e-invoicing network. */
        OrganisationEInvoiceResponse: {
            /** Format: uuid */
            id?: string;
            /** @description Ingested once the document became a bill or a supplier credit note; Rejected when it is not one we can process. */
            state?: components["schemas"]["OrganisationEInvoiceState"];
            /** @description The network it arrived over. */
            network?: components["schemas"]["EInvoicingNetwork"];
            /**
             * Format: uuid
             * @description The bill created from this document. Null when the document was a credit note, or was not processable.
             */
            billId?: null | string;
            /**
             * Format: uuid
             * @description The supplier credit note created from this document. Null when the document was an invoice, or was not processable. On an Ingested document exactly one of billId and supplierCreditNoteId is set, so which one it is tells you what kind of document arrived.
             */
            supplierCreditNoteId?: null | string;
            /** @description The sender's name as stated on the document. */
            supplierName?: null | string;
            /** @description The sender's tax identifier, country-qualified. */
            supplierTaxId?: null | string;
            /** @description The sender's network participant identifier. */
            supplierElectronicAddress?: null | string;
            invoiceNumber?: null | string;
            /** @description The network's own identifier for this document - for SDI, the IdentificativoSdI that SDI's receipts, the tax portal and the supplier quote. Null when the network gives none (Peppol). Filter the list by it. */
            networkReference?: null | string;
            /** Format: date-time */
            invoiceDate?: null | string;
            /** Format: date-time */
            dueDate?: null | string;
            /** Format: double */
            totalAmount?: null | number | string;
            currency?: null | string;
            /**
             * Format: date-time
             * @description When the network delivered the document, which can be earlier than when it was matched to this organisation.
             */
            receivedAt?: string;
            /** @description Anything about the document we could not fully honour, and the reason if it was rejected. */
            faults?: components["schemas"]["EInvoiceFault"][];
        };
        /** @enum {unknown} */
        OrganisationEInvoiceState: "Received" | "Ingested" | "Rejected";
        OrganisationMembershipResponse: {
            /** Format: uuid */
            userId?: string;
            /** Format: uuid */
            organisationId?: string;
            role?: components["schemas"]["OrganisationRole"];
        };
        OrganisationResponse: {
            /** Format: uuid */
            id?: string;
            name: string;
            /**
             * Format: uuid
             * @description Parent company this organisation belongs to, when it is one site of a multi-site business. Null for a standalone organisation.
             */
            companyId?: null | string;
            /** Format: uuid */
            industryId?: string;
            industryCode?: null | string;
            industryDisplayName?: null | string;
            contactEmail: string;
            phone?: null | string;
            website?: null | string;
            addressLine1?: null | string;
            addressLine2?: null | string;
            city?: null | string;
            /** @description Province, state or county. */
            addressRegion?: null | string;
            postalCode?: null | string;
            /** @description ISO 3166-1 alpha-2 country code (e.g. GB, US, DE) */
            country: string;
            taxNumber?: null | string;
            companyRegistrationNumber?: null | string;
            vatRegistered?: null | boolean;
            /** @description Registered legal name, when it differs from the trading name in Name. */
            legalName?: null | string;
            businessType?: null | components["schemas"]["BusinessType"];
            /** Format: int32 */
            incorporationYear?: null | number | string;
            employeeCount?: null | components["schemas"]["EmployeeCount"];
            annualRevenue?: null | components["schemas"]["AnnualRevenue"];
            avgInvoicesPerMonth?: null | components["schemas"]["AvgInvoicesPerMonth"];
            avgInvoiceValue?: null | components["schemas"]["AvgInvoiceValue"];
            primaryPaymentMethod?: null | components["schemas"]["PrimaryPaymentMethod"];
            primaryColour?: null | string;
            logoUrl?: null | string;
            /** @description ISO 4217 currency code (e.g. GBP, USD, EUR) */
            defaultCurrency?: null | string;
            hasBeenOnboarded?: boolean;
            /** @description True for a demo organisation: made-up data, every outside connection simulated, and most changes turned off. */
            isDemo?: boolean;
            demoStatus?: null | components["schemas"]["DemoStatus"];
            /**
             * Format: date-time
             * @description When a demo organisation is deleted. Null for an organisation that is not a demo.
             */
            demoExpiresAt?: null | string;
            /** Format: date-time */
            createdAt?: string;
            /** Format: uuid */
            createdBy?: null | string;
            /** Format: date-time */
            updatedAt?: string;
            /** Format: uuid */
            updatedBy?: null | string;
        };
        /** @enum {unknown} */
        OrganisationRole: "Member" | "Admin" | "Owner";
        OrganisationSearchHit: {
            /** Format: uuid */
            id?: string;
            name: string;
            contactEmail?: null | string;
            /**
             * Format: uuid
             * @description The parent company this organisation already belongs to, if any. Null means it is standalone and can be added to a company.
             */
            companyId?: null | string;
            /**
             * Format: double
             * @description Trigram similarity of the query to the organisation, between 0 and 1. Higher is a closer match.
             */
            score?: number | string;
        };
        OrganisationUserResponse: {
            role: components["schemas"]["OrganisationRole"];
            /** Format: uuid */
            id?: string;
            email: string;
            name?: null | string;
            /** Format: date-time */
            createdAt?: string;
        };
        OsSignIns: {
            os: components["schemas"]["DeviceOs"];
            /** Format: int32 */
            signIns: number | string;
        };
        /** @enum {unknown} */
        OutboundDocumentKind: "Invoice" | "CreditNote";
        OutboundEInvoiceAdminView: {
            /**
             * Format: uuid
             * @description The organisation that sent the document.
             */
            organisationId?: string;
            /** @description That organisation's name. */
            organisationName?: null | string;
            /** @description Every id the network has given this document, across attempts, oldest first. */
            networkReferences?: string[];
            /**
             * Format: uuid
             * @description Stable identifier for this invoice's electronic delivery.
             */
            id?: string;
            /**
             * Format: uuid
             * @description The invoice being delivered, or - for a credit note - the invoice it credits.
             */
            invoiceId?: string;
            /** @description Whether this delivery carries an invoice or a credit note. */
            documentKind?: components["schemas"]["OutboundDocumentKind"];
            /**
             * Format: uuid
             * @description The credit note being delivered. Null when the delivery carries an invoice.
             */
            creditNoteId?: null | string;
            /** @description The document's number as it appears on the electronic document. */
            documentNumber?: null | string;
            /** @description How far the delivery has got. The same states for every network; a network skips the ones it has no signal for. Validated: built and checked, not yet sent. Submitted: handed to the network, awaiting the send's result. Accepted: the network took charge of the document and its verdict is still to come (SDI; a rejection usually arrives within minutes, delivery within up to five days) - not yet a success. Delivered: reached the recipient. MadeAvailable: legally issued but not delivered; the network holds it for the recipient to collect (SDI files it on the buyer's tax portal), so tell the customer - do not send again. DeliveryFailed: refused; see faults, canRetry and canCorrectAndResubmit. Abandoned: the send never started. Peppol goes Submitted -> Delivered; SDI goes Submitted -> Accepted -> Delivered | MadeAvailable | DeliveryFailed. */
            state?: components["schemas"]["OutboundEInvoiceState"];
            /** @description The network the document travels over. */
            network?: components["schemas"]["EInvoicingNetwork"];
            /** @description The country whose e-invoicing setup sent the document. */
            country?: null | string;
            /** @description True when the document went to a test environment and reached no real recipient or authority. */
            sandbox?: boolean;
            /** @description Where the network was told to deliver this document: the codice destinatario, certified email or participant id that went on the invoice. Recorded as it was sent, so correcting the customer afterwards does not change what this says was done. */
            recipientAddress?: null | string;
            /** @description Which channel the recipient address belongs to. */
            recipientScheme?: null | string;
            /** @description Why the delivery failed, when it did. Decides whether it can be retried. */
            failureKind?: components["schemas"]["OutboundEInvoiceFailureKind"];
            /** @description What the network said went wrong, one entry per fault. Empty unless the delivery failed. Each carries the network's own code where it gives one, the message to show a person, and the stage of sending that produced it. */
            faults?: components["schemas"]["ProviderFaultDetail"][];
            /** @description Whether the delivery can be sent again with POST /invoices/{id}/e-invoice/resend (or the credit-note equivalent). True when it failed or was abandoned and either the document may be corrected or the same document could succeed on another attempt. */
            canResend?: boolean;
            /** @description Whether a resend builds a new document from the current customer and organisation data. True only when nothing reached the network, for example when the recipient could not be found or SDI rejected the document (NS). When false, a resend sends the saved document again, because the recipient may already hold it. */
            resendRebuildsDocument?: boolean;
            /** @description Deprecated: use canResend. Whether sending this same document again could succeed. */
            canRetry?: boolean;
            /**
             * Format: int32
             * @description Workflow attempt number across this invoice's document revisions.
             */
            attempt?: number | string;
            /**
             * Format: int32
             * @description Document version. A retry re-sends the same revision; a correction creates the next one.
             */
            revision?: number | string;
            /** @description Deprecated: use canResend and resendRebuildsDocument. Whether a corrected document may be sent after the network refused the document without issuing it. */
            canCorrectAndResubmit?: boolean;
            /** @description What the network, or the recipient through it, reported about the current document, oldest first. The state is derived from these; networkCode keeps the network's own code (SDI: RC, NS, MC...). Earlier documents keep theirs under previousAttempts. */
            networkEvents?: components["schemas"]["OutboundNetworkEvent"][];
            /** @description The network's own identifier for the current submission, when it gives one (SDI's submission id). */
            networkReference?: null | string;
            /** @description Completed earlier attempts, oldest first. Recovery of an uncertain send does not add an attempt. Legacy history may be incomplete. */
            previousAttempts?: components["schemas"]["OutboundEInvoiceAttemptView"][];
            /**
             * Format: date-time
             * @description When the document was handed to the network.
             */
            submittedAt?: null | string;
            /**
             * Format: date-time
             * @description When the network took charge of the document, when its verdict comes later (SDI).
             */
            acceptedAt?: null | string;
            /**
             * Format: date-time
             * @description When the document reached the recipient.
             */
            deliveredAt?: null | string;
            /**
             * Format: date-time
             * @description When the network reported the document issued but not delivered, and held for the recipient.
             */
            madeAvailableAt?: null | string;
            /**
             * Format: date-time
             * @description When the delivery failed.
             */
            failedAt?: null | string;
            /**
             * Format: date-time
             * @description When the delivery was first attempted.
             */
            createdAt?: string;
            /** @description The customer the invoice (or the credited invoice) was issued to. */
            customerName?: null | string;
            /**
             * Format: double
             * @description The document's total, in its own currency: the invoice total, or the credit note's amount.
             */
            totalAmount?: null | number | string;
            /** @description ISO 4217 currency code of the document. */
            currency?: null | string;
            /**
             * Format: date-time
             * @description The date the document was issued.
             */
            issueDate?: null | string;
        };
        /** @description An earlier attempt at this invoice's electronic delivery, as it concluded. */
        OutboundEInvoiceAttemptView: {
            /**
             * Format: int32
             * @description Attempt number.
             */
            attempt?: number | string;
            /**
             * Format: int32
             * @description Document version that attempt sent.
             */
            revision?: number | string;
            /**
             * Format: uuid
             * @description Provider identifier of the document that attempt sent.
             */
            siloEntryId?: string;
            /** @description Provider identifier of that attempt's workflow run. */
            jobId?: null | string;
            /** @description How that attempt ended. See the delivery's state for the meaning of each value. */
            state?: components["schemas"]["OutboundEInvoiceState"];
            /** @description Which channel that attempt's recipient address belonged to. */
            recipientScheme?: null | string;
            /** @description Where that attempt told the network to deliver. */
            recipientAddress?: null | string;
            /** @description Why that attempt failed, when it did. */
            failureKind?: components["schemas"]["OutboundEInvoiceFailureKind"];
            /** @description What went wrong in that attempt, in the network's own terms. */
            faults?: components["schemas"]["ProviderFaultDetail"][];
            /**
             * Format: date-time
             * @description When that attempt began.
             */
            startedAt?: null | string;
            /**
             * Format: date-time
             * @description When that attempt's document was handed to the network.
             */
            submittedAt?: null | string;
            /**
             * Format: date-time
             * @description When that attempt failed.
             */
            failedAt?: null | string;
            /**
             * Format: date-time
             * @description When that attempt's document reached the recipient.
             */
            deliveredAt?: null | string;
            /**
             * Format: date-time
             * @description When the network took charge of that attempt's document.
             */
            acceptedAt?: null | string;
            /**
             * Format: date-time
             * @description When the network reported that attempt's document issued but not delivered.
             */
            madeAvailableAt?: null | string;
            /** @description The network's own identifier for that attempt's submission. */
            networkReference?: null | string;
            /** @description What the network reported about that attempt's document, oldest first. */
            networkEvents?: components["schemas"]["OutboundNetworkEvent"][];
        };
        /** @enum {unknown} */
        OutboundEInvoiceFailureKind: "None" | "DocumentRejected" | "RecipientUnreachable" | "NetworkFailed" | "Unknown";
        /** @enum {unknown} */
        OutboundEInvoiceState: "Validated" | "Submitted" | "Delivered" | "DeliveryFailed" | "Abandoned" | "Accepted" | "MadeAvailable";
        OutboundEInvoiceView: {
            /**
             * Format: uuid
             * @description Stable identifier for this invoice's electronic delivery.
             */
            id?: string;
            /**
             * Format: uuid
             * @description The invoice being delivered, or - for a credit note - the invoice it credits.
             */
            invoiceId?: string;
            /** @description Whether this delivery carries an invoice or a credit note. */
            documentKind?: components["schemas"]["OutboundDocumentKind"];
            /**
             * Format: uuid
             * @description The credit note being delivered. Null when the delivery carries an invoice.
             */
            creditNoteId?: null | string;
            /** @description The document's number as it appears on the electronic document. */
            documentNumber?: null | string;
            /** @description How far the delivery has got. The same states for every network; a network skips the ones it has no signal for. Validated: built and checked, not yet sent. Submitted: handed to the network, awaiting the send's result. Accepted: the network took charge of the document and its verdict is still to come (SDI; a rejection usually arrives within minutes, delivery within up to five days) - not yet a success. Delivered: reached the recipient. MadeAvailable: legally issued but not delivered; the network holds it for the recipient to collect (SDI files it on the buyer's tax portal), so tell the customer - do not send again. DeliveryFailed: refused; see faults, canRetry and canCorrectAndResubmit. Abandoned: the send never started. Peppol goes Submitted -> Delivered; SDI goes Submitted -> Accepted -> Delivered | MadeAvailable | DeliveryFailed. */
            state?: components["schemas"]["OutboundEInvoiceState"];
            /** @description The network the document travels over. */
            network?: components["schemas"]["EInvoicingNetwork"];
            /** @description The country whose e-invoicing setup sent the document. */
            country?: null | string;
            /** @description True when the document went to a test environment and reached no real recipient or authority. */
            sandbox?: boolean;
            /** @description Where the network was told to deliver this document: the codice destinatario, certified email or participant id that went on the invoice. Recorded as it was sent, so correcting the customer afterwards does not change what this says was done. */
            recipientAddress?: null | string;
            /** @description Which channel the recipient address belongs to. */
            recipientScheme?: null | string;
            /** @description Why the delivery failed, when it did. Decides whether it can be retried. */
            failureKind?: components["schemas"]["OutboundEInvoiceFailureKind"];
            /** @description What the network said went wrong, one entry per fault. Empty unless the delivery failed. Each carries the network's own code where it gives one, the message to show a person, and the stage of sending that produced it. */
            faults?: components["schemas"]["ProviderFaultDetail"][];
            /** @description Whether the delivery can be sent again with POST /invoices/{id}/e-invoice/resend (or the credit-note equivalent). True when it failed or was abandoned and either the document may be corrected or the same document could succeed on another attempt. */
            canResend?: boolean;
            /** @description Whether a resend builds a new document from the current customer and organisation data. True only when nothing reached the network, for example when the recipient could not be found or SDI rejected the document (NS). When false, a resend sends the saved document again, because the recipient may already hold it. */
            resendRebuildsDocument?: boolean;
            /** @description Deprecated: use canResend. Whether sending this same document again could succeed. */
            canRetry?: boolean;
            /**
             * Format: int32
             * @description Workflow attempt number across this invoice's document revisions.
             */
            attempt?: number | string;
            /**
             * Format: int32
             * @description Document version. A retry re-sends the same revision; a correction creates the next one.
             */
            revision?: number | string;
            /** @description Deprecated: use canResend and resendRebuildsDocument. Whether a corrected document may be sent after the network refused the document without issuing it. */
            canCorrectAndResubmit?: boolean;
            /** @description What the network, or the recipient through it, reported about the current document, oldest first. The state is derived from these; networkCode keeps the network's own code (SDI: RC, NS, MC...). Earlier documents keep theirs under previousAttempts. */
            networkEvents?: components["schemas"]["OutboundNetworkEvent"][];
            /** @description The network's own identifier for the current submission, when it gives one (SDI's submission id). */
            networkReference?: null | string;
            /** @description Completed earlier attempts, oldest first. Recovery of an uncertain send does not add an attempt. Legacy history may be incomplete. */
            previousAttempts?: components["schemas"]["OutboundEInvoiceAttemptView"][];
            /**
             * Format: date-time
             * @description When the document was handed to the network.
             */
            submittedAt?: null | string;
            /**
             * Format: date-time
             * @description When the network took charge of the document, when its verdict comes later (SDI).
             */
            acceptedAt?: null | string;
            /**
             * Format: date-time
             * @description When the document reached the recipient.
             */
            deliveredAt?: null | string;
            /**
             * Format: date-time
             * @description When the network reported the document issued but not delivered, and held for the recipient.
             */
            madeAvailableAt?: null | string;
            /**
             * Format: date-time
             * @description When the delivery failed.
             */
            failedAt?: null | string;
            /**
             * Format: date-time
             * @description When the delivery was first attempted.
             */
            createdAt?: string;
            /** @description The customer the invoice (or the credited invoice) was issued to. */
            customerName?: null | string;
            /**
             * Format: double
             * @description The document's total, in its own currency: the invoice total, or the credit note's amount.
             */
            totalAmount?: null | number | string;
            /** @description ISO 4217 currency code of the document. */
            currency?: null | string;
            /**
             * Format: date-time
             * @description The date the document was issued.
             */
            issueDate?: null | string;
        };
        /** @description One thing the e-invoicing network, or the recipient through it, reported about a sent document. Listed oldest first on the delivery; the delivery's state is derived from them. */
        OutboundNetworkEvent: {
            /** @description Provider identifier for this report. Stable, so a report delivered twice is recorded once. */
            id: string;
            /**
             * Format: date-time
             * @description When the report was recorded.
             */
            at?: string;
            /** @description Who spoke: the network reporting on the document, or the recipient answering it. */
            source?: components["schemas"]["OutboundNetworkEventSource"];
            /** @description What the report means, independent of network: Accepted (taken in charge, verdict to come), Delivered, MadeAvailable (issued but not delivered; held for the recipient to collect), Rejected (refused by the network), RecipientAccepted, RecipientRejected, or Other (recorded only). */
            outcome?: components["schemas"]["OutboundNetworkEventOutcome"];
            /** @description The network's own code for the report, when it has one — e.g. SDI's RC (delivered), NS (rejected), MC (not delivered, filed on the buyer's tax portal). Null for events the network gives no code for. */
            networkCode?: null | string;
            /** @description The network's own identifier for the message, when it has one — e.g. SDI's message id. */
            networkReference?: null | string;
            /** @description Plain-language account of the report, as the network or provider phrased it. */
            description?: null | string;
            /** @description Structured reasons the network gave, for a rejection. Empty otherwise. */
            faults?: components["schemas"]["ProviderFaultDetail"][];
        };
        /** @enum {unknown} */
        OutboundNetworkEventOutcome: "Other" | "Accepted" | "Delivered" | "MadeAvailable" | "Rejected" | "RecipientAccepted" | "RecipientRejected";
        /** @enum {unknown} */
        OutboundNetworkEventSource: "Network" | "Recipient";
        OutstandingCustomerRow: {
            /** Format: uuid */
            customerId?: string;
            customerName: string;
            currency: string;
            /** Format: double */
            totalOutstanding?: number | string;
            /** Format: double */
            overdueAmount?: number | string;
            /** Format: double */
            notYetDueAmount?: number | string;
            /** Format: int32 */
            invoiceCount?: number | string;
            /** Format: int32 */
            maxDaysOverdue?: number | string;
            oldestInvoice?: null | components["schemas"]["InvoiceSummary"];
            invoiceIds?: string[];
        };
        OutstandingPayablesResponse: {
            /** Format: date */
            asOf?: string;
            totals: components["schemas"]["OutstandingPayablesTotals"];
            aging?: components["schemas"]["CurrencyAging"][];
            /** @description One row per supplier per currency — a supplier billing in multiple currencies appears once per currency. Amounts are never summed across currencies. Org default currency rows first, largest to-pay first within each currency. */
            suppliers?: components["schemas"]["OutstandingSupplierRow"][];
            recommendation: components["schemas"]["Recommendation"];
        };
        OutstandingPayablesTotals: {
            /**
             * Format: int32
             * @description Distinct suppliers with bills to pay. May be lower than the number of Suppliers rows, which are per (supplier, currency).
             */
            supplierCount?: number | string;
            /** Format: int32 */
            billCount?: number | string;
            /** @description Committed liability: bills in Approved, Scheduled or PaymentFailed (a failed payment moved no money, so the bill is still owed). Bills still in review are NOT included — see InReviewByCurrency. Bills with a payment in progress are NOT included — see PaymentInProgressByCurrency. */
            toPayByCurrency?: components["schemas"]["CurrencyTotal"][];
            notYetDueByCurrency?: components["schemas"]["CurrencyTotal"][];
            overdueByCurrency?: components["schemas"]["CurrencyTotal"][];
            /** @description Subset of NotYetDue falling due within the next 7 days — the cash about to go out. */
            dueWithin7DaysByCurrency?: components["schemas"]["CurrencyTotal"][];
            /** @description Bills in PendingReview or NeedsApproval — pipeline, not yet a committed liability. Never part of ToPay. */
            inReviewByCurrency?: components["schemas"]["CurrencyTotal"][];
            /** @description Bills in PaymentInProgress — a pay-by-bank payment has been started and money may already be on its way. Still owed until it completes, but never part of ToPay or Overdue, so they are not paid twice. */
            paymentInProgressByCurrency?: components["schemas"]["CurrencyTotal"][];
        };
        OutstandingResponse: {
            /** Format: date */
            asOf?: string;
            totals: components["schemas"]["OutstandingTotals"];
            aging?: components["schemas"]["CurrencyAging"][];
            /** @description One row per customer per currency — a customer invoicing in multiple currencies appears once per currency. Amounts are never summed across currencies. Org default currency rows first, largest outstanding first within each currency. */
            customers?: components["schemas"]["OutstandingCustomerRow"][];
            recommendation: components["schemas"]["Recommendation"];
        };
        OutstandingSupplierRow: {
            /**
             * Format: uuid
             * @description Null when OCR extracted a supplier name but no Supplier record was ever matched — suggest fixing the match rather than ignoring the bill.
             */
            supplierId?: null | string;
            supplierName: string;
            currency: string;
            /** Format: double */
            totalToPay?: number | string;
            /** Format: double */
            overdueAmount?: number | string;
            /** Format: double */
            notYetDueAmount?: number | string;
            /** Format: int32 */
            billCount?: number | string;
            /** Format: int32 */
            maxDaysOverdue?: number | string;
            oldestBill?: null | components["schemas"]["BillSummary"];
            billIds?: string[];
        };
        OutstandingTotals: {
            /**
             * Format: int32
             * @description Distinct customers with open invoices. May be lower than the number of Customers rows, which are per (customer, currency).
             */
            customerCount?: number | string;
            /** Format: int32 */
            invoiceCount?: number | string;
            outstandingByCurrency?: components["schemas"]["CurrencyTotal"][];
            notYetDueByCurrency?: components["schemas"]["CurrencyTotal"][];
            overdueByCurrency?: components["schemas"]["CurrencyTotal"][];
        };
        OverdueCustomerRow: {
            /** Format: uuid */
            customerId?: string;
            customerName: string;
            currency: string;
            /** Format: double */
            totalOverdue?: number | string;
            /** Format: int32 */
            invoiceCount?: number | string;
            oldestInvoice?: null | components["schemas"]["InvoiceSummary"];
            /** @description gentle | firm | final | escalation */
            tier: string;
            /** @description send_reminder | call_or_escalate | wait */
            suggestedAction: string;
            /** @description friendly | direct | formal */
            suggestedTone: string;
            /** Format: date-time */
            lastReminderSentAt?: null | string;
            /** Format: int32 */
            daysSinceLastReminder?: null | number | string;
            paymentBehaviour?: null | components["schemas"]["PaymentBehaviour"];
            invoiceIds?: string[];
        };
        OverduePayablesResponse: {
            /** Format: date */
            asOf?: string;
            totals: components["schemas"]["OverduePayablesTotals"];
            aging?: components["schemas"]["CurrencyAging"][];
            /** @description One row per supplier per currency — amounts are never summed across currencies. Org default currency rows first, most days overdue first within each currency. */
            suppliers?: components["schemas"]["OverdueSupplierRow"][];
        };
        /** @description Overdue payables in brief. */
        OverduePayablesSummary: {
            /** @description Overdue totals per currency, as in GET /payables/overdue. */
            totals: components["schemas"]["OverduePayablesTotals"];
            /** @description Up to 5 overdue supplier rows, in the order GET /payables/overdue returns them (org default currency first, most overdue first). */
            suppliers?: components["schemas"]["OverdueSupplierRow"][];
        };
        OverduePayablesTotals: {
            /**
             * Format: int32
             * @description Distinct suppliers with overdue bills. May be lower than the number of Suppliers rows, which are per (supplier, currency).
             */
            supplierCount?: number | string;
            /** Format: int32 */
            billCount?: number | string;
            overdueByCurrency?: components["schemas"]["CurrencyTotal"][];
        };
        OverdueResponse: {
            /** Format: date */
            asOf?: string;
            totals: components["schemas"]["OverdueTotals"];
            aging?: components["schemas"]["CurrencyAging"][];
            /** @description One row per customer per currency — a customer overdue in multiple currencies appears once per currency. Amounts are never summed across currencies. Org default currency rows first, most days overdue first within each currency. */
            customers?: components["schemas"]["OverdueCustomerRow"][];
        };
        /** @description Overdue receivables in brief. */
        OverdueSummary: {
            /** @description Overdue totals per currency, as in GET /receivables/overdue. */
            totals: components["schemas"]["OverdueTotals"];
            /** @description Up to 5 overdue customer rows, in the order GET /receivables/overdue returns them (org default currency first, most overdue first). */
            customers?: components["schemas"]["OverdueCustomerRow"][];
        };
        OverdueSupplierRow: {
            /**
             * Format: uuid
             * @description Null when OCR extracted a supplier name but no Supplier record was ever matched.
             */
            supplierId?: null | string;
            supplierName: string;
            currency: string;
            /** Format: double */
            totalOverdue?: number | string;
            /** Format: int32 */
            billCount?: number | string;
            oldestBill?: null | components["schemas"]["BillSummary"];
            /** @description low | medium | high | critical */
            urgency: string;
            /** @description schedule_payment | confirm_or_reschedule | wait. 'wait' means every overdue bill already has a future payment scheduled — never suggest paying twice. */
            suggestedAction: string;
            /**
             * Format: date
             * @description Earliest scheduled payment date among the supplier's overdue bills, when any are Scheduled.
             */
            scheduledPaymentDate?: null | string;
            paymentTiming?: null | components["schemas"]["SupplierPaymentTiming"];
            billIds?: string[];
        };
        OverdueTotals: {
            /**
             * Format: int32
             * @description Distinct customers with overdue invoices. May be lower than the number of Customers rows, which are per (customer, currency).
             */
            customerCount?: number | string;
            /** Format: int32 */
            invoiceCount?: number | string;
            overdueByCurrency?: components["schemas"]["CurrencyTotal"][];
        };
        PagedResponseCursors: {
            current?: null | string;
            next?: null | string;
            previous?: null | string;
        };
        PagedResponseMeta: {
            cursors?: components["schemas"]["PagedResponseCursors"];
        };
        PagedResponseOfAdminAgentMessageResponse: {
            data?: components["schemas"]["AdminAgentMessageResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfAdminConversationResponse: {
            data?: components["schemas"]["AdminConversationResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfAdminInvoiceEmailResponse: {
            data?: components["schemas"]["AdminInvoiceEmailResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfAdminInvoiceReminderResponse: {
            data?: components["schemas"]["AdminInvoiceReminderResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfApiKeyResponse: {
            data?: components["schemas"]["ApiKeyResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfBankAccountResponse: {
            data?: components["schemas"]["BankAccountResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfBankConnectionResponse: {
            data?: components["schemas"]["BankConnectionResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfBankLineResponse: {
            data?: components["schemas"]["BankLineResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfBankTransactionResponse: {
            data?: components["schemas"]["BankTransactionResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfBillActivityResponse: {
            data?: components["schemas"]["BillActivityResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfBillAuditLogResponse: {
            data?: components["schemas"]["BillAuditLogResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfBillLlmExtractionResponse: {
            data?: components["schemas"]["BillLlmExtractionResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfBillResponse: {
            data?: components["schemas"]["BillResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfCardConnectionResponse: {
            data?: components["schemas"]["CardConnectionResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfCardTransactionResponse: {
            data?: components["schemas"]["CardTransactionResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfClientAdminResponse: {
            data?: components["schemas"]["ClientAdminResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfClientModuleAuditLogResponse: {
            data?: components["schemas"]["ClientModuleAuditLogResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfClientResponse: {
            data?: components["schemas"]["ClientResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfCompanyAdminResponse: {
            data?: components["schemas"]["CompanyAdminResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfCompanyInboxBillResponse: {
            data?: components["schemas"]["CompanyInboxBillResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfCompanyResponse: {
            data?: components["schemas"]["CompanyResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfConversationMessageResponse: {
            data?: components["schemas"]["ConversationMessageResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfConversationSummaryResponse: {
            data?: components["schemas"]["ConversationSummaryResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfCreditNoteResponse: {
            data?: components["schemas"]["CreditNoteResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfCustomerResponse: {
            data?: components["schemas"]["CustomerResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfDeliveryNoteResponse: {
            data?: components["schemas"]["DeliveryNoteResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfEInvoicingRegistrationAdminResponse: {
            data?: components["schemas"]["EInvoicingRegistrationAdminResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfExpenseResponse: {
            data?: components["schemas"]["ExpenseResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfGmailAuditLogResponse: {
            data?: components["schemas"]["GmailAuditLogResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfGmailCandidateResponse: {
            data?: components["schemas"]["GmailCandidateResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfGmailConnectionAdminListItem: {
            data?: components["schemas"]["GmailConnectionAdminListItem"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfInboundEmailResponse: {
            data?: components["schemas"]["InboundEmailResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfInvoiceActivityResponse: {
            data?: components["schemas"]["InvoiceActivityResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfInvoiceAuditLogResponse: {
            data?: components["schemas"]["InvoiceAuditLogResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfInvoicePaymentResponse: {
            data?: components["schemas"]["InvoicePaymentResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfInvoiceResponse: {
            data?: components["schemas"]["InvoiceResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfMagicLinkResponse: {
            data?: components["schemas"]["MagicLinkResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfMatchCandidateAdminRow: {
            data?: components["schemas"]["MatchCandidateAdminRow"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfMatchGroupSummaryResponse: {
            data?: components["schemas"]["MatchGroupSummaryResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfMatchLineAdminRow: {
            data?: components["schemas"]["MatchLineAdminRow"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfMcpSessionSummaryResponse: {
            data?: components["schemas"]["McpSessionSummaryResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfMcpToolInvocationResponse: {
            data?: components["schemas"]["McpToolInvocationResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfMerchantResponse: {
            data?: components["schemas"]["MerchantResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfOrganisationAdminResponse: {
            data?: components["schemas"]["OrganisationAdminResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfOrganisationEInvoiceResponse: {
            data?: components["schemas"]["OrganisationEInvoiceResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfOrganisationResponse: {
            data?: components["schemas"]["OrganisationResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfOrganisationUserResponse: {
            data?: components["schemas"]["OrganisationUserResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfOutboundEInvoiceAdminView: {
            data?: components["schemas"]["OutboundEInvoiceAdminView"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfOutboundEInvoiceView: {
            data?: components["schemas"]["OutboundEInvoiceView"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfPostingResponse: {
            data?: components["schemas"]["PostingResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfProductResponse: {
            data?: components["schemas"]["ProductResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfPurchaseOrderResponse: {
            data?: components["schemas"]["PurchaseOrderResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfReceiptLlmExtractionResponse: {
            data?: components["schemas"]["ReceiptLlmExtractionResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfReceiptResponse: {
            data?: components["schemas"]["ReceiptResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfReceivedEInvoiceAdminResponse: {
            data?: components["schemas"]["ReceivedEInvoiceAdminResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfRecurringInvoiceScheduleResponse: {
            data?: components["schemas"]["RecurringInvoiceScheduleResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfSupplierCreditLedgerEntryResponse: {
            data?: components["schemas"]["SupplierCreditLedgerEntryResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfSupplierCreditNoteResponse: {
            data?: components["schemas"]["SupplierCreditNoteResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfSupplierResponse: {
            data?: components["schemas"]["SupplierResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfTaxRateResponse: {
            data?: components["schemas"]["TaxRateResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfUserActivityUserRow: {
            data?: components["schemas"]["UserActivityUserRow"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfUserResponse: {
            data?: components["schemas"]["UserResponse"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PagedResponseOfUserSignInRow: {
            data?: components["schemas"]["UserSignInRow"][];
            meta?: components["schemas"]["PagedResponseMeta"];
        };
        PaidBucket: {
            /** Format: date */
            periodStart?: string;
            /** Format: date */
            periodEnd?: string;
            /** Format: double */
            paid?: number | string;
            /** Format: int32 */
            billCount?: number | string;
        };
        /** @description Cash paid out over the last 30 days. */
        PaidPayablesSummary: {
            /** @description Totals for the last 30 days, in the organisation's default currency. */
            last30Days: components["schemas"]["PaidTotals"];
            /** @description The last 30 days against the 30 before, in the organisation's default currency. */
            trend: components["schemas"]["PaidTrend"];
            /** @description Total paid per currency over the last 30 days, covering every currency. */
            paidByCurrency?: components["schemas"]["CurrencyTotal"][];
        };
        PaidResponse: {
            /** Format: date */
            asOf?: string;
            period?: components["schemas"]["LookbackPeriod"];
            /** Format: date */
            periodStart?: string;
            /** Format: date */
            periodEnd?: string;
            /** @description daily | weekly | monthly */
            granularity: string;
            /** @description The primary currency the Summary, Trend, PaymentTiming, Buckets, ByMethod and TopSuppliers fields are reported in. See PaidByCurrency for activity in every currency. */
            currency: string;
            /** @description Total paid per currency across the period — covers ALL currencies, not just the primary one. Use this for the headline figure when the org pays in multiple currencies so amounts are never reported as zero. */
            paidByCurrency?: components["schemas"]["CurrencyTotal"][];
            summary: components["schemas"]["PaidTotals"];
            trend: components["schemas"]["PaidTrend"];
            paymentTiming: components["schemas"]["PaymentTiming"];
            buckets?: components["schemas"]["PaidBucket"][];
            byMethod?: components["schemas"]["MethodPaidTotal"][];
            topSuppliers?: components["schemas"]["SupplierPaid"][];
        };
        PaidTotals: {
            /** Format: double */
            totalPaid?: number | string;
            /** Format: int32 */
            billCount?: number | string;
            /** Format: int32 */
            uniqueSuppliers?: number | string;
            /** Format: double */
            averageBill?: number | string;
        };
        PaidTrend: {
            /** Format: date */
            previousPeriodStart?: string;
            /** Format: date */
            previousPeriodEnd?: string;
            /** Format: double */
            previousTotal?: number | string;
            /** Format: double */
            deltaAmount?: number | string;
            /**
             * Format: double
             * @description Fractional change vs the prior equal-length window. Null when the prior window paid nothing.
             */
            deltaPercent?: null | number | string;
            /** @description up | down | flat */
            direction: string;
        };
        PatchApSettingsRequest: {
            /** @description Client-level opt-out for outbound AP (bill) notification emails. Set false to stop sending approval-request emails to approvers and approved/rejected notices to the submitter; bills still move through approval unchanged. */
            apEmailsEnabled?: null | boolean;
            /** @description Client-level opt-in to the Yapily pay-by-bank flow for this client's organisations. */
            payByBankEnabled?: null | boolean;
            paymentLinkMode?: null | components["schemas"]["ApPaymentLinkMode"];
            /** @description Bring-your-own payment link template, used when paymentLinkMode is BringYourOwn. An absolute https URL of at most 2048 characters; may contain the tokens {billId}, {organisationId} and {supplierId}, each URL-encoded on expansion. Send an empty string to clear it. */
            defaultBillPaymentLinkUrl?: null | string;
            /** @description Cosmetic subdomain label for the bill-forwarding address (bills.<token>@<slug>.accountspayable.co). A single DNS label: 1-63 characters, lowercase letters, digits or hyphens, with no leading or trailing hyphen. Defaults to a slug of the client name when unset. Not a routing key — forwarded bills route by the organisation's inbound token alone. */
            billForwardingSlug?: null | string;
            /**
             * Format: int32
             * @description Token TTL for bill-approval links, in days (a link expires this many days after the bill's due date). Must be a positive integer.
             */
            billReviewTimeAfterDueDate?: null | number | string;
            /** @description Client-level opt-out for duplicate bill detection. Set false to stop checking newly extracted bills against existing ones for the same supplier and invoice number — intended for testing (replaying the same document), since it also removes the approval block on a flagged bill. */
            duplicateBillDetectionEnabled?: null | boolean;
            /** @description Client-level opt-in to the Gmail bill-ingestion connector for this client's organisations. */
            gmailConnectorEnabled?: null | boolean;
            /** @description Hosts the Gmail connector OAuth flow may redirect back to after authorisation. Provide bare hostnames (e.g. portal.example.com), without scheme, port, or path. Replaces the existing list. */
            gmailAllowedRedirectHosts?: null | string[];
            /** @description Hosts the pay-by-bank and bank connection flows may redirect back to after bank authorisation. Provide bare hostnames (e.g. portal.example.com), without scheme, port, or path. Replaces the existing list. */
            paymentAllowedRedirectHosts?: null | string[];
            /**
             * Format: double
             * @description Per-line rounding tolerance (in the bill's currency) for three-way matching. Must be >= 0.
             */
            matchRoundingTolerance?: null | number | string;
            /**
             * Format: double
             * @description Minimum description-similarity score to suggest a fuzzy PO/DN line match. Must be between 0 and 1.
             */
            matchSimilarityThreshold?: null | number | string;
            /**
             * Format: int32
             * @description How many days a purchase order's expected delivery date may fall BEFORE the bill's invoice date and still score full marks on date. Beyond it the date score tapers linearly to zero at 30 days from the invoice date. 0-30 inclusive; 0 means only same-day-or-later orders score full marks. Must be between 0 and 30.
             */
            poMatchWindowDaysBefore?: null | number | string;
            /**
             * Format: int32
             * @description How many days a purchase order's expected delivery date may fall AFTER the bill's invoice date and still score full marks. Expected delivery legitimately lands either side of an invoice, which is why this is separate from the before window. Beyond it the score tapers to zero at 30 days. 0-30 inclusive. Must be between 0 and 30.
             */
            poMatchWindowDaysAfter?: null | number | string;
            /**
             * Format: int32
             * @description How many days a delivery note's received date may fall BEFORE the bill's invoice date and still score full marks. Usually the larger of the delivery pair: goods are received before they are invoiced, and one bill often covers a period of drops. Beyond it the score tapers to zero at 30 days. 0-30 inclusive. Must be between 0 and 30.
             */
            dnMatchWindowDaysBefore?: null | number | string;
            /**
             * Format: int32
             * @description How many days a delivery note's received date may fall AFTER the bill's invoice date and still score full marks. Usually small — an invoice raised before the period's final delivery is normal, a note from the following month is not. Beyond it the score tapers to zero at 30 days. 0-30 inclusive. Must be between 0 and 30.
             */
            dnMatchWindowDaysAfter?: null | number | string;
            /**
             * Format: double
             * @description Minimum combined supplier-match score to suggest a fuzzy supplier link. Must be between 0 and 1.
             */
            supplierMatchSimilarityThreshold?: null | number | string;
            /**
             * Format: double
             * @description Relative weight of supplier-name similarity in the combined supplier-match score. Must be >= 0; cannot be 0 alongside a 0 address weight.
             */
            supplierMatchNameWeight?: null | number | string;
            /**
             * Format: double
             * @description Relative weight of delivery-address similarity in the combined supplier-match score. Must be >= 0; cannot be 0 alongside a 0 name weight.
             */
            supplierMatchAddressWeight?: null | number | string;
            /** @description RETIRED — replaced by PoAutoMatchEnabled and DnAutoMatchEnabled, which gate each route's exact-SKU tier as well as its fuzzy tier. Sending this returns an error; it is accepted only to say so explicitly rather than ignore it. */
            matchAutoAcceptEnabled?: null | boolean;
            /** @description Enable automatic matching of bill lines against purchase orders — both exact SKU matches and confident fuzzy ones. Set false to stop allocating anything against a purchase order without a reviewer, including an identical SKU; suggestions are still offered and can be linked by hand. */
            poAutoMatchEnabled?: null | boolean;
            /** @description Enable automatic matching of bill lines against delivery notes — both exact SKU matches and confident fuzzy ones. Set false to stop allocating anything against a delivery note without a reviewer, including an identical SKU; suggestions are still offered and can be linked by hand. */
            dnAutoMatchEnabled?: null | boolean;
            /**
             * Format: double
             * @description Match score (0-1) at or above which a single, unambiguous fuzzy candidate is accepted automatically. Must be between 0 and 1 and >= MatchSimilarityThreshold.
             */
            matchAutoAcceptThreshold?: null | number | string;
            /**
             * Format: double
             * @description How much to raise the score of suggestions from a purchase order or delivery note already linked elsewhere on the same bill. A fraction between 0 and 1: 0.1 scores them 10% higher, 0 disables it. Never causes an automatic match.
             */
            manualLinkSameDocumentBoost?: null | number | string;
            /**
             * Format: double
             * @description How much to raise the score of suggestions whose line description matches one already confirmed for this bill line, on any document — the split-delivery signal. A fraction between 0 and 1: 0.1 scores them 10% higher, 0 disables it. Never causes an automatic match.
             */
            manualLinkSameItemBoost?: null | number | string;
            /** @description Enable automatic routing of bills received against a company: assign a bill to the organisation whose address matches its delivery address, without anyone confirming. Set false to make every company bill wait in the company inbox. */
            companyAutoAssignEnabled?: null | boolean;
            /**
             * Format: double
             * @description Match score (0-1) the best matching organisation must reach for a company's bill to be assigned automatically. Must be between 0 and 1.
             */
            companyAutoAssignThreshold?: null | number | string;
            /**
             * Format: double
             * @description Minimum lead (0-1) the best matching organisation must have over the runner-up for a company's bill to be assigned automatically. Must be between 0 and 1.
             */
            companyAutoAssignMargin?: null | number | string;
            /**
             * Format: double
             * @description Unit-price tolerance for auto-matching, as a fraction of the ordered price (0.03 = 3%). Gates auto-settle of the price gap and doubles as the confidence dead-zone (within it, price does not dent match confidence). Must be between 0 and 1. Default 0.03.
             */
            matchMaxPriceVarianceFraction?: null | number | string;
            /**
             * Format: double
             * @description Receipt-quantity tolerance for auto-matching against a delivery note, as a fraction of the billed quantity (0.05 = 5%). Gates auto-settle of the billed-vs-received gap and doubles as the confidence dead-zone (only an over-receipt beyond it dents confidence). Must be between 0 and 1.
             */
            matchMaxReceiptQuantityVarianceFraction?: null | number | string;
            /**
             * Format: double
             * @description Order-quantity tolerance for auto-matching against a purchase order, as a fraction of the ordered quantity (0.05 = 5%). Gates auto-settle of the over-order surplus and doubles as the confidence dead-zone (only an over-order beyond it dents confidence). Must be between 0 and 1.
             */
            matchMaxOrderQuantityVarianceFraction?: null | number | string;
        };
        PatchArSettingsRequest: {
            /** @description Client-level kill switch for outbound AR (invoice) emails. When false, sending an invoice still issues it, but no customer email is dispatched and no reminders are scheduled. */
            arEmailsEnabled?: null | boolean;
            /** @description Whether this client uses integrated Dolfin/Stripe payments. Set false to bring your own payment link (see defaultPaymentLinkUrl). */
            integratedPaymentsEnabled?: null | boolean;
            /** @description Bring-your-own payment link template, only valid when integrated payments are off. May include {invoiceId}, {organisationId} and {invoiceNumber} tokens. Must be an absolute https URL. Send an empty string to clear it. */
            defaultPaymentLinkUrl?: null | string;
            whatsAppMessageTone?: null | components["schemas"]["InvoiceTone"];
            pdfDisplayOptions?: null | components["schemas"]["PatchInvoicePdfDisplayOptions"];
        };
        PatchBillLineItemRequest: {
            /**
             * Format: uuid
             * @description Id of an existing line on this bill to update. Omit to add a new line.
             */
            id?: null | string;
            description: string;
            /** @description Product code / SKU for exact three-way matching. Null leaves the line's existing SKU untouched. */
            sku?: null | string;
            /** Format: double */
            quantity?: number | string;
            /** @description Optional unit of measure (e.g. kg, box, hrs). Null leaves it untouched on an existing line. */
            unit?: null | string;
            /** Format: double */
            unitPrice?: number | string;
            /**
             * Format: double
             * @description Authoritative tax amount for the line, persisted as-is. Null leaves the existing line tax untouched (0 on a new line) and is never derived.
             */
            taxAmount?: null | number | string;
            /**
             * Format: double
             * @description Optional tax rate as a percentage (e.g. 20 for 20%). Descriptive metadata only — captured for VAT reporting/display and NOT used to derive TaxAmount.
             */
            taxRate?: null | number | string;
            /**
             * Format: int32
             * @description 0-based display position of the line.
             */
            sortOrder?: number | string;
            /** @description Confirmed spend category key (from GET /payables/categories). Setting it clears the agent suggestion; null leaves classification untouched. */
            category?: null | string;
            spendClass?: null | components["schemas"]["SpendClass"];
            /** @description Freeform tags for this line. When provided, replaces the line's tags (normalised); null leaves them untouched. */
            tags?: null | string[];
        };
        PatchBillRequest: {
            /** Format: uuid */
            supplierId?: null | string;
            supplierName?: null | string;
            supplierEmail?: null | string;
            supplierPhone?: null | string;
            supplierAddress?: null | string;
            deliveryAddress?: null | string;
            supplierAddressDetail?: null | components["schemas"]["Address"];
            deliveryAddressDetail?: null | components["schemas"]["Address"];
            supplierTaxId?: null | string;
            supplierWebsite?: null | string;
            supplierRegistrationNumber?: null | string;
            invoiceNumber?: null | string;
            /** @description Every purchase-order reference printed on the bill by the supplier, in the order printed. REPLACES the whole list: send [] to record that the bill quotes no order after all, and omit the field to leave the references untouched. Correcting them does not link the bill to a purchase order — three-way matching does not read this field. */
            billPoNumbers?: null | string[];
            /** Format: date-time */
            invoiceDate?: null | string;
            /** Format: date-time */
            dueDate?: null | string;
            /** @description ISO 4217 currency code (e.g. GBP, USD, EUR) */
            currency?: null | string;
            /** Format: double */
            subTotal?: null | number | string;
            /** Format: double */
            taxAmount?: null | number | string;
            /** Format: double */
            totalAmount?: null | number | string;
            paymentTerms?: null | string;
            paymentRef?: null | string;
            accountHolderName?: null | string;
            accountNumber?: null | string;
            /** @description UK bank sort code. */
            sortCode?: null | string;
            /** @description US bank routing number. */
            routingNumber?: null | string;
            iban?: null | string;
            bicSwift?: null | string;
            /** @description ISO 3166-1 alpha-2 country code (e.g. GB, US, DE) */
            bankCountry?: null | string;
            /** @description ISO 4217 currency code (e.g. GBP, USD, EUR) */
            bankCurrency?: null | string;
            /** @description Replacement line items. A line with an id updates that existing line; a line without an id is added; existing lines left out of the list are deleted. Omit the field to leave the line items unchanged. */
            lineItems?: null | components["schemas"]["PatchBillLineItemRequest"][];
        };
        /** @description Fields to update on the Client's expense settings. Omitted fields are left unchanged. */
        PatchClientExpenseSettingsRequest: {
            /** @description Whether a coded expense waits for a person to release it before posting. */
            requireReviewBeforePost?: null | boolean;
            /** @description Whether expenses are pushed as drafts in the accounting platform rather than posted transactions. */
            postAsDraft?: null | boolean;
            /**
             * Format: double
             * @description Minimum score for an automatic receipt match, between 0 and 1.
             */
            matchScoreThreshold?: null | number | string;
            /**
             * Format: double
             * @description How far the best candidate must lead the runner-up before an automatic match is made, between 0 and 1.
             */
            matchScoreMargin?: null | number | string;
            /**
             * Format: double
             * @description Absolute amount tolerance for reconciling a receipt to a transaction. Must be 0 or greater.
             */
            matchAmountToleranceAbsolute?: null | number | string;
            /**
             * Format: double
             * @description Proportional amount tolerance, between 0 and 1, applied alongside the absolute one — the larger wins.
             */
            matchAmountTolerancePercent?: null | number | string;
            /**
             * Format: int32
             * @description How many days either side of a transaction a receipt may be dated and still match, between 0 and 90.
             */
            matchDateWindowDays?: null | number | string;
            /**
             * Format: int32
             * @description How far back transactions are pulled when a card is first connected, between 0 and 365 days.
             */
            backfillWindowDays?: null | number | string;
        };
        PatchClientRequest: {
            logoUrl?: null | string;
            primaryColour?: null | string;
        };
        PatchCompanyRequest: {
            /** @description Display name of the parent group, e.g. "Ozone Coffee". */
            name?: null | string;
            /** @description Head office address line 1. */
            addressLine1?: null | string;
            addressLine2?: null | string;
            city?: null | string;
            postalCode?: null | string;
            /** @description ISO 3166-1 alpha-2 country code (e.g. GB, US, DE) */
            country?: null | string;
            /** @description Contact address for notifications about bills awaiting routing. */
            contactEmail?: null | string;
            /**
             * Format: double
             * @description Override the client-wide automatic-routing score for this company only, between 0 and 1.
             */
            autoAssignThreshold?: null | number | string;
            /**
             * Format: double
             * @description Override the client-wide automatic-routing margin for this company only, between 0 and 1.
             */
            autoAssignMargin?: null | number | string;
        };
        PatchConversationRequest: {
            title?: null | string;
        };
        PatchExpenseRequest: {
            memo?: null | string;
            isPersonal?: null | boolean;
        };
        PatchHiddenClientSettingsRequest: {
            billExtractionMode?: null | components["schemas"]["BillExtractionMode"];
            billExtractionModel?: null | components["schemas"]["BillExtractionModel"];
        };
        /** @description A partial set of invoice PDF display flags. Omitted flags keep their current value. */
        PatchInvoicePdfDisplayOptions: {
            /** @description Show the organisation's logo. */
            showLogo?: null | boolean;
            /** @description Show the organisation's contact email. */
            showSenderEmail?: null | boolean;
            /** @description Show the organisation's phone number (Classic and Branded layouts). */
            showSenderPhone?: null | boolean;
            /** @description Show the organisation's website (Classic and Branded layouts). */
            showSenderWebsite?: null | boolean;
            /** @description Show the organisation's tax (VAT) number. VAT invoices may be required to show it. */
            showSenderTaxNumber?: null | boolean;
            /** @description Show the organisation's company registration number. */
            showSenderRegistrationNumber?: null | boolean;
            /** @description Show the organisation's first address line. */
            showSenderAddressLine1?: null | boolean;
            /** @description Show the organisation's second address line. */
            showSenderAddressLine2?: null | boolean;
            /** @description Show the organisation's town or city. */
            showSenderCity?: null | boolean;
            /** @description Show the organisation's state, county or region. */
            showSenderState?: null | boolean;
            /** @description Show the organisation's postcode. */
            showSenderPostalCode?: null | boolean;
            /** @description Show the organisation's country. */
            showSenderCountry?: null | boolean;
            /** @description Show the customer's first address line. */
            showCustomerAddressLine1?: null | boolean;
            /** @description Show the customer's second address line. */
            showCustomerAddressLine2?: null | boolean;
            /** @description Show the customer's town or city. */
            showCustomerCity?: null | boolean;
            /** @description Show the customer's state, county or region. */
            showCustomerState?: null | boolean;
            /** @description Show the customer's postcode. */
            showCustomerPostalCode?: null | boolean;
            /** @description Show the customer's country. */
            showCustomerCountry?: null | boolean;
            /** @description Show the customer's tax (VAT) number. */
            showCustomerTaxNumber?: null | boolean;
            /** @description Show the invoice notes (memo). */
            showNotes?: null | boolean;
            /** @description Show the bank account holder name in Payment Details. */
            showBankAccountName?: null | boolean;
            /** @description Show the UK sort code in Payment Details. */
            showSortCode?: null | boolean;
            /** @description Show the US routing number in Payment Details. */
            showRoutingNumber?: null | boolean;
            /** @description Show the domestic account number in Payment Details. */
            showAccountNumber?: null | boolean;
            /** @description Show the IBAN in Payment Details. */
            showIban?: null | boolean;
            /** @description Show the BIC/SWIFT code in Payment Details. */
            showBicSwift?: null | boolean;
            /** @description Show the scan-to-pay QR code and payment link. */
            showPaymentQrCode?: null | boolean;
        };
        PatchInvoiceRequest: {
            /**
             * Format: uuid
             * @description Id of the customer to bill instead. Omit to leave unchanged.
             */
            customerId?: null | string;
            /** @description ISO 4217 currency code (e.g. GBP, USD, EUR) */
            currency?: null | string;
            /** @description Free-text memo shown on the invoice. Send an empty string to clear it; omit to leave unchanged. */
            memo?: null | string;
            /** @description Replacement CC recipients for the invoice email and its reminders. Omit or send null to leave unchanged; send an empty list for no CC. Each must be a valid email. */
            ccEmails?: null | string[];
            /**
             * Format: int32
             * @description Payment terms in days (0-365) — the number of days from issue to due date. 0 means due on receipt. Omit to leave unchanged.
             */
            paymentTermsDays?: null | number | string;
            discountType?: null | components["schemas"]["DiscountType"];
            /**
             * Format: double
             * @description The invoice-level discount: a percentage (0-100) or a cash amount, per DiscountType. At most 2 decimal places. Omit to leave unchanged. Must be omitted when DiscountType is None, and cannot be sent without DiscountType — the type is never inferred from the invoice's current discount.
             */
            discountValue?: null | number | string;
            earlyPaymentDiscount?: null | components["schemas"]["EarlyPaymentDiscountRequest"];
            /** @description Replacement line items. A line with an id updates that existing line; a line without one is created; existing lines left out are deleted. Omit the field entirely to leave the lines unchanged. */
            lineItems?: null | components["schemas"]["CreateInvoiceLineItemRequest"][];
        };
        PatchOrganisationArSettingsRequest: {
            invoicePdfTemplate?: null | components["schemas"]["InvoicePdfTemplate"];
            invoiceEmailTemplate?: null | components["schemas"]["InvoiceEmailTemplate"];
            /**
             * Format: int32
             * @description Default number of days between an invoice's issue date and its due date, from 0 to 365. 0 means due on receipt. Copied onto each new invoice, which may then override it.
             */
            defaultPaymentTermsDays?: null | number | string;
            /**
             * Format: double
             * @description Percentage fee applied to overdue invoices. Not currently applied automatically.
             */
            latePaymentFee?: null | number | string;
            defaultInvoiceMessageTone?: null | components["schemas"]["InvoiceTone"];
            /** @description Reminder schedule applied automatically when an invoice is sent. Supply an empty list to disable automatic reminders. Duplicates are removed. */
            defaultReminderOffsets?: null | components["schemas"]["InvoiceReminderOffset"][];
            bankDetails?: null | components["schemas"]["BankDetails"];
            /** @description Default CC recipients added to every invoice email and its reminders. Supply an empty list to clear. Each must be a valid email; duplicates and the customer's own address are removed. */
            defaultInvoiceCcEmails?: null | string[];
            /** @description Reply-To address for invoice and reminder emails. Send an empty string to clear it and fall back to the organisation's contact email. Must be a valid email. */
            defaultReplyToEmail?: null | string;
            /** @description Prefix for generated invoice numbers (e.g. "INV"). 1-16 characters. */
            invoiceNumberPrefix?: null | string;
            /**
             * Format: int32
             * @description Minimum zero-padded digit width of the invoice number sequence, 1-10.
             */
            invoiceNumberPadding?: null | number | string;
            /** @description Prefix for generated credit note numbers (e.g. "CN"). 1-16 characters. */
            creditNoteNumberPrefix?: null | string;
            /**
             * Format: int32
             * @description Minimum zero-padded digit width of the credit note number sequence, 1-10.
             */
            creditNoteNumberPadding?: null | number | string;
        };
        PatchOrganisationInvoicePdfTemplateRequest: {
            invoicePdfTemplate: components["schemas"]["InvoicePdfTemplate"];
        };
        PatchOrganisationRequest: {
            name?: null | string;
            /** Format: uuid */
            industryId?: null | string;
            contactEmail?: null | string;
            phone?: null | string;
            website?: null | string;
            addressLine1?: null | string;
            addressLine2?: null | string;
            city?: null | string;
            /** @description Province, state or county. Required by some tax regimes for e-invoicing registration. */
            addressRegion?: null | string;
            postalCode?: null | string;
            /** @description ISO 3166-1 alpha-2 country code (e.g. GB, US, DE) */
            country?: null | string;
            taxNumber?: null | string;
            companyRegistrationNumber?: null | string;
            vatRegistered?: null | boolean;
            /** @description Registered legal name, when it differs from the trading name. Leave null when they are the same. */
            legalName?: null | string;
            businessType?: null | components["schemas"]["BusinessType"];
            /**
             * Format: int32
             * @description Year the business was incorporated, e.g. 2020.
             */
            incorporationYear?: null | number | string;
            employeeCount?: null | components["schemas"]["EmployeeCount"];
            annualRevenue?: null | components["schemas"]["AnnualRevenue"];
            avgInvoicesPerMonth?: null | components["schemas"]["AvgInvoicesPerMonth"];
            avgInvoiceValue?: null | components["schemas"]["AvgInvoiceValue"];
            primaryPaymentMethod?: null | components["schemas"]["PrimaryPaymentMethod"];
            /** @description Brand colour as a hex code, e.g. #2DD4BF. */
            primaryColour?: null | string;
            logoUrl?: null | string;
            /** @description ISO 4217 currency code (e.g. GBP, USD, EUR) */
            defaultCurrency?: null | string;
            hasBeenOnboarded?: null | boolean;
        };
        PatchOrganisationUserRoleRequest: {
            role: null | components["schemas"]["OrganisationRole"];
        };
        PatchRecurringInvoiceScheduleRequest: {
            memo?: null | string;
            autoSend?: null | boolean;
            /**
             * Format: int32
             * @description Payment terms in days (0-365) applied to future occurrences. Omit to leave unchanged; 0 means due on receipt.
             */
            paymentTermsDays?: null | number | string;
            /**
             * Format: int32
             * @description Must be at least the number of occurrences already generated. Setting it equal completes the schedule.
             */
            totalOccurrences?: null | number | string;
            /**
             * Format: date-time
             * @description Only editable before the first invoice is generated.
             */
            startDate?: null | string;
            cadence?: null | components["schemas"]["RecurrenceCadence"];
            discountType?: null | components["schemas"]["DiscountType"];
            /**
             * Format: double
             * @description The invoice-level discount applied to future occurrences: a percentage (0-100) or a cash amount, per DiscountType. At most 2 decimal places. Omit to leave unchanged; cannot be sent without DiscountType — the type is never inferred from the schedule's current discount.
             */
            discountValue?: null | number | string;
            earlyPaymentDiscount?: null | components["schemas"]["RecurringEarlyPaymentDiscount"];
            /** @description Full replacement of the line-item templates. Affects future occurrences only. */
            lineItems?: null | components["schemas"]["RecurringInvoiceLineItemRequest"][];
        };
        PatchSpendCategoryRequest: {
            displayName: null | string;
            defaultSpendClass: null | components["schemas"]["SpendClass"];
            glAccountCode: null | string;
            isArchived: null | boolean;
        };
        PatchSupplierRequest: {
            name?: null | string;
            email?: null | string;
            phone?: null | string;
            website?: null | string;
            taxNumber?: null | string;
            registrationNumber?: null | string;
            address?: null | components["schemas"]["Address"];
            bankDetails?: null | components["schemas"]["BankDetails"];
            /** @description Default payment terms, e.g. 'Net 30'. */
            paymentTermsDefault?: null | string;
            /**
             * Format: uuid
             * @description Id of an active ledger account (from GET /accounting/ledger-accounts) this supplier's bills post to in the accounting platform when a line names none of its own. Left out or null leaves it as it is.
             */
            defaultLedgerAccountId?: null | string;
        };
        PatchWebhookSubscriptionRequest: {
            url?: null | string;
            eventTypes?: ("bill.created" | "bill.updated" | "bill.ocr_failed" | "bill.pending_review" | "bill.needs_approval" | "bill.approved" | "bill.rejected" | "bill.scheduled" | "bill.paid" | "bill.voided" | "bill.payment_failed" | "bill.payment_in_progress" | "invoice.created" | "invoice.updated" | "invoice.sent" | "invoice.partially_paid" | "invoice.paid" | "invoice.voided" | "invoice.credited" | "credit_note.issued" | "match_group.created" | "match_group.variance" | "match_group.resolved" | "supplier_credit_note.issued" | "supplier_credit_note.blocked" | "supplier_credit.applied" | "supplier_credit.reversed" | "bill.credited" | "bill.duplicate_detected" | "recurring_invoice.generation_failed" | "e_invoice.ingested" | "e_invoice.rejected" | "e_invoicing_registration.action_required" | "e_invoicing_registration.registered" | "e_invoicing_registration.failed" | "e_invoicing_registration.unregistered" | "outbound_e_invoice.delivered" | "outbound_e_invoice.made_available" | "outbound_e_invoice.failed" | "outbound_e_invoice.abandoned" | "company_bill.awaiting_organisation" | "customer.created" | "customer.updated" | "customer.deleted" | "supplier.created" | "supplier.updated" | "product.created" | "product.updated" | "product.deleted" | "tax_rate.created" | "tax_rate.updated" | "tax_rate.deleted" | "approval_policy.created" | "approval_policy.updated" | "approval_policy.deleted" | "expense.posted" | "expense.flagged" | "expense.pending_review" | "expense.matched" | "expense.post_failed" | "card_transaction.created" | "card_connection.broken" | "invoice.issued" | "expense_approval_policy.created" | "expense_approval_policy.updated" | "expense_approval_policy.deleted" | "expense_policy_document.ready_for_review" | "expense_policy_document.failed" | "accounting_sync.succeeded" | "accounting_sync.failed" | "whatsapp_connection.updated" | "bank_connection.connected" | "bank_connection.failed" | "bank_connection.expired" | "bank_connection.revoked" | "bank_connection.reconfirmation_due" | "bill.partially_paid" | "bill.payment_recorded" | "bill.payment_abandoned")[];
            active?: null | boolean;
        };
        /** @description Events to switch on or off. Omitted events are left as they are. */
        PatchWhatsAppEventsRequest: {
            invoiceSend?: null | boolean;
            reminderDueSoon?: null | boolean;
            reminderJustOverdue?: null | boolean;
            reminderOverdue?: null | boolean;
            reminderFinalNotice?: null | boolean;
            billNeedsApproval?: null | boolean;
        };
        /** @description A one-call briefing on payables: what is owed, what is late, what went out, and what is waiting for review or approval. */
        PayablesSummaryResponse: {
            /**
             * Format: date
             * @description The date the figures are aged against.
             */
            asOf?: string;
            /** @description Everything owed, per currency, as in GET /payables/outstanding. */
            outstanding: components["schemas"]["OutstandingPayablesTotals"];
            /** @description What is overdue, and the five most overdue suppliers. */
            overdue: components["schemas"]["OverduePayablesSummary"];
            /** @description What was paid in the last 30 days, with the trend. */
            paid: components["schemas"]["PaidPayablesSummary"];
            /** @description The review and approval queue, with whether each bill is waiting on the caller. */
            approvals: components["schemas"]["ApprovalQueueSummary"];
        };
        PaymentAccountCapabilities: {
            chargesEnabled?: boolean;
            payoutsEnabled?: boolean;
            detailsSubmitted?: boolean;
            currentlyDue?: string[];
            pastDue?: string[];
            disabledReason?: null | string;
        };
        PaymentAccountLinkResponse: {
            url: string;
            /** Format: date-time */
            expiresAt?: string;
        };
        PaymentAccountResponse: {
            /** Format: uuid */
            organisationId?: string;
            provider?: null | components["schemas"]["PaymentProvider"];
            accountId?: null | string;
            status?: components["schemas"]["PaymentAccountState"];
            capabilities?: null | components["schemas"]["PaymentAccountCapabilities"];
            /** Format: date-time */
            enabledAt?: null | string;
        };
        PaymentAccountSessionResponse: {
            clientSecret: string;
            /** Format: date-time */
            expiresAt?: string;
        };
        /** @enum {unknown} */
        PaymentAccountState: "NotStarted" | "OnboardingInProgress" | "Active" | "Restricted" | "Rejected" | "Disconnected";
        PaymentBehaviour: {
            /** Format: double */
            averageDaysLate?: number | string;
            /** Format: double */
            onTimeRate?: number | string;
            /**
             * Format: int32
             * @description Invoices paid in the last 12 months.
             */
            totalInvoicesPaid?: number | string;
        };
        PaymentBillingDetailsResponse: {
            name?: null | string;
            email?: null | string;
        };
        PaymentInstitutionResponse: {
            id: string;
            name: string;
            fullName: null | string;
            countries: string[];
            iconUrl: null | string;
            /** @description Currencies this bank can pay a bill in: GBP for UK banks, EUR for banks in a eurozone country. A bill in a currency not listed can't be paid from this bank. */
            supportedCurrencies: string[];
            /** @description True when this bank needs the paying account (payerBankAccountId or payerIban) to start a EUR payment. Never needed for GBP. */
            payerAccountRequired: boolean;
        };
        PaymentInstitutionsResponse: {
            institutions: components["schemas"]["PaymentInstitutionResponse"][];
            disclosure: components["schemas"]["YapilyDisclosure"];
        };
        PaymentMethodDetailsResponse: {
            id?: null | string;
            type: string;
            brand?: null | string;
            last4?: null | string;
            /** Format: int64 */
            expMonth?: null | number | string;
            /** Format: int64 */
            expYear?: null | number | string;
            funding?: null | string;
            country?: null | string;
            wallet?: null | string;
        };
        /** @enum {unknown} */
        PaymentProvider: "Stripe" | "Manual" | "Yapily";
        PaymentRailSupport: {
            sepa?: boolean;
            sepaInstant?: boolean;
            fasterPayments?: boolean;
            bacs?: boolean;
            chaps?: boolean;
            ach?: boolean;
            fedWire?: boolean;
            swift?: boolean;
            localRailName?: null | string;
        };
        PaymentRiskResponse: {
            level?: null | string;
            /** Format: int64 */
            score?: null | number | string;
        };
        PaymentTiming: {
            /**
             * Format: int32
             * @description Bills paid in the window (primary currency). Bills missing an invoice date are excluded from AverageDaysToPay; bills missing a due date are excluded from AverageDaysVsDue/OnTermsRate — so the averages may rest on fewer bills than this.
             */
            billsPaid?: number | string;
            /**
             * Format: double
             * @description Mean days from bill invoice date to payment. Null when no paid bill in the window has an invoice date.
             */
            averageDaysToPay?: null | number | string;
            /**
             * Format: double
             * @description Mean days paid after the due date — negative means paid early. Null when no paid bill in the window has a due date.
             */
            averageDaysVsDue?: null | number | string;
            /**
             * Format: double
             * @description Share of paid bills settled on or before their due date. Null when no paid bill in the window has a due date.
             */
            onTermsRate?: null | number | string;
            /** @description on_terms (AverageDaysVsDue <= 0) | late | unknown (no measurable bills) */
            verdict: string;
        };
        /** @description Whether a source document is in the books, and why not. */
        PostingResponse: {
            /**
             * Format: uuid
             * @description Posting id.
             */
            id?: string;
            /** @description Kind of source document. */
            sourceType?: components["schemas"]["JournalSourceType"];
            /**
             * Format: uuid
             * @description Id of the source document.
             */
            sourceId?: string;
            /** @description Waiting, Pending (in flight), Posted, Skipped or Failed. */
            status?: components["schemas"]["PostingStatus"];
            /** @description Why it is waiting, skipped or failed. */
            reason?: null | string;
            /**
             * Format: int32
             * @description Attempts so far.
             */
            attempts?: number | string;
            /**
             * Format: date-time
             * @description When it was last attempted.
             */
            lastAttemptAt?: null | string;
            /**
             * Format: date-time
             * @description When it was first seen.
             */
            createdAt?: string;
            /**
             * Format: date-time
             * @description When it last changed.
             */
            updatedAt?: string;
            /**
             * Format: uuid
             * @description The document's latest journal entry still in force (not reversed), if any: the one to link to.
             */
            entryId?: null | string;
        };
        /** @enum {unknown} */
        PostingStatus: "Waiting" | "Pending" | "Posted" | "Skipped" | "Failed";
        PreviewArSettingsInvoicePdfRequest: {
            pdfTemplate?: null | components["schemas"]["InvoicePdfTemplate"];
            pdfDisplayOptions?: null | components["schemas"]["PatchInvoicePdfDisplayOptions"];
        };
        PreviewOrganisationInvoiceEmailRequest: {
            template: components["schemas"]["InvoiceEmailTemplate"];
            messageKind: components["schemas"]["InvoiceEmailMessageKind"];
        };
        PreviewUnsavedInvoiceEmailRequest: {
            overrides?: null | components["schemas"]["SendInvoiceOverrides"];
            /**
             * Format: uuid
             * @description The customer the invoice is for; must belong to the organisation. Omit until chosen: the email shows [Customer].
             */
            customerId?: null | string;
            /** @description ISO 4217 currency code (e.g. GBP, USD, EUR). Until it is set the amount shows as [Amount]. */
            currency?: null | string;
            /** @description The invoice lines. A line without a productId or a quantity greater than zero is left out of the total until complete; with no complete line the amount shows as [Amount]. */
            lineItems?: null | components["schemas"]["CreateInvoiceLineItemRequest"][];
            /**
             * Format: int32
             * @description Payment terms in days (0-365), used to derive the due date. Omit to use the organisation's default.
             */
            paymentTermsDays?: null | number | string;
            /** @description How DiscountValue is interpreted for the invoice-level discount. Omit (or send None) for no invoice-level discount. */
            discountType?: components["schemas"]["DiscountType"];
            /**
             * Format: double
             * @description The invoice-level discount, as on create.
             */
            discountValue?: null | number | string;
            memo?: null | string;
            /** @description CC recipients for the invoice, as on create. Omit to use the organisation's default CC list. */
            ccEmails?: null | string[];
        };
        PreviewUnsavedInvoicePdfRequest: {
            /**
             * Format: uuid
             * @description When editing a saved draft, keep its snapshotted layout. Must belong to the organisation.
             */
            invoiceId?: null | string;
            pdfTemplate?: null | components["schemas"]["InvoicePdfTemplate"];
            /**
             * Format: uuid
             * @description The customer the invoice is for; must belong to the organisation. Omit until chosen: the email shows [Customer].
             */
            customerId?: null | string;
            /** @description ISO 4217 currency code (e.g. GBP, USD, EUR). Until it is set the amount shows as [Amount]. */
            currency?: null | string;
            /** @description The invoice lines. A line without a productId or a quantity greater than zero is left out of the total until complete; with no complete line the amount shows as [Amount]. */
            lineItems?: null | components["schemas"]["CreateInvoiceLineItemRequest"][];
            /**
             * Format: int32
             * @description Payment terms in days (0-365), used to derive the due date. Omit to use the organisation's default.
             */
            paymentTermsDays?: null | number | string;
            /** @description How DiscountValue is interpreted for the invoice-level discount. Omit (or send None) for no invoice-level discount. */
            discountType?: components["schemas"]["DiscountType"];
            /**
             * Format: double
             * @description The invoice-level discount, as on create.
             */
            discountValue?: null | number | string;
            memo?: null | string;
            /** @description CC recipients for the invoice, as on create. Omit to use the organisation's default CC list. */
            ccEmails?: null | string[];
        };
        /** @enum {unknown} */
        PrimaryPaymentMethod: "BankTransfer" | "Card" | "DirectDebit" | "Cash" | null;
        ProblemDetails: {
            type?: null | string;
            title?: null | string;
            /** Format: int32 */
            status?: null | number | string;
            detail?: null | string;
            instance?: null | string;
        };
        ProductResponse: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            organisationId?: string;
            name: string;
            description?: null | string;
            /** Format: double */
            unitPrice?: number | string;
            /** @description ISO 4217 currency code (e.g. GBP, USD, EUR) */
            currency: string;
            type?: components["schemas"]["ProductType"];
            /**
             * Format: uuid
             * @description The accounting platform income ledger account this product's invoice lines post to. Null uses the organisation's default income account.
             */
            incomeLedgerAccountId?: null | string;
            /** Format: date-time */
            createdAt?: string;
            /** Format: uuid */
            createdBy?: null | string;
            /** Format: date-time */
            updatedAt?: string;
            /** Format: uuid */
            updatedBy?: null | string;
        };
        ProductSearchHit: {
            /** Format: uuid */
            id?: string;
            name: string;
            description?: null | string;
            /** Format: double */
            score?: number | string;
        };
        /** @enum {unknown} */
        ProductType: "Product" | "Service";
        /** @description Profit and loss for a period, on accrual or cash basis, grouped by account classification. */
        ProfitAndLossResponse: {
            /**
             * Format: date
             * @description First day of the period.
             */
            from?: string;
            /**
             * Format: date
             * @description Last day of the period.
             */
            to?: string;
            /** @description The basis the figures are on: Accrual or Cash. */
            basis?: components["schemas"]["ReportingBasis"];
            /** @description Currency of every amount. */
            currency?: string;
            /** @description True when the platform columns are filled. */
            compared?: boolean;
            /** @description Revenue then expense. */
            groups?: components["schemas"]["StatementGroup"][];
            /**
             * Format: double
             * @description Revenue less expenses.
             */
            netProfit?: number | string;
            /**
             * Format: double
             * @description The platform's net profit (compare only).
             */
            platformNetProfit?: null | number | string;
            /**
             * Format: double
             * @description Revenue less cost of sales: the rows in the Revenue section less those in the CostOfSales section. Other income and other expenses fall below it.
             */
            grossProfit?: number | string;
            /**
             * Format: double
             * @description The platform's gross profit (compare only).
             */
            platformGrossProfit?: null | number | string;
        };
        /**
         * @description Where a profit and loss row sits on the statement. Gross profit is Revenue less CostOfSales; net profit then takes off OperatingExpenses and OtherExpenses and adds OtherIncome.
         * @enum {unknown}
         */
        ProfitAndLossSection: "Revenue" | "CostOfSales" | "OperatingExpenses" | "OtherIncome" | "OtherExpenses" | null;
        /** @description One thing an e-invoicing network said went wrong, in the network's own terms. A delivery that failed carries at least one; a delivered one carries none. */
        ProviderFaultDetail: {
            /** @description Which part of the network raised it, such as the document conversion or the send itself. Absent when the network reported a fault without attributing it. */
            provider?: null | string;
            /** @description The network's own error code, where it gives one. Stable enough to map to your own help text or to group on. Often absent: many networks report a message and no code, so treat this as extra information rather than the primary identifier — the delivery's failureKind is the field that is always present and always safe to switch on. */
            code?: null | string;
            /** @description What the network said, in its own words. Frequently the only place a rejection is explained at all, so it is written to be shown to a person as it came. */
            message?: null | string;
            /** @description The stage of sending that produced the fault, named as a person would recognise it. Null for a fault about the document as a whole rather than about one stage. */
            step?: null | string;
            /**
             * Format: date-time
             * @description When the network reported it.
             */
            at?: null | string;
        };
        /** @description A single ordered line on a purchase order. */
        PurchaseOrderLineResponse: {
            /**
             * Format: uuid
             * @description Unique identifier of the line, and the only key that identifies it on update. Send it back in the update request to edit this line in place rather than replacing it.
             */
            id?: string;
            /** @description Caller's own reference for this line, echoed back verbatim. Null when none was supplied. */
            externalRef?: null | string;
            /** @description Line description. */
            description: string;
            /** @description Product SKU, used as the exact-match key against bill lines. Optional. */
            sku?: null | string;
            /**
             * Format: double
             * @description Quantity ordered on this line.
             */
            quantityOrdered?: number | string;
            /** @description Unit of measure (e.g. each, kg), if recorded. */
            unit?: null | string;
            unitOfMeasure?: null | components["schemas"]["UnitOfMeasure"];
            /**
             * Format: double
             * @description Ordered unit price (ex-tax).
             */
            unitPrice?: number | string;
            /**
             * Format: double
             * @description Tax rate applied to the line, as a percentage.
             */
            taxRate?: number | string;
            /**
             * Format: double
             * @description Tax amount for the line.
             */
            taxAmount?: number | string;
            /**
             * Format: double
             * @description Net (ex-tax) line total.
             */
            subTotal?: number | string;
            /**
             * Format: int32
             * @description Display order of the line within the order, exactly as supplied — never renumbered. Lines are returned sorted by this value, with ties broken by line id.
             */
            sortOrder?: number | string;
            /**
             * Format: double
             * @description Total quantity matched against this line across all bills. Null on list responses (not computed there); populated on the detail (get-by-id) response.
             */
            matchedQuantity?: null | number | string;
            /** @description True once the matched quantity covers the whole ordered quantity. Null when MatchedQuantity is not computed (list responses) — null means 'unknown', not 'unmatched'. */
            fullyMatched?: null | boolean;
        };
        /** @description A purchase order and its ordered lines. */
        PurchaseOrderResponse: {
            /**
             * Format: uuid
             * @description Unique identifier of the purchase order.
             */
            id?: string;
            /**
             * Format: uuid
             * @description The organisation that owns the purchase order.
             */
            organisationId?: string;
            /**
             * Format: uuid
             * @description The supplier the order is raised against, if assigned.
             */
            supplierId?: null | string;
            /** @description Caller's own reference for the order (a reverse pointer to the platform's record), if any. */
            externalRef?: null | string;
            /** @description Human purchase-order number printed on the order. Required and unique within the organisation. */
            poNumber: string;
            /** @description ISO 4217 currency code of the order. */
            currency: string;
            /** @description Lifecycle status: Draft, Open, PartiallyMatched, FullyMatched (all derived from matching), or the manual terminal states Closed / Cancelled. */
            status?: components["schemas"]["PurchaseOrderStatus"];
            /**
             * Format: date-time
             * @description Date the order was raised, if recorded.
             */
            orderDate?: null | string;
            /**
             * Format: date-time
             * @description Expected delivery date, if recorded.
             */
            expectedDeliveryDate?: null | string;
            /** @description The ordered lines, in display order. */
            lines?: components["schemas"]["PurchaseOrderLineResponse"][];
            /**
             * Format: date-time
             * @description When the purchase order was created.
             */
            createdAt?: string;
            /**
             * Format: date-time
             * @description When the purchase order was last updated.
             */
            updatedAt?: string;
        };
        /**
         * @description Lifecycle status of a purchase order. Draft, Open, PartiallyMatched and FullyMatched are derived from matching (and reverse as allocations change); Closed and Cancelled are manual terminal states a human sets.
         * @enum {unknown}
         */
        PurchaseOrderStatus: "Draft" | "Open" | "PartiallyMatched" | "FullyMatched" | "Closed" | "Cancelled";
        PutOrganisationCompanyRequest: {
            /**
             * Format: uuid
             * @description Identifier of the company to link this organisation to. Must belong to the same client.
             */
            companyId: string;
        };
        PutOrganisationRequest: {
            name: string;
            /** Format: uuid */
            industryId: string;
            contactEmail: string;
            /** @description ISO 3166-1 alpha-2 country code (e.g. GB, US, DE) */
            country: string;
            phone?: null | string;
            website?: null | string;
            addressLine1?: null | string;
            addressLine2?: null | string;
            city?: null | string;
            /** @description Province, state or county. Required by some tax regimes for e-invoicing registration. */
            addressRegion?: null | string;
            postalCode?: null | string;
            taxNumber?: null | string;
            companyRegistrationNumber?: null | string;
            vatRegistered?: null | boolean;
            /** @description Registered legal name, when it differs from the trading name. Leave null when they are the same. */
            legalName?: null | string;
            businessType?: null | components["schemas"]["BusinessType"];
            /** Format: int32 */
            incorporationYear?: null | number | string;
            employeeCount?: null | components["schemas"]["EmployeeCount"];
            annualRevenue?: null | components["schemas"]["AnnualRevenue"];
            avgInvoicesPerMonth?: null | components["schemas"]["AvgInvoicesPerMonth"];
            avgInvoiceValue?: null | components["schemas"]["AvgInvoiceValue"];
            primaryPaymentMethod?: null | components["schemas"]["PrimaryPaymentMethod"];
            primaryColour?: null | string;
            logoUrl?: null | string;
            /** @description ISO 4217 currency code (e.g. GBP, USD, EUR) */
            defaultCurrency?: null | string;
            hasBeenOnboarded?: null | boolean;
        };
        /** @description Asks for a new bank authorisation for an expired connection. */
        ReauthoriseBankConnectionRequest: {
            /** @description Absolute http(s) URL the account holder is sent back to after their bank; its host must be on the client's allowed redirect hosts, as for starting a connection. */
            returnUrl: string;
        };
        /** @enum {unknown} */
        ReceiptExtractionStatus: "Pending" | "Extracted" | "Failed";
        ReceiptFileUrlResponse: {
            url: string;
        };
        /** @description A single line read from a receipt. */
        ReceiptLineResponse: {
            /**
             * Format: uuid
             * @description Unique identifier of the line.
             */
            id?: string;
            /**
             * Format: int32
             * @description Position of the line on the receipt.
             */
            lineNumber?: number | string;
            /** @description Line description. */
            description: string;
            /**
             * Format: double
             * @description Quantity, where the receipt shows one.
             */
            quantity?: null | number | string;
            /**
             * Format: double
             * @description Unit amount, where the receipt shows one.
             */
            unitAmount?: null | number | string;
            /**
             * Format: double
             * @description Gross amount for the line.
             */
            amount?: number | string;
            /**
             * Format: double
             * @description Tax rate as a percentage, where the receipt shows one.
             */
            taxRate?: null | number | string;
            /**
             * Format: double
             * @description Tax amount for the line.
             */
            taxAmount?: null | number | string;
        };
        ReceiptLlmExtractionResponse: {
            /**
             * Format: uuid
             * @description The receipt this extraction record belongs to.
             */
            receiptId: string;
            /**
             * Format: uuid
             * @description The organisation the receipt belongs to.
             */
            organisationId?: string;
            /** @description The model id the extraction ran against, as the provider reports it served — e.g. the concrete Gemini version a "-latest" alias resolved to. */
            model: string;
            /**
             * Format: int32
             * @description Uncached input tokens billed at the full input rate.
             */
            inputTokens?: number | string;
            /**
             * Format: int32
             * @description Output tokens generated by the model.
             */
            outputTokens?: number | string;
            /**
             * Format: int32
             * @description Input tokens served from the prompt cache (0 until prompt caching is enabled).
             */
            cacheReadTokens?: number | string;
            /**
             * Format: int32
             * @description Input tokens written to the prompt cache (0 until prompt caching is enabled).
             */
            cacheCreationTokens?: number | string;
            /**
             * Format: double
             * @description USD cost of the input side (incl. cache read/write tiers). Null if the model has no configured price.
             */
            inputCostUsd?: null | number | string;
            /**
             * Format: double
             * @description USD cost of the output tokens. Null if the model has no configured price.
             */
            outputCostUsd?: null | number | string;
            /**
             * Format: double
             * @description Total USD cost of the extraction (input + output). Null if the model has no configured price.
             */
            totalCostUsd?: null | number | string;
            /** @description The effort level the request ran with (Anthropic only; empty for Gemini). */
            effort: string;
            /** @description Whether extended/adaptive thinking was enabled for the request. */
            thinkingEnabled?: boolean;
            /**
             * Format: int32
             * @description The max output tokens the request was configured with.
             */
            maxTokens?: number | string;
            /**
             * Format: double
             * @description Wall-clock duration of the LLM API call, in milliseconds.
             */
            durationMs?: number | string;
            /**
             * Format: date-time
             * @description When the extraction ran (UTC).
             */
            extractedAt?: string;
        };
        /** @enum {unknown} */
        ReceiptMatchStatus: "Unmatched" | "Matched";
        /** @description An uploaded receipt and the fields extracted from it. */
        ReceiptResponse: {
            /**
             * Format: uuid
             * @description Unique identifier of the receipt.
             */
            id?: string;
            /**
             * Format: uuid
             * @description The organisation that owns the receipt.
             */
            organisationId?: string;
            /** @description File name as uploaded. A HEIC/HEIF photo is stored as a JPEG, so its extension becomes .jpg. */
            fileName?: null | string;
            /** @description MIME type of the stored file. image/jpeg for a HEIC/HEIF photo, which is converted on upload. */
            contentType?: null | string;
            /**
             * Format: int64
             * @description Size of the stored file in bytes — after conversion, for a HEIC/HEIF photo.
             */
            fileSizeBytes?: number | string;
            /** @description Where the receipt came from: PortalUpload, Api, Email, Mobile or Forwarded. */
            source?: components["schemas"]["ReceiptSource"];
            /** @description Extraction status: Pending, Extracted or Failed. A failed extraction still leaves the receipt available to match by hand. */
            extractionStatus?: components["schemas"]["ReceiptExtractionStatus"];
            /** @description Why extraction failed, when it did. */
            extractionError?: null | string;
            /** @description Merchant name read from the receipt. */
            merchantName?: null | string;
            /** @description The supplier's VAT registration number as printed on the receipt. Required for a UK VAT reclaim even on a simplified receipt, so its absence is what makes a receipt worth chasing. */
            merchantVatNumber?: null | string;
            /** @description Merchant address read from the receipt. */
            merchantAddress?: null | string;
            /** @description The merchant's own document number, where the receipt carries one. */
            receiptNumber?: null | string;
            /**
             * Format: date-time
             * @description Date printed on the receipt.
             */
            receiptDate?: null | string;
            /**
             * Format: double
             * @description Gross total read from the receipt.
             */
            total?: null | number | string;
            /**
             * Format: double
             * @description Total tax read from the receipt.
             */
            taxTotal?: null | number | string;
            /**
             * Format: double
             * @description Tip / gratuity read from the receipt, where it was shown on its own line. A tip added after the card was authorised is the most common reason a receipt total exceeds the transaction that was matched to it.
             */
            tipAmount?: null | number | string;
            /** @description Currency read from the receipt (ISO 4217). */
            currency?: null | string;
            /** @description Whether the receipt has been paired with a card transaction. */
            matchStatus?: components["schemas"]["ReceiptMatchStatus"];
            /**
             * Format: uuid
             * @description The expense this receipt is attached to, once matched.
             */
            expenseId?: null | string;
            /**
             * Format: date-time
             * @description When the receipt was matched.
             */
            matchedAt?: null | string;
            /** @description Lines read from the receipt. These refine coding and the VAT split; they are not matched against card transaction lines, which do not exist. */
            lines?: components["schemas"]["ReceiptLineResponse"][];
            /**
             * Format: date-time
             * @description When the receipt was uploaded.
             */
            createdAt?: string;
            /**
             * Format: date-time
             * @description When the receipt was last updated.
             */
            updatedAt?: string;
        };
        /** @enum {unknown} */
        ReceiptSource: "PortalUpload" | "Api" | "Email" | "Mobile" | "Forwarded";
        /** @description A one-call briefing on receivables: what is owed, who is late, what came in, and what is still in draft. */
        ReceivablesSummaryResponse: {
            /**
             * Format: date
             * @description The date the figures are aged against.
             */
            asOf?: string;
            /** @description Everything owed, per currency, as in GET /receivables/outstanding. */
            outstanding: components["schemas"]["OutstandingTotals"];
            overdue: components["schemas"]["OverdueSummary"];
            received: components["schemas"]["ReceivedSummary"];
            drafts: components["schemas"]["DraftsSummary"];
        };
        ReceivedBucket: {
            /** Format: date */
            periodStart?: string;
            /** Format: date */
            periodEnd?: string;
            /** Format: double */
            received?: number | string;
            /** Format: int32 */
            paymentCount?: number | string;
        };
        ReceivedEInvoiceAdminResponse: {
            /** Format: uuid */
            id?: string;
            siloEntryId: string;
            state?: components["schemas"]["ReceivedEInvoiceState"];
            routedSuccess?: boolean;
            /** Format: uuid */
            organisationEInvoiceId?: null | string;
            /** Format: uuid */
            organisationId?: null | string;
            customerElectronicAddress?: null | string;
            customerTaxId?: null | string;
            supplierName?: null | string;
            invoiceNumber?: null | string;
            networkReference?: null | string;
            /** Format: double */
            totalAmount?: null | number | string;
            currency?: null | string;
            providerEvent?: null | string;
            providerJobId?: null | string;
            providerOwnerId?: null | string;
            providerKey?: null | string;
            providerInvalid?: boolean;
            providerFolder?: null | string;
            /** Format: date-time */
            providerCreatedAt?: null | string;
            /** Format: date-time */
            providerUpdatedAt?: null | string;
            providerFaults?: components["schemas"]["ProviderFaultDetail"][];
            faults?: components["schemas"]["EInvoiceFault"][];
            /** Format: date-time */
            receivedAt?: string;
            /** Format: date-time */
            routedAt?: null | string;
            /** Format: int32 */
            daysUnrouted?: number | string;
        };
        /** @enum {unknown} */
        ReceivedEInvoiceState: "Received" | "Routed" | "Unroutable" | "Unreadable";
        ReceivedResponse: {
            /** Format: date */
            asOf?: string;
            period?: components["schemas"]["LookbackPeriod"];
            /** Format: date */
            periodStart?: string;
            /** Format: date */
            periodEnd?: string;
            /** @description daily | weekly | monthly */
            granularity: string;
            /** @description The primary currency the Summary, Trend, Buckets, ByMethod and TopCustomers fields are reported in. See ReceivedByCurrency for activity in every currency. */
            currency: string;
            /** @description Total received per currency across the period — covers ALL currencies, not just the primary one. Use this for the headline figure when the org collects in multiple currencies so amounts are never reported as zero. */
            receivedByCurrency?: components["schemas"]["CurrencyTotal"][];
            summary: components["schemas"]["ReceivedTotals"];
            trend: components["schemas"]["ReceivedTrend"];
            buckets?: components["schemas"]["ReceivedBucket"][];
            byMethod?: components["schemas"]["MethodTotal"][];
            topCustomers?: components["schemas"]["CustomerReceived"][];
        };
        /** @description Cash collected over the last 30 days. */
        ReceivedSummary: {
            /** @description Totals for the last 30 days, in the organisation's default currency. */
            last30Days: components["schemas"]["ReceivedTotals"];
            /** @description The last 30 days against the 30 before. */
            trend: components["schemas"]["ReceivedTrend"];
            /** @description Total received per currency over the last 30 days, covering every currency. */
            receivedByCurrency?: components["schemas"]["CurrencyTotal"][];
        };
        ReceivedTotals: {
            /** Format: double */
            totalReceived?: number | string;
            /** Format: int32 */
            paymentCount?: number | string;
            /** Format: int32 */
            uniqueCustomers?: number | string;
            /** Format: double */
            averagePayment?: number | string;
        };
        ReceivedTrend: {
            /** Format: date */
            previousPeriodStart?: string;
            /** Format: date */
            previousPeriodEnd?: string;
            /** Format: double */
            previousTotal?: number | string;
            /** Format: double */
            deltaAmount?: number | string;
            /**
             * Format: double
             * @description Fractional change vs the prior equal-length window. Null when the prior window collected nothing.
             */
            deltaPercent?: null | number | string;
            /** @description up | down | flat */
            direction: string;
        };
        Recommendation: {
            headline: string;
            /** @description review_overdue | none */
            action: string;
            nextTool?: null | string;
        };
        /** @description Records a payment made outside Dolfin against an approved bill. Several payments can settle one bill. */
        RecordBillPaymentRequest: {
            /**
             * Format: double
             * @description Amount paid, in the bill's currency. Must be greater than zero and no more than the bill's outstanding amount. Omit to pay everything outstanding.
             */
            amount?: null | number | string;
            /**
             * Format: date
             * @description The day the payment was made. Defaults to today (UTC).
             */
            paidOn?: null | string;
            /** @description How the bill was paid: Cash, BankTransfer, Cheque, Card or Other. Credit is not a payment; settle a bill cleared by supplier credit with confirm-paid. */
            method: components["schemas"]["ManualPaymentMethod"];
            /** @description Your reference for the payment, such as a cheque number or bank reference. At most 100 characters. */
            reference?: null | string;
            /** @description A free-text note about the payment. At most 500 characters. */
            note?: null | string;
        };
        RecordInvoicePaymentRequest: {
            /**
             * Format: double
             * @description Amount received, in the invoice's currency. Must be greater than zero and no more than the outstanding balance.
             */
            amount?: number | string;
            /**
             * Format: date-time
             * @description When the payment was received. Defaults to now.
             */
            paidAt?: null | string;
            /** @description A free-text note about the payment. */
            notes?: null | string;
            /** @description Your reference for the payment, such as a cheque number or bank reference. At most 100 characters. */
            reference?: null | string;
        };
        /** @enum {unknown} */
        RecurrenceCadence: "Weekly" | "Monthly" | "Quarterly" | "Annually";
        /** @description An early payment discount on each invoice a schedule generates. A schedule has no issue date until each occurrence, so the expiry is a number of days: each invoice's discount expires that many days after it is raised. */
        RecurringEarlyPaymentDiscount: {
            /** @description How Value is interpreted. Send None (with no value or days) to remove the discount. */
            type?: components["schemas"]["DiscountType"];
            /**
             * Format: double
             * @description A percentage (0-100) of each invoice's total including tax, or a cash amount in the schedule currency that is less than that total, per Type. At most 2 decimal places.
             */
            value?: null | number | string;
            /**
             * Format: int32
             * @description Days after each invoice is raised that its discount expires. Must not exceed the payment terms, so the discount expires on or before the due date. Required unless Type is None.
             */
            days?: null | number | string;
        };
        RecurringInvoiceLineItemRequest: {
            /**
             * Format: uuid
             * @description Id of the product on this line. Resolve a product name to its id with a product search first.
             */
            productId?: string;
            /**
             * Format: double
             * @description Quantity billed on every occurrence. Must be greater than 0; use 1 for a flat fee.
             */
            quantity?: number | string;
            /**
             * Format: uuid
             * @description Tax rate for this line: an organisation-owned rate or a country default, both listed by GET /tax-rates.
             */
            taxRateId?: null | string;
            /**
             * Format: double
             * @description Fixed unit price billed on every occurrence — immune to product price changes. Omit to bill the product's then-current price.
             */
            unitPriceOverride?: null | number | string;
            /** @description How DiscountValue is interpreted for this line. Omit (or send None) for no line discount. */
            discountType?: components["schemas"]["DiscountType"];
            /**
             * Format: double
             * @description The line discount billed on every occurrence: a percentage (0-100) or a cash amount, per DiscountType.
             */
            discountValue?: null | number | string;
        };
        RecurringInvoiceLineItemResponse: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            productId?: string;
            productName?: null | string;
            /** Format: double */
            quantity?: number | string;
            /** Format: uuid */
            taxRateId?: null | string;
            /**
             * Format: double
             * @description Fixed unit price billed on every occurrence. Null means the product's then-current price is billed.
             */
            unitPriceOverride?: null | number | string;
            /** @description How DiscountValue is interpreted for this line. */
            discountType?: components["schemas"]["DiscountType"];
            /**
             * Format: double
             * @description The line discount billed on every occurrence: a percentage (0-100) or a cash amount, per DiscountType.
             */
            discountValue?: null | number | string;
        };
        RecurringInvoiceScheduleResponse: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            organisationId?: string;
            /** Format: uuid */
            customerId?: string;
            /** @description ISO 4217 currency code (e.g. GBP, USD, EUR) */
            currency: string;
            memo?: null | string;
            /**
             * Format: int32
             * @description Payment terms in days applied to every generated invoice. Null means each occurrence uses the organisation's default at generation time.
             */
            paymentTermsDays?: null | number | string;
            /** Format: date-time */
            startDate?: string;
            cadence?: components["schemas"]["RecurrenceCadence"];
            /** Format: int32 */
            totalOccurrences?: null | number | string;
            /** Format: int32 */
            occurrencesGenerated?: number | string;
            /**
             * Format: date-time
             * @description When the next invoice will be generated. Null on Paused, Completed, and Cancelled schedules.
             */
            nextRunAt?: null | string;
            autoSend?: boolean;
            /** @description How DiscountValue is interpreted for the invoice-level discount applied to every generated invoice. */
            discountType?: components["schemas"]["DiscountType"];
            /**
             * Format: double
             * @description The invoice-level discount applied to every generated invoice: a percentage (0-100) or a cash amount, per DiscountType. Resolved to cash afresh at each occurrence.
             */
            discountValue?: null | number | string;
            earlyPaymentDiscount?: null | components["schemas"]["RecurringEarlyPaymentDiscount"];
            status?: components["schemas"]["RecurringScheduleStatus"];
            /** Format: date-time */
            lastGeneratedAt?: null | string;
            /** Format: date-time */
            createdAt?: string;
            /** Format: uuid */
            createdBy?: null | string;
            /** Format: date-time */
            updatedAt?: string;
            /** Format: uuid */
            updatedBy?: null | string;
            customer?: null | components["schemas"]["CustomerResponse"];
            lineItems?: components["schemas"]["RecurringInvoiceLineItemResponse"][];
        };
        /** @enum {unknown} */
        RecurringScheduleStatus: "Active" | "Paused" | "Completed" | "Cancelled";
        /** @description The outcome of dropping a client's cached match statistics. */
        RefreshMatchStatsResult: {
            /**
             * Format: uuid
             * @description The client whose cached statistics were dropped.
             */
            clientId: string;
            /**
             * Format: int32
             * @description How many of the client's organisations had their drill-down statistics dropped alongside the client-wide rollup. Zero is a valid answer for a client with no organisations.
             */
            organisationsCleared: number | string;
            /**
             * Format: date-time
             * @description When the cache was dropped, UTC. Any match-stats payload with an earlier `asOf` is a stale read.
             */
            invalidatedAt: string;
        };
        RegisterRequest: {
            accessToken: string;
            provider: string;
            magicLinkToken: string;
        };
        RejectBillRequest: {
            reason?: null | string;
        };
        /** @description Options for a rematch run. Every field is optional; an omitted body re-runs every bill. */
        RematchRequest: {
            /** @description Which bills to pull back. AllBills (default) includes bills the engine never grouped, which is where a settings change most often shows up. GroupedOnly narrows to bills that already have a match group. */
            population?: components["schemas"]["RewindPopulation"];
            /**
             * Format: date-time
             * @description Optional lower bound on Bill.CreatedAt.
             */
            createdFrom?: null | string;
            /**
             * Format: date-time
             * @description Optional upper bound on Bill.CreatedAt.
             */
            createdTo?: null | string;
        };
        /** @description A current document-sourced policy that confirming this document would delete, because the new version no longer contains it. */
        RemovedExpensePolicyResponse: {
            /**
             * Format: uuid
             * @description Policy id.
             */
            id: string;
            /** @description Policy name. */
            name: string;
            /**
             * Format: int32
             * @description The policy's current version.
             */
            version: number | string;
        };
        ReplaceClientModulesRequest: {
            /** @description The complete set of module keys the client should hold, such as ["ar", "ap", "ap.payments"]. Anything omitted is revoked; an empty array revokes everything. Duplicates are ignored. Keys come from GET /admin/modules. */
            modules?: null | string[];
            /** @description Why the entitlements are changing, for the audit trail — for example "downgraded per contract change 2026-08". Recorded against every module this call moves. Optional, but it is the only record of the reason: the states before and after are captured automatically, the motive is not. */
            reason?: null | string;
        };
        ReplaceExpenseLinesRequest: {
            lines: components["schemas"]["ExpenseLineRequest"][];
        };
        /** @enum {unknown} */
        ReportingBasis: "Accrual" | "Cash";
        ResolvedCategoryResponse: {
            key: string;
            displayName: string;
            defaultSpendClass: null | components["schemas"]["SpendClass"];
            source: string;
        };
        /** @description Records a human decision against one bill line's variance. Accept settles that line; Dispute and RequestCreditNote keep it (and so the bill) blocked. */
        ResolveMatchRequest: {
            /**
             * Format: uuid
             * @description The bill line whose variance is being resolved.
             */
            billLineId: string;
            /** @description The decision to record (e.g. Accept, RequestCreditNote, Dispute). */
            action: components["schemas"]["MatchResolutionAction"];
            /** @description Optional free-text note to capture with the resolution. */
            notes?: null | string;
        };
        /**
         * @default AllBills
         * @enum {unknown}
         */
        RewindPopulation: "AllBills" | "GroupedOnly";
        SandboxHandoffRequest: {
            /** Format: uuid */
            organisationId: string;
        };
        SandboxHandoffResponse: {
            code: string;
            sandboxUrl: string;
            /** Format: date-time */
            expiresAt: string;
        };
        ScheduleBillPaymentRequest: {
            /** Format: date-time */
            paymentDate?: null | string;
            /** @description How the bill will be paid, e.g. 'BankTransfer'. */
            paymentMethod?: null | string;
        };
        SeedDemoRequest: {
            preset?: null | components["schemas"]["DemoPreset"];
        };
        /** @description A single practice case: one bill and the orders and deliveries it has to be matched against. */
        SeededMatchCaseResponse: {
            /**
             * Format: uuid
             * @description The seeded bill.
             */
            billId: string;
            /** @description Invoice number printed on the bill. */
            invoiceNumber: string;
            /** @description Supplier the bill and all its paperwork belong to. */
            supplierName: string;
            /**
             * Format: int32
             * @description How many lines the bill carries.
             */
            lineCount: number | string;
            /** @description Numbers of the purchase orders this bill has to be matched against. */
            purchaseOrderNumbers: string[];
            /** @description Numbers of the delivery notes this bill has to be matched against. */
            deliveryNoteNumbers: string[];
            /** @description Plain-English list of what this case is designed to exercise, such as a price variance against the order or an over-delivery. Shown so whoever is practising knows what to look for. */
            exercises: string[];
            /**
             * Format: int32
             * @description Allocations already on this bill. Zero for ManualSet; for MixedMatchTypes, the lines the engine was meant to match unattended.
             */
            allocationCount: number | string;
            /** @description Per line, how it was meant to match and how it actually did. Populated for MixedMatchTypes, where the lanes are the point; empty for ManualSet, where every line is meant to be manual and the Exercises above say what makes each one interesting. */
            lines: components["schemas"]["SeededMatchLineResponse"][];
        };
        /** @description One seeded bill line: the way it was meant to match, and the way it did. */
        SeededMatchLineResponse: {
            /** @description The line as it reads on the bill. */
            description: string;
            /** @description How this line was designed to match. */
            intended: components["schemas"]["MatchPracticeLane"];
            /** @description What the matching engine actually did with it, read back from the match group after seeding rather than assumed. */
            outcome: components["schemas"]["MatchPracticeOutcome"];
            /**
             * Format: int32
             * @description Suggestions the engine offered for this line. Zero on a line it matched outright, and zero on a line it cannot see a candidate for — Outcome tells those two apart.
             */
            suggestionCount: number | string;
            /**
             * Format: double
             * @description Best suggestion confidence for the line, or null when nothing was suggested.
             */
            topConfidence?: null | number | string;
        };
        /** @description Which shape of three-way-match practice data to add. */
        SeedMatchPracticeDataAdminRequest: {
            scenario?: null | components["schemas"]["MatchPracticeScenario"];
        };
        /** @description What one call to the three-way-match practice seeder added to the organisation. */
        SeedMatchPracticeDataAdminResponse: {
            /**
             * Format: uuid
             * @description The organisation the data landed in.
             */
            organisationId: string;
            /** @description The scenario that was seeded. */
            scenario: components["schemas"]["MatchPracticeScenario"];
            /**
             * Format: int32
             * @description Bills created, one per practice case.
             */
            billsCreated: number | string;
            /**
             * Format: int32
             * @description Bill lines created across every case.
             */
            billLinesCreated: number | string;
            /**
             * Format: int32
             * @description Purchase orders created across every case.
             */
            purchaseOrdersCreated: number | string;
            /**
             * Format: int32
             * @description Delivery notes created across every case.
             */
            deliveryNotesCreated: number | string;
            /**
             * Format: int32
             * @description Allocations the auto-matcher wrote by itself. Zero for ManualSet by design; for MixedMatchTypes this is the SKU and wording lines the engine was meant to take unattended.
             */
            allocationsCreated: number | string;
            /**
             * Format: int32
             * @description Lines whose actual outcome differed from what the scenario intended. Always 0 on a client running default matching settings. A non-zero count means the client's thresholds moved a line into a different lane — read the per-line outcomes to see which, rather than assuming the seeded bills demonstrate what they claim to.
             */
            linesNotAsIntended: number | string;
            /** @description One entry per practice case, in the order they were created. */
            cases: components["schemas"]["SeededMatchCaseResponse"][];
        };
        SendInvoiceOverrides: {
            eInvoice?: null | components["schemas"]["InvoiceEInvoiceChoice"];
            email?: null | components["schemas"]["InvoiceEmailChoice"];
            tone?: null | components["schemas"]["InvoiceTone"];
            /** @description Overrides the catalogue-resolved email Subject. When null, catalogue resolves. */
            subject?: null | string;
            /** @description Overrides the catalogue-resolved inbox preview text (the line that previews next to the subject in most clients). When null, catalogue resolves. */
            previewText?: null | string;
            /** @description Overrides the catalogue-resolved greeting line (e.g. "Hi Acme,"). When null, catalogue resolves. */
            greetingLine?: null | string;
            /** @description Overrides the catalogue-resolved opening body. Markdown; rendered to HTML at send time. When null, catalogue resolves. */
            openingBodyMarkdown?: null | string;
            /** @description Override the organisation's DefaultReminderOffsets for this send. null (or field omitted): use the organisation's default list. []: schedule no reminders for this send. Populated: schedule exactly these offsets, overriding the organisation default. Each offset is resolved relative to the invoice's DueDate; offsets that would resolve to a past time are skipped silently. */
            reminders?: null | components["schemas"]["InvoiceReminderOffset"][];
            /** @description Override the invoice's CC recipients for this send. null (or omitted): use the invoice's CC, or the organisation default when the invoice has none. Populated (or []): use exactly these, and persist them on the invoice so its reminders CC the same recipients. Each must be a valid email. */
            cc?: null | string[];
            /** @description Override the Reply-To address for this send's email only (reminders keep the organisation default). When null, the organisation's DefaultReplyToEmail is used, falling back to its contact email. Must be a valid email. */
            replyTo?: null | string;
        };
        SendReminderRequest: {
            /** @description Optional custom subject line. Omit to use the chaser template matched to how overdue the invoice is. */
            subject?: null | string;
            /** @description Optional custom opening message (markdown). Omit to use the chaser template. */
            message?: null | string;
        };
        /** @description Where bill lines go in the organisation's books. Each line listed has both its choices replaced; lines left out are unchanged. */
        SetBillCodingRequest: {
            /** @description The lines to code. */
            lines?: components["schemas"]["BillLineCodingRequest"][];
        };
        /** @description The organisation member who made the spend. */
        SetExpenseSpenderRequest: {
            /**
             * Format: uuid
             * @description The user to attribute the expense to. Must be a member of the organisation.
             */
            userId: string;
        };
        /** @description The accounting platform tax rate to post a Dolfin tax rate as. */
        SetTaxRateMappingRequest: {
            /**
             * Format: uuid
             * @description Id of an active accounting platform tax rate (from GET /accounting/tax-rates). Choose a sales rate: Xero's OUTPUT rates, not its INPUT ones.
             */
            accountingTaxRateId?: string;
        };
        /** @enum {unknown} */
        SignInApp: "Portal" | "Sandbox" | "Integrator" | "Direct";
        /** @enum {unknown} */
        SignInMethod: "Google" | "Microsoft" | "Register" | "InviteAccept" | "DevLogin" | "IntegratorExchange" | "EmailCode";
        /** @description A purchase to simulate on a sample card. Every field is optional; anything left out is filled with a plausible everyday purchase. */
        SimulateCardTransactionRequest: {
            /** @description Merchant name as the card network would print it, e.g. "PRET A MANGER". Random when omitted. */
            merchant?: null | string;
            /**
             * Format: double
             * @description Amount in the card's currency. Must be greater than 0. Random when omitted.
             */
            amount?: null | number | string;
            /** @description Four-digit merchant category code, which decides how the expense is coded. Defaults to the chosen merchant's code, or 5999 (miscellaneous retail) when a merchant is named without one. */
            mcc?: null | string;
            status?: null | components["schemas"]["CardTransactionStatus"];
            /**
             * Format: date-time
             * @description When the purchase happened. A time with an offset is converted to UTC; one without is taken as UTC. Defaults to now.
             */
            occurredAt?: null | string;
        };
        SpendCategoryResponse: {
            /** Format: uuid */
            id: string;
            key: string;
            displayName: string;
            defaultSpendClass: null | components["schemas"]["SpendClass"];
            glAccountCode: null | string;
            isArchived: boolean;
            /** Format: date-time */
            createdAt: string;
        };
        SpendCategoryRow: {
            /** @description The stored category key (e.g. ai_intelligence), or null for uncategorised line items. Resolve the display name via GET /payables/categories. */
            category?: null | string;
            currency: string;
            /** Format: double */
            total?: number | string;
            /** Format: double */
            fixed?: number | string;
            /** Format: double */
            variable?: number | string;
            /** Format: int32 */
            billCount?: number | string;
            /** Format: int32 */
            lineItemCount?: number | string;
            billIds?: string[];
        };
        /** @enum {unknown} */
        SpendClass: "Fixed" | "Variable" | null;
        SpendClassRow: {
            spendClass: components["schemas"]["SpendClass"];
            currency: string;
            /** Format: double */
            total?: number | string;
            /** Format: int32 */
            billCount?: number | string;
            billIds?: string[];
        };
        SpendDeltaRow: {
            currency: string;
            /** Format: date */
            previousFrom?: string;
            /** Format: date */
            previousTo?: string;
            /** Format: double */
            previousTotal?: number | string;
            /** Format: double */
            deltaAmount?: number | string;
            /**
             * Format: double
             * @description DeltaAmount / PreviousTotal; null when the prior window was zero (no baseline to compare).
             */
            deltaPercent?: null | number | string;
            /** @description up | down | flat. */
            direction: string;
        };
        SpendSummaryResponse: {
            /** Format: date */
            from?: string;
            /** Format: date */
            to?: string;
            defaultCurrency?: null | string;
            mixedCurrency?: boolean;
            totals?: components["schemas"]["SpendTotalsRow"][];
            byCategory?: components["schemas"]["SpendCategoryRow"][];
            bySpendClass?: components["schemas"]["SpendClassRow"][];
            bySupplier?: components["schemas"]["SpendSupplierRow"][];
            tags?: components["schemas"]["SpendTagRow"][];
            delta?: components["schemas"]["SpendDeltaRow"][];
            /** Format: int32 */
            uncategorisedCount?: number | string;
        };
        SpendSupplierRow: {
            /** Format: uuid */
            supplierId?: null | string;
            supplierName: string;
            currency: string;
            /** Format: double */
            total?: number | string;
            /** Format: double */
            fixed?: number | string;
            /** Format: double */
            variable?: number | string;
            /** Format: int32 */
            billCount?: number | string;
            billIds?: string[];
        };
        SpendTagRow: {
            tag: string;
            currency: string;
            /** Format: double */
            total?: number | string;
            /** Format: int32 */
            billCount?: number | string;
            billIds?: string[];
        };
        SpendTotalsRow: {
            currency: string;
            /** Format: double */
            total?: number | string;
            /** Format: double */
            fixed?: number | string;
            /** Format: double */
            variable?: number | string;
            /**
             * Format: double
             * @description Fixed / (Fixed + Variable) — committed share among classified lines; null when none are classified.
             */
            fixedShare?: null | number | string;
            /** Format: int32 */
            billCount?: number | string;
        };
        StartBackfillRequest: {
            /** Format: date-time */
            since?: null | string;
            /** Format: date-time */
            until?: null | string;
        };
        /** @description Starts connecting a bank. */
        StartBankConnectionRequest: {
            /** @description Institution id from the bank connections institutions list, e.g. 'modelo-sandbox'. */
            institutionId: string;
            /** @description Absolute http(s) URL the account holder is sent back to after their bank; its host must be on the client's allowed redirect hosts. Gets `bankConnectionId` and `status` (connected or failed) appended as query parameters. Defaults to the Dolfin sandbox's bank connection return page. */
            returnUrl?: null | string;
        };
        /** @description Start a set of books. */
        StartBookRequest: {
            /**
             * Format: date
             * @description First day of the books, YYYY-MM-DD. Must be the first day of a month, not in the future, and inside the fetched transaction history of every connected bank account. The platform's trial balance at the day before becomes the opening balances.
             */
            startDate: string;
        };
        /** @description Accounts of one classification. */
        StatementGroup: {
            /** @description asset, liability, equity, revenue or expense. */
            classification?: string;
            /** @description One row per account. */
            rows?: components["schemas"]["StatementRow"][];
            /**
             * Format: double
             * @description Sum of the rows.
             */
            total?: number | string;
            /**
             * Format: double
             * @description Sum of the platform rows (compare only).
             */
            platformTotal?: null | number | string;
        };
        /** @description One account on a statement. Amounts are in the account's natural sign: assets and expenses debit positive; liabilities, equity and revenue credit positive. */
        StatementRow: {
            /**
             * Format: uuid
             * @description Ledger account id; null for a computed line such as current year earnings.
             */
            ledgerAccountId?: null | string;
            /** @description Account code, when the platform has codes. */
            code?: null | string;
            /** @description Account name. */
            name?: string;
            /**
             * Format: double
             * @description Amount in the books.
             */
            amount?: number | string;
            /**
             * Format: double
             * @description Amount on the platform (compare only).
             */
            platformAmount?: null | number | string;
            /**
             * Format: double
             * @description Books minus platform (compare only).
             */
            difference?: null | number | string;
            section?: null | components["schemas"]["ProfitAndLossSection"];
            balanceSheetSection?: null | components["schemas"]["BalanceSheetSection"];
        };
        /** @description Optional overrides for a registration. Any field left null uses the organisation's own value. */
        SubmitEInvoicingRegistrationRequest: {
            /** @description Registered legal name, if different from the organisation's name. */
            legalName?: null | string;
            /** @description VAT or tax number. Required for registration, from here or from the organisation. */
            taxNumber?: null | string;
            companyRegistrationNumber?: null | string;
            addressLine1?: null | string;
            addressLine2?: null | string;
            city?: null | string;
            /** @description Province, state or county. */
            addressRegion?: null | string;
            postalCode?: null | string;
            /** @description ISO 3166-1 alpha-2 country code (e.g. GB, BE, DE) */
            country?: null | string;
            contactEmail?: null | string;
        };
        SupplierCreditApplicationResponse: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            supplierCreditNoteId?: string;
            /** Format: uuid */
            billId?: string;
            /** Format: uuid */
            supplierId?: string;
            /** Format: double */
            amount?: number | string;
            currency: string;
            /** @description Applied or Reversed. */
            status?: components["schemas"]["SupplierCreditApplicationStatus"];
            /** Format: date-time */
            createdAt?: string;
            /** Format: uuid */
            createdBy?: null | string;
            /** Format: date-time */
            updatedAt?: string;
            accountingSync?: null | components["schemas"]["AccountingDocumentSyncResponse"];
        };
        /** @enum {unknown} */
        SupplierCreditApplicationStatus: "Applied" | "Reversed";
        SupplierCreditBalanceResponse: {
            /** @description ISO 4217 currency code. */
            currency: string;
            /**
             * Format: double
             * @description Total credit available to apply against this supplier's bills, in this currency.
             */
            available?: number | string;
        };
        SupplierCreditLedgerEntryResponse: {
            entryType?: components["schemas"]["SupplierCreditLedgerEntryType"];
            /** Format: uuid */
            supplierCreditNoteId?: string;
            /**
             * Format: uuid
             * @description Set for AppliedToBill / ApplicationReversed entries.
             */
            billId?: null | string;
            /**
             * Format: uuid
             * @description Set for AppliedToBill / ApplicationReversed entries.
             */
            applicationId?: null | string;
            /** @description Document number for credit-note-issued entries. */
            reference?: null | string;
            /**
             * Format: double
             * @description Signed amount: + for credit created/released, − for credit consumed.
             */
            amount?: number | string;
            currency: string;
            /** Format: date-time */
            occurredAt?: string;
        };
        /** @enum {unknown} */
        SupplierCreditLedgerEntryType: "CreditNoteIssued" | "AppliedToBill" | "ApplicationReversed";
        SupplierCreditNoteResponse: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            organisationId?: string;
            /** Format: uuid */
            supplierId?: string;
            documentNumber?: null | string;
            /**
             * Format: double
             * @description Gross (tax-inclusive) credit amount, always positive.
             */
            amount?: number | string;
            /**
             * Format: double
             * @description Net (ex-tax) portion of the credit. NetAmount + TaxAmount == Amount.
             */
            netAmount?: number | string;
            /**
             * Format: double
             * @description VAT/tax portion of the credit.
             */
            taxAmount?: number | string;
            /**
             * Format: double
             * @description How much of Amount has been netted against bills.
             */
            appliedAmount?: number | string;
            /**
             * Format: double
             * @description Remaining credit available to apply (Amount - AppliedAmount).
             */
            available?: number | string;
            /**
             * Format: uuid
             * @description Soft reference to the tax rate applied. Null on a zero-rated credit.
             */
            taxRateId?: null | string;
            taxRateSnapshot?: null | components["schemas"]["TaxRateSnapshotResponse"];
            /**
             * Format: uuid
             * @description Optional id of the bill this credit relates to (header-level provenance).
             */
            originalBillId?: null | string;
            /** @description ISO 4217 currency code (e.g. GBP, USD, EUR). */
            currency: string;
            reason?: null | string;
            /** @description How the credit note reached Dolfin. Manual: keyed in here. Ocr: read off an uploaded document. EInvoice: delivered over an e-invoicing network, which makes it the supplier's own document — it cannot be deleted, though it can still be issued and applied. */
            source?: components["schemas"]["SupplierCreditNoteSource"];
            status?: components["schemas"]["SupplierCreditNoteState"];
            /** Format: date-time */
            issuedAt?: null | string;
            /** Format: date-time */
            createdAt?: string;
            /** Format: uuid */
            createdBy?: null | string;
            /** Format: date-time */
            updatedAt?: string;
            /** Format: uuid */
            updatedBy?: null | string;
            accountingSync?: null | components["schemas"]["AccountingDocumentSyncResponse"];
        };
        /** @enum {unknown} */
        SupplierCreditNoteSource: "Manual" | "Ocr" | "EInvoice";
        /** @enum {unknown} */
        SupplierCreditNoteState: "Draft" | "Issued" | "PartiallyApplied" | "Applied";
        /** @enum {unknown} */
        SupplierOrigin: "Unknown" | "Manual" | "BillExtraction" | "EInvoice";
        SupplierPaid: {
            /** Format: uuid */
            supplierId?: null | string;
            supplierName: string;
            /** Format: double */
            paid?: number | string;
            /** Format: int32 */
            billCount?: number | string;
        };
        SupplierPaymentTiming: {
            /**
             * Format: double
             * @description Mean days from bill invoice date to payment, over paid bills with an invoice date. Null when none have one.
             */
            averageDaysToPay?: null | number | string;
            /**
             * Format: double
             * @description Share of paid bills settled on or before their due date. Null when no paid bill has a due date.
             */
            onTermsRate?: null | number | string;
            /**
             * Format: int32
             * @description Bills paid in the last 12 months.
             */
            billsPaid?: number | string;
        };
        SupplierResponse: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            organisationId?: string;
            name: string;
            email?: null | string;
            phone?: null | string;
            website?: null | string;
            taxNumber?: null | string;
            registrationNumber?: null | string;
            address?: null | components["schemas"]["Address"];
            bankDetails?: components["schemas"]["BankDetails"];
            bankDetailsVerified?: boolean;
            /** Format: date-time */
            bankDetailsVerifiedAt?: null | string;
            paymentTermsDefault?: null | string;
            /**
             * Format: uuid
             * @description The ledger account (from GET /accounting/ledger-accounts) this supplier's bills post to when a line names none of its own. Taken from the supplier's default purchases account in the accounting platform the first time a bill of theirs is pushed, if not set before. Null uses the organisation's default expense account.
             */
            defaultLedgerAccountId?: null | string;
            /** @description How this supplier record came to exist. Manual: created through the API or UI by a person. BillExtraction: inferred from a bill we read by OCR or an LLM, so every field including the name is a reading of a document. EInvoice: created from a document delivered over an e-invoicing network, carrying a scheme-qualified participant id and figures from the sender's own accounting system. Unknown: predates the field being recorded, which is not the same fact as Manual and is deliberately not reported as it. */
            origin?: components["schemas"]["SupplierOrigin"];
            /** Format: date-time */
            createdAt?: string;
            /** Format: uuid */
            createdBy?: null | string;
            /** Format: date-time */
            updatedAt?: string;
            /** Format: uuid */
            updatedBy?: null | string;
        };
        /** @enum {unknown} */
        SupplierStanding: "Any" | "New" | "Established";
        SyncStartedResponse: {
            /** Format: uuid */
            jobId: string;
        };
        /** @description One of the organisation's tax rates, and the accounting platform's tax rate it posts as. */
        TaxRateMappingResponse: {
            /**
             * Format: uuid
             * @description Id of the tax rate, as set on invoice lines.
             */
            taxRateId?: string;
            /** @description The tax rate's code. */
            taxRateCode: string;
            /** @description The tax rate's name. */
            taxRateName: string;
            /**
             * Format: double
             * @description The tax rate, as a percentage (20 for 20%).
             */
            taxRate?: number | string;
            /**
             * Format: uuid
             * @description Id of the accounting platform's tax rate it posts as (from GET /accounting/tax-rates). Null when it is not mapped yet; an invoice using it cannot be pushed until it is.
             */
            accountingTaxRateId?: null | string;
            /** @description The platform tax rate's code, e.g. Xero's OUTPUT2. Null when not mapped. */
            accountingTaxRateCode?: null | string;
            /** @description The platform tax rate's name. Null when not mapped. */
            accountingTaxRateName?: null | string;
        };
        TaxRateResponse: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            organisationId?: null | string;
            code: string;
            name: string;
            /** Format: double */
            rate?: number | string;
            source: string;
            isReadOnly?: boolean;
            /** Format: date-time */
            createdAt?: null | string;
            /** Format: uuid */
            createdBy?: null | string;
            /** Format: date-time */
            updatedAt?: null | string;
            /** Format: uuid */
            updatedBy?: null | string;
        };
        TaxRateSnapshotResponse: {
            code: string;
            name: string;
            /** Format: double */
            rate?: number | string;
            source: string;
            /** Format: uuid */
            sourceId?: null | string;
            /** Format: date-time */
            snapshottedAt?: string;
        };
        ToolAction: {
            type: string;
            label: string;
            params?: unknown;
        };
        /** @description A project, department or cost-centre dimension synced from the accounting platform. Read-only in v1. */
        TrackingCategoryResponse: {
            /**
             * Format: uuid
             * @description Unique identifier of the tracking category within Dolfin.
             */
            id?: string;
            /** @description Category name. */
            name: string;
            /** @description Whether the category is still active in the accounting platform. */
            isActive?: boolean;
            /** @description The parent dimension in the accounting platform, where categories are nested. */
            parentId?: null | string;
            /**
             * Format: date-time
             * @description When the category was last synced.
             */
            syncedAt?: string;
        };
        /** @description The books' trial balance at a date, optionally beside the accounting platform's. */
        TrialBalanceResponse: {
            /**
             * Format: date
             * @description Report date.
             */
            date?: string;
            /** @description The basis the figures are on: Accrual or Cash. */
            basis?: components["schemas"]["ReportingBasis"];
            /** @description Currency of every amount. */
            currency?: string;
            /** @description True when the platform columns are filled. */
            compared?: boolean;
            /** @description One row per account with a balance on either side. */
            rows?: components["schemas"]["TrialBalanceRow"][];
            /**
             * Format: double
             * @description Sum of debit balances.
             */
            totalDebit?: number | string;
            /**
             * Format: double
             * @description Sum of credit balances.
             */
            totalCredit?: number | string;
            /**
             * Format: double
             * @description The platform's sum of debit balances.
             */
            platformTotalDebit?: null | number | string;
            /**
             * Format: double
             * @description The platform's sum of credit balances.
             */
            platformTotalCredit?: null | number | string;
        };
        /** @description One account's balance. Income and expense accounts are year-to-date for the financial year containing the report date; earlier years' result is in retained earnings, as on the platform. */
        TrialBalanceRow: {
            /**
             * Format: uuid
             * @description Ledger account id; null for a line with no account (prior years' result when no retained earnings account exists).
             */
            ledgerAccountId?: null | string;
            /** @description Account code, when the platform has codes. */
            code?: null | string;
            /** @description Account name. */
            name?: string;
            /** @description Account classification: asset, liability, equity, revenue or expense. */
            classification?: null | string;
            /**
             * Format: double
             * @description Debit balance in the books.
             */
            debit?: number | string;
            /**
             * Format: double
             * @description Credit balance in the books.
             */
            credit?: number | string;
            /**
             * Format: double
             * @description Debit balance on the platform (compare only).
             */
            platformDebit?: null | number | string;
            /**
             * Format: double
             * @description Credit balance on the platform (compare only).
             */
            platformCredit?: null | number | string;
            /**
             * Format: double
             * @description Books minus platform, debit positive (compare only). Non-zero means the two disagree.
             */
            difference?: null | number | string;
        };
        /** @description A clause of the policy document that cannot be enforced automatically. */
        UnenforceableExpensePolicyClauseResponse: {
            /** @description The clause, quoted from the document. */
            quote: string;
            /**
             * Format: int32
             * @description Page the clause appears on. Only set for PDF documents.
             */
            page?: null | number | string;
            /** @description Why it cannot be enforced automatically. */
            reason: string;
        };
        /** @enum {unknown} */
        UnitOfMeasure: "Gram" | "Kilogram" | "Millilitre" | "Litre" | null;
        /** @description A merchant category code seen on this organisation's spend that has no account mapped, with what it has cost so far. */
        UnmappedMccResponse: {
            /** @description The four-digit merchant category code. */
            mcc: string;
            /** @description Human-readable label for the category. */
            label: string;
            /**
             * Format: int32
             * @description How many transactions carry this code.
             */
            transactionCount?: number | string;
            /**
             * Format: double
             * @description Total billed to the organisation's cards across those transactions. Sort by this to fix the mappings that matter first.
             */
            totalAmount?: number | string;
            /** @description Currency of totalAmount (ISO 4217). Null when the spend was billed in more than one currency, in which case the total is only useful for ordering. */
            currency?: null | string;
        };
        /** @description The accounts to set. A field left out or null is left as it is. */
        UpdateApAccountingSettingsRequest: {
            /**
             * Format: uuid
             * @description Id of an active ledger account (from GET /accounting/ledger-accounts) that bill lines post to by default.
             */
            defaultExpenseLedgerAccountId?: null | string;
            /**
             * Format: uuid
             * @description Id of an active bank or credit card ledger account (from GET /accounting/ledger-accounts) that bill payments are paid from.
             */
            billPaymentLedgerAccountId?: null | string;
        };
        /** @description The accounts to set. A field left out or null is left as it is. */
        UpdateArAccountingSettingsRequest: {
            /**
             * Format: uuid
             * @description Id of an active ledger account (from GET /accounting/ledger-accounts) that invoice revenue posts to by default.
             */
            defaultIncomeLedgerAccountId?: null | string;
            /**
             * Format: uuid
             * @description Id of an active bank ledger account (from GET /accounting/ledger-accounts) that invoice payments are deposited into.
             */
            depositLedgerAccountId?: null | string;
            /**
             * Format: uuid
             * @description Id of an active ledger account (from GET /accounting/ledger-accounts) that Stripe card payments are recorded into until Stripe pays them out. Xero: a current asset with "Enable payments to this account" on. QuickBooks: a current asset or bank account. It cannot be the deposit account.
             */
            stripeClearingLedgerAccountId?: null | string;
            /**
             * Format: uuid
             * @description Id of an active expense ledger account (from GET /accounting/ledger-accounts) that Stripe's fees are posted to.
             */
            stripeFeesLedgerAccountId?: null | string;
            /** @description True to stop using Stripe clearing: both Stripe accounts are unset, Stripe payments are recorded straight into the deposit account again and payouts are no longer pushed. Cannot be combined with choosing either Stripe account. */
            removeStripeAccounts?: null | boolean;
        };
        /** @description Changes to the current book. Omitted fields are unchanged. Control accounts and bank mapping can only change while the book is in setup; the close date only once it is active. */
        UpdateBookRequest: {
            /**
             * Format: uuid
             * @description Accounts receivable control account (ledger account id).
             */
            accountsReceivableLedgerAccountId?: null | string;
            /**
             * Format: uuid
             * @description Accounts payable control account (ledger account id).
             */
            accountsPayableLedgerAccountId?: null | string;
            /**
             * Format: uuid
             * @description VAT control account (ledger account id).
             */
            vatLedgerAccountId?: null | string;
            /**
             * Format: uuid
             * @description Suspense account that unmatched, uncategorised bank lines post to (ledger account id).
             */
            uncategorisedLedgerAccountId?: null | string;
            /**
             * Format: uuid
             * @description Clearing account for card payments taken through Stripe (ledger account id). Optional.
             */
            stripeClearingLedgerAccountId?: null | string;
            /**
             * Format: uuid
             * @description Expense account for Stripe processing fees (ledger account id). Optional.
             */
            stripeFeesLedgerAccountId?: null | string;
            /**
             * Format: uuid
             * @description Account that takes trial-balance rows the platform reports without an account (ledger account id).
             */
            openingBalanceDifferenceLedgerAccountId?: null | string;
            /**
             * Format: uuid
             * @description Retained earnings: where earlier financial years' result is reported (ledger account id).
             */
            retainedEarningsLedgerAccountId?: null | string;
            /** @description Mapping of the platform's bank-type accounts to connected bank accounts. Each entry replaces that platform account's mapping; platform accounts not listed are unchanged. */
            bankAccounts?: null | components["schemas"]["BookBankAccountRequest"][];
            /**
             * Format: date
             * @description Lock date, YYYY-MM-DD. Postings dated on or before it land on the next day and keep their original date. Active books only; not in the future and not before the opening-balance date.
             */
            closeDate?: null | string;
            /** @description True removes the close date, so no postings move. Active books only; not with closeDate. */
            clearCloseDate?: boolean;
            reportingBasis?: null | components["schemas"]["ReportingBasis"];
        };
        /** @description Changes to a categorisation rule; leave out what stays the same. */
        UpdateBookRuleRequest: {
            /** @description New name. */
            name?: null | string;
            /**
             * Format: int32
             * @description New priority, lowest first.
             */
            priority?: null | number | string;
            field?: null | components["schemas"]["BookRuleField"];
            operator?: null | components["schemas"]["BookRuleOperator"];
            /** @description New text to look for. */
            value?: null | string;
            direction?: null | components["schemas"]["BankLineDirection"];
            /**
             * @description True makes the rule apply in either direction (applied before direction, so both can be sent).
             * @default false
             */
            clearDirection: boolean;
            /**
             * Format: double
             * @description New minimum unsigned amount.
             */
            minAmount?: null | number | string;
            /**
             * Format: double
             * @description New maximum unsigned amount.
             */
            maxAmount?: null | number | string;
            /**
             * @description True removes the amount range (applied before minAmount and maxAmount, so a full edit can send all three).
             * @default false
             */
            clearAmountRange: boolean;
            /**
             * Format: uuid
             * @description New ledger account.
             */
            ledgerAccountId?: null | string;
            /**
             * Format: uuid
             * @description New tax rate.
             */
            accountingTaxRateId?: null | string;
            /**
             * @description True removes the tax rate (applied before accountingTaxRateId).
             * @default false
             */
            clearTaxRate: boolean;
            /** @description False turns the rule off; true turns it back on. */
            isEnabled?: null | boolean;
        };
        UpdateCardConnectionRequest: {
            displayName?: null | string;
            /** Format: uuid */
            clearingLedgerAccountId?: null | string;
            /** Format: uuid */
            defaultExpenseLedgerAccountId?: null | string;
        };
        UpdateClientRequest: {
            name: string;
            /** Format: double */
            paymentRevenueSharePercent: number | string;
            /** Format: double */
            dolfinRevenueSharePercent: number | string;
        };
        UpdateCustomerRequest: {
            name: string;
            email?: null | string;
            phone?: null | string;
            taxNumber?: null | string;
            addressLine1?: null | string;
            addressLine2?: null | string;
            city?: null | string;
            state?: null | string;
            postalCode?: null | string;
            /** @description ISO 3166-1 alpha-2 country code (e.g. GB, US, DE) */
            country?: null | string;
            electronicAddressScheme?: null | components["schemas"]["EInvoiceAddressScheme"];
            /** @description Where electronic invoices are delivered: a Peppol participant id such as 0208:0455341259, an Italian codice destinatario such as M5UXCR5, or a PEC address. This is a routing address, not a tax identifier. */
            electronicAddress?: null | string;
            /** @description The customer's WhatsApp number in international format, e.g. +447700900123. Omit to leave it unchanged; an empty string removes it. Changing it withdraws any WhatsApp consent recorded for the previous number. */
            whatsAppPhone?: null | string;
            preferredChannel?: null | components["schemas"]["CustomerChannel"];
        };
        /** @description A line in a delivery-note update. Null id creates a new line; a known id updates the existing line in place. */
        UpdateDeliveryNoteLineRequest: {
            /**
             * Format: uuid
             * @description Existing line id to update in place, or null to create a new line.
             */
            id?: null | string;
            /** @description Caller's own reference for this line (a reverse pointer to the platform's record). Optional and free-form — stored and echoed back verbatim. It does not identify the line: a line is only ever updated in place by id, so a request line with no id creates a new line even if this value matches an existing one. */
            externalRef?: null | string;
            /** @description Line description. */
            description: string;
            /** @description Product SKU, used as the exact-match key against bill lines. Optional. */
            sku?: null | string;
            /**
             * Format: double
             * @description Quantity received on this line. Zero is allowed and meaningful: it records an item that was expected but did not arrive, so the shortfall can be matched and reported against the bill instead of the line being left off the note. Negative is rejected.
             */
            quantityReceived?: number | string;
            /** @description Unit of measure (e.g. each, kg). Optional. */
            unit?: null | string;
            /**
             * Format: int32
             * @description Display order of the line within the note. Stored and returned exactly as supplied — it is never renumbered. Lines are returned sorted by this value, with ties broken by line id.
             */
            sortOrder?: number | string;
        };
        /** @description Full-representation update of a delivery note and its lines. Lines with a known id are updated in place, lines with no id are added, and omitted lines are removed. A line already matched to a bill cannot be removed or have its received quantity dropped below what is already matched. */
        UpdateDeliveryNoteRequest: {
            /**
             * Format: uuid
             * @description Supplier the goods were received from. Optional.
             */
            supplierId?: null | string;
            /** @description Caller's own reference for the note. Optional. */
            externalRef?: null | string;
            /** @description Human delivery-note number. Required. */
            dnNumber?: null | string;
            /**
             * Format: uuid
             * @description The purchase order this note was despatched against. Optional, and worth supplying: once a line on this note is matched to a bill line, the engine looks for the same item on this order and matches that too, in preference to scoring the order against the bill. It says which order to look at, not which line — the item must appear on the order (same product code, else the same description) or no purchase-order match is made from it. The authoritative binding is always line-level, through allocations.
             */
            purchaseOrderId?: null | string;
            /**
             * Format: date-time
             * @description When the goods were received. Optional.
             */
            receivedAt?: null | string;
            /** @description The full set of received lines after the edit. */
            lines?: components["schemas"]["UpdateDeliveryNoteLineRequest"][];
        };
        UpdateMemberRoleRequest: {
            role: components["schemas"]["ClientRole"];
        };
        UpdateProductRequest: {
            /** @description Product or service name, unique within the organisation. Up to 256 characters. */
            name: string;
            /** @description Optional longer description of the product or service. */
            description?: null | string;
            /**
             * Format: double
             * @description Price per unit, in the product's currency. Zero is valid — use it for comped items, free shipping lines and £0 trial SKUs. A negative price is rejected with Product.InvalidPrice, as is omitting the field or sending null.
             */
            unitPrice: number | string;
            /** @description ISO 4217 currency code (e.g. GBP, USD, EUR) */
            currency: string;
            /** @description Whether this is a physical product or a service. Defaults to Product. */
            type?: components["schemas"]["ProductType"];
            /**
             * Format: uuid
             * @description Id of the accounting platform income ledger account (from GET /accounting/ledger-accounts) this product's invoice lines post their revenue to when invoices are pushed to the accounting platform. This request replaces the product, so send the current value (from GET /products/{id}) to keep it; omitted or null resets it to the organisation's default income account.
             */
            incomeLedgerAccountId?: null | string;
        };
        /** @description A line in a purchase-order update. Null id creates a new line; a known id updates the existing line in place. */
        UpdatePurchaseOrderLineRequest: {
            /**
             * Format: uuid
             * @description Existing line id to update in place, or null to create a new line.
             */
            id?: null | string;
            /** @description Caller's own reference for this line (a reverse pointer to the platform's record). Optional and free-form — stored and echoed back verbatim. It does not identify the line: a line is only ever updated in place by id, so a request line with no id creates a new line even if this value matches an existing one. */
            externalRef?: null | string;
            /** @description Line description. */
            description: string;
            /** @description Product SKU, used as the exact-match key against bill lines. Optional. */
            sku?: null | string;
            /**
             * Format: double
             * @description Quantity ordered on this line.
             */
            quantityOrdered?: number | string;
            /** @description Unit of measure (e.g. each, kg). Optional. */
            unit?: null | string;
            /**
             * Format: double
             * @description Ordered unit price (ex-tax).
             */
            unitPrice?: number | string;
            /**
             * Format: double
             * @description Tax rate to apply, as a percentage.
             */
            taxRate?: number | string;
            /**
             * Format: double
             * @description Tax amount for the line.
             */
            taxAmount?: number | string;
            /**
             * Format: double
             * @description Net (ex-tax) line total.
             */
            subTotal?: number | string;
            /**
             * Format: int32
             * @description Display order of the line within the order. Stored and returned exactly as supplied — it is never renumbered. Lines are returned sorted by this value, with ties broken by line id.
             */
            sortOrder?: number | string;
        };
        /** @description Full-representation update of a purchase order and its lines. Lines with a known id are updated in place, lines with no id are added, and omitted lines are removed. A line already matched to a bill cannot be removed or have its ordered quantity dropped below what is already matched. */
        UpdatePurchaseOrderRequest: {
            /**
             * Format: uuid
             * @description Supplier the order is raised against. Optional.
             */
            supplierId?: null | string;
            /** @description Caller's own reference for the order. Optional. */
            externalRef?: null | string;
            /** @description Human purchase-order number printed on the order. Required. */
            poNumber?: null | string;
            /** @description ISO 4217 currency code. Defaults to GBP. */
            currency?: string;
            /**
             * Format: date-time
             * @description Date the order was raised. Optional.
             */
            orderDate?: null | string;
            /**
             * Format: date-time
             * @description Expected delivery date. Optional.
             */
            expectedDeliveryDate?: null | string;
            /** @description The full set of ordered lines after the edit. */
            lines?: components["schemas"]["UpdatePurchaseOrderLineRequest"][];
        };
        UpdateScheduleLineItemTaxRatesAdminRequest: {
            /** @description The line items to update. Each entry sets or clears the tax rate on one of the schedule's existing line items. */
            lineItems: components["schemas"]["LineItemTaxRateUpdate"][];
        };
        UpdateTaxRateRequest: {
            /** @description Short code, e.g. "VAT20". Must be unique within the organisation. */
            code: string;
            /** @description Human-readable name, e.g. "VAT 20%". */
            name: string;
            /**
             * Format: double
             * @description Percentage from 0 to 100, e.g. 20 for 20%.
             */
            rate?: number | string;
        };
        UpdateUserRoleRequest: {
            role?: null | components["schemas"]["OrganisationRole"];
        };
        UpdateUserRoleResponse: {
            /** Format: uuid */
            userId?: string;
            /** Format: uuid */
            organisationId?: string;
            role?: components["schemas"]["OrganisationRole"];
        };
        UpsertApprovalPolicyRequest: {
            /** @description Policy name, e.g. "High value bills". Required, up to 120 characters. */
            name?: string;
            /**
             * Format: int32
             * @description 0 to 1000; when several policies match a bill, the lowest number wins. Defaults to 0.
             */
            priorityOrder?: number | string;
            /** @description Whether the policy is active. Defaults to true. */
            active?: boolean;
            /**
             * Format: double
             * @description Match bills whose total is greater than or equal to this amount. Requires currency.
             */
            amountGte?: null | number | string;
            /**
             * Format: double
             * @description Match bills whose total is less than or equal to this amount. Requires currency.
             */
            amountLte?: null | number | string;
            /** @description ISO 4217 currency code, e.g. GBP. Required when an amount bound is set; scopes the policy to bills in this currency (no FX conversion). */
            currency?: null | string;
            /** @description Restrict the policy to bills from these suppliers. Empty or omitted applies it to bills from any supplier. A supplier-specific policy beats a global one. */
            supplierIds?: string[];
            /** @description Supplier-history filter: Any, New (the supplier has never had a bill reviewed), or Established. Defaults to Any. */
            supplierStanding?: components["schemas"]["SupplierStanding"];
            /** @description Outcome when the policy matches a bill: AutoApprove (skip review), AlwaysReview (route for approval), or AutoVoid (void the bill). Defaults to AlwaysReview. */
            action?: components["schemas"]["ApprovalPolicyAction"];
            /** @description For AlwaysReview only: the users to route approval to, at most 5. Empty means no designated approver, and organisation admins action the bill. */
            approverUserIds?: string[];
        };
        UpsertClientMccMappingRequest: {
            ledgerAccountCode: string;
            taxCode?: null | string;
            categoryLabel?: null | string;
            isVatReclaimable?: null | boolean;
        };
        /** @description An expense approval policy: the conditions an expense must meet, and what happens when it does. */
        UpsertExpenseApprovalPolicyRequest: {
            /** @description Display name, up to 120 characters. */
            name?: string;
            /**
             * Format: int32
             * @description 0–1000; lower numbers win when several policies match. Also the display order.
             */
            priorityOrder?: number | string;
            /** @description Inactive policies are kept but never applied. Defaults to true. */
            active?: boolean;
            /**
             * Format: double
             * @description Match expenses of at least this amount, in `currency`. Judged on what the card was charged in its billing currency, the figure that posts to the accounting platform.
             */
            amountGte?: null | number | string;
            /**
             * Format: double
             * @description Match expenses of at most this amount, in `currency`. Judged on what the card was charged in its billing currency, the figure that posts to the accounting platform.
             */
            amountLte?: null | number | string;
            /** @description ISO 4217 code. Required when an amount bound is set; the policy then only matches spend on cards billed in this currency, with no conversion. A purchase made abroad is judged on its billed amount, not the foreign amount. */
            currency?: null | string;
            /** @description Four-digit merchant category codes to match. Empty matches any category. */
            mccCodes?: string[];
            /** @description Merchants to match. Empty matches any merchant. A merchant-, card- or person-specific policy takes precedence over one that applies to all. */
            merchantIds?: string[];
            /** @description Linked cards to match. Empty matches any card. A merchant-, card- or person-specific policy takes precedence over one that applies to all. */
            cardConnectionIds?: string[];
            /** @description Organisation members whose spend to match, by who spent it. Empty matches anyone, including spend with no spender. A merchant-, card- or person-specific policy takes precedence over one that applies to all. */
            spenderUserIds?: string[];
            /** @description Match by whether a receipt is attached. Defaults to Any. */
            receiptCondition?: components["schemas"]["ExpenseReceiptCondition"];
            /** @description Match business spend, personal spend, or both. Defaults to Any. */
            personalSpend?: components["schemas"]["ExpensePersonalSpendCondition"];
            /** @description What happens to a matching expense. Defaults to RequireApproval. */
            action?: components["schemas"]["ExpenseApprovalPolicyAction"];
            /** @description Up to 5 organisation members who may approve, for RequireApproval only (ignored otherwise). Empty means any member allowed to approve expenses. */
            approverUserIds?: string[];
        };
        UpsertMccMappingRequest: {
            /** Format: uuid */
            ledgerAccountId: string;
            taxCode?: null | string;
            categoryLabel?: null | string;
            isVatReclaimable?: null | boolean;
        };
        UserActivityClient: {
            /** Format: uuid */
            clientId: string;
            clientName: string;
        };
        UserActivityDay: {
            /** Format: date */
            date: string;
            /** Format: int32 */
            signIns: number | string;
            /** Format: int32 */
            activeUsers: number | string;
        };
        UserActivityOrganisation: {
            /** Format: uuid */
            organisationId: string;
            organisationName: string;
            /** Format: uuid */
            clientId: string;
            clientName: string;
        };
        UserActivitySummary: {
            /** Format: date */
            from: string;
            /** Format: date */
            to: string;
            /** Format: int32 */
            activeToday: number | string;
            /** Format: int32 */
            active7Days: number | string;
            /** Format: int32 */
            active30Days: number | string;
            /** Format: int32 */
            activeInWindow: number | string;
            /** Format: int32 */
            signIns: number | string;
            daily: components["schemas"]["UserActivityDay"][];
            byCountry: components["schemas"]["CountrySignIns"][];
            byDeviceType: components["schemas"]["DeviceTypeSignIns"][];
            byOs: components["schemas"]["OsSignIns"][];
            byBrowser: components["schemas"]["BrowserSignIns"][];
            byMethod: components["schemas"]["MethodSignIns"][];
            byApp: components["schemas"]["AppSignIns"][];
            activeOrganisationsByClient: components["schemas"]["ClientActiveOrganisations"][];
        };
        UserActivityUserRow: {
            /** Format: uuid */
            userId: string;
            email: string;
            name: null | string;
            organisations: components["schemas"]["UserActivityOrganisation"][];
            clients: components["schemas"]["UserActivityClient"][];
            /** Format: date-time */
            lastSignInAt: null | string;
            /** Format: date-time */
            lastActiveAt: null | string;
            /** Format: int32 */
            signInsInWindow: number | string;
            lastCountry: null | string;
            lastCity: null | string;
            lastDeviceType: null | components["schemas"]["DeviceType"];
            lastOs: null | components["schemas"]["DeviceOs"];
            lastBrowser: null | components["schemas"]["DeviceBrowser"];
        };
        UserOrganisationResponse: {
            /** Format: uuid */
            organisationId?: string;
            organisationName: string;
            industryDisplayName?: null | string;
            role: components["schemas"]["OrganisationRole"];
            /** Format: date-time */
            joinedAt?: string;
        };
        UserResponse: {
            /** Format: uuid */
            id?: string;
            email: string;
            name?: null | string;
            /** Format: date-time */
            createdAt?: string;
        };
        UserSignInRow: {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            userId: string;
            email: string;
            /** Format: date-time */
            occurredAt: string;
            method: components["schemas"]["SignInMethod"];
            app: components["schemas"]["SignInApp"];
            continent: null | string;
            country: null | string;
            region: null | string;
            city: null | string;
            postalCode: null | string;
            timezone: null | string;
            /** Format: double */
            latitude: null | number | string;
            /** Format: double */
            longitude: null | number | string;
            deviceType: components["schemas"]["DeviceType"];
            os: components["schemas"]["DeviceOs"];
            browser: components["schemas"]["DeviceBrowser"];
            userAgent: null | string;
        };
        ValidationError: {
            field: string;
            code: string;
            message: string;
        };
        /** @enum {unknown} */
        VatReclaimBlockedReason: "NoReceipt" | "NoSupplierVatNumber" | "NonReclaimableCategory" | "NoVatCharged" | "VatAmountNotItemised" | "PersonalExpense" | null;
        /** @description One tax rate's share of the VAT summary. */
        VatSummaryRate: {
            /**
             * Format: uuid
             * @description The accounting platform's tax rate id.
             */
            accountingTaxRateId?: string;
            /** @description The platform's tax code, e.g. OUTPUT2. */
            code?: null | string;
            /** @description The tax rate's name. */
            name?: null | string;
            /**
             * Format: double
             * @description The effective rate in percent; null if the platform gives none.
             */
            rate?: null | number | string;
            /**
             * Format: double
             * @description Sales excluding VAT at this rate.
             */
            netSales?: number | string;
            /**
             * Format: double
             * @description VAT on sales at this rate.
             */
            vatOnSales?: number | string;
            /**
             * Format: double
             * @description Purchases and expenses excluding VAT at this rate.
             */
            netPurchases?: number | string;
            /**
             * Format: double
             * @description VAT on purchases and expenses at this rate.
             */
            vatOnPurchases?: number | string;
        };
        /** @description An estimate of the UK VAT return's boxes 1, 4, 5, 6 and 7 for a period, from the books. Not a filed return: the accountant files from the accounting platform. */
        VatSummaryResponse: {
            /**
             * Format: date
             * @description First day of the period.
             */
            from?: string;
            /**
             * Format: date
             * @description Last day of the period.
             */
            to?: string;
            /** @description The basis the figures are on: Accrual or Cash. */
            basis?: components["schemas"]["ReportingBasis"];
            /** @description Currency of every amount. */
            currency?: string;
            /**
             * Format: double
             * @description Box 1: VAT on sales, from the VAT account's lines on income, net of credit notes.
             */
            vatOnSales?: number | string;
            /**
             * Format: double
             * @description Box 4: VAT reclaimable on purchases and expenses, net of supplier credits.
             */
            vatOnPurchases?: number | string;
            /**
             * Format: double
             * @description Box 5: VAT on sales less VAT on purchases. Positive is owed to HMRC, negative is a refund due.
             */
            netVat?: number | string;
            /**
             * Format: double
             * @description Box 6: sales excluding VAT, from income lines that carry a tax rate (zero-rated and exempt included). Pounds and pence, not rounded to whole pounds as on the return.
             */
            netSales?: number | string;
            /**
             * Format: double
             * @description Box 7: purchases and expenses excluding VAT, from the other lines that carry a tax rate (zero-rated and exempt included). Pounds and pence.
             */
            netPurchases?: number | string;
            /**
             * Format: double
             * @description The VAT account's other movement in the period, from lines with no tax rate (a payment to or refund from HMRC, a manual journal), credit positive. Not in any box.
             */
            otherVatAccountMovement?: number | string;
            /** @description The same figures per tax rate. */
            rates?: components["schemas"]["VatSummaryRate"][];
            /** @description How the figures are made. */
            note?: string;
            /** @description What the estimate leaves out. */
            leavesOut?: string[];
        };
        VoidBillRequest: {
            reason?: null | string;
        };
        WebhookDeliveryResponse: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            subscriptionId?: string;
            /** Format: uuid */
            eventId?: string;
            eventType: string;
            /**
             * Format: uuid
             * @description Organisation this delivery's underlying event belongs to. Null for company-scoped events, which carry a companyId instead — exactly one of the two is set.
             */
            organisationId?: null | string;
            /**
             * Format: uuid
             * @description Company this delivery's underlying event belongs to, for events about a bill that has not been assigned to an organisation yet. Null for every organisation-scoped event.
             */
            companyId?: null | string;
            status: string;
            /** Format: int32 */
            attempts?: number | string;
            /** Format: int32 */
            lastStatusCode?: null | number | string;
            /** Format: date-time */
            lastAttemptAt?: null | string;
            /** Format: date-time */
            nextAttemptAt?: null | string;
            /** Format: date-time */
            createdAt?: string;
            /** @description Full webhook envelope JSON exactly as it was sent to (or will be sent to) the subscriber URL. Useful for debugging / replay. */
            payload: string;
        };
        /** @enum {unknown} */
        WebhookDeliveryStatus: "Pending" | "Delivered" | "Failed" | null;
        WebhookSubscriptionResponse: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            clientId?: string;
            url: string;
            eventTypes: ("bill.created" | "bill.updated" | "bill.ocr_failed" | "bill.pending_review" | "bill.needs_approval" | "bill.approved" | "bill.rejected" | "bill.scheduled" | "bill.paid" | "bill.voided" | "bill.payment_failed" | "bill.payment_in_progress" | "invoice.created" | "invoice.updated" | "invoice.sent" | "invoice.partially_paid" | "invoice.paid" | "invoice.voided" | "invoice.credited" | "credit_note.issued" | "match_group.created" | "match_group.variance" | "match_group.resolved" | "supplier_credit_note.issued" | "supplier_credit_note.blocked" | "supplier_credit.applied" | "supplier_credit.reversed" | "bill.credited" | "bill.duplicate_detected" | "recurring_invoice.generation_failed" | "e_invoice.ingested" | "e_invoice.rejected" | "e_invoicing_registration.action_required" | "e_invoicing_registration.registered" | "e_invoicing_registration.failed" | "e_invoicing_registration.unregistered" | "outbound_e_invoice.delivered" | "outbound_e_invoice.made_available" | "outbound_e_invoice.failed" | "outbound_e_invoice.abandoned" | "company_bill.awaiting_organisation" | "customer.created" | "customer.updated" | "customer.deleted" | "supplier.created" | "supplier.updated" | "product.created" | "product.updated" | "product.deleted" | "tax_rate.created" | "tax_rate.updated" | "tax_rate.deleted" | "approval_policy.created" | "approval_policy.updated" | "approval_policy.deleted" | "expense.posted" | "expense.flagged" | "expense.pending_review" | "expense.matched" | "expense.post_failed" | "card_transaction.created" | "card_connection.broken" | "invoice.issued" | "expense_approval_policy.created" | "expense_approval_policy.updated" | "expense_approval_policy.deleted" | "expense_policy_document.ready_for_review" | "expense_policy_document.failed" | "accounting_sync.succeeded" | "accounting_sync.failed" | "whatsapp_connection.updated" | "bank_connection.connected" | "bank_connection.failed" | "bank_connection.expired" | "bank_connection.revoked" | "bank_connection.reconfirmation_due" | "bill.partially_paid" | "bill.payment_recorded" | "bill.payment_abandoned")[];
            active?: boolean;
            /** Format: int32 */
            consecutiveFailures?: number | string;
            /** Format: date-time */
            createdAt?: string;
            /** Format: date-time */
            updatedAt?: string;
        };
        WebhookSubscriptionWithSecretResponse: {
            secret: string;
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            clientId?: string;
            url: string;
            eventTypes: ("bill.created" | "bill.updated" | "bill.ocr_failed" | "bill.pending_review" | "bill.needs_approval" | "bill.approved" | "bill.rejected" | "bill.scheduled" | "bill.paid" | "bill.voided" | "bill.payment_failed" | "bill.payment_in_progress" | "invoice.created" | "invoice.updated" | "invoice.sent" | "invoice.partially_paid" | "invoice.paid" | "invoice.voided" | "invoice.credited" | "credit_note.issued" | "match_group.created" | "match_group.variance" | "match_group.resolved" | "supplier_credit_note.issued" | "supplier_credit_note.blocked" | "supplier_credit.applied" | "supplier_credit.reversed" | "bill.credited" | "bill.duplicate_detected" | "recurring_invoice.generation_failed" | "e_invoice.ingested" | "e_invoice.rejected" | "e_invoicing_registration.action_required" | "e_invoicing_registration.registered" | "e_invoicing_registration.failed" | "e_invoicing_registration.unregistered" | "outbound_e_invoice.delivered" | "outbound_e_invoice.made_available" | "outbound_e_invoice.failed" | "outbound_e_invoice.abandoned" | "company_bill.awaiting_organisation" | "customer.created" | "customer.updated" | "customer.deleted" | "supplier.created" | "supplier.updated" | "product.created" | "product.updated" | "product.deleted" | "tax_rate.created" | "tax_rate.updated" | "tax_rate.deleted" | "approval_policy.created" | "approval_policy.updated" | "approval_policy.deleted" | "expense.posted" | "expense.flagged" | "expense.pending_review" | "expense.matched" | "expense.post_failed" | "card_transaction.created" | "card_connection.broken" | "invoice.issued" | "expense_approval_policy.created" | "expense_approval_policy.updated" | "expense_approval_policy.deleted" | "expense_policy_document.ready_for_review" | "expense_policy_document.failed" | "accounting_sync.succeeded" | "accounting_sync.failed" | "whatsapp_connection.updated" | "bank_connection.connected" | "bank_connection.failed" | "bank_connection.expired" | "bank_connection.revoked" | "bank_connection.reconfirmation_due" | "bill.partially_paid" | "bill.payment_recorded" | "bill.payment_abandoned")[];
            active?: boolean;
            /** Format: int32 */
            consecutiveFailures?: number | string;
            /** Format: date-time */
            createdAt?: string;
            /** Format: date-time */
            updatedAt?: string;
        };
        /** @description A WhatsApp number, for Dolfin support. */
        WhatsAppConnectionAdminResponse: {
            /** Format: uuid */
            clientId?: string;
            /** @description The Twilio subaccount the number's messages go through. */
            twilioAccountSid?: string;
            /** @description The number's WhatsApp Sender at Twilio. Null once disconnected. */
            senderSid?: null | string;
            connection: components["schemas"]["WhatsAppConnectionResponse"];
        };
        /** @description The Client's connected WhatsApp Business number, which sends bill approvals, and the invoices and reminders of every one of the Client's organisations. */
        WhatsAppConnectionResponse: {
            /** Format: uuid */
            id?: string;
            status?: components["schemas"]["WhatsAppConnectionStatus"];
            /** @description Meta's reason when the status is NeedsAttention. */
            statusReason?: null | string;
            /** @description The number as WhatsApp displays it, e.g. +44 7700 900123. */
            displayPhoneNumber?: null | string;
            /** @description The display name Meta approved for the number; what recipients see. */
            verifiedName?: null | string;
            /** @description Meta's quality rating for the number: GREEN, YELLOW, RED or UNKNOWN. */
            qualityRating?: null | string;
            /** @description How many people the number may start conversations with per day, as Meta names it (e.g. TIER_250). */
            messagingLimitTier?: null | string;
            wabaId?: string;
            /** Format: date-time */
            connectedAt?: string;
            /** Format: date-time */
            revokedAt?: null | string;
            /** @description The message templates Dolfin created on the number's account, and Meta's review of each. */
            templates?: components["schemas"]["WhatsAppTemplateResponse"][];
            /** @description Which events go out on WhatsApp. A switched-off event goes by email. */
            events: components["schemas"]["WhatsAppEventsResponse"];
        };
        /** @description A WhatsApp number's connection, and what the page needs to start Embedded Signup. */
        WhatsAppConnectionStateResponse: {
            connection?: null | components["schemas"]["WhatsAppConnectionResponse"];
            embeddedSignup?: null | components["schemas"]["WhatsAppEmbeddedSignupResponse"];
            /** @description Test environments only: Twilio's WhatsApp sandbox number, which connecting gives the number at once, with no Embedded Signup. Send the connect request with an empty body. Null in production. */
            sandboxNumber?: null | string;
        };
        /**
         * @description Where a WhatsApp number's connection stands.
         * @enum {unknown}
         */
        WhatsAppConnectionStatus: "Connecting" | "Connected" | "NeedsAttention" | "Revoked";
        /**
         * @description Who gave the customer's consent to WhatsApp messages.
         * @enum {unknown}
         */
        WhatsAppConsentSource: "OrgAttested" | "Payer" | null;
        /** @description What FB.init and FB.login need to run Embedded Signup. */
        WhatsAppEmbeddedSignupResponse: {
            /** @description Dolfin's Meta app id. */
            appId: string;
            /** @description The Facebook Login for Business configuration id, passed to FB.login as config_id. */
            configurationId: string;
            /** @description Graph API version for FB.init, e.g. v23.0. */
            graphVersion: string;
            /** @description The partner solution to pass to FB.login as extras.setup.solutionID, so the WhatsApp account is shared with Dolfin's messaging provider. Null until it is set up. */
            solutionId?: null | string;
        };
        /** @description The caller's WhatsApp enrolment with their Client. */
        WhatsAppEnrolmentResponse: {
            status?: null | components["schemas"]["WhatsAppEnrolmentStatus"];
            /** @description The verified number, international digits without the plus. Null until verified. */
            phone?: null | string;
            /** @description The code to send, only in the response that started the enrolment. Expires after 15 minutes. */
            code?: null | string;
            /** Format: date-time */
            codeExpiresAt?: null | string;
            /** @description The Client's WhatsApp number to send the code to, as WhatsApp displays it. */
            sendTo?: null | string;
            /** @description A wa.me link that opens WhatsApp with the code ready to send. */
            sendLink?: null | string;
            /** Format: date-time */
            verifiedAt?: null | string;
        };
        /**
         * @description Where a user's WhatsApp enrolment stands.
         * @enum {unknown}
         */
        WhatsAppEnrolmentStatus: "Pending" | "Verified" | "OptedOut" | null;
        /** @description Which events go out on WhatsApp from this number. All are on until switched off. */
        WhatsAppEventsResponse: {
            /** @description The invoice itself, when it is sent. */
            invoiceSend?: boolean;
            /** @description The reminder before the due date. */
            reminderDueSoon?: boolean;
            /** @description The reminder on or just after the due date. */
            reminderJustOverdue?: boolean;
            /** @description The reminder once the invoice is overdue. */
            reminderOverdue?: boolean;
            /** @description The final reminder. */
            reminderFinalNotice?: boolean;
            /** @description A bill waiting for the recipient's approval. */
            billNeedsApproval?: boolean;
        };
        /**
         * @description What a WhatsApp message was for.
         * @enum {unknown}
         */
        WhatsAppMessageKind: "InvoiceSend" | "InvoiceReminder" | "BillNeedsApproval";
        /**
         * @description Where a WhatsApp message stands. Skipped means it was never sent and email went instead.
         * @enum {unknown}
         */
        WhatsAppMessageStatus: "Skipped" | "Sent" | "Delivered" | "Read" | "Failed";
        /** @description One message template and Meta's review of it. */
        WhatsAppTemplateResponse: {
            /** @description The template's name on Meta. */
            key: string;
            language: string;
            status?: components["schemas"]["WhatsAppTemplateStatus"];
            /** @description Meta's reason when the template was rejected. */
            rejectionReason?: null | string;
        };
        /**
         * @description Meta's review status for a message template.
         * @enum {unknown}
         */
        WhatsAppTemplateStatus: "Pending" | "Approved" | "Rejected" | "Paused" | "Disabled" | "NotSubmitted";
        YapilyDisclosure: {
            text: string;
            termsUrl: string;
            privacyUrl: string;
        };
    };
    responses: never;
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
}
export type $defs = Record<string, never>;
type FlattenedDeepRequired<T> = {
    [K in keyof T]-?: FlattenedDeepRequired<T[K] extends unknown[] | undefined | null ? Extract<T[K], unknown[]>[number] : T[K]>;
};
type ReadonlyArray<T> = [
    Exclude<T, undefined>
] extends [
    unknown[]
] ? Readonly<Exclude<T, undefined>> : Readonly<Exclude<T, undefined>[]>;
export const accountingConnectionStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["AccountingConnectionStatus"]> = ["Pending", "Callable", "Broken", "Revoked"];
export const accountingSyncStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["AccountingSyncStatus"]> = ["Waiting", "Pending", "Synced", "Failed", "Skipped"];
export const activityResourceValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ActivityResource"]> = ["Bills", "Invoices", "Customers", "Suppliers", "Products", "TaxRates", "PurchaseOrders", "DeliveryNotes", "CreditNotes", "SupplierCreditNotes", "Expenses", "Receipts"];
export const activityScopeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ActivityScope"]> = ["Global", "Client", "Organisation"];
export const actorTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ActorType"]> = ["User", "System"];
export const agentMessageRoleValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["AgentMessageRole"]> = ["User", "Assistant", "Tool"];
export const agentRefTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["AgentRefType"]> = ["invoice", "bill", "expense", "merchant"];
export const agentTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["AgentType"]> = ["Ar", "Ap", "All", "Books"];
export const apPaymentLinkModeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ApPaymentLinkMode"]> = ["None", "Dolfin", "BringYourOwn"];
export const approvalPolicyActionValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ApprovalPolicyAction"]> = ["AutoApprove", "AlwaysReview", "AutoVoid"];
export const bankConnectionStateValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["BankConnectionState"]> = ["Initiated", "AwaitingAuthorisation", "AwaitingFurtherAuthorisation", "Connected", "Failed", "Expired", "Reauthorising", "Revoked", "Disconnected"];
export const bankLineDirectionValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["BankLineDirection"]> = ["In", "Out"];
export const bankTransactionStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["BankTransactionStatus"]> = ["Booked", "Pending"];
export const billAllowedSenderKindValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["BillAllowedSenderKind"]> = ["Address", "Domain"];
export const billEventTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["BillEventType"]> = ["BillCreated", "BillStateChanged", "BillOcrCompleted", "BillOcrFailed", "BillFieldsUpdated"];
export const billExtractionModeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["BillExtractionMode"]> = ["Ocr", "Llm"];
export const billExtractionModelValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["BillExtractionModel"]> = ["GeminiFlash", "ClaudeSonnet", "ClaudeHaiku"];
export const billForwardingRejectionReasonValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["BillForwardingRejectionReason"]> = ["SenderNotAllowed", "AuthenticationFailed"];
export const billPaymentMethodValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["BillPaymentMethod"]> = ["Cash", "BankTransfer", "Cheque", "Card", "Other", "PayByBank"];
export const billPaymentProviderValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["BillPaymentProvider"]> = ["Manual", "PayByBank"];
export const billPaymentStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["BillPaymentStatus"]> = ["Initiating", "AwaitingAuthorisation", "Authorised", "Pending", "Completed", "Failed", "Expired", "Abandoned"];
export const billSourceValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["BillSource"]> = ["Upload", "Email", "Webhook", "EInvoice"];
export const billStateValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["BillState"]> = ["Created", "Extracting", "PendingReview", "NeedsApproval", "Approved", "Rejected", "Scheduled", "Paid", "ExtractionFailed", "PaymentInProgress", "PaymentFailed", "Voided", "PartiallyPaid", "OcrProcessing", "OcrFailed"];
export const bookBankLineStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["BookBankLineStatus"]> = ["Uncategorised", "Matched", "Categorised", "PossibleDuplicate", "Ignored"];
export const bookRuleFieldValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["BookRuleField"]> = ["Description", "Counterparty"];
export const bookRuleOperatorValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["BookRuleOperator"]> = ["Contains", "Equals"];
export const bookStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["BookStatus"]> = ["Setup", "Active", "Closed"];
export const cardConnectionStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["CardConnectionStatus"]> = ["Pending", "Active", "Broken", "Removed"];
export const cardProviderValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["CardProvider"]> = ["Fake", "Legacy"];
export const cardTransactionStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["CardTransactionStatus"]> = ["Pending", "Voided", "Settled", "Declined"];
export const cashFlowCategoryValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["CashFlowCategory"]> = ["CustomerReceipts", "SupplierPayments", "Income", "Expenses", "Tax", "Transfers", "Uncategorised", "Financing", "Assets", "CardPayouts", "Other"];
export const clientInviteStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ClientInviteStatus"]> = ["Pending", "Expired"];
export const clientRoleValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ClientRole"]> = ["Member", "Developer", "Admin", "Owner"];
export const clientTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ClientType"]> = ["Live", "Sandbox", "Demo"];
export const cloneModeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["CloneMode"]> = ["Rewound", "Verbatim"];
export const companyInboxBillStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["CompanyInboxBillStatus"]> = ["Extracting", "ExtractionFailed", "AwaitingOrganisation", "Discarded"];
export const createWebhookSubscriptionRequestEventTypesValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["CreateWebhookSubscriptionRequest"]["eventTypes"]> = ["bill.created", "bill.updated", "bill.ocr_failed", "bill.pending_review", "bill.needs_approval", "bill.approved", "bill.rejected", "bill.scheduled", "bill.paid", "bill.voided", "bill.payment_failed", "bill.payment_in_progress", "invoice.created", "invoice.updated", "invoice.sent", "invoice.partially_paid", "invoice.paid", "invoice.voided", "invoice.credited", "credit_note.issued", "match_group.created", "match_group.variance", "match_group.resolved", "supplier_credit_note.issued", "supplier_credit_note.blocked", "supplier_credit.applied", "supplier_credit.reversed", "bill.credited", "bill.duplicate_detected", "recurring_invoice.generation_failed", "e_invoice.ingested", "e_invoice.rejected", "e_invoicing_registration.action_required", "e_invoicing_registration.registered", "e_invoicing_registration.failed", "e_invoicing_registration.unregistered", "outbound_e_invoice.delivered", "outbound_e_invoice.made_available", "outbound_e_invoice.failed", "outbound_e_invoice.abandoned", "company_bill.awaiting_organisation", "customer.created", "customer.updated", "customer.deleted", "supplier.created", "supplier.updated", "product.created", "product.updated", "product.deleted", "tax_rate.created", "tax_rate.updated", "tax_rate.deleted", "approval_policy.created", "approval_policy.updated", "approval_policy.deleted", "expense.posted", "expense.flagged", "expense.pending_review", "expense.matched", "expense.post_failed", "card_transaction.created", "card_connection.broken", "invoice.issued", "expense_approval_policy.created", "expense_approval_policy.updated", "expense_approval_policy.deleted", "expense_policy_document.ready_for_review", "expense_policy_document.failed", "accounting_sync.succeeded", "accounting_sync.failed", "whatsapp_connection.updated", "bank_connection.connected", "bank_connection.failed", "bank_connection.expired", "bank_connection.revoked", "bank_connection.reconfirmation_due", "bill.partially_paid", "bill.payment_recorded", "bill.payment_abandoned"];
export const creditNoteReasonValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["CreditNoteReason"]> = ["None", "EarlyPaymentDiscount"];
export const creditNoteStateValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["CreditNoteState"]> = ["Draft", "Issuing", "Issued"];
export const customerChannelValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["CustomerChannel"]> = ["Email", "WhatsApp", "Both"];
export const demoStepStateValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["DemoStepState"]> = ["Pending", "Active", "Done", "Failed"];
export const deviceBrowserValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["DeviceBrowser"]> = ["Chrome", "Edge", "Safari", "Firefox", "Other"];
export const deviceOsValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["DeviceOs"]> = ["Windows", "MacOs", "Ios", "Android", "Linux", "ChromeOs", "Other"];
export const deviceTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["DeviceType"]> = ["Desktop", "Mobile", "Tablet", "Bot", "Unknown"];
export const discountTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["DiscountType"]> = ["None", "Percentage", "Fixed"];
export const eInvoiceFaultCodeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["EInvoiceFaultCode"]> = ["NoTotals", "NoLineItems", "PartPayment", "DocumentDiscount", "DocumentCharge", "TotalsUnbalanced", "Instalments", "CreditNoteTotalsAdjusted", "CreditNoteLineLevel", "CreditNoteMultipleInvoices", "CreditNoteNonInvoiceReference", "CreditNoteParentMissing", "CreditNoteParentNotCreditable", "CreditNoteParentCurrencyMismatch", "SupplierNameOnlyMatch", "SupplierFuzzyNearMatch", "SupplierMissing", "SupplierTaxNumberDiffers", "SupplierParticipantDiffers", "SupplierEmailDiffers", "SupplierAddressDiffers", "BankDetailsDiffer", "BankDetailsNotComparable", "LateRouting", "Unroutable", "Unreadable", "UnsupportedDocumentType", "Legacy", "SupplierNameCollision", "CreditNoteNegativeAmounts", "CreditNoteMixedTaxRates", "SupplierPossibleDuplicate", "SupplierIdentityUnresolved"];
export const eInvoiceFaultSeverityValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["EInvoiceFaultSeverity"]> = ["Note", "Warning", "Stop"];
export const eInvoicingRegistrationStateValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["EInvoicingRegistrationState"]> = ["Submitted", "ActionRequired", "Processing", "Registered", "Failed", "Unregistering", "Unregistered"];
export const eInvoicingRegistrationStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["EInvoicingRegistrationStatus"]> = ["NotStarted", "Submitted", "ActionRequired", "Processing", "Registered", "Failed", "Unregistering", "Unregistered"];
export const emailAuthResultValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["EmailAuthResult"]> = ["Unknown", "Pass", "Fail"];
export const expenseApprovalOutcomeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ExpenseApprovalOutcome"]> = ["AutoApprove", "RequireApproval", "Flag", "NoPolicy"];
export const expenseCodingSourceValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ExpenseCodingSource"]> = ["None", "Personal", "OrgMapping", "History", "ClientMapping", "CardDefault", "Human"];
export const expenseLineSourceValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ExpenseLineSource"]> = ["ReceiptLine", "MccDefault", "Manual", "Balancing"];
export const expenseMatchSourceValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ExpenseMatchSource"]> = ["None", "Auto", "Manual"];
export const expensePersonalSpendConditionValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ExpensePersonalSpendCondition"]> = ["Any", "Business", "Personal"];
export const expensePolicyDocumentStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ExpensePolicyDocumentStatus"]> = ["Compiling", "ReadyForReview", "Confirmed", "Failed", "Superseded"];
export const expensePolicyProposalChangeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ExpensePolicyProposalChange"]> = ["Added", "Changed", "Unchanged"];
export const expenseReceiptAgeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ExpenseReceiptAge"]> = ["Days0To7", "Days8To30", "Days31Plus"];
export const expenseReceiptConditionValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ExpenseReceiptCondition"]> = ["Any", "Attached", "Missing"];
export const expenseReportGranularityValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ExpenseReportGranularity"]> = ["Daily", "Weekly", "Monthly"];
export const expenseSearchSignalValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ExpenseSearchSignal"]> = ["Both", "Meaning", "Name", "Filter"];
export const expenseSpendFamilyValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ExpenseSpendFamily"]> = ["Travel", "Meals", "Entertainment", "Motor", "Office", "Supplies", "Telecoms", "Software", "Marketing", "Professional", "Facilities", "Logistics", "Training", "Financial", "Insurance", "Government", "Uncategorised"];
export const expenseSpendLocationValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ExpenseSpendLocation"]> = ["Domestic", "Foreign", "Unknown"];
export const expenseStateValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ExpenseState"]> = ["Captured", "Coded", "PendingReview", "Posting", "Posted", "Flagged", "PostFailed"];
export const expenseTrendDirectionValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ExpenseTrendDirection"]> = ["Up", "Down", "Flat"];
export const fieldRequirementValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["FieldRequirement"]> = ["Hidden", "Optional", "Required"];
export const gmailAuditLogEventTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["GmailAuditLogEventType"]> = ["ConnectionCreated", "ConnectionRevoked", "ReauthRequired", "CandidateDetected", "CandidateImported"];
export const gmailCandidateStateFilterValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["GmailCandidateStateFilter"]> = ["Candidate", "Imported", "Dismissed", "Failed", "Filtered", "All"];
export const gmailConnectionStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["GmailConnectionStatus"]> = ["Connected", "NeedsReauth", "Revoked", "Backfilling", "Pending"];
export const gmailIngestedAttachmentStateValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["GmailIngestedAttachmentState"]> = ["Candidate", "Imported", "Filtered", "Failed", "Dismissed"];
export const inboundEmailStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["InboundEmailStatus"]> = ["Received", "Ingested", "PartiallyIngested", "NoBillAttachments", "Rejected", "Failed"];
export const invoiceDeliveryChannelValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["InvoiceDeliveryChannel"]> = ["EInvoice", "Email"];
export const invoiceDeliveryStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["InvoiceDeliveryStatus"]> = ["Pending", "InFlight", "Delivered", "MadeAvailable", "Sent", "Failed", "NotSentDemo"];
export const invoiceEmailChoiceValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["InvoiceEmailChoice"]> = ["AfterNetwork", "Now", "Skip"];
export const invoiceEmailMessageKindValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["InvoiceEmailMessageKind"]> = ["Invoice", "Reminder"];
export const invoiceEmailTemplateValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["InvoiceEmailTemplate"]> = ["Classic", "Minimal", "Branded"];
export const invoiceEventTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["InvoiceEventType"]> = ["InvoiceCreated", "InvoiceStateChanged", "InvoiceSent", "InvoicePaid", "InvoiceVoided", "InvoiceReminderSent", "InvoiceReminderFailed", "CreditNoteIssued", "InvoiceFieldsUpdated", "InvoiceIssued"];
export const invoicePdfTemplateValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["InvoicePdfTemplate"]> = ["Classic", "Minimal", "Branded"];
export const invoiceReminderOffsetValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["InvoiceReminderOffset"]> = ["OneWeekBefore", "TwoDaysBefore", "OnDueDate", "TwoDaysAfter", "OneWeekAfter"];
export const invoiceReminderStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["InvoiceReminderStatus"]> = ["Pending", "Sent", "Cancelled", "Failed"];
export const invoiceStateValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["InvoiceState"]> = ["Draft", "Issued", "Paid", "Void", "PartiallyPaid", "Credited"];
export const invoiceToneValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["InvoiceTone"]> = ["Friendly", "Direct", "Formal"];
export const journalSourceEventValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["JournalSourceEvent"]> = ["OpeningBalances", "InvoiceIssued", "InvoicePaid", "InvoiceVoided", "CreditNoteIssued", "EarlyPaymentDiscount", "BillApproved", "BillLineRecoded", "BillPaid", "SupplierCreditIssued", "SupplierCreditApplied", "SupplierCreditReversed", "ExpenseCodingSettled", "BankLineSuspense", "BankLineCategorised", "BankLineMatched", "StripePayoutPaid", "Manual", "Reversal"];
export const journalSourceTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["JournalSourceType"]> = ["OpeningBalances", "Invoice", "InvoicePayment", "CreditNote", "Bill", "SupplierCreditNote", "Expense", "BankLine", "StripePayout", "Manual", "BillPayment"];
export const lineBucketValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["LineBucket"]> = ["AutoExact", "AutoFuzzy", "Assisted", "Manual", "AcceptedNoMatch", "Disputed", "CandidateWaiting", "NoCandidate"];
export const lookbackPeriodValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["LookbackPeriod"]> = ["Last7Days", "Last30Days", "Last90Days", "Last12Months", "MonthToDate", "QuarterToDate", "YearToDate"];
export const manualPaymentMethodValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ManualPaymentMethod"]> = ["Cash", "BankTransfer", "Cheque", "Card", "Other", "Credit"];
export const matchAnalyticsUnitValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["MatchAnalyticsUnit"]> = ["Lines", "Bills"];
export const matchCandidateDocumentTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["MatchCandidateDocumentType"]> = ["PurchaseOrder", "DeliveryNote"];
export const matchGroupStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["MatchGroupStatus"]> = ["Open", "Variance", "Resolved", "Synced"];
export const matchLineStateFilterValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["MatchLineStateFilter"]> = ["All", "Actionable", "Starved", "Matched", "Accepted", "Disputed"];
export const matchMethodValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["MatchMethod"]> = ["Manual", "Exact", "Fuzzy", "LinkedPoMatch"];
export const matchOutcomeBucketValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["MatchOutcomeBucket"]> = ["AutoSku", "AutoSimilarity", "AutoLinkedPo", "Confirmed", "Manual"];
export const matchPracticeLaneValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["MatchPracticeLane"]> = ["SkuExact", "FuzzyAuto", "SuggestedManual", "NoSuggestion", "UnmatchedCharge", "Manual"];
export const matchPracticeOutcomeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["MatchPracticeOutcome"]> = ["AutoMatchedOnSku", "AutoMatchedOnSimilarity", "Suggested", "NothingOffered"];
export const matchPracticeScenarioValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["MatchPracticeScenario"]> = ["ManualSet", "MixedMatchTypes"];
export const matchResolutionActionValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["MatchResolutionAction"]> = ["Accept", "AcceptAndUpdateCatalog", "RequestCreditNote", "Dispute"];
export const matchStatsPeriodValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["MatchStatsPeriod"]> = ["Last30Days", "Last90Days", "MonthToDate"];
export const matchStatsScopeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["MatchStatsScope"]> = ["Client", "Organisation"];
export const merchantMatchMethodValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["MerchantMatchMethod"]> = ["New", "Similar"];
export const moduleGrantActorTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ModuleGrantActorType"]> = ["System", "StaffUser", "AdminApiKey"];
export const moduleGrantStateValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ModuleGrantState"]> = ["NotGranted", "Granted"];
export const moduleStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ModuleStatus"]> = ["Preview", "Active", "Deprecated"];
export const newLedgerAccountTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["NewLedgerAccountType"]> = ["Expense", "OtherExpense", "CostOfSales", "CurrentAsset"];
export const organisationEInvoiceStateValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["OrganisationEInvoiceState"]> = ["Received", "Ingested", "Rejected"];
export const organisationRoleValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["OrganisationRole"]> = ["Member", "Admin", "Owner"];
export const outboundDocumentKindValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["OutboundDocumentKind"]> = ["Invoice", "CreditNote"];
export const outboundEInvoiceFailureKindValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["OutboundEInvoiceFailureKind"]> = ["None", "DocumentRejected", "RecipientUnreachable", "NetworkFailed", "Unknown"];
export const outboundEInvoiceStateValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["OutboundEInvoiceState"]> = ["Validated", "Submitted", "Delivered", "DeliveryFailed", "Abandoned", "Accepted", "MadeAvailable"];
export const outboundNetworkEventOutcomeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["OutboundNetworkEventOutcome"]> = ["Other", "Accepted", "Delivered", "MadeAvailable", "Rejected", "RecipientAccepted", "RecipientRejected"];
export const outboundNetworkEventSourceValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["OutboundNetworkEventSource"]> = ["Network", "Recipient"];
export const patchWebhookSubscriptionRequestEventTypesValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["PatchWebhookSubscriptionRequest"]["eventTypes"]> = ["bill.created", "bill.updated", "bill.ocr_failed", "bill.pending_review", "bill.needs_approval", "bill.approved", "bill.rejected", "bill.scheduled", "bill.paid", "bill.voided", "bill.payment_failed", "bill.payment_in_progress", "invoice.created", "invoice.updated", "invoice.sent", "invoice.partially_paid", "invoice.paid", "invoice.voided", "invoice.credited", "credit_note.issued", "match_group.created", "match_group.variance", "match_group.resolved", "supplier_credit_note.issued", "supplier_credit_note.blocked", "supplier_credit.applied", "supplier_credit.reversed", "bill.credited", "bill.duplicate_detected", "recurring_invoice.generation_failed", "e_invoice.ingested", "e_invoice.rejected", "e_invoicing_registration.action_required", "e_invoicing_registration.registered", "e_invoicing_registration.failed", "e_invoicing_registration.unregistered", "outbound_e_invoice.delivered", "outbound_e_invoice.made_available", "outbound_e_invoice.failed", "outbound_e_invoice.abandoned", "company_bill.awaiting_organisation", "customer.created", "customer.updated", "customer.deleted", "supplier.created", "supplier.updated", "product.created", "product.updated", "product.deleted", "tax_rate.created", "tax_rate.updated", "tax_rate.deleted", "approval_policy.created", "approval_policy.updated", "approval_policy.deleted", "expense.posted", "expense.flagged", "expense.pending_review", "expense.matched", "expense.post_failed", "card_transaction.created", "card_connection.broken", "invoice.issued", "expense_approval_policy.created", "expense_approval_policy.updated", "expense_approval_policy.deleted", "expense_policy_document.ready_for_review", "expense_policy_document.failed", "accounting_sync.succeeded", "accounting_sync.failed", "whatsapp_connection.updated", "bank_connection.connected", "bank_connection.failed", "bank_connection.expired", "bank_connection.revoked", "bank_connection.reconfirmation_due", "bill.partially_paid", "bill.payment_recorded", "bill.payment_abandoned"];
export const paymentAccountStateValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["PaymentAccountState"]> = ["NotStarted", "OnboardingInProgress", "Active", "Restricted", "Rejected", "Disconnected"];
export const paymentProviderValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["PaymentProvider"]> = ["Stripe", "Manual", "Yapily"];
export const postingStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["PostingStatus"]> = ["Waiting", "Pending", "Posted", "Skipped", "Failed"];
export const productTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ProductType"]> = ["Product", "Service"];
export const purchaseOrderStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["PurchaseOrderStatus"]> = ["Draft", "Open", "PartiallyMatched", "FullyMatched", "Closed", "Cancelled"];
export const receiptExtractionStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ReceiptExtractionStatus"]> = ["Pending", "Extracted", "Failed"];
export const receiptMatchStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ReceiptMatchStatus"]> = ["Unmatched", "Matched"];
export const receiptSourceValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ReceiptSource"]> = ["PortalUpload", "Api", "Email", "Mobile", "Forwarded"];
export const receivedEInvoiceStateValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ReceivedEInvoiceState"]> = ["Received", "Routed", "Unroutable", "Unreadable"];
export const recurrenceCadenceValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["RecurrenceCadence"]> = ["Weekly", "Monthly", "Quarterly", "Annually"];
export const recurringScheduleStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["RecurringScheduleStatus"]> = ["Active", "Paused", "Completed", "Cancelled"];
export const reportingBasisValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ReportingBasis"]> = ["Accrual", "Cash"];
export const rewindPopulationValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["RewindPopulation"]> = ["AllBills", "GroupedOnly"];
export const signInAppValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SignInApp"]> = ["Portal", "Sandbox", "Integrator", "Direct"];
export const signInMethodValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SignInMethod"]> = ["Google", "Microsoft", "Register", "InviteAccept", "DevLogin", "IntegratorExchange", "EmailCode"];
export const supplierCreditApplicationStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SupplierCreditApplicationStatus"]> = ["Applied", "Reversed"];
export const supplierCreditLedgerEntryTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SupplierCreditLedgerEntryType"]> = ["CreditNoteIssued", "AppliedToBill", "ApplicationReversed"];
export const supplierCreditNoteSourceValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SupplierCreditNoteSource"]> = ["Manual", "Ocr", "EInvoice"];
export const supplierCreditNoteStateValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SupplierCreditNoteState"]> = ["Draft", "Issued", "PartiallyApplied", "Applied"];
export const supplierOriginValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SupplierOrigin"]> = ["Unknown", "Manual", "BillExtraction", "EInvoice"];
export const supplierStandingValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SupplierStanding"]> = ["Any", "New", "Established"];
export const webhookSubscriptionResponseEventTypesValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["WebhookSubscriptionResponse"]["eventTypes"]> = ["bill.created", "bill.updated", "bill.ocr_failed", "bill.pending_review", "bill.needs_approval", "bill.approved", "bill.rejected", "bill.scheduled", "bill.paid", "bill.voided", "bill.payment_failed", "bill.payment_in_progress", "invoice.created", "invoice.updated", "invoice.sent", "invoice.partially_paid", "invoice.paid", "invoice.voided", "invoice.credited", "credit_note.issued", "match_group.created", "match_group.variance", "match_group.resolved", "supplier_credit_note.issued", "supplier_credit_note.blocked", "supplier_credit.applied", "supplier_credit.reversed", "bill.credited", "bill.duplicate_detected", "recurring_invoice.generation_failed", "e_invoice.ingested", "e_invoice.rejected", "e_invoicing_registration.action_required", "e_invoicing_registration.registered", "e_invoicing_registration.failed", "e_invoicing_registration.unregistered", "outbound_e_invoice.delivered", "outbound_e_invoice.made_available", "outbound_e_invoice.failed", "outbound_e_invoice.abandoned", "company_bill.awaiting_organisation", "customer.created", "customer.updated", "customer.deleted", "supplier.created", "supplier.updated", "product.created", "product.updated", "product.deleted", "tax_rate.created", "tax_rate.updated", "tax_rate.deleted", "approval_policy.created", "approval_policy.updated", "approval_policy.deleted", "expense.posted", "expense.flagged", "expense.pending_review", "expense.matched", "expense.post_failed", "card_transaction.created", "card_connection.broken", "invoice.issued", "expense_approval_policy.created", "expense_approval_policy.updated", "expense_approval_policy.deleted", "expense_policy_document.ready_for_review", "expense_policy_document.failed", "accounting_sync.succeeded", "accounting_sync.failed", "whatsapp_connection.updated", "bank_connection.connected", "bank_connection.failed", "bank_connection.expired", "bank_connection.revoked", "bank_connection.reconfirmation_due", "bill.partially_paid", "bill.payment_recorded", "bill.payment_abandoned"];
export const webhookSubscriptionWithSecretResponseEventTypesValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["WebhookSubscriptionWithSecretResponse"]["eventTypes"]> = ["bill.created", "bill.updated", "bill.ocr_failed", "bill.pending_review", "bill.needs_approval", "bill.approved", "bill.rejected", "bill.scheduled", "bill.paid", "bill.voided", "bill.payment_failed", "bill.payment_in_progress", "invoice.created", "invoice.updated", "invoice.sent", "invoice.partially_paid", "invoice.paid", "invoice.voided", "invoice.credited", "credit_note.issued", "match_group.created", "match_group.variance", "match_group.resolved", "supplier_credit_note.issued", "supplier_credit_note.blocked", "supplier_credit.applied", "supplier_credit.reversed", "bill.credited", "bill.duplicate_detected", "recurring_invoice.generation_failed", "e_invoice.ingested", "e_invoice.rejected", "e_invoicing_registration.action_required", "e_invoicing_registration.registered", "e_invoicing_registration.failed", "e_invoicing_registration.unregistered", "outbound_e_invoice.delivered", "outbound_e_invoice.made_available", "outbound_e_invoice.failed", "outbound_e_invoice.abandoned", "company_bill.awaiting_organisation", "customer.created", "customer.updated", "customer.deleted", "supplier.created", "supplier.updated", "product.created", "product.updated", "product.deleted", "tax_rate.created", "tax_rate.updated", "tax_rate.deleted", "approval_policy.created", "approval_policy.updated", "approval_policy.deleted", "expense.posted", "expense.flagged", "expense.pending_review", "expense.matched", "expense.post_failed", "card_transaction.created", "card_connection.broken", "invoice.issued", "expense_approval_policy.created", "expense_approval_policy.updated", "expense_approval_policy.deleted", "expense_policy_document.ready_for_review", "expense_policy_document.failed", "accounting_sync.succeeded", "accounting_sync.failed", "whatsapp_connection.updated", "bank_connection.connected", "bank_connection.failed", "bank_connection.expired", "bank_connection.revoked", "bank_connection.reconfirmation_due", "bill.partially_paid", "bill.payment_recorded", "bill.payment_abandoned"];
export const whatsAppConnectionStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["WhatsAppConnectionStatus"]> = ["Connecting", "Connected", "NeedsAttention", "Revoked"];
export const whatsAppMessageKindValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["WhatsAppMessageKind"]> = ["InvoiceSend", "InvoiceReminder", "BillNeedsApproval"];
export const whatsAppMessageStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["WhatsAppMessageStatus"]> = ["Skipped", "Sent", "Delivered", "Read", "Failed"];
export const whatsAppTemplateStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["WhatsAppTemplateStatus"]> = ["Pending", "Approved", "Rejected", "Paused", "Disabled", "NotSubmitted"];
export type operations = Record<string, never>;
